import React, { Component, createFactory, useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled, { createGlobalStyle, ThemeProvider as ThemeProvider$1, keyframes } from 'styled-components';
import ReactDOM from 'react-dom';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1.apply(this, arguments);
}

var compare = function compare(a, b) {
  if (a < b) return -1;
  if (a > b) return 1;
  return 0;
};

var defaultBreakpoints = [40, 52, 64].map(function (n) {
  return n + 'em';
});
var propType = PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.array, PropTypes.object]);

var cloneFunction = function cloneFunction(fn) {
  return function () {
    return fn.apply(void 0, arguments);
  };
};

var get = function get(obj) {
  for (var _len = arguments.length, paths = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    paths[_key - 1] = arguments[_key];
  }

  var value = paths.reduce(function (a, path) {
    if (is(a)) return a;
    var keys = typeof path === 'string' ? path.split('.') : [path];
    return keys.reduce(function (a, key) {
      return a && is(a[key]) ? a[key] : null;
    }, obj);
  }, null);
  return is(value) ? value : paths[paths.length - 1];
};

var themeGet = function themeGet(path, fallback) {
  if (fallback === void 0) {
    fallback = null;
  }

  return function (props) {
    return get(props.theme, path, fallback);
  };
};

var is = function is(n) {
  return n !== undefined && n !== null;
};

var isObject = function isObject(n) {
  return typeof n === 'object' && n !== null;
};

var num = function num(n) {
  return typeof n === 'number' && !isNaN(n);
};

var px = function px(n) {
  return num(n) && n !== 0 ? n + 'px' : n;
};

var createMediaQuery = function createMediaQuery(n) {
  return "@media screen and (min-width: " + px(n) + ")";
};

var getValue = function getValue(n, scale) {
  return get(scale, n);
}; // loosely based on deepmerge package


var merge = function merge(a, b) {
  var result = {};

  for (var key in a) {
    result[key] = a[key];
  }

  for (var _key2 in b) {
    if (!a[_key2] || typeof a[_key2] !== 'object') {
      result[_key2] = b[_key2];
    } else {
      result[_key2] = merge(a[_key2], b[_key2]);
    }
  }

  return result;
};

var mergeAll = function mergeAll() {
  var result = {};

  for (var i = 0; i < arguments.length; i++) {
    result = merge(result, i < 0 || arguments.length <= i ? undefined : arguments[i]);
  }

  return result;
};

var style = function style(_ref) {
  var _func$propTypes;

  var prop = _ref.prop,
      cssProperty = _ref.cssProperty,
      alias = _ref.alias,
      key = _ref.key,
      _ref$transformValue = _ref.transformValue,
      transformValue = _ref$transformValue === void 0 ? getValue : _ref$transformValue,
      _ref$scale = _ref.scale,
      defaultScale = _ref$scale === void 0 ? {} : _ref$scale;
  var property = cssProperty || prop;

  var func = function func(props) {
    var value = get(props, prop, alias, null);
    if (!is(value)) return null;
    var scale = get(props.theme, key, defaultScale);

    var createStyle = function createStyle(n) {
      var _ref2;

      return is(n) ? (_ref2 = {}, _ref2[property] = transformValue(n, scale), _ref2) : null;
    };

    if (!isObject(value)) return createStyle(value);
    var breakpoints = get(props.theme, 'breakpoints', defaultBreakpoints);
    var styles = [];

    if (Array.isArray(value)) {
      styles.push(createStyle(value[0]));

      for (var i = 1; i < value.slice(0, breakpoints.length + 1).length; i++) {
        var rule = createStyle(value[i]);

        if (rule) {
          var _styles$push;

          var media = createMediaQuery(breakpoints[i - 1]);
          styles.push((_styles$push = {}, _styles$push[media] = rule, _styles$push));
        }
      }
    } else {
      for (var _key3 in value) {
        var breakpoint = breakpoints[_key3];

        var _media = createMediaQuery(breakpoint);

        var _rule = createStyle(value[_key3]);

        if (!breakpoint) {
          styles.unshift(_rule);
        } else {
          var _styles$push2;

          styles.push((_styles$push2 = {}, _styles$push2[_media] = _rule, _styles$push2));
        }
      }

      styles.sort(compare);
    }

    return mergeAll.apply(void 0, styles);
  };

  func.propTypes = (_func$propTypes = {}, _func$propTypes[prop] = cloneFunction(propType), _func$propTypes);
  func.propTypes[prop].meta = {
    prop: prop,
    themeKey: key
  };

  if (alias) {
    func.propTypes[alias] = cloneFunction(propType);
    func.propTypes[alias].meta = {
      prop: alias,
      themeKey: key
    };
  }

  return func;
};

var compose = function compose() {
  for (var _len2 = arguments.length, funcs = new Array(_len2), _key4 = 0; _key4 < _len2; _key4++) {
    funcs[_key4] = arguments[_key4];
  }

  var func = function func(props) {
    var n = funcs.map(function (fn) {
      return fn(props);
    }).filter(Boolean);
    return mergeAll.apply(void 0, n);
  };

  func.propTypes = {};
  funcs.forEach(function (fn) {
    func.propTypes = _extends$1({}, func.propTypes, fn.propTypes);
  });
  return func;
};

var mapProps = function mapProps(mapper) {
  return function (func) {
    var next = function next(props) {
      return func(mapper(props));
    };

    for (var key in func) {
      next[key] = func[key];
    }

    return next;
  };
};

var variant = function variant(_ref3) {
  var _fn$propTypes;

  var key = _ref3.key,
      _ref3$prop = _ref3.prop,
      prop = _ref3$prop === void 0 ? 'variant' : _ref3$prop;

  var fn = function fn(props) {
    return get(props.theme, [key, props[prop]].join('.'), null);
  };

  fn.propTypes = (_fn$propTypes = {}, _fn$propTypes[prop] = PropTypes.oneOfType([PropTypes.number, PropTypes.string]), _fn$propTypes);
  return fn;
}; // space


var spaceScale = [0, 4, 8, 16, 32, 64, 128, 256, 512];

var getSpace = function getSpace(n, scale) {
  if (!num(n)) {
    return px(get(scale, n, n));
  }

  var isNegative = n < 0;
  var absolute = Math.abs(n);
  var value = get(scale, absolute);

  if (!num(value)) {
    return isNegative ? '-' + value : value;
  }

  return px(value * (isNegative ? -1 : 1));
};

var margin = style({
  prop: 'margin',
  alias: 'm',
  key: 'space',
  transformValue: getSpace,
  scale: spaceScale
});
var marginTop = style({
  prop: 'marginTop',
  alias: 'mt',
  key: 'space',
  transformValue: getSpace,
  scale: spaceScale
});
var marginBottom = style({
  prop: 'marginBottom',
  alias: 'mb',
  key: 'space',
  transformValue: getSpace,
  scale: spaceScale
});
var marginLeft = style({
  prop: 'marginLeft',
  alias: 'ml',
  key: 'space',
  transformValue: getSpace,
  scale: spaceScale
});
var marginRight = style({
  prop: 'marginRight',
  alias: 'mr',
  key: 'space',
  transformValue: getSpace,
  scale: spaceScale
});
var padding = style({
  prop: 'padding',
  alias: 'p',
  key: 'space',
  transformValue: getSpace,
  scale: spaceScale
});
var paddingTop = style({
  prop: 'paddingTop',
  alias: 'pt',
  key: 'space',
  transformValue: getSpace,
  scale: spaceScale
});
var paddingBottom = style({
  prop: 'paddingBottom',
  alias: 'pb',
  key: 'space',
  transformValue: getSpace,
  scale: spaceScale
});
var paddingLeft = style({
  prop: 'paddingLeft',
  alias: 'pl',
  key: 'space',
  transformValue: getSpace,
  scale: spaceScale
});
var paddingRight = style({
  prop: 'paddingRight',
  alias: 'pr',
  key: 'space',
  transformValue: getSpace,
  scale: spaceScale
});
var space = mapProps(function (props) {
  return _extends$1({}, props, {
    mt: is(props.my) ? props.my : props.mt,
    mb: is(props.my) ? props.my : props.mb,
    ml: is(props.mx) ? props.mx : props.ml,
    mr: is(props.mx) ? props.mx : props.mr,
    pt: is(props.py) ? props.py : props.pt,
    pb: is(props.py) ? props.py : props.pb,
    pl: is(props.px) ? props.px : props.pl,
    pr: is(props.px) ? props.px : props.pr
  });
})(compose(margin, marginTop, marginBottom, marginLeft, marginRight, padding, paddingTop, paddingBottom, paddingLeft, paddingRight)); // color

var textColor = style({
  prop: 'color',
  key: 'colors'
});
var backgroundColor = style({
  prop: 'backgroundColor',
  alias: 'bg',
  key: 'colors'
});
var color = compose(textColor, backgroundColor); // width

var getWidth = function getWidth(n, scale) {
  return !num(n) || n > 1 ? px(n) : n * 100 + '%';
};

var width = style({
  prop: 'width',
  key: 'widths',
  transformValue: getWidth
}); // typography

var getPx = function getPx(n, scale) {
  return px(get(scale, n));
};

var fontSize = style({
  prop: 'fontSize',
  key: 'fontSizes',
  transformValue: getPx,
  scale: [12, 14, 16, 20, 24, 32, 48, 64, 72]
});
var fontFamily = style({
  prop: 'fontFamily',
  key: 'fonts'
});
var fontWeight = style({
  prop: 'fontWeight',
  key: 'fontWeights'
});
var lineHeight = style({
  prop: 'lineHeight',
  key: 'lineHeights'
});
var textAlign = style({
  prop: 'textAlign'
});
var fontStyle = style({
  prop: 'fontStyle'
});
var letterSpacing = style({
  prop: 'letterSpacing',
  key: 'letterSpacings',
  transformValue: getPx
}); // layout

var display = style({
  prop: 'display'
});
var maxWidth = style({
  prop: 'maxWidth',
  key: 'maxWidths',
  transformValue: getPx
});
var minWidth = style({
  prop: 'minWidth',
  key: 'minWidths',
  transformValue: getPx
});
var height = style({
  prop: 'height',
  key: 'heights',
  transformValue: getPx
});
var maxHeight = style({
  prop: 'maxHeight',
  key: 'maxHeights',
  transformValue: getPx
});
var minHeight = style({
  prop: 'minHeight',
  key: 'minHeights',
  transformValue: getPx
});
var size = mapProps(function (props) {
  return _extends$1({}, props, {
    width: props.size,
    height: props.size
  });
})(compose(width, height));
var verticalAlign = style({
  prop: 'verticalAlign'
}); // flexbox

var alignItems = style({
  prop: 'alignItems'
});
var alignContent = style({
  prop: 'alignContent'
});
var justifyItems = style({
  prop: 'justifyItems'
});
var justifyContent = style({
  prop: 'justifyContent'
});
var flexWrap = style({
  prop: 'flexWrap'
});
var flexBasis = style({
  prop: 'flexBasis',
  transformValue: getWidth
});
var flexDirection = style({
  prop: 'flexDirection'
});
var flex = style({
  prop: 'flex'
});
var justifySelf = style({
  prop: 'justifySelf'
});
var alignSelf = style({
  prop: 'alignSelf'
});
var order = style({
  prop: 'order'
}); // grid

var gridGap = style({
  prop: 'gridGap',
  key: 'space',
  transformValue: getPx,
  scale: spaceScale
});
var gridColumnGap = style({
  prop: 'gridColumnGap',
  key: 'space',
  transformValue: getPx,
  scale: spaceScale
});
var gridRowGap = style({
  prop: 'gridRowGap',
  key: 'space',
  transformValue: getPx,
  scale: spaceScale
});
var gridColumn = style({
  prop: 'gridColumn'
});
var gridRow = style({
  prop: 'gridRow'
});
var gridAutoFlow = style({
  prop: 'gridAutoFlow'
});
var gridAutoColumns = style({
  prop: 'gridAutoColumns'
});
var gridAutoRows = style({
  prop: 'gridAutoRows'
});
var gridTemplateColumns = style({
  prop: 'gridTemplateColumns'
});
var gridTemplateRows = style({
  prop: 'gridTemplateRows'
});
var gridTemplateAreas = style({
  prop: 'gridTemplateAreas'
});
var gridArea = style({
  prop: 'gridArea'
}); // borders

var border = style({
  prop: 'border',
  key: 'borders'
});
var borderWidth = style({
  prop: 'borderWidth',
  key: 'borderWidths',
  transformValue: getPx
});
var borderStyle = style({
  prop: 'borderStyle',
  key: 'borderStyles'
});
var borderColor = style({
  prop: 'borderColor',
  key: 'colors'
});
var borderTop = style({
  prop: 'borderTop',
  key: 'borders'
});
var borderRight = style({
  prop: 'borderRight',
  key: 'borders'
});
var borderBottom = style({
  prop: 'borderBottom',
  key: 'borders'
});
var borderLeft = style({
  prop: 'borderLeft',
  key: 'borders'
});
var borderRadius = style({
  prop: 'borderRadius',
  key: 'radii',
  transformValue: getPx
});
var borders = compose(border, borderTop, borderRight, borderBottom, borderLeft, borderWidth, borderStyle, borderColor, borderRadius);
var boxShadow = style({
  prop: 'boxShadow',
  key: 'shadows'
});
var opacity = style({
  prop: 'opacity'
});
var overflow = style({
  prop: 'overflow'
}); // backgrounds

var background = style({
  prop: 'background'
});
var backgroundImage = style({
  prop: 'backgroundImage'
});
var backgroundSize = style({
  prop: 'backgroundSize'
});
var backgroundPosition = style({
  prop: 'backgroundPosition'
});
var backgroundRepeat = style({
  prop: 'backgroundRepeat'
}); // position

var position = style({
  prop: 'position'
});
var zIndex = style({
  prop: 'zIndex',
  key: 'zIndices'
});
var top = style({
  prop: 'top',
  transformValue: getPx
});
var right = style({
  prop: 'right',
  transformValue: getPx
});
var bottom = style({
  prop: 'bottom',
  transformValue: getPx
});
var left = style({
  prop: 'left',
  transformValue: getPx
}); // variants

var buttonStyle = variant({
  key: 'buttons'
});
var textStyle = variant({
  key: 'textStyles',
  prop: 'textStyle'
});
var colorStyle = variant({
  key: 'colorStyles',
  prop: 'colors'
});
var COMMON = compose(color, space);
var TYPOGRAPHY = compose(fontFamily, fontSize, fontWeight, lineHeight, textAlign, letterSpacing);
var LAYOUT = compose(display, size, width, height, minWidth, minHeight, maxWidth, maxHeight, overflow, verticalAlign);
var POSITION = compose(position, zIndex, top, right, bottom, left);
var BORDERS = compose(borders, borderColor, borderRadius, boxShadow);
var FLEXBOX = compose( // container
flexBasis, flexDirection, flexWrap, alignContent, alignItems, justifyContent, justifyItems, // item
flex, justifySelf, alignSelf, order);

function _assertThisInitialized$1(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _getPrototypeOf$1(o) {
  _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$1(o);
}

function _setPrototypeOf$1(o, p) {
  _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$1(o, p);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf$1(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf$1(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf$1(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
} // based on https://github.com/styled-components/styled-components/blob/fcf6f3804c57a14dd7984dfab7bc06ee2edca044/src/utils/error.js

/**
 * Parse errors.md and turn it into a simple hash of code: message
 * @private
 */


var ERRORS = {
  "1": "Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).\n\n",
  "2": "Passed invalid arguments to hsla, please pass multiple numbers e.g. hsla(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).\n\n",
  "3": "Passed an incorrect argument to a color function, please pass a string representation of a color.\n\n",
  "4": "Couldn't generate valid rgb string from %s, it returned %s.\n\n",
  "5": "Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.\n\n",
  "6": "Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).\n\n",
  "7": "Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).\n\n",
  "8": "Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.\n\n",
  "9": "Please provide a number of steps to the modularScale helper.\n\n",
  "10": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
  "11": "Invalid value passed as base to modularScale, expected number or em string but got \"%s\"\n\n",
  "12": "Expected a string ending in \"px\" or a number passed as the first argument to %s(), got \"%s\" instead.\n\n",
  "13": "Expected a string ending in \"px\" or a number passed as the second argument to %s(), got \"%s\" instead.\n\n",
  "14": "Passed invalid pixel value (\"%s\") to %s(), please pass a value like \"12px\" or 12.\n\n",
  "15": "Passed invalid base value (\"%s\") to %s(), please pass a value like \"12px\" or 12.\n\n",
  "16": "You must provide a template to this method.\n\n",
  "17": "You passed an unsupported selector state to this method.\n\n",
  "18": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
  "19": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
  "20": "expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
  "21": "expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  "22": "expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  "23": "fontFace expects a name of a font-family.\n\n",
  "24": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
  "25": "fontFace expects localFonts to be an array.\n\n",
  "26": "fontFace expects fileFormats to be an array.\n\n",
  "27": "radialGradient requries at least 2 color-stops to properly render.\n\n",
  "28": "Please supply a filename to retinaImage() as the first argument.\n\n",
  "29": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
  "30": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  "31": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation\n\n",
  "32": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')\n\n",
  "33": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation\n\n",
  "34": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
  "35": "borderRadius expects one of \"top\", \"bottom\", \"left\" or \"right\" as the first argument.\n\n",
  "36": "Property must be a string value.\n\n",
  "37": "Syntax Error at %s.\n\n",
  "38": "Formula contains a function that needs parentheses at %s.\n\n",
  "39": "Formula is missing closing parenthesis at %s.\n\n",
  "40": "Formula has too many closing parentheses at %s.\n\n",
  "41": "All values in a formula must have the same unit or be unitless.\n\n",
  "42": "Please provide a number of steps to the modularScale helper.\n\n",
  "43": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
  "44": "Invalid value passed as base to modularScale, expected number or em/rem string but got %s.\n\n",
  "45": "Passed invalid argument to hslToColorString, please pass a HslColor or HslaColor object.\n\n",
  "46": "Passed invalid argument to rgbToColorString, please pass a RgbColor or RgbaColor object.\n\n",
  "47": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
  "48": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
  "49": "Expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
  "50": "Expects the objects in the first argument array to have the properties prop, fromSize, and toSize.\n\n",
  "51": "Expects the first argument object to have the properties prop, fromSize, and toSize.\n\n",
  "52": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
  "53": "fontFace expects localFonts to be an array.\n\n",
  "54": "fontFace expects fileFormats to be an array.\n\n",
  "55": "fontFace expects a name of a font-family.\n\n",
  "56": "linearGradient requries at least 2 color-stops to properly render.\n\n",
  "57": "radialGradient requries at least 2 color-stops to properly render.\n\n",
  "58": "Please supply a filename to retinaImage() as the first argument.\n\n",
  "59": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
  "60": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  "61": "Property must be a string value.\n\n",
  "62": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
  "63": "borderRadius expects one of \"top\", \"bottom\", \"left\" or \"right\" as the first argument.\n\n",
  "64": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation.\n\n",
  "65": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s').\n\n",
  "66": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation.\n\n",
  "67": "You must provide a template to this method.\n\n",
  "68": "You passed an unsupported selector state to this method.\n\n",
  "69": "Expected a string ending in \"px\" or a number passed as the first argument to %s(), got %s instead.\n\n",
  "70": "Expected a string ending in \"px\" or a number passed as the second argument to %s(), got %s instead.\n\n",
  "71": "Passed invalid pixel value %s to %s(), please pass a value like \"12px\" or 12.\n\n",
  "72": "Passed invalid base value %s to %s(), please pass a value like \"12px\" or 12.\n"
};
/**
 * super basic version of sprintf
 * @private
 */

function format() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var a = args[0];
  var b = [];
  var c;

  for (c = 1; c < args.length; c += 1) {
    b.push(args[c]);
  }

  b.forEach(function (d) {
    a = a.replace(/%[a-z]/, d);
  });
  return a;
}
/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 * @private
 */


var PolishedError =
/*#__PURE__*/
function (_Error) {
  _inheritsLoose(PolishedError, _Error);

  function PolishedError(code) {
    var _this;

    if (process.env.NODE_ENV === 'production') {
      _this = _Error.call(this, "An error occurred. See https://github.com/styled-components/polished/blob/master/src/internalHelpers/errors.md#" + code + " for more information.") || this;
    } else {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      _this = _Error.call(this, format.apply(void 0, [ERRORS[code]].concat(args))) || this;
    }

    return _assertThisInitialized$1(_this);
  }

  return PolishedError;
}(
/*#__PURE__*/
_wrapNativeSuper(Error));
/**
 * CSS to represent truncated text with an ellipsis.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...ellipsis('250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${ellipsis('250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'display': 'inline-block',
 *   'maxWidth': '250px',
 *   'overflow': 'hidden',
 *   'textOverflow': 'ellipsis',
 *   'whiteSpace': 'nowrap',
 *   'wordWrap': 'normal'
 * }
 */


function ellipsis(width) {
  if (width === void 0) {
    width = '100%';
  }

  return {
    display: 'inline-block',
    maxWidth: width,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    wordWrap: 'normal'
  };
}
/**
 * CSS to normalize abnormalities across browsers (normalize.css v8.0.0 | MIT License | github.com/necolas/normalize.css)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...normalize(),
 * }
 *
 * // styled-components usage
 * const GlobalStyle = createGlobalStyle`${normalize()}`
 *
 * // CSS as JS Output
 *
 * html {
 *   lineHeight: 1.15,
 *   textSizeAdjust: 100%,
 * } ...
 */


function normalize() {
  var _ref;

  return [(_ref = {
    html: {
      lineHeight: '1.15',
      textSizeAdjust: '100%'
    },
    body: {
      margin: '0'
    },
    h1: {
      fontSize: '2em',
      margin: '0.67em 0'
    },
    hr: {
      boxSizing: 'content-box',
      height: '0',
      overflow: 'visible'
    },
    pre: {
      fontFamily: 'monospace, monospace',
      fontSize: '1em'
    },
    a: {
      backgroundColor: 'transparent'
    },
    'abbr[title]': {
      borderBottom: 'none',
      textDecoration: 'underline'
    }
  }, _ref["b,\n    strong"] = {
    fontWeight: 'bolder'
  }, _ref["code,\n    kbd,\n    samp"] = {
    fontFamily: 'monospace, monospace',
    fontSize: '1em'
  }, _ref.small = {
    fontSize: '80%'
  }, _ref["sub,\n    sup"] = {
    fontSize: '75%',
    lineHeight: '0',
    position: 'relative',
    verticalAlign: 'baseline'
  }, _ref.sub = {
    bottom: '-0.25em'
  }, _ref.sup = {
    top: '-0.5em'
  }, _ref.img = {
    borderStyle: 'none'
  }, _ref["button,\n    input,\n    optgroup,\n    select,\n    textarea"] = {
    fontFamily: 'inherit',
    fontSize: '100%',
    lineHeight: '1.15',
    margin: '0'
  }, _ref["button,\n    input"] = {
    overflow: 'visible'
  }, _ref["button,\n    select"] = {
    textTransform: 'none'
  }, _ref["button,\n    html [type=\"button\"],\n    [type=\"reset\"],\n    [type=\"submit\"]"] = {
    WebkitAppearance: 'button'
  }, _ref["button::-moz-focus-inner,\n    [type=\"button\"]::-moz-focus-inner,\n    [type=\"reset\"]::-moz-focus-inner,\n    [type=\"submit\"]::-moz-focus-inner"] = {
    borderStyle: 'none',
    padding: '0'
  }, _ref["button:-moz-focusring,\n    [type=\"button\"]:-moz-focusring,\n    [type=\"reset\"]:-moz-focusring,\n    [type=\"submit\"]:-moz-focusring"] = {
    outline: '1px dotted ButtonText'
  }, _ref.fieldset = {
    padding: '0.35em 0.625em 0.75em'
  }, _ref.legend = {
    boxSizing: 'border-box',
    color: 'inherit',
    display: 'table',
    maxWidth: '100%',
    padding: '0',
    whiteSpace: 'normal'
  }, _ref.progress = {
    verticalAlign: 'baseline'
  }, _ref.textarea = {
    overflow: 'auto'
  }, _ref["[type=\"checkbox\"],\n    [type=\"radio\"]"] = {
    boxSizing: 'border-box',
    padding: '0'
  }, _ref["[type=\"number\"]::-webkit-inner-spin-button,\n    [type=\"number\"]::-webkit-outer-spin-button"] = {
    height: 'auto'
  }, _ref['[type="search"]'] = {
    WebkitAppearance: 'textfield',
    outlineOffset: '-2px'
  }, _ref['[type="search"]::-webkit-search-decoration'] = {
    WebkitAppearance: 'none'
  }, _ref['::-webkit-file-upload-button'] = {
    WebkitAppearance: 'button',
    font: 'inherit'
  }, _ref.details = {
    display: 'block'
  }, _ref.summary = {
    display: 'list-item'
  }, _ref.template = {
    display: 'none'
  }, _ref['[hidden]'] = {
    display: 'none'
  }, _ref), {
    'abbr[title]': {
      textDecoration: 'underline dotted'
    }
  }];
}
/* eslint-disable key-spacing */


var functionsMap = {
  easeInBack: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
  easeInCirc: 'cubic-bezier(0.600,  0.040, 0.980, 0.335)',
  easeInCubic: 'cubic-bezier(0.550,  0.055, 0.675, 0.190)',
  easeInExpo: 'cubic-bezier(0.950,  0.050, 0.795, 0.035)',
  easeInQuad: 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
  easeInQuart: 'cubic-bezier(0.895,  0.030, 0.685, 0.220)',
  easeInQuint: 'cubic-bezier(0.755,  0.050, 0.855, 0.060)',
  easeInSine: 'cubic-bezier(0.470,  0.000, 0.745, 0.715)',
  easeOutBack: 'cubic-bezier(0.175,  0.885, 0.320, 1.275)',
  easeOutCubic: 'cubic-bezier(0.215,  0.610, 0.355, 1.000)',
  easeOutCirc: 'cubic-bezier(0.075,  0.820, 0.165, 1.000)',
  easeOutExpo: 'cubic-bezier(0.190,  1.000, 0.220, 1.000)',
  easeOutQuad: 'cubic-bezier(0.250,  0.460, 0.450, 0.940)',
  easeOutQuart: 'cubic-bezier(0.165,  0.840, 0.440, 1.000)',
  easeOutQuint: 'cubic-bezier(0.230,  1.000, 0.320, 1.000)',
  easeOutSine: 'cubic-bezier(0.390,  0.575, 0.565, 1.000)',
  easeInOutBack: 'cubic-bezier(0.680, -0.550, 0.265, 1.550)',
  easeInOutCirc: 'cubic-bezier(0.785,  0.135, 0.150, 0.860)',
  easeInOutCubic: 'cubic-bezier(0.645,  0.045, 0.355, 1.000)',
  easeInOutExpo: 'cubic-bezier(1.000,  0.000, 0.000, 1.000)',
  easeInOutQuad: 'cubic-bezier(0.455,  0.030, 0.515, 0.955)',
  easeInOutQuart: 'cubic-bezier(0.770,  0.000, 0.175, 1.000)',
  easeInOutQuint: 'cubic-bezier(0.860,  0.000, 0.070, 1.000)',
  easeInOutSine: 'cubic-bezier(0.445,  0.050, 0.550, 0.950)'
  /* eslint-enable key-spacing */

};

function getTimingFunction(functionName) {
  return functionsMap[functionName];
}
/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': timingFunctions('easeInQuad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${timingFunctions('easeInQuad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
 * }
 */


function timingFunctions(timingFunction) {
  return getTimingFunction(timingFunction);
}

function colorToInt(color) {
  return Math.round(color * 255);
}

function convertToInt(red, green, blue) {
  return colorToInt(red) + "," + colorToInt(green) + "," + colorToInt(blue);
}

function hslToRgb(hue, saturation, lightness, convert) {
  if (convert === void 0) {
    convert = convertToInt;
  }

  if (saturation === 0) {
    // achromatic
    return convert(lightness, lightness, lightness);
  } // formulae from https://en.wikipedia.org/wiki/HSL_and_HSV


  var huePrime = (hue % 360 + 360) % 360 / 60;
  var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
  var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
  var red = 0;
  var green = 0;
  var blue = 0;

  if (huePrime >= 0 && huePrime < 1) {
    red = chroma;
    green = secondComponent;
  } else if (huePrime >= 1 && huePrime < 2) {
    red = secondComponent;
    green = chroma;
  } else if (huePrime >= 2 && huePrime < 3) {
    green = chroma;
    blue = secondComponent;
  } else if (huePrime >= 3 && huePrime < 4) {
    green = secondComponent;
    blue = chroma;
  } else if (huePrime >= 4 && huePrime < 5) {
    red = secondComponent;
    blue = chroma;
  } else if (huePrime >= 5 && huePrime < 6) {
    red = chroma;
    blue = secondComponent;
  }

  var lightnessModification = lightness - chroma / 2;
  var finalRed = red + lightnessModification;
  var finalGreen = green + lightnessModification;
  var finalBlue = blue + lightnessModification;
  return convert(finalRed, finalGreen, finalBlue);
}

var namedColorMap = {
  aliceblue: 'f0f8ff',
  antiquewhite: 'faebd7',
  aqua: '00ffff',
  aquamarine: '7fffd4',
  azure: 'f0ffff',
  beige: 'f5f5dc',
  bisque: 'ffe4c4',
  black: '000',
  blanchedalmond: 'ffebcd',
  blue: '0000ff',
  blueviolet: '8a2be2',
  brown: 'a52a2a',
  burlywood: 'deb887',
  cadetblue: '5f9ea0',
  chartreuse: '7fff00',
  chocolate: 'd2691e',
  coral: 'ff7f50',
  cornflowerblue: '6495ed',
  cornsilk: 'fff8dc',
  crimson: 'dc143c',
  cyan: '00ffff',
  darkblue: '00008b',
  darkcyan: '008b8b',
  darkgoldenrod: 'b8860b',
  darkgray: 'a9a9a9',
  darkgreen: '006400',
  darkgrey: 'a9a9a9',
  darkkhaki: 'bdb76b',
  darkmagenta: '8b008b',
  darkolivegreen: '556b2f',
  darkorange: 'ff8c00',
  darkorchid: '9932cc',
  darkred: '8b0000',
  darksalmon: 'e9967a',
  darkseagreen: '8fbc8f',
  darkslateblue: '483d8b',
  darkslategray: '2f4f4f',
  darkslategrey: '2f4f4f',
  darkturquoise: '00ced1',
  darkviolet: '9400d3',
  deeppink: 'ff1493',
  deepskyblue: '00bfff',
  dimgray: '696969',
  dimgrey: '696969',
  dodgerblue: '1e90ff',
  firebrick: 'b22222',
  floralwhite: 'fffaf0',
  forestgreen: '228b22',
  fuchsia: 'ff00ff',
  gainsboro: 'dcdcdc',
  ghostwhite: 'f8f8ff',
  gold: 'ffd700',
  goldenrod: 'daa520',
  gray: '808080',
  green: '008000',
  greenyellow: 'adff2f',
  grey: '808080',
  honeydew: 'f0fff0',
  hotpink: 'ff69b4',
  indianred: 'cd5c5c',
  indigo: '4b0082',
  ivory: 'fffff0',
  khaki: 'f0e68c',
  lavender: 'e6e6fa',
  lavenderblush: 'fff0f5',
  lawngreen: '7cfc00',
  lemonchiffon: 'fffacd',
  lightblue: 'add8e6',
  lightcoral: 'f08080',
  lightcyan: 'e0ffff',
  lightgoldenrodyellow: 'fafad2',
  lightgray: 'd3d3d3',
  lightgreen: '90ee90',
  lightgrey: 'd3d3d3',
  lightpink: 'ffb6c1',
  lightsalmon: 'ffa07a',
  lightseagreen: '20b2aa',
  lightskyblue: '87cefa',
  lightslategray: '789',
  lightslategrey: '789',
  lightsteelblue: 'b0c4de',
  lightyellow: 'ffffe0',
  lime: '0f0',
  limegreen: '32cd32',
  linen: 'faf0e6',
  magenta: 'f0f',
  maroon: '800000',
  mediumaquamarine: '66cdaa',
  mediumblue: '0000cd',
  mediumorchid: 'ba55d3',
  mediumpurple: '9370db',
  mediumseagreen: '3cb371',
  mediumslateblue: '7b68ee',
  mediumspringgreen: '00fa9a',
  mediumturquoise: '48d1cc',
  mediumvioletred: 'c71585',
  midnightblue: '191970',
  mintcream: 'f5fffa',
  mistyrose: 'ffe4e1',
  moccasin: 'ffe4b5',
  navajowhite: 'ffdead',
  navy: '000080',
  oldlace: 'fdf5e6',
  olive: '808000',
  olivedrab: '6b8e23',
  orange: 'ffa500',
  orangered: 'ff4500',
  orchid: 'da70d6',
  palegoldenrod: 'eee8aa',
  palegreen: '98fb98',
  paleturquoise: 'afeeee',
  palevioletred: 'db7093',
  papayawhip: 'ffefd5',
  peachpuff: 'ffdab9',
  peru: 'cd853f',
  pink: 'ffc0cb',
  plum: 'dda0dd',
  powderblue: 'b0e0e6',
  purple: '800080',
  rebeccapurple: '639',
  red: 'f00',
  rosybrown: 'bc8f8f',
  royalblue: '4169e1',
  saddlebrown: '8b4513',
  salmon: 'fa8072',
  sandybrown: 'f4a460',
  seagreen: '2e8b57',
  seashell: 'fff5ee',
  sienna: 'a0522d',
  silver: 'c0c0c0',
  skyblue: '87ceeb',
  slateblue: '6a5acd',
  slategray: '708090',
  slategrey: '708090',
  snow: 'fffafa',
  springgreen: '00ff7f',
  steelblue: '4682b4',
  tan: 'd2b48c',
  teal: '008080',
  thistle: 'd8bfd8',
  tomato: 'ff6347',
  turquoise: '40e0d0',
  violet: 'ee82ee',
  wheat: 'f5deb3',
  white: 'fff',
  whitesmoke: 'f5f5f5',
  yellow: 'ff0',
  yellowgreen: '9acd32'
  /**
   * Checks if a string is a CSS named color and returns its equivalent hex value, otherwise returns the original color.
   * @private
   */

};

function nameToHex(color) {
  if (typeof color !== 'string') return color;
  var normalizedColorName = color.toLowerCase();
  return namedColorMap[normalizedColorName] ? "#" + namedColorMap[normalizedColorName] : color;
}

var hexRegex = /^#[a-fA-F0-9]{6}$/;
var hexRgbaRegex = /^#[a-fA-F0-9]{8}$/;
var reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var reducedRgbaHexRegex = /^#[a-fA-F0-9]{4}$/;
var rgbRegex = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/i;
var rgbaRegex = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/i;
var hslRegex = /^hsl\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3})%\s*,\s*(\d{1,3})%\s*\)$/i;
var hslaRegex = /^hsla\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3})%\s*,\s*(\d{1,3})%\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/i;
/**
 * Returns an RgbColor or RgbaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a RgbColor or RgbaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = parseToRgb('rgb(255, 0, 0)');
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = parseToRgb('hsla(210, 10%, 40%, 0.75)');
 */

function parseToRgb(color) {
  if (typeof color !== 'string') {
    throw new PolishedError(3);
  }

  var normalizedColor = nameToHex(color);

  if (normalizedColor.match(hexRegex)) {
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16)
    };
  }

  if (normalizedColor.match(hexRgbaRegex)) {
    var alpha = parseFloat((parseInt("" + normalizedColor[7] + normalizedColor[8], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16),
      alpha: alpha
    };
  }

  if (normalizedColor.match(reducedHexRegex)) {
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16)
    };
  }

  if (normalizedColor.match(reducedRgbaHexRegex)) {
    var _alpha = parseFloat((parseInt("" + normalizedColor[4] + normalizedColor[4], 16) / 255).toFixed(2));

    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16),
      alpha: _alpha
    };
  }

  var rgbMatched = rgbRegex.exec(normalizedColor);

  if (rgbMatched) {
    return {
      red: parseInt("" + rgbMatched[1], 10),
      green: parseInt("" + rgbMatched[2], 10),
      blue: parseInt("" + rgbMatched[3], 10)
    };
  }

  var rgbaMatched = rgbaRegex.exec(normalizedColor);

  if (rgbaMatched) {
    return {
      red: parseInt("" + rgbaMatched[1], 10),
      green: parseInt("" + rgbaMatched[2], 10),
      blue: parseInt("" + rgbaMatched[3], 10),
      alpha: parseFloat("" + rgbaMatched[4])
    };
  }

  var hslMatched = hslRegex.exec(normalizedColor);

  if (hslMatched) {
    var hue = parseInt("" + hslMatched[1], 10);
    var saturation = parseInt("" + hslMatched[2], 10) / 100;
    var lightness = parseInt("" + hslMatched[3], 10) / 100;
    var rgbColorString = "rgb(" + hslToRgb(hue, saturation, lightness) + ")";
    var hslRgbMatched = rgbRegex.exec(rgbColorString);

    if (!hslRgbMatched) {
      throw new PolishedError(4, normalizedColor, rgbColorString);
    }

    return {
      red: parseInt("" + hslRgbMatched[1], 10),
      green: parseInt("" + hslRgbMatched[2], 10),
      blue: parseInt("" + hslRgbMatched[3], 10)
    };
  }

  var hslaMatched = hslaRegex.exec(normalizedColor);

  if (hslaMatched) {
    var _hue = parseInt("" + hslaMatched[1], 10);

    var _saturation = parseInt("" + hslaMatched[2], 10) / 100;

    var _lightness = parseInt("" + hslaMatched[3], 10) / 100;

    var _rgbColorString = "rgb(" + hslToRgb(_hue, _saturation, _lightness) + ")";

    var _hslRgbMatched = rgbRegex.exec(_rgbColorString);

    if (!_hslRgbMatched) {
      throw new PolishedError(4, normalizedColor, _rgbColorString);
    }

    return {
      red: parseInt("" + _hslRgbMatched[1], 10),
      green: parseInt("" + _hslRgbMatched[2], 10),
      blue: parseInt("" + _hslRgbMatched[3], 10),
      alpha: parseFloat("" + hslaMatched[4])
    };
  }

  throw new PolishedError(5);
}
/**
 * Reduces hex values if possible e.g. #ff8866 to #f86
 * @private
 */


var reduceHexValue = function reduceHexValue(value) {
  if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) {
    return "#" + value[1] + value[3] + value[5];
  }

  return value;
};

function numberToHex(value) {
  var hex = value.toString(16);
  return hex.length === 1 ? "0" + hex : hex;
}
/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgb(255, 205, 100),
 *   background: rgb({ red: 255, green: 205, blue: 100 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgb(255, 205, 100)};
 *   background: ${rgb({ red: 255, green: 205, blue: 100 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffcd64";
 *   background: "#ffcd64";
 * }
 */


function rgb(value, green, blue) {
  if (typeof value === 'number' && typeof green === 'number' && typeof blue === 'number') {
    return reduceHexValue("#" + numberToHex(value) + numberToHex(green) + numberToHex(blue));
  } else if (typeof value === 'object' && green === undefined && blue === undefined) {
    return reduceHexValue("#" + numberToHex(value.red) + numberToHex(value.green) + numberToHex(value.blue));
  }

  throw new PolishedError(6);
}
/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * Can also be used to fade a color by passing a hex value or named CSS color along with an alpha value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgba(255, 205, 100, 0.7),
 *   background: rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 }),
 *   background: rgba(255, 205, 100, 1),
 *   background: rgba('#ffffff', 0.4),
 *   background: rgba('black', 0.7),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgba(255, 205, 100, 0.7)};
 *   background: ${rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 })};
 *   background: ${rgba(255, 205, 100, 1)};
 *   background: ${rgba('#ffffff', 0.4)};
 *   background: ${rgba('black', 0.7)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,205,100,0.7)";
 *   background: "rgba(255,205,100,0.7)";
 *   background: "#ffcd64";
 *   background: "rgba(255,255,255,0.4)";
 *   background: "rgba(0,0,0,0.7)";
 * }
 */


function rgba(firstValue, secondValue, thirdValue, fourthValue) {
  if (typeof firstValue === 'string' && typeof secondValue === 'number') {
    var rgbValue = parseToRgb(firstValue);
    return "rgba(" + rgbValue.red + "," + rgbValue.green + "," + rgbValue.blue + "," + secondValue + ")";
  } else if (typeof firstValue === 'number' && typeof secondValue === 'number' && typeof thirdValue === 'number' && typeof fourthValue === 'number') {
    return fourthValue >= 1 ? rgb(firstValue, secondValue, thirdValue) : "rgba(" + firstValue + "," + secondValue + "," + thirdValue + "," + fourthValue + ")";
  } else if (typeof firstValue === 'object' && secondValue === undefined && thirdValue === undefined && fourthValue === undefined) {
    return firstValue.alpha >= 1 ? rgb(firstValue.red, firstValue.green, firstValue.blue) : "rgba(" + firstValue.red + "," + firstValue.green + "," + firstValue.blue + "," + firstValue.alpha + ")";
  }

  throw new PolishedError(7);
} // Type definitions taken from https://github.com/gcanti/flow-static-land/blob/master/src/Fun.js
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-redeclare


function curried(f, length, acc) {
  return function fn() {
    // eslint-disable-next-line prefer-rest-params
    var combined = acc.concat(Array.prototype.slice.call(arguments));
    return combined.length >= length ? f.apply(this, combined) : curried(f, length, combined);
  };
} // eslint-disable-next-line no-redeclare


function curry(f) {
  // eslint-disable-line no-redeclare
  return curried(f, f.length, []);
}

function guard(lowerBoundary, upperBoundary, value) {
  return Math.max(lowerBoundary, Math.min(upperBoundary, value));
}
/**
 * Returns a number (float) representing the luminance of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff',
 *   background: getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)',
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff'};
 *   background: ${getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)'};
 *
 * // CSS in JS Output
 *
 * div {
 *   background: "#CCCD64";
 *   background: "rgba(58, 133, 255, 1)";
 * }
 */


function getLuminance(color) {
  if (color === 'transparent') return 0;
  var rgbColor = parseToRgb(color);

  var _Object$keys$map = Object.keys(rgbColor).map(function (key) {
    var channel = rgbColor[key] / 255;
    return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
  }),
      r = _Object$keys$map[0],
      g = _Object$keys$map[1],
      b = _Object$keys$map[2];

  return parseFloat((0.2126 * r + 0.7152 * g + 0.0722 * b).toFixed(3));
}
/**
 * Mixes the two provided colors together by calculating the average of each of the RGB components weighted to the first color by the provided weight.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: mix(0.5, '#f00', '#00f')
 *   background: mix(0.25, '#f00', '#00f')
 *   background: mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${mix(0.5, '#f00', '#00f')};
 *   background: ${mix(0.25, '#f00', '#00f')};
 *   background: ${mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#7f007f";
 *   background: "#3f00bf";
 *   background: "rgba(63, 0, 191, 0.75)";
 * }
 */


function mix(weight, color, otherColor) {
  if (color === 'transparent') return otherColor;
  if (otherColor === 'transparent') return color;
  var parsedColor1 = parseToRgb(color);

  var color1 = _extends$1({}, parsedColor1, {
    alpha: typeof parsedColor1.alpha === 'number' ? parsedColor1.alpha : 1
  });

  var parsedColor2 = parseToRgb(otherColor);

  var color2 = _extends$1({}, parsedColor2, {
    alpha: typeof parsedColor2.alpha === 'number' ? parsedColor2.alpha : 1 // The formular is copied from the original Sass implementation:
    // http://sass-lang.com/documentation/Sass/Script/Functions.html#mix-instance_method

  });

  var alphaDelta = color1.alpha - color2.alpha;
  var x = parseFloat(weight) * 2 - 1;
  var y = x * alphaDelta === -1 ? x : x + alphaDelta;
  var z = 1 + x * alphaDelta;
  var weight1 = (y / z + 1) / 2.0;
  var weight2 = 1 - weight1;
  var mixedColor = {
    red: Math.floor(color1.red * weight1 + color2.red * weight2),
    green: Math.floor(color1.green * weight1 + color2.green * weight2),
    blue: Math.floor(color1.blue * weight1 + color2.blue * weight2),
    alpha: color1.alpha + (color2.alpha - color1.alpha) * (parseFloat(weight) / 1.0)
  };
  return rgba(mixedColor);
} // prettier-ignore


var curriedMix =
/*#__PURE__*/
curry
/* ::<number | string, string, string, string> */
(mix);
/**
 * Returns black or white (or optional light and dark return colors) for best contrast depending on the luminosity of the given color.
 * Follows [W3C specs for readability](https://www.w3.org/TR/WCAG20-TECHS/G18.html).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   color: readableColor('#000'),
 *   color: readableColor('black', '#001', '#ff8'),
 *   color: readableColor('white', '#001', '#ff8'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   color: ${readableColor('#000')};
 *   color: ${readableColor('black', '#001', '#ff8')};
 *   color: ${readableColor('white', '#001', '#ff8')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   color: "#fff";
 *   color: "#ff8";
 *   color: "#001";
 * }
 */

function readableColor(color, lightReturnColor, darkReturnColor) {
  if (lightReturnColor === void 0) {
    lightReturnColor = '#000';
  }

  if (darkReturnColor === void 0) {
    darkReturnColor = '#fff';
  }

  return getLuminance(color) > 0.179 ? lightReturnColor : darkReturnColor;
}
/**
 * Shades a color by mixing it with black. `shade` can produce
 * hue shifts, where as `darken` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: shade(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${shade(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#00003f";
 * }
 */


function shade(percentage, color) {
  if (color === 'transparent') return color;
  return curriedMix(parseFloat(percentage), 'rgb(0, 0, 0)', color);
} // prettier-ignore


var curriedShade =
/*#__PURE__*/
curry
/* ::<number | string, string, string> */
(shade);
/**
 * Tints a color by mixing it with white. `tint` can produce
 * hue shifts, where as `lighten` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: tint(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${tint(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#bfbfff";
 * }
 */

function tint(percentage, color) {
  if (color === 'transparent') return color;
  return curriedMix(parseFloat(percentage), 'rgb(255, 255, 255)', color);
} // prettier-ignore


var curriedTint =
/*#__PURE__*/
curry
/* ::<number | string, string, string> */
(tint);
/**
 * Decreases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: transparentize(0.1, '#fff');
 *   background: transparentize(0.2, 'hsl(0, 0%, 100%)'),
 *   background: transparentize('0.5', 'rgba(255, 0, 0, 0.8)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${transparentize(0.1, '#fff')};
 *   background: ${transparentize(0.2, 'hsl(0, 0%, 100%)')},
 *   background: ${transparentize('0.5', 'rgba(255, 0, 0, 0.8)')},
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,255,255,0.9)";
 *   background: "rgba(255,255,255,0.8)";
 *   background: "rgba(255,0,0,0.3)";
 * }
 */

function transparentize(amount, color) {
  if (color === 'transparent') return color;
  var parsedColor = parseToRgb(color);
  var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;

  var colorWithAlpha = _extends$1({}, parsedColor, {
    alpha: guard(0, 1, (alpha * 100 - parseFloat(amount) * 100) / 100)
  });

  return rgba(colorWithAlpha);
} // prettier-ignore


var curriedTransparentize =
/*#__PURE__*/
curry
/* ::<number | string, string, string> */
(transparentize);
var baseColors = {
  black: '#000',
  white: '#FFF',
  blue: '#36ADF1',
  green: '#28C081',
  yellow: '#FD9D28',
  red: '#DC2C10',
  blurple: '#4E3FCE',
  consensysblue: '#3259D6'
}; // rimble palette

var colors = {
  blurple: {
    base: baseColors.blurple,
    text: readableColor(baseColors.blurple),
    light: [null, curriedTint(0.2, baseColors.blurple)],
    dark: [null, curriedShade(0.2, baseColors.blurple)]
  },
  blue: {
    base: baseColors.blue,
    text: readableColor(baseColors.blue),
    light: [null, curriedTint(0.9, baseColors.blue)],
    dark: [null, curriedShade(0.4, baseColors.blue)]
  },
  green: {
    base: baseColors.green,
    text: baseColors.white,
    light: [null, curriedTint(0.9, baseColors.green)],
    dark: [null, curriedShade(0.4, baseColors.green)]
  },
  yellow: {
    base: baseColors.yellow,
    text: readableColor(baseColors.yellow),
    light: [null, curriedTint(0.9, baseColors.yellow)],
    dark: [null, curriedShade(0.4, baseColors.yellow)]
  },
  red: {
    base: baseColors.red,
    text: readableColor(baseColors.red),
    light: [null, curriedTint(0.9, baseColors.red)],
    dark: [null, curriedShade(0.4, baseColors.red)]
  }
};
var blurple = colors.blurple;
var blue = colors.blue;
var green = colors.green;
var yellow = colors.yellow;
var red = colors.red;
var theme = {
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64],
  fontWeights: [0, 300, 400, 600, 700],
  letterSpacings: [0, 1, 2, 4, 8],
  lineHeights: {
    solid: 1,
    title: 1.25,
    copy: 1.5
  },
  fonts: {
    serif: 'athelas, georgia, times, serif',
    sansSerif: '"Source Sans Pro", -apple-system, sans-serif'
  },
  space: [0, 4, 8, 16, 32, 64, 128, 256],
  radii: ['0', '4px', '8px', '16px', '32px'],
  width: [0, 16, 32, 64, 128, 256],
  minWidths: [0, 16, 32, 64, 128, 256],
  maxWidths: [0, 16, 32, 64, 128, 256, 512, 768, 1024, 1536],
  heights: [0, 16, 32, 64, 128, 256],
  minHeights: [0, 16, 32, 64, 128, 256],
  maxHeights: [0, 16, 32, 64, 128, 256],
  borders: [0, '1px solid transparent'],
  borderWidths: ['0', '1px', '2px', '4px'],
  shadows: ['0', '0px 2px 4px rgba(0, 0, 0, 0.1)', '0px 8px 16px rgba(0, 0, 0, 0.1)', '0 7px 14px rgba(50,50,93,.1)'],
  opacity: {
    disabled: 0.4
  },
  colors: {
    primary: blurple.base,
    'primary-light': blurple.light[1],
    'primary-dark': blurple.dark[1],
    blue: baseColors.consensysblue,
    copyColor: '#3F3D4B',
    black: '#000e1a',
    'near-black': '#111',
    'dark-gray': '#333',
    'mid-gray': '#555',
    grey: '#CCC',
    silver: '#999',
    'light-silver': '#aaa',
    'moon-gray': '#ccc',
    'light-gray': '#eee',
    'near-white': '#f4f4f4',
    white: '#fff',
    transparent: 'transparent',
    blacks: ['rgba(0,0,0,.0125)', 'rgba(0,0,0,.025)', 'rgba(0,0,0,.05)', 'rgba(0,0,0,.1)', 'rgba(0,0,0,.2)', 'rgba(0,0,0,.3)', 'rgba(0,0,0,.4)', 'rgba(0,0,0,.5)', 'rgba(0,0,0,.6)', 'rgba(0,0,0,.7)', 'rgba(0,0,0,.8)', 'rgba(0,0,0,.9)'],
    whites: ['rgba(255,255,255,.0125)', 'rgba(255,255,255,.025)', 'rgba(255,255,255,.05)', 'rgba(255,255,255,.1)', 'rgba(255,255,255,.2)', 'rgba(255,255,255,.3)', 'rgba(255,255,255,.4)', 'rgba(255,255,255,.5)', 'rgba(255,255,255,.6)', 'rgba(255,255,255,.7)', 'rgba(255,255,255,.8)', 'rgba(255,255,255,.9)'],
    success: green.base,
    warning: yellow.base,
    danger: red.base,
    info: blue.base
  },
  zIndices: [0, 9, 99, 999, 9999],
  messageStyle: {
    base: {
      color: curriedShade(0.4, '#AAA'),
      backgroundColor: curriedTint(0.9, '#AAA'),
      borderColor: '#AAA'
    },
    success: {
      color: curriedShade(0.4, green.base),
      backgroundColor: curriedTint(0.9, green.base),
      borderColor: green.base
    },
    warning: {
      color: curriedShade(0.4, yellow.base),
      backgroundColor: curriedTint(0.9, yellow.base),
      borderColor: yellow.base
    },
    danger: {
      color: curriedShade(0.4, red.base),
      backgroundColor: curriedTint(0.9, red.base),
      borderColor: red.base
    },
    info: {
      color: curriedShade(0.4, blue.base),
      backgroundColor: curriedTint(0.9, blue.base),
      borderColor: blue.base
    }
  },
  buttons: {
    primary: {
      color: blurple.text,
      backgroundColor: blurple.base,
      // use css custom props
      '--main-color': blurple.base,
      '--contrast-color': blurple.text
    },
    success: {
      '--main-color': green.base,
      '--contrast-color': green.text
    },
    danger: {
      '--main-color': red.base,
      '--contrast-color': red.text
    }
  },
  buttonSizes: {
    small: {
      fontSize: '0.75rem',
      height: '2rem',
      minWidth: '2rem',
      padding: '0 1rem'
    },
    medium: {
      fontSize: '1rem',
      height: '3rem',
      minWidth: '3rem'
    },
    large: {
      fontSize: '1.5rem',
      height: '4rem',
      minWidth: '4rem'
    }
  }
};

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  & {\n    box-sizing: border-box;\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledBox = styled.div(_templateObject(), COMMON, LAYOUT, POSITION, FLEXBOX, BORDERS, opacity);
StyledBox.defaultProps = {
  theme: theme
};
var Box = React.forwardRef(function (props, ref) {
  return React.createElement(StyledBox, _extends({
    ref: ref
  }, props));
});
Box.propTypes = _objectSpread2({}, COMMON.propTypes, {}, LAYOUT.propTypes, {}, POSITION.propTypes, {}, FLEXBOX.propTypes, {}, BORDERS.propTypes, {
  theme: PropTypes.object
});
Box.displayName = 'Box';
var Flex = React.forwardRef(function (props, ref) {
  return React.createElement(Box, _extends({
    ref: ref
  }, props));
});
Flex.defaultProps = {
  display: 'flex'
};
Flex.propTypes = _objectSpread2({}, Box.propTypes);
Flex.displayName = 'Flex';
var Card = React.forwardRef(function (props, ref) {
  return React.createElement(Box, _extends({
    ref: ref
  }, props));
});
Card.defaultProps = {
  position: 'relative',
  bg: 'white',
  border: 1,
  borderColor: 'light-gray',
  boxShadow: 2,
  p: 4,
  width: 1,
  minWidth: 1,
  height: 'auto',
  minHeight: 1
};
Card.propTypes = _objectSpread2({}, Box.propTypes, {
  theme: PropTypes.object
});
Card.displayName = 'Card';
var Image = React.forwardRef(function (props, ref) {
  return React.createElement(Box, _extends({
    ref: ref
  }, props));
});
Image.defaultProps = {
  as: 'img',
  maxWidth: '100%',
  height: 'auto'
};
Image.propTypes = _objectSpread2({}, Box.propTypes, {
  theme: PropTypes.object,

  /**
   * Sets alt attribute on image for accessibility
   */
  alt: PropTypes.string,

  /**
   * Sets the src attribute of the img element
   */
  src: PropTypes.string.isRequired
});
Image.displayName = 'Image';
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

var constants = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var breakpoints = exports.breakpoints = ['40em', '52em', '64em'];
  var space = exports.space = [0, 4, 8, 16, 32, 64, 128, 256, 512];
  var fontSizes = exports.fontSizes = [12, 14, 16, 20, 24, 32, 48, 64, 72];
  exports.default = {
    breakpoints: breakpoints,
    space: space,
    fontSizes: fontSizes
  };
});
unwrapExports(constants);
var constants_1 = constants.breakpoints;
var constants_2 = constants.space;
var constants_3 = constants.fontSizes;
var util = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.complexStyle = exports.themeGet = exports.pseudoStyle = exports.responsiveStyle = exports.style = exports.cloneFunc = exports.getValue = exports.merge = exports.media = exports.dec = exports.breaks = exports.fallbackTheme = exports.mq = exports.get = exports.getWidth = exports.arr = exports.neg = exports.px = exports.num = exports.is = undefined;

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _propTypes2 = _interopRequireDefault(PropTypes);

  var _constants2 = _interopRequireDefault(constants);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }

      return arr2;
    } else {
      return Array.from(arr);
    }
  }

  var propTypes = {
    responsive: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.array]),
    numberOrString: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
  };

  var is = exports.is = function is(n) {
    return n !== undefined && n !== null;
  };

  var num = exports.num = function num(n) {
    return typeof n === 'number' && !isNaN(n);
  };

  var px = exports.px = function px(n) {
    return num(n) ? n + 'px' : n;
  };

  var neg = exports.neg = function neg(n) {
    return n < 0;
  };

  var arr = exports.arr = function arr(n) {
    return Array.isArray(n) ? n : [n];
  };

  var getWidth = exports.getWidth = function getWidth(n) {
    return !num(n) || n > 1 ? px(n) : n * 100 + '%';
  };

  var get = exports.get = function get(obj, path, fallback) {
    return path.split('.').reduce(function (a, b) {
      return a && a[b] ? a[b] : null;
    }, obj) || fallback;
  };

  var mq = exports.mq = function mq(n) {
    return '@media screen and (min-width: ' + px(n) + ')';
  };

  var fallbackTheme = exports.fallbackTheme = function fallbackTheme(props) {
    return _extends({}, _constants2.default, get(props, 'theme'));
  };

  var breaks = exports.breaks = function breaks(props) {
    return [null].concat(_toConsumableArray(get(props, 'theme.breakpoints', constants.breakpoints).map(mq)));
  };

  var dec = exports.dec = function dec(props) {
    return function (val) {
      return arr(props).reduce(function (acc, prop) {
        return acc[prop] = val, acc;
      }, {});
    };
  };

  var media = exports.media = function media(bp) {
    return function (d, i) {
      return is(d) ? bp[i] ? _defineProperty({}, bp[i], d) : d : null;
    };
  };

  var merge = exports.merge = function merge(a, b) {
    return Object.assign({}, a, b, Object.keys(b || {}).reduce(function (obj, key) {
      return Object.assign(obj, _defineProperty({}, key, a[key] !== null && _typeof(a[key]) === 'object' ? merge(a[key], b[key]) : b[key]));
    }, {}));
  };

  var getValue = exports.getValue = function getValue(val, getter, toPx) {
    return typeof getter === 'function' ? getter(val) : toPx ? px(val) : val;
  };

  var cloneFunc = exports.cloneFunc = function cloneFunc(fn) {
    return function () {
      return fn.apply(undefined, arguments);
    };
  };

  var style = exports.style = function style(_ref2) {
    var prop = _ref2.prop,
        cssProperty = _ref2.cssProperty,
        alias = _ref2.alias,
        key = _ref2.key,
        getter = _ref2.getter,
        numberToPx = _ref2.numberToPx;

    var fn = function fn(props) {
      cssProperty = cssProperty || prop;
      var n = is(props[prop]) ? props[prop] : props[alias];
      var th = fallbackTheme(props);
      if (!is(n)) return null;
      var value = getValue(get(th, [key, n].join('.'), n), getter, numberToPx);
      return _defineProperty({}, cssProperty, value);
    };

    fn.propTypes = _defineProperty({}, prop, cloneFunc(propTypes.numberOrString));

    if (alias) {
      fn.propTypes[alias] = propTypes.numberOrString;
    }

    fn.propTypes[prop].meta = {
      prop: prop,
      themeKey: key,
      styleType: 'default'
    };
    return fn;
  };

  var responsiveStyle = exports.responsiveStyle = function responsiveStyle(_ref4) {
    var prop = _ref4.prop,
        cssProperty = _ref4.cssProperty,
        alias = _ref4.alias,
        key = _ref4.key,
        getter = _ref4.getter,
        numberToPx = _ref4.numberToPx;

    var fn = function fn(props) {
      cssProperty = cssProperty || prop;
      var n = is(props[prop]) ? props[prop] : props[alias];
      if (!is(n)) return null;
      var bp = breaks(props);
      var th = fallbackTheme(props);

      var sx = function sx(n) {
        return getValue(get(th, [key || prop, n].join('.'), n), getter, numberToPx);
      };

      if (!Array.isArray(n)) {
        return _defineProperty({}, cssProperty, sx(n));
      }

      var val = arr(n);
      return val.map(sx).map(dec(cssProperty)).map(media(bp)).reduce(merge, {});
    }; // add propTypes object to returned function


    fn.propTypes = _defineProperty({}, prop, cloneFunc(propTypes.responsive));

    if (alias) {
      fn.propTypes[alias] = propTypes.responsive;
    }

    fn.propTypes[prop].meta = {
      prop: prop,
      themeKey: key,
      responsive: true,
      styleType: 'responsive'
    };
    return fn;
  };

  var pseudoStyle = exports.pseudoStyle = function pseudoStyle(_ref6) {
    var prop = _ref6.prop,
        alias = _ref6.alias,
        pseudoclass = _ref6.pseudoclass,
        _ref6$keys = _ref6.keys,
        keys = _ref6$keys === undefined ? {} : _ref6$keys,
        _ref6$getters = _ref6.getters,
        getters = _ref6$getters === undefined ? {} : _ref6$getters,
        _ref6$numberToPx = _ref6.numberToPx,
        numberToPx = _ref6$numberToPx === undefined ? {} : _ref6$numberToPx;

    var fn = function fn(props) {
      var style = props[prop] || props[alias];
      pseudoclass = pseudoclass || prop;
      var th = fallbackTheme(props);

      for (var key in style) {
        var toPx = numberToPx[key];
        if (!keys[key] && !getters[key] && !toPx) continue;
        var themeKey = [keys[key], style[key]].join('.');
        style[key] = getValue(get(th, themeKey, style[key]), getters[key], toPx);
      }

      return _defineProperty({}, '&:' + pseudoclass, style);
    };

    fn.propTypes = _defineProperty({}, prop, cloneFunc(_propTypes2.default.object));
    fn.propTypes[prop].meta = {
      prop: prop,
      pseudo: true,
      styleType: 'pseudo'
    };
    return fn;
  }; // todo: consider alternative names


  var themeGet = exports.themeGet = function themeGet(keys, fallback) {
    return function (props) {
      return get(props.theme, keys, fallback);
    };
  };

  var getBooleans = function getBooleans(props) {
    var bools = [];

    for (var key in props) {
      if (props[key] !== true) continue;
      bools.push(key);
    }

    return bools;
  };

  var complexStyle = exports.complexStyle = function complexStyle(_ref8) {
    var prop = _ref8.prop,
        key = _ref8.key,
        alias = _ref8.alias;

    var fn = function fn(props) {
      var style = get(props, ['theme', key, get(props, prop, props[alias])].join('.'), {});
      var bools = getBooleans(props);
      bools.forEach(function (name) {
        style = _extends({}, style, get(props, ['theme', key, name].join('.'), {}));
      });
      return style;
    };

    fn.propTypes = _defineProperty({}, prop, _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]));

    if (alias) {
      fn.propTypes[alias] = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]);
    }

    fn.propTypes[prop].meta = {
      prop: prop,
      themeKey: key,
      complex: true,
      styleType: 'complex'
    };
    return fn;
  };
});
unwrapExports(util);
var util_1 = util.complexStyle;
var util_2 = util.themeGet;
var util_3 = util.pseudoStyle;
var util_4 = util.responsiveStyle;
var util_5 = util.style;
var util_6 = util.cloneFunc;
var util_7 = util.getValue;
var util_8 = util.merge;
var util_9 = util.media;
var util_10 = util.dec;
var util_11 = util.breaks;
var util_12 = util.fallbackTheme;
var util_13 = util.mq;
var util_14 = util.get;
var util_15 = util.getWidth;
var util_16 = util.arr;
var util_17 = util.neg;
var util_18 = util.px;
var util_19 = util.num;
var util_20 = util.is;
var space_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.space = undefined;

  var _slicedToArray = function () {
    function sliceIterator(arr, i) {
      var _arr = [];
      var _n = true;
      var _d = false;
      var _e = undefined;

      try {
        for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
          _arr.push(_s.value);

          if (i && _arr.length === i) break;
        }
      } catch (err) {
        _d = true;
        _e = err;
      } finally {
        try {
          if (!_n && _i["return"]) _i["return"]();
        } finally {
          if (_d) throw _e;
        }
      }

      return _arr;
    }

    return function (arr, i) {
      if (Array.isArray(arr)) {
        return arr;
      } else if (Symbol.iterator in Object(arr)) {
        return sliceIterator(arr, i);
      } else {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }
    };
  }();

  var _propTypes2 = _interopRequireDefault(PropTypes);

  var _constants2 = _interopRequireDefault(constants);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var REG = /^[mp][trblxy]?$/;

  var space = exports.space = function space(props) {
    var keys = Object.keys(props).filter(function (key) {
      return REG.test(key);
    }).sort();
    var bp = (0, util.breaks)(props);
    var sc = (0, util.get)(props, 'theme.space', _constants2.default.space);
    return keys.map(function (key) {
      var val = props[key];
      var p = getProperties(key);

      if (!Array.isArray(val)) {
        return p.reduce(function (a, b) {
          return Object.assign(a, _defineProperty({}, b, mx(sc)(val)));
        }, {});
      }

      return (0, util.arr)(val).map(mx(sc)).map((0, util.dec)(p)).map((0, util.media)(bp)).reduce(util.merge, {});
    }).reduce(util.merge, {});
  };

  var mx = function mx(scale) {
    return function (n) {
      if (!(0, util.num)(n)) {
        return scale[n] || n;
      }

      var value = scale[Math.abs(n)] || Math.abs(n);

      if (!(0, util.num)(value)) {
        return (0, util.neg)(n) ? '-' + value : value;
      }

      return (0, util.px)(value * ((0, util.neg)(n) ? -1 : 1));
    };
  };

  var getProperties = function getProperties(key) {
    var _key$split = key.split(''),
        _key$split2 = _slicedToArray(_key$split, 2),
        a = _key$split2[0],
        b = _key$split2[1];

    var prop = properties[a];
    var dirs = directions[b] || [''];
    return dirs.map(function (dir) {
      return prop + dir;
    });
  };

  var properties = {
    m: 'margin',
    p: 'padding'
  };
  var directions = {
    t: ['Top'],
    r: ['Right'],
    b: ['Bottom'],
    l: ['Left'],
    x: ['Left', 'Right'],
    y: ['Top', 'Bottom']
  };

  var responsive = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.array]);

  space.propTypes = {
    m: responsive,
    mt: responsive,
    mr: responsive,
    mb: responsive,
    ml: responsive,
    mx: responsive,
    my: responsive,
    p: responsive,
    pt: responsive,
    pr: responsive,
    pb: responsive,
    pl: responsive,
    px: responsive,
    py: responsive
  };

  var meta = function meta(prop) {
    return {
      prop: prop,
      responsive: true,
      styleType: 'responsive',
      themeKey: 'space'
    };
  };

  Object.keys(space.propTypes).forEach(function (prop) {
    space.propTypes[prop].meta = meta(prop);
  });
  exports.default = space;
});
unwrapExports(space_1);
var space_2 = space_1.space;
var styles = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.borderWidth = exports.buttonStyle = exports.colorStyle = exports.textStyle = exports.disabled = exports.active = exports.focus = exports.hover = exports.left = exports.bottom = exports.right = exports.top = exports.zIndex = exports.position = exports.backgroundRepeat = exports.backgroundPosition = exports.backgroundSize = exports.backgroundImage = exports.background = exports.boxShadow = exports.borderRadius = exports.borderColor = exports.borders = exports.borderLeft = exports.borderBottom = exports.borderRight = exports.borderTop = exports.border = exports.gridTemplateRows = exports.gridTemplateColumns = exports.gridAutoRows = exports.gridAutoColumns = exports.gridAutoFlow = exports.gridRow = exports.gridColumn = exports.gridRowGap = exports.gridColumnGap = exports.gridGap = exports.order = exports.alignSelf = exports.justifySelf = exports.flex = exports.flexDirection = exports.flexBasis = exports.flexWrap = exports.justifyContent = exports.alignContent = exports.alignItems = exports.verticalAlign = exports.ratio = exports.ratioPadding = exports.size = exports.sizeHeight = exports.sizeWidth = exports.minHeight = exports.maxHeight = exports.height = exports.minWidth = exports.maxWidth = exports.display = exports.letterSpacing = exports.fontWeight = exports.lineHeight = exports.textAlign = exports.fontFamily = exports.opacity = exports.color = exports.bgColor = exports.textColor = exports.fontSize = exports.width = exports.space = undefined;

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  Object.defineProperty(exports, 'space', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(space_1).default;
    }
  });

  var util$1 = _interopRequireWildcard(util);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var width = exports.width = (0, util.responsiveStyle)({
    prop: 'width',
    alias: 'w',
    getter: util.getWidth
  });
  var fontSize = exports.fontSize = (0, util.responsiveStyle)({
    prop: 'fontSize',
    alias: 'f',
    key: 'fontSizes',
    numberToPx: true
  });
  var textColor = exports.textColor = (0, util.responsiveStyle)({
    prop: 'color',
    key: 'colors'
  });
  var bgColor = exports.bgColor = (0, util.responsiveStyle)({
    prop: 'bg',
    cssProperty: 'backgroundColor',
    key: 'colors'
  });

  var color = exports.color = function color(props) {
    return _extends({}, textColor(props), bgColor(props));
  };

  color.propTypes = _extends({}, textColor.propTypes, bgColor.propTypes);
  var opacity = exports.opacity = (0, util.responsiveStyle)({
    prop: 'opacity'
  }); // typography

  var fontFamily = exports.fontFamily = (0, util.style)({
    prop: 'fontFamily',
    alias: 'font',
    key: 'fonts'
  });
  var textAlign = exports.textAlign = (0, util.responsiveStyle)({
    prop: 'textAlign',
    // for backwards compatibility - will cause bugs when used with alignItems
    alias: 'align'
  });
  var lineHeight = exports.lineHeight = (0, util.responsiveStyle)({
    prop: 'lineHeight',
    key: 'lineHeights'
  });
  var fontWeight = exports.fontWeight = (0, util.style)({
    prop: 'fontWeight',
    key: 'fontWeights'
  });
  var letterSpacing = exports.letterSpacing = (0, util.style)({
    prop: 'letterSpacing',
    key: 'letterSpacings',
    numberToPx: true
  }); // layout

  var display = exports.display = (0, util.responsiveStyle)({
    prop: 'display'
  });
  var maxWidth = exports.maxWidth = (0, util.responsiveStyle)({
    prop: 'maxWidth',
    key: 'maxWidths',
    numberToPx: true
  });
  var minWidth = exports.minWidth = (0, util.responsiveStyle)({
    prop: 'minWidth',
    key: 'minWidths',
    numberToPx: true
  });
  var height = exports.height = (0, util.responsiveStyle)({
    prop: 'height',
    key: 'heights',
    numberToPx: true
  });
  var maxHeight = exports.maxHeight = (0, util.responsiveStyle)({
    prop: 'maxHeight',
    key: 'maxHeights',
    numberToPx: true
  });
  var minHeight = exports.minHeight = (0, util.responsiveStyle)({
    prop: 'minHeight',
    key: 'minHeights',
    numberToPx: true
  });
  var sizeWidth = exports.sizeWidth = (0, util.responsiveStyle)({
    prop: 'size',
    cssProperty: 'width',
    numberToPx: true
  });
  var sizeHeight = exports.sizeHeight = (0, util.responsiveStyle)({
    prop: 'size',
    cssProperty: 'height',
    numberToPx: true
  });

  var size = exports.size = function size(props) {
    return (0, util.merge)(sizeHeight(props), sizeWidth(props));
  };

  size.propTypes = _extends({}, sizeWidth.propTypes, sizeHeight.propTypes);
  var ratioPadding = exports.ratioPadding = (0, util.style)({
    prop: 'ratio',
    cssProperty: 'paddingBottom',
    getter: function getter(n) {
      return n * 100 + '%';
    }
  });

  var ratio = exports.ratio = function ratio(props) {
    return props.ratio ? _extends({
      height: 0
    }, ratioPadding(props)) : null;
  };

  ratio.propTypes = _extends({}, ratioPadding.propTypes);
  var verticalAlign = exports.verticalAlign = (0, util.style)({
    prop: 'verticalAlign'
  }); // flexbox

  var alignItems = exports.alignItems = (0, util.responsiveStyle)({
    prop: 'alignItems',
    // for backwards compatibility - will cause bugs when used with textAlign
    alias: 'align'
  });
  var alignContent = exports.alignContent = (0, util.responsiveStyle)({
    prop: 'alignContent'
  });
  var justifyContent = exports.justifyContent = (0, util.responsiveStyle)({
    prop: 'justifyContent',
    // for backwards compatibility
    alias: 'justify'
  }); // for backwards compatibility

  var flexWrapShim = function flexWrapShim(n) {
    return n === true ? 'wrap' : n;
  };

  var flexWrap = exports.flexWrap = (0, util.responsiveStyle)({
    prop: 'flexWrap',
    alias: 'wrap',
    getter: flexWrapShim
  });
  var flexBasis = exports.flexBasis = (0, util.responsiveStyle)({
    prop: 'flexBasis',
    getter: util.getWidth
  });
  var flexDirection = exports.flexDirection = (0, util.responsiveStyle)({
    prop: 'flexDirection'
  });
  var flex = exports.flex = (0, util.responsiveStyle)({
    prop: 'flex'
  });
  var justifySelf = exports.justifySelf = (0, util.responsiveStyle)({
    prop: 'justifySelf'
  });
  var alignSelf = exports.alignSelf = (0, util.responsiveStyle)({
    prop: 'alignSelf'
  });
  var order = exports.order = (0, util.responsiveStyle)({
    prop: 'order'
  }); // grid

  var gridGap = exports.gridGap = (0, util.responsiveStyle)({
    prop: 'gridGap',
    numberToPx: true,
    key: 'space'
  });
  var gridColumnGap = exports.gridColumnGap = (0, util.responsiveStyle)({
    prop: 'gridColumnGap',
    numberToPx: true,
    key: 'space'
  });
  var gridRowGap = exports.gridRowGap = (0, util.responsiveStyle)({
    prop: 'gridRowGap',
    numberToPx: true,
    key: 'space'
  });
  var gridColumn = exports.gridColumn = (0, util.responsiveStyle)({
    prop: 'gridColumn'
  });
  var gridRow = exports.gridRow = (0, util.responsiveStyle)({
    prop: 'gridRow'
  });
  var gridAutoFlow = exports.gridAutoFlow = (0, util.style)({
    prop: 'gridAutoFlow'
  });
  var gridAutoColumns = exports.gridAutoColumns = (0, util.style)({
    prop: 'gridAutoColumns'
  });
  var gridAutoRows = exports.gridAutoRows = (0, util.style)({
    prop: 'gridAutoRows'
  });
  var gridTemplateColumns = exports.gridTemplateColumns = (0, util.responsiveStyle)({
    prop: 'gridTemplateColumns'
  });
  var gridTemplateRows = exports.gridTemplateRows = (0, util.responsiveStyle)({
    prop: 'gridTemplateRows'
  }); // borders

  var getBorder = function getBorder(n) {
    return util$1.num(n) && n > 0 ? n + 'px solid' : n;
  };

  var border = exports.border = (0, util.responsiveStyle)({
    prop: 'border',
    key: 'borders',
    getter: getBorder
  });
  var borderTop = exports.borderTop = (0, util.responsiveStyle)({
    prop: 'borderTop',
    key: 'borders',
    getter: getBorder
  });
  var borderRight = exports.borderRight = (0, util.responsiveStyle)({
    prop: 'borderRight',
    key: 'borders',
    getter: getBorder
  });
  var borderBottom = exports.borderBottom = (0, util.responsiveStyle)({
    prop: 'borderBottom',
    key: 'borders',
    getter: getBorder
  });
  var borderLeft = exports.borderLeft = (0, util.responsiveStyle)({
    prop: 'borderLeft',
    key: 'borders',
    getter: getBorder
  });

  var borders = exports.borders = function borders(props) {
    return _extends({}, border(props), borderTop(props), borderRight(props), borderBottom(props), borderLeft(props));
  };

  borders.propTypes = _extends({}, border.propTypes, borderTop.propTypes, borderRight.propTypes, borderBottom.propTypes, borderLeft.propTypes);
  var borderColor = exports.borderColor = (0, util.style)({
    prop: 'borderColor',
    key: 'colors'
  });
  var borderRadius = exports.borderRadius = (0, util.style)({
    prop: 'borderRadius',
    key: 'radii',
    numberToPx: true
  });
  var boxShadow = exports.boxShadow = (0, util.style)({
    prop: 'boxShadow',
    key: 'shadows'
  }); // backgrounds

  var background = exports.background = (0, util.style)({
    prop: 'background'
  });
  var backgroundImage = exports.backgroundImage = (0, util.style)({
    prop: 'backgroundImage',
    alias: 'bgImage',
    getter: function getter(n) {
      return 'url(' + n + ')';
    }
  });
  var backgroundSize = exports.backgroundSize = (0, util.style)({
    prop: 'backgroundSize',
    alias: 'bgSize'
  });
  var backgroundPosition = exports.backgroundPosition = (0, util.style)({
    prop: 'backgroundPosition',
    alias: 'bgPosition'
  });
  var backgroundRepeat = exports.backgroundRepeat = (0, util.style)({
    prop: 'backgroundRepeat',
    alias: 'bgRepeat'
  }); // position

  var position = exports.position = (0, util.responsiveStyle)({
    prop: 'position'
  });
  var zIndex = exports.zIndex = (0, util.style)({
    prop: 'zIndex'
  });
  var top = exports.top = (0, util.responsiveStyle)({
    prop: 'top',
    numberToPx: true
  });
  var right = exports.right = (0, util.responsiveStyle)({
    prop: 'right',
    numberToPx: true
  });
  var bottom = exports.bottom = (0, util.responsiveStyle)({
    prop: 'bottom',
    numberToPx: true
  });
  var left = exports.left = (0, util.responsiveStyle)({
    prop: 'left',
    numberToPx: true
  }); // pseudos

  var hover = exports.hover = (0, util.pseudoStyle)({
    prop: 'hover',
    pseudoclass: 'hover',
    keys: {
      color: 'colors',
      backgroundColor: 'colors',
      borderColor: 'colors',
      boxShadow: 'shadows'
    }
  });
  var focus = exports.focus = (0, util.pseudoStyle)({
    prop: 'focus',
    keys: {
      color: 'colors',
      backgroundColor: 'colors',
      borderColor: 'colors',
      boxShadow: 'shadows'
    }
  });
  var active = exports.active = (0, util.pseudoStyle)({
    prop: 'active',
    keys: {
      color: 'colors',
      backgroundColor: 'colors',
      borderColor: 'colors',
      boxShadow: 'shadows'
    }
  });
  var disabled = exports.disabled = (0, util.pseudoStyle)({
    prop: 'disabledStyle',
    pseudoclass: 'disabled',
    keys: {
      color: 'colors',
      backgroundColor: 'colors',
      borderColor: 'colors',
      boxShadow: 'shadows'
    }
  });
  var textStyle = exports.textStyle = (0, util.complexStyle)({
    prop: 'textStyle',
    key: 'textStyles'
  });
  var colorStyle = exports.colorStyle = (0, util.complexStyle)({
    prop: 'colors',
    key: 'colorStyles'
  });
  var buttonStyle = exports.buttonStyle = (0, util.complexStyle)({
    prop: 'buttonStyle',
    key: 'buttons'
  }); // for backwards-compatibility
  // these will be removed in v3

  var __DEV__ = process.env.NODE_ENV !== 'production';

  var borderWidth = exports.borderWidth = (0, util.style)({
    prop: 'borderWidth',
    cssProperty: 'border',
    key: 'borderWidths',
    getter: function getter(v) {
      if (__DEV__) {
        console.warn('borderWidth is deprecated. Please use the `borders` utility instead');
      }

      return getBorder(v);
    }
  });
});
unwrapExports(styles);
var styles_1 = styles.borderWidth;
var styles_2 = styles.buttonStyle;
var styles_3 = styles.colorStyle;
var styles_4 = styles.textStyle;
var styles_5 = styles.disabled;
var styles_6 = styles.active;
var styles_7 = styles.focus;
var styles_8 = styles.hover;
var styles_9 = styles.left;
var styles_10 = styles.bottom;
var styles_11 = styles.right;
var styles_12 = styles.top;
var styles_13 = styles.zIndex;
var styles_14 = styles.position;
var styles_15 = styles.backgroundRepeat;
var styles_16 = styles.backgroundPosition;
var styles_17 = styles.backgroundSize;
var styles_18 = styles.backgroundImage;
var styles_19 = styles.background;
var styles_20 = styles.boxShadow;
var styles_21 = styles.borderRadius;
var styles_22 = styles.borderColor;
var styles_23 = styles.borders;
var styles_24 = styles.borderLeft;
var styles_25 = styles.borderBottom;
var styles_26 = styles.borderRight;
var styles_27 = styles.borderTop;
var styles_28 = styles.border;
var styles_29 = styles.gridTemplateRows;
var styles_30 = styles.gridTemplateColumns;
var styles_31 = styles.gridAutoRows;
var styles_32 = styles.gridAutoColumns;
var styles_33 = styles.gridAutoFlow;
var styles_34 = styles.gridRow;
var styles_35 = styles.gridColumn;
var styles_36 = styles.gridRowGap;
var styles_37 = styles.gridColumnGap;
var styles_38 = styles.gridGap;
var styles_39 = styles.order;
var styles_40 = styles.alignSelf;
var styles_41 = styles.justifySelf;
var styles_42 = styles.flex;
var styles_43 = styles.flexDirection;
var styles_44 = styles.flexBasis;
var styles_45 = styles.flexWrap;
var styles_46 = styles.justifyContent;
var styles_47 = styles.alignContent;
var styles_48 = styles.alignItems;
var styles_49 = styles.verticalAlign;
var styles_50 = styles.ratio;
var styles_51 = styles.ratioPadding;
var styles_52 = styles.size;
var styles_53 = styles.sizeHeight;
var styles_54 = styles.sizeWidth;
var styles_55 = styles.minHeight;
var styles_56 = styles.maxHeight;
var styles_57 = styles.height;
var styles_58 = styles.minWidth;
var styles_59 = styles.maxWidth;
var styles_60 = styles.display;
var styles_61 = styles.letterSpacing;
var styles_62 = styles.fontWeight;
var styles_63 = styles.lineHeight;
var styles_64 = styles.textAlign;
var styles_65 = styles.fontFamily;
var styles_66 = styles.opacity;
var styles_67 = styles.color;
var styles_68 = styles.bgColor;
var styles_69 = styles.textColor;
var styles_70 = styles.fontSize;
var styles_71 = styles.width;
var styles_72 = styles.space;
var dist = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.propTypes = exports.util = exports.theme = exports.themeGet = exports.complexStyle = exports.responsiveStyle = exports.pseudoStyle = exports.style = exports.borderWidth = exports.buttonStyle = exports.colorStyle = exports.textStyle = exports.disabled = exports.active = exports.focus = exports.hover = exports.left = exports.bottom = exports.right = exports.top = exports.zIndex = exports.position = exports.opacity = exports.backgroundRepeat = exports.backgroundPosition = exports.backgroundSize = exports.backgroundImage = exports.background = exports.boxShadow = exports.borderRadius = exports.borderColor = exports.borders = exports.borderLeft = exports.borderBottom = exports.borderRight = exports.borderTop = exports.border = exports.gridTemplateRows = exports.gridTemplateColumns = exports.gridAutoRows = exports.gridAutoColumns = exports.gridAutoFlow = exports.gridRow = exports.gridColumn = exports.gridRowGap = exports.gridColumnGap = exports.gridGap = exports.order = exports.alignSelf = exports.justifySelf = exports.flexBasis = exports.flex = exports.flexDirection = exports.flexWrap = exports.justifyContent = exports.alignContent = exports.alignItems = exports.verticalAlign = exports.ratio = exports.size = exports.minHeight = exports.maxHeight = exports.height = exports.minWidth = exports.maxWidth = exports.display = exports.letterSpacing = exports.fontWeight = exports.lineHeight = exports.textAlign = exports.fontFamily = exports.color = exports.bgColor = exports.textColor = exports.fontSize = exports.width = exports.space = exports.styles = undefined;
  Object.defineProperty(exports, 'space', {
    enumerable: true,
    get: function get() {
      return styles.space;
    }
  });
  Object.defineProperty(exports, 'width', {
    enumerable: true,
    get: function get() {
      return styles.width;
    }
  });
  Object.defineProperty(exports, 'fontSize', {
    enumerable: true,
    get: function get() {
      return styles.fontSize;
    }
  });
  Object.defineProperty(exports, 'textColor', {
    enumerable: true,
    get: function get() {
      return styles.textColor;
    }
  });
  Object.defineProperty(exports, 'bgColor', {
    enumerable: true,
    get: function get() {
      return styles.bgColor;
    }
  });
  Object.defineProperty(exports, 'color', {
    enumerable: true,
    get: function get() {
      return styles.color;
    }
  });
  Object.defineProperty(exports, 'fontFamily', {
    enumerable: true,
    get: function get() {
      return styles.fontFamily;
    }
  });
  Object.defineProperty(exports, 'textAlign', {
    enumerable: true,
    get: function get() {
      return styles.textAlign;
    }
  });
  Object.defineProperty(exports, 'lineHeight', {
    enumerable: true,
    get: function get() {
      return styles.lineHeight;
    }
  });
  Object.defineProperty(exports, 'fontWeight', {
    enumerable: true,
    get: function get() {
      return styles.fontWeight;
    }
  });
  Object.defineProperty(exports, 'letterSpacing', {
    enumerable: true,
    get: function get() {
      return styles.letterSpacing;
    }
  });
  Object.defineProperty(exports, 'display', {
    enumerable: true,
    get: function get() {
      return styles.display;
    }
  });
  Object.defineProperty(exports, 'maxWidth', {
    enumerable: true,
    get: function get() {
      return styles.maxWidth;
    }
  });
  Object.defineProperty(exports, 'minWidth', {
    enumerable: true,
    get: function get() {
      return styles.minWidth;
    }
  });
  Object.defineProperty(exports, 'height', {
    enumerable: true,
    get: function get() {
      return styles.height;
    }
  });
  Object.defineProperty(exports, 'maxHeight', {
    enumerable: true,
    get: function get() {
      return styles.maxHeight;
    }
  });
  Object.defineProperty(exports, 'minHeight', {
    enumerable: true,
    get: function get() {
      return styles.minHeight;
    }
  });
  Object.defineProperty(exports, 'size', {
    enumerable: true,
    get: function get() {
      return styles.size;
    }
  });
  Object.defineProperty(exports, 'ratio', {
    enumerable: true,
    get: function get() {
      return styles.ratio;
    }
  });
  Object.defineProperty(exports, 'verticalAlign', {
    enumerable: true,
    get: function get() {
      return styles.verticalAlign;
    }
  });
  Object.defineProperty(exports, 'alignItems', {
    enumerable: true,
    get: function get() {
      return styles.alignItems;
    }
  });
  Object.defineProperty(exports, 'alignContent', {
    enumerable: true,
    get: function get() {
      return styles.alignContent;
    }
  });
  Object.defineProperty(exports, 'justifyContent', {
    enumerable: true,
    get: function get() {
      return styles.justifyContent;
    }
  });
  Object.defineProperty(exports, 'flexWrap', {
    enumerable: true,
    get: function get() {
      return styles.flexWrap;
    }
  });
  Object.defineProperty(exports, 'flexDirection', {
    enumerable: true,
    get: function get() {
      return styles.flexDirection;
    }
  });
  Object.defineProperty(exports, 'flex', {
    enumerable: true,
    get: function get() {
      return styles.flex;
    }
  });
  Object.defineProperty(exports, 'flexBasis', {
    enumerable: true,
    get: function get() {
      return styles.flexBasis;
    }
  });
  Object.defineProperty(exports, 'justifySelf', {
    enumerable: true,
    get: function get() {
      return styles.justifySelf;
    }
  });
  Object.defineProperty(exports, 'alignSelf', {
    enumerable: true,
    get: function get() {
      return styles.alignSelf;
    }
  });
  Object.defineProperty(exports, 'order', {
    enumerable: true,
    get: function get() {
      return styles.order;
    }
  });
  Object.defineProperty(exports, 'gridGap', {
    enumerable: true,
    get: function get() {
      return styles.gridGap;
    }
  });
  Object.defineProperty(exports, 'gridColumnGap', {
    enumerable: true,
    get: function get() {
      return styles.gridColumnGap;
    }
  });
  Object.defineProperty(exports, 'gridRowGap', {
    enumerable: true,
    get: function get() {
      return styles.gridRowGap;
    }
  });
  Object.defineProperty(exports, 'gridColumn', {
    enumerable: true,
    get: function get() {
      return styles.gridColumn;
    }
  });
  Object.defineProperty(exports, 'gridRow', {
    enumerable: true,
    get: function get() {
      return styles.gridRow;
    }
  });
  Object.defineProperty(exports, 'gridAutoFlow', {
    enumerable: true,
    get: function get() {
      return styles.gridAutoFlow;
    }
  });
  Object.defineProperty(exports, 'gridAutoColumns', {
    enumerable: true,
    get: function get() {
      return styles.gridAutoColumns;
    }
  });
  Object.defineProperty(exports, 'gridAutoRows', {
    enumerable: true,
    get: function get() {
      return styles.gridAutoRows;
    }
  });
  Object.defineProperty(exports, 'gridTemplateColumns', {
    enumerable: true,
    get: function get() {
      return styles.gridTemplateColumns;
    }
  });
  Object.defineProperty(exports, 'gridTemplateRows', {
    enumerable: true,
    get: function get() {
      return styles.gridTemplateRows;
    }
  });
  Object.defineProperty(exports, 'border', {
    enumerable: true,
    get: function get() {
      return styles.border;
    }
  });
  Object.defineProperty(exports, 'borderTop', {
    enumerable: true,
    get: function get() {
      return styles.borderTop;
    }
  });
  Object.defineProperty(exports, 'borderRight', {
    enumerable: true,
    get: function get() {
      return styles.borderRight;
    }
  });
  Object.defineProperty(exports, 'borderBottom', {
    enumerable: true,
    get: function get() {
      return styles.borderBottom;
    }
  });
  Object.defineProperty(exports, 'borderLeft', {
    enumerable: true,
    get: function get() {
      return styles.borderLeft;
    }
  });
  Object.defineProperty(exports, 'borders', {
    enumerable: true,
    get: function get() {
      return styles.borders;
    }
  });
  Object.defineProperty(exports, 'borderColor', {
    enumerable: true,
    get: function get() {
      return styles.borderColor;
    }
  });
  Object.defineProperty(exports, 'borderRadius', {
    enumerable: true,
    get: function get() {
      return styles.borderRadius;
    }
  });
  Object.defineProperty(exports, 'boxShadow', {
    enumerable: true,
    get: function get() {
      return styles.boxShadow;
    }
  });
  Object.defineProperty(exports, 'background', {
    enumerable: true,
    get: function get() {
      return styles.background;
    }
  });
  Object.defineProperty(exports, 'backgroundImage', {
    enumerable: true,
    get: function get() {
      return styles.backgroundImage;
    }
  });
  Object.defineProperty(exports, 'backgroundSize', {
    enumerable: true,
    get: function get() {
      return styles.backgroundSize;
    }
  });
  Object.defineProperty(exports, 'backgroundPosition', {
    enumerable: true,
    get: function get() {
      return styles.backgroundPosition;
    }
  });
  Object.defineProperty(exports, 'backgroundRepeat', {
    enumerable: true,
    get: function get() {
      return styles.backgroundRepeat;
    }
  });
  Object.defineProperty(exports, 'opacity', {
    enumerable: true,
    get: function get() {
      return styles.opacity;
    }
  });
  Object.defineProperty(exports, 'position', {
    enumerable: true,
    get: function get() {
      return styles.position;
    }
  });
  Object.defineProperty(exports, 'zIndex', {
    enumerable: true,
    get: function get() {
      return styles.zIndex;
    }
  });
  Object.defineProperty(exports, 'top', {
    enumerable: true,
    get: function get() {
      return styles.top;
    }
  });
  Object.defineProperty(exports, 'right', {
    enumerable: true,
    get: function get() {
      return styles.right;
    }
  });
  Object.defineProperty(exports, 'bottom', {
    enumerable: true,
    get: function get() {
      return styles.bottom;
    }
  });
  Object.defineProperty(exports, 'left', {
    enumerable: true,
    get: function get() {
      return styles.left;
    }
  });
  Object.defineProperty(exports, 'hover', {
    enumerable: true,
    get: function get() {
      return styles.hover;
    }
  });
  Object.defineProperty(exports, 'focus', {
    enumerable: true,
    get: function get() {
      return styles.focus;
    }
  });
  Object.defineProperty(exports, 'active', {
    enumerable: true,
    get: function get() {
      return styles.active;
    }
  });
  Object.defineProperty(exports, 'disabled', {
    enumerable: true,
    get: function get() {
      return styles.disabled;
    }
  });
  Object.defineProperty(exports, 'textStyle', {
    enumerable: true,
    get: function get() {
      return styles.textStyle;
    }
  });
  Object.defineProperty(exports, 'colorStyle', {
    enumerable: true,
    get: function get() {
      return styles.colorStyle;
    }
  });
  Object.defineProperty(exports, 'buttonStyle', {
    enumerable: true,
    get: function get() {
      return styles.buttonStyle;
    }
  });
  Object.defineProperty(exports, 'borderWidth', {
    enumerable: true,
    get: function get() {
      return styles.borderWidth;
    }
  });
  Object.defineProperty(exports, 'style', {
    enumerable: true,
    get: function get() {
      return util.style;
    }
  });
  Object.defineProperty(exports, 'pseudoStyle', {
    enumerable: true,
    get: function get() {
      return util.pseudoStyle;
    }
  });
  Object.defineProperty(exports, 'responsiveStyle', {
    enumerable: true,
    get: function get() {
      return util.responsiveStyle;
    }
  });
  Object.defineProperty(exports, 'complexStyle', {
    enumerable: true,
    get: function get() {
      return util.complexStyle;
    }
  });
  Object.defineProperty(exports, 'themeGet', {
    enumerable: true,
    get: function get() {
      return util.themeGet;
    }
  });
  Object.defineProperty(exports, 'theme', {
    enumerable: true,
    get: function get() {
      return util.themeGet;
    }
  });

  var styles$1 = _interopRequireWildcard(styles);

  var _styles = _interopRequireWildcard(styles);

  var _util = _interopRequireWildcard(util);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  exports.styles = _styles;
  exports.util = _util;
  var propTypes = exports.propTypes = {};
  Object.keys(styles$1).forEach(function (key) {
    propTypes[key] = styles$1[key].propTypes;
  });
  styles$1.propTypes = propTypes;
  exports.default = styles$1;
});
unwrapExports(dist);
var dist_1 = dist.propTypes;
var dist_2 = dist.util;
var dist_3 = dist.theme;
var dist_4 = dist.themeGet;
var dist_5 = dist.complexStyle;
var dist_6 = dist.responsiveStyle;
var dist_7 = dist.pseudoStyle;
var dist_8 = dist.style;
var dist_9 = dist.borderWidth;
var dist_10 = dist.buttonStyle;
var dist_11 = dist.colorStyle;
var dist_12 = dist.textStyle;
var dist_13 = dist.disabled;
var dist_14 = dist.active;
var dist_15 = dist.focus;
var dist_16 = dist.hover;
var dist_17 = dist.left;
var dist_18 = dist.bottom;
var dist_19 = dist.right;
var dist_20 = dist.top;
var dist_21 = dist.zIndex;
var dist_22 = dist.position;
var dist_23 = dist.opacity;
var dist_24 = dist.backgroundRepeat;
var dist_25 = dist.backgroundPosition;
var dist_26 = dist.backgroundSize;
var dist_27 = dist.backgroundImage;
var dist_28 = dist.background;
var dist_29 = dist.boxShadow;
var dist_30 = dist.borderRadius;
var dist_31 = dist.borderColor;
var dist_32 = dist.borders;
var dist_33 = dist.borderLeft;
var dist_34 = dist.borderBottom;
var dist_35 = dist.borderRight;
var dist_36 = dist.borderTop;
var dist_37 = dist.border;
var dist_38 = dist.gridTemplateRows;
var dist_39 = dist.gridTemplateColumns;
var dist_40 = dist.gridAutoRows;
var dist_41 = dist.gridAutoColumns;
var dist_42 = dist.gridAutoFlow;
var dist_43 = dist.gridRow;
var dist_44 = dist.gridColumn;
var dist_45 = dist.gridRowGap;
var dist_46 = dist.gridColumnGap;
var dist_47 = dist.gridGap;
var dist_48 = dist.order;
var dist_49 = dist.alignSelf;
var dist_50 = dist.justifySelf;
var dist_51 = dist.flexBasis;
var dist_52 = dist.flex;
var dist_53 = dist.flexDirection;
var dist_54 = dist.flexWrap;
var dist_55 = dist.justifyContent;
var dist_56 = dist.alignContent;
var dist_57 = dist.alignItems;
var dist_58 = dist.verticalAlign;
var dist_59 = dist.ratio;
var dist_60 = dist.size;
var dist_61 = dist.minHeight;
var dist_62 = dist.maxHeight;
var dist_63 = dist.height;
var dist_64 = dist.minWidth;
var dist_65 = dist.maxWidth;
var dist_66 = dist.display;
var dist_67 = dist.letterSpacing;
var dist_68 = dist.fontWeight;
var dist_69 = dist.lineHeight;
var dist_70 = dist.textAlign;
var dist_71 = dist.fontFamily;
var dist_72 = dist.color;
var dist_73 = dist.bgColor;
var dist_74 = dist.textColor;
var dist_75 = dist.fontSize;
var dist_76 = dist.width;
var dist_77 = dist.space;
var dist_78 = dist.styles;
var AcUnit = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M22 11h-4.17l3.24-3.24-1.41-1.42L15 11h-2V9l4.66-4.66-1.42-1.41L13 6.17V2h-2v4.17L7.76 2.93 6.34 4.34 11 9v2H9L4.34 6.34 2.93 7.76 6.17 11H2v2h4.17l-3.24 3.24 1.41 1.42L9 13h2v2l-4.66 4.66 1.42 1.41L11 17.83V22h2v-4.17l3.24 3.24 1.42-1.41L13 15v-2h2l4.66 4.66 1.41-1.42L17.83 13H22z'
    }));
  };

  var AcUnitIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AcUnitIcon.displayName = 'AcUnitIcon';
  AcUnitIcon.defaultProps = {
    size: 24
  };
  exports.default = AcUnitIcon;
});
unwrapExports(AcUnit);
var AccessAlarm = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12.5 8H11v6l4.75 2.85.75-1.23-4-2.37V8zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z'
    }));
  };

  var AccessAlarmIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AccessAlarmIcon.displayName = 'AccessAlarmIcon';
  AccessAlarmIcon.defaultProps = {
    size: 24
  };
  exports.default = AccessAlarmIcon;
});
unwrapExports(AccessAlarm);
var AccessAlarms = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M22 5.7l-4.6-3.9-1.3 1.5 4.6 3.9L22 5.7zM7.9 3.4L6.6 1.9 2 5.7l1.3 1.5 4.6-3.8zM12.5 8H11v6l4.7 2.9.8-1.2-4-2.4V8zM12 4c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm0 16c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7z'
    }));
  };

  var AccessAlarmsIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AccessAlarmsIcon.displayName = 'AccessAlarmsIcon';
  AccessAlarmsIcon.defaultProps = {
    size: 24
  };
  exports.default = AccessAlarmsIcon;
});
unwrapExports(AccessAlarms);
var AccessTime = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z'
    }));
  };

  var AccessTimeIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AccessTimeIcon.displayName = 'AccessTimeIcon';
  AccessTimeIcon.defaultProps = {
    size: 24
  };
  exports.default = AccessTimeIcon;
});
unwrapExports(AccessTime);
var Accessibility = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 2c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 7h-6v13h-2v-6h-2v6H9V9H3V7h18v2z'
    }));
  };

  var AccessibilityIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AccessibilityIcon.displayName = 'AccessibilityIcon';
  AccessibilityIcon.defaultProps = {
    size: 24
  };
  exports.default = AccessibilityIcon;
});
unwrapExports(Accessibility);
var Accessible = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M 12 2 A 2 2 0 0 1 12 6 A 2 2 0 0 1 12 2 M19 13v-2c-1.54.02-3.09-.75-4.07-1.83l-1.29-1.43c-.17-.19-.38-.34-.61-.45-.01 0-.01-.01-.02-.01H13c-.35-.2-.75-.3-1.19-.26C10.76 7.11 10 8.04 10 9.09V15c0 1.1.9 2 2 2h5v5h2v-5.5c0-1.1-.9-2-2-2h-3v-3.45c1.29 1.07 3.25 1.94 5 1.95zm-6.17 5c-.41 1.16-1.52 2-2.83 2-1.66 0-3-1.34-3-3 0-1.31.84-2.41 2-2.83V12.1c-2.28.46-4 2.48-4 4.9 0 2.76 2.24 5 5 5 2.42 0 4.44-1.72 4.9-4h-2.07z'
    }));
  };

  var AccessibleIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AccessibleIcon.displayName = 'AccessibleIcon';
  AccessibleIcon.defaultProps = {
    size: 24
  };
  exports.default = AccessibleIcon;
});
unwrapExports(Accessible);
var AccountBalance = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M4 10v7h3v-7H4zm6 0v7h3v-7h-3zM2 22h19v-3H2v3zm14-12v7h3v-7h-3zm-4.5-9L2 6v2h19V6l-9.5-5z'
    }));
  };

  var AccountBalanceIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AccountBalanceIcon.displayName = 'AccountBalanceIcon';
  AccountBalanceIcon.defaultProps = {
    size: 24
  };
  exports.default = AccountBalanceIcon;
});
unwrapExports(AccountBalance);
var AccountBalanceWallet = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21 18v1c0 1.1-.9 2-2 2H5c-1.11 0-2-.9-2-2V5c0-1.1.89-2 2-2h14c1.1 0 2 .9 2 2v1h-9c-1.11 0-2 .9-2 2v8c0 1.1.89 2 2 2h9zm-9-2h10V8H12v8zm4-2.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z'
    }));
  };

  var AccountBalanceWalletIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AccountBalanceWalletIcon.displayName = 'AccountBalanceWalletIcon';
  AccountBalanceWalletIcon.defaultProps = {
    size: 24
  };
  exports.default = AccountBalanceWalletIcon;
});
unwrapExports(AccountBalanceWallet);
var AccountBox = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M3 5v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H5c-1.11 0-2 .9-2 2zm12 4c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3zm-9 8c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1H6v-1z'
    }));
  };

  var AccountBoxIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AccountBoxIcon.displayName = 'AccountBoxIcon';
  AccountBoxIcon.defaultProps = {
    size: 24
  };
  exports.default = AccountBoxIcon;
});
unwrapExports(AccountBox);
var AccountCircle = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z'
    }));
  };

  var AccountCircleIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AccountCircleIcon.displayName = 'AccountCircleIcon';
  AccountCircleIcon.defaultProps = {
    size: 24
  };
  exports.default = AccountCircleIcon;
});
unwrapExports(AccountCircle);
var Adb = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M5 16c0 3.87 3.13 7 7 7s7-3.13 7-7v-4H5v4zM16.12 4.37l2.1-2.1-.82-.83-2.3 2.31C14.16 3.28 13.12 3 12 3s-2.16.28-3.09.75L6.6 1.44l-.82.83 2.1 2.1C6.14 5.64 5 7.68 5 10v1h14v-1c0-2.32-1.14-4.36-2.88-5.63zM9 9c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm6 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z'
    }));
  };

  var AdbIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AdbIcon.displayName = 'AdbIcon';
  AdbIcon.defaultProps = {
    size: 24
  };
  exports.default = AdbIcon;
});
unwrapExports(Adb);
var Add = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z'
    }));
  };

  var AddIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AddIcon.displayName = 'AddIcon';
  AddIcon.defaultProps = {
    size: 24
  };
  exports.default = AddIcon;
});
unwrapExports(Add);
var AddAPhoto = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M3 4V1h2v3h3v2H5v3H3V6H0V4h3zm3 6V7h3V4h7l1.83 2H21c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V10h3zm7 9c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-3.2-5c0 1.77 1.43 3.2 3.2 3.2s3.2-1.43 3.2-3.2-1.43-3.2-3.2-3.2-3.2 1.43-3.2 3.2z'
    }));
  };

  var AddAPhotoIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AddAPhotoIcon.displayName = 'AddAPhotoIcon';
  AddAPhotoIcon.defaultProps = {
    size: 24
  };
  exports.default = AddAPhotoIcon;
});
unwrapExports(AddAPhoto);
var AddAlarm = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm1-11h-2v3H8v2h3v3h2v-3h3v-2h-3V9z'
    }));
  };

  var AddAlarmIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AddAlarmIcon.displayName = 'AddAlarmIcon';
  AddAlarmIcon.defaultProps = {
    size: 24
  };
  exports.default = AddAlarmIcon;
});
unwrapExports(AddAlarm);
var AddAlert = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M10.01 21.01c0 1.1.89 1.99 1.99 1.99s1.99-.89 1.99-1.99h-3.98zm8.87-4.19V11c0-3.25-2.25-5.97-5.29-6.69v-.72C13.59 2.71 12.88 2 12 2s-1.59.71-1.59 1.59v.72C7.37 5.03 5.12 7.75 5.12 11v5.82L3 18.94V20h18v-1.06l-2.12-2.12zM16 13.01h-3v3h-2v-3H8V11h3V8h2v3h3v2.01z'
    }));
  };

  var AddAlertIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AddAlertIcon.displayName = 'AddAlertIcon';
  AddAlertIcon.defaultProps = {
    size: 24
  };
  exports.default = AddAlertIcon;
});
unwrapExports(AddAlert);
var AddBox = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10h-4v4h-2v-4H7v-2h4V7h2v4h4v2z'
    }));
  };

  var AddBoxIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AddBoxIcon.displayName = 'AddBoxIcon';
  AddBoxIcon.defaultProps = {
    size: 24
  };
  exports.default = AddBoxIcon;
});
unwrapExports(AddBox);
var AddCircle = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z'
    }));
  };

  var AddCircleIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AddCircleIcon.displayName = 'AddCircleIcon';
  AddCircleIcon.defaultProps = {
    size: 24
  };
  exports.default = AddCircleIcon;
});
unwrapExports(AddCircle);
var AddCircleOutline = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z'
    }));
  };

  var AddCircleOutlineIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AddCircleOutlineIcon.displayName = 'AddCircleOutlineIcon';
  AddCircleOutlineIcon.defaultProps = {
    size: 24
  };
  exports.default = AddCircleOutlineIcon;
});
unwrapExports(AddCircleOutline);
var AddLocation = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7zm4 8h-3v3h-2v-3H8V8h3V5h2v3h3v2z'
    }));
  };

  var AddLocationIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AddLocationIcon.displayName = 'AddLocationIcon';
  AddLocationIcon.defaultProps = {
    size: 24
  };
  exports.default = AddLocationIcon;
});
unwrapExports(AddLocation);
var AddShoppingCart = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M11 9h2V6h3V4h-3V1h-2v3H8v2h3v3zm-4 9c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2zm-9.83-3.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.86-7.01L19.42 4h-.01l-1.1 2-2.76 5H8.53l-.13-.27L6.16 6l-.95-2-.94-2H1v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.13 0-.25-.11-.25-.25z'
    }));
  };

  var AddShoppingCartIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AddShoppingCartIcon.displayName = 'AddShoppingCartIcon';
  AddShoppingCartIcon.defaultProps = {
    size: 24
  };
  exports.default = AddShoppingCartIcon;
});
unwrapExports(AddShoppingCart);
var AddToPhotos = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z'
    }));
  };

  var AddToPhotosIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AddToPhotosIcon.displayName = 'AddToPhotosIcon';
  AddToPhotosIcon.defaultProps = {
    size: 24
  };
  exports.default = AddToPhotosIcon;
});
unwrapExports(AddToPhotos);
var AddToQueue = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.11-.9-2-2-2zm0 14H3V5h18v12zm-5-7v2h-3v3h-2v-3H8v-2h3V7h2v3h3z'
    }));
  };

  var AddToQueueIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AddToQueueIcon.displayName = 'AddToQueueIcon';
  AddToQueueIcon.defaultProps = {
    size: 24
  };
  exports.default = AddToQueueIcon;
});
unwrapExports(AddToQueue);
var Adjust = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3-8c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3z'
    }));
  };

  var AdjustIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AdjustIcon.displayName = 'AdjustIcon';
  AdjustIcon.defaultProps = {
    size: 24
  };
  exports.default = AdjustIcon;
});
unwrapExports(Adjust);
var AirlineSeatFlat = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M22 11v2H9V7h9c2.21 0 4 1.79 4 4zM2 14v2h6v2h8v-2h6v-2H2zm5.14-1.9c1.16-1.19 1.14-3.08-.04-4.24-1.19-1.16-3.08-1.14-4.24.04-1.16 1.19-1.14 3.08.04 4.24 1.19 1.16 3.08 1.14 4.24-.04z'
    }));
  };

  var AirlineSeatFlatIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AirlineSeatFlatIcon.displayName = 'AirlineSeatFlatIcon';
  AirlineSeatFlatIcon.defaultProps = {
    size: 24
  };
  exports.default = AirlineSeatFlatIcon;
});
unwrapExports(AirlineSeatFlat);
var AirlineSeatFlatAngled = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M22.25 14.29l-.69 1.89L9.2 11.71l2.08-5.66 8.56 3.09c2.1.76 3.18 3.06 2.41 5.15zM1.5 12.14L8 14.48V19h8v-1.63L20.52 19l.69-1.89-19.02-6.86-.69 1.89zm5.8-1.94c1.49-.72 2.12-2.51 1.41-4C7.99 4.71 6.2 4.08 4.7 4.8c-1.49.71-2.12 2.5-1.4 4 .71 1.49 2.5 2.12 4 1.4z'
    }));
  };

  var AirlineSeatFlatAngledIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AirlineSeatFlatAngledIcon.displayName = 'AirlineSeatFlatAngledIcon';
  AirlineSeatFlatAngledIcon.defaultProps = {
    size: 24
  };
  exports.default = AirlineSeatFlatAngledIcon;
});
unwrapExports(AirlineSeatFlatAngled);
var AirlineSeatIndividualSuite = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M7 13c1.65 0 3-1.35 3-3S8.65 7 7 7s-3 1.35-3 3 1.35 3 3 3zm12-6h-8v7H3V7H1v10h22v-6c0-2.21-1.79-4-4-4z'
    }));
  };

  var AirlineSeatIndividualSuiteIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AirlineSeatIndividualSuiteIcon.displayName = 'AirlineSeatIndividualSuiteIcon';
  AirlineSeatIndividualSuiteIcon.defaultProps = {
    size: 24
  };
  exports.default = AirlineSeatIndividualSuiteIcon;
});
unwrapExports(AirlineSeatIndividualSuite);
var AirlineSeatLegroomExtra = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M4 12V3H2v9c0 2.76 2.24 5 5 5h6v-2H7c-1.66 0-3-1.34-3-3zm18.83 5.24c-.38-.72-1.29-.97-2.03-.63l-1.09.5-3.41-6.98c-.34-.68-1.03-1.12-1.79-1.12L11 9V3H5v8c0 1.66 1.34 3 3 3h7l3.41 7 3.72-1.7c.77-.36 1.1-1.3.7-2.06z'
    }));
  };

  var AirlineSeatLegroomExtraIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AirlineSeatLegroomExtraIcon.displayName = 'AirlineSeatLegroomExtraIcon';
  AirlineSeatLegroomExtraIcon.defaultProps = {
    size: 24
  };
  exports.default = AirlineSeatLegroomExtraIcon;
});
unwrapExports(AirlineSeatLegroomExtra);
var AirlineSeatLegroomNormal = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M5 12V3H3v9c0 2.76 2.24 5 5 5h6v-2H8c-1.66 0-3-1.34-3-3zm15.5 6H19v-7c0-1.1-.9-2-2-2h-5V3H6v8c0 1.65 1.35 3 3 3h7v7h4.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5z'
    }));
  };

  var AirlineSeatLegroomNormalIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AirlineSeatLegroomNormalIcon.displayName = 'AirlineSeatLegroomNormalIcon';
  AirlineSeatLegroomNormalIcon.defaultProps = {
    size: 24
  };
  exports.default = AirlineSeatLegroomNormalIcon;
});
unwrapExports(AirlineSeatLegroomNormal);
var AirlineSeatLegroomReduced = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19.97 19.2c.18.96-.55 1.8-1.47 1.8H14v-3l1-4H9c-1.65 0-3-1.35-3-3V3h6v6h5c1.1 0 2 .9 2 2l-2 7h1.44c.73 0 1.39.49 1.53 1.2zM5 12V3H3v9c0 2.76 2.24 5 5 5h4v-2H8c-1.66 0-3-1.34-3-3z'
    }));
  };

  var AirlineSeatLegroomReducedIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AirlineSeatLegroomReducedIcon.displayName = 'AirlineSeatLegroomReducedIcon';
  AirlineSeatLegroomReducedIcon.defaultProps = {
    size: 24
  };
  exports.default = AirlineSeatLegroomReducedIcon;
});
unwrapExports(AirlineSeatLegroomReduced);
var AirlineSeatReclineExtra = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M5.35 5.64c-.9-.64-1.12-1.88-.49-2.79.63-.9 1.88-1.12 2.79-.49.9.64 1.12 1.88.49 2.79-.64.9-1.88 1.12-2.79.49zM16 19H8.93c-1.48 0-2.74-1.08-2.96-2.54L4 7H2l1.99 9.76C4.37 19.2 6.47 21 8.94 21H16v-2zm.23-4h-4.88l-1.03-4.1c1.58.89 3.28 1.54 5.15 1.22V9.99c-1.63.31-3.44-.27-4.69-1.25L9.14 7.47c-.23-.18-.49-.3-.76-.38-.32-.09-.66-.12-.99-.06h-.02c-1.23.22-2.05 1.39-1.84 2.61l1.35 5.92C7.16 16.98 8.39 18 9.83 18h6.85l3.82 3 1.5-1.5-5.77-4.5z'
    }));
  };

  var AirlineSeatReclineExtraIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AirlineSeatReclineExtraIcon.displayName = 'AirlineSeatReclineExtraIcon';
  AirlineSeatReclineExtraIcon.defaultProps = {
    size: 24
  };
  exports.default = AirlineSeatReclineExtraIcon;
});
unwrapExports(AirlineSeatReclineExtra);
var AirlineSeatReclineNormal = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M7.59 5.41c-.78-.78-.78-2.05 0-2.83.78-.78 2.05-.78 2.83 0 .78.78.78 2.05 0 2.83-.79.79-2.05.79-2.83 0zM6 16V7H4v9c0 2.76 2.24 5 5 5h6v-2H9c-1.66 0-3-1.34-3-3zm14 4.07L14.93 15H11.5v-3.68c1.4 1.15 3.6 2.16 5.5 2.16v-2.16c-1.66.02-3.61-.87-4.67-2.04l-1.4-1.55c-.19-.21-.43-.38-.69-.5-.29-.14-.62-.23-.96-.23h-.03C8.01 7 7 8.01 7 9.25V15c0 1.66 1.34 3 3 3h5.07l3.5 3.5L20 20.07z'
    }));
  };

  var AirlineSeatReclineNormalIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AirlineSeatReclineNormalIcon.displayName = 'AirlineSeatReclineNormalIcon';
  AirlineSeatReclineNormalIcon.defaultProps = {
    size: 24
  };
  exports.default = AirlineSeatReclineNormalIcon;
});
unwrapExports(AirlineSeatReclineNormal);
var AirplanemodeActive = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M10.18 9 M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z'
    }));
  };

  var AirplanemodeActiveIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AirplanemodeActiveIcon.displayName = 'AirplanemodeActiveIcon';
  AirplanemodeActiveIcon.defaultProps = {
    size: 24
  };
  exports.default = AirplanemodeActiveIcon;
});
unwrapExports(AirplanemodeActive);
var AirplanemodeInactive = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M13 9V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5v3.68l7.83 7.83L21 16v-2l-8-5zM3 5.27l4.99 4.99L2 14v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-3.73L18.73 21 20 19.73 4.27 4 3 5.27z'
    }));
  };

  var AirplanemodeInactiveIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AirplanemodeInactiveIcon.displayName = 'AirplanemodeInactiveIcon';
  AirplanemodeInactiveIcon.defaultProps = {
    size: 24
  };
  exports.default = AirplanemodeInactiveIcon;
});
unwrapExports(AirplanemodeInactive);
var Airplay = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M6 22h12l-6-6zM21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4v-2H3V5h18v12h-4v2h4c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z'
    }));
  };

  var AirplayIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AirplayIcon.displayName = 'AirplayIcon';
  AirplayIcon.defaultProps = {
    size: 24
  };
  exports.default = AirplayIcon;
});
unwrapExports(Airplay);
var AirportShuttle = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M17 5H3c-1.1 0-2 .89-2 2v9h2c0 1.65 1.34 3 3 3s3-1.35 3-3h5.5c0 1.65 1.34 3 3 3s3-1.35 3-3H23v-5l-6-6zM3 11V7h4v4H3zm3 6.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm7-6.5H9V7h4v4zm4.5 6.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM15 11V7h1l4 4h-5z'
    }));
  };

  var AirportShuttleIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AirportShuttleIcon.displayName = 'AirportShuttleIcon';
  AirportShuttleIcon.defaultProps = {
    size: 24
  };
  exports.default = AirportShuttleIcon;
});
unwrapExports(AirportShuttle);
var Alarm = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12.5 8H11v6l4.75 2.85.75-1.23-4-2.37V8zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z'
    }));
  };

  var AlarmIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AlarmIcon.displayName = 'AlarmIcon';
  AlarmIcon.defaultProps = {
    size: 24
  };
  exports.default = AlarmIcon;
});
unwrapExports(Alarm);
var AlarmAdd = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm1-11h-2v3H8v2h3v3h2v-3h3v-2h-3V9z'
    }));
  };

  var AlarmAddIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AlarmAddIcon.displayName = 'AlarmAddIcon';
  AlarmAddIcon.defaultProps = {
    size: 24
  };
  exports.default = AlarmAddIcon;
});
unwrapExports(AlarmAdd);
var AlarmOff = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 6c3.87 0 7 3.13 7 7 0 .84-.16 1.65-.43 2.4l1.52 1.52c.58-1.19.91-2.51.91-3.92 0-4.97-4.03-9-9-9-1.41 0-2.73.33-3.92.91L9.6 6.43C10.35 6.16 11.16 6 12 6zm10-.28l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM2.92 2.29L1.65 3.57 2.98 4.9l-1.11.93 1.42 1.42 1.11-.94.8.8C3.83 8.69 3 10.75 3 13c0 4.97 4.02 9 9 9 2.25 0 4.31-.83 5.89-2.2l2.2 2.2 1.27-1.27L3.89 3.27l-.97-.98zm13.55 16.1C15.26 19.39 13.7 20 12 20c-3.87 0-7-3.13-7-7 0-1.7.61-3.26 1.61-4.47l9.86 9.86zM8.02 3.28L6.6 1.86l-.86.71 1.42 1.42.86-.71z'
    }));
  };

  var AlarmOffIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AlarmOffIcon.displayName = 'AlarmOffIcon';
  AlarmOffIcon.defaultProps = {
    size: 24
  };
  exports.default = AlarmOffIcon;
});
unwrapExports(AlarmOff);
var AlarmOn = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm-1.46-5.47L8.41 12.4l-1.06 1.06 3.18 3.18 6-6-1.06-1.06-4.93 4.95z'
    }));
  };

  var AlarmOnIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AlarmOnIcon.displayName = 'AlarmOnIcon';
  AlarmOnIcon.defaultProps = {
    size: 24
  };
  exports.default = AlarmOnIcon;
});
unwrapExports(AlarmOn);
var Album = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 14.5c-2.49 0-4.5-2.01-4.5-4.5S9.51 7.5 12 7.5s4.5 2.01 4.5 4.5-2.01 4.5-4.5 4.5zm0-5.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z'
    }));
  };

  var AlbumIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AlbumIcon.displayName = 'AlbumIcon';
  AlbumIcon.defaultProps = {
    size: 24
  };
  exports.default = AlbumIcon;
});
unwrapExports(Album);
var AllInclusive = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M18.6 6.62c-1.44 0-2.8.56-3.77 1.53L12 10.66 10.48 12h.01L7.8 14.39c-.64.64-1.49.99-2.4.99-1.87 0-3.39-1.51-3.39-3.38S3.53 8.62 5.4 8.62c.91 0 1.76.35 2.44 1.03l1.13 1 1.51-1.34L9.22 8.2C8.2 7.18 6.84 6.62 5.4 6.62 2.42 6.62 0 9.04 0 12s2.42 5.38 5.4 5.38c1.44 0 2.8-.56 3.77-1.53l2.83-2.5.01.01L13.52 12h-.01l2.69-2.39c.64-.64 1.49-.99 2.4-.99 1.87 0 3.39 1.51 3.39 3.38s-1.52 3.38-3.39 3.38c-.9 0-1.76-.35-2.44-1.03l-1.14-1.01-1.51 1.34 1.27 1.12c1.02 1.01 2.37 1.57 3.82 1.57 2.98 0 5.4-2.41 5.4-5.38s-2.42-5.37-5.4-5.37z'
    }));
  };

  var AllInclusiveIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AllInclusiveIcon.displayName = 'AllInclusiveIcon';
  AllInclusiveIcon.defaultProps = {
    size: 24
  };
  exports.default = AllInclusiveIcon;
});
unwrapExports(AllInclusive);
var AllOut = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M16.21 4.16l4 4v-4zm4 12l-4 4h4zm-12 4l-4-4v4zm-4-12l4-4h-4zm12.95-.95c-2.73-2.73-7.17-2.73-9.9 0s-2.73 7.17 0 9.9 7.17 2.73 9.9 0 2.73-7.16 0-9.9zm-1.1 8.8c-2.13 2.13-5.57 2.13-7.7 0s-2.13-5.57 0-7.7 5.57-2.13 7.7 0 2.13 5.57 0 7.7z'
    }));
  };

  var AllOutIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AllOutIcon.displayName = 'AllOutIcon';
  AllOutIcon.defaultProps = {
    size: 24
  };
  exports.default = AllOutIcon;
});
unwrapExports(AllOut);
var Android = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M6 18c0 .55.45 1 1 1h1v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h2v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h1c.55 0 1-.45 1-1V8H6v10zM3.5 8C2.67 8 2 8.67 2 9.5v7c0 .83.67 1.5 1.5 1.5S5 17.33 5 16.5v-7C5 8.67 4.33 8 3.5 8zm17 0c-.83 0-1.5.67-1.5 1.5v7c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5zm-4.97-5.84l1.3-1.3c.2-.2.2-.51 0-.71-.2-.2-.51-.2-.71 0l-1.48 1.48C13.85 1.23 12.95 1 12 1c-.96 0-1.86.23-2.66.63L7.85.15c-.2-.2-.51-.2-.71 0-.2.2-.2.51 0 .71l1.31 1.31C6.97 3.26 6 5.01 6 7h12c0-1.99-.97-3.75-2.47-4.84zM10 5H9V4h1v1zm5 0h-1V4h1v1z'
    }));
  };

  var AndroidIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AndroidIcon.displayName = 'AndroidIcon';
  AndroidIcon.defaultProps = {
    size: 24
  };
  exports.default = AndroidIcon;
});
unwrapExports(Android);
var Announcement = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 9h-2V5h2v6zm0 4h-2v-2h2v2z'
    }));
  };

  var AnnouncementIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AnnouncementIcon.displayName = 'AnnouncementIcon';
  AnnouncementIcon.defaultProps = {
    size: 24
  };
  exports.default = AnnouncementIcon;
});
unwrapExports(Announcement);
var Apps = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M4 8h4V4H4v4zm6 12h4v-4h-4v4zm-6 0h4v-4H4v4zm0-6h4v-4H4v4zm6 0h4v-4h-4v4zm6-10v4h4V4h-4zm-6 4h4V4h-4v4zm6 6h4v-4h-4v4zm0 6h4v-4h-4v4z'
    }));
  };

  var AppsIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AppsIcon.displayName = 'AppsIcon';
  AppsIcon.defaultProps = {
    size: 24
  };
  exports.default = AppsIcon;
});
unwrapExports(Apps);
var Archive = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20.54 5.23l-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.16.55L3.46 5.23C3.17 5.57 3 6.02 3 6.5V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.48-.17-.93-.46-1.27zM12 17.5L6.5 12H10v-2h4v2h3.5L12 17.5zM5.12 5l.81-1h12l.94 1H5.12z'
    }));
  };

  var ArchiveIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ArchiveIcon.displayName = 'ArchiveIcon';
  ArchiveIcon.defaultProps = {
    size: 24
  };
  exports.default = ArchiveIcon;
});
unwrapExports(Archive);
var ArrowBack = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z'
    }));
  };

  var ArrowBackIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ArrowBackIcon.displayName = 'ArrowBackIcon';
  ArrowBackIcon.defaultProps = {
    size: 24
  };
  exports.default = ArrowBackIcon;
});
unwrapExports(ArrowBack);
var ArrowDownward = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z'
    }));
  };

  var ArrowDownwardIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ArrowDownwardIcon.displayName = 'ArrowDownwardIcon';
  ArrowDownwardIcon.defaultProps = {
    size: 24
  };
  exports.default = ArrowDownwardIcon;
});
unwrapExports(ArrowDownward);
var ArrowDropDown = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M7 10l5 5 5-5z'
    }));
  };

  var ArrowDropDownIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ArrowDropDownIcon.displayName = 'ArrowDropDownIcon';
  ArrowDropDownIcon.defaultProps = {
    size: 24
  };
  exports.default = ArrowDropDownIcon;
});
unwrapExports(ArrowDropDown);
var ArrowDropDownCircle = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 12l-4-4h8l-4 4z'
    }));
  };

  var ArrowDropDownCircleIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ArrowDropDownCircleIcon.displayName = 'ArrowDropDownCircleIcon';
  ArrowDropDownCircleIcon.defaultProps = {
    size: 24
  };
  exports.default = ArrowDropDownCircleIcon;
});
unwrapExports(ArrowDropDownCircle);
var ArrowDropUp = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M7 14l5-5 5 5z'
    }));
  };

  var ArrowDropUpIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ArrowDropUpIcon.displayName = 'ArrowDropUpIcon';
  ArrowDropUpIcon.defaultProps = {
    size: 24
  };
  exports.default = ArrowDropUpIcon;
});
unwrapExports(ArrowDropUp);
var ArrowForward = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z'
    }));
  };

  var ArrowForwardIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ArrowForwardIcon.displayName = 'ArrowForwardIcon';
  ArrowForwardIcon.defaultProps = {
    size: 24
  };
  exports.default = ArrowForwardIcon;
});
unwrapExports(ArrowForward);
var ArrowUpward = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z'
    }));
  };

  var ArrowUpwardIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ArrowUpwardIcon.displayName = 'ArrowUpwardIcon';
  ArrowUpwardIcon.defaultProps = {
    size: 24
  };
  exports.default = ArrowUpwardIcon;
});
unwrapExports(ArrowUpward);
var ArtTrack = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M22 13h-8v-2h8v2zm0-6h-8v2h8V7zm-8 10h8v-2h-8v2zm-2-8v6c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2zm-1.5 6l-2.25-3-1.75 2.26-1.25-1.51L3.5 15h7z'
    }));
  };

  var ArtTrackIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ArtTrackIcon.displayName = 'ArtTrackIcon';
  ArtTrackIcon.defaultProps = {
    size: 24
  };
  exports.default = ArtTrackIcon;
});
unwrapExports(ArtTrack);
var AspectRatio = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 12h-2v3h-3v2h5v-5zM7 9h3V7H5v5h2V9zm14-6H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z'
    }));
  };

  var AspectRatioIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AspectRatioIcon.displayName = 'AspectRatioIcon';
  AspectRatioIcon.defaultProps = {
    size: 24
  };
  exports.default = AspectRatioIcon;
});
unwrapExports(AspectRatio);
var Assessment = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z'
    }));
  };

  var AssessmentIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AssessmentIcon.displayName = 'AssessmentIcon';
  AssessmentIcon.defaultProps = {
    size: 24
  };
  exports.default = AssessmentIcon;
});
unwrapExports(Assessment);
var Assignment = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z'
    }));
  };

  var AssignmentIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AssignmentIcon.displayName = 'AssignmentIcon';
  AssignmentIcon.defaultProps = {
    size: 24
  };
  exports.default = AssignmentIcon;
});
unwrapExports(Assignment);
var AssignmentInd = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 4c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H6v-1.4c0-2 4-3.1 6-3.1s6 1.1 6 3.1V19z'
    }));
  };

  var AssignmentIndIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AssignmentIndIcon.displayName = 'AssignmentIndIcon';
  AssignmentIndIcon.defaultProps = {
    size: 24
  };
  exports.default = AssignmentIndIcon;
});
unwrapExports(AssignmentInd);
var AssignmentLate = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-6 15h-2v-2h2v2zm0-4h-2V8h2v6zm-1-9c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z'
    }));
  };

  var AssignmentLateIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AssignmentLateIcon.displayName = 'AssignmentLateIcon';
  AssignmentLateIcon.defaultProps = {
    size: 24
  };
  exports.default = AssignmentLateIcon;
});
unwrapExports(AssignmentLate);
var AssignmentReturn = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm4 12h-4v3l-5-5 5-5v3h4v4z'
    }));
  };

  var AssignmentReturnIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AssignmentReturnIcon.displayName = 'AssignmentReturnIcon';
  AssignmentReturnIcon.defaultProps = {
    size: 24
  };
  exports.default = AssignmentReturnIcon;
});
unwrapExports(AssignmentReturn);
var AssignmentReturned = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 15l-5-5h3V9h4v4h3l-5 5z'
    }));
  };

  var AssignmentReturnedIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AssignmentReturnedIcon.displayName = 'AssignmentReturnedIcon';
  AssignmentReturnedIcon.defaultProps = {
    size: 24
  };
  exports.default = AssignmentReturnedIcon;
});
unwrapExports(AssignmentReturned);
var AssignmentTurnedIn = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-2 14l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z'
    }));
  };

  var AssignmentTurnedInIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AssignmentTurnedInIcon.displayName = 'AssignmentTurnedInIcon';
  AssignmentTurnedInIcon.defaultProps = {
    size: 24
  };
  exports.default = AssignmentTurnedInIcon;
});
unwrapExports(AssignmentTurnedIn);
var Assistant = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-5.12 10.88L12 17l-1.88-4.12L6 11l4.12-1.88L12 5l1.88 4.12L18 11l-4.12 1.88z'
    }));
  };

  var AssistantIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AssistantIcon.displayName = 'AssistantIcon';
  AssistantIcon.defaultProps = {
    size: 24
  };
  exports.default = AssistantIcon;
});
unwrapExports(Assistant);
var AssistantPhoto = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z'
    }));
  };

  var AssistantPhotoIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AssistantPhotoIcon.displayName = 'AssistantPhotoIcon';
  AssistantPhotoIcon.defaultProps = {
    size: 24
  };
  exports.default = AssistantPhotoIcon;
});
unwrapExports(AssistantPhoto);
var AttachFile = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z'
    }));
  };

  var AttachFileIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AttachFileIcon.displayName = 'AttachFileIcon';
  AttachFileIcon.defaultProps = {
    size: 24
  };
  exports.default = AttachFileIcon;
});
unwrapExports(AttachFile);
var AttachMoney = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z'
    }));
  };

  var AttachMoneyIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AttachMoneyIcon.displayName = 'AttachMoneyIcon';
  AttachMoneyIcon.defaultProps = {
    size: 24
  };
  exports.default = AttachMoneyIcon;
});
unwrapExports(AttachMoney);
var Attachment = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M2 12.5C2 9.46 4.46 7 7.5 7H18c2.21 0 4 1.79 4 4s-1.79 4-4 4H9.5C8.12 15 7 13.88 7 12.5S8.12 10 9.5 10H17v2H9.41c-.55 0-.55 1 0 1H18c1.1 0 2-.9 2-2s-.9-2-2-2H7.5C5.57 9 4 10.57 4 12.5S5.57 16 7.5 16H17v2H7.5C4.46 18 2 15.54 2 12.5z'
    }));
  };

  var AttachmentIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AttachmentIcon.displayName = 'AttachmentIcon';
  AttachmentIcon.defaultProps = {
    size: 24
  };
  exports.default = AttachmentIcon;
});
unwrapExports(Attachment);
var Audiotrack = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 3v9.28c-.47-.17-.97-.28-1.5-.28C8.01 12 6 14.01 6 16.5S8.01 21 10.5 21c2.31 0 4.2-1.75 4.45-4H15V6h4V3h-7z'
    }));
  };

  var AudiotrackIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AudiotrackIcon.displayName = 'AudiotrackIcon';
  AudiotrackIcon.defaultProps = {
    size: 24
  };
  exports.default = AudiotrackIcon;
});
unwrapExports(Audiotrack);
var Autorenew = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8c-.45-.83-.7-1.79-.7-2.8 0-3.31 2.69-6 6-6zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26z'
    }));
  };

  var AutorenewIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AutorenewIcon.displayName = 'AutorenewIcon';
  AutorenewIcon.defaultProps = {
    size: 24
  };
  exports.default = AutorenewIcon;
});
unwrapExports(Autorenew);
var AvTimer = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M11 17c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1zm0-14v4h2V5.08c3.39.49 6 3.39 6 6.92 0 3.87-3.13 7-7 7s-7-3.13-7-7c0-1.68.59-3.22 1.58-4.42L12 13l1.41-1.41-6.8-6.8v.02C4.42 6.45 3 9.05 3 12c0 4.97 4.02 9 9 9 4.97 0 9-4.03 9-9s-4.03-9-9-9h-1zm7 9c0-.55-.45-1-1-1s-1 .45-1 1 .45 1 1 1 1-.45 1-1zM6 12c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1z'
    }));
  };

  var AvTimerIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  AvTimerIcon.displayName = 'AvTimerIcon';
  AvTimerIcon.defaultProps = {
    size: 24
  };
  exports.default = AvTimerIcon;
});
unwrapExports(AvTimer);
var Backspace = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M22 3H7c-.69 0-1.23.35-1.59.88L0 12l5.41 8.11c.36.53.9.89 1.59.89h15c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-3 12.59L17.59 17 14 13.41 10.41 17 9 15.59 12.59 12 9 8.41 10.41 7 14 10.59 17.59 7 19 8.41 15.41 12 19 15.59z'
    }));
  };

  var BackspaceIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  BackspaceIcon.displayName = 'BackspaceIcon';
  BackspaceIcon.defaultProps = {
    size: 24
  };
  exports.default = BackspaceIcon;
});
unwrapExports(Backspace);
var Backup = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z'
    }));
  };

  var BackupIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  BackupIcon.displayName = 'BackupIcon';
  BackupIcon.defaultProps = {
    size: 24
  };
  exports.default = BackupIcon;
});
unwrapExports(Backup);
var Battery20 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M7 17v3.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V17H7z M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V17h10V5.33z'
    }));
  };

  var Battery20Icon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  Battery20Icon.displayName = 'Battery20Icon';
  Battery20Icon.defaultProps = {
    size: 24
  };
  exports.default = Battery20Icon;
});
unwrapExports(Battery20);
var Battery30 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V15h10V5.33z M7 15v5.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V15H7z'
    }));
  };

  var Battery30Icon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  Battery30Icon.displayName = 'Battery30Icon';
  Battery30Icon.defaultProps = {
    size: 24
  };
  exports.default = Battery30Icon;
});
unwrapExports(Battery30);
var Battery50 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V13h10V5.33z M7 13v7.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V13H7z'
    }));
  };

  var Battery50Icon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  Battery50Icon.displayName = 'Battery50Icon';
  Battery50Icon.defaultProps = {
    size: 24
  };
  exports.default = Battery50Icon;
});
unwrapExports(Battery50);
var Battery60 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V11h10V5.33z M7 11v9.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V11H7z'
    }));
  };

  var Battery60Icon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  Battery60Icon.displayName = 'Battery60Icon';
  Battery60Icon.defaultProps = {
    size: 24
  };
  exports.default = Battery60Icon;
});
unwrapExports(Battery60);
var Battery80 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V9h10V5.33z M7 9v11.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V9H7z'
    }));
  };

  var Battery80Icon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  Battery80Icon.displayName = 'Battery80Icon';
  Battery80Icon.defaultProps = {
    size: 24
  };
  exports.default = Battery80Icon;
});
unwrapExports(Battery80);
var Battery90 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V8h10V5.33z M7 8v12.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V8H7z'
    }));
  };

  var Battery90Icon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  Battery90Icon.displayName = 'Battery90Icon';
  Battery90Icon.defaultProps = {
    size: 24
  };
  exports.default = Battery90Icon;
});
unwrapExports(Battery90);
var BatteryAlert = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zM13 18h-2v-2h2v2zm0-4h-2V9h2v5z'
    }));
  };

  var BatteryAlertIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  BatteryAlertIcon.displayName = 'BatteryAlertIcon';
  BatteryAlertIcon.defaultProps = {
    size: 24
  };
  exports.default = BatteryAlertIcon;
});
unwrapExports(BatteryAlert);
var BatteryCharging20 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M11 20v-3H7v3.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V17h-4.4L11 20z M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V17h4v-2.5H9L13 7v5.5h2L12.6 17H17V5.33C17 4.6 16.4 4 15.67 4z'
    }));
  };

  var BatteryCharging20Icon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  BatteryCharging20Icon.displayName = 'BatteryCharging20Icon';
  BatteryCharging20Icon.defaultProps = {
    size: 24
  };
  exports.default = BatteryCharging20Icon;
});
unwrapExports(BatteryCharging20);
var BatteryCharging30 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v9.17h2L13 7v5.5h2l-1.07 2H17V5.33C17 4.6 16.4 4 15.67 4z M11 20v-5.5H7v6.17C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V14.5h-3.07L11 20z'
    }));
  };

  var BatteryCharging30Icon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  BatteryCharging30Icon.displayName = 'BatteryCharging30Icon';
  BatteryCharging30Icon.defaultProps = {
    size: 24
  };
  exports.default = BatteryCharging30Icon;
});
unwrapExports(BatteryCharging30);
var BatteryCharging50 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M14.47 13.5L11 20v-5.5H9l.53-1H7v7.17C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V13.5h-2.53z M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v8.17h2.53L13 7v5.5h2l-.53 1H17V5.33C17 4.6 16.4 4 15.67 4z'
    }));
  };

  var BatteryCharging50Icon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  BatteryCharging50Icon.displayName = 'BatteryCharging50Icon';
  BatteryCharging50Icon.defaultProps = {
    size: 24
  };
  exports.default = BatteryCharging50Icon;
});
unwrapExports(BatteryCharging50);
var BatteryCharging60 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V11h3.87L13 7v4h4V5.33C17 4.6 16.4 4 15.67 4z M13 12.5h2L11 20v-5.5H9l1.87-3.5H7v9.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V11h-4v1.5z'
    }));
  };

  var BatteryCharging60Icon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  BatteryCharging60Icon.displayName = 'BatteryCharging60Icon';
  BatteryCharging60Icon.defaultProps = {
    size: 24
  };
  exports.default = BatteryCharging60Icon;
});
unwrapExports(BatteryCharging60);
var BatteryCharging80 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V9h4.93L13 7v2h4V5.33C17 4.6 16.4 4 15.67 4z M13 12.5h2L11 20v-5.5H9L11.93 9H7v11.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V9h-4v3.5z'
    }));
  };

  var BatteryCharging80Icon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  BatteryCharging80Icon.displayName = 'BatteryCharging80Icon';
  BatteryCharging80Icon.defaultProps = {
    size: 24
  };
  exports.default = BatteryCharging80Icon;
});
unwrapExports(BatteryCharging80);
var BatteryCharging90 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V8h5.47L13 7v1h4V5.33C17 4.6 16.4 4 15.67 4z M13 12.5h2L11 20v-5.5H9L12.47 8H7v12.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V8h-4v4.5z'
    }));
  };

  var BatteryCharging90Icon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  BatteryCharging90Icon.displayName = 'BatteryCharging90Icon';
  BatteryCharging90Icon.defaultProps = {
    size: 24
  };
  exports.default = BatteryCharging90Icon;
});
unwrapExports(BatteryCharging90);
var BatteryChargingFull = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zM11 20v-5.5H9L13 7v5.5h2L11 20z'
    }));
  };

  var BatteryChargingFullIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  BatteryChargingFullIcon.displayName = 'BatteryChargingFullIcon';
  BatteryChargingFullIcon.defaultProps = {
    size: 24
  };
  exports.default = BatteryChargingFullIcon;
});
unwrapExports(BatteryChargingFull);
var BatteryFull = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4z'
    }));
  };

  var BatteryFullIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  BatteryFullIcon.displayName = 'BatteryFullIcon';
  BatteryFullIcon.defaultProps = {
    size: 24
  };
  exports.default = BatteryFullIcon;
});
unwrapExports(BatteryFull);
var BatteryStd = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4z'
    }));
  };

  var BatteryStdIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  BatteryStdIcon.displayName = 'BatteryStdIcon';
  BatteryStdIcon.defaultProps = {
    size: 24
  };
  exports.default = BatteryStdIcon;
});
unwrapExports(BatteryStd);
var BatteryUnknown = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zm-2.72 13.95h-1.9v-1.9h1.9v1.9zm1.35-5.26s-.38.42-.67.71c-.48.48-.83 1.15-.83 1.6h-1.6c0-.83.46-1.52.93-2l.93-.94c.27-.27.44-.65.44-1.06 0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5H9c0-1.66 1.34-3 3-3s3 1.34 3 3c0 .66-.27 1.26-.7 1.69z'
    }));
  };

  var BatteryUnknownIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  BatteryUnknownIcon.displayName = 'BatteryUnknownIcon';
  BatteryUnknownIcon.defaultProps = {
    size: 24
  };
  exports.default = BatteryUnknownIcon;
});
unwrapExports(BatteryUnknown);
var BeachAccess = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M13.127 14.56l1.43-1.43 6.44 6.443L19.57 21zm4.293-5.73l2.86-2.86c-3.95-3.95-10.35-3.96-14.3-.02 3.93-1.3 8.31-.25 11.44 2.88zM5.95 5.98c-3.94 3.95-3.93 10.35.02 14.3l2.86-2.86C5.7 14.29 4.65 9.91 5.95 5.98zm.02-.02l-.01.01c-.38 3.01 1.17 6.88 4.3 10.02l5.73-5.73c-3.13-3.13-7.01-4.68-10.02-4.3z'
    }));
  };

  var BeachAccessIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  BeachAccessIcon.displayName = 'BeachAccessIcon';
  BeachAccessIcon.defaultProps = {
    size: 24
  };
  exports.default = BeachAccessIcon;
});
unwrapExports(BeachAccess);
var Beenhere = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 1H5c-1.1 0-1.99.9-1.99 2L3 15.93c0 .69.35 1.3.88 1.66L12 23l8.11-5.41c.53-.36.88-.97.88-1.66L21 3c0-1.1-.9-2-2-2zm-9 15l-5-5 1.41-1.41L10 13.17l7.59-7.59L19 7l-9 9z'
    }));
  };

  var BeenhereIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  BeenhereIcon.displayName = 'BeenhereIcon';
  BeenhereIcon.defaultProps = {
    size: 24
  };
  exports.default = BeenhereIcon;
});
unwrapExports(Beenhere);
var Block = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L5.69 16.9C4.63 15.55 4 13.85 4 12zm8 8c-1.85 0-3.55-.63-4.9-1.69L18.31 7.1C19.37 8.45 20 10.15 20 12c0 4.42-3.58 8-8 8z'
    }));
  };

  var BlockIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  BlockIcon.displayName = 'BlockIcon';
  BlockIcon.defaultProps = {
    size: 24
  };
  exports.default = BlockIcon;
});
unwrapExports(Block);
var Bluetooth = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M17.71 7.71L12 2h-1v7.59L6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 5.83l1.88 1.88L13 9.59V5.83zm1.88 10.46L13 18.17v-3.76l1.88 1.88z'
    }));
  };

  var BluetoothIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  BluetoothIcon.displayName = 'BluetoothIcon';
  BluetoothIcon.defaultProps = {
    size: 24
  };
  exports.default = BluetoothIcon;
});
unwrapExports(Bluetooth);
var BluetoothAudio = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M14.24 12.01l2.32 2.32c.28-.72.44-1.51.44-2.33 0-.82-.16-1.59-.43-2.31l-2.33 2.32zm5.29-5.3l-1.26 1.26c.63 1.21.98 2.57.98 4.02s-.36 2.82-.98 4.02l1.2 1.2c.97-1.54 1.54-3.36 1.54-5.31-.01-1.89-.55-3.67-1.48-5.19zm-3.82 1L10 2H9v7.59L4.41 5 3 6.41 8.59 12 3 17.59 4.41 19 9 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM11 5.83l1.88 1.88L11 9.59V5.83zm1.88 10.46L11 18.17v-3.76l1.88 1.88z'
    }));
  };

  var BluetoothAudioIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  BluetoothAudioIcon.displayName = 'BluetoothAudioIcon';
  BluetoothAudioIcon.defaultProps = {
    size: 24
  };
  exports.default = BluetoothAudioIcon;
});
unwrapExports(BluetoothAudio);
var BluetoothConnected = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M7 12l-2-2-2 2 2 2 2-2zm10.71-4.29L12 2h-1v7.59L6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 5.83l1.88 1.88L13 9.59V5.83zm1.88 10.46L13 18.17v-3.76l1.88 1.88zM19 10l-2 2 2 2 2-2-2-2z'
    }));
  };

  var BluetoothConnectedIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  BluetoothConnectedIcon.displayName = 'BluetoothConnectedIcon';
  BluetoothConnectedIcon.defaultProps = {
    size: 24
  };
  exports.default = BluetoothConnectedIcon;
});
unwrapExports(BluetoothConnected);
var BluetoothDisabled = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M13 5.83l1.88 1.88-1.6 1.6 1.41 1.41 3.02-3.02L12 2h-1v5.03l2 2v-3.2zM5.41 4L4 5.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l4.29-4.29 2.3 2.29L20 18.59 5.41 4zM13 18.17v-3.76l1.88 1.88L13 18.17z'
    }));
  };

  var BluetoothDisabledIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  BluetoothDisabledIcon.displayName = 'BluetoothDisabledIcon';
  BluetoothDisabledIcon.defaultProps = {
    size: 24
  };
  exports.default = BluetoothDisabledIcon;
});
unwrapExports(BluetoothDisabled);
var BluetoothSearching = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M14.24 12.01l2.32 2.32c.28-.72.44-1.51.44-2.33 0-.82-.16-1.59-.43-2.31l-2.33 2.32zm5.29-5.3l-1.26 1.26c.63 1.21.98 2.57.98 4.02s-.36 2.82-.98 4.02l1.2 1.2c.97-1.54 1.54-3.36 1.54-5.31-.01-1.89-.55-3.67-1.48-5.19zm-3.82 1L10 2H9v7.59L4.41 5 3 6.41 8.59 12 3 17.59 4.41 19 9 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM11 5.83l1.88 1.88L11 9.59V5.83zm1.88 10.46L11 18.17v-3.76l1.88 1.88z'
    }));
  };

  var BluetoothSearchingIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  BluetoothSearchingIcon.displayName = 'BluetoothSearchingIcon';
  BluetoothSearchingIcon.defaultProps = {
    size: 24
  };
  exports.default = BluetoothSearchingIcon;
});
unwrapExports(BluetoothSearching);
var BlurCircular = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M10 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zM7 9.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm3 7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-3-3c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm3-6c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM14 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-1.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm3 6c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-4c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm2-3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-3.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z'
    }));
  };

  var BlurCircularIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  BlurCircularIcon.displayName = 'BlurCircularIcon';
  BlurCircularIcon.defaultProps = {
    size: 24
  };
  exports.default = BlurCircularIcon;
});
unwrapExports(BlurCircular);
var BlurLinear = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M5 17.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM9 13c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zM3 21h18v-2H3v2zM5 9.5c.83 0 1.5-.67 1.5-1.5S5.83 6.5 5 6.5 3.5 7.17 3.5 8 4.17 9.5 5 9.5zm0 4c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM9 17c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm8-.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM3 3v2h18V3H3zm14 5.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm0 4c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM13 9c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1z'
    }));
  };

  var BlurLinearIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  BlurLinearIcon.displayName = 'BlurLinearIcon';
  BlurLinearIcon.defaultProps = {
    size: 24
  };
  exports.default = BlurLinearIcon;
});
unwrapExports(BlurLinear);
var BlurOff = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M14 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm-.2 4.48l.2.02c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5l.02.2c.09.67.61 1.19 1.28 1.28zM14 3.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm-4 0c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm11 7c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM10 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm8 8c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm-4 13.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM2.5 5.27l3.78 3.78L6 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1c0-.1-.03-.19-.06-.28l2.81 2.81c-.71.11-1.25.73-1.25 1.47 0 .83.67 1.5 1.5 1.5.74 0 1.36-.54 1.47-1.25l2.81 2.81c-.09-.03-.18-.06-.28-.06-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1c0-.1-.03-.19-.06-.28l3.78 3.78L20 20.23 3.77 4 2.5 5.27zM10 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm11-3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM6 13c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zM3 9.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm7 11c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM6 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-3-3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z'
    }));
  };

  var BlurOffIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  BlurOffIcon.displayName = 'BlurOffIcon';
  BlurOffIcon.defaultProps = {
    size: 24
  };
  exports.default = BlurOffIcon;
});
unwrapExports(BlurOff);
var BlurOn = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M6 13c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-3 .5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM6 5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm15 5.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM14 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-3.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm-11 10c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm7 7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-17c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM10 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 5.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm8 .5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm3 8.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM14 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-4-12c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0 8.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm4-4.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-4c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z'
    }));
  };

  var BlurOnIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  BlurOnIcon.displayName = 'BlurOnIcon';
  BlurOnIcon.defaultProps = {
    size: 24
  };
  exports.default = BlurOnIcon;
});
unwrapExports(BlurOn);
var Book = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z'
    }));
  };

  var BookIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  BookIcon.displayName = 'BookIcon';
  BookIcon.defaultProps = {
    size: 24
  };
  exports.default = BookIcon;
});
unwrapExports(Book);
var Bookmark = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2z'
    }));
  };

  var BookmarkIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  BookmarkIcon.displayName = 'BookmarkIcon';
  BookmarkIcon.defaultProps = {
    size: 24
  };
  exports.default = BookmarkIcon;
});
unwrapExports(Bookmark);
var BookmarkBorder = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2zm0 15l-5-2.18L7 18V5h10v13z'
    }));
  };

  var BookmarkBorderIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  BookmarkBorderIcon.displayName = 'BookmarkBorderIcon';
  BookmarkBorderIcon.defaultProps = {
    size: 24
  };
  exports.default = BookmarkBorderIcon;
});
unwrapExports(BookmarkBorder);
var BorderAll = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M3 3v18h18V3H3zm8 16H5v-6h6v6zm0-8H5V5h6v6zm8 8h-6v-6h6v6zm0-8h-6V5h6v6z'
    }));
  };

  var BorderAllIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  BorderAllIcon.displayName = 'BorderAllIcon';
  BorderAllIcon.defaultProps = {
    size: 24
  };
  exports.default = BorderAllIcon;
});
unwrapExports(BorderAll);
var BorderBottom = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M9 11H7v2h2v-2zm4 4h-2v2h2v-2zM9 3H7v2h2V3zm4 8h-2v2h2v-2zM5 3H3v2h2V3zm8 4h-2v2h2V7zm4 4h-2v2h2v-2zm-4-8h-2v2h2V3zm4 0h-2v2h2V3zm2 10h2v-2h-2v2zm0 4h2v-2h-2v2zM5 7H3v2h2V7zm14-4v2h2V3h-2zm0 6h2V7h-2v2zM5 11H3v2h2v-2zM3 21h18v-2H3v2zm2-6H3v2h2v-2z'
    }));
  };

  var BorderBottomIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  BorderBottomIcon.displayName = 'BorderBottomIcon';
  BorderBottomIcon.defaultProps = {
    size: 24
  };
  exports.default = BorderBottomIcon;
});
unwrapExports(BorderBottom);
var BorderClear = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M7 5h2V3H7v2zm0 8h2v-2H7v2zm0 8h2v-2H7v2zm4-4h2v-2h-2v2zm0 4h2v-2h-2v2zm-8 0h2v-2H3v2zm0-4h2v-2H3v2zm0-4h2v-2H3v2zm0-4h2V7H3v2zm0-4h2V3H3v2zm8 8h2v-2h-2v2zm8 4h2v-2h-2v2zm0-4h2v-2h-2v2zm0 8h2v-2h-2v2zm0-12h2V7h-2v2zm-8 0h2V7h-2v2zm8-6v2h2V3h-2zm-8 2h2V3h-2v2zm4 16h2v-2h-2v2zm0-8h2v-2h-2v2zm0-8h2V3h-2v2z'
    }));
  };

  var BorderClearIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  BorderClearIcon.displayName = 'BorderClearIcon';
  BorderClearIcon.defaultProps = {
    size: 24
  };
  exports.default = BorderClearIcon;
});
unwrapExports(BorderClear);
var BorderColor = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M17.75 7L14 3.25l-10 10V17h3.75l10-10zm2.96-2.96c.39-.39.39-1.02 0-1.41L18.37.29c-.39-.39-1.02-.39-1.41 0L15 2.25 18.75 6l1.96-1.96z M0 20h24v4H0z'
    }));
  };

  var BorderColorIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  BorderColorIcon.displayName = 'BorderColorIcon';
  BorderColorIcon.defaultProps = {
    size: 24
  };
  exports.default = BorderColorIcon;
});
unwrapExports(BorderColor);
var BorderHorizontal = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M3 21h2v-2H3v2zM5 7H3v2h2V7zM3 17h2v-2H3v2zm4 4h2v-2H7v2zM5 3H3v2h2V3zm4 0H7v2h2V3zm8 0h-2v2h2V3zm-4 4h-2v2h2V7zm0-4h-2v2h2V3zm6 14h2v-2h-2v2zm-8 4h2v-2h-2v2zm-8-8h18v-2H3v2zM19 3v2h2V3h-2zm0 6h2V7h-2v2zm-8 8h2v-2h-2v2zm4 4h2v-2h-2v2zm4 0h2v-2h-2v2z'
    }));
  };

  var BorderHorizontalIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  BorderHorizontalIcon.displayName = 'BorderHorizontalIcon';
  BorderHorizontalIcon.defaultProps = {
    size: 24
  };
  exports.default = BorderHorizontalIcon;
});
unwrapExports(BorderHorizontal);
var BorderInner = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M3 21h2v-2H3v2zm4 0h2v-2H7v2zM5 7H3v2h2V7zM3 17h2v-2H3v2zM9 3H7v2h2V3zM5 3H3v2h2V3zm12 0h-2v2h2V3zm2 6h2V7h-2v2zm0-6v2h2V3h-2zm-4 18h2v-2h-2v2zM13 3h-2v8H3v2h8v8h2v-8h8v-2h-8V3zm6 18h2v-2h-2v2zm0-4h2v-2h-2v2z'
    }));
  };

  var BorderInnerIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  BorderInnerIcon.displayName = 'BorderInnerIcon';
  BorderInnerIcon.defaultProps = {
    size: 24
  };
  exports.default = BorderInnerIcon;
});
unwrapExports(BorderInner);
var BorderLeft = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M11 21h2v-2h-2v2zm0-4h2v-2h-2v2zm0-12h2V3h-2v2zm0 4h2V7h-2v2zm0 4h2v-2h-2v2zm-4 8h2v-2H7v2zM7 5h2V3H7v2zm0 8h2v-2H7v2zm-4 8h2V3H3v18zM19 9h2V7h-2v2zm-4 12h2v-2h-2v2zm4-4h2v-2h-2v2zm0-14v2h2V3h-2zm0 10h2v-2h-2v2zm0 8h2v-2h-2v2zm-4-8h2v-2h-2v2zm0-8h2V3h-2v2z'
    }));
  };

  var BorderLeftIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  BorderLeftIcon.displayName = 'BorderLeftIcon';
  BorderLeftIcon.defaultProps = {
    size: 24
  };
  exports.default = BorderLeftIcon;
});
unwrapExports(BorderLeft);
var BorderOuter = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M13 7h-2v2h2V7zm0 4h-2v2h2v-2zm4 0h-2v2h2v-2zM3 3v18h18V3H3zm16 16H5V5h14v14zm-6-4h-2v2h2v-2zm-4-4H7v2h2v-2z'
    }));
  };

  var BorderOuterIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  BorderOuterIcon.displayName = 'BorderOuterIcon';
  BorderOuterIcon.defaultProps = {
    size: 24
  };
  exports.default = BorderOuterIcon;
});
unwrapExports(BorderOuter);
var BorderRight = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M7 21h2v-2H7v2zM3 5h2V3H3v2zm4 0h2V3H7v2zm0 8h2v-2H7v2zm-4 8h2v-2H3v2zm8 0h2v-2h-2v2zm-8-8h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm8 8h2v-2h-2v2zm4-4h2v-2h-2v2zm4-10v18h2V3h-2zm-4 18h2v-2h-2v2zm0-16h2V3h-2v2zm-4 8h2v-2h-2v2zm0-8h2V3h-2v2zm0 4h2V7h-2v2z'
    }));
  };

  var BorderRightIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  BorderRightIcon.displayName = 'BorderRightIcon';
  BorderRightIcon.defaultProps = {
    size: 24
  };
  exports.default = BorderRightIcon;
});
unwrapExports(BorderRight);
var BorderStyle = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M15 21h2v-2h-2v2zm4 0h2v-2h-2v2zM7 21h2v-2H7v2zm4 0h2v-2h-2v2zm8-4h2v-2h-2v2zm0-4h2v-2h-2v2zM3 3v18h2V5h16V3H3zm16 6h2V7h-2v2z'
    }));
  };

  var BorderStyleIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  BorderStyleIcon.displayName = 'BorderStyleIcon';
  BorderStyleIcon.defaultProps = {
    size: 24
  };
  exports.default = BorderStyleIcon;
});
unwrapExports(BorderStyle);
var BorderTop = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M7 21h2v-2H7v2zm0-8h2v-2H7v2zm4 0h2v-2h-2v2zm0 8h2v-2h-2v2zm-8-4h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2v-2H3v2zm0-4h2V7H3v2zm8 8h2v-2h-2v2zm8-8h2V7h-2v2zm0 4h2v-2h-2v2zM3 3v2h18V3H3zm16 14h2v-2h-2v2zm-4 4h2v-2h-2v2zM11 9h2V7h-2v2zm8 12h2v-2h-2v2zm-4-8h2v-2h-2v2z'
    }));
  };

  var BorderTopIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  BorderTopIcon.displayName = 'BorderTopIcon';
  BorderTopIcon.defaultProps = {
    size: 24
  };
  exports.default = BorderTopIcon;
});
unwrapExports(BorderTop);
var BorderVertical = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M3 9h2V7H3v2zm0-4h2V3H3v2zm4 16h2v-2H7v2zm0-8h2v-2H7v2zm-4 0h2v-2H3v2zm0 8h2v-2H3v2zm0-4h2v-2H3v2zM7 5h2V3H7v2zm12 12h2v-2h-2v2zm-8 4h2V3h-2v18zm8 0h2v-2h-2v2zm0-8h2v-2h-2v2zm0-10v2h2V3h-2zm0 6h2V7h-2v2zm-4-4h2V3h-2v2zm0 16h2v-2h-2v2zm0-8h2v-2h-2v2z'
    }));
  };

  var BorderVerticalIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  BorderVerticalIcon.displayName = 'BorderVerticalIcon';
  BorderVerticalIcon.defaultProps = {
    size: 24
  };
  exports.default = BorderVerticalIcon;
});
unwrapExports(BorderVertical);
var BrandingWatermark = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16h-9v-6h9v6z'
    }));
  };

  var BrandingWatermarkIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  BrandingWatermarkIcon.displayName = 'BrandingWatermarkIcon';
  BrandingWatermarkIcon.defaultProps = {
    size: 24
  };
  exports.default = BrandingWatermarkIcon;
});
unwrapExports(BrandingWatermark);
var Brightness1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M 12 2 A 10 10 0 0 1 12 22 A 10 10 0 0 1 12 2'
    }));
  };

  var Brightness1Icon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  Brightness1Icon.displayName = 'Brightness1Icon';
  Brightness1Icon.defaultProps = {
    size: 24
  };
  exports.default = Brightness1Icon;
});
unwrapExports(Brightness1);
var Brightness2 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M10 2c-1.82 0-3.53.5-5 1.35C7.99 5.08 10 8.3 10 12s-2.01 6.92-5 8.65C6.47 21.5 8.18 22 10 22c5.52 0 10-4.48 10-10S15.52 2 10 2z'
    }));
  };

  var Brightness2Icon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  Brightness2Icon.displayName = 'Brightness2Icon';
  Brightness2Icon.defaultProps = {
    size: 24
  };
  exports.default = Brightness2Icon;
});
unwrapExports(Brightness2);
var Brightness3 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M9 2c-1.05 0-2.05.16-3 .46 4.06 1.27 7 5.06 7 9.54 0 4.48-2.94 8.27-7 9.54.95.3 1.95.46 3 .46 5.52 0 10-4.48 10-10S14.52 2 9 2z'
    }));
  };

  var Brightness3Icon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  Brightness3Icon.displayName = 'Brightness3Icon';
  Brightness3Icon.defaultProps = {
    size: 24
  };
  exports.default = Brightness3Icon;
});
unwrapExports(Brightness3);
var Brightness4 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM12 18c-.89 0-1.74-.2-2.5-.55C11.56 16.5 13 14.42 13 12s-1.44-4.5-3.5-5.45C10.26 6.2 11.11 6 12 6c3.31 0 6 2.69 6 6s-2.69 6-6 6z'
    }));
  };

  var Brightness4Icon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  Brightness4Icon.displayName = 'Brightness4Icon';
  Brightness4Icon.defaultProps = {
    size: 24
  };
  exports.default = Brightness4Icon;
});
unwrapExports(Brightness4);
var Brightness5 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z'
    }));
  };

  var Brightness5Icon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  Brightness5Icon.displayName = 'Brightness5Icon';
  Brightness5Icon.defaultProps = {
    size: 24
  };
  exports.default = Brightness5Icon;
});
unwrapExports(Brightness5);
var Brightness6 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18V6c3.31 0 6 2.69 6 6s-2.69 6-6 6z'
    }));
  };

  var Brightness6Icon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  Brightness6Icon.displayName = 'Brightness6Icon';
  Brightness6Icon.defaultProps = {
    size: 24
  };
  exports.default = Brightness6Icon;
});
unwrapExports(Brightness6);
var Brightness7 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z'
    }));
  };

  var Brightness7Icon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  Brightness7Icon.displayName = 'Brightness7Icon';
  Brightness7Icon.defaultProps = {
    size: 24
  };
  exports.default = Brightness7Icon;
});
unwrapExports(Brightness7);
var BrightnessAuto = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M10.85 12.65h2.3L12 9l-1.15 3.65zM20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM14.3 16l-.7-2h-3.2l-.7 2H7.8L11 7h2l3.2 9h-1.9z'
    }));
  };

  var BrightnessAutoIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  BrightnessAutoIcon.displayName = 'BrightnessAutoIcon';
  BrightnessAutoIcon.defaultProps = {
    size: 24
  };
  exports.default = BrightnessAutoIcon;
});
unwrapExports(BrightnessAuto);
var BrightnessHigh = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z'
    }));
  };

  var BrightnessHighIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  BrightnessHighIcon.displayName = 'BrightnessHighIcon';
  BrightnessHighIcon.defaultProps = {
    size: 24
  };
  exports.default = BrightnessHighIcon;
});
unwrapExports(BrightnessHigh);
var BrightnessLow = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z'
    }));
  };

  var BrightnessLowIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  BrightnessLowIcon.displayName = 'BrightnessLowIcon';
  BrightnessLowIcon.defaultProps = {
    size: 24
  };
  exports.default = BrightnessLowIcon;
});
unwrapExports(BrightnessLow);
var BrightnessMedium = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18V6c3.31 0 6 2.69 6 6s-2.69 6-6 6z'
    }));
  };

  var BrightnessMediumIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  BrightnessMediumIcon.displayName = 'BrightnessMediumIcon';
  BrightnessMediumIcon.defaultProps = {
    size: 24
  };
  exports.default = BrightnessMediumIcon;
});
unwrapExports(BrightnessMedium);
var BrokenImage = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21 5v6.59l-3-3.01-4 4.01-4-4-4 4-3-3.01V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2zm-3 6.42l3 3.01V19c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2v-6.58l3 2.99 4-4 4 4 4-3.99z'
    }));
  };

  var BrokenImageIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  BrokenImageIcon.displayName = 'BrokenImageIcon';
  BrokenImageIcon.defaultProps = {
    size: 24
  };
  exports.default = BrokenImageIcon;
});
unwrapExports(BrokenImage);
var Brush = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M7 14c-1.66 0-3 1.34-3 3 0 1.31-1.16 2-2 2 .92 1.22 2.49 2 4 2 2.21 0 4-1.79 4-4 0-1.66-1.34-3-3-3zm13.71-9.37l-1.34-1.34c-.39-.39-1.02-.39-1.41 0L9 12.25 11.75 15l8.96-8.96c.39-.39.39-1.02 0-1.41z'
    }));
  };

  var BrushIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  BrushIcon.displayName = 'BrushIcon';
  BrushIcon.defaultProps = {
    size: 24
  };
  exports.default = BrushIcon;
});
unwrapExports(Brush);
var BubbleChart = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M 7.2 11.2 A 3.2 3.2 0 0 1 7.2 17.6 A 3.2 3.2 0 0 1 7.2 11.2 M 14.8 16 A 2 2 0 0 0 14.8 20 A 2 2 0 0 0 14.8 16 M 15.2 4.000000000000001 A 4.8 4.8 0 0 1 15.2 13.600000000000001 A 4.8 4.8 0 0 1 15.2 4.000000000000001'
    }));
  };

  var BubbleChartIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  BubbleChartIcon.displayName = 'BubbleChartIcon';
  BubbleChartIcon.defaultProps = {
    size: 24
  };
  exports.default = BubbleChartIcon;
});
unwrapExports(BubbleChart);
var BugReport = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 8h-2.81c-.45-.78-1.07-1.45-1.82-1.96L17 4.41 15.59 3l-2.17 2.17C12.96 5.06 12.49 5 12 5c-.49 0-.96.06-1.41.17L8.41 3 7 4.41l1.62 1.63C7.88 6.55 7.26 7.22 6.81 8H4v2h2.09c-.05.33-.09.66-.09 1v1H4v2h2v1c0 .34.04.67.09 1H4v2h2.81c1.04 1.79 2.97 3 5.19 3s4.15-1.21 5.19-3H20v-2h-2.09c.05-.33.09-.66.09-1v-1h2v-2h-2v-1c0-.34-.04-.67-.09-1H20V8zm-6 8h-4v-2h4v2zm0-4h-4v-2h4v2z'
    }));
  };

  var BugReportIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  BugReportIcon.displayName = 'BugReportIcon';
  BugReportIcon.defaultProps = {
    size: 24
  };
  exports.default = BugReportIcon;
});
unwrapExports(BugReport);
var Build = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z'
    }));
  };

  var BuildIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  BuildIcon.displayName = 'BuildIcon';
  BuildIcon.defaultProps = {
    size: 24
  };
  exports.default = BuildIcon;
});
unwrapExports(Build);
var BurstMode = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M1 5h2v14H1zm4 0h2v14H5zm17 0H10c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zM11 17l2.5-3.15L15.29 16l2.5-3.22L21 17H11z'
    }));
  };

  var BurstModeIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  BurstModeIcon.displayName = 'BurstModeIcon';
  BurstModeIcon.defaultProps = {
    size: 24
  };
  exports.default = BurstModeIcon;
});
unwrapExports(BurstMode);
var Business = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z'
    }));
  };

  var BusinessIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  BusinessIcon.displayName = 'BusinessIcon';
  BusinessIcon.defaultProps = {
    size: 24
  };
  exports.default = BusinessIcon;
});
unwrapExports(Business);
var BusinessCenter = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M10 16v-1H3.01L3 19c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2v-4h-7v1h-4zm10-9h-4.01V5l-2-2h-4l-2 2v2H4c-1.1 0-2 .9-2 2v3c0 1.11.89 2 2 2h6v-2h4v2h6c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm-6 0h-4V5h4v2z'
    }));
  };

  var BusinessCenterIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  BusinessCenterIcon.displayName = 'BusinessCenterIcon';
  BusinessCenterIcon.defaultProps = {
    size: 24
  };
  exports.default = BusinessCenterIcon;
});
unwrapExports(BusinessCenter);
var Cached = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 8l-4 4h3c0 3.31-2.69 6-6 6-1.01 0-1.97-.25-2.8-.7l-1.46 1.46C8.97 19.54 10.43 20 12 20c4.42 0 8-3.58 8-8h3l-4-4zM6 12c0-3.31 2.69-6 6-6 1.01 0 1.97.25 2.8.7l1.46-1.46C15.03 4.46 13.57 4 12 4c-4.42 0-8 3.58-8 8H1l4 4 4-4H6z'
    }));
  };

  var CachedIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  CachedIcon.displayName = 'CachedIcon';
  CachedIcon.defaultProps = {
    size: 24
  };
  exports.default = CachedIcon;
});
unwrapExports(Cached);
var Cake = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 6c1.11 0 2-.9 2-2 0-.38-.1-.73-.29-1.03L12 0l-1.71 2.97c-.19.3-.29.65-.29 1.03 0 1.1.9 2 2 2zm4.6 9.99l-1.07-1.07-1.08 1.07c-1.3 1.3-3.58 1.31-4.89 0l-1.07-1.07-1.09 1.07C6.75 16.64 5.88 17 4.96 17c-.73 0-1.4-.23-1.96-.61V21c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-4.61c-.56.38-1.23.61-1.96.61-.92 0-1.79-.36-2.44-1.01zM18 9h-5V7h-2v2H6c-1.66 0-3 1.34-3 3v1.54c0 1.08.88 1.96 1.96 1.96.52 0 1.02-.2 1.38-.57l2.14-2.13 2.13 2.13c.74.74 2.03.74 2.77 0l2.14-2.13 2.13 2.13c.37.37.86.57 1.38.57 1.08 0 1.96-.88 1.96-1.96V12C21 10.34 19.66 9 18 9z'
    }));
  };

  var CakeIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  CakeIcon.displayName = 'CakeIcon';
  CakeIcon.defaultProps = {
    size: 24
  };
  exports.default = CakeIcon;
});
unwrapExports(Cake);
var Call = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z'
    }));
  };

  var CallIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  CallIcon.displayName = 'CallIcon';
  CallIcon.defaultProps = {
    size: 24
  };
  exports.default = CallIcon;
});
unwrapExports(Call);
var CallEnd = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 9c-1.6 0-3.15.25-4.6.72v3.1c0 .39-.23.74-.56.9-.98.49-1.87 1.12-2.66 1.85-.18.18-.43.28-.7.28-.28 0-.53-.11-.71-.29L.29 13.08c-.18-.17-.29-.42-.29-.7 0-.28.11-.53.29-.71C3.34 8.78 7.46 7 12 7s8.66 1.78 11.71 4.67c.18.18.29.43.29.71 0 .28-.11.53-.29.71l-2.48 2.48c-.18.18-.43.29-.71.29-.27 0-.52-.11-.7-.28-.79-.74-1.69-1.36-2.67-1.85-.33-.16-.56-.5-.56-.9v-3.1C15.15 9.25 13.6 9 12 9z'
    }));
  };

  var CallEndIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  CallEndIcon.displayName = 'CallEndIcon';
  CallEndIcon.defaultProps = {
    size: 24
  };
  exports.default = CallEndIcon;
});
unwrapExports(CallEnd);
var CallMade = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M9 5v2h6.59L4 18.59 5.41 20 17 8.41V15h2V5z'
    }));
  };

  var CallMadeIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  CallMadeIcon.displayName = 'CallMadeIcon';
  CallMadeIcon.defaultProps = {
    size: 24
  };
  exports.default = CallMadeIcon;
});
unwrapExports(CallMade);
var CallMerge = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M17 20.41L18.41 19 15 15.59 13.59 17 17 20.41zM7.5 8H11v5.59L5.59 19 7 20.41l6-6V8h3.5L12 3.5 7.5 8z'
    }));
  };

  var CallMergeIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  CallMergeIcon.displayName = 'CallMergeIcon';
  CallMergeIcon.defaultProps = {
    size: 24
  };
  exports.default = CallMergeIcon;
});
unwrapExports(CallMerge);
var CallMissed = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19.59 7L12 14.59 6.41 9H11V7H3v8h2v-4.59l7 7 9-9z'
    }));
  };

  var CallMissedIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  CallMissedIcon.displayName = 'CallMissedIcon';
  CallMissedIcon.defaultProps = {
    size: 24
  };
  exports.default = CallMissedIcon;
});
unwrapExports(CallMissed);
var CallMissedOutgoing = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M3 8.41l9 9 7-7V15h2V7h-8v2h4.59L12 14.59 4.41 7 3 8.41z'
    }));
  };

  var CallMissedOutgoingIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  CallMissedOutgoingIcon.displayName = 'CallMissedOutgoingIcon';
  CallMissedOutgoingIcon.defaultProps = {
    size: 24
  };
  exports.default = CallMissedOutgoingIcon;
});
unwrapExports(CallMissedOutgoing);
var CallReceived = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 5.41L18.59 4 7 15.59V9H5v10h10v-2H8.41z'
    }));
  };

  var CallReceivedIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  CallReceivedIcon.displayName = 'CallReceivedIcon';
  CallReceivedIcon.defaultProps = {
    size: 24
  };
  exports.default = CallReceivedIcon;
});
unwrapExports(CallReceived);
var CallSplit = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M14 4l2.29 2.29-2.88 2.88 1.42 1.42 2.88-2.88L20 10V4zm-4 0H4v6l2.29-2.29 4.71 4.7V20h2v-8.41l-5.29-5.3z'
    }));
  };

  var CallSplitIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  CallSplitIcon.displayName = 'CallSplitIcon';
  CallSplitIcon.defaultProps = {
    size: 24
  };
  exports.default = CallSplitIcon;
});
unwrapExports(CallSplit);
var CallToAction = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3v-3h18v3z'
    }));
  };

  var CallToActionIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  CallToActionIcon.displayName = 'CallToActionIcon';
  CallToActionIcon.defaultProps = {
    size: 24
  };
  exports.default = CallToActionIcon;
});
unwrapExports(CallToAction);
var Camera = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M9.4 10.5l4.77-8.26C13.47 2.09 12.75 2 12 2c-2.4 0-4.6.85-6.32 2.25l3.66 6.35.06-.1zM21.54 9c-.92-2.92-3.15-5.26-6-6.34L11.88 9h9.66zm.26 1h-7.49l.29.5 4.76 8.25C21 16.97 22 14.61 22 12c0-.69-.07-1.35-.2-2zM8.54 12l-3.9-6.75C3.01 7.03 2 9.39 2 12c0 .69.07 1.35.2 2h7.49l-1.15-2zm-6.08 3c.92 2.92 3.15 5.26 6 6.34L12.12 15H2.46zm11.27 0l-3.9 6.76c.7.15 1.42.24 2.17.24 2.4 0 4.6-.85 6.32-2.25l-3.66-6.35-.93 1.6z'
    }));
  };

  var CameraIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  CameraIcon.displayName = 'CameraIcon';
  CameraIcon.defaultProps = {
    size: 24
  };
  exports.default = CameraIcon;
});
unwrapExports(Camera);
var CameraAlt = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M 12 8.8 A 3.2 3.2 0 0 1 12 15.2 A 3.2 3.2 0 0 1 12 8.8 M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z'
    }));
  };

  var CameraAltIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  CameraAltIcon.displayName = 'CameraAltIcon';
  CameraAltIcon.defaultProps = {
    size: 24
  };
  exports.default = CameraAltIcon;
});
unwrapExports(CameraAlt);
var CameraEnhance = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M9 3L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2h-3.17L15 3H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-1l1.25-2.75L16 13l-2.75-1.25L12 9l-1.25 2.75L8 13l2.75 1.25z'
    }));
  };

  var CameraEnhanceIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  CameraEnhanceIcon.displayName = 'CameraEnhanceIcon';
  CameraEnhanceIcon.defaultProps = {
    size: 24
  };
  exports.default = CameraEnhanceIcon;
});
unwrapExports(CameraEnhance);
var CameraFront = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M10 20H5v2h5v2l3-3-3-3v2zm4 0v2h5v-2h-5zM12 8c1.1 0 2-.9 2-2s-.9-2-2-2-1.99.9-1.99 2S10.9 8 12 8zm5-8H7C5.9 0 5 .9 5 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zM7 2h10v10.5c0-1.67-3.33-2.5-5-2.5s-5 .83-5 2.5V2z'
    }));
  };

  var CameraFrontIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  CameraFrontIcon.displayName = 'CameraFrontIcon';
  CameraFrontIcon.defaultProps = {
    size: 24
  };
  exports.default = CameraFrontIcon;
});
unwrapExports(CameraFront);
var CameraRear = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M10 20H5v2h5v2l3-3-3-3v2zm4 0v2h5v-2h-5zm3-20H7C5.9 0 5 .9 5 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm-5 6c-1.11 0-2-.9-2-2s.89-2 1.99-2 2 .9 2 2C14 5.1 13.1 6 12 6z'
    }));
  };

  var CameraRearIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  CameraRearIcon.displayName = 'CameraRearIcon';
  CameraRearIcon.defaultProps = {
    size: 24
  };
  exports.default = CameraRearIcon;
});
unwrapExports(CameraRear);
var CameraRoll = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M14 5c0-1.1-.9-2-2-2h-1V2c0-.55-.45-1-1-1H6c-.55 0-1 .45-1 1v1H4c-1.1 0-2 .9-2 2v15c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2h8V5h-8zm-2 13h-2v-2h2v2zm0-9h-2V7h2v2zm4 9h-2v-2h2v2zm0-9h-2V7h2v2zm4 9h-2v-2h2v2zm0-9h-2V7h2v2z'
    }));
  };

  var CameraRollIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  CameraRollIcon.displayName = 'CameraRollIcon';
  CameraRollIcon.defaultProps = {
    size: 24
  };
  exports.default = CameraRollIcon;
});
unwrapExports(CameraRoll);
var Cancel = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z'
    }));
  };

  var CancelIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  CancelIcon.displayName = 'CancelIcon';
  CancelIcon.defaultProps = {
    size: 24
  };
  exports.default = CancelIcon;
});
unwrapExports(Cancel);
var CardGiftcard = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z'
    }));
  };

  var CardGiftcardIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  CardGiftcardIcon.displayName = 'CardGiftcardIcon';
  CardGiftcardIcon.defaultProps = {
    size: 24
  };
  exports.default = CardGiftcardIcon;
});
unwrapExports(CardGiftcard);
var CardMembership = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 2H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h4v5l4-2 4 2v-5h4c1.11 0 2-.89 2-2V4c0-1.11-.89-2-2-2zm0 13H4v-2h16v2zm0-5H4V4h16v6z'
    }));
  };

  var CardMembershipIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  CardMembershipIcon.displayName = 'CardMembershipIcon';
  CardMembershipIcon.defaultProps = {
    size: 24
  };
  exports.default = CardMembershipIcon;
});
unwrapExports(CardMembership);
var CardTravel = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 6h-3V4c0-1.11-.89-2-2-2H9c-1.11 0-2 .89-2 2v2H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zM9 4h6v2H9V4zm11 15H4v-2h16v2zm0-5H4V8h3v2h2V8h6v2h2V8h3v6z'
    }));
  };

  var CardTravelIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  CardTravelIcon.displayName = 'CardTravelIcon';
  CardTravelIcon.defaultProps = {
    size: 24
  };
  exports.default = CardTravelIcon;
});
unwrapExports(CardTravel);
var Casino = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM7.5 18c-.83 0-1.5-.67-1.5-1.5S6.67 15 7.5 15s1.5.67 1.5 1.5S8.33 18 7.5 18zm0-9C6.67 9 6 8.33 6 7.5S6.67 6 7.5 6 9 6.67 9 7.5 8.33 9 7.5 9zm4.5 4.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4.5 4.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm0-9c-.83 0-1.5-.67-1.5-1.5S15.67 6 16.5 6s1.5.67 1.5 1.5S17.33 9 16.5 9z'
    }));
  };

  var CasinoIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  CasinoIcon.displayName = 'CasinoIcon';
  CasinoIcon.defaultProps = {
    size: 24
  };
  exports.default = CasinoIcon;
});
unwrapExports(Casino);
var Cast = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21 3H3c-1.1 0-2 .9-2 2v3h2V5h18v14h-7v2h7c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM1 18v3h3c0-1.66-1.34-3-3-3zm0-4v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm0-4v2c4.97 0 9 4.03 9 9h2c0-6.08-4.93-11-11-11z'
    }));
  };

  var CastIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  CastIcon.displayName = 'CastIcon';
  CastIcon.defaultProps = {
    size: 24
  };
  exports.default = CastIcon;
});
unwrapExports(Cast);
var CastConnected = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M1 18v3h3c0-1.66-1.34-3-3-3zm0-4v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm18-7H5v1.63c3.96 1.28 7.09 4.41 8.37 8.37H19V7zM1 10v2c4.97 0 9 4.03 9 9h2c0-6.08-4.93-11-11-11zm20-7H3c-1.1 0-2 .9-2 2v3h2V5h18v14h-7v2h7c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z'
    }));
  };

  var CastConnectedIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  CastConnectedIcon.displayName = 'CastConnectedIcon';
  CastConnectedIcon.defaultProps = {
    size: 24
  };
  exports.default = CastConnectedIcon;
});
unwrapExports(CastConnected);
var CenterFocusStrong = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm-7 7H3v4c0 1.1.9 2 2 2h4v-2H5v-4zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm14-2h-4v2h4v4h2V5c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4z'
    }));
  };

  var CenterFocusStrongIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  CenterFocusStrongIcon.displayName = 'CenterFocusStrongIcon';
  CenterFocusStrongIcon.defaultProps = {
    size: 24
  };
  exports.default = CenterFocusStrongIcon;
});
unwrapExports(CenterFocusStrong);
var CenterFocusWeak = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M5 15H3v4c0 1.1.9 2 2 2h4v-2H5v-4zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm14-2h-4v2h4v4h2V5c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z'
    }));
  };

  var CenterFocusWeakIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  CenterFocusWeakIcon.displayName = 'CenterFocusWeakIcon';
  CenterFocusWeakIcon.defaultProps = {
    size: 24
  };
  exports.default = CenterFocusWeakIcon;
});
unwrapExports(CenterFocusWeak);
var ChangeHistory = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 7.77L18.39 18H5.61L12 7.77M12 4L2 20h20L12 4z'
    }));
  };

  var ChangeHistoryIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ChangeHistoryIcon.displayName = 'ChangeHistoryIcon';
  ChangeHistoryIcon.defaultProps = {
    size: 24
  };
  exports.default = ChangeHistoryIcon;
});
unwrapExports(ChangeHistory);
var Chat = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z'
    }));
  };

  var ChatIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ChatIcon.displayName = 'ChatIcon';
  ChatIcon.defaultProps = {
    size: 24
  };
  exports.default = ChatIcon;
});
unwrapExports(Chat);
var ChatBubble = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z'
    }));
  };

  var ChatBubbleIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ChatBubbleIcon.displayName = 'ChatBubbleIcon';
  ChatBubbleIcon.defaultProps = {
    size: 24
  };
  exports.default = ChatBubbleIcon;
});
unwrapExports(ChatBubble);
var ChatBubbleOutline = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z'
    }));
  };

  var ChatBubbleOutlineIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ChatBubbleOutlineIcon.displayName = 'ChatBubbleOutlineIcon';
  ChatBubbleOutlineIcon.defaultProps = {
    size: 24
  };
  exports.default = ChatBubbleOutlineIcon;
});
unwrapExports(ChatBubbleOutline);
var Check = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z'
    }));
  };

  var CheckIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  CheckIcon.displayName = 'CheckIcon';
  CheckIcon.defaultProps = {
    size: 24
  };
  exports.default = CheckIcon;
});
unwrapExports(Check);
var CheckBox = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z'
    }));
  };

  var CheckBoxIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  CheckBoxIcon.displayName = 'CheckBoxIcon';
  CheckBoxIcon.defaultProps = {
    size: 24
  };
  exports.default = CheckBoxIcon;
});
var IconChecked = unwrapExports(CheckBox);
var CheckBoxOutlineBlank = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z'
    }));
  };

  var CheckBoxOutlineBlankIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  CheckBoxOutlineBlankIcon.displayName = 'CheckBoxOutlineBlankIcon';
  CheckBoxOutlineBlankIcon.defaultProps = {
    size: 24
  };
  exports.default = CheckBoxOutlineBlankIcon;
});
var IconUnChecked = unwrapExports(CheckBoxOutlineBlank);
var CheckCircle = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z'
    }));
  };

  var CheckCircleIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  CheckCircleIcon.displayName = 'CheckCircleIcon';
  CheckCircleIcon.defaultProps = {
    size: 24
  };
  exports.default = CheckCircleIcon;
});
var IconCheckCircle = unwrapExports(CheckCircle);
var ChevronLeft = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z'
    }));
  };

  var ChevronLeftIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ChevronLeftIcon.displayName = 'ChevronLeftIcon';
  ChevronLeftIcon.defaultProps = {
    size: 24
  };
  exports.default = ChevronLeftIcon;
});
unwrapExports(ChevronLeft);
var ChevronRight = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z'
    }));
  };

  var ChevronRightIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ChevronRightIcon.displayName = 'ChevronRightIcon';
  ChevronRightIcon.defaultProps = {
    size: 24
  };
  exports.default = ChevronRightIcon;
});
unwrapExports(ChevronRight);
var ChildCare = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M22.94 12.66c.04-.21.06-.43.06-.66s-.02-.45-.06-.66c-.25-1.51-1.36-2.74-2.81-3.17-.53-1.12-1.28-2.1-2.19-2.91C16.36 3.85 14.28 3 12 3s-4.36.85-5.94 2.26c-.92.81-1.67 1.8-2.19 2.91-1.45.43-2.56 1.65-2.81 3.17-.04.21-.06.43-.06.66s.02.45.06.66c.25 1.51 1.36 2.74 2.81 3.17.52 1.11 1.27 2.09 2.17 2.89C7.62 20.14 9.71 21 12 21s4.38-.86 5.97-2.28c.9-.8 1.65-1.79 2.17-2.89 1.44-.43 2.55-1.65 2.8-3.17zM19 14c-.1 0-.19-.02-.29-.03-.2.67-.49 1.29-.86 1.86C16.6 17.74 14.45 19 12 19s-4.6-1.26-5.85-3.17c-.37-.57-.66-1.19-.86-1.86-.1.01-.19.03-.29.03-1.1 0-2-.9-2-2s.9-2 2-2c.1 0 .19.02.29.03.2-.67.49-1.29.86-1.86C7.4 6.26 9.55 5 12 5s4.6 1.26 5.85 3.17c.37.57.66 1.19.86 1.86.1-.01.19-.03.29-.03 1.1 0 2 .9 2 2s-.9 2-2 2zM7.5 14c.76 1.77 2.49 3 4.5 3s3.74-1.23 4.5-3h-9z M 14.5 9.25 A 1.25 1.25 0 0 1 14.5 11.75 A 1.25 1.25 0 0 1 14.5 9.25 M 9.5 9.25 A 1.25 1.25 0 0 0 9.5 11.75 A 1.25 1.25 0 0 0 9.5 9.25'
    }));
  };

  var ChildCareIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ChildCareIcon.displayName = 'ChildCareIcon';
  ChildCareIcon.defaultProps = {
    size: 24
  };
  exports.default = ChildCareIcon;
});
unwrapExports(ChildCare);
var ChildFriendly = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M13 2v8h8c0-4.42-3.58-8-8-8zm6.32 13.89C20.37 14.54 21 12.84 21 11H6.44l-.95-2H2v2h2.22s1.89 4.07 2.12 4.42c-1.1.59-1.84 1.75-1.84 3.08C4.5 20.43 6.07 22 8 22c1.76 0 3.22-1.3 3.46-3h2.08c.24 1.7 1.7 3 3.46 3 1.93 0 3.5-1.57 3.5-3.5 0-1.04-.46-1.97-1.18-2.61zM8 20c-.83 0-1.5-.67-1.5-1.5S7.17 17 8 17s1.5.67 1.5 1.5S8.83 20 8 20zm9 0c-.83 0-1.5-.67-1.5-1.5S16.17 17 17 17s1.5.67 1.5 1.5S17.83 20 17 20z'
    }));
  };

  var ChildFriendlyIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ChildFriendlyIcon.displayName = 'ChildFriendlyIcon';
  ChildFriendlyIcon.defaultProps = {
    size: 24
  };
  exports.default = ChildFriendlyIcon;
});
unwrapExports(ChildFriendly);
var ChromeReaderMode = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M13 12h7v1.5h-7zm0-2.5h7V11h-7zm0 5h7V16h-7zM21 4H3c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 15h-9V6h9v13z'
    }));
  };

  var ChromeReaderModeIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ChromeReaderModeIcon.displayName = 'ChromeReaderModeIcon';
  ChromeReaderModeIcon.defaultProps = {
    size: 24
  };
  exports.default = ChromeReaderModeIcon;
});
unwrapExports(ChromeReaderMode);
var Class = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z'
    }));
  };

  var ClassIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ClassIcon.displayName = 'ClassIcon';
  ClassIcon.defaultProps = {
    size: 24
  };
  exports.default = ClassIcon;
});
unwrapExports(Class);
var Clear = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'
    }));
  };

  var ClearIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ClearIcon.displayName = 'ClearIcon';
  ClearIcon.defaultProps = {
    size: 24
  };
  exports.default = ClearIcon;
});
unwrapExports(Clear);
var ClearAll = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M5 13h14v-2H5v2zm-2 4h14v-2H3v2zM7 7v2h14V7H7z'
    }));
  };

  var ClearAllIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ClearAllIcon.displayName = 'ClearAllIcon';
  ClearAllIcon.defaultProps = {
    size: 24
  };
  exports.default = ClearAllIcon;
});
unwrapExports(ClearAll);
var Close = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'
    }));
  };

  var CloseIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  CloseIcon.displayName = 'CloseIcon';
  CloseIcon.defaultProps = {
    size: 24
  };
  exports.default = CloseIcon;
});
unwrapExports(Close);
var ClosedCaption = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 7H9.5v-.5h-2v3h2V13H11v1c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1zm7 0h-1.5v-.5h-2v3h2V13H18v1c0 .55-.45 1-1 1h-3c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1z'
    }));
  };

  var ClosedCaptionIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ClosedCaptionIcon.displayName = 'ClosedCaptionIcon';
  ClosedCaptionIcon.defaultProps = {
    size: 24
  };
  exports.default = ClosedCaptionIcon;
});
unwrapExports(ClosedCaption);
var Cloud = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96z'
    }));
  };

  var CloudIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  CloudIcon.displayName = 'CloudIcon';
  CloudIcon.defaultProps = {
    size: 24
  };
  exports.default = CloudIcon;
});
unwrapExports(Cloud);
var CloudCircle = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.5 14H8c-1.66 0-3-1.34-3-3s1.34-3 3-3l.14.01C8.58 8.28 10.13 7 12 7c2.21 0 4 1.79 4 4h.5c1.38 0 2.5 1.12 2.5 2.5S17.88 16 16.5 16z'
    }));
  };

  var CloudCircleIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  CloudCircleIcon.displayName = 'CloudCircleIcon';
  CloudCircleIcon.defaultProps = {
    size: 24
  };
  exports.default = CloudCircleIcon;
});
unwrapExports(CloudCircle);
var CloudDone = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM10 17l-3.5-3.5 1.41-1.41L10 14.17 15.18 9l1.41 1.41L10 17z'
    }));
  };

  var CloudDoneIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  CloudDoneIcon.displayName = 'CloudDoneIcon';
  CloudDoneIcon.defaultProps = {
    size: 24
  };
  exports.default = CloudDoneIcon;
});
unwrapExports(CloudDone);
var CloudDownload = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM17 13l-5 5-5-5h3V9h4v4h3z'
    }));
  };

  var CloudDownloadIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  CloudDownloadIcon.displayName = 'CloudDownloadIcon';
  CloudDownloadIcon.defaultProps = {
    size: 24
  };
  exports.default = CloudDownloadIcon;
});
unwrapExports(CloudDownload);
var CloudOff = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19.35 10.04C18.67 6.59 15.64 4 12 4c-1.48 0-2.85.43-4.01 1.17l1.46 1.46C10.21 6.23 11.08 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3 0 1.13-.64 2.11-1.56 2.62l1.45 1.45C23.16 18.16 24 16.68 24 15c0-2.64-2.05-4.78-4.65-4.96zM3 5.27l2.75 2.74C2.56 8.15 0 10.77 0 14c0 3.31 2.69 6 6 6h11.73l2 2L21 20.73 4.27 4 3 5.27zM7.73 10l8 8H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h1.73z'
    }));
  };

  var CloudOffIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  CloudOffIcon.displayName = 'CloudOffIcon';
  CloudOffIcon.defaultProps = {
    size: 24
  };
  exports.default = CloudOffIcon;
});
unwrapExports(CloudOff);
var CloudQueue = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h.71C7.37 7.69 9.48 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3s-1.34 3-3 3z'
    }));
  };

  var CloudQueueIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  CloudQueueIcon.displayName = 'CloudQueueIcon';
  CloudQueueIcon.defaultProps = {
    size: 24
  };
  exports.default = CloudQueueIcon;
});
unwrapExports(CloudQueue);
var CloudUpload = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z'
    }));
  };

  var CloudUploadIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  CloudUploadIcon.displayName = 'CloudUploadIcon';
  CloudUploadIcon.defaultProps = {
    size: 24
  };
  exports.default = CloudUploadIcon;
});
unwrapExports(CloudUpload);
var Code = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z'
    }));
  };

  var CodeIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  CodeIcon.displayName = 'CodeIcon';
  CodeIcon.defaultProps = {
    size: 24
  };
  exports.default = CodeIcon;
});
unwrapExports(Code);
var Collections = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M22 16V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2zm-11-4l2.03 2.71L16 11l4 5H8l3-4zM2 6v14c0 1.1.9 2 2 2h14v-2H4V6H2z'
    }));
  };

  var CollectionsIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  CollectionsIcon.displayName = 'CollectionsIcon';
  CollectionsIcon.defaultProps = {
    size: 24
  };
  exports.default = CollectionsIcon;
});
unwrapExports(Collections);
var CollectionsBookmark = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 10l-2.5-1.5L15 12V4h5v8z'
    }));
  };

  var CollectionsBookmarkIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  CollectionsBookmarkIcon.displayName = 'CollectionsBookmarkIcon';
  CollectionsBookmarkIcon.defaultProps = {
    size: 24
  };
  exports.default = CollectionsBookmarkIcon;
});
unwrapExports(CollectionsBookmark);
var ColorLens = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9c.83 0 1.5-.67 1.5-1.5 0-.39-.15-.74-.39-1.01-.23-.26-.38-.61-.38-.99 0-.83.67-1.5 1.5-1.5H16c2.76 0 5-2.24 5-5 0-4.42-4.03-8-9-8zm-5.5 9c-.83 0-1.5-.67-1.5-1.5S5.67 9 6.5 9 8 9.67 8 10.5 7.33 12 6.5 12zm3-4C8.67 8 8 7.33 8 6.5S8.67 5 9.5 5s1.5.67 1.5 1.5S10.33 8 9.5 8zm5 0c-.83 0-1.5-.67-1.5-1.5S13.67 5 14.5 5s1.5.67 1.5 1.5S15.33 8 14.5 8zm3 4c-.83 0-1.5-.67-1.5-1.5S16.67 9 17.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z'
    }));
  };

  var ColorLensIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ColorLensIcon.displayName = 'ColorLensIcon';
  ColorLensIcon.defaultProps = {
    size: 24
  };
  exports.default = ColorLensIcon;
});
unwrapExports(ColorLens);
var Colorize = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20.71 5.63l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-3.12 3.12-1.93-1.91-1.41 1.41 1.42 1.42L3 16.25V21h4.75l8.92-8.92 1.42 1.42 1.41-1.41-1.92-1.92 3.12-3.12c.4-.4.4-1.03.01-1.42zM6.92 19L5 17.08l8.06-8.06 1.92 1.92L6.92 19z'
    }));
  };

  var ColorizeIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ColorizeIcon.displayName = 'ColorizeIcon';
  ColorizeIcon.defaultProps = {
    size: 24
  };
  exports.default = ColorizeIcon;
});
unwrapExports(Colorize);
var Comment = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18zM18 14H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z'
    }));
  };

  var CommentIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  CommentIcon.displayName = 'CommentIcon';
  CommentIcon.defaultProps = {
    size: 24
  };
  exports.default = CommentIcon;
});
unwrapExports(Comment);
var Compare = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M10 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h5v2h2V1h-2v2zm0 15H5l5-6v6zm9-15h-5v2h5v13l-5-6v9h5c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z'
    }));
  };

  var CompareIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  CompareIcon.displayName = 'CompareIcon';
  CompareIcon.defaultProps = {
    size: 24
  };
  exports.default = CompareIcon;
});
unwrapExports(Compare);
var CompareArrows = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M9.01 14H2v2h7.01v3L13 15l-3.99-4v3zm5.98-1v-3H22V8h-7.01V5L11 9l3.99 4z'
    }));
  };

  var CompareArrowsIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  CompareArrowsIcon.displayName = 'CompareArrowsIcon';
  CompareArrowsIcon.defaultProps = {
    size: 24
  };
  exports.default = CompareArrowsIcon;
});
unwrapExports(CompareArrows);
var Computer = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 18c1.1 0 1.99-.9 1.99-2L22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z'
    }));
  };

  var ComputerIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ComputerIcon.displayName = 'ComputerIcon';
  ComputerIcon.defaultProps = {
    size: 24
  };
  exports.default = ComputerIcon;
});
unwrapExports(Computer);
var ConfirmationNumber = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M22 10V6c0-1.11-.9-2-2-2H4c-1.1 0-1.99.89-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2s.9-2 2-2zm-9 7.5h-2v-2h2v2zm0-4.5h-2v-2h2v2zm0-4.5h-2v-2h2v2z'
    }));
  };

  var ConfirmationNumberIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ConfirmationNumberIcon.displayName = 'ConfirmationNumberIcon';
  ConfirmationNumberIcon.defaultProps = {
    size: 24
  };
  exports.default = ConfirmationNumberIcon;
});
unwrapExports(ConfirmationNumber);
var ContactMail = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21 8V7l-3 2-3-2v1l3 2 3-2zm1-5H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h20c1.1 0 1.99-.9 1.99-2L24 5c0-1.1-.9-2-2-2zM8 6c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H2v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1zm8-6h-8V6h8v6z'
    }));
  };

  var ContactMailIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ContactMailIcon.displayName = 'ContactMailIcon';
  ContactMailIcon.defaultProps = {
    size: 24
  };
  exports.default = ContactMailIcon;
});
unwrapExports(ContactMail);
var ContactPhone = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M22 3H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h20c1.1 0 1.99-.9 1.99-2L24 5c0-1.1-.9-2-2-2zM8 6c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H2v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1zm3.85-4h1.64L21 16l-1.99 1.99c-1.31-.98-2.28-2.38-2.73-3.99-.18-.64-.28-1.31-.28-2s.1-1.36.28-2c.45-1.62 1.42-3.01 2.73-3.99L21 8l-1.51 2h-1.64c-.22.63-.35 1.3-.35 2s.13 1.37.35 2z'
    }));
  };

  var ContactPhoneIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ContactPhoneIcon.displayName = 'ContactPhoneIcon';
  ContactPhoneIcon.defaultProps = {
    size: 24
  };
  exports.default = ContactPhoneIcon;
});
unwrapExports(ContactPhone);
var Contacts = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 0H4v2h16V0zM4 24h16v-2H4v2zM20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 2.75c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25S9.75 10.24 9.75 9 10.76 6.75 12 6.75zM17 17H7v-1.5c0-1.67 3.33-2.5 5-2.5s5 .83 5 2.5V17z'
    }));
  };

  var ContactsIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ContactsIcon.displayName = 'ContactsIcon';
  ContactsIcon.defaultProps = {
    size: 24
  };
  exports.default = ContactsIcon;
});
unwrapExports(Contacts);
var ContentCopy = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z'
    }));
  };

  var ContentCopyIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ContentCopyIcon.displayName = 'ContentCopyIcon';
  ContentCopyIcon.defaultProps = {
    size: 24
  };
  exports.default = ContentCopyIcon;
});
unwrapExports(ContentCopy);
var ContentCut = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M9.64 7.64c.23-.5.36-1.05.36-1.64 0-2.21-1.79-4-4-4S2 3.79 2 6s1.79 4 4 4c.59 0 1.14-.13 1.64-.36L10 12l-2.36 2.36C7.14 14.13 6.59 14 6 14c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4c0-.59-.13-1.14-.36-1.64L12 14l7 7h3v-1L9.64 7.64zM6 8c-1.1 0-2-.89-2-2s.9-2 2-2 2 .89 2 2-.9 2-2 2zm0 12c-1.1 0-2-.89-2-2s.9-2 2-2 2 .89 2 2-.9 2-2 2zm6-7.5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5.5.22.5.5-.22.5-.5.5zM19 3l-6 6 2 2 7-7V3z M 6 16 A 2 2 0 0 1 6 20 A 2 2 0 0 1 6 16 M 12 11.5 A 0.5 0.5 0 0 0 12 12.5 A 0.5 0.5 0 0 0 12 11.5 M 6 4 A 2 2 0 0 1 6 8 A 2 2 0 0 1 6 4'
    }));
  };

  var ContentCutIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ContentCutIcon.displayName = 'ContentCutIcon';
  ContentCutIcon.defaultProps = {
    size: 24
  };
  exports.default = ContentCutIcon;
});
unwrapExports(ContentCut);
var ContentPaste = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 2h-4.18C14.4.84 13.3 0 12 0c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm7 18H5V4h2v3h10V4h2v16z'
    }));
  };

  var ContentPasteIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ContentPasteIcon.displayName = 'ContentPasteIcon';
  ContentPasteIcon.defaultProps = {
    size: 24
  };
  exports.default = ContentPasteIcon;
});
unwrapExports(ContentPaste);
var ControlPoint = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z'
    }));
  };

  var ControlPointIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ControlPointIcon.displayName = 'ControlPointIcon';
  ControlPointIcon.defaultProps = {
    size: 24
  };
  exports.default = ControlPointIcon;
});
unwrapExports(ControlPoint);
var ControlPointDuplicate = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M16 8h-2v3h-3v2h3v3h2v-3h3v-2h-3zM2 12c0-2.79 1.64-5.2 4.01-6.32V3.52C2.52 4.76 0 8.09 0 12s2.52 7.24 6.01 8.48v-2.16C3.64 17.2 2 14.79 2 12zm13-9c-4.96 0-9 4.04-9 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z'
    }));
  };

  var ControlPointDuplicateIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ControlPointDuplicateIcon.displayName = 'ControlPointDuplicateIcon';
  ControlPointDuplicateIcon.defaultProps = {
    size: 24
  };
  exports.default = ControlPointDuplicateIcon;
});
unwrapExports(ControlPointDuplicate);
var Copyright = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M10.08 10.86c.05-.33.16-.62.3-.87s.34-.46.59-.62c.24-.15.54-.22.91-.23.23.01.44.05.63.13.2.09.38.21.52.36s.25.33.34.53.13.42.14.64h1.79c-.02-.47-.11-.9-.28-1.29s-.4-.73-.7-1.01-.66-.5-1.08-.66-.88-.23-1.39-.23c-.65 0-1.22.11-1.7.34s-.88.53-1.2.92-.56.84-.71 1.36S8 11.29 8 11.87v.27c0 .58.08 1.12.23 1.64s.39.97.71 1.35.72.69 1.2.91 1.05.34 1.7.34c.47 0 .91-.08 1.32-.23s.77-.36 1.08-.63.56-.58.74-.94.29-.74.3-1.15h-1.79c-.01.21-.06.4-.15.58s-.21.33-.36.46-.32.23-.52.3c-.19.07-.39.09-.6.1-.36-.01-.66-.08-.89-.23-.25-.16-.45-.37-.59-.62s-.25-.55-.3-.88-.08-.67-.08-1v-.27c0-.35.03-.68.08-1.01zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z'
    }));
  };

  var CopyrightIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  CopyrightIcon.displayName = 'CopyrightIcon';
  CopyrightIcon.defaultProps = {
    size: 24
  };
  exports.default = CopyrightIcon;
});
unwrapExports(Copyright);
var Create = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z'
    }));
  };

  var CreateIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  CreateIcon.displayName = 'CreateIcon';
  CreateIcon.defaultProps = {
    size: 24
  };
  exports.default = CreateIcon;
});
unwrapExports(Create);
var CreateNewFolder = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 6h-8l-2-2H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-1 8h-3v3h-2v-3h-3v-2h3V9h2v3h3v2z'
    }));
  };

  var CreateNewFolderIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  CreateNewFolderIcon.displayName = 'CreateNewFolderIcon';
  CreateNewFolderIcon.defaultProps = {
    size: 24
  };
  exports.default = CreateNewFolderIcon;
});
unwrapExports(CreateNewFolder);
var CreditCard = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z'
    }));
  };

  var CreditCardIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  CreditCardIcon.displayName = 'CreditCardIcon';
  CreditCardIcon.defaultProps = {
    size: 24
  };
  exports.default = CreditCardIcon;
});
unwrapExports(CreditCard);
var Crop = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M17 15h2V7c0-1.1-.9-2-2-2H9v2h8v8zM7 17V1H5v4H1v2h4v10c0 1.1.9 2 2 2h10v4h2v-4h4v-2H7z'
    }));
  };

  var CropIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  CropIcon.displayName = 'CropIcon';
  CropIcon.defaultProps = {
    size: 24
  };
  exports.default = CropIcon;
});
unwrapExports(Crop);
var Crop169 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 6H5c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 10H5V8h14v8z'
    }));
  };

  var Crop169Icon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  Crop169Icon.displayName = 'Crop169Icon';
  Crop169Icon.defaultProps = {
    size: 24
  };
  exports.default = Crop169Icon;
});
unwrapExports(Crop169);
var Crop32 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 4H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H5V6h14v12z'
    }));
  };

  var Crop32Icon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  Crop32Icon.displayName = 'Crop32Icon';
  Crop32Icon.defaultProps = {
    size: 24
  };
  exports.default = Crop32Icon;
});
unwrapExports(Crop32);
var Crop54 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 5H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 12H5V7h14v10z'
    }));
  };

  var Crop54Icon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  Crop54Icon.displayName = 'Crop54Icon';
  Crop54Icon.defaultProps = {
    size: 24
  };
  exports.default = Crop54Icon;
});
unwrapExports(Crop54);
var Crop75 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 7H5c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm0 8H5V9h14v6z'
    }));
  };

  var Crop75Icon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  Crop75Icon.displayName = 'Crop75Icon';
  Crop75Icon.defaultProps = {
    size: 24
  };
  exports.default = Crop75Icon;
});
unwrapExports(Crop75);
var CropDin = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z'
    }));
  };

  var CropDinIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  CropDinIcon.displayName = 'CropDinIcon';
  CropDinIcon.defaultProps = {
    size: 24
  };
  exports.default = CropDinIcon;
});
unwrapExports(CropDin);
var CropFree = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M3 5v4h2V5h4V3H5c-1.1 0-2 .9-2 2zm2 10H3v4c0 1.1.9 2 2 2h4v-2H5v-4zm14 4h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zm0-16h-4v2h4v4h2V5c0-1.1-.9-2-2-2z'
    }));
  };

  var CropFreeIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  CropFreeIcon.displayName = 'CropFreeIcon';
  CropFreeIcon.defaultProps = {
    size: 24
  };
  exports.default = CropFreeIcon;
});
unwrapExports(CropFree);
var CropLandscape = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 5H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 12H5V7h14v10z'
    }));
  };

  var CropLandscapeIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  CropLandscapeIcon.displayName = 'CropLandscapeIcon';
  CropLandscapeIcon.defaultProps = {
    size: 24
  };
  exports.default = CropLandscapeIcon;
});
unwrapExports(CropLandscape);
var CropOriginal = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-5.04-6.71l-2.75 3.54-1.96-2.36L6.5 17h11l-3.54-4.71z'
    }));
  };

  var CropOriginalIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  CropOriginalIcon.displayName = 'CropOriginalIcon';
  CropOriginalIcon.defaultProps = {
    size: 24
  };
  exports.default = CropOriginalIcon;
});
unwrapExports(CropOriginal);
var CropPortrait = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M17 3H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H7V5h10v14z'
    }));
  };

  var CropPortraitIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  CropPortraitIcon.displayName = 'CropPortraitIcon';
  CropPortraitIcon.defaultProps = {
    size: 24
  };
  exports.default = CropPortraitIcon;
});
unwrapExports(CropPortrait);
var CropRotate = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M7.47 21.49C4.2 19.93 1.86 16.76 1.5 13H0c.51 6.16 5.66 11 11.95 11 .23 0 .44-.02.66-.03L8.8 20.15l-1.33 1.34zM12.05 0c-.23 0-.44.02-.66.04l3.81 3.81 1.33-1.33C19.8 4.07 22.14 7.24 22.5 11H24c-.51-6.16-5.66-11-11.95-11zM16 14h2V8c0-1.11-.9-2-2-2h-6v2h6v6zm-8 2V4H6v2H4v2h2v8c0 1.1.89 2 2 2h8v2h2v-2h2v-2H8z'
    }));
  };

  var CropRotateIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  CropRotateIcon.displayName = 'CropRotateIcon';
  CropRotateIcon.defaultProps = {
    size: 24
  };
  exports.default = CropRotateIcon;
});
unwrapExports(CropRotate);
var CropSquare = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M18 4H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H6V6h12v12z'
    }));
  };

  var CropSquareIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  CropSquareIcon.displayName = 'CropSquareIcon';
  CropSquareIcon.defaultProps = {
    size: 24
  };
  exports.default = CropSquareIcon;
});
unwrapExports(CropSquare);
var Dashboard = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z'
    }));
  };

  var DashboardIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  DashboardIcon.displayName = 'DashboardIcon';
  DashboardIcon.defaultProps = {
    size: 24
  };
  exports.default = DashboardIcon;
});
unwrapExports(Dashboard);
var DataUsage = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M13 2.05v3.03c3.39.49 6 3.39 6 6.92 0 .9-.18 1.75-.48 2.54l2.6 1.53c.56-1.24.88-2.62.88-4.07 0-5.18-3.95-9.45-9-9.95zM12 19c-3.87 0-7-3.13-7-7 0-3.53 2.61-6.43 6-6.92V2.05c-5.06.5-9 4.76-9 9.95 0 5.52 4.47 10 9.99 10 3.31 0 6.24-1.61 8.06-4.09l-2.6-1.53C16.17 17.98 14.21 19 12 19z'
    }));
  };

  var DataUsageIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  DataUsageIcon.displayName = 'DataUsageIcon';
  DataUsageIcon.defaultProps = {
    size: 24
  };
  exports.default = DataUsageIcon;
});
unwrapExports(DataUsage);
var DateRange = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z'
    }));
  };

  var DateRangeIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  DateRangeIcon.displayName = 'DateRangeIcon';
  DateRangeIcon.defaultProps = {
    size: 24
  };
  exports.default = DateRangeIcon;
});
unwrapExports(DateRange);
var Dehaze = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M2 15.5v2h20v-2H2zm0-5v2h20v-2H2zm0-5v2h20v-2H2z'
    }));
  };

  var DehazeIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  DehazeIcon.displayName = 'DehazeIcon';
  DehazeIcon.defaultProps = {
    size: 24
  };
  exports.default = DehazeIcon;
});
unwrapExports(Dehaze);
var Delete = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z'
    }));
  };

  var DeleteIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  DeleteIcon.displayName = 'DeleteIcon';
  DeleteIcon.defaultProps = {
    size: 24
  };
  exports.default = DeleteIcon;
});
unwrapExports(Delete);
var DeleteForever = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm2.46-7.12l1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14l-2.13-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4z'
    }));
  };

  var DeleteForeverIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  DeleteForeverIcon.displayName = 'DeleteForeverIcon';
  DeleteForeverIcon.defaultProps = {
    size: 24
  };
  exports.default = DeleteForeverIcon;
});
unwrapExports(DeleteForever);
var DeleteSweep = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M15 16h4v2h-4zm0-8h7v2h-7zm0 4h6v2h-6zM3 18c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2V8H3v10zM14 5h-3l-1-1H6L5 5H2v2h12z'
    }));
  };

  var DeleteSweepIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  DeleteSweepIcon.displayName = 'DeleteSweepIcon';
  DeleteSweepIcon.defaultProps = {
    size: 24
  };
  exports.default = DeleteSweepIcon;
});
unwrapExports(DeleteSweep);
var Description = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z'
    }));
  };

  var DescriptionIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  DescriptionIcon.displayName = 'DescriptionIcon';
  DescriptionIcon.defaultProps = {
    size: 24
  };
  exports.default = DescriptionIcon;
});
unwrapExports(Description);
var DesktopMac = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7l-2 3v1h8v-1l-2-3h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 12H3V4h18v10z'
    }));
  };

  var DesktopMacIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  DesktopMacIcon.displayName = 'DesktopMacIcon';
  DesktopMacIcon.defaultProps = {
    size: 24
  };
  exports.default = DesktopMacIcon;
});
unwrapExports(DesktopMac);
var DesktopWindows = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7v2H8v2h8v-2h-2v-2h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H3V4h18v12z'
    }));
  };

  var DesktopWindowsIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  DesktopWindowsIcon.displayName = 'DesktopWindowsIcon';
  DesktopWindowsIcon.defaultProps = {
    size: 24
  };
  exports.default = DesktopWindowsIcon;
});
unwrapExports(DesktopWindows);
var Details = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M3 4l9 16 9-16H3zm3.38 2h11.25L12 16 6.38 6z'
    }));
  };

  var DetailsIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  DetailsIcon.displayName = 'DetailsIcon';
  DetailsIcon.defaultProps = {
    size: 24
  };
  exports.default = DetailsIcon;
});
unwrapExports(Details);
var DeveloperBoard = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M22 9V7h-2V5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-2h2v-2h-2v-2h2v-2h-2V9h2zm-4 10H4V5h14v14zM6 13h5v4H6zm6-6h4v3h-4zM6 7h5v5H6zm6 4h4v6h-4z'
    }));
  };

  var DeveloperBoardIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  DeveloperBoardIcon.displayName = 'DeveloperBoardIcon';
  DeveloperBoardIcon.defaultProps = {
    size: 24
  };
  exports.default = DeveloperBoardIcon;
});
unwrapExports(DeveloperBoard);
var DeveloperMode = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M7 5h10v2h2V3c0-1.1-.9-1.99-2-1.99L7 1c-1.1 0-2 .9-2 2v4h2V5zm8.41 11.59L20 12l-4.59-4.59L14 8.83 17.17 12 14 15.17l1.41 1.42zM10 15.17L6.83 12 10 8.83 8.59 7.41 4 12l4.59 4.59L10 15.17zM17 19H7v-2H5v4c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-4h-2v2z'
    }));
  };

  var DeveloperModeIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  DeveloperModeIcon.displayName = 'DeveloperModeIcon';
  DeveloperModeIcon.defaultProps = {
    size: 24
  };
  exports.default = DeveloperModeIcon;
});
unwrapExports(DeveloperMode);
var DeviceHub = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M17 16l-4-4V8.82C14.16 8.4 15 7.3 15 6c0-1.66-1.34-3-3-3S9 4.34 9 6c0 1.3.84 2.4 2 2.82V12l-4 4H3v5h5v-3.05l4-4.2 4 4.2V21h5v-5h-4z'
    }));
  };

  var DeviceHubIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  DeviceHubIcon.displayName = 'DeviceHubIcon';
  DeviceHubIcon.defaultProps = {
    size: 24
  };
  exports.default = DeviceHubIcon;
});
unwrapExports(DeviceHub);
var Devices = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M4 6h18V4H4c-1.1 0-2 .9-2 2v11H0v3h14v-3H4V6zm19 2h-6c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-1 9h-4v-7h4v7z'
    }));
  };

  var DevicesIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  DevicesIcon.displayName = 'DevicesIcon';
  DevicesIcon.defaultProps = {
    size: 24
  };
  exports.default = DevicesIcon;
});
unwrapExports(Devices);
var DevicesOther = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M3 6h18V4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4v-2H3V6zm10 6H9v1.78c-.61.55-1 1.33-1 2.22s.39 1.67 1 2.22V20h4v-1.78c.61-.55 1-1.34 1-2.22s-.39-1.67-1-2.22V12zm-2 5.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM22 8h-6c-.5 0-1 .5-1 1v10c0 .5.5 1 1 1h6c.5 0 1-.5 1-1V9c0-.5-.5-1-1-1zm-1 10h-4v-8h4v8z'
    }));
  };

  var DevicesOtherIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  DevicesOtherIcon.displayName = 'DevicesOtherIcon';
  DevicesOtherIcon.defaultProps = {
    size: 24
  };
  exports.default = DevicesOtherIcon;
});
unwrapExports(DevicesOther);
var DialerSip = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M17 3h-1v5h1V3zm-2 2h-2V4h2V3h-3v3h2v1h-2v1h3V5zm3-2v5h1V6h2V3h-3zm2 2h-1V4h1v1zm0 10.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.01.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.27-.26.35-.65.24-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1z'
    }));
  };

  var DialerSipIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  DialerSipIcon.displayName = 'DialerSipIcon';
  DialerSipIcon.defaultProps = {
    size: 24
  };
  exports.default = DialerSipIcon;
});
unwrapExports(DialerSip);
var Dialpad = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 19c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM6 1c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12-8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-6 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z'
    }));
  };

  var DialpadIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  DialpadIcon.displayName = 'DialpadIcon';
  DialpadIcon.defaultProps = {
    size: 24
  };
  exports.default = DialpadIcon;
});
unwrapExports(Dialpad);
var Directions = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21.71 11.29l-9-9c-.39-.39-1.02-.39-1.41 0l-9 9c-.39.39-.39 1.02 0 1.41l9 9c.39.39 1.02.39 1.41 0l9-9c.39-.38.39-1.01 0-1.41zM14 14.5V12h-4v3H8v-4c0-.55.45-1 1-1h5V7.5l3.5 3.5-3.5 3.5z'
    }));
  };

  var DirectionsIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  DirectionsIcon.displayName = 'DirectionsIcon';
  DirectionsIcon.defaultProps = {
    size: 24
  };
  exports.default = DirectionsIcon;
});
unwrapExports(Directions);
var DirectionsBike = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M15.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5zm5.8-10l2.4-2.4.8.8c1.3 1.3 3 2.1 5.1 2.1V9c-1.5 0-2.7-.6-3.6-1.5l-1.9-1.9c-.5-.4-1-.6-1.6-.6s-1.1.2-1.4.6L7.8 8.4c-.4.4-.6.9-.6 1.4 0 .6.2 1.1.6 1.4L11 14v5h2v-6.2l-2.2-2.3zM19 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5z'
    }));
  };

  var DirectionsBikeIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  DirectionsBikeIcon.displayName = 'DirectionsBikeIcon';
  DirectionsBikeIcon.defaultProps = {
    size: 24
  };
  exports.default = DirectionsBikeIcon;
});
unwrapExports(DirectionsBike);
var DirectionsBoat = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 21c-1.39 0-2.78-.47-4-1.32-2.44 1.71-5.56 1.71-8 0C6.78 20.53 5.39 21 4 21H2v2h2c1.38 0 2.74-.35 4-.99 2.52 1.29 5.48 1.29 8 0 1.26.65 2.62.99 4 .99h2v-2h-2zM3.95 19H4c1.6 0 3.02-.88 4-2 .98 1.12 2.4 2 4 2s3.02-.88 4-2c.98 1.12 2.4 2 4 2h.05l1.89-6.68c.08-.26.06-.54-.06-.78s-.34-.42-.6-.5L20 10.62V6c0-1.1-.9-2-2-2h-3V1H9v3H6c-1.1 0-2 .9-2 2v4.62l-1.29.42c-.26.08-.48.26-.6.5s-.15.52-.06.78L3.95 19zM6 6h12v3.97L12 8 6 9.97V6z'
    }));
  };

  var DirectionsBoatIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  DirectionsBoatIcon.displayName = 'DirectionsBoatIcon';
  DirectionsBoatIcon.defaultProps = {
    size: 24
  };
  exports.default = DirectionsBoatIcon;
});
unwrapExports(DirectionsBoat);
var DirectionsBus = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M4 16c0 .88.39 1.67 1 2.22V20c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h8v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1.78c.61-.55 1-1.34 1-2.22V6c0-3.5-3.58-4-8-4s-8 .5-8 4v10zm3.5 1c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm9 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-6H6V6h12v5z'
    }));
  };

  var DirectionsBusIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  DirectionsBusIcon.displayName = 'DirectionsBusIcon';
  DirectionsBusIcon.defaultProps = {
    size: 24
  };
  exports.default = DirectionsBusIcon;
});
unwrapExports(DirectionsBus);
var DirectionsCar = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z'
    }));
  };

  var DirectionsCarIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  DirectionsCarIcon.displayName = 'DirectionsCarIcon';
  DirectionsCarIcon.defaultProps = {
    size: 24
  };
  exports.default = DirectionsCarIcon;
});
unwrapExports(DirectionsCar);
var DirectionsRailway = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M4 15.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V5c0-3.5-3.58-4-8-4s-8 .5-8 4v10.5zm8 1.5c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm6-7H6V5h12v5z'
    }));
  };

  var DirectionsRailwayIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  DirectionsRailwayIcon.displayName = 'DirectionsRailwayIcon';
  DirectionsRailwayIcon.defaultProps = {
    size: 24
  };
  exports.default = DirectionsRailwayIcon;
});
unwrapExports(DirectionsRailway);
var DirectionsRun = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M13.49 5.48c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-3.6 13.9l1-4.4 2.1 2v6h2v-7.5l-2.1-2 .6-3c1.3 1.5 3.3 2.5 5.5 2.5v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6c-.4-.6-1-1-1.7-1-.3 0-.5.1-.8.1l-5.2 2.2v4.7h2v-3.4l1.8-.7-1.6 8.1-4.9-1-.4 2 7 1.4z'
    }));
  };

  var DirectionsRunIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  DirectionsRunIcon.displayName = 'DirectionsRunIcon';
  DirectionsRunIcon.defaultProps = {
    size: 24
  };
  exports.default = DirectionsRunIcon;
});
unwrapExports(DirectionsRun);
var DirectionsSubway = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 2c-4.42 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm3.5-6H6V6h5v5zm5.5 6c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-6h-5V6h5v5z'
    }));
  };

  var DirectionsSubwayIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  DirectionsSubwayIcon.displayName = 'DirectionsSubwayIcon';
  DirectionsSubwayIcon.defaultProps = {
    size: 24
  };
  exports.default = DirectionsSubwayIcon;
});
unwrapExports(DirectionsSubway);
var DirectionsTransit = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 2c-4.42 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm3.5-6H6V6h5v5zm5.5 6c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-6h-5V6h5v5z'
    }));
  };

  var DirectionsTransitIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  DirectionsTransitIcon.displayName = 'DirectionsTransitIcon';
  DirectionsTransitIcon.defaultProps = {
    size: 24
  };
  exports.default = DirectionsTransitIcon;
});
unwrapExports(DirectionsTransit);
var DirectionsWalk = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M13.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM9.8 8.9L7 23h2.1l1.8-8 2.1 2v6h2v-7.5l-2.1-2 .6-3C14.8 12 16.8 13 19 13v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6c-.4-.6-1-1-1.7-1-.3 0-.5.1-.8.1L6 8.3V13h2V9.6l1.8-.7'
    }));
  };

  var DirectionsWalkIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  DirectionsWalkIcon.displayName = 'DirectionsWalkIcon';
  DirectionsWalkIcon.defaultProps = {
    size: 24
  };
  exports.default = DirectionsWalkIcon;
});
unwrapExports(DirectionsWalk);
var DiscFull = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 16h2v-2h-2v2zm0-9v5h2V7h-2zM10 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 10c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z'
    }));
  };

  var DiscFullIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  DiscFullIcon.displayName = 'DiscFullIcon';
  DiscFullIcon.defaultProps = {
    size: 24
  };
  exports.default = DiscFullIcon;
});
unwrapExports(DiscFull);
var Dns = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 13H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1zM7 19c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM20 3H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1zM7 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z'
    }));
  };

  var DnsIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  DnsIcon.displayName = 'DnsIcon';
  DnsIcon.defaultProps = {
    size: 24
  };
  exports.default = DnsIcon;
});
unwrapExports(Dns);
var DoNotDisturb = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31C15.55 19.37 13.85 20 12 20zm6.31-3.1L7.1 5.69C8.45 4.63 10.15 4 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z'
    }));
  };

  var DoNotDisturbIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  DoNotDisturbIcon.displayName = 'DoNotDisturbIcon';
  DoNotDisturbIcon.defaultProps = {
    size: 24
  };
  exports.default = DoNotDisturbIcon;
});
unwrapExports(DoNotDisturb);
var DoNotDisturbAlt = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zM4 12c0-4.4 3.6-8 8-8 1.8 0 3.5.6 4.9 1.7L5.7 16.9C4.6 15.5 4 13.8 4 12zm8 8c-1.8 0-3.5-.6-4.9-1.7L18.3 7.1C19.4 8.5 20 10.2 20 12c0 4.4-3.6 8-8 8z'
    }));
  };

  var DoNotDisturbAltIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  DoNotDisturbAltIcon.displayName = 'DoNotDisturbAltIcon';
  DoNotDisturbAltIcon.defaultProps = {
    size: 24
  };
  exports.default = DoNotDisturbAltIcon;
});
unwrapExports(DoNotDisturbAlt);
var DoNotDisturbOff = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M17 11v2h-1.46l4.68 4.68C21.34 16.07 22 14.11 22 12c0-5.52-4.48-10-10-10-2.11 0-4.07.66-5.68 1.78L13.54 11H17zM2.27 2.27L1 3.54l2.78 2.78C2.66 7.93 2 9.89 2 12c0 5.52 4.48 10 10 10 2.11 0 4.07-.66 5.68-1.78L20.46 23l1.27-1.27L11 11 2.27 2.27zM7 13v-2h1.46l2 2H7z'
    }));
  };

  var DoNotDisturbOffIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  DoNotDisturbOffIcon.displayName = 'DoNotDisturbOffIcon';
  DoNotDisturbOffIcon.defaultProps = {
    size: 24
  };
  exports.default = DoNotDisturbOffIcon;
});
unwrapExports(DoNotDisturbOff);
var DoNotDisturbOn = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z'
    }));
  };

  var DoNotDisturbOnIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  DoNotDisturbOnIcon.displayName = 'DoNotDisturbOnIcon';
  DoNotDisturbOnIcon.defaultProps = {
    size: 24
  };
  exports.default = DoNotDisturbOnIcon;
});
unwrapExports(DoNotDisturbOn);
var Dock = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M8 23h8v-2H8v2zm8-21.99L8 1c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM16 15H8V5h8v10z'
    }));
  };

  var DockIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  DockIcon.displayName = 'DockIcon';
  DockIcon.defaultProps = {
    size: 24
  };
  exports.default = DockIcon;
});
unwrapExports(Dock);
var Domain = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z'
    }));
  };

  var DomainIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  DomainIcon.displayName = 'DomainIcon';
  DomainIcon.defaultProps = {
    size: 24
  };
  exports.default = DomainIcon;
});
unwrapExports(Domain);
var Done = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z'
    }));
  };

  var DoneIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  DoneIcon.displayName = 'DoneIcon';
  DoneIcon.defaultProps = {
    size: 24
  };
  exports.default = DoneIcon;
});
unwrapExports(Done);
var DoneAll = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M18 7l-1.41-1.41-6.34 6.34 1.41 1.41L18 7zm4.24-1.41L11.66 16.17 7.48 12l-1.41 1.41L11.66 19l12-12-1.42-1.41zM.41 13.41L6 19l1.41-1.41L1.83 12 .41 13.41z'
    }));
  };

  var DoneAllIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  DoneAllIcon.displayName = 'DoneAllIcon';
  DoneAllIcon.defaultProps = {
    size: 24
  };
  exports.default = DoneAllIcon;
});
unwrapExports(DoneAll);
var DonutLarge = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M11 5.08V2c-5 .5-9 4.81-9 10s4 9.5 9 10v-3.08c-3-.48-6-3.4-6-6.92s3-6.44 6-6.92zM18.97 11H22c-.47-5-4-8.53-9-9v3.08C16 5.51 18.54 8 18.97 11zM13 18.92V22c5-.47 8.53-4 9-9h-3.03c-.43 3-2.97 5.49-5.97 5.92z'
    }));
  };

  var DonutLargeIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  DonutLargeIcon.displayName = 'DonutLargeIcon';
  DonutLargeIcon.defaultProps = {
    size: 24
  };
  exports.default = DonutLargeIcon;
});
unwrapExports(DonutLarge);
var DonutSmall = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M11 9.16V2c-5 .5-9 4.79-9 10s4 9.5 9 10v-7.16c-1-.41-2-1.52-2-2.84s1-2.43 2-2.84zM14.86 11H22c-.48-4.75-4-8.53-9-9v7.16c1 .3 1.52.98 1.86 1.84zM13 14.84V22c5-.47 8.52-4.25 9-9h-7.14c-.34.86-.86 1.54-1.86 1.84z'
    }));
  };

  var DonutSmallIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  DonutSmallIcon.displayName = 'DonutSmallIcon';
  DonutSmallIcon.defaultProps = {
    size: 24
  };
  exports.default = DonutSmallIcon;
});
unwrapExports(DonutSmall);
var Drafts = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21.99 8c0-.72-.37-1.35-.94-1.7L12 1 2.95 6.3C2.38 6.65 2 7.28 2 8v10c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2l-.01-10zM12 13L3.74 7.84 12 3l8.26 4.84L12 13z'
    }));
  };

  var DraftsIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  DraftsIcon.displayName = 'DraftsIcon';
  DraftsIcon.defaultProps = {
    size: 24
  };
  exports.default = DraftsIcon;
});
unwrapExports(Drafts);
var DragHandle = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 9H4v2h16V9zM4 15h16v-2H4v2z'
    }));
  };

  var DragHandleIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  DragHandleIcon.displayName = 'DragHandleIcon';
  DragHandleIcon.defaultProps = {
    size: 24
  };
  exports.default = DragHandleIcon;
});
unwrapExports(DragHandle);
var DriveEta = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M18.92 5.01C18.72 4.42 18.16 4 17.5 4h-11c-.66 0-1.21.42-1.42 1.01L3 11v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 15c-.83 0-1.5-.67-1.5-1.5S5.67 12 6.5 12s1.5.67 1.5 1.5S7.33 15 6.5 15zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 10l1.5-4.5h11L19 10H5z'
    }));
  };

  var DriveEtaIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  DriveEtaIcon.displayName = 'DriveEtaIcon';
  DriveEtaIcon.defaultProps = {
    size: 24
  };
  exports.default = DriveEtaIcon;
});
unwrapExports(DriveEta);
var Dvr = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.1-.9-2-2-2zm0 14H3V5h18v12zm-2-9H8v2h11V8zm0 4H8v2h11v-2zM7 8H5v2h2V8zm0 4H5v2h2v-2z'
    }));
  };

  var DvrIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  DvrIcon.displayName = 'DvrIcon';
  DvrIcon.defaultProps = {
    size: 24
  };
  exports.default = DvrIcon;
});
unwrapExports(Dvr);
var Edit = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z'
    }));
  };

  var EditIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  EditIcon.displayName = 'EditIcon';
  EditIcon.defaultProps = {
    size: 24
  };
  exports.default = EditIcon;
});
unwrapExports(Edit);
var EditLocation = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7zm-1.56 10H9v-1.44l3.35-3.34 1.43 1.43L10.44 12zm4.45-4.45l-.7.7-1.44-1.44.7-.7c.15-.15.39-.15.54 0l.9.9c.15.15.15.39 0 .54z'
    }));
  };

  var EditLocationIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  EditLocationIcon.displayName = 'EditLocationIcon';
  EditLocationIcon.defaultProps = {
    size: 24
  };
  exports.default = EditLocationIcon;
});
unwrapExports(EditLocation);
var Eject = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M5 17h14v2H5zm7-12L5.33 15h13.34z'
    }));
  };

  var EjectIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  EjectIcon.displayName = 'EjectIcon';
  EjectIcon.defaultProps = {
    size: 24
  };
  exports.default = EjectIcon;
});
unwrapExports(Eject);
var Email = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z'
    }));
  };

  var EmailIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  EmailIcon.displayName = 'EmailIcon';
  EmailIcon.defaultProps = {
    size: 24
  };
  exports.default = EmailIcon;
});
unwrapExports(Email);
var EnhancedEncryption = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2H8.9V6zM16 16h-3v3h-2v-3H8v-2h3v-3h2v3h3v2z'
    }));
  };

  var EnhancedEncryptionIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  EnhancedEncryptionIcon.displayName = 'EnhancedEncryptionIcon';
  EnhancedEncryptionIcon.defaultProps = {
    size: 24
  };
  exports.default = EnhancedEncryptionIcon;
});
unwrapExports(EnhancedEncryption);
var Equalizer = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M10 20h4V4h-4v16zm-6 0h4v-8H4v8zM16 9v11h4V9h-4z'
    }));
  };

  var EqualizerIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  EqualizerIcon.displayName = 'EqualizerIcon';
  EqualizerIcon.defaultProps = {
    size: 24
  };
  exports.default = EqualizerIcon;
});
unwrapExports(Equalizer);

var _Error = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z'
    }));
  };

  var ErrorIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ErrorIcon.displayName = 'ErrorIcon';
  ErrorIcon.defaultProps = {
    size: 24
  };
  exports.default = ErrorIcon;
});

unwrapExports(_Error);
var ErrorOutline = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z'
    }));
  };

  var ErrorOutlineIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ErrorOutlineIcon.displayName = 'ErrorOutlineIcon';
  ErrorOutlineIcon.defaultProps = {
    size: 24
  };
  exports.default = ErrorOutlineIcon;
});
unwrapExports(ErrorOutline);
var EuroSymbol = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M15 18.5c-2.51 0-4.68-1.42-5.76-3.5H15v-2H8.58c-.05-.33-.08-.66-.08-1s.03-.67.08-1H15V9H9.24C10.32 6.92 12.5 5.5 15 5.5c1.61 0 3.09.59 4.23 1.57L21 5.3C19.41 3.87 17.3 3 15 3c-3.92 0-7.24 2.51-8.48 6H3v2h3.06c-.04.33-.06.66-.06 1 0 .34.02.67.06 1H3v2h3.52c1.24 3.49 4.56 6 8.48 6 2.31 0 4.41-.87 6-2.3l-1.78-1.77c-1.13.98-2.6 1.57-4.22 1.57z'
    }));
  };

  var EuroSymbolIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  EuroSymbolIcon.displayName = 'EuroSymbolIcon';
  EuroSymbolIcon.defaultProps = {
    size: 24
  };
  exports.default = EuroSymbolIcon;
});
unwrapExports(EuroSymbol);
var EvStation = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19.77 7.23l.01-.01-3.72-3.72L15 4.56l2.11 2.11c-.94.36-1.61 1.26-1.61 2.33 0 1.38 1.12 2.5 2.5 2.5.36 0 .69-.08 1-.21v7.21c0 .55-.45 1-1 1s-1-.45-1-1V14c0-1.1-.9-2-2-2h-1V5c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v16h10v-7.5h1.5v5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V9c0-.69-.28-1.32-.73-1.77zM18 10c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM8 18v-4.5H6L10 6v5h2l-4 7z'
    }));
  };

  var EvStationIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  EvStationIcon.displayName = 'EvStationIcon';
  EvStationIcon.defaultProps = {
    size: 24
  };
  exports.default = EvStationIcon;
});
unwrapExports(EvStation);
var Event = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z'
    }));
  };

  var EventIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  EventIcon.displayName = 'EventIcon';
  EventIcon.defaultProps = {
    size: 24
  };
  exports.default = EventIcon;
});
unwrapExports(Event);
var EventAvailable = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M16.53 11.06L15.47 10l-4.88 4.88-2.12-2.12-1.06 1.06L10.59 17l5.94-5.94zM19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11z'
    }));
  };

  var EventAvailableIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  EventAvailableIcon.displayName = 'EventAvailableIcon';
  EventAvailableIcon.defaultProps = {
    size: 24
  };
  exports.default = EventAvailableIcon;
});
unwrapExports(EventAvailable);
var EventBusy = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M9.31 17l2.44-2.44L14.19 17l1.06-1.06-2.44-2.44 2.44-2.44L14.19 10l-2.44 2.44L9.31 10l-1.06 1.06 2.44 2.44-2.44 2.44L9.31 17zM19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11z'
    }));
  };

  var EventBusyIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  EventBusyIcon.displayName = 'EventBusyIcon';
  EventBusyIcon.defaultProps = {
    size: 24
  };
  exports.default = EventBusyIcon;
});
unwrapExports(EventBusy);
var EventNote = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M17 10H7v2h10v-2zm2-7h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zm-5-5H7v2h7v-2z'
    }));
  };

  var EventNoteIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  EventNoteIcon.displayName = 'EventNoteIcon';
  EventNoteIcon.defaultProps = {
    size: 24
  };
  exports.default = EventNoteIcon;
});
unwrapExports(EventNote);
var EventSeat = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M4 18v3h3v-3h10v3h3v-6H4zm15-8h3v3h-3zM2 10h3v3H2zm15 3H7V5c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2v8z'
    }));
  };

  var EventSeatIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  EventSeatIcon.displayName = 'EventSeatIcon';
  EventSeatIcon.defaultProps = {
    size: 24
  };
  exports.default = EventSeatIcon;
});
unwrapExports(EventSeat);
var ExitToApp = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z'
    }));
  };

  var ExitToAppIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ExitToAppIcon.displayName = 'ExitToAppIcon';
  ExitToAppIcon.defaultProps = {
    size: 24
  };
  exports.default = ExitToAppIcon;
});
unwrapExports(ExitToApp);
var ExpandLess = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z'
    }));
  };

  var ExpandLessIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ExpandLessIcon.displayName = 'ExpandLessIcon';
  ExpandLessIcon.defaultProps = {
    size: 24
  };
  exports.default = ExpandLessIcon;
});
unwrapExports(ExpandLess);
var ExpandMore = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z'
    }));
  };

  var ExpandMoreIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ExpandMoreIcon.displayName = 'ExpandMoreIcon';
  ExpandMoreIcon.defaultProps = {
    size: 24
  };
  exports.default = ExpandMoreIcon;
});
var ExpandMore$1 = unwrapExports(ExpandMore);
var Explicit = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 6h-4v2h4v2h-4v2h4v2H9V7h6v2z'
    }));
  };

  var ExplicitIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ExplicitIcon.displayName = 'ExplicitIcon';
  ExplicitIcon.defaultProps = {
    size: 24
  };
  exports.default = ExplicitIcon;
});
unwrapExports(Explicit);
var Explore = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 10.9c-.61 0-1.1.49-1.1 1.1s.49 1.1 1.1 1.1c.61 0 1.1-.49 1.1-1.1s-.49-1.1-1.1-1.1zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm2.19 12.19L6 18l3.81-8.19L18 6l-3.81 8.19z'
    }));
  };

  var ExploreIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ExploreIcon.displayName = 'ExploreIcon';
  ExploreIcon.defaultProps = {
    size: 24
  };
  exports.default = ExploreIcon;
});
unwrapExports(Explore);
var Exposure = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M15 17v2h2v-2h2v-2h-2v-2h-2v2h-2v2h2zm5-15H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM5 5h6v2H5V5zm15 15H4L20 4v16z'
    }));
  };

  var ExposureIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ExposureIcon.displayName = 'ExposureIcon';
  ExposureIcon.defaultProps = {
    size: 24
  };
  exports.default = ExposureIcon;
});
unwrapExports(Exposure);
var ExposureNeg1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M4 11v2h8v-2H4zm15 7h-2V7.38L14 8.4V6.7L18.7 5h.3v13z'
    }));
  };

  var ExposureNeg1Icon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ExposureNeg1Icon.displayName = 'ExposureNeg1Icon';
  ExposureNeg1Icon.defaultProps = {
    size: 24
  };
  exports.default = ExposureNeg1Icon;
});
unwrapExports(ExposureNeg1);
var ExposureNeg2 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M15.05 16.29l2.86-3.07c.38-.39.72-.79 1.04-1.18.32-.39.59-.78.82-1.17.23-.39.41-.78.54-1.17s.19-.79.19-1.18c0-.53-.09-1.02-.27-1.46-.18-.44-.44-.81-.78-1.11-.34-.31-.77-.54-1.26-.71-.51-.16-1.08-.24-1.72-.24-.69 0-1.31.11-1.85.32-.54.21-1 .51-1.36.88-.37.37-.65.8-.84 1.3-.18.47-.27.97-.28 1.5h2.14c.01-.31.05-.6.13-.87.09-.29.23-.54.4-.75.18-.21.41-.37.68-.49.27-.12.6-.18.96-.18.31 0 .58.05.81.15.23.1.43.25.59.43.16.18.28.4.37.65.08.25.13.52.13.81 0 .22-.03.43-.08.65-.06.22-.15.45-.29.7-.14.25-.32.53-.56.83-.23.3-.52.65-.88 1.03l-4.17 4.55V18H21v-1.71h-5.95zM2 11v2h8v-2H2z'
    }));
  };

  var ExposureNeg2Icon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ExposureNeg2Icon.displayName = 'ExposureNeg2Icon';
  ExposureNeg2Icon.defaultProps = {
    size: 24
  };
  exports.default = ExposureNeg2Icon;
});
unwrapExports(ExposureNeg2);
var ExposurePlus1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M10 7H8v4H4v2h4v4h2v-4h4v-2h-4V7zm10 11h-2V7.38L15 8.4V6.7L19.7 5h.3v13z'
    }));
  };

  var ExposurePlus1Icon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ExposurePlus1Icon.displayName = 'ExposurePlus1Icon';
  ExposurePlus1Icon.defaultProps = {
    size: 24
  };
  exports.default = ExposurePlus1Icon;
});
unwrapExports(ExposurePlus1);
var ExposurePlus2 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M16.05 16.29l2.86-3.07c.38-.39.72-.79 1.04-1.18.32-.39.59-.78.82-1.17.23-.39.41-.78.54-1.17.13-.39.19-.79.19-1.18 0-.53-.09-1.02-.27-1.46-.18-.44-.44-.81-.78-1.11-.34-.31-.77-.54-1.26-.71-.51-.16-1.08-.24-1.72-.24-.69 0-1.31.11-1.85.32-.54.21-1 .51-1.36.88-.37.37-.65.8-.84 1.3-.18.47-.27.97-.28 1.5h2.14c.01-.31.05-.6.13-.87.09-.29.23-.54.4-.75.18-.21.41-.37.68-.49.27-.12.6-.18.96-.18.31 0 .58.05.81.15.23.1.43.25.59.43.16.18.28.4.37.65.08.25.13.52.13.81 0 .22-.03.43-.08.65-.06.22-.15.45-.29.7-.14.25-.32.53-.56.83-.23.3-.52.65-.88 1.03l-4.17 4.55V18H22v-1.71h-5.95zM8 7H6v4H2v2h4v4h2v-4h4v-2H8V7z'
    }));
  };

  var ExposurePlus2Icon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ExposurePlus2Icon.displayName = 'ExposurePlus2Icon';
  ExposurePlus2Icon.defaultProps = {
    size: 24
  };
  exports.default = ExposurePlus2Icon;
});
unwrapExports(ExposurePlus2);
var ExposureZero = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M16.14 12.5c0 1-.1 1.85-.3 2.55-.2.7-.48 1.27-.83 1.7-.36.44-.79.75-1.3.95-.51.2-1.07.3-1.7.3-.62 0-1.18-.1-1.69-.3-.51-.2-.95-.51-1.31-.95-.36-.44-.65-1.01-.85-1.7-.2-.7-.3-1.55-.3-2.55v-2.04c0-1 .1-1.85.3-2.55.2-.7.48-1.26.84-1.69.36-.43.8-.74 1.31-.93C10.81 5.1 11.38 5 12 5c.63 0 1.19.1 1.7.29.51.19.95.5 1.31.93.36.43.64.99.84 1.69.2.7.3 1.54.3 2.55v2.04zm-2.11-2.36c0-.64-.05-1.18-.13-1.62-.09-.44-.22-.79-.4-1.06-.17-.27-.39-.46-.64-.58-.25-.13-.54-.19-.86-.19-.32 0-.61.06-.86.18s-.47.31-.64.58c-.17.27-.31.62-.4 1.06s-.13.98-.13 1.62v2.67c0 .64.05 1.18.14 1.62.09.45.23.81.4 1.09s.39.48.64.61.54.19.87.19c.33 0 .62-.06.87-.19s.46-.33.63-.61c.17-.28.3-.64.39-1.09.09-.45.13-.99.13-1.62v-2.66z'
    }));
  };

  var ExposureZeroIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ExposureZeroIcon.displayName = 'ExposureZeroIcon';
  ExposureZeroIcon.defaultProps = {
    size: 24
  };
  exports.default = ExposureZeroIcon;
});
unwrapExports(ExposureZero);
var Extension = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20.5 11H19V7c0-1.1-.9-2-2-2h-4V3.5C13 2.12 11.88 1 10.5 1S8 2.12 8 3.5V5H4c-1.1 0-1.99.9-1.99 2v3.8H3.5c1.49 0 2.7 1.21 2.7 2.7s-1.21 2.7-2.7 2.7H2V20c0 1.1.9 2 2 2h3.8v-1.5c0-1.49 1.21-2.7 2.7-2.7 1.49 0 2.7 1.21 2.7 2.7V22H17c1.1 0 2-.9 2-2v-4h1.5c1.38 0 2.5-1.12 2.5-2.5S21.88 11 20.5 11z'
    }));
  };

  var ExtensionIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ExtensionIcon.displayName = 'ExtensionIcon';
  ExtensionIcon.defaultProps = {
    size: 24
  };
  exports.default = ExtensionIcon;
});
unwrapExports(Extension);
var Face = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M9 11.75c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zm6 0c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8 0-.29.02-.58.05-.86 2.36-1.05 4.23-2.98 5.21-5.37C11.07 8.33 14.05 10 17.42 10c.78 0 1.53-.09 2.25-.26.21.71.33 1.47.33 2.26 0 4.41-3.59 8-8 8z'
    }));
  };

  var FaceIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FaceIcon.displayName = 'FaceIcon';
  FaceIcon.defaultProps = {
    size: 24
  };
  exports.default = FaceIcon;
});
unwrapExports(Face);
var FastForward = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M4 18l8.5-6L4 6v12zm9-12v12l8.5-6L13 6z'
    }));
  };

  var FastForwardIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FastForwardIcon.displayName = 'FastForwardIcon';
  FastForwardIcon.defaultProps = {
    size: 24
  };
  exports.default = FastForwardIcon;
});
unwrapExports(FastForward);
var FastRewind = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M11 18V6l-8.5 6 8.5 6zm.5-6l8.5 6V6l-8.5 6z'
    }));
  };

  var FastRewindIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FastRewindIcon.displayName = 'FastRewindIcon';
  FastRewindIcon.defaultProps = {
    size: 24
  };
  exports.default = FastRewindIcon;
});
unwrapExports(FastRewind);
var Favorite = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z'
    }));
  };

  var FavoriteIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FavoriteIcon.displayName = 'FavoriteIcon';
  FavoriteIcon.defaultProps = {
    size: 24
  };
  exports.default = FavoriteIcon;
});
unwrapExports(Favorite);
var FavoriteBorder = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z'
    }));
  };

  var FavoriteBorderIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FavoriteBorderIcon.displayName = 'FavoriteBorderIcon';
  FavoriteBorderIcon.defaultProps = {
    size: 24
  };
  exports.default = FavoriteBorderIcon;
});
unwrapExports(FavoriteBorder);
var FeaturedPlayList = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 8H3V9h9v2zm0-4H3V5h9v2z'
    }));
  };

  var FeaturedPlayListIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FeaturedPlayListIcon.displayName = 'FeaturedPlayListIcon';
  FeaturedPlayListIcon.defaultProps = {
    size: 24
  };
  exports.default = FeaturedPlayListIcon;
});
unwrapExports(FeaturedPlayList);
var FeaturedVideo = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 9H3V5h9v7z'
    }));
  };

  var FeaturedVideoIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FeaturedVideoIcon.displayName = 'FeaturedVideoIcon';
  FeaturedVideoIcon.defaultProps = {
    size: 24
  };
  exports.default = FeaturedVideoIcon;
});
unwrapExports(FeaturedVideo);
var Feedback = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 12h-2v-2h2v2zm0-4h-2V6h2v4z'
    }));
  };

  var FeedbackIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FeedbackIcon.displayName = 'FeedbackIcon';
  FeedbackIcon.defaultProps = {
    size: 24
  };
  exports.default = FeedbackIcon;
});
unwrapExports(Feedback);
var FiberDvr = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M17.5 10.5h2v1h-2zm-13 0h2v3h-2zM21 3H3c-1.11 0-2 .89-2 2v14c0 1.1.89 2 2 2h18c1.11 0 2-.9 2-2V5c0-1.11-.89-2-2-2zM8 13.5c0 .85-.65 1.5-1.5 1.5H3V9h3.5c.85 0 1.5.65 1.5 1.5v3zm4.62 1.5h-1.5L9.37 9h1.5l1 3.43 1-3.43h1.5l-1.75 6zM21 11.5c0 .6-.4 1.15-.9 1.4L21 15h-1.5l-.85-2H17.5v2H16V9h3.5c.85 0 1.5.65 1.5 1.5v1z'
    }));
  };

  var FiberDvrIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FiberDvrIcon.displayName = 'FiberDvrIcon';
  FiberDvrIcon.defaultProps = {
    size: 24
  };
  exports.default = FiberDvrIcon;
});
unwrapExports(FiberDvr);
var FiberManualRecord = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M 12 4 A 8 8 0 0 0 12 20 A 8 8 0 0 0 12 4'
    }));
  };

  var FiberManualRecordIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FiberManualRecordIcon.displayName = 'FiberManualRecordIcon';
  FiberManualRecordIcon.defaultProps = {
    size: 24
  };
  exports.default = FiberManualRecordIcon;
});
unwrapExports(FiberManualRecord);
var FiberNew = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zM8.5 15H7.3l-2.55-3.5V15H3.5V9h1.25l2.5 3.5V9H8.5v6zm5-4.74H11v1.12h2.5v1.26H11v1.11h2.5V15h-4V9h4v1.26zm7 3.74c0 .55-.45 1-1 1h-4c-.55 0-1-.45-1-1V9h1.25v4.51h1.13V9.99h1.25v3.51h1.12V9h1.25v5z'
    }));
  };

  var FiberNewIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FiberNewIcon.displayName = 'FiberNewIcon';
  FiberNewIcon.defaultProps = {
    size: 24
  };
  exports.default = FiberNewIcon;
});
unwrapExports(FiberNew);
var FiberPin = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M5.5 10.5h2v1h-2zM20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zM9 11.5c0 .85-.65 1.5-1.5 1.5h-2v2H4V9h3.5c.85 0 1.5.65 1.5 1.5v1zm3.5 3.5H11V9h1.5v6zm7.5 0h-1.2l-2.55-3.5V15H15V9h1.25l2.5 3.5V9H20v6z'
    }));
  };

  var FiberPinIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FiberPinIcon.displayName = 'FiberPinIcon';
  FiberPinIcon.defaultProps = {
    size: 24
  };
  exports.default = FiberPinIcon;
});
unwrapExports(FiberPin);
var FiberSmartRecord = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M 9 4 A 8 8 0 0 1 9 20 A 8 8 0 0 1 9 4 M17 4.26v2.09c2.33.82 4 3.04 4 5.65s-1.67 4.83-4 5.65v2.09c3.45-.89 6-4.01 6-7.74s-2.55-6.85-6-7.74z'
    }));
  };

  var FiberSmartRecordIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FiberSmartRecordIcon.displayName = 'FiberSmartRecordIcon';
  FiberSmartRecordIcon.defaultProps = {
    size: 24
  };
  exports.default = FiberSmartRecordIcon;
});
unwrapExports(FiberSmartRecord);
var FileDownload = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z'
    }));
  };

  var FileDownloadIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FileDownloadIcon.displayName = 'FileDownloadIcon';
  FileDownloadIcon.defaultProps = {
    size: 24
  };
  exports.default = FileDownloadIcon;
});
unwrapExports(FileDownload);
var FileUpload = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z'
    }));
  };

  var FileUploadIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FileUploadIcon.displayName = 'FileUploadIcon';
  FileUploadIcon.defaultProps = {
    size: 24
  };
  exports.default = FileUploadIcon;
});
unwrapExports(FileUpload);
var Filter = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M15.96 10.29l-2.75 3.54-1.96-2.36L8.5 15h11l-3.54-4.71zM3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z'
    }));
  };

  var FilterIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FilterIcon.displayName = 'FilterIcon';
  FilterIcon.defaultProps = {
    size: 24
  };
  exports.default = FilterIcon;
});
unwrapExports(Filter);
var Filter1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm11 10h2V5h-4v2h2v8zm7-14H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z'
    }));
  };

  var Filter1Icon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  Filter1Icon.displayName = 'Filter1Icon';
  Filter1Icon.defaultProps = {
    size: 24
  };
  exports.default = Filter1Icon;
});
unwrapExports(Filter1);
var Filter2 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-4-4h-4v-2h2c1.1 0 2-.89 2-2V7c0-1.11-.9-2-2-2h-4v2h4v2h-2c-1.1 0-2 .89-2 2v4h6v-2z'
    }));
  };

  var Filter2Icon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  Filter2Icon.displayName = 'Filter2Icon';
  Filter2Icon.defaultProps = {
    size: 24
  };
  exports.default = Filter2Icon;
});
unwrapExports(Filter2);
var Filter3 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21 1H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm14 8v-1.5c0-.83-.67-1.5-1.5-1.5.83 0 1.5-.67 1.5-1.5V7c0-1.11-.9-2-2-2h-4v2h4v2h-2v2h2v2h-4v2h4c1.1 0 2-.89 2-2z'
    }));
  };

  var Filter3Icon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  Filter3Icon.displayName = 'Filter3Icon';
  Filter3Icon.defaultProps = {
    size: 24
  };
  exports.default = Filter3Icon;
});
unwrapExports(Filter3);
var Filter4 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm12 10h2V5h-2v4h-2V5h-2v6h4v4zm6-14H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z'
    }));
  };

  var Filter4Icon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  Filter4Icon.displayName = 'Filter4Icon';
  Filter4Icon.defaultProps = {
    size: 24
  };
  exports.default = Filter4Icon;
});
unwrapExports(Filter4);
var Filter5 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21 1H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm14 8v-2c0-1.11-.9-2-2-2h-2V7h4V5h-6v6h4v2h-4v2h4c1.1 0 2-.89 2-2z'
    }));
  };

  var Filter5Icon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  Filter5Icon.displayName = 'Filter5Icon';
  Filter5Icon.defaultProps = {
    size: 24
  };
  exports.default = Filter5Icon;
});
unwrapExports(Filter5);
var Filter6 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-8-2h2c1.1 0 2-.89 2-2v-2c0-1.11-.9-2-2-2h-2V7h4V5h-4c-1.1 0-2 .89-2 2v6c0 1.11.9 2 2 2zm0-4h2v2h-2v-2z'
    }));
  };

  var Filter6Icon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  Filter6Icon.displayName = 'Filter6Icon';
  Filter6Icon.defaultProps = {
    size: 24
  };
  exports.default = Filter6Icon;
});
unwrapExports(Filter6);
var Filter7 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-8-2l4-8V5h-6v2h4l-4 8h2z'
    }));
  };

  var Filter7Icon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  Filter7Icon.displayName = 'Filter7Icon';
  Filter7Icon.defaultProps = {
    size: 24
  };
  exports.default = Filter7Icon;
});
unwrapExports(Filter7);
var Filter8 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-8-2h2c1.1 0 2-.89 2-2v-1.5c0-.83-.67-1.5-1.5-1.5.83 0 1.5-.67 1.5-1.5V7c0-1.11-.9-2-2-2h-2c-1.1 0-2 .89-2 2v1.5c0 .83.67 1.5 1.5 1.5-.83 0-1.5.67-1.5 1.5V13c0 1.11.9 2 2 2zm0-8h2v2h-2V7zm0 4h2v2h-2v-2z'
    }));
  };

  var Filter8Icon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  Filter8Icon.displayName = 'Filter8Icon';
  Filter8Icon.defaultProps = {
    size: 24
  };
  exports.default = Filter8Icon;
});
unwrapExports(Filter8);
var Filter9 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM15 5h-2c-1.1 0-2 .89-2 2v2c0 1.11.9 2 2 2h2v2h-4v2h4c1.1 0 2-.89 2-2V7c0-1.11-.9-2-2-2zm0 4h-2V7h2v2z'
    }));
  };

  var Filter9Icon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  Filter9Icon.displayName = 'Filter9Icon';
  Filter9Icon.defaultProps = {
    size: 24
  };
  exports.default = Filter9Icon;
});
unwrapExports(Filter9);
var Filter9Plus = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm11 7V8c0-1.11-.9-2-2-2h-1c-1.1 0-2 .89-2 2v1c0 1.11.9 2 2 2h1v1H9v2h3c1.1 0 2-.89 2-2zm-3-3V8h1v1h-1zm10-8H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 8h-2V7h-2v2h-2v2h2v2h2v-2h2v6H7V3h14v6z'
    }));
  };

  var Filter9PlusIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  Filter9PlusIcon.displayName = 'Filter9PlusIcon';
  Filter9PlusIcon.defaultProps = {
    size: 24
  };
  exports.default = Filter9PlusIcon;
});
unwrapExports(Filter9Plus);
var FilterBAndW = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16l-7-8v8H5l7-8V5h7v14z'
    }));
  };

  var FilterBAndWIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FilterBAndWIcon.displayName = 'FilterBAndWIcon';
  FilterBAndWIcon.defaultProps = {
    size: 24
  };
  exports.default = FilterBAndWIcon;
});
unwrapExports(FilterBAndW);
var FilterCenterFocus = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M5 15H3v4c0 1.1.9 2 2 2h4v-2H5v-4zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm14-2h-4v2h4v4h2V5c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zM12 9c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z'
    }));
  };

  var FilterCenterFocusIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FilterCenterFocusIcon.displayName = 'FilterCenterFocusIcon';
  FilterCenterFocusIcon.defaultProps = {
    size: 24
  };
  exports.default = FilterCenterFocusIcon;
});
unwrapExports(FilterCenterFocus);
var FilterDrama = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.61 5.64 5.36 8.04 2.35 8.36 0 10.9 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4h2c0-2.76-1.86-5.08-4.4-5.78C8.61 6.88 10.2 6 12 6c3.03 0 5.5 2.47 5.5 5.5v.5H19c1.65 0 3 1.35 3 3s-1.35 3-3 3z'
    }));
  };

  var FilterDramaIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FilterDramaIcon.displayName = 'FilterDramaIcon';
  FilterDramaIcon.defaultProps = {
    size: 24
  };
  exports.default = FilterDramaIcon;
});
unwrapExports(FilterDrama);
var FilterFrames = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 4h-4l-4-4-4 4H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H4V6h4.52l3.52-3.5L15.52 6H20v14zM18 8H6v10h12'
    }));
  };

  var FilterFramesIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FilterFramesIcon.displayName = 'FilterFramesIcon';
  FilterFramesIcon.defaultProps = {
    size: 24
  };
  exports.default = FilterFramesIcon;
});
unwrapExports(FilterFrames);
var FilterHdr = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M14 6l-3.75 5 2.85 3.8-1.6 1.2C9.81 13.75 7 10 7 10l-6 8h22L14 6z'
    }));
  };

  var FilterHdrIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FilterHdrIcon.displayName = 'FilterHdrIcon';
  FilterHdrIcon.defaultProps = {
    size: 24
  };
  exports.default = FilterHdrIcon;
});
unwrapExports(FilterHdr);
var FilterList = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z'
    }));
  };

  var FilterListIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FilterListIcon.displayName = 'FilterListIcon';
  FilterListIcon.defaultProps = {
    size: 24
  };
  exports.default = FilterListIcon;
});
unwrapExports(FilterList);
var FilterNone = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z'
    }));
  };

  var FilterNoneIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FilterNoneIcon.displayName = 'FilterNoneIcon';
  FilterNoneIcon.defaultProps = {
    size: 24
  };
  exports.default = FilterNoneIcon;
});
unwrapExports(FilterNone);
var FilterTiltShift = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M11 4.07V2.05c-2.01.2-3.84 1-5.32 2.21L7.1 5.69c1.11-.86 2.44-1.44 3.9-1.62zm7.32.19C16.84 3.05 15.01 2.25 13 2.05v2.02c1.46.18 2.79.76 3.9 1.62l1.42-1.43zM19.93 11h2.02c-.2-2.01-1-3.84-2.21-5.32L18.31 7.1c.86 1.11 1.44 2.44 1.62 3.9zM5.69 7.1L4.26 5.68C3.05 7.16 2.25 8.99 2.05 11h2.02c.18-1.46.76-2.79 1.62-3.9zM4.07 13H2.05c.2 2.01 1 3.84 2.21 5.32l1.43-1.43c-.86-1.1-1.44-2.43-1.62-3.89zM15 12c0-1.66-1.34-3-3-3s-3 1.34-3 3 1.34 3 3 3 3-1.34 3-3zm3.31 4.9l1.43 1.43c1.21-1.48 2.01-3.32 2.21-5.32h-2.02c-.18 1.45-.76 2.78-1.62 3.89zM13 19.93v2.02c2.01-.2 3.84-1 5.32-2.21l-1.43-1.43c-1.1.86-2.43 1.44-3.89 1.62zm-7.32-.19C7.16 20.95 9 21.75 11 21.95v-2.02c-1.46-.18-2.79-.76-3.9-1.62l-1.42 1.43z'
    }));
  };

  var FilterTiltShiftIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FilterTiltShiftIcon.displayName = 'FilterTiltShiftIcon';
  FilterTiltShiftIcon.defaultProps = {
    size: 24
  };
  exports.default = FilterTiltShiftIcon;
});
unwrapExports(FilterTiltShift);
var FilterVintage = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M18.7 12.4c-.28-.16-.57-.29-.86-.4.29-.11.58-.24.86-.4 1.92-1.11 2.99-3.12 3-5.19-1.79-1.03-4.07-1.11-6 0-.28.16-.54.35-.78.54.05-.31.08-.63.08-.95 0-2.22-1.21-4.15-3-5.19C10.21 1.85 9 3.78 9 6c0 .32.03.64.08.95-.24-.2-.5-.39-.78-.55-1.92-1.11-4.2-1.03-6 0 0 2.07 1.07 4.08 3 5.19.28.16.57.29.86.4-.29.11-.58.24-.86.4-1.92 1.11-2.99 3.12-3 5.19 1.79 1.03 4.07 1.11 6 0 .28-.16.54-.35.78-.54-.05.32-.08.64-.08.96 0 2.22 1.21 4.15 3 5.19 1.79-1.04 3-2.97 3-5.19 0-.32-.03-.64-.08-.95.24.2.5.38.78.54 1.92 1.11 4.2 1.03 6 0-.01-2.07-1.08-4.08-3-5.19zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z'
    }));
  };

  var FilterVintageIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FilterVintageIcon.displayName = 'FilterVintageIcon';
  FilterVintageIcon.defaultProps = {
    size: 24
  };
  exports.default = FilterVintageIcon;
});
unwrapExports(FilterVintage);
var FindInPage = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 19.59V8l-6-6H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c.45 0 .85-.15 1.19-.4l-4.43-4.43c-.8.52-1.74.83-2.76.83-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5c0 1.02-.31 1.96-.83 2.75L20 19.59zM9 13c0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3-3 1.34-3 3z'
    }));
  };

  var FindInPageIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FindInPageIcon.displayName = 'FindInPageIcon';
  FindInPageIcon.defaultProps = {
    size: 24
  };
  exports.default = FindInPageIcon;
});
unwrapExports(FindInPage);
var FindReplace = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M11 6c1.38 0 2.63.56 3.54 1.46L12 10h6V4l-2.05 2.05C14.68 4.78 12.93 4 11 4c-3.53 0-6.43 2.61-6.92 6H6.1c.46-2.28 2.48-4 4.9-4zm5.64 9.14c.66-.9 1.12-1.97 1.28-3.14H15.9c-.46 2.28-2.48 4-4.9 4-1.38 0-2.63-.56-3.54-1.46L10 12H4v6l2.05-2.05C7.32 17.22 9.07 18 11 18c1.55 0 2.98-.51 4.14-1.36L20 21.49 21.49 20l-4.85-4.86z'
    }));
  };

  var FindReplaceIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FindReplaceIcon.displayName = 'FindReplaceIcon';
  FindReplaceIcon.defaultProps = {
    size: 24
  };
  exports.default = FindReplaceIcon;
});
unwrapExports(FindReplace);
var Fingerprint = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M17.81 4.47c-.08 0-.16-.02-.23-.06C15.66 3.42 14 3 12.01 3c-1.98 0-3.86.47-5.57 1.41-.24.13-.54.04-.68-.2-.13-.24-.04-.55.2-.68C7.82 2.52 9.86 2 12.01 2c2.13 0 3.99.47 6.03 1.52.25.13.34.43.21.67-.09.18-.26.28-.44.28zM3.5 9.72c-.1 0-.2-.03-.29-.09-.23-.16-.28-.47-.12-.7.99-1.4 2.25-2.5 3.75-3.27C9.98 4.04 14 4.03 17.15 5.65c1.5.77 2.76 1.86 3.75 3.25.16.22.11.54-.12.7-.23.16-.54.11-.7-.12-.9-1.26-2.04-2.25-3.39-2.94-2.87-1.47-6.54-1.47-9.4.01-1.36.7-2.5 1.7-3.4 2.96-.08.14-.23.21-.39.21zm6.25 12.07c-.13 0-.26-.05-.35-.15-.87-.87-1.34-1.43-2.01-2.64-.69-1.23-1.05-2.73-1.05-4.34 0-2.97 2.54-5.39 5.66-5.39s5.66 2.42 5.66 5.39c0 .28-.22.5-.5.5s-.5-.22-.5-.5c0-2.42-2.09-4.39-4.66-4.39-2.57 0-4.66 1.97-4.66 4.39 0 1.44.32 2.77.93 3.85.64 1.15 1.08 1.64 1.85 2.42.19.2.19.51 0 .71-.11.1-.24.15-.37.15zm7.17-1.85c-1.19 0-2.24-.3-3.1-.89-1.49-1.01-2.38-2.65-2.38-4.39 0-.28.22-.5.5-.5s.5.22.5.5c0 1.41.72 2.74 1.94 3.56.71.48 1.54.71 2.54.71.24 0 .64-.03 1.04-.1.27-.05.53.13.58.41.05.27-.13.53-.41.58-.57.11-1.07.12-1.21.12zM14.91 22c-.04 0-.09-.01-.13-.02-1.59-.44-2.63-1.03-3.72-2.1-1.4-1.39-2.17-3.24-2.17-5.22 0-1.62 1.38-2.94 3.08-2.94 1.7 0 3.08 1.32 3.08 2.94 0 1.07.93 1.94 2.08 1.94s2.08-.87 2.08-1.94c0-3.77-3.25-6.83-7.25-6.83-2.84 0-5.44 1.58-6.61 4.03-.39.81-.59 1.76-.59 2.8 0 .78.07 2.01.67 3.61.1.26-.03.55-.29.64-.26.1-.55-.04-.64-.29-.49-1.31-.73-2.61-.73-3.96 0-1.2.23-2.29.68-3.24 1.33-2.79 4.28-4.6 7.51-4.6 4.55 0 8.25 3.51 8.25 7.83 0 1.62-1.38 2.94-3.08 2.94s-3.08-1.32-3.08-2.94c0-1.07-.93-1.94-2.08-1.94s-2.08.87-2.08 1.94c0 1.71.66 3.31 1.87 4.51.95.94 1.86 1.46 3.27 1.85.27.07.42.35.35.61-.05.23-.26.38-.47.38z'
    }));
  };

  var FingerprintIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FingerprintIcon.displayName = 'FingerprintIcon';
  FingerprintIcon.defaultProps = {
    size: 24
  };
  exports.default = FingerprintIcon;
});
unwrapExports(Fingerprint);
var FirstPage = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z'
    }));
  };

  var FirstPageIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FirstPageIcon.displayName = 'FirstPageIcon';
  FirstPageIcon.defaultProps = {
    size: 24
  };
  exports.default = FirstPageIcon;
});
unwrapExports(FirstPage);
var FitnessCenter = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20.57 14.86L22 13.43 20.57 12 17 15.57 8.43 7 12 3.43 10.57 2 9.14 3.43 7.71 2 5.57 4.14 4.14 2.71 2.71 4.14l1.43 1.43L2 7.71l1.43 1.43L2 10.57 3.43 12 7 8.43 15.57 17 12 20.57 13.43 22l1.43-1.43L16.29 22l2.14-2.14 1.43 1.43 1.43-1.43-1.43-1.43L22 16.29z'
    }));
  };

  var FitnessCenterIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FitnessCenterIcon.displayName = 'FitnessCenterIcon';
  FitnessCenterIcon.defaultProps = {
    size: 24
  };
  exports.default = FitnessCenterIcon;
});
unwrapExports(FitnessCenter);
var Flag = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z'
    }));
  };

  var FlagIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FlagIcon.displayName = 'FlagIcon';
  FlagIcon.defaultProps = {
    size: 24
  };
  exports.default = FlagIcon;
});
unwrapExports(Flag);
var Flare = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M7 11H1v2h6v-2zm2.17-3.24L7.05 5.64 5.64 7.05l2.12 2.12 1.41-1.41zM13 1h-2v6h2V1zm5.36 6.05l-1.41-1.41-2.12 2.12 1.41 1.41 2.12-2.12zM17 11v2h6v-2h-6zm-5-2c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm2.83 7.24l2.12 2.12 1.41-1.41-2.12-2.12-1.41 1.41zm-9.19.71l1.41 1.41 2.12-2.12-1.41-1.41-2.12 2.12zM11 23h2v-6h-2v6z'
    }));
  };

  var FlareIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FlareIcon.displayName = 'FlareIcon';
  FlareIcon.defaultProps = {
    size: 24
  };
  exports.default = FlareIcon;
});
unwrapExports(Flare);
var FlashAuto = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M3 2v12h3v9l7-12H9l4-9H3zm16 0h-2l-3.2 9h1.9l.7-2h3.2l.7 2h1.9L19 2zm-2.15 5.65L18 4l1.15 3.65h-2.3z'
    }));
  };

  var FlashAutoIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FlashAutoIcon.displayName = 'FlashAutoIcon';
  FlashAutoIcon.defaultProps = {
    size: 24
  };
  exports.default = FlashAutoIcon;
});
unwrapExports(FlashAuto);
var FlashOff = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M3.27 3L2 4.27l5 5V13h3v9l3.58-6.14L17.73 20 19 18.73 3.27 3zM17 10h-4l4-8H7v2.18l8.46 8.46L17 10z'
    }));
  };

  var FlashOffIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FlashOffIcon.displayName = 'FlashOffIcon';
  FlashOffIcon.defaultProps = {
    size: 24
  };
  exports.default = FlashOffIcon;
});
unwrapExports(FlashOff);
var FlashOn = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M7 2v11h3v9l7-12h-4l4-8z'
    }));
  };

  var FlashOnIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FlashOnIcon.displayName = 'FlashOnIcon';
  FlashOnIcon.defaultProps = {
    size: 24
  };
  exports.default = FlashOnIcon;
});
unwrapExports(FlashOn);
var Flight = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M10.18 9 M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z'
    }));
  };

  var FlightIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FlightIcon.displayName = 'FlightIcon';
  FlightIcon.defaultProps = {
    size: 24
  };
  exports.default = FlightIcon;
});
unwrapExports(Flight);
var FlightLand = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M2.5 19h19v2h-19zm7.18-5.73l4.35 1.16 5.31 1.42c.8.21 1.62-.26 1.84-1.06.21-.8-.26-1.62-1.06-1.84l-5.31-1.42-2.76-9.02L10.12 2v8.28L5.15 8.95l-.93-2.32-1.45-.39v5.17l1.6.43 5.31 1.43z'
    }));
  };

  var FlightLandIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FlightLandIcon.displayName = 'FlightLandIcon';
  FlightLandIcon.defaultProps = {
    size: 24
  };
  exports.default = FlightLandIcon;
});
unwrapExports(FlightLand);
var FlightTakeoff = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M2.5 19h19v2h-19zm19.57-9.36c-.21-.8-1.04-1.28-1.84-1.06L14.92 10l-6.9-6.43-1.93.51 4.14 7.17-4.97 1.33-1.97-1.54-1.45.39 1.82 3.16.77 1.33 1.6-.43 5.31-1.42 4.35-1.16L21 11.49c.81-.23 1.28-1.05 1.07-1.85z'
    }));
  };

  var FlightTakeoffIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FlightTakeoffIcon.displayName = 'FlightTakeoffIcon';
  FlightTakeoffIcon.defaultProps = {
    size: 24
  };
  exports.default = FlightTakeoffIcon;
});
unwrapExports(FlightTakeoff);
var Flip = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M15 21h2v-2h-2v2zm4-12h2V7h-2v2zM3 5v14c0 1.1.9 2 2 2h4v-2H5V5h4V3H5c-1.1 0-2 .9-2 2zm16-2v2h2c0-1.1-.9-2-2-2zm-8 20h2V1h-2v22zm8-6h2v-2h-2v2zM15 5h2V3h-2v2zm4 8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2z'
    }));
  };

  var FlipIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FlipIcon.displayName = 'FlipIcon';
  FlipIcon.defaultProps = {
    size: 24
  };
  exports.default = FlipIcon;
});
unwrapExports(Flip);
var FlipToBack = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M9 7H7v2h2V7zm0 4H7v2h2v-2zm0-8c-1.11 0-2 .9-2 2h2V3zm4 12h-2v2h2v-2zm6-12v2h2c0-1.1-.9-2-2-2zm-6 0h-2v2h2V3zM9 17v-2H7c0 1.1.89 2 2 2zm10-4h2v-2h-2v2zm0-4h2V7h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zM5 7H3v12c0 1.1.89 2 2 2h12v-2H5V7zm10-2h2V3h-2v2zm0 12h2v-2h-2v2z'
    }));
  };

  var FlipToBackIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FlipToBackIcon.displayName = 'FlipToBackIcon';
  FlipToBackIcon.defaultProps = {
    size: 24
  };
  exports.default = FlipToBackIcon;
});
unwrapExports(FlipToBack);
var FlipToFront = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M3 13h2v-2H3v2zm0 4h2v-2H3v2zm2 4v-2H3c0 1.1.89 2 2 2zM3 9h2V7H3v2zm12 12h2v-2h-2v2zm4-18H9c-1.11 0-2 .9-2 2v10c0 1.1.89 2 2 2h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 12H9V5h10v10zm-8 6h2v-2h-2v2zm-4 0h2v-2H7v2z'
    }));
  };

  var FlipToFrontIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FlipToFrontIcon.displayName = 'FlipToFrontIcon';
  FlipToFrontIcon.defaultProps = {
    size: 24
  };
  exports.default = FlipToFrontIcon;
});
unwrapExports(FlipToFront);
var Folder = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z'
    }));
  };

  var FolderIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FolderIcon.displayName = 'FolderIcon';
  FolderIcon.defaultProps = {
    size: 24
  };
  exports.default = FolderIcon;
});
unwrapExports(Folder);
var FolderOpen = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V8h16v10z'
    }));
  };

  var FolderOpenIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FolderOpenIcon.displayName = 'FolderOpenIcon';
  FolderOpenIcon.defaultProps = {
    size: 24
  };
  exports.default = FolderOpenIcon;
});
unwrapExports(FolderOpen);
var FolderShared = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-5 3c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm4 8h-8v-1c0-1.33 2.67-2 4-2s4 .67 4 2v1z'
    }));
  };

  var FolderSharedIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FolderSharedIcon.displayName = 'FolderSharedIcon';
  FolderSharedIcon.defaultProps = {
    size: 24
  };
  exports.default = FolderSharedIcon;
});
unwrapExports(FolderShared);
var FolderSpecial = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-2.06 11L15 15.28 12.06 17l.78-3.33-2.59-2.24 3.41-.29L15 8l1.34 3.14 3.41.29-2.59 2.24.78 3.33z'
    }));
  };

  var FolderSpecialIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FolderSpecialIcon.displayName = 'FolderSpecialIcon';
  FolderSpecialIcon.defaultProps = {
    size: 24
  };
  exports.default = FolderSpecialIcon;
});
unwrapExports(FolderSpecial);
var FontDownload = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M9.93 13.5h4.14L12 7.98zM20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-4.05 16.5l-1.14-3H9.17l-1.12 3H5.96l5.11-13h1.86l5.11 13h-2.09z'
    }));
  };

  var FontDownloadIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FontDownloadIcon.displayName = 'FontDownloadIcon';
  FontDownloadIcon.defaultProps = {
    size: 24
  };
  exports.default = FontDownloadIcon;
});
unwrapExports(FontDownload);
var FormatAlignCenter = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M7 15v2h10v-2H7zm-4 6h18v-2H3v2zm0-8h18v-2H3v2zm4-6v2h10V7H7zM3 3v2h18V3H3z'
    }));
  };

  var FormatAlignCenterIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FormatAlignCenterIcon.displayName = 'FormatAlignCenterIcon';
  FormatAlignCenterIcon.defaultProps = {
    size: 24
  };
  exports.default = FormatAlignCenterIcon;
});
unwrapExports(FormatAlignCenter);
var FormatAlignJustify = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M3 21h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18V7H3v2zm0-6v2h18V3H3z'
    }));
  };

  var FormatAlignJustifyIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FormatAlignJustifyIcon.displayName = 'FormatAlignJustifyIcon';
  FormatAlignJustifyIcon.defaultProps = {
    size: 24
  };
  exports.default = FormatAlignJustifyIcon;
});
unwrapExports(FormatAlignJustify);
var FormatAlignLeft = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M15 15H3v2h12v-2zm0-8H3v2h12V7zM3 13h18v-2H3v2zm0 8h18v-2H3v2zM3 3v2h18V3H3z'
    }));
  };

  var FormatAlignLeftIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FormatAlignLeftIcon.displayName = 'FormatAlignLeftIcon';
  FormatAlignLeftIcon.defaultProps = {
    size: 24
  };
  exports.default = FormatAlignLeftIcon;
});
unwrapExports(FormatAlignLeft);
var FormatAlignRight = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M3 21h18v-2H3v2zm6-4h12v-2H9v2zm-6-4h18v-2H3v2zm6-4h12V7H9v2zM3 3v2h18V3H3z'
    }));
  };

  var FormatAlignRightIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FormatAlignRightIcon.displayName = 'FormatAlignRightIcon';
  FormatAlignRightIcon.defaultProps = {
    size: 24
  };
  exports.default = FormatAlignRightIcon;
});
unwrapExports(FormatAlignRight);
var FormatBold = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M15.6 10.79c.97-.67 1.65-1.77 1.65-2.79 0-2.26-1.75-4-4-4H7v14h7.04c2.09 0 3.71-1.7 3.71-3.79 0-1.52-.86-2.82-2.15-3.42zM10 6.5h3c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-3v-3zm3.5 9H10v-3h3.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z'
    }));
  };

  var FormatBoldIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FormatBoldIcon.displayName = 'FormatBoldIcon';
  FormatBoldIcon.defaultProps = {
    size: 24
  };
  exports.default = FormatBoldIcon;
});
unwrapExports(FormatBold);
var FormatClear = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M3.27 5L2 6.27l6.97 6.97L6.5 19h3l1.57-3.66L16.73 21 18 19.73 3.55 5.27 3.27 5zM6 5v.18L8.82 8h2.4l-.72 1.68 2.1 2.1L14.21 8H20V5H6z'
    }));
  };

  var FormatClearIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FormatClearIcon.displayName = 'FormatClearIcon';
  FormatClearIcon.defaultProps = {
    size: 24
  };
  exports.default = FormatClearIcon;
});
unwrapExports(FormatClear);
var FormatColorFill = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M16.56 8.94L7.62 0 6.21 1.41l2.38 2.38-5.15 5.15c-.59.59-.59 1.54 0 2.12l5.5 5.5c.29.29.68.44 1.06.44s.77-.15 1.06-.44l5.5-5.5c.59-.58.59-1.53 0-2.12zM5.21 10L10 5.21 14.79 10H5.21zM19 11.5s-2 2.17-2 3.5c0 1.1.9 2 2 2s2-.9 2-2c0-1.33-2-3.5-2-3.5z M0 20h24v4H0z'
    }));
  };

  var FormatColorFillIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FormatColorFillIcon.displayName = 'FormatColorFillIcon';
  FormatColorFillIcon.defaultProps = {
    size: 24
  };
  exports.default = FormatColorFillIcon;
});
unwrapExports(FormatColorFill);
var FormatColorReset = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M18 14c0-4-6-10.8-6-10.8s-1.33 1.51-2.73 3.52l8.59 8.59c.09-.42.14-.86.14-1.31zm-.88 3.12L12.5 12.5 5.27 5.27 4 6.55l3.32 3.32C6.55 11.32 6 12.79 6 14c0 3.31 2.69 6 6 6 1.52 0 2.9-.57 3.96-1.5l2.63 2.63 1.27-1.27-2.74-2.74z'
    }));
  };

  var FormatColorResetIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FormatColorResetIcon.displayName = 'FormatColorResetIcon';
  FormatColorResetIcon.defaultProps = {
    size: 24
  };
  exports.default = FormatColorResetIcon;
});
unwrapExports(FormatColorReset);
var FormatColorText = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M0 20h24v4H0z M11 3L5.5 17h2.25l1.12-3h6.25l1.12 3h2.25L13 3h-2zm-1.38 9L12 5.67 14.38 12H9.62z'
    }));
  };

  var FormatColorTextIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FormatColorTextIcon.displayName = 'FormatColorTextIcon';
  FormatColorTextIcon.defaultProps = {
    size: 24
  };
  exports.default = FormatColorTextIcon;
});
unwrapExports(FormatColorText);
var FormatIndentDecrease = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M11 17h10v-2H11v2zm-8-5l4 4V8l-4 4zm0 9h18v-2H3v2zM3 3v2h18V3H3zm8 6h10V7H11v2zm0 4h10v-2H11v2z'
    }));
  };

  var FormatIndentDecreaseIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FormatIndentDecreaseIcon.displayName = 'FormatIndentDecreaseIcon';
  FormatIndentDecreaseIcon.defaultProps = {
    size: 24
  };
  exports.default = FormatIndentDecreaseIcon;
});
unwrapExports(FormatIndentDecrease);
var FormatIndentIncrease = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M3 21h18v-2H3v2zM3 8v8l4-4-4-4zm8 9h10v-2H11v2zM3 3v2h18V3H3zm8 6h10V7H11v2zm0 4h10v-2H11v2z'
    }));
  };

  var FormatIndentIncreaseIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FormatIndentIncreaseIcon.displayName = 'FormatIndentIncreaseIcon';
  FormatIndentIncreaseIcon.defaultProps = {
    size: 24
  };
  exports.default = FormatIndentIncreaseIcon;
});
unwrapExports(FormatIndentIncrease);
var FormatItalic = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M10 4v3h2.21l-3.42 8H6v3h8v-3h-2.21l3.42-8H18V4z'
    }));
  };

  var FormatItalicIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FormatItalicIcon.displayName = 'FormatItalicIcon';
  FormatItalicIcon.defaultProps = {
    size: 24
  };
  exports.default = FormatItalicIcon;
});
unwrapExports(FormatItalic);
var FormatLineSpacing = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M6 7h2.5L5 3.5 1.5 7H4v10H1.5L5 20.5 8.5 17H6V7zm4-2v2h12V5H10zm0 14h12v-2H10v2zm0-6h12v-2H10v2z'
    }));
  };

  var FormatLineSpacingIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FormatLineSpacingIcon.displayName = 'FormatLineSpacingIcon';
  FormatLineSpacingIcon.defaultProps = {
    size: 24
  };
  exports.default = FormatLineSpacingIcon;
});
unwrapExports(FormatLineSpacing);
var FormatListBulleted = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M4 10.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-6c-.83 0-1.5.67-1.5 1.5S3.17 7.5 4 7.5 5.5 6.83 5.5 6 4.83 4.5 4 4.5zm0 12c-.83 0-1.5.68-1.5 1.5s.68 1.5 1.5 1.5 1.5-.68 1.5-1.5-.67-1.5-1.5-1.5zM7 19h14v-2H7v2zm0-6h14v-2H7v2zm0-8v2h14V5H7z'
    }));
  };

  var FormatListBulletedIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FormatListBulletedIcon.displayName = 'FormatListBulletedIcon';
  FormatListBulletedIcon.defaultProps = {
    size: 24
  };
  exports.default = FormatListBulletedIcon;
});
unwrapExports(FormatListBulleted);
var FormatListNumbered = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M2 17h2v.5H3v1h1v.5H2v1h3v-4H2v1zm1-9h1V4H2v1h1v3zm-1 3h1.8L2 13.1v.9h3v-1H3.2L5 10.9V10H2v1zm5-6v2h14V5H7zm0 14h14v-2H7v2zm0-6h14v-2H7v2z'
    }));
  };

  var FormatListNumberedIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FormatListNumberedIcon.displayName = 'FormatListNumberedIcon';
  FormatListNumberedIcon.defaultProps = {
    size: 24
  };
  exports.default = FormatListNumberedIcon;
});
unwrapExports(FormatListNumbered);
var FormatPaint = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M18 4V3c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6h1v4H9v11c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-9h8V4h-3z'
    }));
  };

  var FormatPaintIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FormatPaintIcon.displayName = 'FormatPaintIcon';
  FormatPaintIcon.defaultProps = {
    size: 24
  };
  exports.default = FormatPaintIcon;
});
unwrapExports(FormatPaint);
var FormatQuote = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M6 17h3l2-4V7H5v6h3zm8 0h3l2-4V7h-6v6h3z'
    }));
  };

  var FormatQuoteIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FormatQuoteIcon.displayName = 'FormatQuoteIcon';
  FormatQuoteIcon.defaultProps = {
    size: 24
  };
  exports.default = FormatQuoteIcon;
});
unwrapExports(FormatQuote);
var FormatShapes = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M23 7V1h-6v2H7V1H1v6h2v10H1v6h6v-2h10v2h6v-6h-2V7h2zM3 3h2v2H3V3zm2 18H3v-2h2v2zm12-2H7v-2H5V7h2V5h10v2h2v10h-2v2zm4 2h-2v-2h2v2zM19 5V3h2v2h-2zm-5.27 9h-3.49l-.73 2H7.89l3.4-9h1.4l3.41 9h-1.63l-.74-2zm-3.04-1.26h2.61L12 8.91l-1.31 3.83z'
    }));
  };

  var FormatShapesIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FormatShapesIcon.displayName = 'FormatShapesIcon';
  FormatShapesIcon.defaultProps = {
    size: 24
  };
  exports.default = FormatShapesIcon;
});
unwrapExports(FormatShapes);
var FormatSize = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M9 4v3h5v12h3V7h5V4H9zm-6 8h3v7h3v-7h3V9H3v3z'
    }));
  };

  var FormatSizeIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FormatSizeIcon.displayName = 'FormatSizeIcon';
  FormatSizeIcon.defaultProps = {
    size: 24
  };
  exports.default = FormatSizeIcon;
});
unwrapExports(FormatSize);
var FormatStrikethrough = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M10 19h4v-3h-4v3zM5 4v3h5v3h4V7h5V4H5zM3 14h18v-2H3v2z'
    }));
  };

  var FormatStrikethroughIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FormatStrikethroughIcon.displayName = 'FormatStrikethroughIcon';
  FormatStrikethroughIcon.defaultProps = {
    size: 24
  };
  exports.default = FormatStrikethroughIcon;
});
unwrapExports(FormatStrikethrough);
var FormatTextdirectionLToR = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M9 10v5h2V4h2v11h2V4h2V2H9C6.79 2 5 3.79 5 6s1.79 4 4 4zm12 8l-4-4v3H5v2h12v3l4-4z'
    }));
  };

  var FormatTextdirectionLToRIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FormatTextdirectionLToRIcon.displayName = 'FormatTextdirectionLToRIcon';
  FormatTextdirectionLToRIcon.defaultProps = {
    size: 24
  };
  exports.default = FormatTextdirectionLToRIcon;
});
unwrapExports(FormatTextdirectionLToR);
var FormatTextdirectionRToL = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M10 10v5h2V4h2v11h2V4h2V2h-8C7.79 2 6 3.79 6 6s1.79 4 4 4zm-2 7v-3l-4 4 4 4v-3h12v-2H8z'
    }));
  };

  var FormatTextdirectionRToLIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FormatTextdirectionRToLIcon.displayName = 'FormatTextdirectionRToLIcon';
  FormatTextdirectionRToLIcon.defaultProps = {
    size: 24
  };
  exports.default = FormatTextdirectionRToLIcon;
});
unwrapExports(FormatTextdirectionRToL);
var FormatUnderlined = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 17c3.31 0 6-2.69 6-6V3h-2.5v8c0 1.93-1.57 3.5-3.5 3.5S8.5 12.93 8.5 11V3H6v8c0 3.31 2.69 6 6 6zm-7 2v2h14v-2H5z'
    }));
  };

  var FormatUnderlinedIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FormatUnderlinedIcon.displayName = 'FormatUnderlinedIcon';
  FormatUnderlinedIcon.defaultProps = {
    size: 24
  };
  exports.default = FormatUnderlinedIcon;
});
unwrapExports(FormatUnderlined);
var Forum = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z'
    }));
  };

  var ForumIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ForumIcon.displayName = 'ForumIcon';
  ForumIcon.defaultProps = {
    size: 24
  };
  exports.default = ForumIcon;
});
unwrapExports(Forum);
var Forward = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 8V4l8 8-8 8v-4H4V8z'
    }));
  };

  var ForwardIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ForwardIcon.displayName = 'ForwardIcon';
  ForwardIcon.defaultProps = {
    size: 24
  };
  exports.default = ForwardIcon;
});
unwrapExports(Forward);
var Forward10 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M4 13c0 4.4 3.6 8 8 8s8-3.6 8-8h-2c0 3.3-2.7 6-6 6s-6-2.7-6-6 2.7-6 6-6v4l5-5-5-5v4c-4.4 0-8 3.6-8 8zm6.8 3H10v-3.3L9 13v-.7l1.8-.6h.1V16zm4.3-1.8c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1.3.2.5.3.2.3.3.6.1.5.1.8v.7zm-.8-.8v-.5s-.1-.2-.1-.3-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5z'
    }));
  };

  var Forward10Icon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  Forward10Icon.displayName = 'Forward10Icon';
  Forward10Icon.defaultProps = {
    size: 24
  };
  exports.default = Forward10Icon;
});
unwrapExports(Forward10);
var Forward30 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M9.6 13.5h.4c.2 0 .4-.1.5-.2s.2-.2.2-.4v-.2s-.1-.1-.1-.2-.1-.1-.2-.1h-.5s-.1.1-.2.1-.1.1-.1.2v.2h-1c0-.2 0-.3.1-.5s.2-.3.3-.4.3-.2.4-.2.4-.1.5-.1c.2 0 .4 0 .6.1s.3.1.5.2.2.2.3.4.1.3.1.5v.3s-.1.2-.1.3-.1.2-.2.2-.2.1-.3.2c.2.1.4.2.5.4s.2.4.2.6c0 .2 0 .4-.1.5s-.2.3-.3.4-.3.2-.5.2-.4.1-.6.1c-.2 0-.4 0-.5-.1s-.3-.1-.5-.2-.2-.2-.3-.4-.1-.4-.1-.6h.8v.2s.1.1.1.2.1.1.2.1h.5s.1-.1.2-.1.1-.1.1-.2v-.5s-.1-.1-.1-.2-.1-.1-.2-.1h-.6v-.7zm5.7.7c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1.3.2.5.3.2.3.3.6.1.5.1.8v.7zm-.9-.8v-.5s-.1-.2-.1-.3-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5zM4 13c0 4.4 3.6 8 8 8s8-3.6 8-8h-2c0 3.3-2.7 6-6 6s-6-2.7-6-6 2.7-6 6-6v4l5-5-5-5v4c-4.4 0-8 3.6-8 8z'
    }));
  };

  var Forward30Icon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  Forward30Icon.displayName = 'Forward30Icon';
  Forward30Icon.defaultProps = {
    size: 24
  };
  exports.default = Forward30Icon;
});
unwrapExports(Forward30);
var Forward5 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M4 13c0 4.4 3.6 8 8 8s8-3.6 8-8h-2c0 3.3-2.7 6-6 6s-6-2.7-6-6 2.7-6 6-6v4l5-5-5-5v4c-4.4 0-8 3.6-8 8zm6.7.9l.2-2.2h2.4v.7h-1.7l-.1.9s.1 0 .1-.1.1 0 .1-.1.1 0 .2 0h.2c.2 0 .4 0 .5.1s.3.2.4.3.2.3.3.5.1.4.1.6c0 .2 0 .4-.1.5s-.1.3-.3.5-.3.2-.5.3-.4.1-.6.1c-.2 0-.4 0-.5-.1s-.3-.1-.5-.2-.2-.2-.3-.4-.1-.3-.1-.5h.8c0 .2.1.3.2.4s.2.1.4.1c.1 0 .2 0 .3-.1l.2-.2s.1-.2.1-.3v-.6l-.1-.2-.2-.2s-.2-.1-.3-.1h-.2s-.1 0-.2.1-.1 0-.1.1-.1.1-.1.1h-.6z'
    }));
  };

  var Forward5Icon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  Forward5Icon.displayName = 'Forward5Icon';
  Forward5Icon.defaultProps = {
    size: 24
  };
  exports.default = Forward5Icon;
});
unwrapExports(Forward5);
var FreeBreakfast = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 3H4v10c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2c1.11 0 2-.9 2-2V5c0-1.11-.89-2-2-2zm0 5h-2V5h2v3zM4 19h16v2H4z'
    }));
  };

  var FreeBreakfastIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FreeBreakfastIcon.displayName = 'FreeBreakfastIcon';
  FreeBreakfastIcon.defaultProps = {
    size: 24
  };
  exports.default = FreeBreakfastIcon;
});
unwrapExports(FreeBreakfast);
var Fullscreen = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z'
    }));
  };

  var FullscreenIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FullscreenIcon.displayName = 'FullscreenIcon';
  FullscreenIcon.defaultProps = {
    size: 24
  };
  exports.default = FullscreenIcon;
});
unwrapExports(Fullscreen);
var FullscreenExit = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z'
    }));
  };

  var FullscreenExitIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FullscreenExitIcon.displayName = 'FullscreenExitIcon';
  FullscreenExitIcon.defaultProps = {
    size: 24
  };
  exports.default = FullscreenExitIcon;
});
unwrapExports(FullscreenExit);
var Functions = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M18 4H6v2l6.5 6L6 18v2h12v-3h-7l5-5-5-5h7z'
    }));
  };

  var FunctionsIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  FunctionsIcon.displayName = 'FunctionsIcon';
  FunctionsIcon.defaultProps = {
    size: 24
  };
  exports.default = FunctionsIcon;
});
unwrapExports(Functions);
var GTranslate = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 5h-9.12L10 2H4c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h7l1 3h8c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zM7.17 14.59c-2.25 0-4.09-1.83-4.09-4.09s1.83-4.09 4.09-4.09c1.04 0 1.99.37 2.74 1.07l.07.06-1.23 1.18-.06-.05c-.29-.27-.78-.59-1.52-.59-1.31 0-2.38 1.09-2.38 2.42s1.07 2.42 2.38 2.42c1.37 0 1.96-.87 2.12-1.46H7.08V9.91h3.95l.01.07c.04.21.05.4.05.61 0 2.35-1.61 4-3.92 4zm6.03-1.71c.33.6.74 1.18 1.19 1.7l-.54.53-.65-2.23zm.77-.76h-.99l-.31-1.04h3.99s-.34 1.31-1.56 2.74c-.52-.62-.89-1.23-1.13-1.7zM21 20c0 .55-.45 1-1 1h-7l2-2-.81-2.77.92-.92L17.79 18l.73-.73-2.71-2.68c.9-1.03 1.6-2.25 1.92-3.51H19v-1.04h-3.64V9h-1.04v1.04h-1.96L11.18 6H20c.55 0 1 .45 1 1v13z'
    }));
  };

  var GTranslateIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  GTranslateIcon.displayName = 'GTranslateIcon';
  GTranslateIcon.defaultProps = {
    size: 24
  };
  exports.default = GTranslateIcon;
});
unwrapExports(GTranslate);
var Gamepad = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M15 7.5V2H9v5.5l3 3 3-3zM7.5 9H2v6h5.5l3-3-3-3zM9 16.5V22h6v-5.5l-3-3-3 3zM16.5 9l-3 3 3 3H22V9h-5.5z'
    }));
  };

  var GamepadIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  GamepadIcon.displayName = 'GamepadIcon';
  GamepadIcon.defaultProps = {
    size: 24
  };
  exports.default = GamepadIcon;
});
unwrapExports(Gamepad);
var Games = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M15 7.5V2H9v5.5l3 3 3-3zM7.5 9H2v6h5.5l3-3-3-3zM9 16.5V22h6v-5.5l-3-3-3 3zM16.5 9l-3 3 3 3H22V9h-5.5z'
    }));
  };

  var GamesIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  GamesIcon.displayName = 'GamesIcon';
  GamesIcon.defaultProps = {
    size: 24
  };
  exports.default = GamesIcon;
});
unwrapExports(Games);
var Gavel = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M1 21h12v2H1zM5.245 8.07l2.83-2.827 14.14 14.142-2.828 2.828zM12.317 1l5.657 5.656-2.83 2.83-5.654-5.66zM3.825 9.485l5.657 5.657-2.828 2.828-5.657-5.657z'
    }));
  };

  var GavelIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  GavelIcon.displayName = 'GavelIcon';
  GavelIcon.defaultProps = {
    size: 24
  };
  exports.default = GavelIcon;
});
unwrapExports(Gavel);
var Gesture = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M4.59 6.89c.7-.71 1.4-1.35 1.71-1.22.5.2 0 1.03-.3 1.52-.25.42-2.86 3.89-2.86 6.31 0 1.28.48 2.34 1.34 2.98.75.56 1.74.73 2.64.46 1.07-.31 1.95-1.4 3.06-2.77 1.21-1.49 2.83-3.44 4.08-3.44 1.63 0 1.65 1.01 1.76 1.79-3.78.64-5.38 3.67-5.38 5.37 0 1.7 1.44 3.09 3.21 3.09 1.63 0 4.29-1.33 4.69-6.1H21v-2.5h-2.47c-.15-1.65-1.09-4.2-4.03-4.2-2.25 0-4.18 1.91-4.94 2.84-.58.73-2.06 2.48-2.29 2.72-.25.3-.68.84-1.11.84-.45 0-.72-.83-.36-1.92.35-1.09 1.4-2.86 1.85-3.52.78-1.14 1.3-1.92 1.3-3.28C8.95 3.69 7.31 3 6.44 3 5.12 3 3.97 4 3.72 4.25c-.36.36-.66.66-.88.93l1.75 1.71zm9.29 11.66c-.31 0-.74-.26-.74-.72 0-.6.73-2.2 2.87-2.76-.3 2.69-1.43 3.48-2.13 3.48z'
    }));
  };

  var GestureIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  GestureIcon.displayName = 'GestureIcon';
  GestureIcon.defaultProps = {
    size: 24
  };
  exports.default = GestureIcon;
});
unwrapExports(Gesture);
var GetApp = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z'
    }));
  };

  var GetAppIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  GetAppIcon.displayName = 'GetAppIcon';
  GetAppIcon.defaultProps = {
    size: 24
  };
  exports.default = GetAppIcon;
});
unwrapExports(GetApp);
var Gif = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M11.5 9H13v6h-1.5zM9 9H6c-.6 0-1 .5-1 1v4c0 .5.4 1 1 1h3c.6 0 1-.5 1-1v-2H8.5v1.5h-2v-3H10V10c0-.5-.4-1-1-1zm10 1.5V9h-4.5v6H16v-2h2v-1.5h-2v-1z'
    }));
  };

  var GifIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  GifIcon.displayName = 'GifIcon';
  GifIcon.defaultProps = {
    size: 24
  };
  exports.default = GifIcon;
});
unwrapExports(Gif);
var GolfCourse = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M17 5.92L9 2v18H7v-1.73c-1.79.35-3 .99-3 1.73 0 1.1 2.69 2 6 2s6-.9 6-2c0-.99-2.16-1.81-5-1.97V8.98l6-3.06z M 19.5 18 A 1.5 1.5 0 0 1 19.5 21 A 1.5 1.5 0 0 1 19.5 18'
    }));
  };

  var GolfCourseIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  GolfCourseIcon.displayName = 'GolfCourseIcon';
  GolfCourseIcon.defaultProps = {
    size: 24
  };
  exports.default = GolfCourseIcon;
});
unwrapExports(GolfCourse);
var GpsFixed = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z'
    }));
  };

  var GpsFixedIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  GpsFixedIcon.displayName = 'GpsFixedIcon';
  GpsFixedIcon.defaultProps = {
    size: 24
  };
  exports.default = GpsFixedIcon;
});
unwrapExports(GpsFixed);
var GpsNotFixed = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z'
    }));
  };

  var GpsNotFixedIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  GpsNotFixedIcon.displayName = 'GpsNotFixedIcon';
  GpsNotFixedIcon.defaultProps = {
    size: 24
  };
  exports.default = GpsNotFixedIcon;
});
unwrapExports(GpsNotFixed);
var GpsOff = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06c-1.13.12-2.19.46-3.16.97l1.5 1.5C10.16 5.19 11.06 5 12 5c3.87 0 7 3.13 7 7 0 .94-.19 1.84-.52 2.65l1.5 1.5c.5-.96.84-2.02.97-3.15H23v-2h-2.06zM3 4.27l2.04 2.04C3.97 7.62 3.25 9.23 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c1.77-.2 3.38-.91 4.69-1.98L19.73 21 21 19.73 4.27 3 3 4.27zm13.27 13.27C15.09 18.45 13.61 19 12 19c-3.87 0-7-3.13-7-7 0-1.61.55-3.09 1.46-4.27l9.81 9.81z'
    }));
  };

  var GpsOffIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  GpsOffIcon.displayName = 'GpsOffIcon';
  GpsOffIcon.defaultProps = {
    size: 24
  };
  exports.default = GpsOffIcon;
});
unwrapExports(GpsOff);
var Grade = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z'
    }));
  };

  var GradeIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  GradeIcon.displayName = 'GradeIcon';
  GradeIcon.defaultProps = {
    size: 24
  };
  exports.default = GradeIcon;
});
unwrapExports(Grade);
var Gradient = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M11 9h2v2h-2zm-2 2h2v2H9zm4 0h2v2h-2zm2-2h2v2h-2zM7 9h2v2H7zm12-6H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 18H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2zm2-7h-2v2h2v2h-2v-2h-2v2h-2v-2h-2v2H9v-2H7v2H5v-2h2v-2H5V5h14v6z'
    }));
  };

  var GradientIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  GradientIcon.displayName = 'GradientIcon';
  GradientIcon.defaultProps = {
    size: 24
  };
  exports.default = GradientIcon;
});
unwrapExports(Gradient);
var Grain = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M10 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM6 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12-8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-4 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z'
    }));
  };

  var GrainIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  GrainIcon.displayName = 'GrainIcon';
  GrainIcon.defaultProps = {
    size: 24
  };
  exports.default = GrainIcon;
});
unwrapExports(Grain);
var GraphicEq = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M7 18h2V6H7v12zm4 4h2V2h-2v20zm-8-8h2v-4H3v4zm12 4h2V6h-2v12zm4-8v4h2v-4h-2z'
    }));
  };

  var GraphicEqIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  GraphicEqIcon.displayName = 'GraphicEqIcon';
  GraphicEqIcon.defaultProps = {
    size: 24
  };
  exports.default = GraphicEqIcon;
});
unwrapExports(GraphicEq);
var GridOff = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M8 4v1.45l2 2V4h4v4h-3.45l2 2H14v1.45l2 2V10h4v4h-3.45l2 2H20v1.45l2 2V4c0-1.1-.9-2-2-2H4.55l2 2H8zm8 0h4v4h-4V4zM1.27 1.27L0 2.55l2 2V20c0 1.1.9 2 2 2h15.46l2 2 1.27-1.27L1.27 1.27zM10 12.55L11.45 14H10v-1.45zm-6-6L5.45 8H4V6.55zM8 20H4v-4h4v4zm0-6H4v-4h3.45l.55.55V14zm6 6h-4v-4h3.45l.55.54V20zm2 0v-1.46L17.46 20H16z'
    }));
  };

  var GridOffIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  GridOffIcon.displayName = 'GridOffIcon';
  GridOffIcon.defaultProps = {
    size: 24
  };
  exports.default = GridOffIcon;
});
unwrapExports(GridOff);
var GridOn = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM8 20H4v-4h4v4zm0-6H4v-4h4v4zm0-6H4V4h4v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V4h4v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V4h4v4z'
    }));
  };

  var GridOnIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  GridOnIcon.displayName = 'GridOnIcon';
  GridOnIcon.defaultProps = {
    size: 24
  };
  exports.default = GridOnIcon;
});
unwrapExports(GridOn);
var Group = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z'
    }));
  };

  var GroupIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  GroupIcon.displayName = 'GroupIcon';
  GroupIcon.defaultProps = {
    size: 24
  };
  exports.default = GroupIcon;
});
unwrapExports(Group);
var GroupAdd = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M8 10H5V7H3v3H0v2h3v3h2v-3h3v-2zm10 1c1.66 0 2.99-1.34 2.99-3S19.66 5 18 5c-.32 0-.63.05-.91.14.57.81.9 1.79.9 2.86s-.34 2.04-.9 2.86c.28.09.59.14.91.14zm-5 0c1.66 0 2.99-1.34 2.99-3S14.66 5 13 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm6.62 2.16c.83.73 1.38 1.66 1.38 2.84v2h3v-2c0-1.54-2.37-2.49-4.38-2.84zM13 13c-2 0-6 1-6 3v2h12v-2c0-2-4-3-6-3z'
    }));
  };

  var GroupAddIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  GroupAddIcon.displayName = 'GroupAddIcon';
  GroupAddIcon.defaultProps = {
    size: 24
  };
  exports.default = GroupAddIcon;
});
unwrapExports(GroupAdd);
var GroupWork = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM8 17.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5zM9.5 8c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5S9.5 9.38 9.5 8zm6.5 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z'
    }));
  };

  var GroupWorkIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  GroupWorkIcon.displayName = 'GroupWorkIcon';
  GroupWorkIcon.defaultProps = {
    size: 24
  };
  exports.default = GroupWorkIcon;
});
unwrapExports(GroupWork);
var Hd = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-8 12H9.5v-2h-2v2H6V9h1.5v2.5h2V9H11v6zm2-6h4c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1h-4V9zm1.5 4.5h2v-3h-2v3z'
    }));
  };

  var HdIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  HdIcon.displayName = 'HdIcon';
  HdIcon.defaultProps = {
    size: 24
  };
  exports.default = HdIcon;
});
unwrapExports(Hd);
var HdrOff = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M17.5 15v-2h1.1l.9 2H21l-.9-2.1c.5-.2.9-.8.9-1.4v-1c0-.8-.7-1.5-1.5-1.5H16v4.9l1.1 1.1h.4zm0-4.5h2v1h-2v-1zm-4.5 0v.4l1.5 1.5v-1.9c0-.8-.7-1.5-1.5-1.5h-1.9l1.5 1.5h.4zm-3.5-1l-7-7-1.1 1L6.9 9h-.4v2h-2V9H3v6h1.5v-2.5h2V15H8v-4.9l1.5 1.5V15h3.4l7.6 7.6 1.1-1.1-12.1-12z'
    }));
  };

  var HdrOffIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  HdrOffIcon.displayName = 'HdrOffIcon';
  HdrOffIcon.defaultProps = {
    size: 24
  };
  exports.default = HdrOffIcon;
});
unwrapExports(HdrOff);
var HdrOn = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21 11.5v-1c0-.8-.7-1.5-1.5-1.5H16v6h1.5v-2h1.1l.9 2H21l-.9-2.1c.5-.3.9-.8.9-1.4zm-1.5 0h-2v-1h2v1zm-13-.5h-2V9H3v6h1.5v-2.5h2V15H8V9H6.5v2zM13 9H9.5v6H13c.8 0 1.5-.7 1.5-1.5v-3c0-.8-.7-1.5-1.5-1.5zm0 4.5h-2v-3h2v3z'
    }));
  };

  var HdrOnIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  HdrOnIcon.displayName = 'HdrOnIcon';
  HdrOnIcon.defaultProps = {
    size: 24
  };
  exports.default = HdrOnIcon;
});
unwrapExports(HdrOn);
var HdrStrong = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M17 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zM5 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z'
    }));
  };

  var HdrStrongIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  HdrStrongIcon.displayName = 'HdrStrongIcon';
  HdrStrongIcon.defaultProps = {
    size: 24
  };
  exports.default = HdrStrongIcon;
});
unwrapExports(HdrStrong);
var HdrWeak = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M5 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm12-2c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z'
    }));
  };

  var HdrWeakIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  HdrWeakIcon.displayName = 'HdrWeakIcon';
  HdrWeakIcon.defaultProps = {
    size: 24
  };
  exports.default = HdrWeakIcon;
});
unwrapExports(HdrWeak);
var Headset = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 1c-4.97 0-9 4.03-9 9v7c0 1.66 1.34 3 3 3h3v-8H5v-2c0-3.87 3.13-7 7-7s7 3.13 7 7v2h-4v8h3c1.66 0 3-1.34 3-3v-7c0-4.97-4.03-9-9-9z'
    }));
  };

  var HeadsetIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  HeadsetIcon.displayName = 'HeadsetIcon';
  HeadsetIcon.defaultProps = {
    size: 24
  };
  exports.default = HeadsetIcon;
});
unwrapExports(Headset);
var HeadsetMic = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 1c-4.97 0-9 4.03-9 9v7c0 1.66 1.34 3 3 3h3v-8H5v-2c0-3.87 3.13-7 7-7s7 3.13 7 7v2h-4v8h4v1h-7v2h6c1.66 0 3-1.34 3-3V10c0-4.97-4.03-9-9-9z'
    }));
  };

  var HeadsetMicIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  HeadsetMicIcon.displayName = 'HeadsetMicIcon';
  HeadsetMicIcon.defaultProps = {
    size: 24
  };
  exports.default = HeadsetMicIcon;
});
unwrapExports(HeadsetMic);
var Healing = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M17.73 12.02l3.98-3.98c.39-.39.39-1.02 0-1.41l-4.34-4.34c-.39-.39-1.02-.39-1.41 0l-3.98 3.98L8 2.29C7.8 2.1 7.55 2 7.29 2c-.25 0-.51.1-.7.29L2.25 6.63c-.39.39-.39 1.02 0 1.41l3.98 3.98L2.25 16c-.39.39-.39 1.02 0 1.41l4.34 4.34c.39.39 1.02.39 1.41 0l3.98-3.98 3.98 3.98c.2.2.45.29.71.29.26 0 .51-.1.71-.29l4.34-4.34c.39-.39.39-1.02 0-1.41l-3.99-3.98zM12 9c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-4.71 1.96L3.66 7.34l3.63-3.63 3.62 3.62-3.62 3.63zM10 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2 2c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2.66 9.34l-3.63-3.62 3.63-3.63 3.62 3.62-3.62 3.63z'
    }));
  };

  var HealingIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  HealingIcon.displayName = 'HealingIcon';
  HealingIcon.defaultProps = {
    size: 24
  };
  exports.default = HealingIcon;
});
unwrapExports(Healing);
var Hearing = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M17 20c-.29 0-.56-.06-.76-.15-.71-.37-1.21-.88-1.71-2.38-.51-1.56-1.47-2.29-2.39-3-.79-.61-1.61-1.24-2.32-2.53C9.29 10.98 9 9.93 9 9c0-2.8 2.2-5 5-5s5 2.2 5 5h2c0-3.93-3.07-7-7-7S7 5.07 7 9c0 1.26.38 2.65 1.07 3.9.91 1.65 1.98 2.48 2.85 3.15.81.62 1.39 1.07 1.71 2.05.6 1.82 1.37 2.84 2.73 3.55.51.23 1.07.35 1.64.35 2.21 0 4-1.79 4-4h-2c0 1.1-.9 2-2 2zM7.64 2.64L6.22 1.22C4.23 3.21 3 5.96 3 9s1.23 5.79 3.22 7.78l1.41-1.41C6.01 13.74 5 11.49 5 9s1.01-4.74 2.64-6.36zM11.5 9c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5-1.12-2.5-2.5-2.5-2.5 1.12-2.5 2.5z'
    }));
  };

  var HearingIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  HearingIcon.displayName = 'HearingIcon';
  HearingIcon.defaultProps = {
    size: 24
  };
  exports.default = HearingIcon;
});
unwrapExports(Hearing);
var Help = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z'
    }));
  };

  var HelpIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  HelpIcon.displayName = 'HelpIcon';
  HelpIcon.defaultProps = {
    size: 24
  };
  exports.default = HelpIcon;
});
unwrapExports(Help);
var HelpOutline = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z'
    }));
  };

  var HelpOutlineIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  HelpOutlineIcon.displayName = 'HelpOutlineIcon';
  HelpOutlineIcon.defaultProps = {
    size: 24
  };
  exports.default = HelpOutlineIcon;
});
unwrapExports(HelpOutline);
var HighQuality = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 11H9.5v-2h-2v2H6V9h1.5v2.5h2V9H11v6zm7-1c0 .55-.45 1-1 1h-.75v1.5h-1.5V15H14c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v4zm-3.5-.5h2v-3h-2v3z'
    }));
  };

  var HighQualityIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  HighQualityIcon.displayName = 'HighQualityIcon';
  HighQualityIcon.defaultProps = {
    size: 24
  };
  exports.default = HighQualityIcon;
});
unwrapExports(HighQuality);
var Highlight = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M6 14l3 3v5h6v-5l3-3V9H6zm5-12h2v3h-2zM3.5 5.875L4.914 4.46l2.12 2.122L5.62 7.997zm13.46.71l2.123-2.12 1.414 1.414L18.375 8z'
    }));
  };

  var HighlightIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  HighlightIcon.displayName = 'HighlightIcon';
  HighlightIcon.defaultProps = {
    size: 24
  };
  exports.default = HighlightIcon;
});
unwrapExports(Highlight);
var HighlightOff = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M14.59 8L12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41 14.59 8zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z'
    }));
  };

  var HighlightOffIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  HighlightOffIcon.displayName = 'HighlightOffIcon';
  HighlightOffIcon.defaultProps = {
    size: 24
  };
  exports.default = HighlightOffIcon;
});
unwrapExports(HighlightOff);
var History = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z'
    }));
  };

  var HistoryIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  HistoryIcon.displayName = 'HistoryIcon';
  HistoryIcon.defaultProps = {
    size: 24
  };
  exports.default = HistoryIcon;
});
unwrapExports(History);
var Home = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z'
    }));
  };

  var HomeIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  HomeIcon.displayName = 'HomeIcon';
  HomeIcon.defaultProps = {
    size: 24
  };
  exports.default = HomeIcon;
});
unwrapExports(Home);
var HotTub = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M 7 4 A 2 2 0 0 1 7 8 A 2 2 0 0 1 7 4 M11.15 12c-.31-.22-.59-.46-.82-.72l-1.4-1.55c-.19-.21-.43-.38-.69-.5-.29-.14-.62-.23-.96-.23h-.03C6.01 9 5 10.01 5 11.25V12H2v8c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-8H11.15zM7 20H5v-6h2v6zm4 0H9v-6h2v6zm4 0h-2v-6h2v6zm4 0h-2v-6h2v6zm-.35-14.14l-.07-.07c-.57-.62-.82-1.41-.67-2.2L18 3h-1.89l-.06.43c-.2 1.36.27 2.71 1.3 3.72l.07.06c.57.62.82 1.41.67 2.2l-.11.59h1.91l.06-.43c.21-1.36-.27-2.71-1.3-3.71zm-4 0l-.07-.07c-.57-.62-.82-1.41-.67-2.2L14 3h-1.89l-.06.43c-.2 1.36.27 2.71 1.3 3.72l.07.06c.57.62.82 1.41.67 2.2l-.11.59h1.91l.06-.43c.21-1.36-.27-2.71-1.3-3.71z'
    }));
  };

  var HotTubIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  HotTubIcon.displayName = 'HotTubIcon';
  HotTubIcon.defaultProps = {
    size: 24
  };
  exports.default = HotTubIcon;
});
unwrapExports(HotTub);
var Hotel = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M7 13c1.66 0 3-1.34 3-3S8.66 7 7 7s-3 1.34-3 3 1.34 3 3 3zm12-6h-8v7H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4z'
    }));
  };

  var HotelIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  HotelIcon.displayName = 'HotelIcon';
  HotelIcon.defaultProps = {
    size: 24
  };
  exports.default = HotelIcon;
});
unwrapExports(Hotel);
var HourglassEmpty = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M6 2v6h.01L6 8.01 10 12l-4 4 .01.01H6V22h12v-5.99h-.01L18 16l-4-4 4-3.99-.01-.01H18V2H6zm10 14.5V20H8v-3.5l4-4 4 4zm-4-5l-4-4V4h8v3.5l-4 4z'
    }));
  };

  var HourglassEmptyIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  HourglassEmptyIcon.displayName = 'HourglassEmptyIcon';
  HourglassEmptyIcon.defaultProps = {
    size: 24
  };
  exports.default = HourglassEmptyIcon;
});
unwrapExports(HourglassEmpty);
var HourglassFull = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M6 2v6h.01L6 8.01 10 12l-4 4 .01.01H6V22h12v-5.99h-.01L18 16l-4-4 4-3.99-.01-.01H18V2H6z'
    }));
  };

  var HourglassFullIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  HourglassFullIcon.displayName = 'HourglassFullIcon';
  HourglassFullIcon.defaultProps = {
    size: 24
  };
  exports.default = HourglassFullIcon;
});
unwrapExports(HourglassFull);
var Http = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M4.5 11h-2V9H1v6h1.5v-2.5h2V15H6V9H4.5v2zm2.5-.5h1.5V15H10v-4.5h1.5V9H7v1.5zm5.5 0H14V15h1.5v-4.5H17V9h-4.5v1.5zm9-1.5H18v6h1.5v-2h2c.8 0 1.5-.7 1.5-1.5v-1c0-.8-.7-1.5-1.5-1.5zm0 2.5h-2v-1h2v1z'
    }));
  };

  var HttpIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  HttpIcon.displayName = 'HttpIcon';
  HttpIcon.defaultProps = {
    size: 24
  };
  exports.default = HttpIcon;
});
unwrapExports(Http);
var Https = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z'
    }));
  };

  var HttpsIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  HttpsIcon.displayName = 'HttpsIcon';
  HttpsIcon.defaultProps = {
    size: 24
  };
  exports.default = HttpsIcon;
});
unwrapExports(Https);
var Image$1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z'
    }));
  };

  var ImageIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ImageIcon.displayName = 'ImageIcon';
  ImageIcon.defaultProps = {
    size: 24
  };
  exports.default = ImageIcon;
});
unwrapExports(Image$1);
var ImageAspectRatio = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M16 10h-2v2h2v-2zm0 4h-2v2h2v-2zm-8-4H6v2h2v-2zm4 0h-2v2h2v-2zm8-6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h16v12z'
    }));
  };

  var ImageAspectRatioIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ImageAspectRatioIcon.displayName = 'ImageAspectRatioIcon';
  ImageAspectRatioIcon.defaultProps = {
    size: 24
  };
  exports.default = ImageAspectRatioIcon;
});
unwrapExports(ImageAspectRatio);
var ImportContacts = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21 5c-1.11-.35-2.33-.5-3.5-.5-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6v14.65c0 .25.25.5.5.5.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.1.05.15.05.25.05.25 0 .5-.25.5-.5V6c-.6-.45-1.25-.75-2-1zm0 13.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5 1.2 0 2.4.15 3.5.5v11.5z'
    }));
  };

  var ImportContactsIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ImportContactsIcon.displayName = 'ImportContactsIcon';
  ImportContactsIcon.defaultProps = {
    size: 24
  };
  exports.default = ImportContactsIcon;
});
unwrapExports(ImportContacts);
var ImportExport = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M9 3L5 6.99h3V14h2V6.99h3L9 3zm7 14.01V10h-2v7.01h-3L15 21l4-3.99h-3z'
    }));
  };

  var ImportExportIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ImportExportIcon.displayName = 'ImportExportIcon';
  ImportExportIcon.defaultProps = {
    size: 24
  };
  exports.default = ImportExportIcon;
});
unwrapExports(ImportExport);
var ImportantDevices = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M23 11.01L18 11c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-9c0-.55-.45-.99-1-.99zM23 20h-5v-7h5v7zM20 2H2C.89 2 0 2.89 0 4v12c0 1.1.89 2 2 2h7v2H7v2h8v-2h-2v-2h2v-2H2V4h18v5h2V4c0-1.11-.9-2-2-2zm-8.03 7L11 6l-.97 3H7l2.47 1.76-.94 2.91 2.47-1.8 2.47 1.8-.94-2.91L15 9h-3.03z'
    }));
  };

  var ImportantDevicesIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ImportantDevicesIcon.displayName = 'ImportantDevicesIcon';
  ImportantDevicesIcon.defaultProps = {
    size: 24
  };
  exports.default = ImportantDevicesIcon;
});
unwrapExports(ImportantDevices);
var Inbox = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 3H4.99c-1.11 0-1.98.89-1.98 2L3 19c0 1.1.88 2 1.99 2H19c1.1 0 2-.9 2-2V5c0-1.11-.9-2-2-2zm0 12h-4c0 1.66-1.35 3-3 3s-3-1.34-3-3H4.99V5H19v10z'
    }));
  };

  var InboxIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  InboxIcon.displayName = 'InboxIcon';
  InboxIcon.defaultProps = {
    size: 24
  };
  exports.default = InboxIcon;
});
unwrapExports(Inbox);
var IndeterminateCheckBox = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z'
    }));
  };

  var IndeterminateCheckBoxIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  IndeterminateCheckBoxIcon.displayName = 'IndeterminateCheckBoxIcon';
  IndeterminateCheckBoxIcon.defaultProps = {
    size: 24
  };
  exports.default = IndeterminateCheckBoxIcon;
});
unwrapExports(IndeterminateCheckBox);
var Info = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z'
    }));
  };

  var InfoIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  InfoIcon.displayName = 'InfoIcon';
  InfoIcon.defaultProps = {
    size: 24
  };
  exports.default = InfoIcon;
});
unwrapExports(Info);
var InfoOutline = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M11 17h2v-6h-2v6zm1-15C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM11 9h2V7h-2v2z'
    }));
  };

  var InfoOutlineIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  InfoOutlineIcon.displayName = 'InfoOutlineIcon';
  InfoOutlineIcon.defaultProps = {
    size: 24
  };
  exports.default = InfoOutlineIcon;
});
unwrapExports(InfoOutline);
var Input = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21 3.01H3c-1.1 0-2 .9-2 2V9h2V4.99h18v14.03H3V15H1v4.01c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98v-14c0-1.11-.9-2-2-2zM11 16l4-4-4-4v3H1v2h10v3z'
    }));
  };

  var InputIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  InputIcon.displayName = 'InputIcon';
  InputIcon.defaultProps = {
    size: 24
  };
  exports.default = InputIcon;
});
unwrapExports(Input);
var InsertChart = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z'
    }));
  };

  var InsertChartIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  InsertChartIcon.displayName = 'InsertChartIcon';
  InsertChartIcon.defaultProps = {
    size: 24
  };
  exports.default = InsertChartIcon;
});
unwrapExports(InsertChart);
var InsertComment = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z'
    }));
  };

  var InsertCommentIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  InsertCommentIcon.displayName = 'InsertCommentIcon';
  InsertCommentIcon.defaultProps = {
    size: 24
  };
  exports.default = InsertCommentIcon;
});
unwrapExports(InsertComment);
var InsertDriveFile = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M6 2c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6H6zm7 7V3.5L18.5 9H13z'
    }));
  };

  var InsertDriveFileIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  InsertDriveFileIcon.displayName = 'InsertDriveFileIcon';
  InsertDriveFileIcon.defaultProps = {
    size: 24
  };
  exports.default = InsertDriveFileIcon;
});
unwrapExports(InsertDriveFile);
var InsertEmoticon = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z'
    }));
  };

  var InsertEmoticonIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  InsertEmoticonIcon.displayName = 'InsertEmoticonIcon';
  InsertEmoticonIcon.defaultProps = {
    size: 24
  };
  exports.default = InsertEmoticonIcon;
});
unwrapExports(InsertEmoticon);
var InsertInvitation = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z'
    }));
  };

  var InsertInvitationIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  InsertInvitationIcon.displayName = 'InsertInvitationIcon';
  InsertInvitationIcon.defaultProps = {
    size: 24
  };
  exports.default = InsertInvitationIcon;
});
unwrapExports(InsertInvitation);
var InsertLink = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z'
    }));
  };

  var InsertLinkIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  InsertLinkIcon.displayName = 'InsertLinkIcon';
  InsertLinkIcon.defaultProps = {
    size: 24
  };
  exports.default = InsertLinkIcon;
});
unwrapExports(InsertLink);
var InsertPhoto = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z'
    }));
  };

  var InsertPhotoIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  InsertPhotoIcon.displayName = 'InsertPhotoIcon';
  InsertPhotoIcon.defaultProps = {
    size: 24
  };
  exports.default = InsertPhotoIcon;
});
unwrapExports(InsertPhoto);
var InvertColors = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M17.66 7.93L12 2.27 6.34 7.93c-3.12 3.12-3.12 8.19 0 11.31C7.9 20.8 9.95 21.58 12 21.58c2.05 0 4.1-.78 5.66-2.34 3.12-3.12 3.12-8.19 0-11.31zM12 19.59c-1.6 0-3.11-.62-4.24-1.76C6.62 16.69 6 15.19 6 13.59s.62-3.11 1.76-4.24L12 5.1v14.49z'
    }));
  };

  var InvertColorsIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  InvertColorsIcon.displayName = 'InvertColorsIcon';
  InvertColorsIcon.defaultProps = {
    size: 24
  };
  exports.default = InvertColorsIcon;
});
unwrapExports(InvertColors);
var InvertColorsOff = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20.65 20.87l-2.35-2.35-6.3-6.29-3.56-3.57-1.42-1.41L4.27 4.5 3 5.77l2.78 2.78c-2.55 3.14-2.36 7.76.56 10.69C7.9 20.8 9.95 21.58 12 21.58c1.79 0 3.57-.59 5.03-1.78l2.7 2.7L21 21.23l-.35-.36zM12 19.59c-1.6 0-3.11-.62-4.24-1.76C6.62 16.69 6 15.19 6 13.59c0-1.32.43-2.57 1.21-3.6L12 14.77v4.82zM12 5.1v4.58l7.25 7.26c1.37-2.96.84-6.57-1.6-9.01L12 2.27l-3.7 3.7 1.41 1.41L12 5.1z'
    }));
  };

  var InvertColorsOffIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  InvertColorsOffIcon.displayName = 'InvertColorsOffIcon';
  InvertColorsOffIcon.defaultProps = {
    size: 24
  };
  exports.default = InvertColorsOffIcon;
});
unwrapExports(InvertColorsOff);
var Iso = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5.5 7.5h2v-2H9v2h2V9H9v2H7.5V9h-2V7.5zM19 19H5L19 5v14zm-2-2v-1.5h-5V17h5z'
    }));
  };

  var IsoIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  IsoIcon.displayName = 'IsoIcon';
  IsoIcon.defaultProps = {
    size: 24
  };
  exports.default = IsoIcon;
});
unwrapExports(Iso);
var Keyboard = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 5H4c-1.1 0-1.99.9-1.99 2L2 17c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-9 3h2v2h-2V8zm0 3h2v2h-2v-2zM8 8h2v2H8V8zm0 3h2v2H8v-2zm-1 2H5v-2h2v2zm0-3H5V8h2v2zm9 7H8v-2h8v2zm0-4h-2v-2h2v2zm0-3h-2V8h2v2zm3 3h-2v-2h2v2zm0-3h-2V8h2v2z'
    }));
  };

  var KeyboardIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  KeyboardIcon.displayName = 'KeyboardIcon';
  KeyboardIcon.defaultProps = {
    size: 24
  };
  exports.default = KeyboardIcon;
});
unwrapExports(Keyboard);
var KeyboardArrowDown = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z'
    }));
  };

  var KeyboardArrowDownIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  KeyboardArrowDownIcon.displayName = 'KeyboardArrowDownIcon';
  KeyboardArrowDownIcon.defaultProps = {
    size: 24
  };
  exports.default = KeyboardArrowDownIcon;
});
unwrapExports(KeyboardArrowDown);
var KeyboardArrowLeft = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z'
    }));
  };

  var KeyboardArrowLeftIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  KeyboardArrowLeftIcon.displayName = 'KeyboardArrowLeftIcon';
  KeyboardArrowLeftIcon.defaultProps = {
    size: 24
  };
  exports.default = KeyboardArrowLeftIcon;
});
unwrapExports(KeyboardArrowLeft);
var KeyboardArrowRight = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z'
    }));
  };

  var KeyboardArrowRightIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  KeyboardArrowRightIcon.displayName = 'KeyboardArrowRightIcon';
  KeyboardArrowRightIcon.defaultProps = {
    size: 24
  };
  exports.default = KeyboardArrowRightIcon;
});
unwrapExports(KeyboardArrowRight);
var KeyboardArrowUp = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z'
    }));
  };

  var KeyboardArrowUpIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  KeyboardArrowUpIcon.displayName = 'KeyboardArrowUpIcon';
  KeyboardArrowUpIcon.defaultProps = {
    size: 24
  };
  exports.default = KeyboardArrowUpIcon;
});
unwrapExports(KeyboardArrowUp);
var KeyboardBackspace = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21 11H6.83l3.58-3.59L9 6l-6 6 6 6 1.41-1.41L6.83 13H21z'
    }));
  };

  var KeyboardBackspaceIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  KeyboardBackspaceIcon.displayName = 'KeyboardBackspaceIcon';
  KeyboardBackspaceIcon.defaultProps = {
    size: 24
  };
  exports.default = KeyboardBackspaceIcon;
});
unwrapExports(KeyboardBackspace);
var KeyboardCapslock = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 8.41L16.59 13 18 11.59l-6-6-6 6L7.41 13 12 8.41zM6 18h12v-2H6v2z'
    }));
  };

  var KeyboardCapslockIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  KeyboardCapslockIcon.displayName = 'KeyboardCapslockIcon';
  KeyboardCapslockIcon.defaultProps = {
    size: 24
  };
  exports.default = KeyboardCapslockIcon;
});
unwrapExports(KeyboardCapslock);
var KeyboardHide = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 3H4c-1.1 0-1.99.9-1.99 2L2 15c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 3h2v2h-2V6zm0 3h2v2h-2V9zM8 6h2v2H8V6zm0 3h2v2H8V9zm-1 2H5V9h2v2zm0-3H5V6h2v2zm9 7H8v-2h8v2zm0-4h-2V9h2v2zm0-3h-2V6h2v2zm3 3h-2V9h2v2zm0-3h-2V6h2v2zm-7 15l4-4H8l4 4z'
    }));
  };

  var KeyboardHideIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  KeyboardHideIcon.displayName = 'KeyboardHideIcon';
  KeyboardHideIcon.defaultProps = {
    size: 24
  };
  exports.default = KeyboardHideIcon;
});
unwrapExports(KeyboardHide);
var KeyboardReturn = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 7v4H5.83l3.58-3.59L8 6l-6 6 6 6 1.41-1.41L5.83 13H21V7z'
    }));
  };

  var KeyboardReturnIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  KeyboardReturnIcon.displayName = 'KeyboardReturnIcon';
  KeyboardReturnIcon.defaultProps = {
    size: 24
  };
  exports.default = KeyboardReturnIcon;
});
unwrapExports(KeyboardReturn);
var KeyboardTab = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M11.59 7.41L15.17 11H1v2h14.17l-3.59 3.59L13 18l6-6-6-6-1.41 1.41zM20 6v12h2V6h-2z'
    }));
  };

  var KeyboardTabIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  KeyboardTabIcon.displayName = 'KeyboardTabIcon';
  KeyboardTabIcon.defaultProps = {
    size: 24
  };
  exports.default = KeyboardTabIcon;
});
unwrapExports(KeyboardTab);
var KeyboardVoice = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 15c1.66 0 2.99-1.34 2.99-3L15 6c0-1.66-1.34-3-3-3S9 4.34 9 6v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 15 6.7 12H5c0 3.42 2.72 6.23 6 6.72V22h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z'
    }));
  };

  var KeyboardVoiceIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  KeyboardVoiceIcon.displayName = 'KeyboardVoiceIcon';
  KeyboardVoiceIcon.defaultProps = {
    size: 24
  };
  exports.default = KeyboardVoiceIcon;
});
unwrapExports(KeyboardVoice);
var Kitchen = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M18 2.01L6 2c-1.1 0-2 .89-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.11-.9-1.99-2-1.99zM18 20H6v-9.02h12V20zm0-11H6V4h12v5zM8 5h2v3H8zm0 7h2v5H8z'
    }));
  };

  var KitchenIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  KitchenIcon.displayName = 'KitchenIcon';
  KitchenIcon.defaultProps = {
    size: 24
  };
  exports.default = KitchenIcon;
});
unwrapExports(Kitchen);
var Label = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16z'
    }));
  };

  var LabelIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LabelIcon.displayName = 'LabelIcon';
  LabelIcon.defaultProps = {
    size: 24
  };
  exports.default = LabelIcon;
});
unwrapExports(Label);
var LabelOutline = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16zM16 17H5V7h11l3.55 5L16 17z'
    }));
  };

  var LabelOutlineIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LabelOutlineIcon.displayName = 'LabelOutlineIcon';
  LabelOutlineIcon.defaultProps = {
    size: 24
  };
  exports.default = LabelOutlineIcon;
});
unwrapExports(LabelOutline);
var Landscape = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M14 6l-3.75 5 2.85 3.8-1.6 1.2C9.81 13.75 7 10 7 10l-6 8h22L14 6z'
    }));
  };

  var LandscapeIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LandscapeIcon.displayName = 'LandscapeIcon';
  LandscapeIcon.defaultProps = {
    size: 24
  };
  exports.default = LandscapeIcon;
});
unwrapExports(Landscape);
var Language = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2 0 .68.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2 0-.68.07-1.35.16-2h4.68c.09.65.16 1.32.16 2 0 .68-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2 0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z'
    }));
  };

  var LanguageIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LanguageIcon.displayName = 'LanguageIcon';
  LanguageIcon.defaultProps = {
    size: 24
  };
  exports.default = LanguageIcon;
});
unwrapExports(Language);
var Laptop = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z'
    }));
  };

  var LaptopIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LaptopIcon.displayName = 'LaptopIcon';
  LaptopIcon.defaultProps = {
    size: 24
  };
  exports.default = LaptopIcon;
});
unwrapExports(Laptop);
var LaptopChromebook = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M22 18V3H2v15H0v2h24v-2h-2zm-8 0h-4v-1h4v1zm6-3H4V5h16v10z'
    }));
  };

  var LaptopChromebookIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LaptopChromebookIcon.displayName = 'LaptopChromebookIcon';
  LaptopChromebookIcon.defaultProps = {
    size: 24
  };
  exports.default = LaptopChromebookIcon;
});
unwrapExports(LaptopChromebook);
var LaptopMac = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 18c1.1 0 1.99-.9 1.99-2L22 5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2H0c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2h-4zM4 5h16v11H4V5zm8 14c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z'
    }));
  };

  var LaptopMacIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LaptopMacIcon.displayName = 'LaptopMacIcon';
  LaptopMacIcon.defaultProps = {
    size: 24
  };
  exports.default = LaptopMacIcon;
});
unwrapExports(LaptopMac);
var LaptopWindows = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 18v-1c1.1 0 1.99-.9 1.99-2L22 5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2v1H0v2h24v-2h-4zM4 5h16v10H4V5z'
    }));
  };

  var LaptopWindowsIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LaptopWindowsIcon.displayName = 'LaptopWindowsIcon';
  LaptopWindowsIcon.defaultProps = {
    size: 24
  };
  exports.default = LaptopWindowsIcon;
});
unwrapExports(LaptopWindows);
var LastPage = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z'
    }));
  };

  var LastPageIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LastPageIcon.displayName = 'LastPageIcon';
  LastPageIcon.defaultProps = {
    size: 24
  };
  exports.default = LastPageIcon;
});
unwrapExports(LastPage);
var Launch = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z'
    }));
  };

  var LaunchIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LaunchIcon.displayName = 'LaunchIcon';
  LaunchIcon.defaultProps = {
    size: 24
  };
  exports.default = LaunchIcon;
});
unwrapExports(Launch);
var Layers = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M11.99 18.54l-7.37-5.73L3 14.07l9 7 9-7-1.63-1.27-7.38 5.74zM12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27L12 16z'
    }));
  };

  var LayersIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LayersIcon.displayName = 'LayersIcon';
  LayersIcon.defaultProps = {
    size: 24
  };
  exports.default = LayersIcon;
});
unwrapExports(Layers);
var LayersClear = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19.81 14.99l1.19-.92-1.43-1.43-1.19.92 1.43 1.43zm-.45-4.72L21 9l-9-7-2.91 2.27 7.87 7.88 2.4-1.88zM3.27 1L2 2.27l4.22 4.22L3 9l1.63 1.27L12 16l2.1-1.63 1.43 1.43L12 18.54l-7.37-5.73L3 14.07l9 7 4.95-3.85L20.73 21 22 19.73 3.27 1z'
    }));
  };

  var LayersClearIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LayersClearIcon.displayName = 'LayersClearIcon';
  LayersClearIcon.defaultProps = {
    size: 24
  };
  exports.default = LayersClearIcon;
});
unwrapExports(LayersClear);
var LeakAdd = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M6 3H3v3c1.66 0 3-1.34 3-3zm8 0h-2c0 4.97-4.03 9-9 9v2c6.08 0 11-4.93 11-11zm-4 0H8c0 2.76-2.24 5-5 5v2c3.87 0 7-3.13 7-7zm0 18h2c0-4.97 4.03-9 9-9v-2c-6.07 0-11 4.93-11 11zm8 0h3v-3c-1.66 0-3 1.34-3 3zm-4 0h2c0-2.76 2.24-5 5-5v-2c-3.87 0-7 3.13-7 7z'
    }));
  };

  var LeakAddIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LeakAddIcon.displayName = 'LeakAddIcon';
  LeakAddIcon.defaultProps = {
    size: 24
  };
  exports.default = LeakAddIcon;
});
unwrapExports(LeakAdd);
var LeakRemove = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M10 3H8c0 .37-.04.72-.12 1.06l1.59 1.59C9.81 4.84 10 3.94 10 3zM3 4.27l2.84 2.84C5.03 7.67 4.06 8 3 8v2c1.61 0 3.09-.55 4.27-1.46L8.7 9.97C7.14 11.24 5.16 12 3 12v2c2.71 0 5.19-.99 7.11-2.62l2.5 2.5C10.99 15.81 10 18.29 10 21h2c0-2.16.76-4.14 2.03-5.69l1.43 1.43C14.55 17.91 14 19.39 14 21h2c0-1.06.33-2.03.89-2.84L19.73 21 21 19.73 4.27 3 3 4.27zM14 3h-2c0 1.5-.37 2.91-1.02 4.16l1.46 1.46C13.42 6.98 14 5.06 14 3zm5.94 13.12c.34-.08.69-.12 1.06-.12v-2c-.94 0-1.84.19-2.66.52l1.6 1.6zm-4.56-4.56l1.46 1.46C18.09 12.37 19.5 12 21 12v-2c-2.06 0-3.98.58-5.62 1.56z'
    }));
  };

  var LeakRemoveIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LeakRemoveIcon.displayName = 'LeakRemoveIcon';
  LeakRemoveIcon.defaultProps = {
    size: 24
  };
  exports.default = LeakRemoveIcon;
});
unwrapExports(LeakRemove);
var Lens = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z'
    }));
  };

  var LensIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LensIcon.displayName = 'LensIcon';
  LensIcon.defaultProps = {
    size: 24
  };
  exports.default = LensIcon;
});
unwrapExports(Lens);
var LibraryAdd = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z'
    }));
  };

  var LibraryAddIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LibraryAddIcon.displayName = 'LibraryAddIcon';
  LibraryAddIcon.defaultProps = {
    size: 24
  };
  exports.default = LibraryAddIcon;
});
unwrapExports(LibraryAdd);
var LibraryBooks = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9H9V9h10v2zm-4 4H9v-2h6v2zm4-8H9V5h10v2z'
    }));
  };

  var LibraryBooksIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LibraryBooksIcon.displayName = 'LibraryBooksIcon';
  LibraryBooksIcon.defaultProps = {
    size: 24
  };
  exports.default = LibraryBooksIcon;
});
unwrapExports(LibraryBooks);
var LibraryMusic = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 5h-3v5.5c0 1.38-1.12 2.5-2.5 2.5S10 13.88 10 12.5s1.12-2.5 2.5-2.5c.57 0 1.08.19 1.5.51V5h4v2zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6z'
    }));
  };

  var LibraryMusicIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LibraryMusicIcon.displayName = 'LibraryMusicIcon';
  LibraryMusicIcon.defaultProps = {
    size: 24
  };
  exports.default = LibraryMusicIcon;
});
unwrapExports(LibraryMusic);
var LightbulbOutline = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M9 21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1H9v1zm3-19C8.14 2 5 5.14 5 9c0 2.38 1.19 4.47 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26c1.81-1.27 3-3.36 3-5.74 0-3.86-3.14-7-7-7zm2.85 11.1l-.85.6V16h-4v-2.3l-.85-.6C7.8 12.16 7 10.63 7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 1.63-.8 3.16-2.15 4.1z'
    }));
  };

  var LightbulbOutlineIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LightbulbOutlineIcon.displayName = 'LightbulbOutlineIcon';
  LightbulbOutlineIcon.defaultProps = {
    size: 24
  };
  exports.default = LightbulbOutlineIcon;
});
unwrapExports(LightbulbOutline);
var LineStyle = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M3 16h5v-2H3v2zm6.5 0h5v-2h-5v2zm6.5 0h5v-2h-5v2zM3 20h2v-2H3v2zm4 0h2v-2H7v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zM3 12h8v-2H3v2zm10 0h8v-2h-8v2zM3 4v4h18V4H3z'
    }));
  };

  var LineStyleIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LineStyleIcon.displayName = 'LineStyleIcon';
  LineStyleIcon.defaultProps = {
    size: 24
  };
  exports.default = LineStyleIcon;
});
unwrapExports(LineStyle);
var LineWeight = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M3 17h18v-2H3v2zm0 3h18v-1H3v1zm0-7h18v-3H3v3zm0-9v4h18V4H3z'
    }));
  };

  var LineWeightIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LineWeightIcon.displayName = 'LineWeightIcon';
  LineWeightIcon.defaultProps = {
    size: 24
  };
  exports.default = LineWeightIcon;
});
unwrapExports(LineWeight);
var LinearScale = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19.5 9.5c-1.03 0-1.9.62-2.29 1.5h-2.92c-.39-.88-1.26-1.5-2.29-1.5s-1.9.62-2.29 1.5H6.79c-.39-.88-1.26-1.5-2.29-1.5C3.12 9.5 2 10.62 2 12s1.12 2.5 2.5 2.5c1.03 0 1.9-.62 2.29-1.5h2.92c.39.88 1.26 1.5 2.29 1.5s1.9-.62 2.29-1.5h2.92c.39.88 1.26 1.5 2.29 1.5 1.38 0 2.5-1.12 2.5-2.5s-1.12-2.5-2.5-2.5z'
    }));
  };

  var LinearScaleIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LinearScaleIcon.displayName = 'LinearScaleIcon';
  LinearScaleIcon.defaultProps = {
    size: 24
  };
  exports.default = LinearScaleIcon;
});
unwrapExports(LinearScale);
var Link = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z'
    }));
  };

  var LinkIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LinkIcon.displayName = 'LinkIcon';
  LinkIcon.defaultProps = {
    size: 24
  };
  exports.default = LinkIcon;
});
unwrapExports(Link);
var LinkedCamera = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M 12 10.8 A 3.2 3.2 0 0 1 12 17.2 A 3.2 3.2 0 0 1 12 10.8 M16 3.33c2.58 0 4.67 2.09 4.67 4.67H22c0-3.31-2.69-6-6-6v1.33M16 6c1.11 0 2 .89 2 2h1.33c0-1.84-1.49-3.33-3.33-3.33V6 M17 9c0-1.11-.89-2-2-2V4H9L7.17 6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9h-5zm-5 10c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z'
    }));
  };

  var LinkedCameraIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LinkedCameraIcon.displayName = 'LinkedCameraIcon';
  LinkedCameraIcon.defaultProps = {
    size: 24
  };
  exports.default = LinkedCameraIcon;
});
unwrapExports(LinkedCamera);
var List = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z'
    }));
  };

  var ListIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ListIcon.displayName = 'ListIcon';
  ListIcon.defaultProps = {
    size: 24
  };
  exports.default = ListIcon;
});
unwrapExports(List);
var LiveHelp = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 16h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 11.9 13 12.5 13 14h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z'
    }));
  };

  var LiveHelpIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LiveHelpIcon.displayName = 'LiveHelpIcon';
  LiveHelpIcon.defaultProps = {
    size: 24
  };
  exports.default = LiveHelpIcon;
});
unwrapExports(LiveHelp);
var LiveTv = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21 6h-7.59l3.29-3.29L16 2l-4 4-4-4-.71.71L10.59 6H3c-1.1 0-2 .89-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.11-.9-2-2-2zm0 14H3V8h18v12zM9 10v8l7-4z'
    }));
  };

  var LiveTvIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LiveTvIcon.displayName = 'LiveTvIcon';
  LiveTvIcon.defaultProps = {
    size: 24
  };
  exports.default = LiveTvIcon;
});
unwrapExports(LiveTv);
var LocalActivity = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 12c0-1.1.9-2 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2zm-4.42 4.8L12 14.5l-3.58 2.3 1.08-4.12-3.29-2.69 4.24-.25L12 5.8l1.54 3.95 4.24.25-3.29 2.69 1.09 4.11z'
    }));
  };

  var LocalActivityIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LocalActivityIcon.displayName = 'LocalActivityIcon';
  LocalActivityIcon.defaultProps = {
    size: 24
  };
  exports.default = LocalActivityIcon;
});
unwrapExports(LocalActivity);
var LocalAirport = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z'
    }));
  };

  var LocalAirportIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LocalAirportIcon.displayName = 'LocalAirportIcon';
  LocalAirportIcon.defaultProps = {
    size: 24
  };
  exports.default = LocalAirportIcon;
});
unwrapExports(LocalAirport);
var LocalAtm = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M11 17h2v-1h1c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1h-3v-1h4V8h-2V7h-2v1h-1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h3v1H9v2h2v1zm9-13H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4V6h16v12z'
    }));
  };

  var LocalAtmIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LocalAtmIcon.displayName = 'LocalAtmIcon';
  LocalAtmIcon.defaultProps = {
    size: 24
  };
  exports.default = LocalAtmIcon;
});
unwrapExports(LocalAtm);
var LocalBar = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21 5V3H3v2l8 9v5H6v2h12v-2h-5v-5l8-9zM7.43 7L5.66 5h12.69l-1.78 2H7.43z'
    }));
  };

  var LocalBarIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LocalBarIcon.displayName = 'LocalBarIcon';
  LocalBarIcon.defaultProps = {
    size: 24
  };
  exports.default = LocalBarIcon;
});
unwrapExports(LocalBar);
var LocalCafe = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 3H4v10c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2zm0 5h-2V5h2v3zM2 21h18v-2H2v2z'
    }));
  };

  var LocalCafeIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LocalCafeIcon.displayName = 'LocalCafeIcon';
  LocalCafeIcon.defaultProps = {
    size: 24
  };
  exports.default = LocalCafeIcon;
});
unwrapExports(LocalCafe);
var LocalCarWash = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M17 5c.83 0 1.5-.67 1.5-1.5 0-1-1.5-2.7-1.5-2.7s-1.5 1.7-1.5 2.7c0 .83.67 1.5 1.5 1.5zm-5 0c.83 0 1.5-.67 1.5-1.5 0-1-1.5-2.7-1.5-2.7s-1.5 1.7-1.5 2.7c0 .83.67 1.5 1.5 1.5zM7 5c.83 0 1.5-.67 1.5-1.5C8.5 2.5 7 .8 7 .8S5.5 2.5 5.5 3.5C5.5 4.33 6.17 5 7 5zm11.92 3.01C18.72 7.42 18.16 7 17.5 7h-11c-.66 0-1.21.42-1.42 1.01L3 14v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 18c-.83 0-1.5-.67-1.5-1.5S5.67 15 6.5 15s1.5.67 1.5 1.5S7.33 18 6.5 18zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 13l1.5-4.5h11L19 13H5z'
    }));
  };

  var LocalCarWashIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LocalCarWashIcon.displayName = 'LocalCarWashIcon';
  LocalCarWashIcon.defaultProps = {
    size: 24
  };
  exports.default = LocalCarWashIcon;
});
unwrapExports(LocalCarWash);
var LocalConvenienceStore = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 7V4H5v3H2v13h8v-4h4v4h8V7h-3zm-8 3H9v1h2v1H8V9h2V8H8V7h3v3zm5 2h-1v-2h-2V7h1v2h1V7h1v5z'
    }));
  };

  var LocalConvenienceStoreIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LocalConvenienceStoreIcon.displayName = 'LocalConvenienceStoreIcon';
  LocalConvenienceStoreIcon.defaultProps = {
    size: 24
  };
  exports.default = LocalConvenienceStoreIcon;
});
unwrapExports(LocalConvenienceStore);
var LocalDining = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M8.1 13.34l2.83-2.83L3.91 3.5c-1.56 1.56-1.56 4.09 0 5.66l4.19 4.18zm6.78-1.81c1.53.71 3.68.21 5.27-1.38 1.91-1.91 2.28-4.65.81-6.12-1.46-1.46-4.2-1.1-6.12.81-1.59 1.59-2.09 3.74-1.38 5.27L3.7 19.87l1.41 1.41L12 14.41l6.88 6.88 1.41-1.41L13.41 13l1.47-1.47z'
    }));
  };

  var LocalDiningIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LocalDiningIcon.displayName = 'LocalDiningIcon';
  LocalDiningIcon.defaultProps = {
    size: 24
  };
  exports.default = LocalDiningIcon;
});
unwrapExports(LocalDining);
var LocalDrink = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M3 2l2.01 18.23C5.13 21.23 5.97 22 7 22h10c1.03 0 1.87-.77 1.99-1.77L21 2H3zm9 17c-1.66 0-3-1.34-3-3 0-2 3-5.4 3-5.4s3 3.4 3 5.4c0 1.66-1.34 3-3 3zm6.33-11H5.67l-.44-4h13.53l-.43 4z'
    }));
  };

  var LocalDrinkIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LocalDrinkIcon.displayName = 'LocalDrinkIcon';
  LocalDrinkIcon.defaultProps = {
    size: 24
  };
  exports.default = LocalDrinkIcon;
});
unwrapExports(LocalDrink);
var LocalFlorist = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 22c4.97 0 9-4.03 9-9-4.97 0-9 4.03-9 9zM5.6 10.25c0 1.38 1.12 2.5 2.5 2.5.53 0 1.01-.16 1.42-.44l-.02.19c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5l-.02-.19c.4.28.89.44 1.42.44 1.38 0 2.5-1.12 2.5-2.5 0-1-.59-1.85-1.43-2.25.84-.4 1.43-1.25 1.43-2.25 0-1.38-1.12-2.5-2.5-2.5-.53 0-1.01.16-1.42.44l.02-.19C14.5 2.12 13.38 1 12 1S9.5 2.12 9.5 3.5l.02.19c-.4-.28-.89-.44-1.42-.44-1.38 0-2.5 1.12-2.5 2.5 0 1 .59 1.85 1.43 2.25-.84.4-1.43 1.25-1.43 2.25zM12 5.5c1.38 0 2.5 1.12 2.5 2.5s-1.12 2.5-2.5 2.5S9.5 9.38 9.5 8s1.12-2.5 2.5-2.5zM3 13c0 4.97 4.03 9 9 9 0-4.97-4.03-9-9-9z'
    }));
  };

  var LocalFloristIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LocalFloristIcon.displayName = 'LocalFloristIcon';
  LocalFloristIcon.defaultProps = {
    size: 24
  };
  exports.default = LocalFloristIcon;
});
unwrapExports(LocalFlorist);
var LocalGasStation = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19.77 7.23l.01-.01-3.72-3.72L15 4.56l2.11 2.11c-.94.36-1.61 1.26-1.61 2.33 0 1.38 1.12 2.5 2.5 2.5.36 0 .69-.08 1-.21v7.21c0 .55-.45 1-1 1s-1-.45-1-1V14c0-1.1-.9-2-2-2h-1V5c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v16h10v-7.5h1.5v5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V9c0-.69-.28-1.32-.73-1.77zM12 10H6V5h6v5zm6 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z'
    }));
  };

  var LocalGasStationIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LocalGasStationIcon.displayName = 'LocalGasStationIcon';
  LocalGasStationIcon.defaultProps = {
    size: 24
  };
  exports.default = LocalGasStationIcon;
});
unwrapExports(LocalGasStation);
var LocalGroceryStore = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z'
    }));
  };

  var LocalGroceryStoreIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LocalGroceryStoreIcon.displayName = 'LocalGroceryStoreIcon';
  LocalGroceryStoreIcon.defaultProps = {
    size: 24
  };
  exports.default = LocalGroceryStoreIcon;
});
unwrapExports(LocalGroceryStore);
var LocalHospital = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 3H5c-1.1 0-1.99.9-1.99 2L3 19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 11h-4v4h-4v-4H6v-4h4V6h4v4h4v4z'
    }));
  };

  var LocalHospitalIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LocalHospitalIcon.displayName = 'LocalHospitalIcon';
  LocalHospitalIcon.defaultProps = {
    size: 24
  };
  exports.default = LocalHospitalIcon;
});
unwrapExports(LocalHospital);
var LocalHotel = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M7 13c1.66 0 3-1.34 3-3S8.66 7 7 7s-3 1.34-3 3 1.34 3 3 3zm12-6h-8v7H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4z'
    }));
  };

  var LocalHotelIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LocalHotelIcon.displayName = 'LocalHotelIcon';
  LocalHotelIcon.defaultProps = {
    size: 24
  };
  exports.default = LocalHotelIcon;
});
unwrapExports(LocalHotel);
var LocalLaundryService = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M9.17 16.83c1.56 1.56 4.1 1.56 5.66 0 1.56-1.56 1.56-4.1 0-5.66l-5.66 5.66zM18 2.01L6 2c-1.11 0-2 .89-2 2v16c0 1.11.89 2 2 2h12c1.11 0 2-.89 2-2V4c0-1.11-.89-1.99-2-1.99zM10 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM7 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm5 16c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z'
    }));
  };

  var LocalLaundryServiceIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LocalLaundryServiceIcon.displayName = 'LocalLaundryServiceIcon';
  LocalLaundryServiceIcon.defaultProps = {
    size: 24
  };
  exports.default = LocalLaundryServiceIcon;
});
unwrapExports(LocalLaundryService);
var LocalLibrary = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 11.55C9.64 9.35 6.48 8 3 8v11c3.48 0 6.64 1.35 9 3.55 2.36-2.19 5.52-3.55 9-3.55V8c-3.48 0-6.64 1.35-9 3.55zM12 8c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3z'
    }));
  };

  var LocalLibraryIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LocalLibraryIcon.displayName = 'LocalLibraryIcon';
  LocalLibraryIcon.defaultProps = {
    size: 24
  };
  exports.default = LocalLibraryIcon;
});
unwrapExports(LocalLibrary);
var LocalMall = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 6h-2c0-2.76-2.24-5-5-5S7 3.24 7 6H5c-1.1 0-1.99.9-1.99 2L3 20c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-7-3c1.66 0 3 1.34 3 3H9c0-1.66 1.34-3 3-3zm0 10c-2.76 0-5-2.24-5-5h2c0 1.66 1.34 3 3 3s3-1.34 3-3h2c0 2.76-2.24 5-5 5z'
    }));
  };

  var LocalMallIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LocalMallIcon.displayName = 'LocalMallIcon';
  LocalMallIcon.defaultProps = {
    size: 24
  };
  exports.default = LocalMallIcon;
});
unwrapExports(LocalMall);
var LocalMovies = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M18 3v2h-2V3H8v2H6V3H4v18h2v-2h2v2h8v-2h2v2h2V3h-2zM8 17H6v-2h2v2zm0-4H6v-2h2v2zm0-4H6V7h2v2zm10 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2z'
    }));
  };

  var LocalMoviesIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LocalMoviesIcon.displayName = 'LocalMoviesIcon';
  LocalMoviesIcon.defaultProps = {
    size: 24
  };
  exports.default = LocalMoviesIcon;
});
unwrapExports(LocalMovies);
var LocalOffer = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z'
    }));
  };

  var LocalOfferIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LocalOfferIcon.displayName = 'LocalOfferIcon';
  LocalOfferIcon.defaultProps = {
    size: 24
  };
  exports.default = LocalOfferIcon;
});
unwrapExports(LocalOffer);
var LocalParking = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M13 3H6v18h4v-6h3c3.31 0 6-2.69 6-6s-2.69-6-6-6zm.2 8H10V7h3.2c1.1 0 2 .9 2 2s-.9 2-2 2z'
    }));
  };

  var LocalParkingIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LocalParkingIcon.displayName = 'LocalParkingIcon';
  LocalParkingIcon.defaultProps = {
    size: 24
  };
  exports.default = LocalParkingIcon;
});
unwrapExports(LocalParking);
var LocalPharmacy = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21 5h-2.64l1.14-3.14L17.15 1l-1.46 4H3v2l2 6-2 6v2h18v-2l-2-6 2-6V5zm-5 9h-3v3h-2v-3H8v-2h3V9h2v3h3v2z'
    }));
  };

  var LocalPharmacyIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LocalPharmacyIcon.displayName = 'LocalPharmacyIcon';
  LocalPharmacyIcon.defaultProps = {
    size: 24
  };
  exports.default = LocalPharmacyIcon;
});
unwrapExports(LocalPharmacy);
var LocalPhone = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z'
    }));
  };

  var LocalPhoneIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LocalPhoneIcon.displayName = 'LocalPhoneIcon';
  LocalPhoneIcon.defaultProps = {
    size: 24
  };
  exports.default = LocalPhoneIcon;
});
unwrapExports(LocalPhone);
var LocalPizza = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 2C8.43 2 5.23 3.54 3.01 6L12 22l8.99-16C18.78 3.55 15.57 2 12 2zM7 7c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm5 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z'
    }));
  };

  var LocalPizzaIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LocalPizzaIcon.displayName = 'LocalPizzaIcon';
  LocalPizzaIcon.defaultProps = {
    size: 24
  };
  exports.default = LocalPizzaIcon;
});
unwrapExports(LocalPizza);
var LocalPlay = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 12c0-1.1.9-2 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2zm-4.42 4.8L12 14.5l-3.58 2.3 1.08-4.12-3.29-2.69 4.24-.25L12 5.8l1.54 3.95 4.24.25-3.29 2.69 1.09 4.11z'
    }));
  };

  var LocalPlayIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LocalPlayIcon.displayName = 'LocalPlayIcon';
  LocalPlayIcon.defaultProps = {
    size: 24
  };
  exports.default = LocalPlayIcon;
});
unwrapExports(LocalPlay);
var LocalPostOffice = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z'
    }));
  };

  var LocalPostOfficeIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LocalPostOfficeIcon.displayName = 'LocalPostOfficeIcon';
  LocalPostOfficeIcon.defaultProps = {
    size: 24
  };
  exports.default = LocalPostOfficeIcon;
});
unwrapExports(LocalPostOffice);
var LocalPrintshop = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z'
    }));
  };

  var LocalPrintshopIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LocalPrintshopIcon.displayName = 'LocalPrintshopIcon';
  LocalPrintshopIcon.defaultProps = {
    size: 24
  };
  exports.default = LocalPrintshopIcon;
});
unwrapExports(LocalPrintshop);
var LocalSee = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M 12 8.8 A 3.2 3.2 0 0 1 12 15.2 A 3.2 3.2 0 0 1 12 8.8 M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z'
    }));
  };

  var LocalSeeIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LocalSeeIcon.displayName = 'LocalSeeIcon';
  LocalSeeIcon.defaultProps = {
    size: 24
  };
  exports.default = LocalSeeIcon;
});
unwrapExports(LocalSee);
var LocalShipping = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z'
    }));
  };

  var LocalShippingIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LocalShippingIcon.displayName = 'LocalShippingIcon';
  LocalShippingIcon.defaultProps = {
    size: 24
  };
  exports.default = LocalShippingIcon;
});
unwrapExports(LocalShipping);
var LocalTaxi = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M18.92 6.01C18.72 5.42 18.16 5 17.5 5H15V3H9v2H6.5c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z'
    }));
  };

  var LocalTaxiIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LocalTaxiIcon.displayName = 'LocalTaxiIcon';
  LocalTaxiIcon.defaultProps = {
    size: 24
  };
  exports.default = LocalTaxiIcon;
});
unwrapExports(LocalTaxi);
var LocationCity = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M15 11V5l-3-3-3 3v2H3v14h18V11h-6zm-8 8H5v-2h2v2zm0-4H5v-2h2v2zm0-4H5V9h2v2zm6 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V9h2v2zm0-4h-2V5h2v2zm6 12h-2v-2h2v2zm0-4h-2v-2h2v2z'
    }));
  };

  var LocationCityIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LocationCityIcon.displayName = 'LocationCityIcon';
  LocationCityIcon.defaultProps = {
    size: 24
  };
  exports.default = LocationCityIcon;
});
unwrapExports(LocationCity);
var LocationDisabled = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06c-1.13.12-2.19.46-3.16.97l1.5 1.5C10.16 5.19 11.06 5 12 5c3.87 0 7 3.13 7 7 0 .94-.19 1.84-.52 2.65l1.5 1.5c.5-.96.84-2.02.97-3.15H23v-2h-2.06zM3 4.27l2.04 2.04C3.97 7.62 3.25 9.23 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c1.77-.2 3.38-.91 4.69-1.98L19.73 21 21 19.73 4.27 3 3 4.27zm13.27 13.27C15.09 18.45 13.61 19 12 19c-3.87 0-7-3.13-7-7 0-1.61.55-3.09 1.46-4.27l9.81 9.81z'
    }));
  };

  var LocationDisabledIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LocationDisabledIcon.displayName = 'LocationDisabledIcon';
  LocationDisabledIcon.defaultProps = {
    size: 24
  };
  exports.default = LocationDisabledIcon;
});
unwrapExports(LocationDisabled);
var LocationOff = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 6.5c1.38 0 2.5 1.12 2.5 2.5 0 .74-.33 1.39-.83 1.85l3.63 3.63c.98-1.86 1.7-3.8 1.7-5.48 0-3.87-3.13-7-7-7-1.98 0-3.76.83-5.04 2.15l3.19 3.19c.46-.52 1.11-.84 1.85-.84zm4.37 9.6l-4.63-4.63-.11-.11L3.27 3 2 4.27l3.18 3.18C5.07 7.95 5 8.47 5 9c0 5.25 7 13 7 13s1.67-1.85 3.38-4.35L18.73 21 20 19.73l-3.63-3.63z'
    }));
  };

  var LocationOffIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LocationOffIcon.displayName = 'LocationOffIcon';
  LocationOffIcon.defaultProps = {
    size: 24
  };
  exports.default = LocationOffIcon;
});
unwrapExports(LocationOff);
var LocationOn = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z'
    }));
  };

  var LocationOnIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LocationOnIcon.displayName = 'LocationOnIcon';
  LocationOnIcon.defaultProps = {
    size: 24
  };
  exports.default = LocationOnIcon;
});
unwrapExports(LocationOn);
var LocationSearching = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z'
    }));
  };

  var LocationSearchingIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LocationSearchingIcon.displayName = 'LocationSearchingIcon';
  LocationSearchingIcon.defaultProps = {
    size: 24
  };
  exports.default = LocationSearchingIcon;
});
unwrapExports(LocationSearching);
var Lock = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z'
    }));
  };

  var LockIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LockIcon.displayName = 'LockIcon';
  LockIcon.defaultProps = {
    size: 24
  };
  exports.default = LockIcon;
});
unwrapExports(Lock);
var LockOpen = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h1.9c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm0 12H6V10h12v10z'
    }));
  };

  var LockOpenIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LockOpenIcon.displayName = 'LockOpenIcon';
  LockOpenIcon.defaultProps = {
    size: 24
  };
  exports.default = LockOpenIcon;
});
unwrapExports(LockOpen);
var LockOutline = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2H8.9V6zM18 20H6V10h12v10z'
    }));
  };

  var LockOutlineIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LockOutlineIcon.displayName = 'LockOutlineIcon';
  LockOutlineIcon.defaultProps = {
    size: 24
  };
  exports.default = LockOutlineIcon;
});
unwrapExports(LockOutline);
var Looks = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 10c-3.86 0-7 3.14-7 7h2c0-2.76 2.24-5 5-5s5 2.24 5 5h2c0-3.86-3.14-7-7-7zm0-4C5.93 6 1 10.93 1 17h2c0-4.96 4.04-9 9-9s9 4.04 9 9h2c0-6.07-4.93-11-11-11z'
    }));
  };

  var LooksIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LooksIcon.displayName = 'LooksIcon';
  LooksIcon.defaultProps = {
    size: 24
  };
  exports.default = LooksIcon;
});
unwrapExports(Looks);
var Looks3 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19.01 3h-14c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 7.5c0 .83-.67 1.5-1.5 1.5.83 0 1.5.67 1.5 1.5V15c0 1.11-.9 2-2 2h-4v-2h4v-2h-2v-2h2V9h-4V7h4c1.1 0 2 .89 2 2v1.5z'
    }));
  };

  var Looks3Icon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  Looks3Icon.displayName = 'Looks3Icon';
  Looks3Icon.defaultProps = {
    size: 24
  };
  exports.default = Looks3Icon;
});
unwrapExports(Looks3);
var Looks4 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 14h-2v-4H9V7h2v4h2V7h2v10z'
    }));
  };

  var Looks4Icon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  Looks4Icon.displayName = 'Looks4Icon';
  Looks4Icon.defaultProps = {
    size: 24
  };
  exports.default = Looks4Icon;
});
unwrapExports(Looks4);
var Looks5 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 6h-4v2h2c1.1 0 2 .89 2 2v2c0 1.11-.9 2-2 2H9v-2h4v-2H9V7h6v2z'
    }));
  };

  var Looks5Icon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  Looks5Icon.displayName = 'Looks5Icon';
  Looks5Icon.defaultProps = {
    size: 24
  };
  exports.default = Looks5Icon;
});
unwrapExports(Looks5);
var Looks6 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M11 15h2v-2h-2v2zm8-12H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 6h-4v2h2c1.1 0 2 .89 2 2v2c0 1.11-.9 2-2 2h-2c-1.1 0-2-.89-2-2V9c0-1.11.9-2 2-2h4v2z'
    }));
  };

  var Looks6Icon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  Looks6Icon.displayName = 'Looks6Icon';
  Looks6Icon.defaultProps = {
    size: 24
  };
  exports.default = Looks6Icon;
});
unwrapExports(Looks6);
var LooksOne = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14h-2V9h-2V7h4v10z'
    }));
  };

  var LooksOneIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LooksOneIcon.displayName = 'LooksOneIcon';
  LooksOneIcon.defaultProps = {
    size: 24
  };
  exports.default = LooksOneIcon;
});
unwrapExports(LooksOne);
var LooksTwo = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 8c0 1.11-.9 2-2 2h-2v2h4v2H9v-4c0-1.11.9-2 2-2h2V9H9V7h4c1.1 0 2 .89 2 2v2z'
    }));
  };

  var LooksTwoIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LooksTwoIcon.displayName = 'LooksTwoIcon';
  LooksTwoIcon.defaultProps = {
    size: 24
  };
  exports.default = LooksTwoIcon;
});
unwrapExports(LooksTwo);
var Loop = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z'
    }));
  };

  var LoopIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LoopIcon.displayName = 'LoopIcon';
  LoopIcon.defaultProps = {
    size: 24
  };
  exports.default = LoopIcon;
});
unwrapExports(Loop);
var Loupe = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.49 2 2 6.49 2 12s4.49 10 10 10h8c1.1 0 2-.9 2-2v-8c0-5.51-4.49-10-10-10zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z'
    }));
  };

  var LoupeIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LoupeIcon.displayName = 'LoupeIcon';
  LoupeIcon.defaultProps = {
    size: 24
  };
  exports.default = LoupeIcon;
});
unwrapExports(Loupe);
var LowPriority = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M14 5h8v2h-8zm0 5.5h8v2h-8zm0 5.5h8v2h-8zM2 11.5C2 15.08 4.92 18 8.5 18H9v2l3-3-3-3v2h-.5C6.02 16 4 13.98 4 11.5S6.02 7 8.5 7H12V5H8.5C4.92 5 2 7.92 2 11.5z'
    }));
  };

  var LowPriorityIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LowPriorityIcon.displayName = 'LowPriorityIcon';
  LowPriorityIcon.defaultProps = {
    size: 24
  };
  exports.default = LowPriorityIcon;
});
unwrapExports(LowPriority);
var Loyalty = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7zm11.77 8.27L13 19.54l-4.27-4.27C8.28 14.81 8 14.19 8 13.5c0-1.38 1.12-2.5 2.5-2.5.69 0 1.32.28 1.77.74l.73.72.73-.73c.45-.45 1.08-.73 1.77-.73 1.38 0 2.5 1.12 2.5 2.5 0 .69-.28 1.32-.73 1.77z'
    }));
  };

  var LoyaltyIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  LoyaltyIcon.displayName = 'LoyaltyIcon';
  LoyaltyIcon.defaultProps = {
    size: 24
  };
  exports.default = LoyaltyIcon;
});
unwrapExports(Loyalty);
var Mail = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z'
    }));
  };

  var MailIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  MailIcon.displayName = 'MailIcon';
  MailIcon.defaultProps = {
    size: 24
  };
  exports.default = MailIcon;
});
unwrapExports(Mail);
var MailOutline = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z'
    }));
  };

  var MailOutlineIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  MailOutlineIcon.displayName = 'MailOutlineIcon';
  MailOutlineIcon.defaultProps = {
    size: 24
  };
  exports.default = MailOutlineIcon;
});
unwrapExports(MailOutline);

var _Map = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20.5 3l-.16.03L15 5.1 9 3 3.36 4.9c-.21.07-.36.25-.36.48V20.5c0 .28.22.5.5.5l.16-.03L9 18.9l6 2.1 5.64-1.9c.21-.07.36-.25.36-.48V3.5c0-.28-.22-.5-.5-.5zM15 19l-6-2.11V5l6 2.11V19z'
    }));
  };

  var MapIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  MapIcon.displayName = 'MapIcon';
  MapIcon.defaultProps = {
    size: 24
  };
  exports.default = MapIcon;
});

unwrapExports(_Map);
var Markunread = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z'
    }));
  };

  var MarkunreadIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  MarkunreadIcon.displayName = 'MarkunreadIcon';
  MarkunreadIcon.defaultProps = {
    size: 24
  };
  exports.default = MarkunreadIcon;
});
unwrapExports(Markunread);
var MarkunreadMailbox = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 6H10v6H8V4h6V0H6v6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2z'
    }));
  };

  var MarkunreadMailboxIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  MarkunreadMailboxIcon.displayName = 'MarkunreadMailboxIcon';
  MarkunreadMailboxIcon.defaultProps = {
    size: 24
  };
  exports.default = MarkunreadMailboxIcon;
});
unwrapExports(MarkunreadMailbox);
var Memory = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M15 9H9v6h6V9zm-2 4h-2v-2h2v2zm8-2V9h-2V7c0-1.1-.9-2-2-2h-2V3h-2v2h-2V3H9v2H7c-1.1 0-2 .9-2 2v2H3v2h2v2H3v2h2v2c0 1.1.9 2 2 2h2v2h2v-2h2v2h2v-2h2c1.1 0 2-.9 2-2v-2h2v-2h-2v-2h2zm-4 6H7V7h10v10z'
    }));
  };

  var MemoryIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  MemoryIcon.displayName = 'MemoryIcon';
  MemoryIcon.defaultProps = {
    size: 24
  };
  exports.default = MemoryIcon;
});
unwrapExports(Memory);
var Menu = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z'
    }));
  };

  var MenuIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  MenuIcon.displayName = 'MenuIcon';
  MenuIcon.defaultProps = {
    size: 24
  };
  exports.default = MenuIcon;
});
unwrapExports(Menu);
var MergeType = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M17 20.41L18.41 19 15 15.59 13.59 17 17 20.41zM7.5 8H11v5.59L5.59 19 7 20.41l6-6V8h3.5L12 3.5 7.5 8z'
    }));
  };

  var MergeTypeIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  MergeTypeIcon.displayName = 'MergeTypeIcon';
  MergeTypeIcon.defaultProps = {
    size: 24
  };
  exports.default = MergeTypeIcon;
});
unwrapExports(MergeType);
var Message = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z'
    }));
  };

  var MessageIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  MessageIcon.displayName = 'MessageIcon';
  MessageIcon.defaultProps = {
    size: 24
  };
  exports.default = MessageIcon;
});
unwrapExports(Message);
var Mic = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z'
    }));
  };

  var MicIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  MicIcon.displayName = 'MicIcon';
  MicIcon.defaultProps = {
    size: 24
  };
  exports.default = MicIcon;
});
unwrapExports(Mic);
var MicNone = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm-1.2-9.1c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2l-.01 6.2c0 .66-.53 1.2-1.19 1.2-.66 0-1.2-.54-1.2-1.2V4.9zm6.5 6.1c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z'
    }));
  };

  var MicNoneIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  MicNoneIcon.displayName = 'MicNoneIcon';
  MicNoneIcon.defaultProps = {
    size: 24
  };
  exports.default = MicNoneIcon;
});
unwrapExports(MicNone);
var MicOff = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 11h-1.7c0 .74-.16 1.43-.43 2.05l1.23 1.23c.56-.98.9-2.09.9-3.28zm-4.02.17c0-.06.02-.11.02-.17V5c0-1.66-1.34-3-3-3S9 3.34 9 5v.18l5.98 5.99zM4.27 3L3 4.27l6.01 6.01V11c0 1.66 1.33 3 2.99 3 .22 0 .44-.03.65-.08l1.66 1.66c-.71.33-1.5.52-2.31.52-2.76 0-5.3-2.1-5.3-5.1H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c.91-.13 1.77-.45 2.54-.9L19.73 21 21 19.73 4.27 3z'
    }));
  };

  var MicOffIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  MicOffIcon.displayName = 'MicOffIcon';
  MicOffIcon.defaultProps = {
    size: 24
  };
  exports.default = MicOffIcon;
});
unwrapExports(MicOff);
var Mms = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM5 14l3.5-4.5 2.5 3.01L14.5 8l4.5 6H5z'
    }));
  };

  var MmsIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  MmsIcon.displayName = 'MmsIcon';
  MmsIcon.defaultProps = {
    size: 24
  };
  exports.default = MmsIcon;
});
unwrapExports(Mms);
var ModeComment = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18z'
    }));
  };

  var ModeCommentIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ModeCommentIcon.displayName = 'ModeCommentIcon';
  ModeCommentIcon.defaultProps = {
    size: 24
  };
  exports.default = ModeCommentIcon;
});
unwrapExports(ModeComment);
var ModeEdit = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z'
    }));
  };

  var ModeEditIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ModeEditIcon.displayName = 'ModeEditIcon';
  ModeEditIcon.defaultProps = {
    size: 24
  };
  exports.default = ModeEditIcon;
});
unwrapExports(ModeEdit);
var MonetizationOn = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H14.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.91s4.18 1.39 4.18 3.91c-.01 1.83-1.38 2.83-3.12 3.16z'
    }));
  };

  var MonetizationOnIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  MonetizationOnIcon.displayName = 'MonetizationOnIcon';
  MonetizationOnIcon.defaultProps = {
    size: 24
  };
  exports.default = MonetizationOnIcon;
});
unwrapExports(MonetizationOn);
var MoneyOff = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12.5 6.9c1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-.53.12-1.03.3-1.48.54l1.47 1.47c.41-.17.91-.27 1.51-.27zM5.33 4.06L4.06 5.33 7.5 8.77c0 2.08 1.56 3.21 3.91 3.91l3.51 3.51c-.34.48-1.05.91-2.42.91-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c.96-.18 1.82-.55 2.45-1.12l2.22 2.22 1.27-1.27L5.33 4.06z'
    }));
  };

  var MoneyOffIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  MoneyOffIcon.displayName = 'MoneyOffIcon';
  MoneyOffIcon.defaultProps = {
    size: 24
  };
  exports.default = MoneyOffIcon;
});
unwrapExports(MoneyOff);
var MonochromePhotos = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 5h-3.2L15 3H9L7.2 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 14h-8v-1c-2.8 0-5-2.2-5-5s2.2-5 5-5V7h8v12zm-3-6c0-2.8-2.2-5-5-5v1.8c1.8 0 3.2 1.4 3.2 3.2s-1.4 3.2-3.2 3.2V18c2.8 0 5-2.2 5-5zm-8.2 0c0 1.8 1.4 3.2 3.2 3.2V9.8c-1.8 0-3.2 1.4-3.2 3.2z'
    }));
  };

  var MonochromePhotosIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  MonochromePhotosIcon.displayName = 'MonochromePhotosIcon';
  MonochromePhotosIcon.defaultProps = {
    size: 24
  };
  exports.default = MonochromePhotosIcon;
});
unwrapExports(MonochromePhotos);
var Mood = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z'
    }));
  };

  var MoodIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  MoodIcon.displayName = 'MoodIcon';
  MoodIcon.defaultProps = {
    size: 24
  };
  exports.default = MoodIcon;
});
unwrapExports(Mood);
var MoodBad = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 3c-2.33 0-4.31 1.46-5.11 3.5h10.22c-.8-2.04-2.78-3.5-5.11-3.5z'
    }));
  };

  var MoodBadIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  MoodBadIcon.displayName = 'MoodBadIcon';
  MoodBadIcon.defaultProps = {
    size: 24
  };
  exports.default = MoodBadIcon;
});
unwrapExports(MoodBad);
var More = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M22 3H7c-.69 0-1.23.35-1.59.88L0 12l5.41 8.11c.36.53.97.89 1.66.89H22c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 13.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z'
    }));
  };

  var MoreIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  MoreIcon.displayName = 'MoreIcon';
  MoreIcon.defaultProps = {
    size: 24
  };
  exports.default = MoreIcon;
});
unwrapExports(More);
var MoreHoriz = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z'
    }));
  };

  var MoreHorizIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  MoreHorizIcon.displayName = 'MoreHorizIcon';
  MoreHorizIcon.defaultProps = {
    size: 24
  };
  exports.default = MoreHorizIcon;
});
unwrapExports(MoreHoriz);
var MoreVert = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z'
    }));
  };

  var MoreVertIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  MoreVertIcon.displayName = 'MoreVertIcon';
  MoreVertIcon.defaultProps = {
    size: 24
  };
  exports.default = MoreVertIcon;
});
unwrapExports(MoreVert);
var Motorcycle = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19.44 9.03L15.41 5H11v2h3.59l2 2H5c-2.8 0-5 2.2-5 5s2.2 5 5 5c2.46 0 4.45-1.69 4.9-4h1.65l2.77-2.77c-.21.54-.32 1.14-.32 1.77 0 2.8 2.2 5 5 5s5-2.2 5-5c0-2.65-1.97-4.77-4.56-4.97zM7.82 15C7.4 16.15 6.28 17 5 17c-1.63 0-3-1.37-3-3s1.37-3 3-3c1.28 0 2.4.85 2.82 2H5v2h2.82zM19 17c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z'
    }));
  };

  var MotorcycleIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  MotorcycleIcon.displayName = 'MotorcycleIcon';
  MotorcycleIcon.defaultProps = {
    size: 24
  };
  exports.default = MotorcycleIcon;
});
unwrapExports(Motorcycle);
var Mouse = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M13 1.07V9h7c0-4.08-3.05-7.44-7-7.93zM4 15c0 4.42 3.58 8 8 8s8-3.58 8-8v-4H4v4zm7-13.93C7.05 1.56 4 4.92 4 9h7V1.07z'
    }));
  };

  var MouseIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  MouseIcon.displayName = 'MouseIcon';
  MouseIcon.defaultProps = {
    size: 24
  };
  exports.default = MouseIcon;
});
unwrapExports(Mouse);
var MoveToInbox = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 3H4.99c-1.11 0-1.98.9-1.98 2L3 19c0 1.1.88 2 1.99 2H19c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 12h-4c0 1.66-1.35 3-3 3s-3-1.34-3-3H4.99V5H19v10zm-3-5h-2V7h-4v3H8l4 4 4-4z'
    }));
  };

  var MoveToInboxIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  MoveToInboxIcon.displayName = 'MoveToInboxIcon';
  MoveToInboxIcon.defaultProps = {
    size: 24
  };
  exports.default = MoveToInboxIcon;
});
unwrapExports(MoveToInbox);
var Movie = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M18 4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4z'
    }));
  };

  var MovieIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  MovieIcon.displayName = 'MovieIcon';
  MovieIcon.defaultProps = {
    size: 24
  };
  exports.default = MovieIcon;
});
unwrapExports(Movie);
var MovieCreation = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M18 4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4z'
    }));
  };

  var MovieCreationIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  MovieCreationIcon.displayName = 'MovieCreationIcon';
  MovieCreationIcon.defaultProps = {
    size: 24
  };
  exports.default = MovieCreationIcon;
});
unwrapExports(MovieCreation);
var MovieFilter = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M18 4l2 3h-3l-2-3h-2l2 3h-3l-2-3H8l2 3H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4zm-6.75 11.25L10 18l-1.25-2.75L6 14l2.75-1.25L10 10l1.25 2.75L14 14l-2.75 1.25zm5.69-3.31L16 14l-.94-2.06L13 11l2.06-.94L16 8l.94 2.06L19 11l-2.06.94z'
    }));
  };

  var MovieFilterIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  MovieFilterIcon.displayName = 'MovieFilterIcon';
  MovieFilterIcon.defaultProps = {
    size: 24
  };
  exports.default = MovieFilterIcon;
});
unwrapExports(MovieFilter);
var MultilineChart = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M22 6.92l-1.41-1.41-2.85 3.21C15.68 6.4 12.83 5 9.61 5 6.72 5 4.07 6.16 2 8l1.42 1.42C5.12 7.93 7.27 7 9.61 7c2.74 0 5.09 1.26 6.77 3.24l-2.88 3.24-4-4L2 16.99l1.5 1.5 6-6.01 4 4 4.05-4.55c.75 1.35 1.25 2.9 1.44 4.55H21c-.22-2.3-.95-4.39-2.04-6.14L22 6.92z'
    }));
  };

  var MultilineChartIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  MultilineChartIcon.displayName = 'MultilineChartIcon';
  MultilineChartIcon.defaultProps = {
    size: 24
  };
  exports.default = MultilineChartIcon;
});
unwrapExports(MultilineChart);
var MusicNote = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z'
    }));
  };

  var MusicNoteIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  MusicNoteIcon.displayName = 'MusicNoteIcon';
  MusicNoteIcon.defaultProps = {
    size: 24
  };
  exports.default = MusicNoteIcon;
});
unwrapExports(MusicNote);
var MusicVideo = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM8 15c0-1.66 1.34-3 3-3 .35 0 .69.07 1 .18V6h5v2h-3v7.03c-.02 1.64-1.35 2.97-3 2.97-1.66 0-3-1.34-3-3z'
    }));
  };

  var MusicVideoIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  MusicVideoIcon.displayName = 'MusicVideoIcon';
  MusicVideoIcon.defaultProps = {
    size: 24
  };
  exports.default = MusicVideoIcon;
});
unwrapExports(MusicVideo);
var MyLocation = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z'
    }));
  };

  var MyLocationIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  MyLocationIcon.displayName = 'MyLocationIcon';
  MyLocationIcon.defaultProps = {
    size: 24
  };
  exports.default = MyLocationIcon;
});
unwrapExports(MyLocation);
var Nature = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M13 16.12c3.47-.41 6.17-3.36 6.17-6.95 0-3.87-3.13-7-7-7s-7 3.13-7 7c0 3.47 2.52 6.34 5.83 6.89V20H5v2h14v-2h-6v-3.88z'
    }));
  };

  var NatureIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  NatureIcon.displayName = 'NatureIcon';
  NatureIcon.defaultProps = {
    size: 24
  };
  exports.default = NatureIcon;
});
unwrapExports(Nature);
var NaturePeople = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M22.17 9.17c0-3.87-3.13-7-7-7s-7 3.13-7 7c0 3.47 2.52 6.34 5.83 6.89V20H6v-3h1v-4c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v4h1v5h16v-2h-3v-3.88c3.47-.41 6.17-3.36 6.17-6.95zM4.5 11c.83 0 1.5-.67 1.5-1.5S5.33 8 4.5 8 3 8.67 3 9.5 3.67 11 4.5 11z'
    }));
  };

  var NaturePeopleIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  NaturePeopleIcon.displayName = 'NaturePeopleIcon';
  NaturePeopleIcon.defaultProps = {
    size: 24
  };
  exports.default = NaturePeopleIcon;
});
unwrapExports(NaturePeople);
var NavigateBefore = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z'
    }));
  };

  var NavigateBeforeIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  NavigateBeforeIcon.displayName = 'NavigateBeforeIcon';
  NavigateBeforeIcon.defaultProps = {
    size: 24
  };
  exports.default = NavigateBeforeIcon;
});
unwrapExports(NavigateBefore);
var NavigateNext = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z'
    }));
  };

  var NavigateNextIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  NavigateNextIcon.displayName = 'NavigateNextIcon';
  NavigateNextIcon.defaultProps = {
    size: 24
  };
  exports.default = NavigateNextIcon;
});
unwrapExports(NavigateNext);
var Navigation = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 2L4.5 20.29l.71.71L12 18l6.79 3 .71-.71z'
    }));
  };

  var NavigationIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  NavigationIcon.displayName = 'NavigationIcon';
  NavigationIcon.defaultProps = {
    size: 24
  };
  exports.default = NavigationIcon;
});
unwrapExports(Navigation);
var NearMe = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21 3L3 10.53v.98l6.84 2.65L12.48 21h.98L21 3z'
    }));
  };

  var NearMeIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  NearMeIcon.displayName = 'NearMeIcon';
  NearMeIcon.defaultProps = {
    size: 24
  };
  exports.default = NearMeIcon;
});
unwrapExports(NearMe);
var NetworkCell = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M2 22h20V2z M17 7L2 22h15z'
    }));
  };

  var NetworkCellIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  NetworkCellIcon.displayName = 'NetworkCellIcon';
  NetworkCellIcon.defaultProps = {
    size: 24
  };
  exports.default = NetworkCellIcon;
});
unwrapExports(NetworkCell);
var NetworkCheck = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M15.9 5c-.17 0-.32.09-.41.23l-.07.15-5.18 11.65c-.16.29-.26.61-.26.96 0 1.11.9 2.01 2.01 2.01.96 0 1.77-.68 1.96-1.59l.01-.03L16.4 5.5c0-.28-.22-.5-.5-.5zM1 9l2 2c2.88-2.88 6.79-4.08 10.53-3.62l1.19-2.68C9.89 3.84 4.74 5.27 1 9zm20 2l2-2c-1.64-1.64-3.55-2.82-5.59-3.57l-.53 2.82c1.5.62 2.9 1.53 4.12 2.75zm-4 4l2-2c-.8-.8-1.7-1.42-2.66-1.89l-.55 2.92c.42.27.83.59 1.21.97zM5 13l2 2c1.13-1.13 2.56-1.79 4.03-2l1.28-2.88c-2.63-.08-5.3.87-7.31 2.88z'
    }));
  };

  var NetworkCheckIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  NetworkCheckIcon.displayName = 'NetworkCheckIcon';
  NetworkCheckIcon.defaultProps = {
    size: 24
  };
  exports.default = NetworkCheckIcon;
});
unwrapExports(NetworkCheck);
var NetworkLocked = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19.5 10c.17 0 .33.03.5.05V1L1 20h13v-3c0-.89.39-1.68 1-2.23v-.27c0-2.48 2.02-4.5 4.5-4.5zm2.5 6v-1.5c0-1.38-1.12-2.5-2.5-2.5S17 13.12 17 14.5V16c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1zm-1 0h-3v-1.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V16z'
    }));
  };

  var NetworkLockedIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  NetworkLockedIcon.displayName = 'NetworkLockedIcon';
  NetworkLockedIcon.defaultProps = {
    size: 24
  };
  exports.default = NetworkLockedIcon;
});
unwrapExports(NetworkLocked);
var NetworkWifi = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z M3.53 10.95l8.46 10.54.01.01.01-.01 8.46-10.54C20.04 10.62 16.81 8 12 8c-4.81 0-8.04 2.62-8.47 2.95z'
    }));
  };

  var NetworkWifiIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  NetworkWifiIcon.displayName = 'NetworkWifiIcon';
  NetworkWifiIcon.defaultProps = {
    size: 24
  };
  exports.default = NetworkWifiIcon;
});
unwrapExports(NetworkWifi);
var NewReleases = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M23 12l-2.44-2.78.34-3.68-3.61-.82-1.89-3.18L12 3 8.6 1.54 6.71 4.72l-3.61.81.34 3.68L1 12l2.44 2.78-.34 3.69 3.61.82 1.89 3.18L12 21l3.4 1.46 1.89-3.18 3.61-.82-.34-3.68L23 12zm-10 5h-2v-2h2v2zm0-4h-2V7h2v6z'
    }));
  };

  var NewReleasesIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  NewReleasesIcon.displayName = 'NewReleasesIcon';
  NewReleasesIcon.defaultProps = {
    size: 24
  };
  exports.default = NewReleasesIcon;
});
unwrapExports(NewReleases);
var NextWeek = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 7h-4V5c0-.55-.22-1.05-.59-1.41C15.05 3.22 14.55 3 14 3h-4c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zM10 5h4v2h-4V5zm1 13.5l-1-1 3-3-3-3 1-1 4 4-4 4z'
    }));
  };

  var NextWeekIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  NextWeekIcon.displayName = 'NextWeekIcon';
  NextWeekIcon.defaultProps = {
    size: 24
  };
  exports.default = NextWeekIcon;
});
unwrapExports(NextWeek);
var Nfc = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 18H4V4h16v16zM18 6h-5c-1.1 0-2 .9-2 2v2.28c-.6.35-1 .98-1 1.72 0 1.1.9 2 2 2s2-.9 2-2c0-.74-.4-1.38-1-1.72V8h3v8H8V8h2V6H6v12h12V6z'
    }));
  };

  var NfcIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  NfcIcon.displayName = 'NfcIcon';
  NfcIcon.defaultProps = {
    size: 24
  };
  exports.default = NfcIcon;
});
unwrapExports(Nfc);
var NoEncryption = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21 21.78L4.22 5 3 6.22l2.04 2.04C4.42 8.6 4 9.25 4 10v10c0 1.1.9 2 2 2h12c.23 0 .45-.05.66-.12L19.78 23 21 21.78zM8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2H9.66L20 18.34V10c0-1.1-.9-2-2-2h-1V6c0-2.76-2.24-5-5-5-2.56 0-4.64 1.93-4.94 4.4L8.9 7.24V6z'
    }));
  };

  var NoEncryptionIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  NoEncryptionIcon.displayName = 'NoEncryptionIcon';
  NoEncryptionIcon.defaultProps = {
    size: 24
  };
  exports.default = NoEncryptionIcon;
});
unwrapExports(NoEncryption);
var NoSim = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M18.99 5c0-1.1-.89-2-1.99-2h-7L7.66 5.34 19 16.68 18.99 5zM3.65 3.88L2.38 5.15 5 7.77V19c0 1.1.9 2 2 2h10.01c.35 0 .67-.1.96-.26l1.88 1.88 1.27-1.27L3.65 3.88z'
    }));
  };

  var NoSimIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  NoSimIcon.displayName = 'NoSimIcon';
  NoSimIcon.defaultProps = {
    size: 24
  };
  exports.default = NoSimIcon;
});
unwrapExports(NoSim);
var NotInterested = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31C15.55 19.37 13.85 20 12 20zm6.31-3.1L7.1 5.69C8.45 4.63 10.15 4 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z'
    }));
  };

  var NotInterestedIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  NotInterestedIcon.displayName = 'NotInterestedIcon';
  NotInterestedIcon.defaultProps = {
    size: 24
  };
  exports.default = NotInterestedIcon;
});
unwrapExports(NotInterested);
var Note = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M22 10l-6-6H4c-1.1 0-2 .9-2 2v12.01c0 1.1.9 1.99 2 1.99l16-.01c1.1 0 2-.89 2-1.99v-8zm-7-4.5l5.5 5.5H15V5.5z'
    }));
  };

  var NoteIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  NoteIcon.displayName = 'NoteIcon';
  NoteIcon.defaultProps = {
    size: 24
  };
  exports.default = NoteIcon;
});
unwrapExports(Note);
var NoteAdd = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 14h-3v3h-2v-3H8v-2h3v-3h2v3h3v2zm-3-7V3.5L18.5 9H13z'
    }));
  };

  var NoteAddIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  NoteAddIcon.displayName = 'NoteAddIcon';
  NoteAddIcon.defaultProps = {
    size: 24
  };
  exports.default = NoteAddIcon;
});
unwrapExports(NoteAdd);
var Notifications = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z'
    }));
  };

  var NotificationsIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  NotificationsIcon.displayName = 'NotificationsIcon';
  NotificationsIcon.defaultProps = {
    size: 24
  };
  exports.default = NotificationsIcon;
});
unwrapExports(Notifications);
var NotificationsActive = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M7.58 4.08L6.15 2.65C3.75 4.48 2.17 7.3 2.03 10.5h2c.15-2.65 1.51-4.97 3.55-6.42zm12.39 6.42h2c-.15-3.2-1.73-6.02-4.12-7.85l-1.42 1.43c2.02 1.45 3.39 3.77 3.54 6.42zM18 11c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2v-5zm-6 11c.14 0 .27-.01.4-.04.65-.14 1.18-.58 1.44-1.18.1-.24.15-.5.15-.78h-4c.01 1.1.9 2 2.01 2z'
    }));
  };

  var NotificationsActiveIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  NotificationsActiveIcon.displayName = 'NotificationsActiveIcon';
  NotificationsActiveIcon.defaultProps = {
    size: 24
  };
  exports.default = NotificationsActiveIcon;
});
unwrapExports(NotificationsActive);
var NotificationsNone = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z'
    }));
  };

  var NotificationsNoneIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  NotificationsNoneIcon.displayName = 'NotificationsNoneIcon';
  NotificationsNoneIcon.defaultProps = {
    size: 24
  };
  exports.default = NotificationsNoneIcon;
});
unwrapExports(NotificationsNone);
var NotificationsOff = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 18.69L7.84 6.14 5.27 3.49 4 4.76l2.8 2.8v.01c-.52.99-.8 2.16-.8 3.42v5l-2 2v1h13.73l2 2L21 19.72l-1-1.03zM12 22c1.11 0 2-.89 2-2h-4c0 1.11.89 2 2 2zm6-7.32V11c0-3.08-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68c-.15.03-.29.08-.42.12-.1.03-.2.07-.3.11h-.01c-.01 0-.01 0-.02.01-.23.09-.46.2-.68.31 0 0-.01 0-.01.01L18 14.68z'
    }));
  };

  var NotificationsOffIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  NotificationsOffIcon.displayName = 'NotificationsOffIcon';
  NotificationsOffIcon.defaultProps = {
    size: 24
  };
  exports.default = NotificationsOffIcon;
});
unwrapExports(NotificationsOff);
var NotificationsPaused = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.93 6 11v5l-2 2v1h16v-1l-2-2zm-3.5-6.2l-2.8 3.4h2.8V15h-5v-1.8l2.8-3.4H9.5V8h5v1.8z'
    }));
  };

  var NotificationsPausedIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  NotificationsPausedIcon.displayName = 'NotificationsPausedIcon';
  NotificationsPausedIcon.defaultProps = {
    size: 24
  };
  exports.default = NotificationsPausedIcon;
});
unwrapExports(NotificationsPaused);
var OfflinePin = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm5 16H7v-2h10v2zm-6.7-4L7 10.7l1.4-1.4 1.9 1.9 5.3-5.3L17 7.3 10.3 14z'
    }));
  };

  var OfflinePinIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  OfflinePinIcon.displayName = 'OfflinePinIcon';
  OfflinePinIcon.defaultProps = {
    size: 24
  };
  exports.default = OfflinePinIcon;
});
unwrapExports(OfflinePin);
var OndemandVideo = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.11-.9-2-2-2zm0 14H3V5h18v12zm-5-6l-7 4V7z'
    }));
  };

  var OndemandVideoIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  OndemandVideoIcon.displayName = 'OndemandVideoIcon';
  OndemandVideoIcon.defaultProps = {
    size: 24
  };
  exports.default = OndemandVideoIcon;
});
unwrapExports(OndemandVideo);
var Opacity = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M17.66 8L12 2.35 6.34 8C4.78 9.56 4 11.64 4 13.64s.78 4.11 2.34 5.67 3.61 2.35 5.66 2.35 4.1-.79 5.66-2.35S20 15.64 20 13.64 19.22 9.56 17.66 8zM6 14c.01-2 .62-3.27 1.76-4.4L12 5.27l4.24 4.38C17.38 10.77 17.99 12 18 14H6z'
    }));
  };

  var OpacityIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  OpacityIcon.displayName = 'OpacityIcon';
  OpacityIcon.defaultProps = {
    size: 24
  };
  exports.default = OpacityIcon;
});
unwrapExports(Opacity);
var OpenInBrowser = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h4v-2H5V8h14v10h-4v2h4c1.1 0 2-.9 2-2V6c0-1.1-.89-2-2-2zm-7 6l-4 4h3v6h2v-6h3l-4-4z'
    }));
  };

  var OpenInBrowserIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  OpenInBrowserIcon.displayName = 'OpenInBrowserIcon';
  OpenInBrowserIcon.defaultProps = {
    size: 24
  };
  exports.default = OpenInBrowserIcon;
});
unwrapExports(OpenInBrowser);
var OpenInNew = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z'
    }));
  };

  var OpenInNewIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  OpenInNewIcon.displayName = 'OpenInNewIcon';
  OpenInNewIcon.defaultProps = {
    size: 24
  };
  exports.default = OpenInNewIcon;
});
unwrapExports(OpenInNew);
var OpenWith = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z'
    }));
  };

  var OpenWithIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  OpenWithIcon.displayName = 'OpenWithIcon';
  OpenWithIcon.defaultProps = {
    size: 24
  };
  exports.default = OpenWithIcon;
});
unwrapExports(OpenWith);
var Pages = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M3 5v6h5L7 7l4 1V3H5c-1.1 0-2 .9-2 2zm5 8H3v6c0 1.1.9 2 2 2h6v-5l-4 1 1-4zm9 4l-4-1v5h6c1.1 0 2-.9 2-2v-6h-5l1 4zm2-14h-6v5l4-1-1 4h5V5c0-1.1-.9-2-2-2z'
    }));
  };

  var PagesIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PagesIcon.displayName = 'PagesIcon';
  PagesIcon.defaultProps = {
    size: 24
  };
  exports.default = PagesIcon;
});
unwrapExports(Pages);
var Pageview = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M11.5 9C10.12 9 9 10.12 9 11.5s1.12 2.5 2.5 2.5 2.5-1.12 2.5-2.5S12.88 9 11.5 9zM20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-3.21 14.21l-2.91-2.91c-.69.44-1.51.7-2.39.7C9.01 16 7 13.99 7 11.5S9.01 7 11.5 7 16 9.01 16 11.5c0 .88-.26 1.69-.7 2.39l2.91 2.9-1.42 1.42z'
    }));
  };

  var PageviewIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PageviewIcon.displayName = 'PageviewIcon';
  PageviewIcon.defaultProps = {
    size: 24
  };
  exports.default = PageviewIcon;
});
unwrapExports(Pageview);
var Palette = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9c.83 0 1.5-.67 1.5-1.5 0-.39-.15-.74-.39-1.01-.23-.26-.38-.61-.38-.99 0-.83.67-1.5 1.5-1.5H16c2.76 0 5-2.24 5-5 0-4.42-4.03-8-9-8zm-5.5 9c-.83 0-1.5-.67-1.5-1.5S5.67 9 6.5 9 8 9.67 8 10.5 7.33 12 6.5 12zm3-4C8.67 8 8 7.33 8 6.5S8.67 5 9.5 5s1.5.67 1.5 1.5S10.33 8 9.5 8zm5 0c-.83 0-1.5-.67-1.5-1.5S13.67 5 14.5 5s1.5.67 1.5 1.5S15.33 8 14.5 8zm3 4c-.83 0-1.5-.67-1.5-1.5S16.67 9 17.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z'
    }));
  };

  var PaletteIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PaletteIcon.displayName = 'PaletteIcon';
  PaletteIcon.defaultProps = {
    size: 24
  };
  exports.default = PaletteIcon;
});
unwrapExports(Palette);
var PanTool = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M23 5.5V20c0 2.2-1.8 4-4 4h-7.3c-1.08 0-2.1-.43-2.85-1.19L1 14.83s1.26-1.23 1.3-1.25c.22-.19.49-.29.79-.29.22 0 .42.06.6.16.04.01 4.31 2.46 4.31 2.46V4c0-.83.67-1.5 1.5-1.5S11 3.17 11 4v7h1V1.5c0-.83.67-1.5 1.5-1.5S15 .67 15 1.5V11h1V2.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V11h1V5.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5z'
    }));
  };

  var PanToolIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PanToolIcon.displayName = 'PanToolIcon';
  PanToolIcon.defaultProps = {
    size: 24
  };
  exports.default = PanToolIcon;
});
unwrapExports(PanTool);
var Panorama = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M23 18V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2zM8.5 12.5l2.5 3.01L14.5 11l4.5 6H5l3.5-4.5z'
    }));
  };

  var PanoramaIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PanoramaIcon.displayName = 'PanoramaIcon';
  PanoramaIcon.defaultProps = {
    size: 24
  };
  exports.default = PanoramaIcon;
});
unwrapExports(Panorama);
var PanoramaFishEye = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z'
    }));
  };

  var PanoramaFishEyeIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PanoramaFishEyeIcon.displayName = 'PanoramaFishEyeIcon';
  PanoramaFishEyeIcon.defaultProps = {
    size: 24
  };
  exports.default = PanoramaFishEyeIcon;
});
unwrapExports(PanoramaFishEye);
var PanoramaHorizontal = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 6.54v10.91c-2.6-.77-5.28-1.16-8-1.16-2.72 0-5.4.39-8 1.16V6.54c2.6.77 5.28 1.16 8 1.16 2.72.01 5.4-.38 8-1.16M21.43 4c-.1 0-.2.02-.31.06C18.18 5.16 15.09 5.7 12 5.7c-3.09 0-6.18-.55-9.12-1.64-.11-.04-.22-.06-.31-.06-.34 0-.57.23-.57.63v14.75c0 .39.23.62.57.62.1 0 .2-.02.31-.06 2.94-1.1 6.03-1.64 9.12-1.64 3.09 0 6.18.55 9.12 1.64.11.04.21.06.31.06.33 0 .57-.23.57-.63V4.63c0-.4-.24-.63-.57-.63z'
    }));
  };

  var PanoramaHorizontalIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PanoramaHorizontalIcon.displayName = 'PanoramaHorizontalIcon';
  PanoramaHorizontalIcon.defaultProps = {
    size: 24
  };
  exports.default = PanoramaHorizontalIcon;
});
unwrapExports(PanoramaHorizontal);
var PanoramaVertical = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19.94 21.12c-1.1-2.94-1.64-6.03-1.64-9.12 0-3.09.55-6.18 1.64-9.12.04-.11.06-.22.06-.31 0-.34-.23-.57-.63-.57H4.63c-.4 0-.63.23-.63.57 0 .1.02.2.06.31C5.16 5.82 5.71 8.91 5.71 12c0 3.09-.55 6.18-1.64 9.12-.05.11-.07.22-.07.31 0 .33.23.57.63.57h14.75c.39 0 .63-.24.63-.57-.01-.1-.03-.2-.07-.31zM6.54 20c.77-2.6 1.16-5.28 1.16-8 0-2.72-.39-5.4-1.16-8h10.91c-.77 2.6-1.16 5.28-1.16 8 0 2.72.39 5.4 1.16 8H6.54z'
    }));
  };

  var PanoramaVerticalIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PanoramaVerticalIcon.displayName = 'PanoramaVerticalIcon';
  PanoramaVerticalIcon.defaultProps = {
    size: 24
  };
  exports.default = PanoramaVerticalIcon;
});
unwrapExports(PanoramaVertical);
var PanoramaWideAngle = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 6c2.45 0 4.71.2 7.29.64.47 1.78.71 3.58.71 5.36 0 1.78-.24 3.58-.71 5.36-2.58.44-4.84.64-7.29.64s-4.71-.2-7.29-.64C4.24 15.58 4 13.78 4 12c0-1.78.24-3.58.71-5.36C7.29 6.2 9.55 6 12 6m0-2c-2.73 0-5.22.24-7.95.72l-.93.16-.25.9C2.29 7.85 2 9.93 2 12s.29 4.15.87 6.22l.25.89.93.16c2.73.49 5.22.73 7.95.73s5.22-.24 7.95-.72l.93-.16.25-.89c.58-2.08.87-4.16.87-6.23s-.29-4.15-.87-6.22l-.25-.89-.93-.16C17.22 4.24 14.73 4 12 4z'
    }));
  };

  var PanoramaWideAngleIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PanoramaWideAngleIcon.displayName = 'PanoramaWideAngleIcon';
  PanoramaWideAngleIcon.defaultProps = {
    size: 24
  };
  exports.default = PanoramaWideAngleIcon;
});
unwrapExports(PanoramaWideAngle);
var PartyMode = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 4h-3.17L15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 3c1.63 0 3.06.79 3.98 2H12c-1.66 0-3 1.34-3 3 0 .35.07.69.18 1H7.1c-.06-.32-.1-.66-.1-1 0-2.76 2.24-5 5-5zm0 10c-1.63 0-3.06-.79-3.98-2H12c1.66 0 3-1.34 3-3 0-.35-.07-.69-.18-1h2.08c.07.32.1.66.1 1 0 2.76-2.24 5-5 5z'
    }));
  };

  var PartyModeIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PartyModeIcon.displayName = 'PartyModeIcon';
  PartyModeIcon.defaultProps = {
    size: 24
  };
  exports.default = PartyModeIcon;
});
unwrapExports(PartyMode);
var Pause = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M6 19h4V5H6v14zm8-14v14h4V5h-4z'
    }));
  };

  var PauseIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PauseIcon.displayName = 'PauseIcon';
  PauseIcon.defaultProps = {
    size: 24
  };
  exports.default = PauseIcon;
});
unwrapExports(Pause);
var PauseCircleFilled = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm4 0h-2V8h2v8z'
    }));
  };

  var PauseCircleFilledIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PauseCircleFilledIcon.displayName = 'PauseCircleFilledIcon';
  PauseCircleFilledIcon.defaultProps = {
    size: 24
  };
  exports.default = PauseCircleFilledIcon;
});
unwrapExports(PauseCircleFilled);
var PauseCircleOutline = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M9 16h2V8H9v8zm3-14C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm1-4h2V8h-2v8z'
    }));
  };

  var PauseCircleOutlineIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PauseCircleOutlineIcon.displayName = 'PauseCircleOutlineIcon';
  PauseCircleOutlineIcon.defaultProps = {
    size: 24
  };
  exports.default = PauseCircleOutlineIcon;
});
unwrapExports(PauseCircleOutline);
var Payment = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z'
    }));
  };

  var PaymentIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PaymentIcon.displayName = 'PaymentIcon';
  PaymentIcon.defaultProps = {
    size: 24
  };
  exports.default = PaymentIcon;
});
unwrapExports(Payment);
var People = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z'
    }));
  };

  var PeopleIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PeopleIcon.displayName = 'PeopleIcon';
  PeopleIcon.defaultProps = {
    size: 24
  };
  exports.default = PeopleIcon;
});
unwrapExports(People);
var PeopleOutline = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M16.5 13c-1.2 0-3.07.34-4.5 1-1.43-.67-3.3-1-4.5-1C5.33 13 1 14.08 1 16.25V19h22v-2.75c0-2.17-4.33-3.25-6.5-3.25zm-4 4.5h-10v-1.25c0-.54 2.56-1.75 5-1.75s5 1.21 5 1.75v1.25zm9 0H14v-1.25c0-.46-.2-.86-.52-1.22.88-.3 1.96-.53 3.02-.53 2.44 0 5 1.21 5 1.75v1.25zM7.5 12c1.93 0 3.5-1.57 3.5-3.5S9.43 5 7.5 5 4 6.57 4 8.5 5.57 12 7.5 12zm0-5.5c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 5.5c1.93 0 3.5-1.57 3.5-3.5S18.43 5 16.5 5 13 6.57 13 8.5s1.57 3.5 3.5 3.5zm0-5.5c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2z'
    }));
  };

  var PeopleOutlineIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PeopleOutlineIcon.displayName = 'PeopleOutlineIcon';
  PeopleOutlineIcon.defaultProps = {
    size: 24
  };
  exports.default = PeopleOutlineIcon;
});
unwrapExports(PeopleOutline);
var PermCameraMic = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 5h-3.17L15 3H9L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7v-2.09c-2.83-.48-5-2.94-5-5.91h2c0 2.21 1.79 4 4 4s4-1.79 4-4h2c0 2.97-2.17 5.43-5 5.91V21h7c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-6 8c0 1.1-.9 2-2 2s-2-.9-2-2V9c0-1.1.9-2 2-2s2 .9 2 2v4z'
    }));
  };

  var PermCameraMicIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PermCameraMicIcon.displayName = 'PermCameraMicIcon';
  PermCameraMicIcon.defaultProps = {
    size: 24
  };
  exports.default = PermCameraMicIcon;
});
unwrapExports(PermCameraMic);
var PermContactCalendar = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H6v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1z'
    }));
  };

  var PermContactCalendarIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PermContactCalendarIcon.displayName = 'PermContactCalendarIcon';
  PermContactCalendarIcon.defaultProps = {
    size: 24
  };
  exports.default = PermContactCalendarIcon;
});
unwrapExports(PermContactCalendar);
var PermDataSetting = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M18.99 11.5c.34 0 .67.03 1 .07L20 0 0 20h11.56c-.04-.33-.07-.66-.07-1 0-4.14 3.36-7.5 7.5-7.5zm3.71 7.99c.02-.16.04-.32.04-.49 0-.17-.01-.33-.04-.49l1.06-.83c.09-.08.12-.21.06-.32l-1-1.73c-.06-.11-.19-.15-.31-.11l-1.24.5c-.26-.2-.54-.37-.85-.49l-.19-1.32c-.01-.12-.12-.21-.24-.21h-2c-.12 0-.23.09-.25.21l-.19 1.32c-.3.13-.59.29-.85.49l-1.24-.5c-.11-.04-.24 0-.31.11l-1 1.73c-.06.11-.04.24.06.32l1.06.83c-.02.16-.03.32-.03.49 0 .17.01.33.03.49l-1.06.83c-.09.08-.12.21-.06.32l1 1.73c.06.11.19.15.31.11l1.24-.5c.26.2.54.37.85.49l.19 1.32c.02.12.12.21.25.21h2c.12 0 .23-.09.25-.21l.19-1.32c.3-.13.59-.29.84-.49l1.25.5c.11.04.24 0 .31-.11l1-1.73c.06-.11.03-.24-.06-.32l-1.07-.83zm-3.71 1.01c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z'
    }));
  };

  var PermDataSettingIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PermDataSettingIcon.displayName = 'PermDataSettingIcon';
  PermDataSettingIcon.defaultProps = {
    size: 24
  };
  exports.default = PermDataSettingIcon;
});
unwrapExports(PermDataSetting);
var PermDeviceInformation = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M13 7h-2v2h2V7zm0 4h-2v6h2v-6zm4-9.99L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z'
    }));
  };

  var PermDeviceInformationIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PermDeviceInformationIcon.displayName = 'PermDeviceInformationIcon';
  PermDeviceInformationIcon.defaultProps = {
    size: 24
  };
  exports.default = PermDeviceInformationIcon;
});
unwrapExports(PermDeviceInformation);
var PermIdentity = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z'
    }));
  };

  var PermIdentityIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PermIdentityIcon.displayName = 'PermIdentityIcon';
  PermIdentityIcon.defaultProps = {
    size: 24
  };
  exports.default = PermIdentityIcon;
});
unwrapExports(PermIdentity);
var PermMedia = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M2 6H0v5h.01L0 20c0 1.1.9 2 2 2h18v-2H2V6zm20-2h-8l-2-2H6c-1.1 0-1.99.9-1.99 2L4 16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7 15l4.5-6 3.5 4.51 2.5-3.01L21 15H7z'
    }));
  };

  var PermMediaIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PermMediaIcon.displayName = 'PermMediaIcon';
  PermMediaIcon.defaultProps = {
    size: 24
  };
  exports.default = PermMediaIcon;
});
unwrapExports(PermMedia);
var PermPhoneMsg = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 15.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.58l2.2-2.21c.28-.27.36-.66.25-1.01C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM12 3v10l3-3h6V3h-9z'
    }));
  };

  var PermPhoneMsgIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PermPhoneMsgIcon.displayName = 'PermPhoneMsgIcon';
  PermPhoneMsgIcon.defaultProps = {
    size: 24
  };
  exports.default = PermPhoneMsgIcon;
});
unwrapExports(PermPhoneMsg);
var PermScanWifi = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 3C6.95 3 3.15 4.85 0 7.23L12 22 24 7.25C20.85 4.87 17.05 3 12 3zm1 13h-2v-6h2v6zm-2-8V6h2v2h-2z'
    }));
  };

  var PermScanWifiIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PermScanWifiIcon.displayName = 'PermScanWifiIcon';
  PermScanWifiIcon.defaultProps = {
    size: 24
  };
  exports.default = PermScanWifiIcon;
});
unwrapExports(PermScanWifi);
var Person = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z'
    }));
  };

  var PersonIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PersonIcon.displayName = 'PersonIcon';
  PersonIcon.defaultProps = {
    size: 24
  };
  exports.default = PersonIcon;
});
unwrapExports(Person);
var PersonAdd = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm-9-2V7H4v3H1v2h3v3h2v-3h3v-2H6zm9 4c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z'
    }));
  };

  var PersonAddIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PersonAddIcon.displayName = 'PersonAddIcon';
  PersonAddIcon.defaultProps = {
    size: 24
  };
  exports.default = PersonAddIcon;
});
unwrapExports(PersonAdd);
var PersonOutline = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z'
    }));
  };

  var PersonOutlineIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PersonOutlineIcon.displayName = 'PersonOutlineIcon';
  PersonOutlineIcon.defaultProps = {
    size: 24
  };
  exports.default = PersonOutlineIcon;
});
unwrapExports(PersonOutline);
var PersonPin = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 3.3c1.49 0 2.7 1.21 2.7 2.7 0 1.49-1.21 2.7-2.7 2.7-1.49 0-2.7-1.21-2.7-2.7 0-1.49 1.21-2.7 2.7-2.7zM18 16H6v-.9c0-2 4-3.1 6-3.1s6 1.1 6 3.1v.9z'
    }));
  };

  var PersonPinIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PersonPinIcon.displayName = 'PersonPinIcon';
  PersonPinIcon.defaultProps = {
    size: 24
  };
  exports.default = PersonPinIcon;
});
unwrapExports(PersonPin);
var PersonPinCircle = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7zm0 2c1.1 0 2 .9 2 2 0 1.11-.9 2-2 2s-2-.89-2-2c0-1.1.9-2 2-2zm0 10c-1.67 0-3.14-.85-4-2.15.02-1.32 2.67-2.05 4-2.05s3.98.73 4 2.05c-.86 1.3-2.33 2.15-4 2.15z'
    }));
  };

  var PersonPinCircleIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PersonPinCircleIcon.displayName = 'PersonPinCircleIcon';
  PersonPinCircleIcon.defaultProps = {
    size: 24
  };
  exports.default = PersonPinCircleIcon;
});
unwrapExports(PersonPinCircle);
var PersonalVideo = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.11-.9-2-2-2zm0 14H3V5h18v12z'
    }));
  };

  var PersonalVideoIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PersonalVideoIcon.displayName = 'PersonalVideoIcon';
  PersonalVideoIcon.defaultProps = {
    size: 24
  };
  exports.default = PersonalVideoIcon;
});
unwrapExports(PersonalVideo);
var Pets = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M 4.5 7 A 2.5 2.5 0 0 1 4.5 12 A 2.5 2.5 0 0 1 4.5 7 M 9 3 A 2.5 2.5 0 0 0 9 8 A 2.5 2.5 0 0 0 9 3 M 15 3 A 2.5 2.5 0 0 1 15 8 A 2.5 2.5 0 0 1 15 3 M 19.5 7 A 2.5 2.5 0 0 0 19.5 12 A 2.5 2.5 0 0 0 19.5 7 M17.34 14.86c-.87-1.02-1.6-1.89-2.48-2.91-.46-.54-1.05-1.08-1.75-1.32-.11-.04-.22-.07-.33-.09-.25-.04-.52-.04-.78-.04s-.53 0-.79.05c-.11.02-.22.05-.33.09-.7.24-1.28.78-1.75 1.32-.87 1.02-1.6 1.89-2.48 2.91-1.31 1.31-2.92 2.76-2.62 4.79.29 1.02 1.02 2.03 2.33 2.32.73.15 3.06-.44 5.54-.44h.18c2.48 0 4.81.58 5.54.44 1.31-.29 2.04-1.31 2.33-2.32.31-2.04-1.3-3.49-2.61-4.8z'
    }));
  };

  var PetsIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PetsIcon.displayName = 'PetsIcon';
  PetsIcon.defaultProps = {
    size: 24
  };
  exports.default = PetsIcon;
});
unwrapExports(Pets);
var Phone = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z'
    }));
  };

  var PhoneIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PhoneIcon.displayName = 'PhoneIcon';
  PhoneIcon.defaultProps = {
    size: 24
  };
  exports.default = PhoneIcon;
});
unwrapExports(Phone);
var PhoneAndroid = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M16 1H8C6.34 1 5 2.34 5 4v16c0 1.66 1.34 3 3 3h8c1.66 0 3-1.34 3-3V4c0-1.66-1.34-3-3-3zm-2 20h-4v-1h4v1zm3.25-3H6.75V4h10.5v14z'
    }));
  };

  var PhoneAndroidIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PhoneAndroidIcon.displayName = 'PhoneAndroidIcon';
  PhoneAndroidIcon.defaultProps = {
    size: 24
  };
  exports.default = PhoneAndroidIcon;
});
unwrapExports(PhoneAndroid);
var PhoneBluetoothSpeaker = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M14.71 9.5L17 7.21V11h.5l2.85-2.85L18.21 6l2.15-2.15L17.5 1H17v3.79L14.71 2.5l-.71.71L16.79 6 14 8.79l.71.71zM18 2.91l.94.94-.94.94V2.91zm0 4.3l.94.94-.94.94V7.21zm2 8.29c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1z'
    }));
  };

  var PhoneBluetoothSpeakerIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PhoneBluetoothSpeakerIcon.displayName = 'PhoneBluetoothSpeakerIcon';
  PhoneBluetoothSpeakerIcon.defaultProps = {
    size: 24
  };
  exports.default = PhoneBluetoothSpeakerIcon;
});
unwrapExports(PhoneBluetoothSpeaker);
var PhoneForwarded = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M18 11l5-5-5-5v3h-4v4h4v3zm2 4.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1z'
    }));
  };

  var PhoneForwardedIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PhoneForwardedIcon.displayName = 'PhoneForwardedIcon';
  PhoneForwardedIcon.defaultProps = {
    size: 24
  };
  exports.default = PhoneForwardedIcon;
});
unwrapExports(PhoneForwarded);
var PhoneInTalk = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 15.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM19 12h2c0-4.97-4.03-9-9-9v2c3.87 0 7 3.13 7 7zm-4 0h2c0-2.76-2.24-5-5-5v2c1.66 0 3 1.34 3 3z'
    }));
  };

  var PhoneInTalkIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PhoneInTalkIcon.displayName = 'PhoneInTalkIcon';
  PhoneInTalkIcon.defaultProps = {
    size: 24
  };
  exports.default = PhoneInTalkIcon;
});
unwrapExports(PhoneInTalk);
var PhoneIphone = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M15.5 1h-8C6.12 1 5 2.12 5 3.5v17C5 21.88 6.12 23 7.5 23h8c1.38 0 2.5-1.12 2.5-2.5v-17C18 2.12 16.88 1 15.5 1zm-4 21c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4.5-4H7V4h9v14z'
    }));
  };

  var PhoneIphoneIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PhoneIphoneIcon.displayName = 'PhoneIphoneIcon';
  PhoneIphoneIcon.defaultProps = {
    size: 24
  };
  exports.default = PhoneIphoneIcon;
});
unwrapExports(PhoneIphone);
var PhoneLocked = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 15.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM20 4v-.5C20 2.12 18.88 1 17.5 1S15 2.12 15 3.5V4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm-.8 0h-3.4v-.5c0-.94.76-1.7 1.7-1.7s1.7.76 1.7 1.7V4z'
    }));
  };

  var PhoneLockedIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PhoneLockedIcon.displayName = 'PhoneLockedIcon';
  PhoneLockedIcon.defaultProps = {
    size: 24
  };
  exports.default = PhoneLockedIcon;
});
unwrapExports(PhoneLocked);
var PhoneMissed = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M6.5 5.5L12 11l7-7-1-1-6 6-4.5-4.5H11V3H5v6h1.5V5.5zm17.21 11.17C20.66 13.78 16.54 12 12 12 7.46 12 3.34 13.78.29 16.67c-.18.18-.29.43-.29.71s.11.53.29.71l2.48 2.48c.18.18.43.29.71.29.27 0 .52-.11.7-.28.79-.74 1.69-1.36 2.66-1.85.33-.16.56-.5.56-.9v-3.1c1.45-.48 3-.73 4.6-.73 1.6 0 3.15.25 4.6.72v3.1c0 .39.23.74.56.9.98.49 1.87 1.12 2.67 1.85.18.18.43.28.7.28.28 0 .53-.11.71-.29l2.48-2.48c.18-.18.29-.43.29-.71s-.12-.52-.3-.7z'
    }));
  };

  var PhoneMissedIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PhoneMissedIcon.displayName = 'PhoneMissedIcon';
  PhoneMissedIcon.defaultProps = {
    size: 24
  };
  exports.default = PhoneMissedIcon;
});
unwrapExports(PhoneMissed);
var PhonePaused = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M17 3h-2v7h2V3zm3 12.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM19 3v7h2V3h-2z'
    }));
  };

  var PhonePausedIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PhonePausedIcon.displayName = 'PhonePausedIcon';
  PhonePausedIcon.defaultProps = {
    size: 24
  };
  exports.default = PhonePausedIcon;
});
unwrapExports(PhonePaused);
var Phonelink = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M4 6h18V4H4c-1.1 0-2 .9-2 2v11H0v3h14v-3H4V6zm19 2h-6c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-1 9h-4v-7h4v7z'
    }));
  };

  var PhonelinkIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PhonelinkIcon.displayName = 'PhonelinkIcon';
  PhonelinkIcon.defaultProps = {
    size: 24
  };
  exports.default = PhonelinkIcon;
});
unwrapExports(Phonelink);
var PhonelinkErase = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M13 8.2l-1-1-4 4-4-4-1 1 4 4-4 4 1 1 4-4 4 4 1-1-4-4 4-4zM19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2z'
    }));
  };

  var PhonelinkEraseIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PhonelinkEraseIcon.displayName = 'PhonelinkEraseIcon';
  PhonelinkEraseIcon.defaultProps = {
    size: 24
  };
  exports.default = PhonelinkEraseIcon;
});
unwrapExports(PhonelinkErase);
var PhonelinkLock = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm-8.2 10V9.5C10.8 8.1 9.4 7 8 7S5.2 8.1 5.2 9.5V11c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3zm-1.3 0h-3V9.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3V11z'
    }));
  };

  var PhonelinkLockIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PhonelinkLockIcon.displayName = 'PhonelinkLockIcon';
  PhonelinkLockIcon.defaultProps = {
    size: 24
  };
  exports.default = PhonelinkLockIcon;
});
unwrapExports(PhonelinkLock);
var PhonelinkOff = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M22 6V4H6.82l2 2H22zM1.92 1.65L.65 2.92l1.82 1.82C2.18 5.08 2 5.52 2 6v11H0v3h17.73l2.35 2.35 1.27-1.27L3.89 3.62 1.92 1.65zM4 6.27L14.73 17H4V6.27zM23 8h-6c-.55 0-1 .45-1 1v4.18l2 2V10h4v7h-2.18l3 3H23c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1z'
    }));
  };

  var PhonelinkOffIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PhonelinkOffIcon.displayName = 'PhonelinkOffIcon';
  PhonelinkOffIcon.defaultProps = {
    size: 24
  };
  exports.default = PhonelinkOffIcon;
});
unwrapExports(PhonelinkOff);
var PhonelinkRing = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20.1 7.7l-1 1c1.8 1.8 1.8 4.6 0 6.5l1 1c2.5-2.3 2.5-6.1 0-8.5zM18 9.8l-1 1c.5.7.5 1.6 0 2.3l1 1c1.2-1.2 1.2-3 0-4.3zM14 1H4c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 19H4V4h10v16z'
    }));
  };

  var PhonelinkRingIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PhonelinkRingIcon.displayName = 'PhonelinkRingIcon';
  PhonelinkRingIcon.defaultProps = {
    size: 24
  };
  exports.default = PhonelinkRingIcon;
});
unwrapExports(PhonelinkRing);
var PhonelinkSetup = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M11.8 12.5v-1l1.1-.8c.1-.1.1-.2.1-.3l-1-1.7c-.1-.1-.2-.2-.3-.1l-1.3.4c-.3-.2-.6-.4-.9-.5l-.2-1.3c0-.1-.1-.2-.3-.2H7c-.1 0-.2.1-.3.2l-.2 1.3c-.3.1-.6.3-.9.5l-1.3-.5c-.1 0-.2 0-.3.1l-1 1.7c-.1.1 0 .2.1.3l1.1.8v1l-1.1.8c-.1.2-.1.3-.1.4l1 1.7c.1.1.2.2.3.1l1.4-.4c.3.2.6.4.9.5l.2 1.3c-.1.1.1.2.2.2h2c.1 0 .2-.1.3-.2l.2-1.3c.3-.1.6-.3.9-.5l1.3.5c.1 0 .2 0 .3-.1l1-1.7c.1-.1 0-.2-.1-.3l-1.1-.9zM8 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2z'
    }));
  };

  var PhonelinkSetupIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PhonelinkSetupIcon.displayName = 'PhonelinkSetupIcon';
  PhonelinkSetupIcon.defaultProps = {
    size: 24
  };
  exports.default = PhonelinkSetupIcon;
});
unwrapExports(PhonelinkSetup);
var Photo = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z'
    }));
  };

  var PhotoIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PhotoIcon.displayName = 'PhotoIcon';
  PhotoIcon.defaultProps = {
    size: 24
  };
  exports.default = PhotoIcon;
});
unwrapExports(Photo);
var PhotoAlbum = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4zm0 15l3-3.86 2.14 2.58 3-3.86L18 19H6z'
    }));
  };

  var PhotoAlbumIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PhotoAlbumIcon.displayName = 'PhotoAlbumIcon';
  PhotoAlbumIcon.defaultProps = {
    size: 24
  };
  exports.default = PhotoAlbumIcon;
});
unwrapExports(PhotoAlbum);
var PhotoCamera = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M 12 8.8 A 3.2 3.2 0 0 1 12 15.2 A 3.2 3.2 0 0 1 12 8.8 M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z'
    }));
  };

  var PhotoCameraIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PhotoCameraIcon.displayName = 'PhotoCameraIcon';
  PhotoCameraIcon.defaultProps = {
    size: 24
  };
  exports.default = PhotoCameraIcon;
});
unwrapExports(PhotoCamera);
var PhotoFilter = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19.02 10v9H5V5h9V3H5.02c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-9h-2zM17 10l.94-2.06L20 7l-2.06-.94L17 4l-.94 2.06L14 7l2.06.94zm-3.75.75L12 8l-1.25 2.75L8 12l2.75 1.25L12 16l1.25-2.75L16 12z'
    }));
  };

  var PhotoFilterIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PhotoFilterIcon.displayName = 'PhotoFilterIcon';
  PhotoFilterIcon.defaultProps = {
    size: 24
  };
  exports.default = PhotoFilterIcon;
});
unwrapExports(PhotoFilter);
var PhotoLibrary = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M22 16V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2zm-11-4l2.03 2.71L16 11l4 5H8l3-4zM2 6v14c0 1.1.9 2 2 2h14v-2H4V6H2z'
    }));
  };

  var PhotoLibraryIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PhotoLibraryIcon.displayName = 'PhotoLibraryIcon';
  PhotoLibraryIcon.defaultProps = {
    size: 24
  };
  exports.default = PhotoLibraryIcon;
});
unwrapExports(PhotoLibrary);
var PhotoSizeSelectActual = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21 3H3C2 3 1 4 1 5v14c0 1.1.9 2 2 2h18c1 0 2-1 2-2V5c0-1-1-2-2-2zM5 17l3.5-4.5 2.5 3.01L14.5 11l4.5 6H5z'
    }));
  };

  var PhotoSizeSelectActualIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PhotoSizeSelectActualIcon.displayName = 'PhotoSizeSelectActualIcon';
  PhotoSizeSelectActualIcon.defaultProps = {
    size: 24
  };
  exports.default = PhotoSizeSelectActualIcon;
});
unwrapExports(PhotoSizeSelectActual);
var PhotoSizeSelectLarge = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21 15h2v2h-2v-2zm0-4h2v2h-2v-2zm2 8h-2v2c1 0 2-1 2-2zM13 3h2v2h-2V3zm8 4h2v2h-2V7zm0-4v2h2c0-1-1-2-2-2zM1 7h2v2H1V7zm16-4h2v2h-2V3zm0 16h2v2h-2v-2zM3 3C2 3 1 4 1 5h2V3zm6 0h2v2H9V3zM5 3h2v2H5V3zm-4 8v8c0 1.1.9 2 2 2h12V11H1zm2 8l2.5-3.21 1.79 2.15 2.5-3.22L13 19H3z'
    }));
  };

  var PhotoSizeSelectLargeIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PhotoSizeSelectLargeIcon.displayName = 'PhotoSizeSelectLargeIcon';
  PhotoSizeSelectLargeIcon.defaultProps = {
    size: 24
  };
  exports.default = PhotoSizeSelectLargeIcon;
});
unwrapExports(PhotoSizeSelectLarge);
var PhotoSizeSelectSmall = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M23 15h-2v2h2v-2zm0-4h-2v2h2v-2zm0 8h-2v2c1 0 2-1 2-2zM15 3h-2v2h2V3zm8 4h-2v2h2V7zm-2-4v2h2c0-1-1-2-2-2zM3 21h8v-6H1v4c0 1.1.9 2 2 2zM3 7H1v2h2V7zm12 12h-2v2h2v-2zm4-16h-2v2h2V3zm0 16h-2v2h2v-2zM3 3C2 3 1 4 1 5h2V3zm0 8H1v2h2v-2zm8-8H9v2h2V3zM7 3H5v2h2V3z'
    }));
  };

  var PhotoSizeSelectSmallIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PhotoSizeSelectSmallIcon.displayName = 'PhotoSizeSelectSmallIcon';
  PhotoSizeSelectSmallIcon.defaultProps = {
    size: 24
  };
  exports.default = PhotoSizeSelectSmallIcon;
});
unwrapExports(PhotoSizeSelectSmall);
var PictureAsPdf = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8.5 7.5c0 .83-.67 1.5-1.5 1.5H9v2H7.5V7H10c.83 0 1.5.67 1.5 1.5v1zm5 2c0 .83-.67 1.5-1.5 1.5h-2.5V7H15c.83 0 1.5.67 1.5 1.5v3zm4-3H19v1h1.5V11H19v2h-1.5V7h3v1.5zM9 9.5h1v-1H9v1zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm10 5.5h1v-3h-1v3z'
    }));
  };

  var PictureAsPdfIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PictureAsPdfIcon.displayName = 'PictureAsPdfIcon';
  PictureAsPdfIcon.defaultProps = {
    size: 24
  };
  exports.default = PictureAsPdfIcon;
});
unwrapExports(PictureAsPdf);
var PictureInPicture = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 7h-8v6h8V7zm2-4H3c-1.1 0-2 .9-2 2v14c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98V5c0-1.1-.9-2-2-2zm0 16.01H3V4.98h18v14.03z'
    }));
  };

  var PictureInPictureIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PictureInPictureIcon.displayName = 'PictureInPictureIcon';
  PictureInPictureIcon.defaultProps = {
    size: 24
  };
  exports.default = PictureInPictureIcon;
});
unwrapExports(PictureInPicture);
var PictureInPictureAlt = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 11h-8v6h8v-6zm4 8V4.98C23 3.88 22.1 3 21 3H3c-1.1 0-2 .88-2 1.98V19c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2zm-2 .02H3V4.97h18v14.05z'
    }));
  };

  var PictureInPictureAltIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PictureInPictureAltIcon.displayName = 'PictureInPictureAltIcon';
  PictureInPictureAltIcon.defaultProps = {
    size: 24
  };
  exports.default = PictureInPictureAltIcon;
});
unwrapExports(PictureInPictureAlt);
var PieChart = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M11 2v20c-5.07-.5-9-4.79-9-10s3.93-9.5 9-10zm2.03 0v8.99H22c-.47-4.74-4.24-8.52-8.97-8.99zm0 11.01V22c4.74-.47 8.5-4.25 8.97-8.99h-8.97z'
    }));
  };

  var PieChartIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PieChartIcon.displayName = 'PieChartIcon';
  PieChartIcon.defaultProps = {
    size: 24
  };
  exports.default = PieChartIcon;
});
unwrapExports(PieChart);
var PieChartOutlined = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm1 2.07c3.61.45 6.48 3.33 6.93 6.93H13V4.07zM4 12c0-4.06 3.07-7.44 7-7.93v15.87c-3.93-.5-7-3.88-7-7.94zm9 7.93V13h6.93c-.45 3.61-3.32 6.48-6.93 6.93z'
    }));
  };

  var PieChartOutlinedIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PieChartOutlinedIcon.displayName = 'PieChartOutlinedIcon';
  PieChartOutlinedIcon.defaultProps = {
    size: 24
  };
  exports.default = PieChartOutlinedIcon;
});
unwrapExports(PieChartOutlined);
var PinDrop = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M18 8c0-3.31-2.69-6-6-6S6 4.69 6 8c0 4.5 6 11 6 11s6-6.5 6-11zm-8 0c0-1.1.9-2 2-2s2 .9 2 2-.89 2-2 2c-1.1 0-2-.9-2-2zM5 20v2h14v-2H5z'
    }));
  };

  var PinDropIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PinDropIcon.displayName = 'PinDropIcon';
  PinDropIcon.defaultProps = {
    size: 24
  };
  exports.default = PinDropIcon;
});
unwrapExports(PinDrop);
var Place = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z'
    }));
  };

  var PlaceIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PlaceIcon.displayName = 'PlaceIcon';
  PlaceIcon.defaultProps = {
    size: 24
  };
  exports.default = PlaceIcon;
});
unwrapExports(Place);
var PlayArrow = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M8 5v14l11-7z'
    }));
  };

  var PlayArrowIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PlayArrowIcon.displayName = 'PlayArrowIcon';
  PlayArrowIcon.defaultProps = {
    size: 24
  };
  exports.default = PlayArrowIcon;
});
unwrapExports(PlayArrow);
var PlayCircleFilled = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z'
    }));
  };

  var PlayCircleFilledIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PlayCircleFilledIcon.displayName = 'PlayCircleFilledIcon';
  PlayCircleFilledIcon.defaultProps = {
    size: 24
  };
  exports.default = PlayCircleFilledIcon;
});
unwrapExports(PlayCircleFilled);
var PlayCircleOutline = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M10 16.5l6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z'
    }));
  };

  var PlayCircleOutlineIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PlayCircleOutlineIcon.displayName = 'PlayCircleOutlineIcon';
  PlayCircleOutlineIcon.defaultProps = {
    size: 24
  };
  exports.default = PlayCircleOutlineIcon;
});
unwrapExports(PlayCircleOutline);
var PlayForWork = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M11 5v5.59H7.5l4.5 4.5 4.5-4.5H13V5h-2zm-5 9c0 3.31 2.69 6 6 6s6-2.69 6-6h-2c0 2.21-1.79 4-4 4s-4-1.79-4-4H6z'
    }));
  };

  var PlayForWorkIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PlayForWorkIcon.displayName = 'PlayForWorkIcon';
  PlayForWorkIcon.defaultProps = {
    size: 24
  };
  exports.default = PlayForWorkIcon;
});
unwrapExports(PlayForWork);
var PlaylistAdd = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M14 10H2v2h12v-2zm0-4H2v2h12V6zm4 8v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zM2 16h8v-2H2v2z'
    }));
  };

  var PlaylistAddIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PlaylistAddIcon.displayName = 'PlaylistAddIcon';
  PlaylistAddIcon.defaultProps = {
    size: 24
  };
  exports.default = PlaylistAddIcon;
});
unwrapExports(PlaylistAdd);
var PlaylistAddCheck = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M14 10H2v2h12v-2zm0-4H2v2h12V6zM2 16h8v-2H2v2zm19.5-4.5L23 13l-6.99 7-4.51-4.5L13 14l3.01 3 5.49-5.5z'
    }));
  };

  var PlaylistAddCheckIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PlaylistAddCheckIcon.displayName = 'PlaylistAddCheckIcon';
  PlaylistAddCheckIcon.defaultProps = {
    size: 24
  };
  exports.default = PlaylistAddCheckIcon;
});
unwrapExports(PlaylistAddCheck);
var PlaylistPlay = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M 4 10 H 16 V 12 H 4 z M 4 6 H 16 V 8 H 4 z M 4 14 H 12 V 16 H 4 z M 14 14 L 14 20 L 19 17 z'
    }));
  };

  var PlaylistPlayIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PlaylistPlayIcon.displayName = 'PlaylistPlayIcon';
  PlaylistPlayIcon.defaultProps = {
    size: 24
  };
  exports.default = PlaylistPlayIcon;
});
unwrapExports(PlaylistPlay);
var PlusOne = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M10 8H8v4H4v2h4v4h2v-4h4v-2h-4zm4.5-1.92V7.9l2.5-.5V18h2V5z'
    }));
  };

  var PlusOneIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PlusOneIcon.displayName = 'PlusOneIcon';
  PlusOneIcon.defaultProps = {
    size: 24
  };
  exports.default = PlusOneIcon;
});
unwrapExports(PlusOne);
var Poll = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z'
    }));
  };

  var PollIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PollIcon.displayName = 'PollIcon';
  PollIcon.defaultProps = {
    size: 24
  };
  exports.default = PollIcon;
});
unwrapExports(Poll);
var Polymer = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 4h-4L7.11 16.63 4.5 12 9 4H5L.5 12 5 20h4l7.89-12.63L19.5 12 15 20h4l4.5-8z'
    }));
  };

  var PolymerIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PolymerIcon.displayName = 'PolymerIcon';
  PolymerIcon.defaultProps = {
    size: 24
  };
  exports.default = PolymerIcon;
});
unwrapExports(Polymer);
var Pool = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M22 21c-1.11 0-1.73-.37-2.18-.64-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.46.27-1.07.64-2.18.64s-1.73-.37-2.18-.64c-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.46.27-1.08.64-2.19.64-1.11 0-1.73-.37-2.18-.64-.37-.23-.6-.36-1.15-.36s-.78.13-1.15.36c-.46.27-1.08.64-2.19.64v-2c.56 0 .78-.13 1.15-.36.46-.27 1.08-.64 2.19-.64s1.73.37 2.18.64c.37.23.59.36 1.15.36.56 0 .78-.13 1.15-.36.46-.27 1.08-.64 2.19-.64 1.11 0 1.73.37 2.18.64.37.22.6.36 1.15.36s.78-.13 1.15-.36c.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.23.59.36 1.15.36v2zm0-4.5c-1.11 0-1.73-.37-2.18-.64-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.45.27-1.07.64-2.18.64s-1.73-.37-2.18-.64c-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.45.27-1.07.64-2.18.64s-1.73-.37-2.18-.64c-.37-.22-.6-.36-1.15-.36s-.78.13-1.15.36c-.47.27-1.09.64-2.2.64v-2c.56 0 .78-.13 1.15-.36.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.22.6.36 1.15.36.56 0 .78-.13 1.15-.36.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.22.6.36 1.15.36s.78-.13 1.15-.36c.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.22.6.36 1.15.36v2zM8.67 12c.56 0 .78-.13 1.15-.36.46-.27 1.08-.64 2.19-.64 1.11 0 1.73.37 2.18.64.37.22.6.36 1.15.36s.78-.13 1.15-.36c.12-.07.26-.15.41-.23L10.48 5C8.93 3.45 7.5 2.99 5 3v2.5c1.82-.01 2.89.39 4 1.5l1 1-3.25 3.25c.31.12.56.27.77.39.37.23.59.36 1.15.36z M 16.5 3 A 2.5 2.5 0 0 1 16.5 8 A 2.5 2.5 0 0 1 16.5 3'
    }));
  };

  var PoolIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PoolIcon.displayName = 'PoolIcon';
  PoolIcon.defaultProps = {
    size: 24
  };
  exports.default = PoolIcon;
});
unwrapExports(Pool);
var PortableWifiOff = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M17.56 14.24c.28-.69.44-1.45.44-2.24 0-3.31-2.69-6-6-6-.79 0-1.55.16-2.24.44l1.62 1.62c.2-.03.41-.06.62-.06 2.21 0 4 1.79 4 4 0 .21-.02.42-.05.63l1.61 1.61zM12 4c4.42 0 8 3.58 8 8 0 1.35-.35 2.62-.95 3.74l1.47 1.47C21.46 15.69 22 13.91 22 12c0-5.52-4.48-10-10-10-1.91 0-3.69.55-5.21 1.47l1.46 1.46C9.37 4.34 10.65 4 12 4zM3.27 2.5L2 3.77l2.1 2.1C2.79 7.57 2 9.69 2 12c0 3.7 2.01 6.92 4.99 8.65l1-1.73C5.61 17.53 4 14.96 4 12c0-1.76.57-3.38 1.53-4.69l1.43 1.44C6.36 9.68 6 10.8 6 12c0 2.22 1.21 4.15 3 5.19l1-1.74c-1.19-.7-2-1.97-2-3.45 0-.65.17-1.25.44-1.79l1.58 1.58L10 12c0 1.1.9 2 2 2l.21-.02.01.01 7.51 7.51L21 20.23 4.27 3.5l-1-1z'
    }));
  };

  var PortableWifiOffIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PortableWifiOffIcon.displayName = 'PortableWifiOffIcon';
  PortableWifiOffIcon.defaultProps = {
    size: 24
  };
  exports.default = PortableWifiOffIcon;
});
unwrapExports(PortableWifiOff);
var Portrait = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 12.25c1.24 0 2.25-1.01 2.25-2.25S13.24 7.75 12 7.75 9.75 8.76 9.75 10s1.01 2.25 2.25 2.25zm4.5 4c0-1.5-3-2.25-4.5-2.25s-4.5.75-4.5 2.25V17h9v-.75zM19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z'
    }));
  };

  var PortraitIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PortraitIcon.displayName = 'PortraitIcon';
  PortraitIcon.defaultProps = {
    size: 24
  };
  exports.default = PortraitIcon;
});
unwrapExports(Portrait);
var Power = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M16.01 7L16 3h-2v4h-4V3H8v4h-.01C7 6.99 6 7.99 6 8.99v5.49L9.5 18v3h5v-3l3.5-3.51v-5.5c0-1-1-2-1.99-1.99z'
    }));
  };

  var PowerIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PowerIcon.displayName = 'PowerIcon';
  PowerIcon.defaultProps = {
    size: 24
  };
  exports.default = PowerIcon;
});
unwrapExports(Power);
var PowerInput = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M2 9v2h19V9H2zm0 6h5v-2H2v2zm7 0h5v-2H9v2zm7 0h5v-2h-5v2z'
    }));
  };

  var PowerInputIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PowerInputIcon.displayName = 'PowerInputIcon';
  PowerInputIcon.defaultProps = {
    size: 24
  };
  exports.default = PowerInputIcon;
});
unwrapExports(PowerInput);
var PowerSettingsNew = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M13 3h-2v10h2V3zm4.83 2.17l-1.42 1.42C17.99 7.86 19 9.81 19 12c0 3.87-3.13 7-7 7s-7-3.13-7-7c0-2.19 1.01-4.14 2.58-5.42L6.17 5.17C4.23 6.82 3 9.26 3 12c0 4.97 4.03 9 9 9s9-4.03 9-9c0-2.74-1.23-5.18-3.17-6.83z'
    }));
  };

  var PowerSettingsNewIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PowerSettingsNewIcon.displayName = 'PowerSettingsNewIcon';
  PowerSettingsNewIcon.defaultProps = {
    size: 24
  };
  exports.default = PowerSettingsNewIcon;
});
unwrapExports(PowerSettingsNew);
var PregnantWoman = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M9 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zm7 9c-.01-1.34-.83-2.51-2-3 0-1.66-1.34-3-3-3s-3 1.34-3 3v7h2v5h3v-5h3v-4z'
    }));
  };

  var PregnantWomanIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PregnantWomanIcon.displayName = 'PregnantWomanIcon';
  PregnantWomanIcon.defaultProps = {
    size: 24
  };
  exports.default = PregnantWomanIcon;
});
unwrapExports(PregnantWoman);
var PresentToAll = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21 3H3c-1.11 0-2 .89-2 2v14c0 1.11.89 2 2 2h18c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2zm0 16.02H3V4.98h18v14.04zM10 12H8l4-4 4 4h-2v4h-4v-4z'
    }));
  };

  var PresentToAllIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PresentToAllIcon.displayName = 'PresentToAllIcon';
  PresentToAllIcon.defaultProps = {
    size: 24
  };
  exports.default = PresentToAllIcon;
});
unwrapExports(PresentToAll);
var Print = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z'
    }));
  };

  var PrintIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PrintIcon.displayName = 'PrintIcon';
  PrintIcon.defaultProps = {
    size: 24
  };
  exports.default = PrintIcon;
});
unwrapExports(Print);
var PriorityHigh = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M 12 17 A 2 2 0 0 1 12 21 A 2 2 0 0 1 12 17 M10 3h4v12h-4z'
    }));
  };

  var PriorityHighIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PriorityHighIcon.displayName = 'PriorityHighIcon';
  PriorityHighIcon.defaultProps = {
    size: 24
  };
  exports.default = PriorityHighIcon;
});
unwrapExports(PriorityHigh);
var Public = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z'
    }));
  };

  var PublicIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PublicIcon.displayName = 'PublicIcon';
  PublicIcon.defaultProps = {
    size: 24
  };
  exports.default = PublicIcon;
});
unwrapExports(Public);
var Publish = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M5 4v2h14V4H5zm0 10h4v6h6v-6h4l-7-7-7 7z'
    }));
  };

  var PublishIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  PublishIcon.displayName = 'PublishIcon';
  PublishIcon.defaultProps = {
    size: 24
  };
  exports.default = PublishIcon;
});
unwrapExports(Publish);
var QueryBuilder = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z'
    }));
  };

  var QueryBuilderIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  QueryBuilderIcon.displayName = 'QueryBuilderIcon';
  QueryBuilderIcon.defaultProps = {
    size: 24
  };
  exports.default = QueryBuilderIcon;
});
unwrapExports(QueryBuilder);
var QuestionAnswer = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z'
    }));
  };

  var QuestionAnswerIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  QuestionAnswerIcon.displayName = 'QuestionAnswerIcon';
  QuestionAnswerIcon.defaultProps = {
    size: 24
  };
  exports.default = QuestionAnswerIcon;
});
unwrapExports(QuestionAnswer);
var Queue = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z'
    }));
  };

  var QueueIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  QueueIcon.displayName = 'QueueIcon';
  QueueIcon.defaultProps = {
    size: 24
  };
  exports.default = QueueIcon;
});
unwrapExports(Queue);
var QueueMusic = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M15 6H3v2h12V6zm0 4H3v2h12v-2zM3 16h8v-2H3v2zM17 6v8.18c-.31-.11-.65-.18-1-.18-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3V8h3V6h-5z'
    }));
  };

  var QueueMusicIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  QueueMusicIcon.displayName = 'QueueMusicIcon';
  QueueMusicIcon.defaultProps = {
    size: 24
  };
  exports.default = QueueMusicIcon;
});
unwrapExports(QueueMusic);
var QueuePlayNext = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h2v-2H3V5h18v8h2V5c0-1.11-.9-2-2-2zm-8 7V7h-2v3H8v2h3v3h2v-3h3v-2h-3zm11 8l-4.5 4.5L18 21l3-3-3-3 1.5-1.5L24 18z'
    }));
  };

  var QueuePlayNextIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  QueuePlayNextIcon.displayName = 'QueuePlayNextIcon';
  QueuePlayNextIcon.defaultProps = {
    size: 24
  };
  exports.default = QueuePlayNextIcon;
});
unwrapExports(QueuePlayNext);
var Radio = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M3.24 6.15C2.51 6.43 2 7.17 2 8v12c0 1.1.89 2 2 2h16c1.11 0 2-.9 2-2V8c0-1.11-.89-2-2-2H8.3l8.26-3.34L15.88 1 3.24 6.15zM7 20c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm13-8h-2v-2h-2v2H4V8h16v4z'
    }));
  };

  var RadioIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  RadioIcon.displayName = 'RadioIcon';
  RadioIcon.defaultProps = {
    size: 24
  };
  exports.default = RadioIcon;
});
unwrapExports(Radio);
var RadioButtonChecked = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z'
    }));
  };

  var RadioButtonCheckedIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  RadioButtonCheckedIcon.displayName = 'RadioButtonCheckedIcon';
  RadioButtonCheckedIcon.defaultProps = {
    size: 24
  };
  exports.default = RadioButtonCheckedIcon;
});
var IconChecked$1 = unwrapExports(RadioButtonChecked);
var RadioButtonUnchecked = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z'
    }));
  };

  var RadioButtonUncheckedIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  RadioButtonUncheckedIcon.displayName = 'RadioButtonUncheckedIcon';
  RadioButtonUncheckedIcon.defaultProps = {
    size: 24
  };
  exports.default = RadioButtonUncheckedIcon;
});
var IconUnChecked$1 = unwrapExports(RadioButtonUnchecked);
var RateReview = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 14v-2.47l6.88-6.88c.2-.2.51-.2.71 0l1.77 1.77c.2.2.2.51 0 .71L8.47 14H6zm12 0h-7.5l2-2H18v2z'
    }));
  };

  var RateReviewIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  RateReviewIcon.displayName = 'RateReviewIcon';
  RateReviewIcon.defaultProps = {
    size: 24
  };
  exports.default = RateReviewIcon;
});
unwrapExports(RateReview);
var Receipt = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M18 17H6v-2h12v2zm0-4H6v-2h12v2zm0-4H6V7h12v2zM3 22l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2 4.5 3.5 3 2v20z'
    }));
  };

  var ReceiptIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ReceiptIcon.displayName = 'ReceiptIcon';
  ReceiptIcon.defaultProps = {
    size: 24
  };
  exports.default = ReceiptIcon;
});
unwrapExports(Receipt);
var RecentActors = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21 5v14h2V5h-2zm-4 14h2V5h-2v14zM14 5H2c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zM8 7.75c1.24 0 2.25 1.01 2.25 2.25S9.24 12.25 8 12.25 5.75 11.24 5.75 10 6.76 7.75 8 7.75zM12.5 17h-9v-.75c0-1.5 3-2.25 4.5-2.25s4.5.75 4.5 2.25V17z'
    }));
  };

  var RecentActorsIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  RecentActorsIcon.displayName = 'RecentActorsIcon';
  RecentActorsIcon.defaultProps = {
    size: 24
  };
  exports.default = RecentActorsIcon;
});
unwrapExports(RecentActors);
var RecordVoiceOver = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M 9 5 A 4 4 0 0 1 9 13 A 4 4 0 0 1 9 5 M9 15c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4zm7.76-9.64l-1.68 1.69c.84 1.18.84 2.71 0 3.89l1.68 1.69c2.02-2.02 2.02-5.07 0-7.27zM20.07 2l-1.63 1.63c2.77 3.02 2.77 7.56 0 10.74L20.07 16c3.9-3.89 3.91-9.95 0-14z'
    }));
  };

  var RecordVoiceOverIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  RecordVoiceOverIcon.displayName = 'RecordVoiceOverIcon';
  RecordVoiceOverIcon.defaultProps = {
    size: 24
  };
  exports.default = RecordVoiceOverIcon;
});
unwrapExports(RecordVoiceOver);
var Redeem = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z'
    }));
  };

  var RedeemIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  RedeemIcon.displayName = 'RedeemIcon';
  RedeemIcon.defaultProps = {
    size: 24
  };
  exports.default = RedeemIcon;
});
unwrapExports(Redeem);
var Redo = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M18.4 10.6C16.55 8.99 14.15 8 11.5 8c-4.65 0-8.58 3.03-9.96 7.22L3.9 16c1.05-3.19 4.05-5.5 7.6-5.5 1.95 0 3.73.72 5.12 1.88L13 16h9V7l-3.6 3.6z'
    }));
  };

  var RedoIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  RedoIcon.displayName = 'RedoIcon';
  RedoIcon.defaultProps = {
    size: 24
  };
  exports.default = RedoIcon;
});
unwrapExports(Redo);
var Refresh = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z'
    }));
  };

  var RefreshIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  RefreshIcon.displayName = 'RefreshIcon';
  RefreshIcon.defaultProps = {
    size: 24
  };
  exports.default = RefreshIcon;
});
unwrapExports(Refresh);
var Remove = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 13H5v-2h14v2z'
    }));
  };

  var RemoveIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  RemoveIcon.displayName = 'RemoveIcon';
  RemoveIcon.defaultProps = {
    size: 24
  };
  exports.default = RemoveIcon;
});
unwrapExports(Remove);
var RemoveCircle = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z'
    }));
  };

  var RemoveCircleIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  RemoveCircleIcon.displayName = 'RemoveCircleIcon';
  RemoveCircleIcon.defaultProps = {
    size: 24
  };
  exports.default = RemoveCircleIcon;
});
unwrapExports(RemoveCircle);
var RemoveCircleOutline = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M7 11v2h10v-2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z'
    }));
  };

  var RemoveCircleOutlineIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  RemoveCircleOutlineIcon.displayName = 'RemoveCircleOutlineIcon';
  RemoveCircleOutlineIcon.defaultProps = {
    size: 24
  };
  exports.default = RemoveCircleOutlineIcon;
});
unwrapExports(RemoveCircleOutline);
var RemoveFromQueue = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.11-.9-2-2-2zm0 14H3V5h18v12zm-5-7v2H8v-2h8z'
    }));
  };

  var RemoveFromQueueIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  RemoveFromQueueIcon.displayName = 'RemoveFromQueueIcon';
  RemoveFromQueueIcon.defaultProps = {
    size: 24
  };
  exports.default = RemoveFromQueueIcon;
});
unwrapExports(RemoveFromQueue);
var RemoveRedEye = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z'
    }));
  };

  var RemoveRedEyeIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  RemoveRedEyeIcon.displayName = 'RemoveRedEyeIcon';
  RemoveRedEyeIcon.defaultProps = {
    size: 24
  };
  exports.default = RemoveRedEyeIcon;
});
unwrapExports(RemoveRedEye);
var RemoveShoppingCart = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M22.73 22.73L2.77 2.77 2 2l-.73-.73L0 2.54l4.39 4.39 2.21 4.66-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h7.46l1.38 1.38c-.5.36-.83.95-.83 1.62 0 1.1.89 2 1.99 2 .67 0 1.26-.33 1.62-.84L21.46 24l1.27-1.27zM7.42 15c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h2.36l2 2H7.42zm8.13-2c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H6.54l9.01 9zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2z'
    }));
  };

  var RemoveShoppingCartIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  RemoveShoppingCartIcon.displayName = 'RemoveShoppingCartIcon';
  RemoveShoppingCartIcon.defaultProps = {
    size: 24
  };
  exports.default = RemoveShoppingCartIcon;
});
unwrapExports(RemoveShoppingCart);
var Reorder = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M3 15h18v-2H3v2zm0 4h18v-2H3v2zm0-8h18V9H3v2zm0-6v2h18V5H3z'
    }));
  };

  var ReorderIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ReorderIcon.displayName = 'ReorderIcon';
  ReorderIcon.defaultProps = {
    size: 24
  };
  exports.default = ReorderIcon;
});
unwrapExports(Reorder);
var Repeat = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M7 7h10v3l4-4-4-4v3H5v6h2V7zm10 10H7v-3l-4 4 4 4v-3h12v-6h-2v4z'
    }));
  };

  var RepeatIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  RepeatIcon.displayName = 'RepeatIcon';
  RepeatIcon.defaultProps = {
    size: 24
  };
  exports.default = RepeatIcon;
});
unwrapExports(Repeat);
var RepeatOne = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M7 7h10v3l4-4-4-4v3H5v6h2V7zm10 10H7v-3l-4 4 4 4v-3h12v-6h-2v4zm-4-2V9h-1l-2 1v1h1.5v4H13z'
    }));
  };

  var RepeatOneIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  RepeatOneIcon.displayName = 'RepeatOneIcon';
  RepeatOneIcon.defaultProps = {
    size: 24
  };
  exports.default = RepeatOneIcon;
});
unwrapExports(RepeatOne);
var Replay = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z'
    }));
  };

  var ReplayIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ReplayIcon.displayName = 'ReplayIcon';
  ReplayIcon.defaultProps = {
    size: 24
  };
  exports.default = ReplayIcon;
});
unwrapExports(Replay);
var Replay10 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 5V1L7 6l5 5V7c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6H4c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8zm-1.1 11H10v-3.3L9 13v-.7l1.8-.6h.1V16zm4.3-1.8c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1c.2.1.3.2.5.3s.2.3.3.6.1.5.1.8v.7zm-.9-.8v-.5s-.1-.2-.1-.3-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5z'
    }));
  };

  var Replay10Icon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  Replay10Icon.displayName = 'Replay10Icon';
  Replay10Icon.defaultProps = {
    size: 24
  };
  exports.default = Replay10Icon;
});
unwrapExports(Replay10);
var Replay30 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 5V1L7 6l5 5V7c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6H4c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8zm-2.4 8.5h.4c.2 0 .4-.1.5-.2s.2-.2.2-.4v-.2s-.1-.1-.1-.2-.1-.1-.2-.1h-.5s-.1.1-.2.1-.1.1-.1.2v.2h-1c0-.2 0-.3.1-.5s.2-.3.3-.4.3-.2.4-.2.4-.1.5-.1c.2 0 .4 0 .6.1s.3.1.5.2.2.2.3.4.1.3.1.5v.3s-.1.2-.1.3-.1.2-.2.2-.2.1-.3.2c.2.1.4.2.5.4s.2.4.2.6c0 .2 0 .4-.1.5s-.2.3-.3.4-.3.2-.5.2-.4.1-.6.1c-.2 0-.4 0-.5-.1s-.3-.1-.5-.2-.2-.2-.3-.4-.1-.4-.1-.6h.8v.2s.1.1.1.2.1.1.2.1h.5s.1-.1.2-.1.1-.1.1-.2v-.5s-.1-.1-.1-.2-.1-.1-.2-.1h-.6v-.7zm5.7.7c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1.3.2.5.3.2.3.3.6.1.5.1.8v.7zm-.8-.8v-.5c0-.1-.1-.2-.1-.3s-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5z'
    }));
  };

  var Replay30Icon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  Replay30Icon.displayName = 'Replay30Icon';
  Replay30Icon.defaultProps = {
    size: 24
  };
  exports.default = Replay30Icon;
});
unwrapExports(Replay30);
var Replay5 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 5V1L7 6l5 5V7c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6H4c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8zm-1.3 8.9l.2-2.2h2.4v.7h-1.7l-.1.9s.1 0 .1-.1.1 0 .1-.1.1 0 .2 0h.2c.2 0 .4 0 .5.1s.3.2.4.3.2.3.3.5.1.4.1.6c0 .2 0 .4-.1.5s-.1.3-.3.5-.3.2-.4.3-.4.1-.6.1c-.2 0-.4 0-.5-.1s-.3-.1-.5-.2-.2-.2-.3-.4-.1-.3-.1-.5h.8c0 .2.1.3.2.4s.2.1.4.1c.1 0 .2 0 .3-.1l.2-.2s.1-.2.1-.3v-.6l-.1-.2-.2-.2s-.2-.1-.3-.1h-.2s-.1 0-.2.1-.1 0-.1.1-.1.1-.1.1h-.7z'
    }));
  };

  var Replay5Icon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  Replay5Icon.displayName = 'Replay5Icon';
  Replay5Icon.defaultProps = {
    size: 24
  };
  exports.default = Replay5Icon;
});
unwrapExports(Replay5);
var Reply = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z'
    }));
  };

  var ReplyIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ReplyIcon.displayName = 'ReplyIcon';
  ReplyIcon.defaultProps = {
    size: 24
  };
  exports.default = ReplyIcon;
});
unwrapExports(Reply);
var ReplyAll = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M7 8V5l-7 7 7 7v-3l-4-4 4-4zm6 1V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z'
    }));
  };

  var ReplyAllIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ReplyAllIcon.displayName = 'ReplyAllIcon';
  ReplyAllIcon.defaultProps = {
    size: 24
  };
  exports.default = ReplyAllIcon;
});
unwrapExports(ReplyAll);
var Report = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM12 17.3c-.72 0-1.3-.58-1.3-1.3 0-.72.58-1.3 1.3-1.3.72 0 1.3.58 1.3 1.3 0 .72-.58 1.3-1.3 1.3zm1-4.3h-2V7h2v6z'
    }));
  };

  var ReportIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ReportIcon.displayName = 'ReportIcon';
  ReportIcon.defaultProps = {
    size: 24
  };
  exports.default = ReportIcon;
});
unwrapExports(Report);
var ReportProblem = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z'
    }));
  };

  var ReportProblemIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ReportProblemIcon.displayName = 'ReportProblemIcon';
  ReportProblemIcon.defaultProps = {
    size: 24
  };
  exports.default = ReportProblemIcon;
});
unwrapExports(ReportProblem);
var Restaurant = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M11 9H9V2H7v7H5V2H3v7c0 2.12 1.66 3.84 3.75 3.97V22h2.5v-9.03C11.34 12.84 13 11.12 13 9V2h-2v7zm5-3v8h2.5v8H21V2c-2.76 0-5 2.24-5 4z'
    }));
  };

  var RestaurantIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  RestaurantIcon.displayName = 'RestaurantIcon';
  RestaurantIcon.defaultProps = {
    size: 24
  };
  exports.default = RestaurantIcon;
});
unwrapExports(Restaurant);
var RestaurantMenu = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M8.1 13.34l2.83-2.83L3.91 3.5c-1.56 1.56-1.56 4.09 0 5.66l4.19 4.18zm6.78-1.81c1.53.71 3.68.21 5.27-1.38 1.91-1.91 2.28-4.65.81-6.12-1.46-1.46-4.2-1.1-6.12.81-1.59 1.59-2.09 3.74-1.38 5.27L3.7 19.87l1.41 1.41L12 14.41l6.88 6.88 1.41-1.41L13.41 13l1.47-1.47z'
    }));
  };

  var RestaurantMenuIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  RestaurantMenuIcon.displayName = 'RestaurantMenuIcon';
  RestaurantMenuIcon.defaultProps = {
    size: 24
  };
  exports.default = RestaurantMenuIcon;
});
unwrapExports(RestaurantMenu);
var Restore = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z'
    }));
  };

  var RestoreIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  RestoreIcon.displayName = 'RestoreIcon';
  RestoreIcon.defaultProps = {
    size: 24
  };
  exports.default = RestoreIcon;
});
unwrapExports(Restore);
var RestorePage = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm-2 16c-2.05 0-3.81-1.24-4.58-3h1.71c.63.9 1.68 1.5 2.87 1.5 1.93 0 3.5-1.57 3.5-3.5S13.93 9.5 12 9.5c-1.35 0-2.52.78-3.1 1.9l1.6 1.6h-4V9l1.3 1.3C8.69 8.92 10.23 8 12 8c2.76 0 5 2.24 5 5s-2.24 5-5 5z'
    }));
  };

  var RestorePageIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  RestorePageIcon.displayName = 'RestorePageIcon';
  RestorePageIcon.defaultProps = {
    size: 24
  };
  exports.default = RestorePageIcon;
});
unwrapExports(RestorePage);
var RingVolume = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M23.71 16.67C20.66 13.78 16.54 12 12 12 7.46 12 3.34 13.78.29 16.67c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l2.48 2.48c.18.18.43.29.71.29.27 0 .52-.11.7-.28.79-.74 1.69-1.36 2.66-1.85.33-.16.56-.5.56-.9v-3.1c1.45-.48 3-.73 4.6-.73s3.15.25 4.6.72v3.1c0 .39.23.74.56.9.98.49 1.87 1.12 2.66 1.85.18.18.43.28.7.28.28 0 .53-.11.71-.29l2.48-2.48c.18-.18.29-.43.29-.71 0-.27-.11-.52-.29-.7zM21.16 6.26l-1.41-1.41-3.56 3.55 1.41 1.41s3.45-3.52 3.56-3.55zM13 2h-2v5h2V2zM6.4 9.81L7.81 8.4 4.26 4.84 2.84 6.26c.11.03 3.56 3.55 3.56 3.55z'
    }));
  };

  var RingVolumeIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  RingVolumeIcon.displayName = 'RingVolumeIcon';
  RingVolumeIcon.defaultProps = {
    size: 24
  };
  exports.default = RingVolumeIcon;
});
unwrapExports(RingVolume);
var Room = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z'
    }));
  };

  var RoomIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  RoomIcon.displayName = 'RoomIcon';
  RoomIcon.defaultProps = {
    size: 24
  };
  exports.default = RoomIcon;
});
unwrapExports(Room);
var RoomService = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M2 17h20v2H2zm11.84-9.21c.1-.24.16-.51.16-.79 0-1.1-.9-2-2-2s-2 .9-2 2c0 .28.06.55.16.79C6.25 8.6 3.27 11.93 3 16h18c-.27-4.07-3.25-7.4-7.16-8.21z'
    }));
  };

  var RoomServiceIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  RoomServiceIcon.displayName = 'RoomServiceIcon';
  RoomServiceIcon.defaultProps = {
    size: 24
  };
  exports.default = RoomServiceIcon;
});
unwrapExports(RoomService);
var Rotate90DegreesCcw = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M7.34 6.41L.86 12.9l6.49 6.48 6.49-6.48-6.5-6.49zM3.69 12.9l3.66-3.66L11 12.9l-3.66 3.66-3.65-3.66zm15.67-6.26C17.61 4.88 15.3 4 13 4V.76L8.76 5 13 9.24V6c1.79 0 3.58.68 4.95 2.05 2.73 2.73 2.73 7.17 0 9.9C16.58 19.32 14.79 20 13 20c-.97 0-1.94-.21-2.84-.61l-1.49 1.49C10.02 21.62 11.51 22 13 22c2.3 0 4.61-.88 6.36-2.64 3.52-3.51 3.52-9.21 0-12.72z'
    }));
  };

  var Rotate90DegreesCcwIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  Rotate90DegreesCcwIcon.displayName = 'Rotate90DegreesCcwIcon';
  Rotate90DegreesCcwIcon.defaultProps = {
    size: 24
  };
  exports.default = Rotate90DegreesCcwIcon;
});
unwrapExports(Rotate90DegreesCcw);
var RotateLeft = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M7.11 8.53L5.7 7.11C4.8 8.27 4.24 9.61 4.07 11h2.02c.14-.87.49-1.72 1.02-2.47zM6.09 13H4.07c.17 1.39.72 2.73 1.62 3.89l1.41-1.42c-.52-.75-.87-1.59-1.01-2.47zm1.01 5.32c1.16.9 2.51 1.44 3.9 1.61V17.9c-.87-.15-1.71-.49-2.46-1.03L7.1 18.32zM13 4.07V1L8.45 5.55 13 10V6.09c2.84.48 5 2.94 5 5.91s-2.16 5.43-5 5.91v2.02c3.95-.49 7-3.85 7-7.93s-3.05-7.44-7-7.93z'
    }));
  };

  var RotateLeftIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  RotateLeftIcon.displayName = 'RotateLeftIcon';
  RotateLeftIcon.defaultProps = {
    size: 24
  };
  exports.default = RotateLeftIcon;
});
unwrapExports(RotateLeft);
var RotateRight = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M15.55 5.55L11 1v3.07C7.06 4.56 4 7.92 4 12s3.05 7.44 7 7.93v-2.02c-2.84-.48-5-2.94-5-5.91s2.16-5.43 5-5.91V10l4.55-4.45zM19.93 11c-.17-1.39-.72-2.73-1.62-3.89l-1.42 1.42c.54.75.88 1.6 1.02 2.47h2.02zM13 17.9v2.02c1.39-.17 2.74-.71 3.9-1.61l-1.44-1.44c-.75.54-1.59.89-2.46 1.03zm3.89-2.42l1.42 1.41c.9-1.16 1.45-2.5 1.62-3.89h-2.02c-.14.87-.48 1.72-1.02 2.48z'
    }));
  };

  var RotateRightIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  RotateRightIcon.displayName = 'RotateRightIcon';
  RotateRightIcon.defaultProps = {
    size: 24
  };
  exports.default = RotateRightIcon;
});
unwrapExports(RotateRight);
var RoundedCorner = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 19h2v2h-2v-2zm0-2h2v-2h-2v2zM3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm0-4h2V3H3v2zm4 0h2V3H7v2zm8 16h2v-2h-2v2zm-4 0h2v-2h-2v2zm4 0h2v-2h-2v2zm-8 0h2v-2H7v2zm-4 0h2v-2H3v2zM21 8c0-2.76-2.24-5-5-5h-5v2h5c1.65 0 3 1.35 3 3v5h2V8z'
    }));
  };

  var RoundedCornerIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  RoundedCornerIcon.displayName = 'RoundedCornerIcon';
  RoundedCornerIcon.defaultProps = {
    size: 24
  };
  exports.default = RoundedCornerIcon;
});
unwrapExports(RoundedCorner);
var Router = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20.2 5.9l.8-.8C19.6 3.7 17.8 3 16 3s-3.6.7-5 2.1l.8.8C13 4.8 14.5 4.2 16 4.2s3 .6 4.2 1.7zm-.9.8c-.9-.9-2.1-1.4-3.3-1.4s-2.4.5-3.3 1.4l.8.8c.7-.7 1.6-1 2.5-1 .9 0 1.8.3 2.5 1l.8-.8zM19 13h-2V9h-2v4H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2zM8 18H6v-2h2v2zm3.5 0h-2v-2h2v2zm3.5 0h-2v-2h2v2z'
    }));
  };

  var RouterIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  RouterIcon.displayName = 'RouterIcon';
  RouterIcon.defaultProps = {
    size: 24
  };
  exports.default = RouterIcon;
});
unwrapExports(Router);
var Rowing = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M8.5 14.5L4 19l1.5 1.5L9 17h2l-2.5-2.5zM15 1c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 20.01L18 24l-2.99-3.01V19.5l-7.1-7.09c-.31.05-.61.07-.91.07v-2.16c1.66.03 3.61-.87 4.67-2.04l1.4-1.55c.19-.21.43-.38.69-.5.29-.14.62-.23.96-.23h.03C15.99 6.01 17 7.02 17 8.26v5.75c0 .84-.35 1.61-.92 2.16l-3.58-3.58v-2.27c-.63.52-1.43 1.02-2.29 1.39L16.5 18H18l3 3.01z'
    }));
  };

  var RowingIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  RowingIcon.displayName = 'RowingIcon';
  RowingIcon.defaultProps = {
    size: 24
  };
  exports.default = RowingIcon;
});
unwrapExports(Rowing);
var RssFeed = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M4 4.44v2.83c7.03 0 12.73 5.7 12.73 12.73h2.83c0-8.59-6.97-15.56-15.56-15.56zm0 5.66v2.83c3.9 0 7.07 3.17 7.07 7.07h2.83c0-5.47-4.43-9.9-9.9-9.9z M 6.18 15.64 A 2.18 2.18 0 0 1 6.18 20 A 2.18 2.18 0 0 1 6.18 15.64'
    }));
  };

  var RssFeedIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  RssFeedIcon.displayName = 'RssFeedIcon';
  RssFeedIcon.defaultProps = {
    size: 24
  };
  exports.default = RssFeedIcon;
});
unwrapExports(RssFeed);
var RvHookup = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 17v-6c0-1.1-.9-2-2-2H7V7l-3 3 3 3v-2h4v3H4v3c0 1.1.9 2 2 2h2c0 1.66 1.34 3 3 3s3-1.34 3-3h8v-2h-2zm-9 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm7-6h-4v-3h4v3zM17 2v2H9v2h8v2l3-3z'
    }));
  };

  var RvHookupIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  RvHookupIcon.displayName = 'RvHookupIcon';
  RvHookupIcon.defaultProps = {
    size: 24
  };
  exports.default = RvHookupIcon;
});
unwrapExports(RvHookup);
var Satellite = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5 4.99h3C8 6.65 6.66 8 5 8V4.99zM5 12v-2c2.76 0 5-2.25 5-5.01h2C12 8.86 8.87 12 5 12zm0 6l3.5-4.5 2.5 3.01L14.5 12l4.5 6H5z'
    }));
  };

  var SatelliteIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SatelliteIcon.displayName = 'SatelliteIcon';
  SatelliteIcon.defaultProps = {
    size: 24
  };
  exports.default = SatelliteIcon;
});
unwrapExports(Satellite);
var Save = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z'
    }));
  };

  var SaveIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SaveIcon.displayName = 'SaveIcon';
  SaveIcon.defaultProps = {
    size: 24
  };
  exports.default = SaveIcon;
});
unwrapExports(Save);
var Scanner = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19.8 10.7L4.2 5l-.7 1.9L17.6 12H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-5.5c0-.8-.5-1.6-1.2-1.8zM7 17H5v-2h2v2zm12 0H9v-2h10v2z'
    }));
  };

  var ScannerIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ScannerIcon.displayName = 'ScannerIcon';
  ScannerIcon.defaultProps = {
    size: 24
  };
  exports.default = ScannerIcon;
});
unwrapExports(Scanner);
var Schedule = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z'
    }));
  };

  var ScheduleIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ScheduleIcon.displayName = 'ScheduleIcon';
  ScheduleIcon.defaultProps = {
    size: 24
  };
  exports.default = ScheduleIcon;
});
unwrapExports(Schedule);
var School = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z'
    }));
  };

  var SchoolIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SchoolIcon.displayName = 'SchoolIcon';
  SchoolIcon.defaultProps = {
    size: 24
  };
  exports.default = SchoolIcon;
});
unwrapExports(School);
var ScreenLockLandscape = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21 5H3c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-2 12H5V7h14v10zm-9-1h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1v-1c0-1.11-.9-2-2-2-1.11 0-2 .9-2 2v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1zm.8-6c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2v1h-2.4v-1z'
    }));
  };

  var ScreenLockLandscapeIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ScreenLockLandscapeIcon.displayName = 'ScreenLockLandscapeIcon';
  ScreenLockLandscapeIcon.defaultProps = {
    size: 24
  };
  exports.default = ScreenLockLandscapeIcon;
});
unwrapExports(ScreenLockLandscape);
var ScreenLockPortrait = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M10 16h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1v-1c0-1.11-.9-2-2-2-1.11 0-2 .9-2 2v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1zm.8-6c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2v1h-2.4v-1zM17 1H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 18H7V5h10v14z'
    }));
  };

  var ScreenLockPortraitIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ScreenLockPortraitIcon.displayName = 'ScreenLockPortraitIcon';
  ScreenLockPortraitIcon.defaultProps = {
    size: 24
  };
  exports.default = ScreenLockPortraitIcon;
});
unwrapExports(ScreenLockPortrait);
var ScreenLockRotation = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M23.25 12.77l-2.57-2.57-1.41 1.41 2.22 2.22-5.66 5.66L4.51 8.17l5.66-5.66 2.1 2.1 1.41-1.41L11.23.75c-.59-.59-1.54-.59-2.12 0L2.75 7.11c-.59.59-.59 1.54 0 2.12l12.02 12.02c.59.59 1.54.59 2.12 0l6.36-6.36c.59-.59.59-1.54 0-2.12zM8.47 20.48C5.2 18.94 2.86 15.76 2.5 12H1c.51 6.16 5.66 11 11.95 11l.66-.03-3.81-3.82-1.33 1.33zM16 9h5c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1v-.5C21 1.12 19.88 0 18.5 0S16 1.12 16 2.5V3c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm.8-6.5c0-.94.76-1.7 1.7-1.7s1.7.76 1.7 1.7V3h-3.4v-.5z'
    }));
  };

  var ScreenLockRotationIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ScreenLockRotationIcon.displayName = 'ScreenLockRotationIcon';
  ScreenLockRotationIcon.defaultProps = {
    size: 24
  };
  exports.default = ScreenLockRotationIcon;
});
unwrapExports(ScreenLockRotation);
var ScreenRotation = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M16.48 2.52c3.27 1.55 5.61 4.72 5.97 8.48h1.5C23.44 4.84 18.29 0 12 0l-.66.03 3.81 3.81 1.33-1.32zm-6.25-.77c-.59-.59-1.54-.59-2.12 0L1.75 8.11c-.59.59-.59 1.54 0 2.12l12.02 12.02c.59.59 1.54.59 2.12 0l6.36-6.36c.59-.59.59-1.54 0-2.12L10.23 1.75zm4.6 19.44L2.81 9.17l6.36-6.36 12.02 12.02-6.36 6.36zm-7.31.29C4.25 19.94 1.91 16.76 1.55 13H.05C.56 19.16 5.71 24 12 24l.66-.03-3.81-3.81-1.33 1.32z'
    }));
  };

  var ScreenRotationIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ScreenRotationIcon.displayName = 'ScreenRotationIcon';
  ScreenRotationIcon.defaultProps = {
    size: 24
  };
  exports.default = ScreenRotationIcon;
});
unwrapExports(ScreenRotation);
var ScreenShare = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 18c1.1 0 1.99-.9 1.99-2L22 6c0-1.11-.9-2-2-2H4c-1.11 0-2 .89-2 2v10c0 1.1.89 2 2 2H0v2h24v-2h-4zm-7-3.53v-2.19c-2.78 0-4.61.85-6 2.72.56-2.67 2.11-5.33 6-5.87V7l4 3.73-4 3.74z'
    }));
  };

  var ScreenShareIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ScreenShareIcon.displayName = 'ScreenShareIcon';
  ScreenShareIcon.defaultProps = {
    size: 24
  };
  exports.default = ScreenShareIcon;
});
unwrapExports(ScreenShare);
var SdCard = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M18 2h-8L4.02 8 4 20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 6h-2V4h2v4zm3 0h-2V4h2v4zm3 0h-2V4h2v4z'
    }));
  };

  var SdCardIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SdCardIcon.displayName = 'SdCardIcon';
  SdCardIcon.defaultProps = {
    size: 24
  };
  exports.default = SdCardIcon;
});
unwrapExports(SdCard);
var SdStorage = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M18 2h-8L4.02 8 4 20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 6h-2V4h2v4zm3 0h-2V4h2v4zm3 0h-2V4h2v4z'
    }));
  };

  var SdStorageIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SdStorageIcon.displayName = 'SdStorageIcon';
  SdStorageIcon.defaultProps = {
    size: 24
  };
  exports.default = SdStorageIcon;
});
unwrapExports(SdStorage);
var Search = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z'
    }));
  };

  var SearchIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SearchIcon.displayName = 'SearchIcon';
  SearchIcon.defaultProps = {
    size: 24
  };
  exports.default = SearchIcon;
});
unwrapExports(Search);
var Security = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z'
    }));
  };

  var SecurityIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SecurityIcon.displayName = 'SecurityIcon';
  SecurityIcon.defaultProps = {
    size: 24
  };
  exports.default = SecurityIcon;
});
unwrapExports(Security);
var SelectAll = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M3 5h2V3c-1.1 0-2 .9-2 2zm0 8h2v-2H3v2zm4 8h2v-2H7v2zM3 9h2V7H3v2zm10-6h-2v2h2V3zm6 0v2h2c0-1.1-.9-2-2-2zM5 21v-2H3c0 1.1.9 2 2 2zm-2-4h2v-2H3v2zM9 3H7v2h2V3zm2 18h2v-2h-2v2zm8-8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zm0-12h2V7h-2v2zm0 8h2v-2h-2v2zm-4 4h2v-2h-2v2zm0-16h2V3h-2v2zM7 17h10V7H7v10zm2-8h6v6H9V9z'
    }));
  };

  var SelectAllIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SelectAllIcon.displayName = 'SelectAllIcon';
  SelectAllIcon.defaultProps = {
    size: 24
  };
  exports.default = SelectAllIcon;
});
unwrapExports(SelectAll);
var Send = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M2.01 21L23 12 2.01 3 2 10l15 2-15 2z'
    }));
  };

  var SendIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SendIcon.displayName = 'SendIcon';
  SendIcon.defaultProps = {
    size: 24
  };
  exports.default = SendIcon;
});
unwrapExports(Send);
var SentimentDissatisfied = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-6c-2.33 0-4.32 1.45-5.12 3.5h1.67c.69-1.19 1.97-2 3.45-2s2.75.81 3.45 2h1.67c-.8-2.05-2.79-3.5-5.12-3.5z M 15.5 8 A 1.5 1.5 0 0 1 15.5 11 A 1.5 1.5 0 0 1 15.5 8 M 8.5 8 A 1.5 1.5 0 0 0 8.5 11 A 1.5 1.5 0 0 0 8.5 8'
    }));
  };

  var SentimentDissatisfiedIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SentimentDissatisfiedIcon.displayName = 'SentimentDissatisfiedIcon';
  SentimentDissatisfiedIcon.defaultProps = {
    size: 24
  };
  exports.default = SentimentDissatisfiedIcon;
});
unwrapExports(SentimentDissatisfied);
var SentimentNeutral = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M9 14h6v1.5H9z M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z M 15.5 8 A 1.5 1.5 0 0 0 15.5 11 A 1.5 1.5 0 0 0 15.5 8 M 8.5 8 A 1.5 1.5 0 0 1 8.5 11 A 1.5 1.5 0 0 1 8.5 8'
    }));
  };

  var SentimentNeutralIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SentimentNeutralIcon.displayName = 'SentimentNeutralIcon';
  SentimentNeutralIcon.defaultProps = {
    size: 24
  };
  exports.default = SentimentNeutralIcon;
});
unwrapExports(SentimentNeutral);
var SentimentSatisfied = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-4c-1.48 0-2.75-.81-3.45-2H6.88c.8 2.05 2.79 3.5 5.12 3.5s4.32-1.45 5.12-3.5h-1.67c-.7 1.19-1.97 2-3.45 2z M 15.5 8 A 1.5 1.5 0 0 1 15.5 11 A 1.5 1.5 0 0 1 15.5 8 M 8.5 8 A 1.5 1.5 0 0 0 8.5 11 A 1.5 1.5 0 0 0 8.5 8'
    }));
  };

  var SentimentSatisfiedIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SentimentSatisfiedIcon.displayName = 'SentimentSatisfiedIcon';
  SentimentSatisfiedIcon.defaultProps = {
    size: 24
  };
  exports.default = SentimentSatisfiedIcon;
});
unwrapExports(SentimentSatisfied);
var SentimentVeryDissatisfied = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M11.99 2C6.47 2 2 6.47 2 12s4.47 10 9.99 10S22 17.53 22 12 17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm4.18-12.24l-1.06 1.06-1.06-1.06L13 8.82l1.06 1.06L13 10.94 14.06 12l1.06-1.06L16.18 12l1.06-1.06-1.06-1.06 1.06-1.06zM7.82 12l1.06-1.06L9.94 12 11 10.94 9.94 9.88 11 8.82 9.94 7.76 8.88 8.82 7.82 7.76 6.76 8.82l1.06 1.06-1.06 1.06zM12 14c-2.33 0-4.31 1.46-5.11 3.5h10.22c-.8-2.04-2.78-3.5-5.11-3.5z'
    }));
  };

  var SentimentVeryDissatisfiedIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SentimentVeryDissatisfiedIcon.displayName = 'SentimentVeryDissatisfiedIcon';
  SentimentVeryDissatisfiedIcon.defaultProps = {
    size: 24
  };
  exports.default = SentimentVeryDissatisfiedIcon;
});
unwrapExports(SentimentVeryDissatisfied);
var SentimentVerySatisfied = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M11.99 2C6.47 2 2 6.47 2 12s4.47 10 9.99 10S22 17.53 22 12 17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm1-10.06L14.06 11l1.06-1.06L16.18 11l1.06-1.06-2.12-2.12zm-4.12 0L9.94 11 11 9.94 8.88 7.82 6.76 9.94 7.82 11zM12 17.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z'
    }));
  };

  var SentimentVerySatisfiedIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SentimentVerySatisfiedIcon.displayName = 'SentimentVerySatisfiedIcon';
  SentimentVerySatisfiedIcon.defaultProps = {
    size: 24
  };
  exports.default = SentimentVerySatisfiedIcon;
});
unwrapExports(SentimentVerySatisfied);
var Settings = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19.43 12.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.23.09.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z'
    }));
  };

  var SettingsIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SettingsIcon.displayName = 'SettingsIcon';
  SettingsIcon.defaultProps = {
    size: 24
  };
  exports.default = SettingsIcon;
});
unwrapExports(Settings);
var SettingsApplications = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm7-7H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-1.75 9c0 .23-.02.46-.05.68l1.48 1.16c.13.11.17.3.08.45l-1.4 2.42c-.09.15-.27.21-.43.15l-1.74-.7c-.36.28-.76.51-1.18.69l-.26 1.85c-.03.17-.18.3-.35.3h-2.8c-.17 0-.32-.13-.35-.29l-.26-1.85c-.43-.18-.82-.41-1.18-.69l-1.74.7c-.16.06-.34 0-.43-.15l-1.4-2.42c-.09-.15-.05-.34.08-.45l1.48-1.16c-.03-.23-.05-.46-.05-.69 0-.23.02-.46.05-.68l-1.48-1.16c-.13-.11-.17-.3-.08-.45l1.4-2.42c.09-.15.27-.21.43-.15l1.74.7c.36-.28.76-.51 1.18-.69l.26-1.85c.03-.17.18-.3.35-.3h2.8c.17 0 .32.13.35.29l.26 1.85c.43.18.82.41 1.18.69l1.74-.7c.16-.06.34 0 .43.15l1.4 2.42c.09.15.05.34-.08.45l-1.48 1.16c.03.23.05.46.05.69z'
    }));
  };

  var SettingsApplicationsIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SettingsApplicationsIcon.displayName = 'SettingsApplicationsIcon';
  SettingsApplicationsIcon.defaultProps = {
    size: 24
  };
  exports.default = SettingsApplicationsIcon;
});
unwrapExports(SettingsApplications);
var SettingsBackupRestore = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M14 12c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2zm-2-9c-4.97 0-9 4.03-9 9H0l4 4 4-4H5c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.51 0-2.91-.49-4.06-1.3l-1.42 1.44C8.04 20.3 9.94 21 12 21c4.97 0 9-4.03 9-9s-4.03-9-9-9z'
    }));
  };

  var SettingsBackupRestoreIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SettingsBackupRestoreIcon.displayName = 'SettingsBackupRestoreIcon';
  SettingsBackupRestoreIcon.defaultProps = {
    size: 24
  };
  exports.default = SettingsBackupRestoreIcon;
});
unwrapExports(SettingsBackupRestore);
var SettingsBluetooth = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M11 24h2v-2h-2v2zm-4 0h2v-2H7v2zm8 0h2v-2h-2v2zm2.71-18.29L12 0h-1v7.59L6.41 3 5 4.41 10.59 10 5 15.59 6.41 17 11 12.41V20h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 3.83l1.88 1.88L13 7.59V3.83zm1.88 10.46L13 16.17v-3.76l1.88 1.88z'
    }));
  };

  var SettingsBluetoothIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SettingsBluetoothIcon.displayName = 'SettingsBluetoothIcon';
  SettingsBluetoothIcon.defaultProps = {
    size: 24
  };
  exports.default = SettingsBluetoothIcon;
});
unwrapExports(SettingsBluetooth);
var SettingsBrightness = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02zM8 16h2.5l1.5 1.5 1.5-1.5H16v-2.5l1.5-1.5-1.5-1.5V8h-2.5L12 6.5 10.5 8H8v2.5L6.5 12 8 13.5V16zm4-7c1.66 0 3 1.34 3 3s-1.34 3-3 3V9z'
    }));
  };

  var SettingsBrightnessIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SettingsBrightnessIcon.displayName = 'SettingsBrightnessIcon';
  SettingsBrightnessIcon.defaultProps = {
    size: 24
  };
  exports.default = SettingsBrightnessIcon;
});
unwrapExports(SettingsBrightness);
var SettingsCell = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M7 24h2v-2H7v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zM16 .01L8 0C6.9 0 6 .9 6 2v16c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V2c0-1.1-.9-1.99-2-1.99zM16 16H8V4h8v12z'
    }));
  };

  var SettingsCellIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SettingsCellIcon.displayName = 'SettingsCellIcon';
  SettingsCellIcon.defaultProps = {
    size: 24
  };
  exports.default = SettingsCellIcon;
});
unwrapExports(SettingsCell);
var SettingsEthernet = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M7.77 6.76L6.23 5.48.82 12l5.41 6.52 1.54-1.28L3.42 12l4.35-5.24zM7 13h2v-2H7v2zm10-2h-2v2h2v-2zm-6 2h2v-2h-2v2zm6.77-7.52l-1.54 1.28L20.58 12l-4.35 5.24 1.54 1.28L23.18 12l-5.41-6.52z'
    }));
  };

  var SettingsEthernetIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SettingsEthernetIcon.displayName = 'SettingsEthernetIcon';
  SettingsEthernetIcon.defaultProps = {
    size: 24
  };
  exports.default = SettingsEthernetIcon;
});
unwrapExports(SettingsEthernet);
var SettingsInputAntenna = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 5c-3.87 0-7 3.13-7 7h2c0-2.76 2.24-5 5-5s5 2.24 5 5h2c0-3.87-3.13-7-7-7zm1 9.29c.88-.39 1.5-1.26 1.5-2.29 0-1.38-1.12-2.5-2.5-2.5S9.5 10.62 9.5 12c0 1.02.62 1.9 1.5 2.29v3.3L7.59 21 9 22.41l3-3 3 3L16.41 21 13 17.59v-3.3zM12 1C5.93 1 1 5.93 1 12h2c0-4.97 4.03-9 9-9s9 4.03 9 9h2c0-6.07-4.93-11-11-11z'
    }));
  };

  var SettingsInputAntennaIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SettingsInputAntennaIcon.displayName = 'SettingsInputAntennaIcon';
  SettingsInputAntennaIcon.defaultProps = {
    size: 24
  };
  exports.default = SettingsInputAntennaIcon;
});
unwrapExports(SettingsInputAntenna);
var SettingsInputComponent = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M5 2c0-.55-.45-1-1-1s-1 .45-1 1v4H1v6h6V6H5V2zm4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2H9v2zm-8 0c0 1.3.84 2.4 2 2.82V23h2v-4.18C6.16 18.4 7 17.3 7 16v-2H1v2zM21 6V2c0-.55-.45-1-1-1s-1 .45-1 1v4h-2v6h6V6h-2zm-8-4c0-.55-.45-1-1-1s-1 .45-1 1v4H9v6h6V6h-2V2zm4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2h-6v2z'
    }));
  };

  var SettingsInputComponentIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SettingsInputComponentIcon.displayName = 'SettingsInputComponentIcon';
  SettingsInputComponentIcon.defaultProps = {
    size: 24
  };
  exports.default = SettingsInputComponentIcon;
});
unwrapExports(SettingsInputComponent);
var SettingsInputComposite = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M5 2c0-.55-.45-1-1-1s-1 .45-1 1v4H1v6h6V6H5V2zm4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2H9v2zm-8 0c0 1.3.84 2.4 2 2.82V23h2v-4.18C6.16 18.4 7 17.3 7 16v-2H1v2zM21 6V2c0-.55-.45-1-1-1s-1 .45-1 1v4h-2v6h6V6h-2zm-8-4c0-.55-.45-1-1-1s-1 .45-1 1v4H9v6h6V6h-2V2zm4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2h-6v2z'
    }));
  };

  var SettingsInputCompositeIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SettingsInputCompositeIcon.displayName = 'SettingsInputCompositeIcon';
  SettingsInputCompositeIcon.defaultProps = {
    size: 24
  };
  exports.default = SettingsInputCompositeIcon;
});
unwrapExports(SettingsInputComposite);
var SettingsInputHdmi = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M18 7V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v3H5v6l3 6v3h8v-3l3-6V7h-1zM8 4h8v3h-2V5h-1v2h-2V5h-1v2H8V4z'
    }));
  };

  var SettingsInputHdmiIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SettingsInputHdmiIcon.displayName = 'SettingsInputHdmiIcon';
  SettingsInputHdmiIcon.defaultProps = {
    size: 24
  };
  exports.default = SettingsInputHdmiIcon;
});
unwrapExports(SettingsInputHdmi);
var SettingsInputSvideo = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M8 11.5c0-.83-.67-1.5-1.5-1.5S5 10.67 5 11.5 5.67 13 6.5 13 8 12.33 8 11.5zm7-5c0-.83-.67-1.5-1.5-1.5h-3C9.67 5 9 5.67 9 6.5S9.67 8 10.5 8h3c.83 0 1.5-.67 1.5-1.5zM8.5 15c-.83 0-1.5.67-1.5 1.5S7.67 18 8.5 18s1.5-.67 1.5-1.5S9.33 15 8.5 15zM12 1C5.93 1 1 5.93 1 12s4.93 11 11 11 11-4.93 11-11S18.07 1 12 1zm0 20c-4.96 0-9-4.04-9-9s4.04-9 9-9 9 4.04 9 9-4.04 9-9 9zm5.5-11c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm-2 5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z'
    }));
  };

  var SettingsInputSvideoIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SettingsInputSvideoIcon.displayName = 'SettingsInputSvideoIcon';
  SettingsInputSvideoIcon.defaultProps = {
    size: 24
  };
  exports.default = SettingsInputSvideoIcon;
});
unwrapExports(SettingsInputSvideo);
var SettingsOverscan = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12.01 5.5L10 8h4l-1.99-2.5zM18 10v4l2.5-1.99L18 10zM6 10l-2.5 2.01L6 14v-4zm8 6h-4l2.01 2.5L14 16zm7-13H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z'
    }));
  };

  var SettingsOverscanIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SettingsOverscanIcon.displayName = 'SettingsOverscanIcon';
  SettingsOverscanIcon.defaultProps = {
    size: 24
  };
  exports.default = SettingsOverscanIcon;
});
unwrapExports(SettingsOverscan);
var SettingsPhone = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M13 9h-2v2h2V9zm4 0h-2v2h2V9zm3 6.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.58l2.2-2.21c.28-.27.36-.66.25-1.01C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM19 9v2h2V9h-2z'
    }));
  };

  var SettingsPhoneIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SettingsPhoneIcon.displayName = 'SettingsPhoneIcon';
  SettingsPhoneIcon.defaultProps = {
    size: 24
  };
  exports.default = SettingsPhoneIcon;
});
unwrapExports(SettingsPhone);
var SettingsPower = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M7 24h2v-2H7v2zm4 0h2v-2h-2v2zm2-22h-2v10h2V2zm3.56 2.44l-1.45 1.45C16.84 6.94 18 8.83 18 11c0 3.31-2.69 6-6 6s-6-2.69-6-6c0-2.17 1.16-4.06 2.88-5.12L7.44 4.44C5.36 5.88 4 8.28 4 11c0 4.42 3.58 8 8 8s8-3.58 8-8c0-2.72-1.36-5.12-3.44-6.56zM15 24h2v-2h-2v2z'
    }));
  };

  var SettingsPowerIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SettingsPowerIcon.displayName = 'SettingsPowerIcon';
  SettingsPowerIcon.defaultProps = {
    size: 24
  };
  exports.default = SettingsPowerIcon;
});
unwrapExports(SettingsPower);
var SettingsRemote = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M15 9H9c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V10c0-.55-.45-1-1-1zm-3 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM7.05 6.05l1.41 1.41C9.37 6.56 10.62 6 12 6s2.63.56 3.54 1.46l1.41-1.41C15.68 4.78 13.93 4 12 4s-3.68.78-4.95 2.05zM12 0C8.96 0 6.21 1.23 4.22 3.22l1.41 1.41C7.26 3.01 9.51 2 12 2s4.74 1.01 6.36 2.64l1.41-1.41C17.79 1.23 15.04 0 12 0z'
    }));
  };

  var SettingsRemoteIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SettingsRemoteIcon.displayName = 'SettingsRemoteIcon';
  SettingsRemoteIcon.defaultProps = {
    size: 24
  };
  exports.default = SettingsRemoteIcon;
});
unwrapExports(SettingsRemote);
var SettingsSystemDaydream = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M9 16h6.5c1.38 0 2.5-1.12 2.5-2.5S16.88 11 15.5 11h-.05c-.24-1.69-1.69-3-3.45-3-1.4 0-2.6.83-3.16 2.02h-.16C7.17 10.18 6 11.45 6 13c0 1.66 1.34 3 3 3zM21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z'
    }));
  };

  var SettingsSystemDaydreamIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SettingsSystemDaydreamIcon.displayName = 'SettingsSystemDaydreamIcon';
  SettingsSystemDaydreamIcon.defaultProps = {
    size: 24
  };
  exports.default = SettingsSystemDaydreamIcon;
});
unwrapExports(SettingsSystemDaydream);
var SettingsVoice = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M7 24h2v-2H7v2zm5-11c1.66 0 2.99-1.34 2.99-3L15 4c0-1.66-1.34-3-3-3S9 2.34 9 4v6c0 1.66 1.34 3 3 3zm-1 11h2v-2h-2v2zm4 0h2v-2h-2v2zm4-14h-1.7c0 3-2.54 5.1-5.3 5.1S6.7 13 6.7 10H5c0 3.41 2.72 6.23 6 6.72V20h2v-3.28c3.28-.49 6-3.31 6-6.72z'
    }));
  };

  var SettingsVoiceIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SettingsVoiceIcon.displayName = 'SettingsVoiceIcon';
  SettingsVoiceIcon.defaultProps = {
    size: 24
  };
  exports.default = SettingsVoiceIcon;
});
unwrapExports(SettingsVoice);
var Share = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z'
    }));
  };

  var ShareIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ShareIcon.displayName = 'ShareIcon';
  ShareIcon.defaultProps = {
    size: 24
  };
  exports.default = ShareIcon;
});
unwrapExports(Share);
var Shop = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M16 6V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H2v13c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6h-6zm-6-2h4v2h-4V4zM9 18V9l7.5 4L9 18z'
    }));
  };

  var ShopIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ShopIcon.displayName = 'ShopIcon';
  ShopIcon.defaultProps = {
    size: 24
  };
  exports.default = ShopIcon;
});
unwrapExports(Shop);
var ShopTwo = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M3 9H1v11c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2H3V9zm15-4V3c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H5v11c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2V5h-5zm-6-2h4v2h-4V3zm0 12V8l5.5 3-5.5 4z'
    }));
  };

  var ShopTwoIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ShopTwoIcon.displayName = 'ShopTwoIcon';
  ShopTwoIcon.defaultProps = {
    size: 24
  };
  exports.default = ShopTwoIcon;
});
unwrapExports(ShopTwo);
var ShoppingBasket = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M17.21 9l-4.38-6.56c-.19-.28-.51-.42-.83-.42-.32 0-.64.14-.83.43L6.79 9H2c-.55 0-1 .45-1 1 0 .09.01.18.04.27l2.54 9.27c.23.84 1 1.46 1.92 1.46h13c.92 0 1.69-.62 1.93-1.46l2.54-9.27L23 10c0-.55-.45-1-1-1h-4.79zM9 9l3-4.4L15 9H9zm3 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z'
    }));
  };

  var ShoppingBasketIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ShoppingBasketIcon.displayName = 'ShoppingBasketIcon';
  ShoppingBasketIcon.defaultProps = {
    size: 24
  };
  exports.default = ShoppingBasketIcon;
});
unwrapExports(ShoppingBasket);
var ShoppingCart = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z'
    }));
  };

  var ShoppingCartIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ShoppingCartIcon.displayName = 'ShoppingCartIcon';
  ShoppingCartIcon.defaultProps = {
    size: 24
  };
  exports.default = ShoppingCartIcon;
});
unwrapExports(ShoppingCart);
var ShortText = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M4 9h16v2H4zm0 4h10v2H4z'
    }));
  };

  var ShortTextIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ShortTextIcon.displayName = 'ShortTextIcon';
  ShortTextIcon.defaultProps = {
    size: 24
  };
  exports.default = ShortTextIcon;
});
unwrapExports(ShortText);
var ShowChart = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M3.5 18.49l6-6.01 4 4L22 6.92l-1.41-1.41-7.09 7.97-4-4L2 16.99z'
    }));
  };

  var ShowChartIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ShowChartIcon.displayName = 'ShowChartIcon';
  ShowChartIcon.defaultProps = {
    size: 24
  };
  exports.default = ShowChartIcon;
});
unwrapExports(ShowChart);
var Shuffle = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M10.59 9.17L5.41 4 4 5.41l5.17 5.17 1.42-1.41zM14.5 4l2.04 2.04L4 18.59 5.41 20 17.96 7.46 20 9.5V4h-5.5zm.33 9.41l-1.41 1.41 3.13 3.13L14.5 20H20v-5.5l-2.04 2.04-3.13-3.13z'
    }));
  };

  var ShuffleIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ShuffleIcon.displayName = 'ShuffleIcon';
  ShuffleIcon.defaultProps = {
    size: 24
  };
  exports.default = ShuffleIcon;
});
unwrapExports(Shuffle);
var SignalCellular0Bar = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M2 22h20V2z'
    }));
  };

  var SignalCellular0BarIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SignalCellular0BarIcon.displayName = 'SignalCellular0BarIcon';
  SignalCellular0BarIcon.defaultProps = {
    size: 24
  };
  exports.default = SignalCellular0BarIcon;
});
unwrapExports(SignalCellular0Bar);
var SignalCellular1Bar = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M2 22h20V2z M12 12L2 22h10z'
    }));
  };

  var SignalCellular1BarIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SignalCellular1BarIcon.displayName = 'SignalCellular1BarIcon';
  SignalCellular1BarIcon.defaultProps = {
    size: 24
  };
  exports.default = SignalCellular1BarIcon;
});
unwrapExports(SignalCellular1Bar);
var SignalCellular2Bar = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M2 22h20V2z M14 10L2 22h12z'
    }));
  };

  var SignalCellular2BarIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SignalCellular2BarIcon.displayName = 'SignalCellular2BarIcon';
  SignalCellular2BarIcon.defaultProps = {
    size: 24
  };
  exports.default = SignalCellular2BarIcon;
});
unwrapExports(SignalCellular2Bar);
var SignalCellular3Bar = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M2 22h20V2z M17 7L2 22h15z'
    }));
  };

  var SignalCellular3BarIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SignalCellular3BarIcon.displayName = 'SignalCellular3BarIcon';
  SignalCellular3BarIcon.defaultProps = {
    size: 24
  };
  exports.default = SignalCellular3BarIcon;
});
unwrapExports(SignalCellular3Bar);
var SignalCellular4Bar = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M2 22h20V2z'
    }));
  };

  var SignalCellular4BarIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SignalCellular4BarIcon.displayName = 'SignalCellular4BarIcon';
  SignalCellular4BarIcon.defaultProps = {
    size: 24
  };
  exports.default = SignalCellular4BarIcon;
});
unwrapExports(SignalCellular4Bar);
var SignalCellularConnectedNoInternet0Bar = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M22 8V2L2 22h16V8z M20 22h2v-2h-2v2zm0-12v8h2v-8h-2z'
    }));
  };

  var SignalCellularConnectedNoInternet0BarIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SignalCellularConnectedNoInternet0BarIcon.displayName = 'SignalCellularConnectedNoInternet0BarIcon';
  SignalCellularConnectedNoInternet0BarIcon.defaultProps = {
    size: 24
  };
  exports.default = SignalCellularConnectedNoInternet0BarIcon;
});
unwrapExports(SignalCellularConnectedNoInternet0Bar);
var SignalCellularConnectedNoInternet1Bar = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M22 8V2L2 22h16V8z M20 10v8h2v-8h-2zm-8 12V12L2 22h10zm8 0h2v-2h-2v2z'
    }));
  };

  var SignalCellularConnectedNoInternet1BarIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SignalCellularConnectedNoInternet1BarIcon.displayName = 'SignalCellularConnectedNoInternet1BarIcon';
  SignalCellularConnectedNoInternet1BarIcon.defaultProps = {
    size: 24
  };
  exports.default = SignalCellularConnectedNoInternet1BarIcon;
});
unwrapExports(SignalCellularConnectedNoInternet1Bar);
var SignalCellularConnectedNoInternet2Bar = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M22 8V2L2 22h16V8z M14 22V10L2 22h12zm6-12v8h2v-8h-2zm0 12h2v-2h-2v2z'
    }));
  };

  var SignalCellularConnectedNoInternet2BarIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SignalCellularConnectedNoInternet2BarIcon.displayName = 'SignalCellularConnectedNoInternet2BarIcon';
  SignalCellularConnectedNoInternet2BarIcon.defaultProps = {
    size: 24
  };
  exports.default = SignalCellularConnectedNoInternet2BarIcon;
});
unwrapExports(SignalCellularConnectedNoInternet2Bar);
var SignalCellularConnectedNoInternet3Bar = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M22 8V2L2 22h16V8z M17 22V7L2 22h15zm3-12v8h2v-8h-2zm0 12h2v-2h-2v2z'
    }));
  };

  var SignalCellularConnectedNoInternet3BarIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SignalCellularConnectedNoInternet3BarIcon.displayName = 'SignalCellularConnectedNoInternet3BarIcon';
  SignalCellularConnectedNoInternet3BarIcon.defaultProps = {
    size: 24
  };
  exports.default = SignalCellularConnectedNoInternet3BarIcon;
});
unwrapExports(SignalCellularConnectedNoInternet3Bar);
var SignalCellularConnectedNoInternet4Bar = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 18h2v-8h-2v8zm0 4h2v-2h-2v2zM2 22h16V8h4V2L2 22z'
    }));
  };

  var SignalCellularConnectedNoInternet4BarIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SignalCellularConnectedNoInternet4BarIcon.displayName = 'SignalCellularConnectedNoInternet4BarIcon';
  SignalCellularConnectedNoInternet4BarIcon.defaultProps = {
    size: 24
  };
  exports.default = SignalCellularConnectedNoInternet4BarIcon;
});
unwrapExports(SignalCellularConnectedNoInternet4Bar);
var SignalCellularNoSim = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M18.99 5c0-1.1-.89-2-1.99-2h-7L7.66 5.34 19 16.68 18.99 5zM3.65 3.88L2.38 5.15 5 7.77V19c0 1.1.9 2 2 2h10.01c.35 0 .67-.1.96-.26l1.88 1.88 1.27-1.27L3.65 3.88z'
    }));
  };

  var SignalCellularNoSimIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SignalCellularNoSimIcon.displayName = 'SignalCellularNoSimIcon';
  SignalCellularNoSimIcon.defaultProps = {
    size: 24
  };
  exports.default = SignalCellularNoSimIcon;
});
unwrapExports(SignalCellularNoSim);
var SignalCellularNull = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 6.83V20H6.83L20 6.83M22 2L2 22h20V2z'
    }));
  };

  var SignalCellularNullIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SignalCellularNullIcon.displayName = 'SignalCellularNullIcon';
  SignalCellularNullIcon.defaultProps = {
    size: 24
  };
  exports.default = SignalCellularNullIcon;
});
unwrapExports(SignalCellularNull);
var SignalCellularOff = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21 1l-8.59 8.59L21 18.18V1zM4.77 4.5L3.5 5.77l6.36 6.36L1 21h17.73l2 2L22 21.73 4.77 4.5z'
    }));
  };

  var SignalCellularOffIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SignalCellularOffIcon.displayName = 'SignalCellularOffIcon';
  SignalCellularOffIcon.defaultProps = {
    size: 24
  };
  exports.default = SignalCellularOffIcon;
});
unwrapExports(SignalCellularOff);
var SignalWifi0Bar = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z'
    }));
  };

  var SignalWifi0BarIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SignalWifi0BarIcon.displayName = 'SignalWifi0BarIcon';
  SignalWifi0BarIcon.defaultProps = {
    size: 24
  };
  exports.default = SignalWifi0BarIcon;
});
unwrapExports(SignalWifi0Bar);
var SignalWifi1Bar = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z M6.67 14.86L12 21.49v.01l.01-.01 5.33-6.63C17.06 14.65 15.03 13 12 13s-5.06 1.65-5.33 1.86z'
    }));
  };

  var SignalWifi1BarIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SignalWifi1BarIcon.displayName = 'SignalWifi1BarIcon';
  SignalWifi1BarIcon.defaultProps = {
    size: 24
  };
  exports.default = SignalWifi1BarIcon;
});
unwrapExports(SignalWifi1Bar);
var SignalWifi1BarLock = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16z M15.5 14.5c0-2.8 2.2-5 5-5 .4 0 .7 0 1 .1L23.6 7c-.4-.3-4.9-4-11.6-4C5.3 3 .8 6.7.4 7L12 21.5l3.5-4.3v-2.7z M6.7 14.9l5.3 6.6 3.5-4.3v-2.6c0-.2 0-.5.1-.7-.9-.5-2.2-.9-3.6-.9-3 0-5.1 1.7-5.3 1.9z'
    }));
  };

  var SignalWifi1BarLockIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SignalWifi1BarLockIcon.displayName = 'SignalWifi1BarLockIcon';
  SignalWifi1BarLockIcon.defaultProps = {
    size: 24
  };
  exports.default = SignalWifi1BarLockIcon;
});
unwrapExports(SignalWifi1BarLock);
var SignalWifi2Bar = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z M4.79 12.52l7.2 8.98H12l.01-.01 7.2-8.98C18.85 12.24 16.1 10 12 10s-6.85 2.24-7.21 2.52z'
    }));
  };

  var SignalWifi2BarIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SignalWifi2BarIcon.displayName = 'SignalWifi2BarIcon';
  SignalWifi2BarIcon.defaultProps = {
    size: 24
  };
  exports.default = SignalWifi2BarIcon;
});
unwrapExports(SignalWifi2Bar);
var SignalWifi2BarLock = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16z M15.5 14.5c0-2.8 2.2-5 5-5 .4 0 .7 0 1 .1L23.6 7c-.4-.3-4.9-4-11.6-4C5.3 3 .8 6.7.4 7L12 21.5l3.5-4.3v-2.7z M4.8 12.5l7.2 9 3.5-4.4v-2.6c0-1.3.5-2.5 1.4-3.4C15.6 10.5 14 10 12 10c-4.1 0-6.8 2.2-7.2 2.5z'
    }));
  };

  var SignalWifi2BarLockIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SignalWifi2BarLockIcon.displayName = 'SignalWifi2BarLockIcon';
  SignalWifi2BarLockIcon.defaultProps = {
    size: 24
  };
  exports.default = SignalWifi2BarLockIcon;
});
unwrapExports(SignalWifi2BarLock);
var SignalWifi3Bar = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z M3.53 10.95l8.46 10.54.01.01.01-.01 8.46-10.54C20.04 10.62 16.81 8 12 8c-4.81 0-8.04 2.62-8.47 2.95z'
    }));
  };

  var SignalWifi3BarIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SignalWifi3BarIcon.displayName = 'SignalWifi3BarIcon';
  SignalWifi3BarIcon.defaultProps = {
    size: 24
  };
  exports.default = SignalWifi3BarIcon;
});
unwrapExports(SignalWifi3Bar);
var SignalWifi3BarLock = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 3C5.3 3 .8 6.7.4 7l3.2 3.9L12 21.5l3.5-4.3v-2.6c0-2.2 1.4-4 3.3-4.7.3-.1.5-.2.8-.2.3-.1.6-.1.9-.1.4 0 .7 0 1 .1L23.6 7c-.4-.3-4.9-4-11.6-4z M23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16zm-10 5.5l3.5-4.3v-2.6c0-2.2 1.4-4 3.3-4.7C17.3 9 14.9 8 12 8c-4.8 0-8 2.6-8.5 2.9'
    }));
  };

  var SignalWifi3BarLockIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SignalWifi3BarLockIcon.displayName = 'SignalWifi3BarLockIcon';
  SignalWifi3BarLockIcon.defaultProps = {
    size: 24
  };
  exports.default = SignalWifi3BarLockIcon;
});
unwrapExports(SignalWifi3BarLock);
var SignalWifi4Bar = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z'
    }));
  };

  var SignalWifi4BarIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SignalWifi4BarIcon.displayName = 'SignalWifi4BarIcon';
  SignalWifi4BarIcon.defaultProps = {
    size: 24
  };
  exports.default = SignalWifi4BarIcon;
});
unwrapExports(SignalWifi4Bar);
var SignalWifi4BarLock = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16zm-6.5-1.5c0-2.8 2.2-5 5-5 .4 0 .7 0 1 .1L23.6 7c-.4-.3-4.9-4-11.6-4C5.3 3 .8 6.7.4 7L12 21.5l3.5-4.4v-2.6z'
    }));
  };

  var SignalWifi4BarLockIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SignalWifi4BarLockIcon.displayName = 'SignalWifi4BarLockIcon';
  SignalWifi4BarLockIcon.defaultProps = {
    size: 24
  };
  exports.default = SignalWifi4BarLockIcon;
});
unwrapExports(SignalWifi4BarLock);
var SignalWifiOff = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M23.64 7c-.45-.34-4.93-4-11.64-4-1.5 0-2.89.19-4.15.48L18.18 13.8 23.64 7zm-6.6 8.22L3.27 1.44 2 2.72l2.05 2.06C1.91 5.76.59 6.82.36 7l11.63 14.49.01.01.01-.01 3.9-4.86 3.32 3.32 1.27-1.27-3.46-3.46z'
    }));
  };

  var SignalWifiOffIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SignalWifiOffIcon.displayName = 'SignalWifiOffIcon';
  SignalWifiOffIcon.defaultProps = {
    size: 24
  };
  exports.default = SignalWifiOffIcon;
});
unwrapExports(SignalWifiOff);
var SignalWifiStatusbar1Bar26X24Px = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 26 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M13 21.99l5.66-7.05C18.44 14.78 16.27 13 13 13s-5.44 1.78-5.66 1.95L13 21.99z M13.01 21.99L25.58 6.32C25.1 5.96 20.26 2 13 2S.9 5.96.42 6.32l12.57 15.66.01.02.01-.01z'
    }));
  };

  var SignalWifiStatusbar1Bar26X24PxIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SignalWifiStatusbar1Bar26X24PxIcon.displayName = 'SignalWifiStatusbar1Bar26X24PxIcon';
  SignalWifiStatusbar1Bar26X24PxIcon.defaultProps = {
    size: 24
  };
  exports.default = SignalWifiStatusbar1Bar26X24PxIcon;
});
unwrapExports(SignalWifiStatusbar1Bar26X24Px);
var SignalWifiStatusbar2Bar26X24Px = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 26 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M13.01 21.99L25.58 6.32C25.1 5.96 20.26 2 13 2S.9 5.96.42 6.32l12.57 15.66.01.02.01-.01z M13.01 21.99l7.54-9.4C20.26 12.38 17.36 10 13 10c-4.36 0-7.26 2.38-7.55 2.59l7.54 9.4h.02z'
    }));
  };

  var SignalWifiStatusbar2Bar26X24PxIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SignalWifiStatusbar2Bar26X24PxIcon.displayName = 'SignalWifiStatusbar2Bar26X24PxIcon';
  SignalWifiStatusbar2Bar26X24PxIcon.defaultProps = {
    size: 24
  };
  exports.default = SignalWifiStatusbar2Bar26X24PxIcon;
});
unwrapExports(SignalWifiStatusbar2Bar26X24Px);
var SignalWifiStatusbar3Bar26X24Px = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 26 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M13.01 21.99l9.43-11.75C22.07 9.97 18.44 7 13 7c-5.44 0-9.07 2.97-9.44 3.24l9.43 11.75h.02z M13.01 21.99L25.58 6.32C25.1 5.96 20.26 2 13 2S.9 5.96.42 6.32l12.57 15.66.01.02.01-.01z'
    }));
  };

  var SignalWifiStatusbar3Bar26X24PxIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SignalWifiStatusbar3Bar26X24PxIcon.displayName = 'SignalWifiStatusbar3Bar26X24PxIcon';
  SignalWifiStatusbar3Bar26X24PxIcon.defaultProps = {
    size: 24
  };
  exports.default = SignalWifiStatusbar3Bar26X24PxIcon;
});
unwrapExports(SignalWifiStatusbar3Bar26X24Px);
var SignalWifiStatusbar4Bar26X24Px = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 26 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M13.01 21.99L25.58 6.32C25.1 5.96 20.26 2 13 2S.9 5.96.42 6.32l12.57 15.66.01.02.01-.01z'
    }));
  };

  var SignalWifiStatusbar4Bar26X24PxIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SignalWifiStatusbar4Bar26X24PxIcon.displayName = 'SignalWifiStatusbar4Bar26X24PxIcon';
  SignalWifiStatusbar4Bar26X24PxIcon.defaultProps = {
    size: 24
  };
  exports.default = SignalWifiStatusbar4Bar26X24PxIcon;
});
unwrapExports(SignalWifiStatusbar4Bar26X24Px);
var SignalWifiStatusbarConnectedNoInternet126X24Px = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 26 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M24.24 8l1.35-1.68C25.1 5.96 20.26 2 13 2S.9 5.96.42 6.32l12.57 15.66.01.02.01-.01L20 13.28V8h4.24z M7.34 14.95L13 21.99V22v-.01l5.66-7.05C18.44 14.78 16.27 13 13 13s-5.44 1.78-5.66 1.95zM22 22h2v-2h-2v2zm0-12v8h2v-8h-2z'
    }));
  };

  var SignalWifiStatusbarConnectedNoInternet126X24PxIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SignalWifiStatusbarConnectedNoInternet126X24PxIcon.displayName = 'SignalWifiStatusbarConnectedNoInternet126X24PxIcon';
  SignalWifiStatusbarConnectedNoInternet126X24PxIcon.defaultProps = {
    size: 24
  };
  exports.default = SignalWifiStatusbarConnectedNoInternet126X24PxIcon;
});
unwrapExports(SignalWifiStatusbarConnectedNoInternet126X24Px);
var SignalWifiStatusbarConnectedNoInternet226X24Px = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 26 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M24.24 8l1.35-1.68C25.1 5.96 20.26 2 13 2S.9 5.96.42 6.32l12.57 15.66.01.02.01-.01L20 13.28V8h4.24z M5.45 12.59l7.54 9.4.01.01.01-.01L20 13.28v-1.09c-1.07-.73-3.59-2.19-7-2.19-4.36 0-7.26 2.38-7.55 2.59zM22 10v8h2v-8h-2zm0 12h2v-2h-2v2z'
    }));
  };

  var SignalWifiStatusbarConnectedNoInternet226X24PxIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SignalWifiStatusbarConnectedNoInternet226X24PxIcon.displayName = 'SignalWifiStatusbarConnectedNoInternet226X24PxIcon';
  SignalWifiStatusbarConnectedNoInternet226X24PxIcon.defaultProps = {
    size: 24
  };
  exports.default = SignalWifiStatusbarConnectedNoInternet226X24PxIcon;
});
unwrapExports(SignalWifiStatusbarConnectedNoInternet226X24Px);
var SignalWifiStatusbarConnectedNoInternet26X24Px = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 26 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M24.24 8l1.35-1.68C25.1 5.96 20.26 2 13 2S.9 5.96.42 6.32l12.57 15.66.01.02.01-.01L20 13.28V8h4.24z M22 22h2v-2h-2v2zm0-12v8h2v-8h-2z'
    }));
  };

  var SignalWifiStatusbarConnectedNoInternet26X24PxIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SignalWifiStatusbarConnectedNoInternet26X24PxIcon.displayName = 'SignalWifiStatusbarConnectedNoInternet26X24PxIcon';
  SignalWifiStatusbarConnectedNoInternet26X24PxIcon.defaultProps = {
    size: 24
  };
  exports.default = SignalWifiStatusbarConnectedNoInternet26X24PxIcon;
});
unwrapExports(SignalWifiStatusbarConnectedNoInternet26X24Px);
var SignalWifiStatusbarConnectedNoInternet326X24Px = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 26 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M24.24 8l1.35-1.68C25.1 5.96 20.26 2 13 2S.9 5.96.42 6.32l12.57 15.66.01.02.01-.01L20 13.28V8h4.24z M20 13.28V8.71C18.35 7.87 15.94 7 13 7c-5.44 0-9.07 2.97-9.44 3.24l9.43 11.75.01.01.01-.01L20 13.28zM22 20h2v2h-2zm0-10h2v8h-2z'
    }));
  };

  var SignalWifiStatusbarConnectedNoInternet326X24PxIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SignalWifiStatusbarConnectedNoInternet326X24PxIcon.displayName = 'SignalWifiStatusbarConnectedNoInternet326X24PxIcon';
  SignalWifiStatusbarConnectedNoInternet326X24PxIcon.defaultProps = {
    size: 24
  };
  exports.default = SignalWifiStatusbarConnectedNoInternet326X24PxIcon;
});
unwrapExports(SignalWifiStatusbarConnectedNoInternet326X24Px);
var SignalWifiStatusbarConnectedNoInternet426X24Px = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 26 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M22 22h2v-2h-2v2zM13 2C5.74 2 .9 5.96.42 6.32l12.57 15.66.01.02.01-.01L20 13.28V8h4.24l1.35-1.68C25.1 5.96 20.26 2 13 2zm9 16h2v-8h-2v8z'
    }));
  };

  var SignalWifiStatusbarConnectedNoInternet426X24PxIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SignalWifiStatusbarConnectedNoInternet426X24PxIcon.displayName = 'SignalWifiStatusbarConnectedNoInternet426X24PxIcon';
  SignalWifiStatusbarConnectedNoInternet426X24PxIcon.defaultProps = {
    size: 24
  };
  exports.default = SignalWifiStatusbarConnectedNoInternet426X24PxIcon;
});
unwrapExports(SignalWifiStatusbarConnectedNoInternet426X24Px);
var SignalWifiStatusbarNotConnected26X24Px = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 26 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21 8.5c.85 0 1.64.23 2.34.62l2.24-2.79C25.1 5.96 20.26 2 13 2S.9 5.96.42 6.32l12.57 15.66.01.02.01-.01 4.21-5.24c-.76-.87-1.22-2-1.22-3.25 0-2.76 2.24-5 5-5z M21 10c-1.93 0-3.5 1.57-3.5 3.5h1.75c0-.97.78-1.75 1.75-1.75s1.75.78 1.75 1.75c0 .48-.2.92-.51 1.24l-1.09 1.1c-.63.63-1.02 1.51-1.02 2.47v.44h1.75c0-1.31.39-1.84 1.03-2.47l.78-.8c.5-.5.82-1.2.82-1.97C24.5 11.57 22.93 10 21 10zm-.95 11.95h1.9v-1.9h-1.9v1.9z'
    }));
  };

  var SignalWifiStatusbarNotConnected26X24PxIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SignalWifiStatusbarNotConnected26X24PxIcon.displayName = 'SignalWifiStatusbarNotConnected26X24PxIcon';
  SignalWifiStatusbarNotConnected26X24PxIcon.defaultProps = {
    size: 24
  };
  exports.default = SignalWifiStatusbarNotConnected26X24PxIcon;
});
unwrapExports(SignalWifiStatusbarNotConnected26X24Px);
var SignalWifiStatusbarNull26X24Px = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 26 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M13 4c4.25 0 7.62 1.51 9.68 2.75L13 18.8 3.33 6.75C5.38 5.51 8.75 4 13 4m0-2C5.74 2 .9 5.96.42 6.32l12.57 15.66.01.02.01-.01L25.58 6.32C25.1 5.96 20.26 2 13 2z'
    }));
  };

  var SignalWifiStatusbarNull26X24PxIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SignalWifiStatusbarNull26X24PxIcon.displayName = 'SignalWifiStatusbarNull26X24PxIcon';
  SignalWifiStatusbarNull26X24PxIcon.defaultProps = {
    size: 24
  };
  exports.default = SignalWifiStatusbarNull26X24PxIcon;
});
unwrapExports(SignalWifiStatusbarNull26X24Px);
var SimCard = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19.99 4c0-1.1-.89-2-1.99-2h-8L4 8v12c0 1.1.9 2 2 2h12.01c1.1 0 1.99-.9 1.99-2l-.01-16zM9 19H7v-2h2v2zm8 0h-2v-2h2v2zm-8-4H7v-4h2v4zm4 4h-2v-4h2v4zm0-6h-2v-2h2v2zm4 2h-2v-4h2v4z'
    }));
  };

  var SimCardIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SimCardIcon.displayName = 'SimCardIcon';
  SimCardIcon.defaultProps = {
    size: 24
  };
  exports.default = SimCardIcon;
});
unwrapExports(SimCard);
var SimCardAlert = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M18 2h-8L4.02 8 4 20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-5 15h-2v-2h2v2zm0-4h-2V8h2v5z'
    }));
  };

  var SimCardAlertIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SimCardAlertIcon.displayName = 'SimCardAlertIcon';
  SimCardAlertIcon.defaultProps = {
    size: 24
  };
  exports.default = SimCardAlertIcon;
});
unwrapExports(SimCardAlert);
var SkipNext = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M6 18l8.5-6L6 6v12zM16 6v12h2V6h-2z'
    }));
  };

  var SkipNextIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SkipNextIcon.displayName = 'SkipNextIcon';
  SkipNextIcon.defaultProps = {
    size: 24
  };
  exports.default = SkipNextIcon;
});
unwrapExports(SkipNext);
var SkipPrevious = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M6 6h2v12H6zm3.5 6l8.5 6V6z'
    }));
  };

  var SkipPreviousIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SkipPreviousIcon.displayName = 'SkipPreviousIcon';
  SkipPreviousIcon.defaultProps = {
    size: 24
  };
  exports.default = SkipPreviousIcon;
});
unwrapExports(SkipPrevious);
var Slideshow = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M10 8v8l5-4-5-4zm9-5H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z'
    }));
  };

  var SlideshowIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SlideshowIcon.displayName = 'SlideshowIcon';
  SlideshowIcon.defaultProps = {
    size: 24
  };
  exports.default = SlideshowIcon;
});
unwrapExports(Slideshow);
var SlowMotionVideo = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M13.05 9.79L10 7.5v9l3.05-2.29L16 12zm0 0L10 7.5v9l3.05-2.29L16 12zm0 0L10 7.5v9l3.05-2.29L16 12zM11 4.07V2.05c-2.01.2-3.84 1-5.32 2.21L7.1 5.69c1.11-.86 2.44-1.44 3.9-1.62zM5.69 7.1L4.26 5.68C3.05 7.16 2.25 8.99 2.05 11h2.02c.18-1.46.76-2.79 1.62-3.9zM4.07 13H2.05c.2 2.01 1 3.84 2.21 5.32l1.43-1.43c-.86-1.1-1.44-2.43-1.62-3.89zm1.61 6.74C7.16 20.95 9 21.75 11 21.95v-2.02c-1.46-.18-2.79-.76-3.9-1.62l-1.42 1.43zM22 12c0 5.16-3.92 9.42-8.95 9.95v-2.02C16.97 19.41 20 16.05 20 12s-3.03-7.41-6.95-7.93V2.05C18.08 2.58 22 6.84 22 12z'
    }));
  };

  var SlowMotionVideoIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SlowMotionVideoIcon.displayName = 'SlowMotionVideoIcon';
  SlowMotionVideoIcon.defaultProps = {
    size: 24
  };
  exports.default = SlowMotionVideoIcon;
});
unwrapExports(SlowMotionVideo);
var Smartphone = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z'
    }));
  };

  var SmartphoneIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SmartphoneIcon.displayName = 'SmartphoneIcon';
  SmartphoneIcon.defaultProps = {
    size: 24
  };
  exports.default = SmartphoneIcon;
});
unwrapExports(Smartphone);
var SmokeFree = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M2 6l6.99 7H2v3h9.99l7 7 1.26-1.25-17-17zm18.5 7H22v3h-1.5zM18 13h1.5v3H18zm.85-8.12c.62-.61 1-1.45 1-2.38h-1.5c0 1.02-.83 1.85-1.85 1.85v1.5c2.24 0 4 1.83 4 4.07V12H22V9.92c0-2.23-1.28-4.15-3.15-5.04zM14.5 8.7h1.53c1.05 0 1.97.74 1.97 2.05V12h1.5v-1.59c0-1.8-1.6-3.16-3.47-3.16H14.5c-1.02 0-1.85-.98-1.85-2s.83-1.75 1.85-1.75V2c-1.85 0-3.35 1.5-3.35 3.35s1.5 3.35 3.35 3.35zm2.5 7.23V13h-2.93z'
    }));
  };

  var SmokeFreeIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SmokeFreeIcon.displayName = 'SmokeFreeIcon';
  SmokeFreeIcon.defaultProps = {
    size: 24
  };
  exports.default = SmokeFreeIcon;
});
unwrapExports(SmokeFree);
var SmokingRooms = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M2 16h15v3H2zm18.5 0H22v3h-1.5zM18 16h1.5v3H18zm.85-8.27c.62-.61 1-1.45 1-2.38C19.85 3.5 18.35 2 16.5 2v1.5c1.02 0 1.85.83 1.85 1.85S17.52 7.2 16.5 7.2v1.5c2.24 0 4 1.83 4 4.07V15H22v-2.24c0-2.22-1.28-4.14-3.15-5.03zm-2.82 2.47H14.5c-1.02 0-1.85-.98-1.85-2s.83-1.75 1.85-1.75v-1.5c-1.85 0-3.35 1.5-3.35 3.35s1.5 3.35 3.35 3.35h1.53c1.05 0 1.97.74 1.97 2.05V15h1.5v-1.64c0-1.81-1.6-3.16-3.47-3.16z'
    }));
  };

  var SmokingRoomsIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SmokingRoomsIcon.displayName = 'SmokingRoomsIcon';
  SmokingRoomsIcon.defaultProps = {
    size: 24
  };
  exports.default = SmokingRoomsIcon;
});
unwrapExports(SmokingRooms);
var Sms = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 11H7V9h2v2zm4 0h-2V9h2v2zm4 0h-2V9h2v2z'
    }));
  };

  var SmsIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SmsIcon.displayName = 'SmsIcon';
  SmsIcon.defaultProps = {
    size: 24
  };
  exports.default = SmsIcon;
});
unwrapExports(Sms);
var SmsFailed = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 12h-2v-2h2v2zm0-4h-2V6h2v4z'
    }));
  };

  var SmsFailedIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SmsFailedIcon.displayName = 'SmsFailedIcon';
  SmsFailedIcon.defaultProps = {
    size: 24
  };
  exports.default = SmsFailedIcon;
});
unwrapExports(SmsFailed);
var Snooze = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm-3-9h3.63L9 15.2V17h6v-2h-3.63L15 10.8V9H9v2z'
    }));
  };

  var SnoozeIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SnoozeIcon.displayName = 'SnoozeIcon';
  SnoozeIcon.defaultProps = {
    size: 24
  };
  exports.default = SnoozeIcon;
});
unwrapExports(Snooze);
var Sort = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M3 18h6v-2H3v2zM3 6v2h18V6H3zm0 7h12v-2H3v2z'
    }));
  };

  var SortIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SortIcon.displayName = 'SortIcon';
  SortIcon.defaultProps = {
    size: 24
  };
  exports.default = SortIcon;
});
unwrapExports(Sort);
var SortByAlpha = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M14.94 4.66h-4.72l2.36-2.36zm-4.69 14.71h4.66l-2.33 2.33zM6.1 6.27L1.6 17.73h1.84l.92-2.45h5.11l.92 2.45h1.84L7.74 6.27H6.1zm-1.13 7.37l1.94-5.18 1.94 5.18H4.97zm10.76 2.5h6.12v1.59h-8.53v-1.29l5.92-8.56h-5.88v-1.6h8.3v1.26l-5.93 8.6z'
    }));
  };

  var SortByAlphaIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SortByAlphaIcon.displayName = 'SortByAlphaIcon';
  SortByAlphaIcon.defaultProps = {
    size: 24
  };
  exports.default = SortByAlphaIcon;
});
unwrapExports(SortByAlpha);
var Spa = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M8.55 12c-1.07-.71-2.25-1.27-3.53-1.61 1.28.34 2.46.9 3.53 1.61zm10.43-1.61c-1.29.34-2.49.91-3.57 1.64 1.08-.73 2.28-1.3 3.57-1.64z M15.49 9.63c-.18-2.79-1.31-5.51-3.43-7.63-2.14 2.14-3.32 4.86-3.55 7.63 1.28.68 2.46 1.56 3.49 2.63 1.03-1.06 2.21-1.94 3.49-2.63zm-6.5 2.65c-.14-.1-.3-.19-.45-.29.15.11.31.19.45.29zm6.42-.25c-.13.09-.27.16-.4.26.13-.1.27-.17.4-.26zM12 15.45C9.85 12.17 6.18 10 2 10c0 5.32 3.36 9.82 8.03 11.49.63.23 1.29.4 1.97.51.68-.12 1.33-.29 1.97-.51C18.64 19.82 22 15.32 22 10c-4.18 0-7.85 2.17-10 5.45z'
    }));
  };

  var SpaIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SpaIcon.displayName = 'SpaIcon';
  SpaIcon.defaultProps = {
    size: 24
  };
  exports.default = SpaIcon;
});
unwrapExports(Spa);
var SpaceBar = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M18 9v4H6V9H4v6h16V9z'
    }));
  };

  var SpaceBarIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SpaceBarIcon.displayName = 'SpaceBarIcon';
  SpaceBarIcon.defaultProps = {
    size: 24
  };
  exports.default = SpaceBarIcon;
});
unwrapExports(SpaceBar);
var Speaker = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M17 2H7c-1.1 0-2 .9-2 2v16c0 1.1.9 1.99 2 1.99L17 22c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-5 2c1.1 0 2 .9 2 2s-.9 2-2 2c-1.11 0-2-.9-2-2s.89-2 2-2zm0 16c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z'
    }));
  };

  var SpeakerIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SpeakerIcon.displayName = 'SpeakerIcon';
  SpeakerIcon.defaultProps = {
    size: 24
  };
  exports.default = SpeakerIcon;
});
unwrapExports(Speaker);
var SpeakerGroup = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M18.2 1H9.8C8.81 1 8 1.81 8 2.8v14.4c0 .99.81 1.79 1.8 1.79l8.4.01c.99 0 1.8-.81 1.8-1.8V2.8c0-.99-.81-1.8-1.8-1.8zM14 3c1.1 0 2 .89 2 2s-.9 2-2 2-2-.89-2-2 .9-2 2-2zm0 13.5c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z M6 5H4v16c0 1.1.89 2 2 2h10v-2H6V5z M 14 10 A 2.5 2.5 0 0 0 14 15 A 2.5 2.5 0 0 0 14 10'
    }));
  };

  var SpeakerGroupIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SpeakerGroupIcon.displayName = 'SpeakerGroupIcon';
  SpeakerGroupIcon.defaultProps = {
    size: 24
  };
  exports.default = SpeakerGroupIcon;
});
unwrapExports(SpeakerGroup);
var SpeakerNotes = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM8 14H6v-2h2v2zm0-3H6V9h2v2zm0-3H6V6h2v2zm7 6h-5v-2h5v2zm3-3h-8V9h8v2zm0-3h-8V6h8v2z'
    }));
  };

  var SpeakerNotesIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SpeakerNotesIcon.displayName = 'SpeakerNotesIcon';
  SpeakerNotesIcon.defaultProps = {
    size: 24
  };
  exports.default = SpeakerNotesIcon;
});
unwrapExports(SpeakerNotes);
var SpeakerNotesOff = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M10.54 11l-.54-.54L7.54 8 6 6.46 2.38 2.84 1.27 1.73 0 3l2.01 2.01L2 22l4-4h9l5.73 5.73L22 22.46 17.54 18l-7-7zM8 14H6v-2h2v2zm-2-3V9l2 2H6zm14-9H4.08L10 7.92V6h8v2h-7.92l1 1H18v2h-4.92l6.99 6.99C21.14 17.95 22 17.08 22 16V4c0-1.1-.9-2-2-2z'
    }));
  };

  var SpeakerNotesOffIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SpeakerNotesOffIcon.displayName = 'SpeakerNotesOffIcon';
  SpeakerNotesOffIcon.defaultProps = {
    size: 24
  };
  exports.default = SpeakerNotesOffIcon;
});
unwrapExports(SpeakerNotesOff);
var SpeakerPhone = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M7 7.07L8.43 8.5c.91-.91 2.18-1.48 3.57-1.48s2.66.57 3.57 1.48L17 7.07C15.72 5.79 13.95 5 12 5s-3.72.79-5 2.07zM12 1C8.98 1 6.24 2.23 4.25 4.21l1.41 1.41C7.28 4 9.53 3 12 3s4.72 1 6.34 2.62l1.41-1.41C17.76 2.23 15.02 1 12 1zm2.86 9.01L9.14 10C8.51 10 8 10.51 8 11.14v9.71c0 .63.51 1.14 1.14 1.14h5.71c.63 0 1.14-.51 1.14-1.14v-9.71c.01-.63-.5-1.13-1.13-1.13zM15 20H9v-8h6v8z'
    }));
  };

  var SpeakerPhoneIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SpeakerPhoneIcon.displayName = 'SpeakerPhoneIcon';
  SpeakerPhoneIcon.defaultProps = {
    size: 24
  };
  exports.default = SpeakerPhoneIcon;
});
unwrapExports(SpeakerPhone);
var Spellcheck = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12.45 16h2.09L9.43 3H7.57L2.46 16h2.09l1.12-3h5.64l1.14 3zm-6.02-5L8.5 5.48 10.57 11H6.43zm15.16.59l-8.09 8.09L9.83 16l-1.41 1.41 5.09 5.09L23 13l-1.41-1.41z'
    }));
  };

  var SpellcheckIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SpellcheckIcon.displayName = 'SpellcheckIcon';
  SpellcheckIcon.defaultProps = {
    size: 24
  };
  exports.default = SpellcheckIcon;
});
unwrapExports(Spellcheck);
var Star = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z'
    }));
  };

  var StarIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  StarIcon.displayName = 'StarIcon';
  StarIcon.defaultProps = {
    size: 24
  };
  exports.default = StarIcon;
});
unwrapExports(Star);
var StarBorder = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z'
    }));
  };

  var StarBorderIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  StarBorderIcon.displayName = 'StarBorderIcon';
  StarBorderIcon.defaultProps = {
    size: 24
  };
  exports.default = StarBorderIcon;
});
unwrapExports(StarBorder);
var StarHalf = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4V6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z'
    }));
  };

  var StarHalfIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  StarHalfIcon.displayName = 'StarHalfIcon';
  StarHalfIcon.defaultProps = {
    size: 24
  };
  exports.default = StarHalfIcon;
});
unwrapExports(StarHalf);
var Stars = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm4.24 16L12 15.45 7.77 18l1.12-4.81-3.73-3.23 4.92-.42L12 5l1.92 4.53 4.92.42-3.73 3.23L16.23 18z'
    }));
  };

  var StarsIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  StarsIcon.displayName = 'StarsIcon';
  StarsIcon.defaultProps = {
    size: 24
  };
  exports.default = StarsIcon;
});
unwrapExports(Stars);
var StayCurrentLandscape = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M1.01 7L1 17c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2H3c-1.1 0-1.99.9-1.99 2zM19 7v10H5V7h14z'
    }));
  };

  var StayCurrentLandscapeIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  StayCurrentLandscapeIcon.displayName = 'StayCurrentLandscapeIcon';
  StayCurrentLandscapeIcon.defaultProps = {
    size: 24
  };
  exports.default = StayCurrentLandscapeIcon;
});
unwrapExports(StayCurrentLandscape);
var StayCurrentPortrait = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M17 1.01L7 1c-1.1 0-1.99.9-1.99 2v18c0 1.1.89 2 1.99 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z'
    }));
  };

  var StayCurrentPortraitIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  StayCurrentPortraitIcon.displayName = 'StayCurrentPortraitIcon';
  StayCurrentPortraitIcon.defaultProps = {
    size: 24
  };
  exports.default = StayCurrentPortraitIcon;
});
unwrapExports(StayCurrentPortrait);
var StayPrimaryLandscape = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M1.01 7L1 17c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2H3c-1.1 0-1.99.9-1.99 2zM19 7v10H5V7h14z'
    }));
  };

  var StayPrimaryLandscapeIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  StayPrimaryLandscapeIcon.displayName = 'StayPrimaryLandscapeIcon';
  StayPrimaryLandscapeIcon.defaultProps = {
    size: 24
  };
  exports.default = StayPrimaryLandscapeIcon;
});
unwrapExports(StayPrimaryLandscape);
var StayPrimaryPortrait = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M17 1.01L7 1c-1.1 0-1.99.9-1.99 2v18c0 1.1.89 2 1.99 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z'
    }));
  };

  var StayPrimaryPortraitIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  StayPrimaryPortraitIcon.displayName = 'StayPrimaryPortraitIcon';
  StayPrimaryPortraitIcon.defaultProps = {
    size: 24
  };
  exports.default = StayPrimaryPortraitIcon;
});
unwrapExports(StayPrimaryPortrait);
var Stop = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M6 6h12v12H6z'
    }));
  };

  var StopIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  StopIcon.displayName = 'StopIcon';
  StopIcon.defaultProps = {
    size: 24
  };
  exports.default = StopIcon;
});
unwrapExports(Stop);
var StopScreenShare = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21.22 18.02l2 2H24v-2h-2.78zm.77-2l.01-10c0-1.11-.9-2-2-2H7.22l5.23 5.23c.18-.04.36-.07.55-.1V7.02l4 3.73-1.58 1.47 5.54 5.54c.61-.33 1.03-.99 1.03-1.74zM2.39 1.73L1.11 3l1.54 1.54c-.4.36-.65.89-.65 1.48v10c0 1.1.89 2 2 2H0v2h18.13l2.71 2.71 1.27-1.27L2.39 1.73zM7 15.02c.31-1.48.92-2.95 2.07-4.06l1.59 1.59c-1.54.38-2.7 1.18-3.66 2.47z'
    }));
  };

  var StopScreenShareIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  StopScreenShareIcon.displayName = 'StopScreenShareIcon';
  StopScreenShareIcon.defaultProps = {
    size: 24
  };
  exports.default = StopScreenShareIcon;
});
unwrapExports(StopScreenShare);
var Storage = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M2 20h20v-4H2v4zm2-3h2v2H4v-2zM2 4v4h20V4H2zm4 3H4V5h2v2zm-4 7h20v-4H2v4zm2-3h2v2H4v-2z'
    }));
  };

  var StorageIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  StorageIcon.displayName = 'StorageIcon';
  StorageIcon.defaultProps = {
    size: 24
  };
  exports.default = StorageIcon;
});
unwrapExports(Storage);
var Store = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 4H4v2h16V4zm1 10v-2l-1-5H4l-1 5v2h1v6h10v-6h4v6h2v-6h1zm-9 4H6v-4h6v4z'
    }));
  };

  var StoreIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  StoreIcon.displayName = 'StoreIcon';
  StoreIcon.defaultProps = {
    size: 24
  };
  exports.default = StoreIcon;
});
unwrapExports(Store);
var StoreMallDirectory = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 4H4v2h16V4zm1 10v-2l-1-5H4l-1 5v2h1v6h10v-6h4v6h2v-6h1zm-9 4H6v-4h6v4z'
    }));
  };

  var StoreMallDirectoryIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  StoreMallDirectoryIcon.displayName = 'StoreMallDirectoryIcon';
  StoreMallDirectoryIcon.defaultProps = {
    size: 24
  };
  exports.default = StoreMallDirectoryIcon;
});
unwrapExports(StoreMallDirectory);
var Straighten = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 10H3V8h2v4h2V8h2v4h2V8h2v4h2V8h2v4h2V8h2v8z'
    }));
  };

  var StraightenIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  StraightenIcon.displayName = 'StraightenIcon';
  StraightenIcon.defaultProps = {
    size: 24
  };
  exports.default = StraightenIcon;
});
unwrapExports(Straighten);
var Streetview = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12.56 14.33c-.34.27-.56.7-.56 1.17V21h7c1.1 0 2-.9 2-2v-5.98c-.94-.33-1.95-.52-3-.52-2.03 0-3.93.7-5.44 1.83z M11.5 6c0-1.08.27-2.1.74-3H5c-1.1 0-2 .9-2 2v14c0 .55.23 1.05.59 1.41l9.82-9.82C12.23 9.42 11.5 7.8 11.5 6z M 18 1 A 5 5 0 0 0 18 11 A 5 5 0 0 0 18 1'
    }));
  };

  var StreetviewIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  StreetviewIcon.displayName = 'StreetviewIcon';
  StreetviewIcon.defaultProps = {
    size: 24
  };
  exports.default = StreetviewIcon;
});
unwrapExports(Streetview);
var StrikethroughS = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M7.24 8.75c-.26-.48-.39-1.03-.39-1.67 0-.61.13-1.16.4-1.67.26-.5.63-.93 1.11-1.29.48-.35 1.05-.63 1.7-.83.66-.19 1.39-.29 2.18-.29.81 0 1.54.11 2.21.34.66.22 1.23.54 1.69.94.47.4.83.88 1.08 1.43.25.55.38 1.15.38 1.81h-3.01c0-.31-.05-.59-.15-.85-.09-.27-.24-.49-.44-.68-.2-.19-.45-.33-.75-.44-.3-.1-.66-.16-1.06-.16-.39 0-.74.04-1.03.13-.29.09-.53.21-.72.36-.19.16-.34.34-.44.55-.1.21-.15.43-.15.66 0 .48.25.88.74 1.21.38.25.77.48 1.41.7H7.39c-.05-.08-.11-.17-.15-.25zM21 12v-2H3v2h9.62c.18.07.4.14.55.2.37.17.66.34.87.51.21.17.35.36.43.57.07.2.11.43.11.69 0 .23-.05.45-.14.66-.09.2-.23.38-.42.53-.19.15-.42.26-.71.35-.29.08-.63.13-1.01.13-.43 0-.83-.04-1.18-.13s-.66-.23-.91-.42c-.25-.19-.45-.44-.59-.75-.14-.31-.25-.76-.25-1.21H6.4c0 .55.08 1.13.24 1.58.16.45.37.85.65 1.21.28.35.6.66.98.92.37.26.78.48 1.22.65.44.17.9.3 1.38.39.48.08.96.13 1.44.13.8 0 1.53-.09 2.18-.28s1.21-.45 1.67-.79c.46-.34.82-.77 1.07-1.27s.38-1.07.38-1.71c0-.6-.1-1.14-.31-1.61-.05-.11-.11-.23-.17-.33H21z'
    }));
  };

  var StrikethroughSIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  StrikethroughSIcon.displayName = 'StrikethroughSIcon';
  StrikethroughSIcon.defaultProps = {
    size: 24
  };
  exports.default = StrikethroughSIcon;
});
unwrapExports(StrikethroughS);
var Style = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M2.53 19.65l1.34.56v-9.03l-2.43 5.86c-.41 1.02.08 2.19 1.09 2.61zm19.5-3.7L17.07 3.98c-.31-.75-1.04-1.21-1.81-1.23-.26 0-.53.04-.79.15L7.1 5.95c-.75.31-1.21 1.03-1.23 1.8-.01.27.04.54.15.8l4.96 11.97c.31.76 1.05 1.22 1.83 1.23.26 0 .52-.05.77-.15l7.36-3.05c1.02-.42 1.51-1.59 1.09-2.6zM7.88 8.75c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-2 11c0 1.1.9 2 2 2h1.45l-3.45-8.34v6.34z'
    }));
  };

  var StyleIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  StyleIcon.displayName = 'StyleIcon';
  StyleIcon.defaultProps = {
    size: 24
  };
  exports.default = StyleIcon;
});
unwrapExports(Style);
var SubdirectoryArrowLeft = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M11 9l1.42 1.42L8.83 14H18V4h2v12H8.83l3.59 3.58L11 21l-6-6 6-6z'
    }));
  };

  var SubdirectoryArrowLeftIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SubdirectoryArrowLeftIcon.displayName = 'SubdirectoryArrowLeftIcon';
  SubdirectoryArrowLeftIcon.defaultProps = {
    size: 24
  };
  exports.default = SubdirectoryArrowLeftIcon;
});
unwrapExports(SubdirectoryArrowLeft);
var SubdirectoryArrowRight = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 15l-6 6-1.42-1.42L15.17 16H4V4h2v10h9.17l-3.59-3.58L13 9l6 6z'
    }));
  };

  var SubdirectoryArrowRightIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SubdirectoryArrowRightIcon.displayName = 'SubdirectoryArrowRightIcon';
  SubdirectoryArrowRightIcon.defaultProps = {
    size: 24
  };
  exports.default = SubdirectoryArrowRightIcon;
});
unwrapExports(SubdirectoryArrowRight);
var Subject = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M14 17H4v2h10v-2zm6-8H4v2h16V9zM4 15h16v-2H4v2zM4 5v2h16V5H4z'
    }));
  };

  var SubjectIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SubjectIcon.displayName = 'SubjectIcon';
  SubjectIcon.defaultProps = {
    size: 24
  };
  exports.default = SubjectIcon;
});
unwrapExports(Subject);
var Subscriptions = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 8H4V6h16v2zm-2-6H6v2h12V2zm4 10v8c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2v-8c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2zm-6 4l-6-3.27v6.53L16 16z'
    }));
  };

  var SubscriptionsIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SubscriptionsIcon.displayName = 'SubscriptionsIcon';
  SubscriptionsIcon.defaultProps = {
    size: 24
  };
  exports.default = SubscriptionsIcon;
});
unwrapExports(Subscriptions);
var Subtitles = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM4 12h4v2H4v-2zm10 6H4v-2h10v2zm6 0h-4v-2h4v2zm0-4H10v-2h10v2z'
    }));
  };

  var SubtitlesIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SubtitlesIcon.displayName = 'SubtitlesIcon';
  SubtitlesIcon.defaultProps = {
    size: 24
  };
  exports.default = SubtitlesIcon;
});
unwrapExports(Subtitles);
var Subway = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M7.01 9h10v5h-10z M17.8 2.8C16 2.09 13.86 2 12 2c-1.86 0-4 .09-5.8.8C3.53 3.84 2 6.05 2 8.86V22h20V8.86c0-2.81-1.53-5.02-4.2-6.06zm.2 13.08c0 1.45-1.18 2.62-2.63 2.62l1.13 1.12V20H15l-1.5-1.5h-2.83L9.17 20H7.5v-.38l1.12-1.12C7.18 18.5 6 17.32 6 15.88V9c0-2.63 3-3 6-3 3.32 0 6 .38 6 3v6.88z M 15.5 15 A 1 1 0 0 1 15.5 17 A 1 1 0 0 1 15.5 15 M 8.5 15 A 1 1 0 0 0 8.5 17 A 1 1 0 0 0 8.5 15'
    }));
  };

  var SubwayIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SubwayIcon.displayName = 'SubwayIcon';
  SubwayIcon.defaultProps = {
    size: 24
  };
  exports.default = SubwayIcon;
});
unwrapExports(Subway);
var SupervisorAccount = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M16.5 12c1.38 0 2.49-1.12 2.49-2.5S17.88 7 16.5 7C15.12 7 14 8.12 14 9.5s1.12 2.5 2.5 2.5zM9 11c1.66 0 2.99-1.34 2.99-3S10.66 5 9 5C7.34 5 6 6.34 6 8s1.34 3 3 3zm7.5 3c-1.83 0-5.5.92-5.5 2.75V19h11v-2.25c0-1.83-3.67-2.75-5.5-2.75zM9 13c-2.33 0-7 1.17-7 3.5V19h7v-2.25c0-.85.33-2.34 2.37-3.47C10.5 13.1 9.66 13 9 13z'
    }));
  };

  var SupervisorAccountIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SupervisorAccountIcon.displayName = 'SupervisorAccountIcon';
  SupervisorAccountIcon.defaultProps = {
    size: 24
  };
  exports.default = SupervisorAccountIcon;
});
unwrapExports(SupervisorAccount);
var SurroundSound = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7.76 16.24l-1.41 1.41C4.78 16.1 4 14.05 4 12c0-2.05.78-4.1 2.34-5.66l1.41 1.41C6.59 8.93 6 10.46 6 12s.59 3.07 1.76 4.24zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm5.66 1.66l-1.41-1.41C17.41 15.07 18 13.54 18 12s-.59-3.07-1.76-4.24l1.41-1.41C19.22 7.9 20 9.95 20 12c0 2.05-.78 4.1-2.34 5.66zM12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z'
    }));
  };

  var SurroundSoundIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SurroundSoundIcon.displayName = 'SurroundSoundIcon';
  SurroundSoundIcon.defaultProps = {
    size: 24
  };
  exports.default = SurroundSoundIcon;
});
unwrapExports(SurroundSound);
var SwapCalls = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M18 4l-4 4h3v7c0 1.1-.9 2-2 2s-2-.9-2-2V8c0-2.21-1.79-4-4-4S5 5.79 5 8v7H2l4 4 4-4H7V8c0-1.1.9-2 2-2s2 .9 2 2v7c0 2.21 1.79 4 4 4s4-1.79 4-4V8h3l-4-4z'
    }));
  };

  var SwapCallsIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SwapCallsIcon.displayName = 'SwapCallsIcon';
  SwapCallsIcon.defaultProps = {
    size: 24
  };
  exports.default = SwapCallsIcon;
});
unwrapExports(SwapCalls);
var SwapHoriz = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M6.99 11L3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z'
    }));
  };

  var SwapHorizIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SwapHorizIcon.displayName = 'SwapHorizIcon';
  SwapHorizIcon.defaultProps = {
    size: 24
  };
  exports.default = SwapHorizIcon;
});
unwrapExports(SwapHoriz);
var SwapVert = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z'
    }));
  };

  var SwapVertIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SwapVertIcon.displayName = 'SwapVertIcon';
  SwapVertIcon.defaultProps = {
    size: 24
  };
  exports.default = SwapVertIcon;
});
unwrapExports(SwapVert);
var SwapVerticalCircle = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM6.5 9L10 5.5 13.5 9H11v4H9V9H6.5zm11 6L14 18.5 10.5 15H13v-4h2v4h2.5z'
    }));
  };

  var SwapVerticalCircleIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SwapVerticalCircleIcon.displayName = 'SwapVerticalCircleIcon';
  SwapVerticalCircleIcon.defaultProps = {
    size: 24
  };
  exports.default = SwapVerticalCircleIcon;
});
unwrapExports(SwapVerticalCircle);
var SwitchCamera = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 4h-3.17L15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-5 11.5V13H9v2.5L5.5 12 9 8.5V11h6V8.5l3.5 3.5-3.5 3.5z'
    }));
  };

  var SwitchCameraIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SwitchCameraIcon.displayName = 'SwitchCameraIcon';
  SwitchCameraIcon.defaultProps = {
    size: 24
  };
  exports.default = SwitchCameraIcon;
});
unwrapExports(SwitchCamera);
var SwitchVideo = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M18 9.5V6c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-3.5l4 4v-13l-4 4zm-5 6V13H7v2.5L3.5 12 7 8.5V11h6V8.5l3.5 3.5-3.5 3.5z'
    }));
  };

  var SwitchVideoIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SwitchVideoIcon.displayName = 'SwitchVideoIcon';
  SwitchVideoIcon.defaultProps = {
    size: 24
  };
  exports.default = SwitchVideoIcon;
});
unwrapExports(SwitchVideo);
var Sync = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z'
    }));
  };

  var SyncIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SyncIcon.displayName = 'SyncIcon';
  SyncIcon.defaultProps = {
    size: 24
  };
  exports.default = SyncIcon;
});
unwrapExports(Sync);
var SyncDisabled = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M10 6.35V4.26c-.8.21-1.55.54-2.23.96l1.46 1.46c.25-.12.5-.24.77-.33zm-7.14-.94l2.36 2.36C4.45 8.99 4 10.44 4 12c0 2.21.91 4.2 2.36 5.64L4 20h6v-6l-2.24 2.24C6.68 15.15 6 13.66 6 12c0-1 .25-1.94.68-2.77l8.08 8.08c-.25.13-.5.25-.77.34v2.09c.8-.21 1.55-.54 2.23-.96l2.36 2.36 1.27-1.27L4.14 4.14 2.86 5.41zM20 4h-6v6l2.24-2.24C17.32 8.85 18 10.34 18 12c0 1-.25 1.94-.68 2.77l1.46 1.46C19.55 15.01 20 13.56 20 12c0-2.21-.91-4.2-2.36-5.64L20 4z'
    }));
  };

  var SyncDisabledIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SyncDisabledIcon.displayName = 'SyncDisabledIcon';
  SyncDisabledIcon.defaultProps = {
    size: 24
  };
  exports.default = SyncDisabledIcon;
});
unwrapExports(SyncDisabled);
var SyncProblem = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M3 12c0 2.21.91 4.2 2.36 5.64L3 20h6v-6l-2.24 2.24C5.68 15.15 5 13.66 5 12c0-2.61 1.67-4.83 4-5.65V4.26C5.55 5.15 3 8.27 3 12zm8 5h2v-2h-2v2zM21 4h-6v6l2.24-2.24C18.32 8.85 19 10.34 19 12c0 2.61-1.67 4.83-4 5.65v2.09c3.45-.89 6-4.01 6-7.74 0-2.21-.91-4.2-2.36-5.64L21 4zm-10 9h2V7h-2v6z'
    }));
  };

  var SyncProblemIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SyncProblemIcon.displayName = 'SyncProblemIcon';
  SyncProblemIcon.defaultProps = {
    size: 24
  };
  exports.default = SyncProblemIcon;
});
unwrapExports(SyncProblem);
var SystemUpdate = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14zm-1-6h-3V8h-2v5H8l4 4 4-4z'
    }));
  };

  var SystemUpdateIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SystemUpdateIcon.displayName = 'SystemUpdateIcon';
  SystemUpdateIcon.defaultProps = {
    size: 24
  };
  exports.default = SystemUpdateIcon;
});
unwrapExports(SystemUpdate);
var SystemUpdateAlt = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 16.5l4-4h-3v-9h-2v9H8l4 4zm9-13h-6v1.99h6v14.03H3V5.49h6V3.5H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2v-14c0-1.1-.9-2-2-2z'
    }));
  };

  var SystemUpdateAltIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  SystemUpdateAltIcon.displayName = 'SystemUpdateAltIcon';
  SystemUpdateAltIcon.defaultProps = {
    size: 24
  };
  exports.default = SystemUpdateAltIcon;
});
unwrapExports(SystemUpdateAlt);
var Tab = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h10v4h8v10z'
    }));
  };

  var TabIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  TabIcon.displayName = 'TabIcon';
  TabIcon.defaultProps = {
    size: 24
  };
  exports.default = TabIcon;
});
unwrapExports(Tab);
var TabUnselected = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M1 9h2V7H1v2zm0 4h2v-2H1v2zm0-8h2V3c-1.1 0-2 .9-2 2zm8 16h2v-2H9v2zm-8-4h2v-2H1v2zm2 4v-2H1c0 1.1.9 2 2 2zM21 3h-8v6h10V5c0-1.1-.9-2-2-2zm0 14h2v-2h-2v2zM9 5h2V3H9v2zM5 21h2v-2H5v2zM5 5h2V3H5v2zm16 16c1.1 0 2-.9 2-2h-2v2zm0-8h2v-2h-2v2zm-8 8h2v-2h-2v2zm4 0h2v-2h-2v2z'
    }));
  };

  var TabUnselectedIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  TabUnselectedIcon.displayName = 'TabUnselectedIcon';
  TabUnselectedIcon.defaultProps = {
    size: 24
  };
  exports.default = TabUnselectedIcon;
});
unwrapExports(TabUnselected);
var Tablet = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21 4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 1.99-.9 1.99-2L23 6c0-1.1-.9-2-2-2zm-2 14H5V6h14v12z'
    }));
  };

  var TabletIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  TabletIcon.displayName = 'TabletIcon';
  TabletIcon.defaultProps = {
    size: 24
  };
  exports.default = TabletIcon;
});
unwrapExports(Tablet);
var TabletAndroid = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M18 0H6C4.34 0 3 1.34 3 3v18c0 1.66 1.34 3 3 3h12c1.66 0 3-1.34 3-3V3c0-1.66-1.34-3-3-3zm-4 22h-4v-1h4v1zm5.25-3H4.75V3h14.5v16z'
    }));
  };

  var TabletAndroidIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  TabletAndroidIcon.displayName = 'TabletAndroidIcon';
  TabletAndroidIcon.defaultProps = {
    size: 24
  };
  exports.default = TabletAndroidIcon;
});
unwrapExports(TabletAndroid);
var TabletMac = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M18.5 0h-14C3.12 0 2 1.12 2 2.5v19C2 22.88 3.12 24 4.5 24h14c1.38 0 2.5-1.12 2.5-2.5v-19C21 1.12 19.88 0 18.5 0zm-7 23c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm7.5-4H4V3h15v16z'
    }));
  };

  var TabletMacIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  TabletMacIcon.displayName = 'TabletMacIcon';
  TabletMacIcon.defaultProps = {
    size: 24
  };
  exports.default = TabletMacIcon;
});
unwrapExports(TabletMac);
var TagFaces = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z'
    }));
  };

  var TagFacesIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  TagFacesIcon.displayName = 'TagFacesIcon';
  TagFacesIcon.defaultProps = {
    size: 24
  };
  exports.default = TagFacesIcon;
});
unwrapExports(TagFaces);
var TapAndPlay = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M2 16v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm0 4v3h3c0-1.66-1.34-3-3-3zm0-8v2c4.97 0 9 4.03 9 9h2c0-6.08-4.92-11-11-11zM17 1.01L7 1c-1.1 0-2 .9-2 2v7.37c.69.16 1.36.37 2 .64V5h10v13h-3.03c.52 1.25.84 2.59.95 4H17c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99z'
    }));
  };

  var TapAndPlayIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  TapAndPlayIcon.displayName = 'TapAndPlayIcon';
  TapAndPlayIcon.defaultProps = {
    size: 24
  };
  exports.default = TapAndPlayIcon;
});
unwrapExports(TapAndPlay);
var Terrain = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M14 6l-3.75 5 2.85 3.8-1.6 1.2C9.81 13.75 7 10 7 10l-6 8h22L14 6z'
    }));
  };

  var TerrainIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  TerrainIcon.displayName = 'TerrainIcon';
  TerrainIcon.defaultProps = {
    size: 24
  };
  exports.default = TerrainIcon;
});
unwrapExports(Terrain);
var TextFields = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M2.5 4v3h5v12h3V7h5V4h-13zm19 5h-9v3h3v7h3v-7h3V9z'
    }));
  };

  var TextFieldsIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  TextFieldsIcon.displayName = 'TextFieldsIcon';
  TextFieldsIcon.defaultProps = {
    size: 24
  };
  exports.default = TextFieldsIcon;
});
unwrapExports(TextFields);
var TextFormat = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M5 17v2h14v-2H5zm4.5-4.2h5l.9 2.2h2.1L12.75 4h-1.5L6.5 15h2.1l.9-2.2zM12 5.98L13.87 11h-3.74L12 5.98z'
    }));
  };

  var TextFormatIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  TextFormatIcon.displayName = 'TextFormatIcon';
  TextFormatIcon.defaultProps = {
    size: 24
  };
  exports.default = TextFormatIcon;
});
unwrapExports(TextFormat);
var Textsms = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 11H7V9h2v2zm4 0h-2V9h2v2zm4 0h-2V9h2v2z'
    }));
  };

  var TextsmsIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  TextsmsIcon.displayName = 'TextsmsIcon';
  TextsmsIcon.defaultProps = {
    size: 24
  };
  exports.default = TextsmsIcon;
});
unwrapExports(Textsms);
var Texture = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19.51 3.08L3.08 19.51c.09.34.27.65.51.9.25.24.56.42.9.51L20.93 4.49c-.19-.69-.73-1.23-1.42-1.41zM11.88 3L3 11.88v2.83L14.71 3h-2.83zM5 3c-1.1 0-2 .9-2 2v2l4-4H5zm14 18c.55 0 1.05-.22 1.41-.59.37-.36.59-.86.59-1.41v-2l-4 4h2zm-9.71 0h2.83L21 12.12V9.29L9.29 21z'
    }));
  };

  var TextureIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  TextureIcon.displayName = 'TextureIcon';
  TextureIcon.defaultProps = {
    size: 24
  };
  exports.default = TextureIcon;
});
unwrapExports(Texture);
var Theaters = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M18 3v2h-2V3H8v2H6V3H4v18h2v-2h2v2h8v-2h2v2h2V3h-2zM8 17H6v-2h2v2zm0-4H6v-2h2v2zm0-4H6V7h2v2zm10 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2z'
    }));
  };

  var TheatersIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  TheatersIcon.displayName = 'TheatersIcon';
  TheatersIcon.defaultProps = {
    size: 24
  };
  exports.default = TheatersIcon;
});
unwrapExports(Theaters);
var ThreeDRotation = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M7.52 21.48C4.25 19.94 1.91 16.76 1.55 13H.05C.56 19.16 5.71 24 12 24l.66-.03-3.81-3.81-1.33 1.32zm.89-6.52c-.19 0-.37-.03-.52-.08-.16-.06-.29-.13-.4-.24-.11-.1-.2-.22-.26-.37-.06-.14-.09-.3-.09-.47h-1.3c0 .36.07.68.21.95.14.27.33.5.56.69.24.18.51.32.82.41.3.1.62.15.96.15.37 0 .72-.05 1.03-.15.32-.1.6-.25.83-.44s.42-.43.55-.72c.13-.29.2-.61.2-.97 0-.19-.02-.38-.07-.56-.05-.18-.12-.35-.23-.51-.1-.16-.24-.3-.4-.43-.17-.13-.37-.23-.61-.31.2-.09.37-.2.52-.33.15-.13.27-.27.37-.42.1-.15.17-.3.22-.46.05-.16.07-.32.07-.48 0-.36-.06-.68-.18-.96-.12-.28-.29-.51-.51-.69-.2-.19-.47-.33-.77-.43C9.1 8.05 8.76 8 8.39 8c-.36 0-.69.05-1 .16-.3.11-.57.26-.79.45-.21.19-.38.41-.51.67-.12.26-.18.54-.18.85h1.3c0-.17.03-.32.09-.45s.14-.25.25-.34c.11-.09.23-.17.38-.22.15-.05.3-.08.48-.08.4 0 .7.1.89.31.19.2.29.49.29.86 0 .18-.03.34-.08.49-.05.15-.14.27-.25.37-.11.1-.25.18-.41.24-.16.06-.36.09-.58.09H7.5v1.03h.77c.22 0 .42.02.6.07s.33.13.45.23c.12.11.22.24.29.4.07.16.1.35.1.57 0 .41-.12.72-.35.93-.23.23-.55.33-.95.33zm8.55-5.92c-.32-.33-.7-.59-1.14-.77-.43-.18-.92-.27-1.46-.27H12v8h2.3c.55 0 1.06-.09 1.51-.27.45-.18.84-.43 1.16-.76.32-.33.57-.73.74-1.19.17-.47.26-.99.26-1.57v-.4c0-.58-.09-1.1-.26-1.57-.18-.47-.43-.87-.75-1.2zm-.39 3.16c0 .42-.05.79-.14 1.13-.1.33-.24.62-.43.85-.19.23-.43.41-.71.53-.29.12-.62.18-.99.18h-.91V9.12h.97c.72 0 1.27.23 1.64.69.38.46.57 1.12.57 1.99v.4zM12 0l-.66.03 3.81 3.81 1.33-1.33c3.27 1.55 5.61 4.72 5.96 8.48h1.5C23.44 4.84 18.29 0 12 0z'
    }));
  };

  var ThreeDRotationIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ThreeDRotationIcon.displayName = 'ThreeDRotationIcon';
  ThreeDRotationIcon.defaultProps = {
    size: 24
  };
  exports.default = ThreeDRotationIcon;
});
unwrapExports(ThreeDRotation);
var ThumbDown = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M15 3H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v1.91l.01.01L1 14c0 1.1.9 2 2 2h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 23l6.59-6.59c.36-.36.58-.86.58-1.41V5c0-1.1-.9-2-2-2zm4 0v12h4V3h-4z'
    }));
  };

  var ThumbDownIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ThumbDownIcon.displayName = 'ThumbDownIcon';
  ThumbDownIcon.defaultProps = {
    size: 24
  };
  exports.default = ThumbDownIcon;
});
unwrapExports(ThumbDown);
var ThumbUp = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M1 21h4V9H1v12zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-1.91l-.01-.01L23 10z'
    }));
  };

  var ThumbUpIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ThumbUpIcon.displayName = 'ThumbUpIcon';
  ThumbUpIcon.defaultProps = {
    size: 24
  };
  exports.default = ThumbUpIcon;
});
unwrapExports(ThumbUp);
var ThumbsUpDown = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 6c0-.55-.45-1-1-1H5.82l.66-3.18.02-.23c0-.31-.13-.59-.33-.8L5.38 0 .44 4.94C.17 5.21 0 5.59 0 6v6.5c0 .83.67 1.5 1.5 1.5h6.75c.62 0 1.15-.38 1.38-.91l2.26-5.29c.07-.17.11-.36.11-.55V6zm10.5 4h-6.75c-.62 0-1.15.38-1.38.91l-2.26 5.29c-.07.17-.11.36-.11.55V18c0 .55.45 1 1 1h5.18l-.66 3.18-.02.24c0 .31.13.59.33.8l.79.78 4.94-4.94c.27-.27.44-.65.44-1.06v-6.5c0-.83-.67-1.5-1.5-1.5z'
    }));
  };

  var ThumbsUpDownIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ThumbsUpDownIcon.displayName = 'ThumbsUpDownIcon';
  ThumbsUpDownIcon.defaultProps = {
    size: 24
  };
  exports.default = ThumbsUpDownIcon;
});
unwrapExports(ThumbsUpDown);
var TimeToLeave = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M18.92 5.01C18.72 4.42 18.16 4 17.5 4h-11c-.66 0-1.21.42-1.42 1.01L3 11v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 15c-.83 0-1.5-.67-1.5-1.5S5.67 12 6.5 12s1.5.67 1.5 1.5S7.33 15 6.5 15zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 10l1.5-4.5h11L19 10H5z'
    }));
  };

  var TimeToLeaveIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  TimeToLeaveIcon.displayName = 'TimeToLeaveIcon';
  TimeToLeaveIcon.defaultProps = {
    size: 24
  };
  exports.default = TimeToLeaveIcon;
});
unwrapExports(TimeToLeave);
var Timelapse = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M16.24 7.76C15.07 6.59 13.54 6 12 6v6l-4.24 4.24c2.34 2.34 6.14 2.34 8.49 0 2.34-2.34 2.34-6.14-.01-8.48zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z'
    }));
  };

  var TimelapseIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  TimelapseIcon.displayName = 'TimelapseIcon';
  TimelapseIcon.defaultProps = {
    size: 24
  };
  exports.default = TimelapseIcon;
});
unwrapExports(Timelapse);
var Timeline = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M23 8c0 1.1-.9 2-2 2-.18 0-.35-.02-.51-.07l-3.56 3.55c.05.16.07.34.07.52 0 1.1-.9 2-2 2s-2-.9-2-2c0-.18.02-.36.07-.52l-2.55-2.55c-.16.05-.34.07-.52.07s-.36-.02-.52-.07l-4.55 4.56c.05.16.07.33.07.51 0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2c.18 0 .35.02.51.07l4.56-4.55C8.02 9.36 8 9.18 8 9c0-1.1.9-2 2-2s2 .9 2 2c0 .18-.02.36-.07.52l2.55 2.55c.16-.05.34-.07.52-.07s.36.02.52.07l3.55-3.56C19.02 8.35 19 8.18 19 8c0-1.1.9-2 2-2s2 .9 2 2z'
    }));
  };

  var TimelineIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  TimelineIcon.displayName = 'TimelineIcon';
  TimelineIcon.defaultProps = {
    size: 24
  };
  exports.default = TimelineIcon;
});
unwrapExports(Timeline);
var Timer = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M15 1H9v2h6V1zm-4 13h2V8h-2v6zm8.03-6.61l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42C16.07 4.74 14.12 4 12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9 9-4.03 9-9c0-2.12-.74-4.07-1.97-5.61zM12 20c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z'
    }));
  };

  var TimerIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  TimerIcon.displayName = 'TimerIcon';
  TimerIcon.defaultProps = {
    size: 24
  };
  exports.default = TimerIcon;
});
unwrapExports(Timer);
var Timer10 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M0 7.72V9.4l3-1V18h2V6h-.25L0 7.72zm23.78 6.65c-.14-.28-.35-.53-.63-.74-.28-.21-.61-.39-1.01-.53s-.85-.27-1.35-.38c-.35-.07-.64-.15-.87-.23-.23-.08-.41-.16-.55-.25-.14-.09-.23-.19-.28-.3-.05-.11-.08-.24-.08-.39 0-.14.03-.28.09-.41.06-.13.15-.25.27-.34.12-.1.27-.18.45-.24s.4-.09.64-.09c.25 0 .47.04.66.11.19.07.35.17.48.29.13.12.22.26.29.42.06.16.1.32.1.49h1.95c0-.39-.08-.75-.24-1.09-.16-.34-.39-.63-.69-.88-.3-.25-.66-.44-1.09-.59C21.49 9.07 21 9 20.46 9c-.51 0-.98.07-1.39.21-.41.14-.77.33-1.06.57-.29.24-.51.52-.67.84-.16.32-.23.65-.23 1.01s.08.69.23.96c.15.28.36.52.64.73.27.21.6.38.98.53.38.14.81.26 1.27.36.39.08.71.17.95.26s.43.19.57.29c.13.1.22.22.27.34.05.12.07.25.07.39 0 .32-.13.57-.4.77-.27.2-.66.29-1.17.29-.22 0-.43-.02-.64-.08-.21-.05-.4-.13-.56-.24-.17-.11-.3-.26-.41-.44-.11-.18-.17-.41-.18-.67h-1.89c0 .36.08.71.24 1.05.16.34.39.65.7.93.31.27.69.49 1.15.66.46.17.98.25 1.58.25.53 0 1.01-.06 1.44-.19.43-.13.8-.31 1.11-.54.31-.23.54-.51.71-.83.17-.32.25-.67.25-1.06-.02-.4-.09-.74-.24-1.02zm-9.96-7.32c-.34-.4-.75-.7-1.23-.88-.47-.18-1.01-.27-1.59-.27-.58 0-1.11.09-1.59.27-.48.18-.89.47-1.23.88-.34.41-.6.93-.79 1.59-.18.65-.28 1.45-.28 2.39v1.92c0 .94.09 1.74.28 2.39.19.66.45 1.19.8 1.6.34.41.75.71 1.23.89.48.18 1.01.28 1.59.28.59 0 1.12-.09 1.59-.28.48-.18.88-.48 1.22-.89.34-.41.6-.94.78-1.6.18-.65.28-1.45.28-2.39v-1.92c0-.94-.09-1.74-.28-2.39-.18-.66-.44-1.19-.78-1.59zm-.92 6.17c0 .6-.04 1.11-.12 1.53-.08.42-.2.76-.36 1.02-.16.26-.36.45-.59.57-.23.12-.51.18-.82.18-.3 0-.58-.06-.82-.18s-.44-.31-.6-.57c-.16-.26-.29-.6-.38-1.02-.09-.42-.13-.93-.13-1.53v-2.5c0-.6.04-1.11.13-1.52.09-.41.21-.74.38-1 .16-.25.36-.43.6-.55.24-.11.51-.17.81-.17.31 0 .58.06.81.17.24.11.44.29.6.55.16.25.29.58.37.99.08.41.13.92.13 1.52v2.51z'
    }));
  };

  var Timer10Icon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  Timer10Icon.displayName = 'Timer10Icon';
  Timer10Icon.defaultProps = {
    size: 24
  };
  exports.default = Timer10Icon;
});
unwrapExports(Timer10);
var Timer3 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M11.61 12.97c-.16-.24-.36-.46-.62-.65-.25-.19-.56-.35-.93-.48.3-.14.57-.3.8-.5.23-.2.42-.41.57-.64.15-.23.27-.46.34-.71.08-.24.11-.49.11-.73 0-.55-.09-1.04-.28-1.46-.18-.42-.44-.77-.78-1.06-.33-.28-.73-.5-1.2-.64-.45-.13-.97-.2-1.53-.2-.55 0-1.06.08-1.52.24-.47.17-.87.4-1.2.69-.33.29-.6.63-.78 1.03-.2.39-.29.83-.29 1.29h1.98c0-.26.05-.49.14-.69.09-.2.22-.38.38-.52.17-.14.36-.25.58-.33.22-.08.46-.12.73-.12.61 0 1.06.16 1.36.47.3.31.44.75.44 1.32 0 .27-.04.52-.12.74-.08.22-.21.41-.38.57-.17.16-.38.28-.63.37-.25.09-.55.13-.89.13H6.72v1.57H7.9c.34 0 .64.04.91.11.27.08.5.19.69.35.19.16.34.36.44.61.1.24.16.54.16.87 0 .62-.18 1.09-.53 1.42-.35.33-.84.49-1.45.49-.29 0-.56-.04-.8-.13-.24-.08-.44-.2-.61-.36-.17-.16-.3-.34-.39-.56-.09-.22-.14-.46-.14-.72H4.19c0 .55.11 1.03.32 1.45.21.42.5.77.86 1.05s.77.49 1.24.63.96.21 1.48.21c.57 0 1.09-.08 1.58-.23.49-.15.91-.38 1.26-.68.36-.3.64-.66.84-1.1.2-.43.3-.93.3-1.48 0-.29-.04-.58-.11-.86-.08-.25-.19-.51-.35-.76zm9.26 1.4c-.14-.28-.35-.53-.63-.74-.28-.21-.61-.39-1.01-.53s-.85-.27-1.35-.38c-.35-.07-.64-.15-.87-.23-.23-.08-.41-.16-.55-.25-.14-.09-.23-.19-.28-.3-.05-.11-.08-.24-.08-.39s.03-.28.09-.41c.06-.13.15-.25.27-.34.12-.1.27-.18.45-.24s.4-.09.64-.09c.25 0 .47.04.66.11.19.07.35.17.48.29.13.12.22.26.29.42.06.16.1.32.1.49h1.95c0-.39-.08-.75-.24-1.09-.16-.34-.39-.63-.69-.88-.3-.25-.66-.44-1.09-.59-.43-.15-.92-.22-1.46-.22-.51 0-.98.07-1.39.21-.41.14-.77.33-1.06.57-.29.24-.51.52-.67.84-.16.32-.23.65-.23 1.01s.08.68.23.96c.15.28.37.52.64.73.27.21.6.38.98.53.38.14.81.26 1.27.36.39.08.71.17.95.26s.43.19.57.29c.13.1.22.22.27.34.05.12.07.25.07.39 0 .32-.13.57-.4.77-.27.2-.66.29-1.17.29-.22 0-.43-.02-.64-.08-.21-.05-.4-.13-.56-.24-.17-.11-.3-.26-.41-.44-.11-.18-.17-.41-.18-.67h-1.89c0 .36.08.71.24 1.05.16.34.39.65.7.93.31.27.69.49 1.15.66.46.17.98.25 1.58.25.53 0 1.01-.06 1.44-.19.43-.13.8-.31 1.11-.54.31-.23.54-.51.71-.83.17-.32.25-.67.25-1.06-.02-.4-.09-.74-.24-1.02z'
    }));
  };

  var Timer3Icon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  Timer3Icon.displayName = 'Timer3Icon';
  Timer3Icon.defaultProps = {
    size: 24
  };
  exports.default = Timer3Icon;
});
unwrapExports(Timer3);
var TimerOff = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19.04 4.55l-1.42 1.42C16.07 4.74 14.12 4 12 4c-1.83 0-3.53.55-4.95 1.48l1.46 1.46C9.53 6.35 10.73 6 12 6c3.87 0 7 3.13 7 7 0 1.27-.35 2.47-.94 3.49l1.45 1.45C20.45 16.53 21 14.83 21 13c0-2.12-.74-4.07-1.97-5.61l1.42-1.42-1.41-1.42zM15 1H9v2h6V1zm-4 8.44l2 2V8h-2v1.44zM3.02 4L1.75 5.27 4.5 8.03C3.55 9.45 3 11.16 3 13c0 4.97 4.02 9 9 9 1.84 0 3.55-.55 4.98-1.5l2.5 2.5 1.27-1.27-7.71-7.71L3.02 4zM12 20c-3.87 0-7-3.13-7-7 0-1.28.35-2.48.95-3.52l9.56 9.56c-1.03.61-2.23.96-3.51.96z'
    }));
  };

  var TimerOffIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  TimerOffIcon.displayName = 'TimerOffIcon';
  TimerOffIcon.defaultProps = {
    size: 24
  };
  exports.default = TimerOffIcon;
});
unwrapExports(TimerOff);
var Title = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M5 4v3h5.5v12h3V7H19V4z'
    }));
  };

  var TitleIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  TitleIcon.displayName = 'TitleIcon';
  TitleIcon.defaultProps = {
    size: 24
  };
  exports.default = TitleIcon;
});
unwrapExports(Title);
var Toc = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M3 9h14V7H3v2zm0 4h14v-2H3v2zm0 4h14v-2H3v2zm16 0h2v-2h-2v2zm0-10v2h2V7h-2zm0 6h2v-2h-2v2z'
    }));
  };

  var TocIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  TocIcon.displayName = 'TocIcon';
  TocIcon.defaultProps = {
    size: 24
  };
  exports.default = TocIcon;
});
unwrapExports(Toc);
var Today = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z'
    }));
  };

  var TodayIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  TodayIcon.displayName = 'TodayIcon';
  TodayIcon.defaultProps = {
    size: 24
  };
  exports.default = TodayIcon;
});
unwrapExports(Today);
var Toll = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M15 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zM3 12c0-2.61 1.67-4.83 4-5.65V4.26C3.55 5.15 1 8.27 1 12s2.55 6.85 6 7.74v-2.09c-2.33-.82-4-3.04-4-5.65z'
    }));
  };

  var TollIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  TollIcon.displayName = 'TollIcon';
  TollIcon.defaultProps = {
    size: 24
  };
  exports.default = TollIcon;
});
unwrapExports(Toll);
var Tonality = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.94-.49-7-3.85-7-7.93s3.05-7.44 7-7.93v15.86zm2-15.86c1.03.13 2 .45 2.87.93H13v-.93zM13 7h5.24c.25.31.48.65.68 1H13V7zm0 3h6.74c.08.33.15.66.19 1H13v-1zm0 9.93V19h2.87c-.87.48-1.84.8-2.87.93zM18.24 17H13v-1h5.92c-.2.35-.43.69-.68 1zm1.5-3H13v-1h6.93c-.04.34-.11.67-.19 1z'
    }));
  };

  var TonalityIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  TonalityIcon.displayName = 'TonalityIcon';
  TonalityIcon.defaultProps = {
    size: 24
  };
  exports.default = TonalityIcon;
});
unwrapExports(Tonality);
var TouchApp = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M9 11.24V7.5C9 6.12 10.12 5 11.5 5S14 6.12 14 7.5v3.74c1.21-.81 2-2.18 2-3.74C16 5.01 13.99 3 11.5 3S7 5.01 7 7.5c0 1.56.79 2.93 2 3.74zm9.84 4.63l-4.54-2.26c-.17-.07-.35-.11-.54-.11H13v-6c0-.83-.67-1.5-1.5-1.5S10 6.67 10 7.5v10.74l-3.43-.72c-.08-.01-.15-.03-.24-.03-.31 0-.59.13-.79.33l-.79.8 4.94 4.94c.27.27.65.44 1.06.44h6.79c.75 0 1.33-.55 1.44-1.28l.75-5.27c.01-.07.02-.14.02-.2 0-.62-.38-1.16-.91-1.38z'
    }));
  };

  var TouchAppIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  TouchAppIcon.displayName = 'TouchAppIcon';
  TouchAppIcon.defaultProps = {
    size: 24
  };
  exports.default = TouchAppIcon;
});
unwrapExports(TouchApp);
var Toys = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 12c0-3 2.5-5.5 5.5-5.5S23 9 23 12H12zm0 0c0 3-2.5 5.5-5.5 5.5S1 15 1 12h11zm0 0c-3 0-5.5-2.5-5.5-5.5S9 1 12 1v11zm0 0c3 0 5.5 2.5 5.5 5.5S15 23 12 23V12z'
    }));
  };

  var ToysIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ToysIcon.displayName = 'ToysIcon';
  ToysIcon.defaultProps = {
    size: 24
  };
  exports.default = ToysIcon;
});
unwrapExports(Toys);
var TrackChanges = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19.07 4.93l-1.41 1.41C19.1 7.79 20 9.79 20 12c0 4.42-3.58 8-8 8s-8-3.58-8-8c0-4.08 3.05-7.44 7-7.93v2.02C8.16 6.57 6 9.03 6 12c0 3.31 2.69 6 6 6s6-2.69 6-6c0-1.66-.67-3.16-1.76-4.24l-1.41 1.41C15.55 9.9 16 10.9 16 12c0 2.21-1.79 4-4 4s-4-1.79-4-4c0-1.86 1.28-3.41 3-3.86v2.14c-.6.35-1 .98-1 1.72 0 1.1.9 2 2 2s2-.9 2-2c0-.74-.4-1.38-1-1.72V2h-1C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10c0-2.76-1.12-5.26-2.93-7.07z'
    }));
  };

  var TrackChangesIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  TrackChangesIcon.displayName = 'TrackChangesIcon';
  TrackChangesIcon.defaultProps = {
    size: 24
  };
  exports.default = TrackChangesIcon;
});
unwrapExports(TrackChanges);
var Traffic = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 10h-3V8.86c1.72-.45 3-2 3-3.86h-3V4c0-.55-.45-1-1-1H8c-.55 0-1 .45-1 1v1H4c0 1.86 1.28 3.41 3 3.86V10H4c0 1.86 1.28 3.41 3 3.86V15H4c0 1.86 1.28 3.41 3 3.86V20c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-1.14c1.72-.45 3-2 3-3.86h-3v-1.14c1.72-.45 3-2 3-3.86zm-8 9c-1.11 0-2-.9-2-2s.89-2 2-2c1.1 0 2 .9 2 2s-.89 2-2 2zm0-5c-1.11 0-2-.9-2-2s.89-2 2-2c1.1 0 2 .9 2 2s-.89 2-2 2zm0-5c-1.11 0-2-.9-2-2 0-1.11.89-2 2-2 1.1 0 2 .89 2 2 0 1.1-.89 2-2 2z'
    }));
  };

  var TrafficIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  TrafficIcon.displayName = 'TrafficIcon';
  TrafficIcon.defaultProps = {
    size: 24
  };
  exports.default = TrafficIcon;
});
unwrapExports(Traffic);
var Train = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 2c-4 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h2.23l2-2H14l2 2h2v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm3.5-7H6V6h5v4zm2 0V6h5v4h-5zm3.5 7c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z'
    }));
  };

  var TrainIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  TrainIcon.displayName = 'TrainIcon';
  TrainIcon.defaultProps = {
    size: 24
  };
  exports.default = TrainIcon;
});
unwrapExports(Train);
var Tram = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 16.94V8.5c0-2.79-2.61-3.4-6.01-3.49l.76-1.51H17V2H7v1.5h4.75l-.76 1.52C7.86 5.11 5 5.73 5 8.5v8.44c0 1.45 1.19 2.66 2.59 2.97L6 21.5v.5h2.23l2-2H14l2 2h2v-.5L16.5 20h-.08c1.69 0 2.58-1.37 2.58-3.06zm-7 1.56c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5-4.5H7V9h10v5z'
    }));
  };

  var TramIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  TramIcon.displayName = 'TramIcon';
  TramIcon.defaultProps = {
    size: 24
  };
  exports.default = TramIcon;
});
unwrapExports(Tram);
var TransferWithinAStation = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M16.49 15.5v-1.75L14 16.25l2.49 2.5V17H22v-1.5z M19.51 19.75H14v1.5h5.51V23L22 20.5 19.51 18z M9.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5.75 8.9L3 23h2.1l1.75-8L9 17v6h2v-7.55L8.95 13.4l.6-3C10.85 12 12.8 13 15 13v-2c-1.85 0-3.45-1-4.35-2.45l-.95-1.6C9.35 6.35 8.7 6 8 6c-.25 0-.5.05-.75.15L2 8.3V13h2V9.65l1.75-.75'
    }));
  };

  var TransferWithinAStationIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  TransferWithinAStationIcon.displayName = 'TransferWithinAStationIcon';
  TransferWithinAStationIcon.defaultProps = {
    size: 24
  };
  exports.default = TransferWithinAStationIcon;
});
unwrapExports(TransferWithinAStation);
var Transform = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M22 18v-2H8V4h2L7 1 4 4h2v2H2v2h4v8c0 1.1.9 2 2 2h8v2h-2l3 3 3-3h-2v-2h4zM10 8h6v6h2V8c0-1.1-.9-2-2-2h-6v2z'
    }));
  };

  var TransformIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  TransformIcon.displayName = 'TransformIcon';
  TransformIcon.defaultProps = {
    size: 24
  };
  exports.default = TransformIcon;
});
unwrapExports(Transform);
var Translate = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12.87 15.07l-2.54-2.51.03-.03c1.74-1.94 2.98-4.17 3.71-6.53H17V4h-7V2H8v2H1v1.99h11.17C11.5 7.92 10.44 9.75 9 11.35 8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5 3.11 3.11.76-2.04zM18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12zm-2.62 7l1.62-4.33L19.12 17h-3.24z'
    }));
  };

  var TranslateIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  TranslateIcon.displayName = 'TranslateIcon';
  TranslateIcon.defaultProps = {
    size: 24
  };
  exports.default = TranslateIcon;
});
unwrapExports(Translate);
var TrendingDown = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M16 18l2.29-2.29-4.88-4.88-4 4L2 7.41 3.41 6l6 6 4-4 6.3 6.29L22 12v6z'
    }));
  };

  var TrendingDownIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  TrendingDownIcon.displayName = 'TrendingDownIcon';
  TrendingDownIcon.defaultProps = {
    size: 24
  };
  exports.default = TrendingDownIcon;
});
unwrapExports(TrendingDown);
var TrendingFlat = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M22 12l-4-4v3H3v2h15v3z'
    }));
  };

  var TrendingFlatIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  TrendingFlatIcon.displayName = 'TrendingFlatIcon';
  TrendingFlatIcon.defaultProps = {
    size: 24
  };
  exports.default = TrendingFlatIcon;
});
unwrapExports(TrendingFlat);
var TrendingUp = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z'
    }));
  };

  var TrendingUpIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  TrendingUpIcon.displayName = 'TrendingUpIcon';
  TrendingUpIcon.defaultProps = {
    size: 24
  };
  exports.default = TrendingUpIcon;
});
unwrapExports(TrendingUp);
var Tune = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V9H7zm14 4v-2H11v2h10zm-6-4h2V7h4V5h-4V3h-2v6z'
    }));
  };

  var TuneIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  TuneIcon.displayName = 'TuneIcon';
  TuneIcon.defaultProps = {
    size: 24
  };
  exports.default = TuneIcon;
});
unwrapExports(Tune);
var TurnedIn = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2z'
    }));
  };

  var TurnedInIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  TurnedInIcon.displayName = 'TurnedInIcon';
  TurnedInIcon.defaultProps = {
    size: 24
  };
  exports.default = TurnedInIcon;
});
unwrapExports(TurnedIn);
var TurnedInNot = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2zm0 15l-5-2.18L7 18V5h10v13z'
    }));
  };

  var TurnedInNotIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  TurnedInNotIcon.displayName = 'TurnedInNotIcon';
  TurnedInNotIcon.defaultProps = {
    size: 24
  };
  exports.default = TurnedInNotIcon;
});
unwrapExports(TurnedInNot);
var Tv = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.1-.9-2-2-2zm0 14H3V5h18v12z'
    }));
  };

  var TvIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  TvIcon.displayName = 'TvIcon';
  TvIcon.defaultProps = {
    size: 24
  };
  exports.default = TvIcon;
});
unwrapExports(Tv);
var Unarchive = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20.55 5.22l-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.15.55L3.46 5.22C3.17 5.57 3 6.01 3 6.5V19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.49-.17-.93-.45-1.28zM12 9.5l5.5 5.5H14v2h-4v-2H6.5L12 9.5zM5.12 5l.82-1h12l.93 1H5.12z'
    }));
  };

  var UnarchiveIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  UnarchiveIcon.displayName = 'UnarchiveIcon';
  UnarchiveIcon.defaultProps = {
    size: 24
  };
  exports.default = UnarchiveIcon;
});
unwrapExports(Unarchive);
var Undo = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z'
    }));
  };

  var UndoIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  UndoIcon.displayName = 'UndoIcon';
  UndoIcon.defaultProps = {
    size: 24
  };
  exports.default = UndoIcon;
});
unwrapExports(Undo);
var UnfoldLess = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M7.41 18.59L8.83 20 12 16.83 15.17 20l1.41-1.41L12 14l-4.59 4.59zm9.18-13.18L15.17 4 12 7.17 8.83 4 7.41 5.41 12 10l4.59-4.59z'
    }));
  };

  var UnfoldLessIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  UnfoldLessIcon.displayName = 'UnfoldLessIcon';
  UnfoldLessIcon.defaultProps = {
    size: 24
  };
  exports.default = UnfoldLessIcon;
});
unwrapExports(UnfoldLess);
var UnfoldMore = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 5.83L15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9 12 5.83zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15 12 18.17z'
    }));
  };

  var UnfoldMoreIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  UnfoldMoreIcon.displayName = 'UnfoldMoreIcon';
  UnfoldMoreIcon.defaultProps = {
    size: 24
  };
  exports.default = UnfoldMoreIcon;
});
unwrapExports(UnfoldMore);
var Update = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21 10.12h-6.78l2.74-2.82c-2.73-2.7-7.15-2.8-9.88-.1-2.73 2.71-2.73 7.08 0 9.79 2.73 2.71 7.15 2.71 9.88 0C18.32 15.65 19 14.08 19 12.1h2c0 1.98-.88 4.55-2.64 6.29-3.51 3.48-9.21 3.48-12.72 0-3.5-3.47-3.53-9.11-.02-12.58 3.51-3.47 9.14-3.47 12.65 0L21 3v7.12zM12.5 8v4.25l3.5 2.08-.72 1.21L11 13V8h1.5z'
    }));
  };

  var UpdateIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  UpdateIcon.displayName = 'UpdateIcon';
  UpdateIcon.defaultProps = {
    size: 24
  };
  exports.default = UpdateIcon;
});
unwrapExports(Update);
var Usb = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M15 7v4h1v2h-3V5h2l-3-4-3 4h2v8H8v-2.07c.7-.37 1.2-1.08 1.2-1.93 0-1.21-.99-2.2-2.2-2.2-1.21 0-2.2.99-2.2 2.2 0 .85.5 1.56 1.2 1.93V13c0 1.11.89 2 2 2h3v3.05c-.71.37-1.2 1.1-1.2 1.95 0 1.22.99 2.2 2.2 2.2 1.21 0 2.2-.98 2.2-2.2 0-.85-.49-1.58-1.2-1.95V15h3c1.11 0 2-.89 2-2v-2h1V7h-4z'
    }));
  };

  var UsbIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  UsbIcon.displayName = 'UsbIcon';
  UsbIcon.defaultProps = {
    size: 24
  };
  exports.default = UsbIcon;
});
unwrapExports(Usb);
var VerifiedUser = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z'
    }));
  };

  var VerifiedUserIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  VerifiedUserIcon.displayName = 'VerifiedUserIcon';
  VerifiedUserIcon.defaultProps = {
    size: 24
  };
  exports.default = VerifiedUserIcon;
});
unwrapExports(VerifiedUser);
var VerticalAlignBottom = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M16 13h-3V3h-2v10H8l4 4 4-4zM4 19v2h16v-2H4z'
    }));
  };

  var VerticalAlignBottomIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  VerticalAlignBottomIcon.displayName = 'VerticalAlignBottomIcon';
  VerticalAlignBottomIcon.defaultProps = {
    size: 24
  };
  exports.default = VerticalAlignBottomIcon;
});
unwrapExports(VerticalAlignBottom);
var VerticalAlignCenter = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M8 19h3v4h2v-4h3l-4-4-4 4zm8-14h-3V1h-2v4H8l4 4 4-4zM4 11v2h16v-2H4z'
    }));
  };

  var VerticalAlignCenterIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  VerticalAlignCenterIcon.displayName = 'VerticalAlignCenterIcon';
  VerticalAlignCenterIcon.defaultProps = {
    size: 24
  };
  exports.default = VerticalAlignCenterIcon;
});
unwrapExports(VerticalAlignCenter);
var VerticalAlignTop = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M8 11h3v10h2V11h3l-4-4-4 4zM4 3v2h16V3H4z'
    }));
  };

  var VerticalAlignTopIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  VerticalAlignTopIcon.displayName = 'VerticalAlignTopIcon';
  VerticalAlignTopIcon.defaultProps = {
    size: 24
  };
  exports.default = VerticalAlignTopIcon;
});
unwrapExports(VerticalAlignTop);
var Vibration = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M0 15h2V9H0v6zm3 2h2V7H3v10zm19-8v6h2V9h-2zm-3 8h2V7h-2v10zM16.5 3h-9C6.67 3 6 3.67 6 4.5v15c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-15c0-.83-.67-1.5-1.5-1.5zM16 19H8V5h8v14z'
    }));
  };

  var VibrationIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  VibrationIcon.displayName = 'VibrationIcon';
  VibrationIcon.defaultProps = {
    size: 24
  };
  exports.default = VibrationIcon;
});
unwrapExports(Vibration);
var VideoCall = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4zM14 13h-3v3H9v-3H6v-2h3V8h2v3h3v2z'
    }));
  };

  var VideoCallIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  VideoCallIcon.displayName = 'VideoCallIcon';
  VideoCallIcon.defaultProps = {
    size: 24
  };
  exports.default = VideoCallIcon;
});
unwrapExports(VideoCall);
var VideoLabel = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 13H3V5h18v11z'
    }));
  };

  var VideoLabelIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  VideoLabelIcon.displayName = 'VideoLabelIcon';
  VideoLabelIcon.defaultProps = {
    size: 24
  };
  exports.default = VideoLabelIcon;
});
unwrapExports(VideoLabel);
var VideoLibrary = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8 12.5v-9l6 4.5-6 4.5z'
    }));
  };

  var VideoLibraryIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  VideoLibraryIcon.displayName = 'VideoLibraryIcon';
  VideoLibraryIcon.defaultProps = {
    size: 24
  };
  exports.default = VideoLibraryIcon;
});
unwrapExports(VideoLibrary);
var Videocam = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z'
    }));
  };

  var VideocamIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  VideocamIcon.displayName = 'VideocamIcon';
  VideocamIcon.defaultProps = {
    size: 24
  };
  exports.default = VideocamIcon;
});
unwrapExports(Videocam);
var VideocamOff = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21 6.5l-4 4V7c0-.55-.45-1-1-1H9.82L21 17.18V6.5zM3.27 2L2 3.27 4.73 6H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.21 0 .39-.08.54-.18L19.73 21 21 19.73 3.27 2z'
    }));
  };

  var VideocamOffIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  VideocamOffIcon.displayName = 'VideocamOffIcon';
  VideocamOffIcon.defaultProps = {
    size: 24
  };
  exports.default = VideocamOffIcon;
});
unwrapExports(VideocamOff);
var VideogameAsset = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-10 7H8v3H6v-3H3v-2h3V8h2v3h3v2zm4.5 2c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4-3c-.83 0-1.5-.67-1.5-1.5S18.67 9 19.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z'
    }));
  };

  var VideogameAssetIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  VideogameAssetIcon.displayName = 'VideogameAssetIcon';
  VideogameAssetIcon.defaultProps = {
    size: 24
  };
  exports.default = VideogameAssetIcon;
});
unwrapExports(VideogameAsset);
var ViewAgenda = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 13H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1zm0-10H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1z'
    }));
  };

  var ViewAgendaIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ViewAgendaIcon.displayName = 'ViewAgendaIcon';
  ViewAgendaIcon.defaultProps = {
    size: 24
  };
  exports.default = ViewAgendaIcon;
});
unwrapExports(ViewAgenda);
var ViewArray = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M4 18h3V5H4v13zM18 5v13h3V5h-3zM8 18h9V5H8v13z'
    }));
  };

  var ViewArrayIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ViewArrayIcon.displayName = 'ViewArrayIcon';
  ViewArrayIcon.defaultProps = {
    size: 24
  };
  exports.default = ViewArrayIcon;
});
unwrapExports(ViewArray);
var ViewCarousel = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M7 19h10V4H7v15zm-5-2h4V6H2v11zM18 6v11h4V6h-4z'
    }));
  };

  var ViewCarouselIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ViewCarouselIcon.displayName = 'ViewCarouselIcon';
  ViewCarouselIcon.defaultProps = {
    size: 24
  };
  exports.default = ViewCarouselIcon;
});
unwrapExports(ViewCarousel);
var ViewColumn = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M10 18h5V5h-5v13zm-6 0h5V5H4v13zM16 5v13h5V5h-5z'
    }));
  };

  var ViewColumnIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ViewColumnIcon.displayName = 'ViewColumnIcon';
  ViewColumnIcon.defaultProps = {
    size: 24
  };
  exports.default = ViewColumnIcon;
});
unwrapExports(ViewColumn);
var ViewComfy = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M3 9h4V5H3v4zm0 5h4v-4H3v4zm5 0h4v-4H8v4zm5 0h4v-4h-4v4zM8 9h4V5H8v4zm5-4v4h4V5h-4zm5 9h4v-4h-4v4zM3 19h4v-4H3v4zm5 0h4v-4H8v4zm5 0h4v-4h-4v4zm5 0h4v-4h-4v4zm0-14v4h4V5h-4z'
    }));
  };

  var ViewComfyIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ViewComfyIcon.displayName = 'ViewComfyIcon';
  ViewComfyIcon.defaultProps = {
    size: 24
  };
  exports.default = ViewComfyIcon;
});
unwrapExports(ViewComfy);
var ViewCompact = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M3 19h6v-7H3v7zm7 0h12v-7H10v7zM3 5v6h19V5H3z'
    }));
  };

  var ViewCompactIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ViewCompactIcon.displayName = 'ViewCompactIcon';
  ViewCompactIcon.defaultProps = {
    size: 24
  };
  exports.default = ViewCompactIcon;
});
unwrapExports(ViewCompact);
var ViewDay = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M2 21h19v-3H2v3zM20 8H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zM2 3v3h19V3H2z'
    }));
  };

  var ViewDayIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ViewDayIcon.displayName = 'ViewDayIcon';
  ViewDayIcon.defaultProps = {
    size: 24
  };
  exports.default = ViewDayIcon;
});
unwrapExports(ViewDay);
var ViewHeadline = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M4 15h16v-2H4v2zm0 4h16v-2H4v2zm0-8h16V9H4v2zm0-6v2h16V5H4z'
    }));
  };

  var ViewHeadlineIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ViewHeadlineIcon.displayName = 'ViewHeadlineIcon';
  ViewHeadlineIcon.defaultProps = {
    size: 24
  };
  exports.default = ViewHeadlineIcon;
});
unwrapExports(ViewHeadline);
var ViewList = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M4 14h4v-4H4v4zm0 5h4v-4H4v4zM4 9h4V5H4v4zm5 5h12v-4H9v4zm0 5h12v-4H9v4zM9 5v4h12V5H9z'
    }));
  };

  var ViewListIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ViewListIcon.displayName = 'ViewListIcon';
  ViewListIcon.defaultProps = {
    size: 24
  };
  exports.default = ViewListIcon;
});
unwrapExports(ViewList);
var ViewModule = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M4 11h5V5H4v6zm0 7h5v-6H4v6zm6 0h5v-6h-5v6zm6 0h5v-6h-5v6zm-6-7h5V5h-5v6zm6-6v6h5V5h-5z'
    }));
  };

  var ViewModuleIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ViewModuleIcon.displayName = 'ViewModuleIcon';
  ViewModuleIcon.defaultProps = {
    size: 24
  };
  exports.default = ViewModuleIcon;
});
unwrapExports(ViewModule);
var ViewQuilt = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M10 18h5v-6h-5v6zm-6 0h5V5H4v13zm12 0h5v-6h-5v6zM10 5v6h11V5H10z'
    }));
  };

  var ViewQuiltIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ViewQuiltIcon.displayName = 'ViewQuiltIcon';
  ViewQuiltIcon.defaultProps = {
    size: 24
  };
  exports.default = ViewQuiltIcon;
});
unwrapExports(ViewQuilt);
var ViewStream = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M4 18h17v-6H4v6zM4 5v6h17V5H4z'
    }));
  };

  var ViewStreamIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ViewStreamIcon.displayName = 'ViewStreamIcon';
  ViewStreamIcon.defaultProps = {
    size: 24
  };
  exports.default = ViewStreamIcon;
});
unwrapExports(ViewStream);
var ViewWeek = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M6 5H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm14 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-7 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1z'
    }));
  };

  var ViewWeekIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ViewWeekIcon.displayName = 'ViewWeekIcon';
  ViewWeekIcon.defaultProps = {
    size: 24
  };
  exports.default = ViewWeekIcon;
});
unwrapExports(ViewWeek);
var Vignette = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 15c-4.42 0-8-2.69-8-6s3.58-6 8-6 8 2.69 8 6-3.58 6-8 6z'
    }));
  };

  var VignetteIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  VignetteIcon.displayName = 'VignetteIcon';
  VignetteIcon.defaultProps = {
    size: 24
  };
  exports.default = VignetteIcon;
});
unwrapExports(Vignette);
var Visibility = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z'
    }));
  };

  var VisibilityIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  VisibilityIcon.displayName = 'VisibilityIcon';
  VisibilityIcon.defaultProps = {
    size: 24
  };
  exports.default = VisibilityIcon;
});
unwrapExports(Visibility);
var VisibilityOff = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z'
    }));
  };

  var VisibilityOffIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  VisibilityOffIcon.displayName = 'VisibilityOffIcon';
  VisibilityOffIcon.defaultProps = {
    size: 24
  };
  exports.default = VisibilityOffIcon;
});
unwrapExports(VisibilityOff);
var VoiceChat = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12l-4-3.2V14H6V6h8v3.2L18 6v8z'
    }));
  };

  var VoiceChatIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  VoiceChatIcon.displayName = 'VoiceChatIcon';
  VoiceChatIcon.defaultProps = {
    size: 24
  };
  exports.default = VoiceChatIcon;
});
unwrapExports(VoiceChat);
var Voicemail = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M18.5 6C15.46 6 13 8.46 13 11.5c0 1.33.47 2.55 1.26 3.5H9.74c.79-.95 1.26-2.17 1.26-3.5C11 8.46 8.54 6 5.5 6S0 8.46 0 11.5 2.46 17 5.5 17h13c3.04 0 5.5-2.46 5.5-5.5S21.54 6 18.5 6zm-13 9C3.57 15 2 13.43 2 11.5S3.57 8 5.5 8 9 9.57 9 11.5 7.43 15 5.5 15zm13 0c-1.93 0-3.5-1.57-3.5-3.5S16.57 8 18.5 8 22 9.57 22 11.5 20.43 15 18.5 15z'
    }));
  };

  var VoicemailIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  VoicemailIcon.displayName = 'VoicemailIcon';
  VoicemailIcon.defaultProps = {
    size: 24
  };
  exports.default = VoicemailIcon;
});
unwrapExports(Voicemail);
var VolumeDown = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M18.5 12c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM5 9v6h4l5 5V4L9 9H5z'
    }));
  };

  var VolumeDownIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  VolumeDownIcon.displayName = 'VolumeDownIcon';
  VolumeDownIcon.defaultProps = {
    size: 24
  };
  exports.default = VolumeDownIcon;
});
unwrapExports(VolumeDown);
var VolumeMute = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M7 9v6h4l5 5V4l-5 5H7z'
    }));
  };

  var VolumeMuteIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  VolumeMuteIcon.displayName = 'VolumeMuteIcon';
  VolumeMuteIcon.defaultProps = {
    size: 24
  };
  exports.default = VolumeMuteIcon;
});
unwrapExports(VolumeMute);
var VolumeOff = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z'
    }));
  };

  var VolumeOffIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  VolumeOffIcon.displayName = 'VolumeOffIcon';
  VolumeOffIcon.defaultProps = {
    size: 24
  };
  exports.default = VolumeOffIcon;
});
unwrapExports(VolumeOff);
var VolumeUp = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z'
    }));
  };

  var VolumeUpIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  VolumeUpIcon.displayName = 'VolumeUpIcon';
  VolumeUpIcon.defaultProps = {
    size: 24
  };
  exports.default = VolumeUpIcon;
});
unwrapExports(VolumeUp);
var VpnKey = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12.65 10C11.83 7.67 9.61 6 7 6c-3.31 0-6 2.69-6 6s2.69 6 6 6c2.61 0 4.83-1.67 5.65-4H17v4h4v-4h2v-4H12.65zM7 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z'
    }));
  };

  var VpnKeyIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  VpnKeyIcon.displayName = 'VpnKeyIcon';
  VpnKeyIcon.defaultProps = {
    size: 24
  };
  exports.default = VpnKeyIcon;
});
unwrapExports(VpnKey);
var VpnLock = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M22 4v-.5C22 2.12 20.88 1 19.5 1S17 2.12 17 3.5V4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm-.8 0h-3.4v-.5c0-.94.76-1.7 1.7-1.7s1.7.76 1.7 1.7V4zm-2.28 8c.04.33.08.66.08 1 0 2.08-.8 3.97-2.1 5.39-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H7v-2h2c.55 0 1-.45 1-1V8h2c1.1 0 2-.9 2-2V3.46c-.95-.3-1.95-.46-3-.46C5.48 3 1 7.48 1 13s4.48 10 10 10 10-4.48 10-10c0-.34-.02-.67-.05-1h-2.03zM10 20.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L8 16v1c0 1.1.9 2 2 2v1.93z'
    }));
  };

  var VpnLockIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  VpnLockIcon.displayName = 'VpnLockIcon';
  VpnLockIcon.defaultProps = {
    size: 24
  };
  exports.default = VpnLockIcon;
});
unwrapExports(VpnLock);
var Wallpaper = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M4 4h7V2H4c-1.1 0-2 .9-2 2v7h2V4zm6 9l-4 5h12l-3-4-2.03 2.71L10 13zm7-4.5c0-.83-.67-1.5-1.5-1.5S14 7.67 14 8.5s.67 1.5 1.5 1.5S17 9.33 17 8.5zM20 2h-7v2h7v7h2V4c0-1.1-.9-2-2-2zm0 18h-7v2h7c1.1 0 2-.9 2-2v-7h-2v7zM4 13H2v7c0 1.1.9 2 2 2h7v-2H4v-7z'
    }));
  };

  var WallpaperIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  WallpaperIcon.displayName = 'WallpaperIcon';
  WallpaperIcon.defaultProps = {
    size: 24
  };
  exports.default = WallpaperIcon;
});
unwrapExports(Wallpaper);
var Warning = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z'
    }));
  };

  var WarningIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  WarningIcon.displayName = 'WarningIcon';
  WarningIcon.defaultProps = {
    size: 24
  };
  exports.default = WarningIcon;
});
var IconWarning = unwrapExports(Warning);
var Watch = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 12c0-2.54-1.19-4.81-3.04-6.27L16 0H8l-.95 5.73C5.19 7.19 4 9.45 4 12s1.19 4.81 3.05 6.27L8 24h8l.96-5.73C18.81 16.81 20 14.54 20 12zM6 12c0-3.31 2.69-6 6-6s6 2.69 6 6-2.69 6-6 6-6-2.69-6-6z'
    }));
  };

  var WatchIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  WatchIcon.displayName = 'WatchIcon';
  WatchIcon.defaultProps = {
    size: 24
  };
  exports.default = WatchIcon;
});
unwrapExports(Watch);
var WatchLater = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm4.2 14.2L11 13V7h1.5v5.2l4.5 2.7-.8 1.3z'
    }));
  };

  var WatchLaterIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  WatchLaterIcon.displayName = 'WatchLaterIcon';
  WatchLaterIcon.defaultProps = {
    size: 24
  };
  exports.default = WatchLaterIcon;
});
unwrapExports(WatchLater);
var WbAuto = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M6.85 12.65h2.3L8 9l-1.15 3.65zM22 7l-1.2 6.29L19.3 7h-1.6l-1.49 6.29L15 7h-.76C12.77 5.17 10.53 4 8 4c-4.42 0-8 3.58-8 8s3.58 8 8 8c3.13 0 5.84-1.81 7.15-4.43l.1.43H17l1.5-6.1L20 16h1.75l2.05-9H22zm-11.7 9l-.7-2H6.4l-.7 2H3.8L7 7h2l3.2 9h-1.9z'
    }));
  };

  var WbAutoIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  WbAutoIcon.displayName = 'WbAutoIcon';
  WbAutoIcon.defaultProps = {
    size: 24
  };
  exports.default = WbAutoIcon;
});
unwrapExports(WbAuto);
var WbCloudy = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19.36 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.64-4.96z'
    }));
  };

  var WbCloudyIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  WbCloudyIcon.displayName = 'WbCloudyIcon';
  WbCloudyIcon.defaultProps = {
    size: 24
  };
  exports.default = WbCloudyIcon;
});
unwrapExports(WbCloudy);
var WbIncandescent = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M3.55 18.54l1.41 1.41 1.79-1.8-1.41-1.41-1.79 1.8zM11 22.45h2V19.5h-2v2.95zM4 10.5H1v2h3v-2zm11-4.19V1.5H9v4.81C7.21 7.35 6 9.28 6 11.5c0 3.31 2.69 6 6 6s6-2.69 6-6c0-2.22-1.21-4.15-3-5.19zm5 4.19v2h3v-2h-3zm-2.76 7.66l1.79 1.8 1.41-1.41-1.8-1.79-1.4 1.4z'
    }));
  };

  var WbIncandescentIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  WbIncandescentIcon.displayName = 'WbIncandescentIcon';
  WbIncandescentIcon.defaultProps = {
    size: 24
  };
  exports.default = WbIncandescentIcon;
});
unwrapExports(WbIncandescent);
var WbIridescent = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M5 14.5h14v-6H5v6zM11 .55V3.5h2V.55h-2zm8.04 2.5l-1.79 1.79 1.41 1.41 1.8-1.79-1.42-1.41zM13 22.45V19.5h-2v2.95h2zm7.45-3.91l-1.8-1.79-1.41 1.41 1.79 1.8 1.42-1.42zM3.55 4.46l1.79 1.79 1.41-1.41-1.79-1.79-1.41 1.41zm1.41 15.49l1.79-1.8-1.41-1.41-1.79 1.79 1.41 1.42z'
    }));
  };

  var WbIridescentIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  WbIridescentIcon.displayName = 'WbIridescentIcon';
  WbIridescentIcon.defaultProps = {
    size: 24
  };
  exports.default = WbIridescentIcon;
});
unwrapExports(WbIridescent);
var WbSunny = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M6.76 4.84l-1.8-1.79-1.41 1.41 1.79 1.79 1.42-1.41zM4 10.5H1v2h3v-2zm9-9.95h-2V3.5h2V.55zm7.45 3.91l-1.41-1.41-1.79 1.79 1.41 1.41 1.79-1.79zm-3.21 13.7l1.79 1.8 1.41-1.41-1.8-1.79-1.4 1.4zM20 10.5v2h3v-2h-3zm-8-5c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm-1 16.95h2V19.5h-2v2.95zm-7.45-3.91l1.41 1.41 1.79-1.8-1.41-1.41-1.79 1.8z'
    }));
  };

  var WbSunnyIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  WbSunnyIcon.displayName = 'WbSunnyIcon';
  WbSunnyIcon.defaultProps = {
    size: 24
  };
  exports.default = WbSunnyIcon;
});
unwrapExports(WbSunny);
var Wc = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M5.5 22v-7.5H4V9c0-1.1.9-2 2-2h3c1.1 0 2 .9 2 2v5.5H9.5V22h-4zM18 22v-6h3l-2.54-7.63C18.18 7.55 17.42 7 16.56 7h-.12c-.86 0-1.63.55-1.9 1.37L12 16h3v6h3zM7.5 6c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2zm9 0c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2z'
    }));
  };

  var WcIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  WcIcon.displayName = 'WcIcon';
  WcIcon.defaultProps = {
    size: 24
  };
  exports.default = WcIcon;
});
unwrapExports(Wc);
var Web = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-5 14H4v-4h11v4zm0-5H4V9h11v4zm5 5h-4V9h4v9z'
    }));
  };

  var WebIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  WebIcon.displayName = 'WebIcon';
  WebIcon.defaultProps = {
    size: 24
  };
  exports.default = WebIcon;
});
unwrapExports(Web);
var WebAsset = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.89-2-2-2zm0 14H5V8h14v10z'
    }));
  };

  var WebAssetIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  WebAssetIcon.displayName = 'WebAssetIcon';
  WebAssetIcon.defaultProps = {
    size: 24
  };
  exports.default = WebAssetIcon;
});
unwrapExports(WebAsset);
var Weekend = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M21 10c-1.1 0-2 .9-2 2v3H5v-3c0-1.1-.9-2-2-2s-2 .9-2 2v5c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2v-5c0-1.1-.9-2-2-2zm-3-5H6c-1.1 0-2 .9-2 2v2.15c1.16.41 2 1.51 2 2.82V14h12v-2.03c0-1.3.84-2.4 2-2.82V7c0-1.1-.9-2-2-2z'
    }));
  };

  var WeekendIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  WeekendIcon.displayName = 'WeekendIcon';
  WeekendIcon.defaultProps = {
    size: 24
  };
  exports.default = WeekendIcon;
});
unwrapExports(Weekend);
var Whatshot = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M13.5.67s.74 2.65.74 4.8c0 2.06-1.35 3.73-3.41 3.73-2.07 0-3.63-1.67-3.63-3.73l.03-.36C5.21 7.51 4 10.62 4 14c0 4.42 3.58 8 8 8s8-3.58 8-8C20 8.61 17.41 3.8 13.5.67zM11.71 19c-1.78 0-3.22-1.4-3.22-3.14 0-1.62 1.05-2.76 2.81-3.12 1.77-.36 3.6-1.21 4.62-2.58.39 1.29.59 2.65.59 4.04 0 2.65-2.15 4.8-4.8 4.8z'
    }));
  };

  var WhatshotIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  WhatshotIcon.displayName = 'WhatshotIcon';
  WhatshotIcon.defaultProps = {
    size: 24
  };
  exports.default = WhatshotIcon;
});
unwrapExports(Whatshot);
var Widgets = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M13 13v8h8v-8h-8zM3 21h8v-8H3v8zM3 3v8h8V3H3zm13.66-1.31L11 7.34 16.66 13l5.66-5.66-5.66-5.65z'
    }));
  };

  var WidgetsIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  WidgetsIcon.displayName = 'WidgetsIcon';
  WidgetsIcon.defaultProps = {
    size: 24
  };
  exports.default = WidgetsIcon;
});
unwrapExports(Widgets);
var Wifi = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M1 9l2 2c4.97-4.97 13.03-4.97 18 0l2-2C16.93 2.93 7.08 2.93 1 9zm8 8l3 3 3-3c-1.65-1.66-4.34-1.66-6 0zm-4-4l2 2c2.76-2.76 7.24-2.76 10 0l2-2C15.14 9.14 8.87 9.14 5 13z'
    }));
  };

  var WifiIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  WifiIcon.displayName = 'WifiIcon';
  WifiIcon.defaultProps = {
    size: 24
  };
  exports.default = WifiIcon;
});
unwrapExports(Wifi);
var WifiLock = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20.5 9.5c.28 0 .55.04.81.08L24 6c-3.34-2.51-7.5-4-12-4S3.34 3.49 0 6l12 16 3.5-4.67V14.5c0-2.76 2.24-5 5-5zM23 16v-1.5c0-1.38-1.12-2.5-2.5-2.5S18 13.12 18 14.5V16c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1zm-1 0h-3v-1.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V16z'
    }));
  };

  var WifiLockIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  WifiLockIcon.displayName = 'WifiLockIcon';
  WifiLockIcon.defaultProps = {
    size: 24
  };
  exports.default = WifiLockIcon;
});
unwrapExports(WifiLock);
var WifiTethering = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M12 11c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 2c0-3.31-2.69-6-6-6s-6 2.69-6 6c0 2.22 1.21 4.15 3 5.19l1-1.74c-1.19-.7-2-1.97-2-3.45 0-2.21 1.79-4 4-4s4 1.79 4 4c0 1.48-.81 2.75-2 3.45l1 1.74c1.79-1.04 3-2.97 3-5.19zM12 3C6.48 3 2 7.48 2 13c0 3.7 2.01 6.92 4.99 8.65l1-1.73C5.61 18.53 4 15.96 4 13c0-4.42 3.58-8 8-8s8 3.58 8 8c0 2.96-1.61 5.53-4 6.92l1 1.73c2.99-1.73 5-4.95 5-8.65 0-5.52-4.48-10-10-10z'
    }));
  };

  var WifiTetheringIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  WifiTetheringIcon.displayName = 'WifiTetheringIcon';
  WifiTetheringIcon.defaultProps = {
    size: 24
  };
  exports.default = WifiTetheringIcon;
});
unwrapExports(WifiTethering);
var Work = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z'
    }));
  };

  var WorkIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  WorkIcon.displayName = 'WorkIcon';
  WorkIcon.defaultProps = {
    size: 24
  };
  exports.default = WorkIcon;
});
unwrapExports(Work);
var WrapText = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M4 19h6v-2H4v2zM20 5H4v2h16V5zm-3 6H4v2h13.25c1.1 0 2 .9 2 2s-.9 2-2 2H15v-2l-3 3 3 3v-2h2c2.21 0 4-1.79 4-4s-1.79-4-4-4z'
    }));
  };

  var WrapTextIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  WrapTextIcon.displayName = 'WrapTextIcon';
  WrapTextIcon.defaultProps = {
    size: 24
  };
  exports.default = WrapTextIcon;
});
unwrapExports(WrapText);
var YoutubeSearchedFor = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M17.01 14h-.8l-.27-.27c.98-1.14 1.57-2.61 1.57-4.23 0-3.59-2.91-6.5-6.5-6.5s-6.5 3-6.5 6.5H2l3.84 4 4.16-4H6.51C6.51 7 8.53 5 11.01 5s4.5 2.01 4.5 4.5c0 2.48-2.02 4.5-4.5 4.5-.65 0-1.26-.14-1.82-.38L7.71 15.1c.97.57 2.09.9 3.3.9 1.61 0 3.08-.59 4.22-1.57l.27.27v.79l5.01 4.99L22 19l-4.99-5z'
    }));
  };

  var YoutubeSearchedForIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  YoutubeSearchedForIcon.displayName = 'YoutubeSearchedForIcon';
  YoutubeSearchedForIcon.defaultProps = {
    size: 24
  };
  exports.default = YoutubeSearchedForIcon;
});
unwrapExports(YoutubeSearchedFor);
var ZoomIn = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zm2.5-4h-2v2H9v-2H7V9h2V7h1v2h2v1z'
    }));
  };

  var ZoomInIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ZoomInIcon.displayName = 'ZoomInIcon';
  ZoomInIcon.defaultProps = {
    size: 24
  };
  exports.default = ZoomInIcon;
});
unwrapExports(ZoomIn);
var ZoomOut = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zM7 9h5v1H7z'
    }));
  };

  var ZoomOutIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ZoomOutIcon.displayName = 'ZoomOutIcon';
  ZoomOutIcon.defaultProps = {
    size: 24
  };
  exports.default = ZoomOutIcon;
});
unwrapExports(ZoomOut);
var ZoomOutMap = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _styledComponents2 = _interopRequireDefault(styled);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, ['size']);

    return _react2.default.createElement('svg', _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }), _react2.default.createElement('path', {
      d: 'M15 3l2.3 2.3-2.89 2.87 1.42 1.42L18.7 6.7 21 9V3zM3 9l2.3-2.3 2.87 2.89 1.42-1.42L6.7 5.3 9 3H3zm6 12l-2.3-2.3 2.89-2.87-1.42-1.42L5.3 17.3 3 15v6zm12-6l-2.3 2.3-2.87-2.89-1.42 1.42 2.89 2.87L15 21h6z'
    }));
  };

  var ZoomOutMapIcon = (0, _styledComponents2.default)(Icon)([], dist.space, dist.color);
  ZoomOutMapIcon.displayName = 'ZoomOutMapIcon';
  ZoomOutMapIcon.defaultProps = {
    size: 24
  };
  exports.default = ZoomOutMapIcon;
});
unwrapExports(ZoomOutMap);
var lib = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  Object.defineProperty(exports, 'AcUnit', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(AcUnit).default;
    }
  });
  Object.defineProperty(exports, 'AccessAlarm', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(AccessAlarm).default;
    }
  });
  Object.defineProperty(exports, 'AccessAlarms', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(AccessAlarms).default;
    }
  });
  Object.defineProperty(exports, 'AccessTime', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(AccessTime).default;
    }
  });
  Object.defineProperty(exports, 'Accessibility', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Accessibility).default;
    }
  });
  Object.defineProperty(exports, 'Accessible', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Accessible).default;
    }
  });
  Object.defineProperty(exports, 'AccountBalance', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(AccountBalance).default;
    }
  });
  Object.defineProperty(exports, 'AccountBalanceWallet', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(AccountBalanceWallet).default;
    }
  });
  Object.defineProperty(exports, 'AccountBox', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(AccountBox).default;
    }
  });
  Object.defineProperty(exports, 'AccountCircle', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(AccountCircle).default;
    }
  });
  Object.defineProperty(exports, 'Adb', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Adb).default;
    }
  });
  Object.defineProperty(exports, 'Add', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Add).default;
    }
  });
  Object.defineProperty(exports, 'AddAPhoto', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(AddAPhoto).default;
    }
  });
  Object.defineProperty(exports, 'AddAlarm', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(AddAlarm).default;
    }
  });
  Object.defineProperty(exports, 'AddAlert', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(AddAlert).default;
    }
  });
  Object.defineProperty(exports, 'AddBox', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(AddBox).default;
    }
  });
  Object.defineProperty(exports, 'AddCircle', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(AddCircle).default;
    }
  });
  Object.defineProperty(exports, 'AddCircleOutline', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(AddCircleOutline).default;
    }
  });
  Object.defineProperty(exports, 'AddLocation', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(AddLocation).default;
    }
  });
  Object.defineProperty(exports, 'AddShoppingCart', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(AddShoppingCart).default;
    }
  });
  Object.defineProperty(exports, 'AddToPhotos', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(AddToPhotos).default;
    }
  });
  Object.defineProperty(exports, 'AddToQueue', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(AddToQueue).default;
    }
  });
  Object.defineProperty(exports, 'Adjust', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Adjust).default;
    }
  });
  Object.defineProperty(exports, 'AirlineSeatFlat', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(AirlineSeatFlat).default;
    }
  });
  Object.defineProperty(exports, 'AirlineSeatFlatAngled', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(AirlineSeatFlatAngled).default;
    }
  });
  Object.defineProperty(exports, 'AirlineSeatIndividualSuite', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(AirlineSeatIndividualSuite).default;
    }
  });
  Object.defineProperty(exports, 'AirlineSeatLegroomExtra', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(AirlineSeatLegroomExtra).default;
    }
  });
  Object.defineProperty(exports, 'AirlineSeatLegroomNormal', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(AirlineSeatLegroomNormal).default;
    }
  });
  Object.defineProperty(exports, 'AirlineSeatLegroomReduced', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(AirlineSeatLegroomReduced).default;
    }
  });
  Object.defineProperty(exports, 'AirlineSeatReclineExtra', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(AirlineSeatReclineExtra).default;
    }
  });
  Object.defineProperty(exports, 'AirlineSeatReclineNormal', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(AirlineSeatReclineNormal).default;
    }
  });
  Object.defineProperty(exports, 'AirplanemodeActive', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(AirplanemodeActive).default;
    }
  });
  Object.defineProperty(exports, 'AirplanemodeInactive', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(AirplanemodeInactive).default;
    }
  });
  Object.defineProperty(exports, 'Airplay', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Airplay).default;
    }
  });
  Object.defineProperty(exports, 'AirportShuttle', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(AirportShuttle).default;
    }
  });
  Object.defineProperty(exports, 'Alarm', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Alarm).default;
    }
  });
  Object.defineProperty(exports, 'AlarmAdd', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(AlarmAdd).default;
    }
  });
  Object.defineProperty(exports, 'AlarmOff', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(AlarmOff).default;
    }
  });
  Object.defineProperty(exports, 'AlarmOn', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(AlarmOn).default;
    }
  });
  Object.defineProperty(exports, 'Album', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Album).default;
    }
  });
  Object.defineProperty(exports, 'AllInclusive', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(AllInclusive).default;
    }
  });
  Object.defineProperty(exports, 'AllOut', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(AllOut).default;
    }
  });
  Object.defineProperty(exports, 'Android', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Android).default;
    }
  });
  Object.defineProperty(exports, 'Announcement', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Announcement).default;
    }
  });
  Object.defineProperty(exports, 'Apps', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Apps).default;
    }
  });
  Object.defineProperty(exports, 'Archive', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Archive).default;
    }
  });
  Object.defineProperty(exports, 'ArrowBack', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ArrowBack).default;
    }
  });
  Object.defineProperty(exports, 'ArrowDownward', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ArrowDownward).default;
    }
  });
  Object.defineProperty(exports, 'ArrowDropDown', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ArrowDropDown).default;
    }
  });
  Object.defineProperty(exports, 'ArrowDropDownCircle', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ArrowDropDownCircle).default;
    }
  });
  Object.defineProperty(exports, 'ArrowDropUp', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ArrowDropUp).default;
    }
  });
  Object.defineProperty(exports, 'ArrowForward', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ArrowForward).default;
    }
  });
  Object.defineProperty(exports, 'ArrowUpward', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ArrowUpward).default;
    }
  });
  Object.defineProperty(exports, 'ArtTrack', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ArtTrack).default;
    }
  });
  Object.defineProperty(exports, 'AspectRatio', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(AspectRatio).default;
    }
  });
  Object.defineProperty(exports, 'Assessment', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Assessment).default;
    }
  });
  Object.defineProperty(exports, 'Assignment', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Assignment).default;
    }
  });
  Object.defineProperty(exports, 'AssignmentInd', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(AssignmentInd).default;
    }
  });
  Object.defineProperty(exports, 'AssignmentLate', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(AssignmentLate).default;
    }
  });
  Object.defineProperty(exports, 'AssignmentReturn', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(AssignmentReturn).default;
    }
  });
  Object.defineProperty(exports, 'AssignmentReturned', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(AssignmentReturned).default;
    }
  });
  Object.defineProperty(exports, 'AssignmentTurnedIn', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(AssignmentTurnedIn).default;
    }
  });
  Object.defineProperty(exports, 'Assistant', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Assistant).default;
    }
  });
  Object.defineProperty(exports, 'AssistantPhoto', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(AssistantPhoto).default;
    }
  });
  Object.defineProperty(exports, 'AttachFile', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(AttachFile).default;
    }
  });
  Object.defineProperty(exports, 'AttachMoney', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(AttachMoney).default;
    }
  });
  Object.defineProperty(exports, 'Attachment', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Attachment).default;
    }
  });
  Object.defineProperty(exports, 'Audiotrack', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Audiotrack).default;
    }
  });
  Object.defineProperty(exports, 'Autorenew', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Autorenew).default;
    }
  });
  Object.defineProperty(exports, 'AvTimer', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(AvTimer).default;
    }
  });
  Object.defineProperty(exports, 'Backspace', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Backspace).default;
    }
  });
  Object.defineProperty(exports, 'Backup', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Backup).default;
    }
  });
  Object.defineProperty(exports, 'Battery20', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Battery20).default;
    }
  });
  Object.defineProperty(exports, 'Battery30', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Battery30).default;
    }
  });
  Object.defineProperty(exports, 'Battery50', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Battery50).default;
    }
  });
  Object.defineProperty(exports, 'Battery60', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Battery60).default;
    }
  });
  Object.defineProperty(exports, 'Battery80', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Battery80).default;
    }
  });
  Object.defineProperty(exports, 'Battery90', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Battery90).default;
    }
  });
  Object.defineProperty(exports, 'BatteryAlert', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(BatteryAlert).default;
    }
  });
  Object.defineProperty(exports, 'BatteryCharging20', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(BatteryCharging20).default;
    }
  });
  Object.defineProperty(exports, 'BatteryCharging30', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(BatteryCharging30).default;
    }
  });
  Object.defineProperty(exports, 'BatteryCharging50', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(BatteryCharging50).default;
    }
  });
  Object.defineProperty(exports, 'BatteryCharging60', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(BatteryCharging60).default;
    }
  });
  Object.defineProperty(exports, 'BatteryCharging80', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(BatteryCharging80).default;
    }
  });
  Object.defineProperty(exports, 'BatteryCharging90', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(BatteryCharging90).default;
    }
  });
  Object.defineProperty(exports, 'BatteryChargingFull', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(BatteryChargingFull).default;
    }
  });
  Object.defineProperty(exports, 'BatteryFull', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(BatteryFull).default;
    }
  });
  Object.defineProperty(exports, 'BatteryStd', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(BatteryStd).default;
    }
  });
  Object.defineProperty(exports, 'BatteryUnknown', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(BatteryUnknown).default;
    }
  });
  Object.defineProperty(exports, 'BeachAccess', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(BeachAccess).default;
    }
  });
  Object.defineProperty(exports, 'Beenhere', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Beenhere).default;
    }
  });
  Object.defineProperty(exports, 'Block', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Block).default;
    }
  });
  Object.defineProperty(exports, 'Bluetooth', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Bluetooth).default;
    }
  });
  Object.defineProperty(exports, 'BluetoothAudio', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(BluetoothAudio).default;
    }
  });
  Object.defineProperty(exports, 'BluetoothConnected', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(BluetoothConnected).default;
    }
  });
  Object.defineProperty(exports, 'BluetoothDisabled', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(BluetoothDisabled).default;
    }
  });
  Object.defineProperty(exports, 'BluetoothSearching', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(BluetoothSearching).default;
    }
  });
  Object.defineProperty(exports, 'BlurCircular', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(BlurCircular).default;
    }
  });
  Object.defineProperty(exports, 'BlurLinear', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(BlurLinear).default;
    }
  });
  Object.defineProperty(exports, 'BlurOff', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(BlurOff).default;
    }
  });
  Object.defineProperty(exports, 'BlurOn', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(BlurOn).default;
    }
  });
  Object.defineProperty(exports, 'Book', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Book).default;
    }
  });
  Object.defineProperty(exports, 'Bookmark', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Bookmark).default;
    }
  });
  Object.defineProperty(exports, 'BookmarkBorder', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(BookmarkBorder).default;
    }
  });
  Object.defineProperty(exports, 'BorderAll', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(BorderAll).default;
    }
  });
  Object.defineProperty(exports, 'BorderBottom', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(BorderBottom).default;
    }
  });
  Object.defineProperty(exports, 'BorderClear', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(BorderClear).default;
    }
  });
  Object.defineProperty(exports, 'BorderColor', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(BorderColor).default;
    }
  });
  Object.defineProperty(exports, 'BorderHorizontal', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(BorderHorizontal).default;
    }
  });
  Object.defineProperty(exports, 'BorderInner', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(BorderInner).default;
    }
  });
  Object.defineProperty(exports, 'BorderLeft', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(BorderLeft).default;
    }
  });
  Object.defineProperty(exports, 'BorderOuter', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(BorderOuter).default;
    }
  });
  Object.defineProperty(exports, 'BorderRight', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(BorderRight).default;
    }
  });
  Object.defineProperty(exports, 'BorderStyle', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(BorderStyle).default;
    }
  });
  Object.defineProperty(exports, 'BorderTop', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(BorderTop).default;
    }
  });
  Object.defineProperty(exports, 'BorderVertical', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(BorderVertical).default;
    }
  });
  Object.defineProperty(exports, 'BrandingWatermark', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(BrandingWatermark).default;
    }
  });
  Object.defineProperty(exports, 'Brightness1', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Brightness1).default;
    }
  });
  Object.defineProperty(exports, 'Brightness2', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Brightness2).default;
    }
  });
  Object.defineProperty(exports, 'Brightness3', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Brightness3).default;
    }
  });
  Object.defineProperty(exports, 'Brightness4', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Brightness4).default;
    }
  });
  Object.defineProperty(exports, 'Brightness5', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Brightness5).default;
    }
  });
  Object.defineProperty(exports, 'Brightness6', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Brightness6).default;
    }
  });
  Object.defineProperty(exports, 'Brightness7', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Brightness7).default;
    }
  });
  Object.defineProperty(exports, 'BrightnessAuto', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(BrightnessAuto).default;
    }
  });
  Object.defineProperty(exports, 'BrightnessHigh', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(BrightnessHigh).default;
    }
  });
  Object.defineProperty(exports, 'BrightnessLow', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(BrightnessLow).default;
    }
  });
  Object.defineProperty(exports, 'BrightnessMedium', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(BrightnessMedium).default;
    }
  });
  Object.defineProperty(exports, 'BrokenImage', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(BrokenImage).default;
    }
  });
  Object.defineProperty(exports, 'Brush', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Brush).default;
    }
  });
  Object.defineProperty(exports, 'BubbleChart', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(BubbleChart).default;
    }
  });
  Object.defineProperty(exports, 'BugReport', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(BugReport).default;
    }
  });
  Object.defineProperty(exports, 'Build', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Build).default;
    }
  });
  Object.defineProperty(exports, 'BurstMode', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(BurstMode).default;
    }
  });
  Object.defineProperty(exports, 'Business', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Business).default;
    }
  });
  Object.defineProperty(exports, 'BusinessCenter', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(BusinessCenter).default;
    }
  });
  Object.defineProperty(exports, 'Cached', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Cached).default;
    }
  });
  Object.defineProperty(exports, 'Cake', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Cake).default;
    }
  });
  Object.defineProperty(exports, 'Call', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Call).default;
    }
  });
  Object.defineProperty(exports, 'CallEnd', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(CallEnd).default;
    }
  });
  Object.defineProperty(exports, 'CallMade', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(CallMade).default;
    }
  });
  Object.defineProperty(exports, 'CallMerge', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(CallMerge).default;
    }
  });
  Object.defineProperty(exports, 'CallMissed', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(CallMissed).default;
    }
  });
  Object.defineProperty(exports, 'CallMissedOutgoing', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(CallMissedOutgoing).default;
    }
  });
  Object.defineProperty(exports, 'CallReceived', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(CallReceived).default;
    }
  });
  Object.defineProperty(exports, 'CallSplit', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(CallSplit).default;
    }
  });
  Object.defineProperty(exports, 'CallToAction', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(CallToAction).default;
    }
  });
  Object.defineProperty(exports, 'Camera', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Camera).default;
    }
  });
  Object.defineProperty(exports, 'CameraAlt', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(CameraAlt).default;
    }
  });
  Object.defineProperty(exports, 'CameraEnhance', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(CameraEnhance).default;
    }
  });
  Object.defineProperty(exports, 'CameraFront', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(CameraFront).default;
    }
  });
  Object.defineProperty(exports, 'CameraRear', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(CameraRear).default;
    }
  });
  Object.defineProperty(exports, 'CameraRoll', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(CameraRoll).default;
    }
  });
  Object.defineProperty(exports, 'Cancel', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Cancel).default;
    }
  });
  Object.defineProperty(exports, 'CardGiftcard', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(CardGiftcard).default;
    }
  });
  Object.defineProperty(exports, 'CardMembership', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(CardMembership).default;
    }
  });
  Object.defineProperty(exports, 'CardTravel', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(CardTravel).default;
    }
  });
  Object.defineProperty(exports, 'Casino', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Casino).default;
    }
  });
  Object.defineProperty(exports, 'Cast', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Cast).default;
    }
  });
  Object.defineProperty(exports, 'CastConnected', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(CastConnected).default;
    }
  });
  Object.defineProperty(exports, 'CenterFocusStrong', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(CenterFocusStrong).default;
    }
  });
  Object.defineProperty(exports, 'CenterFocusWeak', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(CenterFocusWeak).default;
    }
  });
  Object.defineProperty(exports, 'ChangeHistory', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ChangeHistory).default;
    }
  });
  Object.defineProperty(exports, 'Chat', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Chat).default;
    }
  });
  Object.defineProperty(exports, 'ChatBubble', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ChatBubble).default;
    }
  });
  Object.defineProperty(exports, 'ChatBubbleOutline', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ChatBubbleOutline).default;
    }
  });
  Object.defineProperty(exports, 'Check', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Check).default;
    }
  });
  Object.defineProperty(exports, 'CheckBox', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(CheckBox).default;
    }
  });
  Object.defineProperty(exports, 'CheckBoxOutlineBlank', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(CheckBoxOutlineBlank).default;
    }
  });
  Object.defineProperty(exports, 'CheckCircle', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(CheckCircle).default;
    }
  });
  Object.defineProperty(exports, 'ChevronLeft', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ChevronLeft).default;
    }
  });
  Object.defineProperty(exports, 'ChevronRight', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ChevronRight).default;
    }
  });
  Object.defineProperty(exports, 'ChildCare', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ChildCare).default;
    }
  });
  Object.defineProperty(exports, 'ChildFriendly', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ChildFriendly).default;
    }
  });
  Object.defineProperty(exports, 'ChromeReaderMode', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ChromeReaderMode).default;
    }
  });
  Object.defineProperty(exports, 'Class', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Class).default;
    }
  });
  Object.defineProperty(exports, 'Clear', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Clear).default;
    }
  });
  Object.defineProperty(exports, 'ClearAll', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ClearAll).default;
    }
  });
  Object.defineProperty(exports, 'Close', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Close).default;
    }
  });
  Object.defineProperty(exports, 'ClosedCaption', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ClosedCaption).default;
    }
  });
  Object.defineProperty(exports, 'Cloud', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Cloud).default;
    }
  });
  Object.defineProperty(exports, 'CloudCircle', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(CloudCircle).default;
    }
  });
  Object.defineProperty(exports, 'CloudDone', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(CloudDone).default;
    }
  });
  Object.defineProperty(exports, 'CloudDownload', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(CloudDownload).default;
    }
  });
  Object.defineProperty(exports, 'CloudOff', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(CloudOff).default;
    }
  });
  Object.defineProperty(exports, 'CloudQueue', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(CloudQueue).default;
    }
  });
  Object.defineProperty(exports, 'CloudUpload', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(CloudUpload).default;
    }
  });
  Object.defineProperty(exports, 'Code', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Code).default;
    }
  });
  Object.defineProperty(exports, 'Collections', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Collections).default;
    }
  });
  Object.defineProperty(exports, 'CollectionsBookmark', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(CollectionsBookmark).default;
    }
  });
  Object.defineProperty(exports, 'ColorLens', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ColorLens).default;
    }
  });
  Object.defineProperty(exports, 'Colorize', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Colorize).default;
    }
  });
  Object.defineProperty(exports, 'Comment', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Comment).default;
    }
  });
  Object.defineProperty(exports, 'Compare', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Compare).default;
    }
  });
  Object.defineProperty(exports, 'CompareArrows', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(CompareArrows).default;
    }
  });
  Object.defineProperty(exports, 'Computer', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Computer).default;
    }
  });
  Object.defineProperty(exports, 'ConfirmationNumber', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ConfirmationNumber).default;
    }
  });
  Object.defineProperty(exports, 'ContactMail', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ContactMail).default;
    }
  });
  Object.defineProperty(exports, 'ContactPhone', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ContactPhone).default;
    }
  });
  Object.defineProperty(exports, 'Contacts', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Contacts).default;
    }
  });
  Object.defineProperty(exports, 'ContentCopy', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ContentCopy).default;
    }
  });
  Object.defineProperty(exports, 'ContentCut', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ContentCut).default;
    }
  });
  Object.defineProperty(exports, 'ContentPaste', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ContentPaste).default;
    }
  });
  Object.defineProperty(exports, 'ControlPoint', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ControlPoint).default;
    }
  });
  Object.defineProperty(exports, 'ControlPointDuplicate', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ControlPointDuplicate).default;
    }
  });
  Object.defineProperty(exports, 'Copyright', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Copyright).default;
    }
  });
  Object.defineProperty(exports, 'Create', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Create).default;
    }
  });
  Object.defineProperty(exports, 'CreateNewFolder', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(CreateNewFolder).default;
    }
  });
  Object.defineProperty(exports, 'CreditCard', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(CreditCard).default;
    }
  });
  Object.defineProperty(exports, 'Crop', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Crop).default;
    }
  });
  Object.defineProperty(exports, 'Crop169', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Crop169).default;
    }
  });
  Object.defineProperty(exports, 'Crop32', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Crop32).default;
    }
  });
  Object.defineProperty(exports, 'Crop54', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Crop54).default;
    }
  });
  Object.defineProperty(exports, 'Crop75', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Crop75).default;
    }
  });
  Object.defineProperty(exports, 'CropDin', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(CropDin).default;
    }
  });
  Object.defineProperty(exports, 'CropFree', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(CropFree).default;
    }
  });
  Object.defineProperty(exports, 'CropLandscape', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(CropLandscape).default;
    }
  });
  Object.defineProperty(exports, 'CropOriginal', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(CropOriginal).default;
    }
  });
  Object.defineProperty(exports, 'CropPortrait', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(CropPortrait).default;
    }
  });
  Object.defineProperty(exports, 'CropRotate', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(CropRotate).default;
    }
  });
  Object.defineProperty(exports, 'CropSquare', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(CropSquare).default;
    }
  });
  Object.defineProperty(exports, 'Dashboard', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Dashboard).default;
    }
  });
  Object.defineProperty(exports, 'DataUsage', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(DataUsage).default;
    }
  });
  Object.defineProperty(exports, 'DateRange', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(DateRange).default;
    }
  });
  Object.defineProperty(exports, 'Dehaze', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Dehaze).default;
    }
  });
  Object.defineProperty(exports, 'Delete', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Delete).default;
    }
  });
  Object.defineProperty(exports, 'DeleteForever', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(DeleteForever).default;
    }
  });
  Object.defineProperty(exports, 'DeleteSweep', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(DeleteSweep).default;
    }
  });
  Object.defineProperty(exports, 'Description', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Description).default;
    }
  });
  Object.defineProperty(exports, 'DesktopMac', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(DesktopMac).default;
    }
  });
  Object.defineProperty(exports, 'DesktopWindows', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(DesktopWindows).default;
    }
  });
  Object.defineProperty(exports, 'Details', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Details).default;
    }
  });
  Object.defineProperty(exports, 'DeveloperBoard', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(DeveloperBoard).default;
    }
  });
  Object.defineProperty(exports, 'DeveloperMode', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(DeveloperMode).default;
    }
  });
  Object.defineProperty(exports, 'DeviceHub', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(DeviceHub).default;
    }
  });
  Object.defineProperty(exports, 'Devices', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Devices).default;
    }
  });
  Object.defineProperty(exports, 'DevicesOther', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(DevicesOther).default;
    }
  });
  Object.defineProperty(exports, 'DialerSip', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(DialerSip).default;
    }
  });
  Object.defineProperty(exports, 'Dialpad', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Dialpad).default;
    }
  });
  Object.defineProperty(exports, 'Directions', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Directions).default;
    }
  });
  Object.defineProperty(exports, 'DirectionsBike', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(DirectionsBike).default;
    }
  });
  Object.defineProperty(exports, 'DirectionsBoat', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(DirectionsBoat).default;
    }
  });
  Object.defineProperty(exports, 'DirectionsBus', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(DirectionsBus).default;
    }
  });
  Object.defineProperty(exports, 'DirectionsCar', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(DirectionsCar).default;
    }
  });
  Object.defineProperty(exports, 'DirectionsRailway', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(DirectionsRailway).default;
    }
  });
  Object.defineProperty(exports, 'DirectionsRun', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(DirectionsRun).default;
    }
  });
  Object.defineProperty(exports, 'DirectionsSubway', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(DirectionsSubway).default;
    }
  });
  Object.defineProperty(exports, 'DirectionsTransit', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(DirectionsTransit).default;
    }
  });
  Object.defineProperty(exports, 'DirectionsWalk', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(DirectionsWalk).default;
    }
  });
  Object.defineProperty(exports, 'DiscFull', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(DiscFull).default;
    }
  });
  Object.defineProperty(exports, 'Dns', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Dns).default;
    }
  });
  Object.defineProperty(exports, 'DoNotDisturb', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(DoNotDisturb).default;
    }
  });
  Object.defineProperty(exports, 'DoNotDisturbAlt', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(DoNotDisturbAlt).default;
    }
  });
  Object.defineProperty(exports, 'DoNotDisturbOff', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(DoNotDisturbOff).default;
    }
  });
  Object.defineProperty(exports, 'DoNotDisturbOn', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(DoNotDisturbOn).default;
    }
  });
  Object.defineProperty(exports, 'Dock', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Dock).default;
    }
  });
  Object.defineProperty(exports, 'Domain', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Domain).default;
    }
  });
  Object.defineProperty(exports, 'Done', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Done).default;
    }
  });
  Object.defineProperty(exports, 'DoneAll', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(DoneAll).default;
    }
  });
  Object.defineProperty(exports, 'DonutLarge', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(DonutLarge).default;
    }
  });
  Object.defineProperty(exports, 'DonutSmall', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(DonutSmall).default;
    }
  });
  Object.defineProperty(exports, 'Drafts', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Drafts).default;
    }
  });
  Object.defineProperty(exports, 'DragHandle', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(DragHandle).default;
    }
  });
  Object.defineProperty(exports, 'DriveEta', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(DriveEta).default;
    }
  });
  Object.defineProperty(exports, 'Dvr', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Dvr).default;
    }
  });
  Object.defineProperty(exports, 'Edit', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Edit).default;
    }
  });
  Object.defineProperty(exports, 'EditLocation', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(EditLocation).default;
    }
  });
  Object.defineProperty(exports, 'Eject', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Eject).default;
    }
  });
  Object.defineProperty(exports, 'Email', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Email).default;
    }
  });
  Object.defineProperty(exports, 'EnhancedEncryption', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(EnhancedEncryption).default;
    }
  });
  Object.defineProperty(exports, 'Equalizer', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Equalizer).default;
    }
  });
  Object.defineProperty(exports, 'Error', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(_Error).default;
    }
  });
  Object.defineProperty(exports, 'ErrorOutline', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ErrorOutline).default;
    }
  });
  Object.defineProperty(exports, 'EuroSymbol', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(EuroSymbol).default;
    }
  });
  Object.defineProperty(exports, 'EvStation', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(EvStation).default;
    }
  });
  Object.defineProperty(exports, 'Event', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Event).default;
    }
  });
  Object.defineProperty(exports, 'EventAvailable', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(EventAvailable).default;
    }
  });
  Object.defineProperty(exports, 'EventBusy', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(EventBusy).default;
    }
  });
  Object.defineProperty(exports, 'EventNote', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(EventNote).default;
    }
  });
  Object.defineProperty(exports, 'EventSeat', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(EventSeat).default;
    }
  });
  Object.defineProperty(exports, 'ExitToApp', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ExitToApp).default;
    }
  });
  Object.defineProperty(exports, 'ExpandLess', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ExpandLess).default;
    }
  });
  Object.defineProperty(exports, 'ExpandMore', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ExpandMore).default;
    }
  });
  Object.defineProperty(exports, 'Explicit', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Explicit).default;
    }
  });
  Object.defineProperty(exports, 'Explore', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Explore).default;
    }
  });
  Object.defineProperty(exports, 'Exposure', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Exposure).default;
    }
  });
  Object.defineProperty(exports, 'ExposureNeg1', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ExposureNeg1).default;
    }
  });
  Object.defineProperty(exports, 'ExposureNeg2', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ExposureNeg2).default;
    }
  });
  Object.defineProperty(exports, 'ExposurePlus1', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ExposurePlus1).default;
    }
  });
  Object.defineProperty(exports, 'ExposurePlus2', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ExposurePlus2).default;
    }
  });
  Object.defineProperty(exports, 'ExposureZero', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ExposureZero).default;
    }
  });
  Object.defineProperty(exports, 'Extension', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Extension).default;
    }
  });
  Object.defineProperty(exports, 'Face', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Face).default;
    }
  });
  Object.defineProperty(exports, 'FastForward', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FastForward).default;
    }
  });
  Object.defineProperty(exports, 'FastRewind', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FastRewind).default;
    }
  });
  Object.defineProperty(exports, 'Favorite', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Favorite).default;
    }
  });
  Object.defineProperty(exports, 'FavoriteBorder', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FavoriteBorder).default;
    }
  });
  Object.defineProperty(exports, 'FeaturedPlayList', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FeaturedPlayList).default;
    }
  });
  Object.defineProperty(exports, 'FeaturedVideo', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FeaturedVideo).default;
    }
  });
  Object.defineProperty(exports, 'Feedback', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Feedback).default;
    }
  });
  Object.defineProperty(exports, 'FiberDvr', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FiberDvr).default;
    }
  });
  Object.defineProperty(exports, 'FiberManualRecord', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FiberManualRecord).default;
    }
  });
  Object.defineProperty(exports, 'FiberNew', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FiberNew).default;
    }
  });
  Object.defineProperty(exports, 'FiberPin', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FiberPin).default;
    }
  });
  Object.defineProperty(exports, 'FiberSmartRecord', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FiberSmartRecord).default;
    }
  });
  Object.defineProperty(exports, 'FileDownload', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FileDownload).default;
    }
  });
  Object.defineProperty(exports, 'FileUpload', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FileUpload).default;
    }
  });
  Object.defineProperty(exports, 'Filter', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Filter).default;
    }
  });
  Object.defineProperty(exports, 'Filter1', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Filter1).default;
    }
  });
  Object.defineProperty(exports, 'Filter2', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Filter2).default;
    }
  });
  Object.defineProperty(exports, 'Filter3', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Filter3).default;
    }
  });
  Object.defineProperty(exports, 'Filter4', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Filter4).default;
    }
  });
  Object.defineProperty(exports, 'Filter5', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Filter5).default;
    }
  });
  Object.defineProperty(exports, 'Filter6', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Filter6).default;
    }
  });
  Object.defineProperty(exports, 'Filter7', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Filter7).default;
    }
  });
  Object.defineProperty(exports, 'Filter8', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Filter8).default;
    }
  });
  Object.defineProperty(exports, 'Filter9', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Filter9).default;
    }
  });
  Object.defineProperty(exports, 'Filter9Plus', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Filter9Plus).default;
    }
  });
  Object.defineProperty(exports, 'FilterBAndW', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FilterBAndW).default;
    }
  });
  Object.defineProperty(exports, 'FilterCenterFocus', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FilterCenterFocus).default;
    }
  });
  Object.defineProperty(exports, 'FilterDrama', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FilterDrama).default;
    }
  });
  Object.defineProperty(exports, 'FilterFrames', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FilterFrames).default;
    }
  });
  Object.defineProperty(exports, 'FilterHdr', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FilterHdr).default;
    }
  });
  Object.defineProperty(exports, 'FilterList', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FilterList).default;
    }
  });
  Object.defineProperty(exports, 'FilterNone', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FilterNone).default;
    }
  });
  Object.defineProperty(exports, 'FilterTiltShift', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FilterTiltShift).default;
    }
  });
  Object.defineProperty(exports, 'FilterVintage', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FilterVintage).default;
    }
  });
  Object.defineProperty(exports, 'FindInPage', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FindInPage).default;
    }
  });
  Object.defineProperty(exports, 'FindReplace', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FindReplace).default;
    }
  });
  Object.defineProperty(exports, 'Fingerprint', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Fingerprint).default;
    }
  });
  Object.defineProperty(exports, 'FirstPage', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FirstPage).default;
    }
  });
  Object.defineProperty(exports, 'FitnessCenter', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FitnessCenter).default;
    }
  });
  Object.defineProperty(exports, 'Flag', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Flag).default;
    }
  });
  Object.defineProperty(exports, 'Flare', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Flare).default;
    }
  });
  Object.defineProperty(exports, 'FlashAuto', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FlashAuto).default;
    }
  });
  Object.defineProperty(exports, 'FlashOff', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FlashOff).default;
    }
  });
  Object.defineProperty(exports, 'FlashOn', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FlashOn).default;
    }
  });
  Object.defineProperty(exports, 'Flight', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Flight).default;
    }
  });
  Object.defineProperty(exports, 'FlightLand', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FlightLand).default;
    }
  });
  Object.defineProperty(exports, 'FlightTakeoff', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FlightTakeoff).default;
    }
  });
  Object.defineProperty(exports, 'Flip', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Flip).default;
    }
  });
  Object.defineProperty(exports, 'FlipToBack', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FlipToBack).default;
    }
  });
  Object.defineProperty(exports, 'FlipToFront', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FlipToFront).default;
    }
  });
  Object.defineProperty(exports, 'Folder', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Folder).default;
    }
  });
  Object.defineProperty(exports, 'FolderOpen', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FolderOpen).default;
    }
  });
  Object.defineProperty(exports, 'FolderShared', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FolderShared).default;
    }
  });
  Object.defineProperty(exports, 'FolderSpecial', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FolderSpecial).default;
    }
  });
  Object.defineProperty(exports, 'FontDownload', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FontDownload).default;
    }
  });
  Object.defineProperty(exports, 'FormatAlignCenter', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FormatAlignCenter).default;
    }
  });
  Object.defineProperty(exports, 'FormatAlignJustify', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FormatAlignJustify).default;
    }
  });
  Object.defineProperty(exports, 'FormatAlignLeft', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FormatAlignLeft).default;
    }
  });
  Object.defineProperty(exports, 'FormatAlignRight', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FormatAlignRight).default;
    }
  });
  Object.defineProperty(exports, 'FormatBold', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FormatBold).default;
    }
  });
  Object.defineProperty(exports, 'FormatClear', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FormatClear).default;
    }
  });
  Object.defineProperty(exports, 'FormatColorFill', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FormatColorFill).default;
    }
  });
  Object.defineProperty(exports, 'FormatColorReset', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FormatColorReset).default;
    }
  });
  Object.defineProperty(exports, 'FormatColorText', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FormatColorText).default;
    }
  });
  Object.defineProperty(exports, 'FormatIndentDecrease', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FormatIndentDecrease).default;
    }
  });
  Object.defineProperty(exports, 'FormatIndentIncrease', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FormatIndentIncrease).default;
    }
  });
  Object.defineProperty(exports, 'FormatItalic', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FormatItalic).default;
    }
  });
  Object.defineProperty(exports, 'FormatLineSpacing', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FormatLineSpacing).default;
    }
  });
  Object.defineProperty(exports, 'FormatListBulleted', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FormatListBulleted).default;
    }
  });
  Object.defineProperty(exports, 'FormatListNumbered', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FormatListNumbered).default;
    }
  });
  Object.defineProperty(exports, 'FormatPaint', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FormatPaint).default;
    }
  });
  Object.defineProperty(exports, 'FormatQuote', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FormatQuote).default;
    }
  });
  Object.defineProperty(exports, 'FormatShapes', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FormatShapes).default;
    }
  });
  Object.defineProperty(exports, 'FormatSize', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FormatSize).default;
    }
  });
  Object.defineProperty(exports, 'FormatStrikethrough', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FormatStrikethrough).default;
    }
  });
  Object.defineProperty(exports, 'FormatTextdirectionLToR', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FormatTextdirectionLToR).default;
    }
  });
  Object.defineProperty(exports, 'FormatTextdirectionRToL', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FormatTextdirectionRToL).default;
    }
  });
  Object.defineProperty(exports, 'FormatUnderlined', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FormatUnderlined).default;
    }
  });
  Object.defineProperty(exports, 'Forum', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Forum).default;
    }
  });
  Object.defineProperty(exports, 'Forward', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Forward).default;
    }
  });
  Object.defineProperty(exports, 'Forward10', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Forward10).default;
    }
  });
  Object.defineProperty(exports, 'Forward30', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Forward30).default;
    }
  });
  Object.defineProperty(exports, 'Forward5', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Forward5).default;
    }
  });
  Object.defineProperty(exports, 'FreeBreakfast', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FreeBreakfast).default;
    }
  });
  Object.defineProperty(exports, 'Fullscreen', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Fullscreen).default;
    }
  });
  Object.defineProperty(exports, 'FullscreenExit', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(FullscreenExit).default;
    }
  });
  Object.defineProperty(exports, 'Functions', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Functions).default;
    }
  });
  Object.defineProperty(exports, 'GTranslate', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(GTranslate).default;
    }
  });
  Object.defineProperty(exports, 'Gamepad', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Gamepad).default;
    }
  });
  Object.defineProperty(exports, 'Games', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Games).default;
    }
  });
  Object.defineProperty(exports, 'Gavel', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Gavel).default;
    }
  });
  Object.defineProperty(exports, 'Gesture', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Gesture).default;
    }
  });
  Object.defineProperty(exports, 'GetApp', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(GetApp).default;
    }
  });
  Object.defineProperty(exports, 'Gif', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Gif).default;
    }
  });
  Object.defineProperty(exports, 'GolfCourse', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(GolfCourse).default;
    }
  });
  Object.defineProperty(exports, 'GpsFixed', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(GpsFixed).default;
    }
  });
  Object.defineProperty(exports, 'GpsNotFixed', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(GpsNotFixed).default;
    }
  });
  Object.defineProperty(exports, 'GpsOff', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(GpsOff).default;
    }
  });
  Object.defineProperty(exports, 'Grade', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Grade).default;
    }
  });
  Object.defineProperty(exports, 'Gradient', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Gradient).default;
    }
  });
  Object.defineProperty(exports, 'Grain', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Grain).default;
    }
  });
  Object.defineProperty(exports, 'GraphicEq', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(GraphicEq).default;
    }
  });
  Object.defineProperty(exports, 'GridOff', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(GridOff).default;
    }
  });
  Object.defineProperty(exports, 'GridOn', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(GridOn).default;
    }
  });
  Object.defineProperty(exports, 'Group', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Group).default;
    }
  });
  Object.defineProperty(exports, 'GroupAdd', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(GroupAdd).default;
    }
  });
  Object.defineProperty(exports, 'GroupWork', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(GroupWork).default;
    }
  });
  Object.defineProperty(exports, 'Hd', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Hd).default;
    }
  });
  Object.defineProperty(exports, 'HdrOff', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(HdrOff).default;
    }
  });
  Object.defineProperty(exports, 'HdrOn', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(HdrOn).default;
    }
  });
  Object.defineProperty(exports, 'HdrStrong', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(HdrStrong).default;
    }
  });
  Object.defineProperty(exports, 'HdrWeak', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(HdrWeak).default;
    }
  });
  Object.defineProperty(exports, 'Headset', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Headset).default;
    }
  });
  Object.defineProperty(exports, 'HeadsetMic', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(HeadsetMic).default;
    }
  });
  Object.defineProperty(exports, 'Healing', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Healing).default;
    }
  });
  Object.defineProperty(exports, 'Hearing', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Hearing).default;
    }
  });
  Object.defineProperty(exports, 'Help', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Help).default;
    }
  });
  Object.defineProperty(exports, 'HelpOutline', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(HelpOutline).default;
    }
  });
  Object.defineProperty(exports, 'HighQuality', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(HighQuality).default;
    }
  });
  Object.defineProperty(exports, 'Highlight', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Highlight).default;
    }
  });
  Object.defineProperty(exports, 'HighlightOff', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(HighlightOff).default;
    }
  });
  Object.defineProperty(exports, 'History', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(History).default;
    }
  });
  Object.defineProperty(exports, 'Home', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Home).default;
    }
  });
  Object.defineProperty(exports, 'HotTub', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(HotTub).default;
    }
  });
  Object.defineProperty(exports, 'Hotel', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Hotel).default;
    }
  });
  Object.defineProperty(exports, 'HourglassEmpty', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(HourglassEmpty).default;
    }
  });
  Object.defineProperty(exports, 'HourglassFull', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(HourglassFull).default;
    }
  });
  Object.defineProperty(exports, 'Http', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Http).default;
    }
  });
  Object.defineProperty(exports, 'Https', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Https).default;
    }
  });
  Object.defineProperty(exports, 'Image', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Image$1).default;
    }
  });
  Object.defineProperty(exports, 'ImageAspectRatio', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ImageAspectRatio).default;
    }
  });
  Object.defineProperty(exports, 'ImportContacts', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ImportContacts).default;
    }
  });
  Object.defineProperty(exports, 'ImportExport', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ImportExport).default;
    }
  });
  Object.defineProperty(exports, 'ImportantDevices', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ImportantDevices).default;
    }
  });
  Object.defineProperty(exports, 'Inbox', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Inbox).default;
    }
  });
  Object.defineProperty(exports, 'IndeterminateCheckBox', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(IndeterminateCheckBox).default;
    }
  });
  Object.defineProperty(exports, 'Info', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Info).default;
    }
  });
  Object.defineProperty(exports, 'InfoOutline', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(InfoOutline).default;
    }
  });
  Object.defineProperty(exports, 'Input', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Input).default;
    }
  });
  Object.defineProperty(exports, 'InsertChart', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(InsertChart).default;
    }
  });
  Object.defineProperty(exports, 'InsertComment', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(InsertComment).default;
    }
  });
  Object.defineProperty(exports, 'InsertDriveFile', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(InsertDriveFile).default;
    }
  });
  Object.defineProperty(exports, 'InsertEmoticon', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(InsertEmoticon).default;
    }
  });
  Object.defineProperty(exports, 'InsertInvitation', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(InsertInvitation).default;
    }
  });
  Object.defineProperty(exports, 'InsertLink', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(InsertLink).default;
    }
  });
  Object.defineProperty(exports, 'InsertPhoto', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(InsertPhoto).default;
    }
  });
  Object.defineProperty(exports, 'InvertColors', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(InvertColors).default;
    }
  });
  Object.defineProperty(exports, 'InvertColorsOff', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(InvertColorsOff).default;
    }
  });
  Object.defineProperty(exports, 'Iso', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Iso).default;
    }
  });
  Object.defineProperty(exports, 'Keyboard', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Keyboard).default;
    }
  });
  Object.defineProperty(exports, 'KeyboardArrowDown', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(KeyboardArrowDown).default;
    }
  });
  Object.defineProperty(exports, 'KeyboardArrowLeft', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(KeyboardArrowLeft).default;
    }
  });
  Object.defineProperty(exports, 'KeyboardArrowRight', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(KeyboardArrowRight).default;
    }
  });
  Object.defineProperty(exports, 'KeyboardArrowUp', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(KeyboardArrowUp).default;
    }
  });
  Object.defineProperty(exports, 'KeyboardBackspace', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(KeyboardBackspace).default;
    }
  });
  Object.defineProperty(exports, 'KeyboardCapslock', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(KeyboardCapslock).default;
    }
  });
  Object.defineProperty(exports, 'KeyboardHide', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(KeyboardHide).default;
    }
  });
  Object.defineProperty(exports, 'KeyboardReturn', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(KeyboardReturn).default;
    }
  });
  Object.defineProperty(exports, 'KeyboardTab', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(KeyboardTab).default;
    }
  });
  Object.defineProperty(exports, 'KeyboardVoice', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(KeyboardVoice).default;
    }
  });
  Object.defineProperty(exports, 'Kitchen', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Kitchen).default;
    }
  });
  Object.defineProperty(exports, 'Label', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Label).default;
    }
  });
  Object.defineProperty(exports, 'LabelOutline', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(LabelOutline).default;
    }
  });
  Object.defineProperty(exports, 'Landscape', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Landscape).default;
    }
  });
  Object.defineProperty(exports, 'Language', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Language).default;
    }
  });
  Object.defineProperty(exports, 'Laptop', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Laptop).default;
    }
  });
  Object.defineProperty(exports, 'LaptopChromebook', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(LaptopChromebook).default;
    }
  });
  Object.defineProperty(exports, 'LaptopMac', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(LaptopMac).default;
    }
  });
  Object.defineProperty(exports, 'LaptopWindows', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(LaptopWindows).default;
    }
  });
  Object.defineProperty(exports, 'LastPage', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(LastPage).default;
    }
  });
  Object.defineProperty(exports, 'Launch', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Launch).default;
    }
  });
  Object.defineProperty(exports, 'Layers', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Layers).default;
    }
  });
  Object.defineProperty(exports, 'LayersClear', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(LayersClear).default;
    }
  });
  Object.defineProperty(exports, 'LeakAdd', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(LeakAdd).default;
    }
  });
  Object.defineProperty(exports, 'LeakRemove', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(LeakRemove).default;
    }
  });
  Object.defineProperty(exports, 'Lens', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Lens).default;
    }
  });
  Object.defineProperty(exports, 'LibraryAdd', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(LibraryAdd).default;
    }
  });
  Object.defineProperty(exports, 'LibraryBooks', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(LibraryBooks).default;
    }
  });
  Object.defineProperty(exports, 'LibraryMusic', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(LibraryMusic).default;
    }
  });
  Object.defineProperty(exports, 'LightbulbOutline', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(LightbulbOutline).default;
    }
  });
  Object.defineProperty(exports, 'LineStyle', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(LineStyle).default;
    }
  });
  Object.defineProperty(exports, 'LineWeight', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(LineWeight).default;
    }
  });
  Object.defineProperty(exports, 'LinearScale', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(LinearScale).default;
    }
  });
  Object.defineProperty(exports, 'Link', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Link).default;
    }
  });
  Object.defineProperty(exports, 'LinkedCamera', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(LinkedCamera).default;
    }
  });
  Object.defineProperty(exports, 'List', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(List).default;
    }
  });
  Object.defineProperty(exports, 'LiveHelp', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(LiveHelp).default;
    }
  });
  Object.defineProperty(exports, 'LiveTv', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(LiveTv).default;
    }
  });
  Object.defineProperty(exports, 'LocalActivity', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(LocalActivity).default;
    }
  });
  Object.defineProperty(exports, 'LocalAirport', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(LocalAirport).default;
    }
  });
  Object.defineProperty(exports, 'LocalAtm', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(LocalAtm).default;
    }
  });
  Object.defineProperty(exports, 'LocalBar', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(LocalBar).default;
    }
  });
  Object.defineProperty(exports, 'LocalCafe', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(LocalCafe).default;
    }
  });
  Object.defineProperty(exports, 'LocalCarWash', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(LocalCarWash).default;
    }
  });
  Object.defineProperty(exports, 'LocalConvenienceStore', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(LocalConvenienceStore).default;
    }
  });
  Object.defineProperty(exports, 'LocalDining', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(LocalDining).default;
    }
  });
  Object.defineProperty(exports, 'LocalDrink', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(LocalDrink).default;
    }
  });
  Object.defineProperty(exports, 'LocalFlorist', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(LocalFlorist).default;
    }
  });
  Object.defineProperty(exports, 'LocalGasStation', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(LocalGasStation).default;
    }
  });
  Object.defineProperty(exports, 'LocalGroceryStore', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(LocalGroceryStore).default;
    }
  });
  Object.defineProperty(exports, 'LocalHospital', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(LocalHospital).default;
    }
  });
  Object.defineProperty(exports, 'LocalHotel', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(LocalHotel).default;
    }
  });
  Object.defineProperty(exports, 'LocalLaundryService', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(LocalLaundryService).default;
    }
  });
  Object.defineProperty(exports, 'LocalLibrary', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(LocalLibrary).default;
    }
  });
  Object.defineProperty(exports, 'LocalMall', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(LocalMall).default;
    }
  });
  Object.defineProperty(exports, 'LocalMovies', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(LocalMovies).default;
    }
  });
  Object.defineProperty(exports, 'LocalOffer', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(LocalOffer).default;
    }
  });
  Object.defineProperty(exports, 'LocalParking', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(LocalParking).default;
    }
  });
  Object.defineProperty(exports, 'LocalPharmacy', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(LocalPharmacy).default;
    }
  });
  Object.defineProperty(exports, 'LocalPhone', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(LocalPhone).default;
    }
  });
  Object.defineProperty(exports, 'LocalPizza', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(LocalPizza).default;
    }
  });
  Object.defineProperty(exports, 'LocalPlay', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(LocalPlay).default;
    }
  });
  Object.defineProperty(exports, 'LocalPostOffice', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(LocalPostOffice).default;
    }
  });
  Object.defineProperty(exports, 'LocalPrintshop', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(LocalPrintshop).default;
    }
  });
  Object.defineProperty(exports, 'LocalSee', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(LocalSee).default;
    }
  });
  Object.defineProperty(exports, 'LocalShipping', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(LocalShipping).default;
    }
  });
  Object.defineProperty(exports, 'LocalTaxi', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(LocalTaxi).default;
    }
  });
  Object.defineProperty(exports, 'LocationCity', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(LocationCity).default;
    }
  });
  Object.defineProperty(exports, 'LocationDisabled', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(LocationDisabled).default;
    }
  });
  Object.defineProperty(exports, 'LocationOff', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(LocationOff).default;
    }
  });
  Object.defineProperty(exports, 'LocationOn', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(LocationOn).default;
    }
  });
  Object.defineProperty(exports, 'LocationSearching', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(LocationSearching).default;
    }
  });
  Object.defineProperty(exports, 'Lock', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Lock).default;
    }
  });
  Object.defineProperty(exports, 'LockOpen', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(LockOpen).default;
    }
  });
  Object.defineProperty(exports, 'LockOutline', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(LockOutline).default;
    }
  });
  Object.defineProperty(exports, 'Looks', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Looks).default;
    }
  });
  Object.defineProperty(exports, 'Looks3', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Looks3).default;
    }
  });
  Object.defineProperty(exports, 'Looks4', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Looks4).default;
    }
  });
  Object.defineProperty(exports, 'Looks5', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Looks5).default;
    }
  });
  Object.defineProperty(exports, 'Looks6', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Looks6).default;
    }
  });
  Object.defineProperty(exports, 'LooksOne', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(LooksOne).default;
    }
  });
  Object.defineProperty(exports, 'LooksTwo', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(LooksTwo).default;
    }
  });
  Object.defineProperty(exports, 'Loop', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Loop).default;
    }
  });
  Object.defineProperty(exports, 'Loupe', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Loupe).default;
    }
  });
  Object.defineProperty(exports, 'LowPriority', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(LowPriority).default;
    }
  });
  Object.defineProperty(exports, 'Loyalty', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Loyalty).default;
    }
  });
  Object.defineProperty(exports, 'Mail', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Mail).default;
    }
  });
  Object.defineProperty(exports, 'MailOutline', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(MailOutline).default;
    }
  });
  Object.defineProperty(exports, 'Map', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(_Map).default;
    }
  });
  Object.defineProperty(exports, 'Markunread', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Markunread).default;
    }
  });
  Object.defineProperty(exports, 'MarkunreadMailbox', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(MarkunreadMailbox).default;
    }
  });
  Object.defineProperty(exports, 'Memory', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Memory).default;
    }
  });
  Object.defineProperty(exports, 'Menu', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Menu).default;
    }
  });
  Object.defineProperty(exports, 'MergeType', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(MergeType).default;
    }
  });
  Object.defineProperty(exports, 'Message', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Message).default;
    }
  });
  Object.defineProperty(exports, 'Mic', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Mic).default;
    }
  });
  Object.defineProperty(exports, 'MicNone', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(MicNone).default;
    }
  });
  Object.defineProperty(exports, 'MicOff', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(MicOff).default;
    }
  });
  Object.defineProperty(exports, 'Mms', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Mms).default;
    }
  });
  Object.defineProperty(exports, 'ModeComment', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ModeComment).default;
    }
  });
  Object.defineProperty(exports, 'ModeEdit', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ModeEdit).default;
    }
  });
  Object.defineProperty(exports, 'MonetizationOn', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(MonetizationOn).default;
    }
  });
  Object.defineProperty(exports, 'MoneyOff', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(MoneyOff).default;
    }
  });
  Object.defineProperty(exports, 'MonochromePhotos', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(MonochromePhotos).default;
    }
  });
  Object.defineProperty(exports, 'Mood', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Mood).default;
    }
  });
  Object.defineProperty(exports, 'MoodBad', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(MoodBad).default;
    }
  });
  Object.defineProperty(exports, 'More', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(More).default;
    }
  });
  Object.defineProperty(exports, 'MoreHoriz', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(MoreHoriz).default;
    }
  });
  Object.defineProperty(exports, 'MoreVert', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(MoreVert).default;
    }
  });
  Object.defineProperty(exports, 'Motorcycle', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Motorcycle).default;
    }
  });
  Object.defineProperty(exports, 'Mouse', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Mouse).default;
    }
  });
  Object.defineProperty(exports, 'MoveToInbox', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(MoveToInbox).default;
    }
  });
  Object.defineProperty(exports, 'Movie', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Movie).default;
    }
  });
  Object.defineProperty(exports, 'MovieCreation', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(MovieCreation).default;
    }
  });
  Object.defineProperty(exports, 'MovieFilter', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(MovieFilter).default;
    }
  });
  Object.defineProperty(exports, 'MultilineChart', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(MultilineChart).default;
    }
  });
  Object.defineProperty(exports, 'MusicNote', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(MusicNote).default;
    }
  });
  Object.defineProperty(exports, 'MusicVideo', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(MusicVideo).default;
    }
  });
  Object.defineProperty(exports, 'MyLocation', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(MyLocation).default;
    }
  });
  Object.defineProperty(exports, 'Nature', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Nature).default;
    }
  });
  Object.defineProperty(exports, 'NaturePeople', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(NaturePeople).default;
    }
  });
  Object.defineProperty(exports, 'NavigateBefore', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(NavigateBefore).default;
    }
  });
  Object.defineProperty(exports, 'NavigateNext', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(NavigateNext).default;
    }
  });
  Object.defineProperty(exports, 'Navigation', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Navigation).default;
    }
  });
  Object.defineProperty(exports, 'NearMe', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(NearMe).default;
    }
  });
  Object.defineProperty(exports, 'NetworkCell', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(NetworkCell).default;
    }
  });
  Object.defineProperty(exports, 'NetworkCheck', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(NetworkCheck).default;
    }
  });
  Object.defineProperty(exports, 'NetworkLocked', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(NetworkLocked).default;
    }
  });
  Object.defineProperty(exports, 'NetworkWifi', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(NetworkWifi).default;
    }
  });
  Object.defineProperty(exports, 'NewReleases', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(NewReleases).default;
    }
  });
  Object.defineProperty(exports, 'NextWeek', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(NextWeek).default;
    }
  });
  Object.defineProperty(exports, 'Nfc', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Nfc).default;
    }
  });
  Object.defineProperty(exports, 'NoEncryption', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(NoEncryption).default;
    }
  });
  Object.defineProperty(exports, 'NoSim', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(NoSim).default;
    }
  });
  Object.defineProperty(exports, 'NotInterested', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(NotInterested).default;
    }
  });
  Object.defineProperty(exports, 'Note', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Note).default;
    }
  });
  Object.defineProperty(exports, 'NoteAdd', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(NoteAdd).default;
    }
  });
  Object.defineProperty(exports, 'Notifications', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Notifications).default;
    }
  });
  Object.defineProperty(exports, 'NotificationsActive', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(NotificationsActive).default;
    }
  });
  Object.defineProperty(exports, 'NotificationsNone', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(NotificationsNone).default;
    }
  });
  Object.defineProperty(exports, 'NotificationsOff', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(NotificationsOff).default;
    }
  });
  Object.defineProperty(exports, 'NotificationsPaused', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(NotificationsPaused).default;
    }
  });
  Object.defineProperty(exports, 'OfflinePin', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(OfflinePin).default;
    }
  });
  Object.defineProperty(exports, 'OndemandVideo', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(OndemandVideo).default;
    }
  });
  Object.defineProperty(exports, 'Opacity', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Opacity).default;
    }
  });
  Object.defineProperty(exports, 'OpenInBrowser', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(OpenInBrowser).default;
    }
  });
  Object.defineProperty(exports, 'OpenInNew', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(OpenInNew).default;
    }
  });
  Object.defineProperty(exports, 'OpenWith', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(OpenWith).default;
    }
  });
  Object.defineProperty(exports, 'Pages', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Pages).default;
    }
  });
  Object.defineProperty(exports, 'Pageview', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Pageview).default;
    }
  });
  Object.defineProperty(exports, 'Palette', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Palette).default;
    }
  });
  Object.defineProperty(exports, 'PanTool', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PanTool).default;
    }
  });
  Object.defineProperty(exports, 'Panorama', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Panorama).default;
    }
  });
  Object.defineProperty(exports, 'PanoramaFishEye', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PanoramaFishEye).default;
    }
  });
  Object.defineProperty(exports, 'PanoramaHorizontal', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PanoramaHorizontal).default;
    }
  });
  Object.defineProperty(exports, 'PanoramaVertical', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PanoramaVertical).default;
    }
  });
  Object.defineProperty(exports, 'PanoramaWideAngle', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PanoramaWideAngle).default;
    }
  });
  Object.defineProperty(exports, 'PartyMode', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PartyMode).default;
    }
  });
  Object.defineProperty(exports, 'Pause', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Pause).default;
    }
  });
  Object.defineProperty(exports, 'PauseCircleFilled', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PauseCircleFilled).default;
    }
  });
  Object.defineProperty(exports, 'PauseCircleOutline', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PauseCircleOutline).default;
    }
  });
  Object.defineProperty(exports, 'Payment', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Payment).default;
    }
  });
  Object.defineProperty(exports, 'People', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(People).default;
    }
  });
  Object.defineProperty(exports, 'PeopleOutline', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PeopleOutline).default;
    }
  });
  Object.defineProperty(exports, 'PermCameraMic', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PermCameraMic).default;
    }
  });
  Object.defineProperty(exports, 'PermContactCalendar', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PermContactCalendar).default;
    }
  });
  Object.defineProperty(exports, 'PermDataSetting', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PermDataSetting).default;
    }
  });
  Object.defineProperty(exports, 'PermDeviceInformation', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PermDeviceInformation).default;
    }
  });
  Object.defineProperty(exports, 'PermIdentity', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PermIdentity).default;
    }
  });
  Object.defineProperty(exports, 'PermMedia', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PermMedia).default;
    }
  });
  Object.defineProperty(exports, 'PermPhoneMsg', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PermPhoneMsg).default;
    }
  });
  Object.defineProperty(exports, 'PermScanWifi', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PermScanWifi).default;
    }
  });
  Object.defineProperty(exports, 'Person', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Person).default;
    }
  });
  Object.defineProperty(exports, 'PersonAdd', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PersonAdd).default;
    }
  });
  Object.defineProperty(exports, 'PersonOutline', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PersonOutline).default;
    }
  });
  Object.defineProperty(exports, 'PersonPin', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PersonPin).default;
    }
  });
  Object.defineProperty(exports, 'PersonPinCircle', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PersonPinCircle).default;
    }
  });
  Object.defineProperty(exports, 'PersonalVideo', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PersonalVideo).default;
    }
  });
  Object.defineProperty(exports, 'Pets', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Pets).default;
    }
  });
  Object.defineProperty(exports, 'Phone', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Phone).default;
    }
  });
  Object.defineProperty(exports, 'PhoneAndroid', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PhoneAndroid).default;
    }
  });
  Object.defineProperty(exports, 'PhoneBluetoothSpeaker', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PhoneBluetoothSpeaker).default;
    }
  });
  Object.defineProperty(exports, 'PhoneForwarded', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PhoneForwarded).default;
    }
  });
  Object.defineProperty(exports, 'PhoneInTalk', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PhoneInTalk).default;
    }
  });
  Object.defineProperty(exports, 'PhoneIphone', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PhoneIphone).default;
    }
  });
  Object.defineProperty(exports, 'PhoneLocked', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PhoneLocked).default;
    }
  });
  Object.defineProperty(exports, 'PhoneMissed', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PhoneMissed).default;
    }
  });
  Object.defineProperty(exports, 'PhonePaused', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PhonePaused).default;
    }
  });
  Object.defineProperty(exports, 'Phonelink', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Phonelink).default;
    }
  });
  Object.defineProperty(exports, 'PhonelinkErase', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PhonelinkErase).default;
    }
  });
  Object.defineProperty(exports, 'PhonelinkLock', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PhonelinkLock).default;
    }
  });
  Object.defineProperty(exports, 'PhonelinkOff', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PhonelinkOff).default;
    }
  });
  Object.defineProperty(exports, 'PhonelinkRing', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PhonelinkRing).default;
    }
  });
  Object.defineProperty(exports, 'PhonelinkSetup', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PhonelinkSetup).default;
    }
  });
  Object.defineProperty(exports, 'Photo', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Photo).default;
    }
  });
  Object.defineProperty(exports, 'PhotoAlbum', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PhotoAlbum).default;
    }
  });
  Object.defineProperty(exports, 'PhotoCamera', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PhotoCamera).default;
    }
  });
  Object.defineProperty(exports, 'PhotoFilter', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PhotoFilter).default;
    }
  });
  Object.defineProperty(exports, 'PhotoLibrary', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PhotoLibrary).default;
    }
  });
  Object.defineProperty(exports, 'PhotoSizeSelectActual', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PhotoSizeSelectActual).default;
    }
  });
  Object.defineProperty(exports, 'PhotoSizeSelectLarge', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PhotoSizeSelectLarge).default;
    }
  });
  Object.defineProperty(exports, 'PhotoSizeSelectSmall', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PhotoSizeSelectSmall).default;
    }
  });
  Object.defineProperty(exports, 'PictureAsPdf', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PictureAsPdf).default;
    }
  });
  Object.defineProperty(exports, 'PictureInPicture', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PictureInPicture).default;
    }
  });
  Object.defineProperty(exports, 'PictureInPictureAlt', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PictureInPictureAlt).default;
    }
  });
  Object.defineProperty(exports, 'PieChart', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PieChart).default;
    }
  });
  Object.defineProperty(exports, 'PieChartOutlined', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PieChartOutlined).default;
    }
  });
  Object.defineProperty(exports, 'PinDrop', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PinDrop).default;
    }
  });
  Object.defineProperty(exports, 'Place', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Place).default;
    }
  });
  Object.defineProperty(exports, 'PlayArrow', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PlayArrow).default;
    }
  });
  Object.defineProperty(exports, 'PlayCircleFilled', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PlayCircleFilled).default;
    }
  });
  Object.defineProperty(exports, 'PlayCircleOutline', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PlayCircleOutline).default;
    }
  });
  Object.defineProperty(exports, 'PlayForWork', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PlayForWork).default;
    }
  });
  Object.defineProperty(exports, 'PlaylistAdd', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PlaylistAdd).default;
    }
  });
  Object.defineProperty(exports, 'PlaylistAddCheck', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PlaylistAddCheck).default;
    }
  });
  Object.defineProperty(exports, 'PlaylistPlay', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PlaylistPlay).default;
    }
  });
  Object.defineProperty(exports, 'PlusOne', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PlusOne).default;
    }
  });
  Object.defineProperty(exports, 'Poll', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Poll).default;
    }
  });
  Object.defineProperty(exports, 'Polymer', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Polymer).default;
    }
  });
  Object.defineProperty(exports, 'Pool', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Pool).default;
    }
  });
  Object.defineProperty(exports, 'PortableWifiOff', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PortableWifiOff).default;
    }
  });
  Object.defineProperty(exports, 'Portrait', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Portrait).default;
    }
  });
  Object.defineProperty(exports, 'Power', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Power).default;
    }
  });
  Object.defineProperty(exports, 'PowerInput', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PowerInput).default;
    }
  });
  Object.defineProperty(exports, 'PowerSettingsNew', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PowerSettingsNew).default;
    }
  });
  Object.defineProperty(exports, 'PregnantWoman', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PregnantWoman).default;
    }
  });
  Object.defineProperty(exports, 'PresentToAll', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PresentToAll).default;
    }
  });
  Object.defineProperty(exports, 'Print', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Print).default;
    }
  });
  Object.defineProperty(exports, 'PriorityHigh', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(PriorityHigh).default;
    }
  });
  Object.defineProperty(exports, 'Public', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Public).default;
    }
  });
  Object.defineProperty(exports, 'Publish', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Publish).default;
    }
  });
  Object.defineProperty(exports, 'QueryBuilder', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(QueryBuilder).default;
    }
  });
  Object.defineProperty(exports, 'QuestionAnswer', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(QuestionAnswer).default;
    }
  });
  Object.defineProperty(exports, 'Queue', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Queue).default;
    }
  });
  Object.defineProperty(exports, 'QueueMusic', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(QueueMusic).default;
    }
  });
  Object.defineProperty(exports, 'QueuePlayNext', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(QueuePlayNext).default;
    }
  });
  Object.defineProperty(exports, 'Radio', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Radio).default;
    }
  });
  Object.defineProperty(exports, 'RadioButtonChecked', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(RadioButtonChecked).default;
    }
  });
  Object.defineProperty(exports, 'RadioButtonUnchecked', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(RadioButtonUnchecked).default;
    }
  });
  Object.defineProperty(exports, 'RateReview', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(RateReview).default;
    }
  });
  Object.defineProperty(exports, 'Receipt', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Receipt).default;
    }
  });
  Object.defineProperty(exports, 'RecentActors', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(RecentActors).default;
    }
  });
  Object.defineProperty(exports, 'RecordVoiceOver', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(RecordVoiceOver).default;
    }
  });
  Object.defineProperty(exports, 'Redeem', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Redeem).default;
    }
  });
  Object.defineProperty(exports, 'Redo', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Redo).default;
    }
  });
  Object.defineProperty(exports, 'Refresh', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Refresh).default;
    }
  });
  Object.defineProperty(exports, 'Remove', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Remove).default;
    }
  });
  Object.defineProperty(exports, 'RemoveCircle', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(RemoveCircle).default;
    }
  });
  Object.defineProperty(exports, 'RemoveCircleOutline', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(RemoveCircleOutline).default;
    }
  });
  Object.defineProperty(exports, 'RemoveFromQueue', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(RemoveFromQueue).default;
    }
  });
  Object.defineProperty(exports, 'RemoveRedEye', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(RemoveRedEye).default;
    }
  });
  Object.defineProperty(exports, 'RemoveShoppingCart', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(RemoveShoppingCart).default;
    }
  });
  Object.defineProperty(exports, 'Reorder', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Reorder).default;
    }
  });
  Object.defineProperty(exports, 'Repeat', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Repeat).default;
    }
  });
  Object.defineProperty(exports, 'RepeatOne', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(RepeatOne).default;
    }
  });
  Object.defineProperty(exports, 'Replay', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Replay).default;
    }
  });
  Object.defineProperty(exports, 'Replay10', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Replay10).default;
    }
  });
  Object.defineProperty(exports, 'Replay30', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Replay30).default;
    }
  });
  Object.defineProperty(exports, 'Replay5', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Replay5).default;
    }
  });
  Object.defineProperty(exports, 'Reply', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Reply).default;
    }
  });
  Object.defineProperty(exports, 'ReplyAll', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ReplyAll).default;
    }
  });
  Object.defineProperty(exports, 'Report', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Report).default;
    }
  });
  Object.defineProperty(exports, 'ReportProblem', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ReportProblem).default;
    }
  });
  Object.defineProperty(exports, 'Restaurant', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Restaurant).default;
    }
  });
  Object.defineProperty(exports, 'RestaurantMenu', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(RestaurantMenu).default;
    }
  });
  Object.defineProperty(exports, 'Restore', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Restore).default;
    }
  });
  Object.defineProperty(exports, 'RestorePage', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(RestorePage).default;
    }
  });
  Object.defineProperty(exports, 'RingVolume', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(RingVolume).default;
    }
  });
  Object.defineProperty(exports, 'Room', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Room).default;
    }
  });
  Object.defineProperty(exports, 'RoomService', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(RoomService).default;
    }
  });
  Object.defineProperty(exports, 'Rotate90DegreesCcw', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Rotate90DegreesCcw).default;
    }
  });
  Object.defineProperty(exports, 'RotateLeft', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(RotateLeft).default;
    }
  });
  Object.defineProperty(exports, 'RotateRight', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(RotateRight).default;
    }
  });
  Object.defineProperty(exports, 'RoundedCorner', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(RoundedCorner).default;
    }
  });
  Object.defineProperty(exports, 'Router', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Router).default;
    }
  });
  Object.defineProperty(exports, 'Rowing', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Rowing).default;
    }
  });
  Object.defineProperty(exports, 'RssFeed', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(RssFeed).default;
    }
  });
  Object.defineProperty(exports, 'RvHookup', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(RvHookup).default;
    }
  });
  Object.defineProperty(exports, 'Satellite', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Satellite).default;
    }
  });
  Object.defineProperty(exports, 'Save', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Save).default;
    }
  });
  Object.defineProperty(exports, 'Scanner', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Scanner).default;
    }
  });
  Object.defineProperty(exports, 'Schedule', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Schedule).default;
    }
  });
  Object.defineProperty(exports, 'School', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(School).default;
    }
  });
  Object.defineProperty(exports, 'ScreenLockLandscape', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ScreenLockLandscape).default;
    }
  });
  Object.defineProperty(exports, 'ScreenLockPortrait', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ScreenLockPortrait).default;
    }
  });
  Object.defineProperty(exports, 'ScreenLockRotation', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ScreenLockRotation).default;
    }
  });
  Object.defineProperty(exports, 'ScreenRotation', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ScreenRotation).default;
    }
  });
  Object.defineProperty(exports, 'ScreenShare', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ScreenShare).default;
    }
  });
  Object.defineProperty(exports, 'SdCard', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SdCard).default;
    }
  });
  Object.defineProperty(exports, 'SdStorage', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SdStorage).default;
    }
  });
  Object.defineProperty(exports, 'Search', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Search).default;
    }
  });
  Object.defineProperty(exports, 'Security', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Security).default;
    }
  });
  Object.defineProperty(exports, 'SelectAll', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SelectAll).default;
    }
  });
  Object.defineProperty(exports, 'Send', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Send).default;
    }
  });
  Object.defineProperty(exports, 'SentimentDissatisfied', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SentimentDissatisfied).default;
    }
  });
  Object.defineProperty(exports, 'SentimentNeutral', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SentimentNeutral).default;
    }
  });
  Object.defineProperty(exports, 'SentimentSatisfied', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SentimentSatisfied).default;
    }
  });
  Object.defineProperty(exports, 'SentimentVeryDissatisfied', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SentimentVeryDissatisfied).default;
    }
  });
  Object.defineProperty(exports, 'SentimentVerySatisfied', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SentimentVerySatisfied).default;
    }
  });
  Object.defineProperty(exports, 'Settings', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Settings).default;
    }
  });
  Object.defineProperty(exports, 'SettingsApplications', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SettingsApplications).default;
    }
  });
  Object.defineProperty(exports, 'SettingsBackupRestore', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SettingsBackupRestore).default;
    }
  });
  Object.defineProperty(exports, 'SettingsBluetooth', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SettingsBluetooth).default;
    }
  });
  Object.defineProperty(exports, 'SettingsBrightness', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SettingsBrightness).default;
    }
  });
  Object.defineProperty(exports, 'SettingsCell', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SettingsCell).default;
    }
  });
  Object.defineProperty(exports, 'SettingsEthernet', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SettingsEthernet).default;
    }
  });
  Object.defineProperty(exports, 'SettingsInputAntenna', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SettingsInputAntenna).default;
    }
  });
  Object.defineProperty(exports, 'SettingsInputComponent', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SettingsInputComponent).default;
    }
  });
  Object.defineProperty(exports, 'SettingsInputComposite', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SettingsInputComposite).default;
    }
  });
  Object.defineProperty(exports, 'SettingsInputHdmi', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SettingsInputHdmi).default;
    }
  });
  Object.defineProperty(exports, 'SettingsInputSvideo', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SettingsInputSvideo).default;
    }
  });
  Object.defineProperty(exports, 'SettingsOverscan', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SettingsOverscan).default;
    }
  });
  Object.defineProperty(exports, 'SettingsPhone', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SettingsPhone).default;
    }
  });
  Object.defineProperty(exports, 'SettingsPower', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SettingsPower).default;
    }
  });
  Object.defineProperty(exports, 'SettingsRemote', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SettingsRemote).default;
    }
  });
  Object.defineProperty(exports, 'SettingsSystemDaydream', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SettingsSystemDaydream).default;
    }
  });
  Object.defineProperty(exports, 'SettingsVoice', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SettingsVoice).default;
    }
  });
  Object.defineProperty(exports, 'Share', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Share).default;
    }
  });
  Object.defineProperty(exports, 'Shop', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Shop).default;
    }
  });
  Object.defineProperty(exports, 'ShopTwo', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ShopTwo).default;
    }
  });
  Object.defineProperty(exports, 'ShoppingBasket', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ShoppingBasket).default;
    }
  });
  Object.defineProperty(exports, 'ShoppingCart', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ShoppingCart).default;
    }
  });
  Object.defineProperty(exports, 'ShortText', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ShortText).default;
    }
  });
  Object.defineProperty(exports, 'ShowChart', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ShowChart).default;
    }
  });
  Object.defineProperty(exports, 'Shuffle', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Shuffle).default;
    }
  });
  Object.defineProperty(exports, 'SignalCellular0Bar', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SignalCellular0Bar).default;
    }
  });
  Object.defineProperty(exports, 'SignalCellular1Bar', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SignalCellular1Bar).default;
    }
  });
  Object.defineProperty(exports, 'SignalCellular2Bar', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SignalCellular2Bar).default;
    }
  });
  Object.defineProperty(exports, 'SignalCellular3Bar', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SignalCellular3Bar).default;
    }
  });
  Object.defineProperty(exports, 'SignalCellular4Bar', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SignalCellular4Bar).default;
    }
  });
  Object.defineProperty(exports, 'SignalCellularConnectedNoInternet0Bar', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SignalCellularConnectedNoInternet0Bar).default;
    }
  });
  Object.defineProperty(exports, 'SignalCellularConnectedNoInternet1Bar', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SignalCellularConnectedNoInternet1Bar).default;
    }
  });
  Object.defineProperty(exports, 'SignalCellularConnectedNoInternet2Bar', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SignalCellularConnectedNoInternet2Bar).default;
    }
  });
  Object.defineProperty(exports, 'SignalCellularConnectedNoInternet3Bar', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SignalCellularConnectedNoInternet3Bar).default;
    }
  });
  Object.defineProperty(exports, 'SignalCellularConnectedNoInternet4Bar', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SignalCellularConnectedNoInternet4Bar).default;
    }
  });
  Object.defineProperty(exports, 'SignalCellularNoSim', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SignalCellularNoSim).default;
    }
  });
  Object.defineProperty(exports, 'SignalCellularNull', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SignalCellularNull).default;
    }
  });
  Object.defineProperty(exports, 'SignalCellularOff', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SignalCellularOff).default;
    }
  });
  Object.defineProperty(exports, 'SignalWifi0Bar', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SignalWifi0Bar).default;
    }
  });
  Object.defineProperty(exports, 'SignalWifi1Bar', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SignalWifi1Bar).default;
    }
  });
  Object.defineProperty(exports, 'SignalWifi1BarLock', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SignalWifi1BarLock).default;
    }
  });
  Object.defineProperty(exports, 'SignalWifi2Bar', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SignalWifi2Bar).default;
    }
  });
  Object.defineProperty(exports, 'SignalWifi2BarLock', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SignalWifi2BarLock).default;
    }
  });
  Object.defineProperty(exports, 'SignalWifi3Bar', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SignalWifi3Bar).default;
    }
  });
  Object.defineProperty(exports, 'SignalWifi3BarLock', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SignalWifi3BarLock).default;
    }
  });
  Object.defineProperty(exports, 'SignalWifi4Bar', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SignalWifi4Bar).default;
    }
  });
  Object.defineProperty(exports, 'SignalWifi4BarLock', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SignalWifi4BarLock).default;
    }
  });
  Object.defineProperty(exports, 'SignalWifiOff', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SignalWifiOff).default;
    }
  });
  Object.defineProperty(exports, 'SignalWifiStatusbar1Bar26X24Px', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SignalWifiStatusbar1Bar26X24Px).default;
    }
  });
  Object.defineProperty(exports, 'SignalWifiStatusbar2Bar26X24Px', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SignalWifiStatusbar2Bar26X24Px).default;
    }
  });
  Object.defineProperty(exports, 'SignalWifiStatusbar3Bar26X24Px', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SignalWifiStatusbar3Bar26X24Px).default;
    }
  });
  Object.defineProperty(exports, 'SignalWifiStatusbar4Bar26X24Px', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SignalWifiStatusbar4Bar26X24Px).default;
    }
  });
  Object.defineProperty(exports, 'SignalWifiStatusbarConnectedNoInternet126X24Px', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SignalWifiStatusbarConnectedNoInternet126X24Px).default;
    }
  });
  Object.defineProperty(exports, 'SignalWifiStatusbarConnectedNoInternet226X24Px', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SignalWifiStatusbarConnectedNoInternet226X24Px).default;
    }
  });
  Object.defineProperty(exports, 'SignalWifiStatusbarConnectedNoInternet26X24Px', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SignalWifiStatusbarConnectedNoInternet26X24Px).default;
    }
  });
  Object.defineProperty(exports, 'SignalWifiStatusbarConnectedNoInternet326X24Px', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SignalWifiStatusbarConnectedNoInternet326X24Px).default;
    }
  });
  Object.defineProperty(exports, 'SignalWifiStatusbarConnectedNoInternet426X24Px', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SignalWifiStatusbarConnectedNoInternet426X24Px).default;
    }
  });
  Object.defineProperty(exports, 'SignalWifiStatusbarNotConnected26X24Px', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SignalWifiStatusbarNotConnected26X24Px).default;
    }
  });
  Object.defineProperty(exports, 'SignalWifiStatusbarNull26X24Px', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SignalWifiStatusbarNull26X24Px).default;
    }
  });
  Object.defineProperty(exports, 'SimCard', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SimCard).default;
    }
  });
  Object.defineProperty(exports, 'SimCardAlert', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SimCardAlert).default;
    }
  });
  Object.defineProperty(exports, 'SkipNext', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SkipNext).default;
    }
  });
  Object.defineProperty(exports, 'SkipPrevious', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SkipPrevious).default;
    }
  });
  Object.defineProperty(exports, 'Slideshow', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Slideshow).default;
    }
  });
  Object.defineProperty(exports, 'SlowMotionVideo', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SlowMotionVideo).default;
    }
  });
  Object.defineProperty(exports, 'Smartphone', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Smartphone).default;
    }
  });
  Object.defineProperty(exports, 'SmokeFree', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SmokeFree).default;
    }
  });
  Object.defineProperty(exports, 'SmokingRooms', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SmokingRooms).default;
    }
  });
  Object.defineProperty(exports, 'Sms', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Sms).default;
    }
  });
  Object.defineProperty(exports, 'SmsFailed', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SmsFailed).default;
    }
  });
  Object.defineProperty(exports, 'Snooze', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Snooze).default;
    }
  });
  Object.defineProperty(exports, 'Sort', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Sort).default;
    }
  });
  Object.defineProperty(exports, 'SortByAlpha', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SortByAlpha).default;
    }
  });
  Object.defineProperty(exports, 'Spa', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Spa).default;
    }
  });
  Object.defineProperty(exports, 'SpaceBar', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SpaceBar).default;
    }
  });
  Object.defineProperty(exports, 'Speaker', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Speaker).default;
    }
  });
  Object.defineProperty(exports, 'SpeakerGroup', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SpeakerGroup).default;
    }
  });
  Object.defineProperty(exports, 'SpeakerNotes', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SpeakerNotes).default;
    }
  });
  Object.defineProperty(exports, 'SpeakerNotesOff', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SpeakerNotesOff).default;
    }
  });
  Object.defineProperty(exports, 'SpeakerPhone', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SpeakerPhone).default;
    }
  });
  Object.defineProperty(exports, 'Spellcheck', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Spellcheck).default;
    }
  });
  Object.defineProperty(exports, 'Star', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Star).default;
    }
  });
  Object.defineProperty(exports, 'StarBorder', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(StarBorder).default;
    }
  });
  Object.defineProperty(exports, 'StarHalf', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(StarHalf).default;
    }
  });
  Object.defineProperty(exports, 'Stars', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Stars).default;
    }
  });
  Object.defineProperty(exports, 'StayCurrentLandscape', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(StayCurrentLandscape).default;
    }
  });
  Object.defineProperty(exports, 'StayCurrentPortrait', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(StayCurrentPortrait).default;
    }
  });
  Object.defineProperty(exports, 'StayPrimaryLandscape', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(StayPrimaryLandscape).default;
    }
  });
  Object.defineProperty(exports, 'StayPrimaryPortrait', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(StayPrimaryPortrait).default;
    }
  });
  Object.defineProperty(exports, 'Stop', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Stop).default;
    }
  });
  Object.defineProperty(exports, 'StopScreenShare', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(StopScreenShare).default;
    }
  });
  Object.defineProperty(exports, 'Storage', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Storage).default;
    }
  });
  Object.defineProperty(exports, 'Store', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Store).default;
    }
  });
  Object.defineProperty(exports, 'StoreMallDirectory', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(StoreMallDirectory).default;
    }
  });
  Object.defineProperty(exports, 'Straighten', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Straighten).default;
    }
  });
  Object.defineProperty(exports, 'Streetview', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Streetview).default;
    }
  });
  Object.defineProperty(exports, 'StrikethroughS', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(StrikethroughS).default;
    }
  });
  Object.defineProperty(exports, 'Style', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Style).default;
    }
  });
  Object.defineProperty(exports, 'SubdirectoryArrowLeft', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SubdirectoryArrowLeft).default;
    }
  });
  Object.defineProperty(exports, 'SubdirectoryArrowRight', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SubdirectoryArrowRight).default;
    }
  });
  Object.defineProperty(exports, 'Subject', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Subject).default;
    }
  });
  Object.defineProperty(exports, 'Subscriptions', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Subscriptions).default;
    }
  });
  Object.defineProperty(exports, 'Subtitles', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Subtitles).default;
    }
  });
  Object.defineProperty(exports, 'Subway', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Subway).default;
    }
  });
  Object.defineProperty(exports, 'SupervisorAccount', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SupervisorAccount).default;
    }
  });
  Object.defineProperty(exports, 'SurroundSound', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SurroundSound).default;
    }
  });
  Object.defineProperty(exports, 'SwapCalls', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SwapCalls).default;
    }
  });
  Object.defineProperty(exports, 'SwapHoriz', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SwapHoriz).default;
    }
  });
  Object.defineProperty(exports, 'SwapVert', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SwapVert).default;
    }
  });
  Object.defineProperty(exports, 'SwapVerticalCircle', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SwapVerticalCircle).default;
    }
  });
  Object.defineProperty(exports, 'SwitchCamera', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SwitchCamera).default;
    }
  });
  Object.defineProperty(exports, 'SwitchVideo', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SwitchVideo).default;
    }
  });
  Object.defineProperty(exports, 'Sync', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Sync).default;
    }
  });
  Object.defineProperty(exports, 'SyncDisabled', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SyncDisabled).default;
    }
  });
  Object.defineProperty(exports, 'SyncProblem', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SyncProblem).default;
    }
  });
  Object.defineProperty(exports, 'SystemUpdate', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SystemUpdate).default;
    }
  });
  Object.defineProperty(exports, 'SystemUpdateAlt', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SystemUpdateAlt).default;
    }
  });
  Object.defineProperty(exports, 'Tab', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Tab).default;
    }
  });
  Object.defineProperty(exports, 'TabUnselected', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(TabUnselected).default;
    }
  });
  Object.defineProperty(exports, 'Tablet', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Tablet).default;
    }
  });
  Object.defineProperty(exports, 'TabletAndroid', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(TabletAndroid).default;
    }
  });
  Object.defineProperty(exports, 'TabletMac', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(TabletMac).default;
    }
  });
  Object.defineProperty(exports, 'TagFaces', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(TagFaces).default;
    }
  });
  Object.defineProperty(exports, 'TapAndPlay', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(TapAndPlay).default;
    }
  });
  Object.defineProperty(exports, 'Terrain', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Terrain).default;
    }
  });
  Object.defineProperty(exports, 'TextFields', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(TextFields).default;
    }
  });
  Object.defineProperty(exports, 'TextFormat', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(TextFormat).default;
    }
  });
  Object.defineProperty(exports, 'Textsms', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Textsms).default;
    }
  });
  Object.defineProperty(exports, 'Texture', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Texture).default;
    }
  });
  Object.defineProperty(exports, 'Theaters', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Theaters).default;
    }
  });
  Object.defineProperty(exports, 'ThreeDRotation', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ThreeDRotation).default;
    }
  });
  Object.defineProperty(exports, 'ThumbDown', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ThumbDown).default;
    }
  });
  Object.defineProperty(exports, 'ThumbUp', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ThumbUp).default;
    }
  });
  Object.defineProperty(exports, 'ThumbsUpDown', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ThumbsUpDown).default;
    }
  });
  Object.defineProperty(exports, 'TimeToLeave', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(TimeToLeave).default;
    }
  });
  Object.defineProperty(exports, 'Timelapse', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Timelapse).default;
    }
  });
  Object.defineProperty(exports, 'Timeline', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Timeline).default;
    }
  });
  Object.defineProperty(exports, 'Timer', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Timer).default;
    }
  });
  Object.defineProperty(exports, 'Timer10', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Timer10).default;
    }
  });
  Object.defineProperty(exports, 'Timer3', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Timer3).default;
    }
  });
  Object.defineProperty(exports, 'TimerOff', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(TimerOff).default;
    }
  });
  Object.defineProperty(exports, 'Title', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Title).default;
    }
  });
  Object.defineProperty(exports, 'Toc', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Toc).default;
    }
  });
  Object.defineProperty(exports, 'Today', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Today).default;
    }
  });
  Object.defineProperty(exports, 'Toll', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Toll).default;
    }
  });
  Object.defineProperty(exports, 'Tonality', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Tonality).default;
    }
  });
  Object.defineProperty(exports, 'TouchApp', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(TouchApp).default;
    }
  });
  Object.defineProperty(exports, 'Toys', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Toys).default;
    }
  });
  Object.defineProperty(exports, 'TrackChanges', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(TrackChanges).default;
    }
  });
  Object.defineProperty(exports, 'Traffic', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Traffic).default;
    }
  });
  Object.defineProperty(exports, 'Train', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Train).default;
    }
  });
  Object.defineProperty(exports, 'Tram', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Tram).default;
    }
  });
  Object.defineProperty(exports, 'TransferWithinAStation', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(TransferWithinAStation).default;
    }
  });
  Object.defineProperty(exports, 'Transform', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Transform).default;
    }
  });
  Object.defineProperty(exports, 'Translate', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Translate).default;
    }
  });
  Object.defineProperty(exports, 'TrendingDown', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(TrendingDown).default;
    }
  });
  Object.defineProperty(exports, 'TrendingFlat', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(TrendingFlat).default;
    }
  });
  Object.defineProperty(exports, 'TrendingUp', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(TrendingUp).default;
    }
  });
  Object.defineProperty(exports, 'Tune', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Tune).default;
    }
  });
  Object.defineProperty(exports, 'TurnedIn', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(TurnedIn).default;
    }
  });
  Object.defineProperty(exports, 'TurnedInNot', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(TurnedInNot).default;
    }
  });
  Object.defineProperty(exports, 'Tv', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Tv).default;
    }
  });
  Object.defineProperty(exports, 'Unarchive', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Unarchive).default;
    }
  });
  Object.defineProperty(exports, 'Undo', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Undo).default;
    }
  });
  Object.defineProperty(exports, 'UnfoldLess', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(UnfoldLess).default;
    }
  });
  Object.defineProperty(exports, 'UnfoldMore', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(UnfoldMore).default;
    }
  });
  Object.defineProperty(exports, 'Update', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Update).default;
    }
  });
  Object.defineProperty(exports, 'Usb', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Usb).default;
    }
  });
  Object.defineProperty(exports, 'VerifiedUser', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(VerifiedUser).default;
    }
  });
  Object.defineProperty(exports, 'VerticalAlignBottom', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(VerticalAlignBottom).default;
    }
  });
  Object.defineProperty(exports, 'VerticalAlignCenter', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(VerticalAlignCenter).default;
    }
  });
  Object.defineProperty(exports, 'VerticalAlignTop', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(VerticalAlignTop).default;
    }
  });
  Object.defineProperty(exports, 'Vibration', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Vibration).default;
    }
  });
  Object.defineProperty(exports, 'VideoCall', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(VideoCall).default;
    }
  });
  Object.defineProperty(exports, 'VideoLabel', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(VideoLabel).default;
    }
  });
  Object.defineProperty(exports, 'VideoLibrary', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(VideoLibrary).default;
    }
  });
  Object.defineProperty(exports, 'Videocam', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Videocam).default;
    }
  });
  Object.defineProperty(exports, 'VideocamOff', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(VideocamOff).default;
    }
  });
  Object.defineProperty(exports, 'VideogameAsset', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(VideogameAsset).default;
    }
  });
  Object.defineProperty(exports, 'ViewAgenda', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ViewAgenda).default;
    }
  });
  Object.defineProperty(exports, 'ViewArray', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ViewArray).default;
    }
  });
  Object.defineProperty(exports, 'ViewCarousel', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ViewCarousel).default;
    }
  });
  Object.defineProperty(exports, 'ViewColumn', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ViewColumn).default;
    }
  });
  Object.defineProperty(exports, 'ViewComfy', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ViewComfy).default;
    }
  });
  Object.defineProperty(exports, 'ViewCompact', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ViewCompact).default;
    }
  });
  Object.defineProperty(exports, 'ViewDay', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ViewDay).default;
    }
  });
  Object.defineProperty(exports, 'ViewHeadline', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ViewHeadline).default;
    }
  });
  Object.defineProperty(exports, 'ViewList', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ViewList).default;
    }
  });
  Object.defineProperty(exports, 'ViewModule', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ViewModule).default;
    }
  });
  Object.defineProperty(exports, 'ViewQuilt', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ViewQuilt).default;
    }
  });
  Object.defineProperty(exports, 'ViewStream', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ViewStream).default;
    }
  });
  Object.defineProperty(exports, 'ViewWeek', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ViewWeek).default;
    }
  });
  Object.defineProperty(exports, 'Vignette', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Vignette).default;
    }
  });
  Object.defineProperty(exports, 'Visibility', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Visibility).default;
    }
  });
  Object.defineProperty(exports, 'VisibilityOff', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(VisibilityOff).default;
    }
  });
  Object.defineProperty(exports, 'VoiceChat', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(VoiceChat).default;
    }
  });
  Object.defineProperty(exports, 'Voicemail', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Voicemail).default;
    }
  });
  Object.defineProperty(exports, 'VolumeDown', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(VolumeDown).default;
    }
  });
  Object.defineProperty(exports, 'VolumeMute', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(VolumeMute).default;
    }
  });
  Object.defineProperty(exports, 'VolumeOff', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(VolumeOff).default;
    }
  });
  Object.defineProperty(exports, 'VolumeUp', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(VolumeUp).default;
    }
  });
  Object.defineProperty(exports, 'VpnKey', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(VpnKey).default;
    }
  });
  Object.defineProperty(exports, 'VpnLock', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(VpnLock).default;
    }
  });
  Object.defineProperty(exports, 'Wallpaper', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Wallpaper).default;
    }
  });
  Object.defineProperty(exports, 'Warning', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Warning).default;
    }
  });
  Object.defineProperty(exports, 'Watch', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Watch).default;
    }
  });
  Object.defineProperty(exports, 'WatchLater', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(WatchLater).default;
    }
  });
  Object.defineProperty(exports, 'WbAuto', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(WbAuto).default;
    }
  });
  Object.defineProperty(exports, 'WbCloudy', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(WbCloudy).default;
    }
  });
  Object.defineProperty(exports, 'WbIncandescent', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(WbIncandescent).default;
    }
  });
  Object.defineProperty(exports, 'WbIridescent', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(WbIridescent).default;
    }
  });
  Object.defineProperty(exports, 'WbSunny', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(WbSunny).default;
    }
  });
  Object.defineProperty(exports, 'Wc', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Wc).default;
    }
  });
  Object.defineProperty(exports, 'Web', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Web).default;
    }
  });
  Object.defineProperty(exports, 'WebAsset', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(WebAsset).default;
    }
  });
  Object.defineProperty(exports, 'Weekend', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Weekend).default;
    }
  });
  Object.defineProperty(exports, 'Whatshot', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Whatshot).default;
    }
  });
  Object.defineProperty(exports, 'Widgets', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Widgets).default;
    }
  });
  Object.defineProperty(exports, 'Wifi', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Wifi).default;
    }
  });
  Object.defineProperty(exports, 'WifiLock', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(WifiLock).default;
    }
  });
  Object.defineProperty(exports, 'WifiTethering', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(WifiTethering).default;
    }
  });
  Object.defineProperty(exports, 'Work', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Work).default;
    }
  });
  Object.defineProperty(exports, 'WrapText', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(WrapText).default;
    }
  });
  Object.defineProperty(exports, 'YoutubeSearchedFor', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(YoutubeSearchedFor).default;
    }
  });
  Object.defineProperty(exports, 'ZoomIn', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ZoomIn).default;
    }
  });
  Object.defineProperty(exports, 'ZoomOut', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ZoomOut).default;
    }
  });
  Object.defineProperty(exports, 'ZoomOutMap', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ZoomOutMap).default;
    }
  });

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
});
unwrapExports(lib);
var Icon_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(React);

  var Icons = _interopRequireWildcard(lib);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Icon = function Icon(_ref) {
    var name = _ref.name,
        props = _objectWithoutProperties(_ref, ['name']);

    var Component = Icons[name];
    if (!Component) return false;
    return _react2.default.createElement(Component, props);
  };

  Icon.displayName = 'Icon';
  exports.default = Icon;
});
unwrapExports(Icon_1);
var rmdi = lib;
var Icon = Icon_1;
rmdi.Icon = Icon;

function _templateObject$1() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}

var StyledBox$1 = styled('div')(_templateObject$1());
var Icon$1 = React.forwardRef(function (props, ref) {
  return React.createElement(StyledBox$1, {
    ref: ref
  }, React.createElement(Icon["default"], props));
}); // RmdIcon.default.defaultProps = {
//   theme,
//   color: 'inherit'
// };

StyledBox$1.defaultProps = {
  theme: theme
};
Icon$1.defaultProps = {
  // theme,
  display: 'block',
  size: '24px'
};
Icon$1.propTypes = {
  /**
   * Sets which icon to display
   */
  name: PropTypes.string.isRequired,

  /**
   * Sets the element display property
   */
  display: PropTypes.string,

  /**
   * Sets the width and height in pixels
   */
  size: PropTypes.string,
  theme: PropTypes.object
};
Icon$1.displayName = 'Icon';

function _templateObject$2() {
  var data = _taggedTemplateLiteral(["\n  & {\n    -webkit-font-smoothing: antialiased;\n    appearance: none;\n    user-select: none;\n    white-space: nowrap;\n    text-decoration: none;\n    text-align: center;\n    overflow: hidden;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n\n    padding: ", ";\n  }\n\n  &:hover {\n    cursor: pointer;\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    pointer-events: none;\n  }\n\n  > span.button-text {\n    display: inline-flex;\n  }\n\n  ", "\n  > div > svg,\n  > span.button-text {\n    position: relative;\n    z-index: 1;\n    user-select: none;\n    pointer-events: none;\n  }\n\n  > div > svg {\n    display: block;\n  }\n  > div:first-child > svg {\n    margin-left: -0.5rem;\n    margin-right: .5rem;\n  }\n  > div:last-child > svg {\n    margin-left: .5rem;\n    margin-right: -0.5rem;\n  }\n  > div:first-child:last-child > svg {\n    margin: 0;\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}

var buttonSize = variant({
  prop: 'size',
  key: 'buttonSizes'
});
var mainColor = style({
  prop: 'mainColor',
  cssProperty: '--main-color',
  key: 'colors'
});
var contrastColor = style({
  prop: 'contrastColor',
  cssProperty: '--contrast-color',
  key: 'colors'
});
var StyledButton = styled('button')(_templateObject$2(), function (props) {
  return props.icononly ? '0' : props.p;
}, ''
/* with icon styles */
, COMMON, LAYOUT, POSITION, BORDERS, TYPOGRAPHY, mainColor, contrastColor, buttonStyle, buttonSize);

var ButtonBody = function ButtonBody(_ref) {
  var children = _ref.children,
      icon = _ref.icon,
      iconpos = _ref.iconpos;

  if (icon) {
    return React.createElement(React.Fragment, null, icon && !iconpos && React.createElement(Icon$1, {
      name: icon
    }), icon && iconpos == 'left' && React.createElement(Icon$1, {
      name: icon
    }), children && React.createElement("span", {
      className: "button-text",
      children: children
    }), icon && iconpos == 'right' && React.createElement(Icon$1, {
      name: icon
    }));
  } else {
    return React.createElement("span", {
      className: "button-text",
      children: children
    });
  }
};

var Button = React.forwardRef(function (props, ref) {
  return React.createElement(StyledButton, _extends({}, props, {
    ref: ref
  }));
});
StyledButton.defaultProps = {
  theme: theme
};
Button.defaultProps = {
  // base props
  // variant: 'primary',
  // size: 'medium',
  position: 'relative',
  height: '3rem',
  minWidth: '3rem',
  m: 0,
  px: 4,
  py: 0,
  fontSize: 'inherit',
  fontFamily: 'sansSerif',
  fontWeight: 3,
  lineHeight: 1,
  // color props
  color: 'white',
  bg: 'silver',
  mainColor: 'primary',
  contrastColor: 'white',
  border: 'none'
};
Button.propTypes = _objectSpread2({}, COMMON.propTypes, {}, LAYOUT.propTypes, {}, POSITION.propTypes, {}, BORDERS.propTypes, {}, TYPOGRAPHY.propTypes, {
  /**
   * Sets theme
   */
  theme: PropTypes.object,

  /**
   * Sets background color of button
   */
  mainColor: PropTypes.string,

  /**
   * Sets text color of button
   */
  contrastColor: PropTypes.string,

  /**
   * Sets font and spacing size of button
   */
  size: PropTypes.oneOf(['small', 'medium', 'large']),

  /**
   * Sets icon of button
   */
  icon: PropTypes.string,

  /**
   * Sets icon position on button
   */
  iconpos: PropTypes.oneOf(['left', 'right']),

  /**
   * Sets padding on button with icon and no text
   */
  icononly: PropTypes.bool
});
Button.displayName = 'Button';

function _templateObject$3() {
  var data = _taggedTemplateLiteral(["\n  & {\n    color: var(--main-color);\n    border: none;\n    background: none;\n    box-shadow: none;\n  }\n\n  &:hover {\n    text-decoration: underline;\n    background: none;\n    box-shadow: none;\n  }\n\n  &:active {\n    text-decoration: none;\n  }\n\n  &::before {\n    display: none;\n  }\n"]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}

var StyledTextButton = styled(StyledButton)(_templateObject$3());
var TextButton = React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      icon = _ref.icon,
      iconpos = _ref.iconpos,
      props = _objectWithoutProperties(_ref, ["children", "icon", "iconpos"]);

  return React.createElement(StyledTextButton, _extends({}, props, {
    ref: ref
  }), React.createElement(ButtonBody, {
    icon: icon,
    iconpos: iconpos,
    children: children
  }));
});
TextButton.defaultProps = _objectSpread2({}, Button.defaultProps, {
  px: 2
});

function _templateObject$4() {
  var data = _taggedTemplateLiteral(["\n  & {\n    color: var(--contrast-color);\n    ", "\n    background: #FFF;\n    z-index: 0;\n    transition: all 0.15s ease;\n  }\n\n  &:hover {\n    text-decoration: inherit;\n    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);\n  }\n\n  &:hover::before {\n    opacity: 0.9;\n  }\n\n  &:active {\n    box-shadow: none;\n    background: #000;\n  }\n\n  &::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    z-index: 1;\n    height: 100%;\n    width: 100%;\n    background: var(--main-color);\n    pointer-events: none;\n  }\n"]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}

var StyledSolidButton = styled(StyledButton)(_templateObject$4(), ''
/* background: var(--main-color); */
);
var SolidButton = React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      icon = _ref.icon,
      iconpos = _ref.iconpos,
      props = _objectWithoutProperties(_ref, ["children", "icon", "iconpos"]);

  return React.createElement(StyledSolidButton, _extends({}, props, {
    ref: ref
  }), React.createElement(ButtonBody, {
    icon: icon,
    iconpos: iconpos,
    children: children
  }));
});
SolidButton.defaultProps = _objectSpread2({}, Button.defaultProps, {
  borderRadius: 1,
  boxShadow: 1
});

function _templateObject$5() {
  var data = _taggedTemplateLiteral(["\n  & {\n    color: var(--main-color);\n    background: transparent;\n  }\n\n  &:hover {\n    border-color: var(--main-color);\n  }\n\n  &:hover::before {\n    opacity: 0;\n  }\n\n  &:active {\n    background: #fff;\n  }\n\n  &:active::before {\n    opacity: 0.1;\n  }\n\n  &::before {\n    opacity: 0;\n  }\n"]);

  _templateObject$5 = function _templateObject() {
    return data;
  };

  return data;
}

var StyledOutlineButton = styled(StyledSolidButton)(_templateObject$5());
var OutlineButton = React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      icon = _ref.icon,
      iconpos = _ref.iconpos,
      props = _objectWithoutProperties(_ref, ["children", "icon", "iconpos"]);

  return React.createElement(StyledOutlineButton, _extends({}, props, {
    ref: ref
  }), React.createElement(ButtonBody, {
    icon: icon,
    iconpos: iconpos,
    children: children
  }));
});
OutlineButton.defaultProps = _objectSpread2({}, SolidButton.defaultProps, {
  border: 1,
  borderColor: 'grey',
  boxShadow: 0
});
var Button$1; // solid style

Button$1 = SolidButton;
Button$1.displayName = 'Button'; // outline style

Button$1.Outline = OutlineButton;
Button$1.Outline.displayName = 'Button.Outline'; // text style

Button$1.Text = TextButton;
Button$1.Text.displayName = 'Button.Text'; // base style

Button$1.Base = Button;
Button$1.Base.displayName = 'Button.Base';
var Button$2 = Button$1;

function _templateObject$6() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n\n  ", "\n  ", "\n"]);

  _templateObject$6 = function _templateObject() {
    return data;
  };

  return data;
}

var caps = function caps(props) {
  return props.caps ? {
    textTransform: 'uppercase'
  } : null;
};

var italic = function italic(props) {
  return props.italic ? {
    fontStyle: 'italic'
  } : null;
};

var StyledText = styled(Box)(_templateObject$6(), TYPOGRAPHY, COMMON, display, caps, italic);
var Text = React.forwardRef(function (props, ref) {
  return React.createElement(StyledText, _extends({
    ref: ref
  }, props));
});
StyledText.defaultProps = {
  theme: theme
};
Text.defaultProps = {
  // theme,
  color: 'copyColor',
  fontFamily: 'sansSerif',
  fontSize: 2,
  fontWeight: 2,
  lineHeight: 'copy',
  textAlign: 'left'
};
Text.propTypes = _objectSpread2({}, TYPOGRAPHY.propTypes, {}, Box.propTypes, {}, display.propTypes, {
  theme: PropTypes.object
});
Text.displayName = 'Text';

Text.span = function (props) {
  return React.createElement(Text, props);
};

Text.span.defaultProps = _objectSpread2({}, Text.defaultProps, {
  as: 'span'
});

Text.p = function (props) {
  return React.createElement(Text, props);
};

Text.p.defaultProps = _objectSpread2({}, Text.defaultProps, {
  as: 'p'
});

Text.s = function (props) {
  return React.createElement(Text, props);
};

Text.s.defaultProps = _objectSpread2({}, Text.defaultProps, {
  as: 's'
});

function _templateObject$7() {
  var data = _taggedTemplateLiteral(["\n  & {\n    text-decoration: none;\n    cursor: pointer;\n  }\n\n  &:hover {\n    text-decoration: underline;\n    ", ";\n  }\n\n  &:active {\n    text-decoration: none;\n    ", ";\n  }\n"]);

  _templateObject$7 = function _templateObject() {
    return data;
  };

  return data;
}

var hoverColor = style({
  prop: 'hoverColor',
  cssProperty: 'color',
  key: 'colors'
});
var activeColor = style({
  prop: 'activeColor',
  cssProperty: 'color',
  key: 'colors'
});
var StyledLink = styled(Text)(_templateObject$7(), hoverColor, activeColor);
var Link$1 = React.forwardRef(function (props, ref) {
  return React.createElement(StyledLink, _extends({
    ref: ref
  }, props));
});
StyledLink.defaultProps = {
  theme: theme
};
Link$1.defaultProps = {
  // theme,
  forwardedAs: 'a',
  color: 'primary',
  hoverColor: 'primary-light',
  activeColor: 'primary-dark',
  fontSize: 1,
  fontWeight: 3
};
Link$1.propTypes = _objectSpread2({}, Text.propTypes, {
  theme: PropTypes.object
});
Link$1.displayName = 'Link';

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  & {\n    cursor: pointer;\n  }\n  &:hover {\n    color: inherit;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$8() {
  var data = _taggedTemplateLiteral(["\n  ", "\n\n  & {\n    position: relative;\n  }\n"]);

  _templateObject$8 = function _templateObject() {
    return data;
  };

  return data;
}

var lastId = 0;

var newID = function newID() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'id';
  return "".concat(prefix).concat(lastId++);
};

var flashVariant = variant({
  key: 'messageStyle'
});
var StyledFlash = styled(Box)(_templateObject$8(), flashVariant);
var StyledLink$1 = styled(Link$1).attrs(function (props) {
  return {
    color: 'inherit',
    fontSize: 'inherit'
  };
})(_templateObject2());
var Flash = React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "children"]);

  var status = props.variant;
  var id = newID('Flash');
  var contentID = "".concat(id, "Content");
  var ariaRoleType = 'status';

  switch (status) {
    case 'warning':
      ariaRoleType = 'alert';
      break;

    case 'danger':
      ariaRoleType = 'alert';
      break;

    default: // invalid status

  }

  return React.createElement(StyledFlash, _extends({
    className: className,
    tabIndex: 0,
    role: ariaRoleType,
    "aria-live": "polite",
    "aria-describedby": contentID,
    ref: ref
  }, props), React.createElement(Text, {
    color: 'inherit',
    display: 'inherit',
    id: contentID
  }, children));
});
Flash.defaultProps = {
  theme: theme,
  variant: 'base',
  p: '3',
  border: '1',
  borderRadius: 1,
  width: '100%'
};
Flash.propTypes = _objectSpread2({
  /**
   * Sets the colors of the background, text and links
   */
  variant: PropTypes.oneOf(['base', 'success', 'warning', 'danger', 'info'])
}, Box.propTypes);
Flash.displayName = 'Flash';
Flash.Link = StyledLink$1;
Flash.Link.displayName = 'Flash.Link';

function _templateObject2$1() {
  var data = _taggedTemplateLiteral(["\n  & {\n    display: inline-block;\n    position: relative;\n    cursor: pointer;\n  }\n"]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$9() {
  var data = _taggedTemplateLiteral(["\n  & {\n    width: 0;\n    height: 0;\n    opacity: 0;\n    position: absolute;\n    overflow: hidden;\n    z-index: -1;\n  }\n"]);

  _templateObject$9 = function _templateObject() {
    return data;
  };

  return data;
}

var StyledFileInput = styled('input')(_templateObject$9());
var StyledFileLabel = styled('label')(_templateObject2$1());

var FileInput =
/*#__PURE__*/
function (_Component) {
  _inherits(FileInput, _Component);

  function FileInput(props) {
    var _this;

    _classCallCheck(this, FileInput);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FileInput).call(this, props));

    _this.handleClick = function (e) {
      _this.fileInput.current.click();
    };

    _this.handleChange = function (e) {
      var files = _this.fileInput.current.files;

      _this.setState({
        files: files.length ? true : false
      });

      if (files && files.length > 1) {
        _this.setState({
          buttonLabel: files.length + ' files selected'
        });
      } else if (files && files.length) {
        _this.setState({
          buttonLabel: files[0].name
        });
      } else {
        _this.setState({
          buttonLabel: 'Choose file…'
        });
      }

      if (_this.props.onChange) {
        _this.props.onChange(e);
      }
    };

    _this.fileInput = React.createRef();
    _this.state = {
      buttonLabel: 'Choose file…',
      files: false
    };
    return _this;
  }

  _createClass(FileInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          variant = _this$props.variant,
          props = _objectWithoutProperties(_this$props, ["variant"]);

      if (variant === 'unstyled') {
        return React.createElement("input", _extends({
          type: 'file'
        }, props));
      }

      return React.createElement(StyledFileLabel, null, React.createElement(StyledFileInput, _extends({
        type: 'file'
      }, props, {
        ref: this.fileInput,
        onChange: this.handleChange
      })), React.createElement(Button$2, {
        icon: this.state.files ? 'CloudDone' : 'CloudUpload',
        onClick: this.handleClick
      }, this.state.buttonLabel));
    }
  }]);

  return FileInput;
}(Component);

FileInput.displayName = 'FileInput';

function _templateObject2$2() {
  var data = _taggedTemplateLiteral(["\n  & {\n    position: relative;\n    display: flex;\n    align-items: center;\n    width: 100%;\n  }\n  > ", " {\n    padding-right: 3rem;\n    text-overflow: ellipsis;\n    white-space: no-wrap;\n  }\n  > svg {\n    position: absolute;\n    right: 1rem;\n    visibility: hidden;\n  }\n"]);

  _templateObject2$2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$a() {
  var data = _taggedTemplateLiteral(["\n  & {\n    appearance: none;\n    box-sizing: border-box;\n  }\n\n  &:hover {\n    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.3);\n  }\n\n  &:focus {\n    outline: none;\n    border-color: ", ";\n  }\n\n  &:disabled {\n    opacity: 0.4;\n    pointer-events: none;\n  }\n\n  .was-validated & {\n    &:valid {\n      border-color: ", ";\n    }\n    &:valid ~ svg.icon-valid {\n      visibility: visible;\n    }\n    &:invalid {\n      border-color: ", ";\n    }\n    &:invalid ~ svg.icon-invalid {\n      visibility: visible;\n    }\n  }}\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject$a = function _templateObject() {
    return data;
  };

  return data;
}

var StyledInput = styled.input(_templateObject$a(), themeGet('colors.primary', '#000'), themeGet('colors.success'), themeGet('colors.danger'), COMMON, LAYOUT, POSITION, FLEXBOX, BORDERS, TYPOGRAPHY);
var StyledIconWrapper = styled.div(_templateObject2$2(), StyledInput);
var WithValidationStyle = React.forwardRef(function (props, ref) {
  var colorSuccess = themeGet('colors.success')(props);
  var colorError = themeGet('colors.danger')(props);
  return React.createElement(StyledIconWrapper, null, React.createElement(StyledInput, _extends({}, props, {
    ref: ref
  })), React.createElement(IconCheckCircle, {
    className: 'icon-valid',
    color: colorSuccess
  }), React.createElement(IconWarning, {
    className: 'icon-invalid',
    color: colorError
  }));
});
var Input$1 = React.forwardRef(function (props, ref) {
  if (props.type === 'file') {
    return React.createElement(FileInput, _extends({}, props, {
      ref: ref
    }));
  } else {
    return React.createElement(StyledInput, _extends({}, props, {
      ref: ref
    }));
  }
});
var defaultProps = {
  theme: theme,
  color: 'copyColor',
  bg: 'white',
  fontFamily: 'sansSerif',
  fontSize: '1rem',
  lineHeight: 'solid',
  height: '3rem',
  p: 3,
  border: 1,
  borderColor: 'grey',
  borderRadius: 1,
  boxShadow: 1
};
Input$1.WithValidationStyle = WithValidationStyle;
Input$1.defaultProps = defaultProps;
WithValidationStyle.defaultProps = defaultProps;
StyledInput.defaultProps = defaultProps;
Input$1.propTypes = _objectSpread2({}, Box.propTypes, {
  theme: PropTypes.object
});
Input$1.displayName = 'Input';

function _templateObject$b() {
  var data = _taggedTemplateLiteral(["\n  &:after {\n    content: ' (optional)';\n    font-weight: normal;\n    font-style: italic;\n  }\n"]);

  _templateObject$b = function _templateObject() {
    return data;
  };

  return data;
}

var OptionalLabel = styled(Text)(_templateObject$b());
var Field = React.forwardRef(function (_ref, ref) {
  var label = _ref.label,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["label", "children"]);

  var isRequired = function isRequired(children) {
    var value = false;
    React.Children.forEach(children, function (child) {
      if (child.props.required) {
        value = true;
      }
    });
    return value;
  };

  var renderLabel = function renderLabel(required) {
    if (required) {
      return React.createElement(Text, {
        fontSize: 1,
        fontWeight: 3,
        mb: 2
      }, label);
    } else {
      return React.createElement(OptionalLabel, {
        fontSize: 1,
        fontWeight: 3,
        mb: 2
      }, label);
    }
  };

  return React.createElement(Box, _extends({
    as: 'label',
    display: 'inline-flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    mb: 3,
    ref: ref
  }, props), renderLabel(isRequired(children)), children);
});
Field.propTypes = {
  // ...Box.propTypes,
  label: PropTypes.string.isRequired,
  children: PropTypes.element.isRequired
};
Field.displayName = 'Field';

function _templateObject2$3() {
  var data = _taggedTemplateLiteral(["\n  & {\n    cursor: pointer;\n  }\n  &:hover input:not(:disabled) ~ svg[name='unchecked'] {\n    fill: ", ";\n  }\n"]);

  _templateObject2$3 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$c() {
  var data = _taggedTemplateLiteral(["\n  & {\n    position: relative;\n    display: inline-block;\n  }\n\n  > input {\n    cursor: pointer;\n    appearance: none;\n    position: relative;\n    z-index: 1;\n    display: block;\n    height: 1.5rem;\n    width: 1.5rem;\n    margin: 0;\n  }\n\n  > svg {\n    position: absolute;\n    z-index: 0;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    height: 100%;\n    width: 100%;\n    pointer-events: none;\n    fill: ", ";\n  }\n\n  > svg[name='checked'] {\n    display: none;\n    z-index: 1;\n    fill: ", ";\n  }\n\n  > input:checked ~ svg[name='checked'] {\n    display: block;\n  }\n"]);

  _templateObject$c = function _templateObject() {
    return data;
  };

  return data;
}

var StyledWrapper = styled(Box)(_templateObject$c(), function (props) {
  return themeGet('colors.grey', '#CCC');
}, function (props) {
  return themeGet('colors.primary', '#000');
});
var StyledLabel = styled(Box)(_templateObject2$3(), function (props) {
  return themeGet('colors.primary', '#000');
});
var Checkbox = React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
      label = _ref.label,
      name = _ref.name,
      value = _ref.value,
      id = _ref.id,
      props = _objectWithoutProperties(_ref, ["className", "label", "name", "value", "id"]);

  return React.createElement(StyledLabel, _extends({
    forwardedAs: 'label',
    display: 'flex',
    alignItems: 'center',
    className: className
  }, props, {
    htmlFor: id,
    opacity: props.disabled ? 0.4 : 1
  }), React.createElement(StyledWrapper, {
    theme: props.theme
  }, React.createElement("input", _extends({
    type: 'checkbox',
    name: name,
    value: value,
    id: id,
    ref: ref
  }, props)), React.createElement(IconChecked, {
    name: 'checked'
  }), React.createElement(IconUnChecked, {
    name: 'unchecked'
  })), React.createElement(Text, {
    fontSize: 1,
    fontWeight: 3,
    lineHeight: 1,
    ml: 1,
    mr: 2
  }, label));
});
StyledWrapper.defaultProps = {
  theme: theme
};
Checkbox.defaultProps = {
  color: 'primary'
};
Checkbox.propTypes = _objectSpread2({}, Box.propTypes, {
  theme: PropTypes.object,
  label: PropTypes.string
});
Checkbox.displayName = 'Checkbox';

var Form =
/*#__PURE__*/
function (_Component) {
  _inherits(Form, _Component);

  function Form() {
    _classCallCheck(this, Form);

    return _possibleConstructorReturn(this, _getPrototypeOf(Form).apply(this, arguments));
  }

  _createClass(Form, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          validated = _this$props.validated;

      if (validated) {
        className += ' was-validated';
      }

      return React.createElement(Box, _extends({
        as: 'form',
        className: className
      }, this.props), children);
    }
  }]);

  return Form;
}(Component);

Form.defaultProps = {
  validated: false
};
Form.propTypes = _objectSpread2({}, Box.propTypes, {
  /**
   * Shows the input validation styles when true by adding he `.was-validated` class to the form element.
   */
  validated: PropTypes.bool
});
Form.displayName = 'Form';
Form.Input = Input$1.WithValidationStyle;
Form.Field = Field;
Form.Check = Checkbox;

function _extends$2() {
  _extends$2 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$2.apply(this, arguments);
}

function _objectWithoutProperties$1(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$1(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.49 3.5L1.492.5l-1 3 2 8.5 18.995-.5 2-8-1.5-3-6.499 3H8.49z",
  fill: "#763D16"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.99 12h10.998v7H6.99v-7z",
  fill: "#333"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#333",
  d: "M7.99 17h5.998v3H7.99z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1.581 10.664a.609.609 0 01.126.585l-1.484 4.59a.517.517 0 000 .356l1.296 4.445c.104.334.438.522.752.417l4.452-1.231c.188-.063.397 0 .564.125l.773.626c.021.021.021.021.042.021l1.923 1.336c.104.062.23.104.355.104H13.6c.125 0 .25-.042.355-.104l1.923-1.336c.02 0 .02-.02.042-.02l.773-.627a.663.663 0 01.564-.125l4.452 1.231c.335.084.669-.104.753-.417l1.295-4.445a.517.517 0 000-.355l-1.483-4.591a.599.599 0 01.125-.585l1.588-7.116a.536.536 0 00-.02-.313L23.024.417c-.105-.334-.48-.5-.815-.375l-6.94 2.587a.744.744 0 01-.208.042H8.917c-.083 0-.146-.02-.209-.042L1.77.042c-.334-.126-.71.041-.815.375l-.92 2.818a.524.524 0 00-.02.313l1.567 7.116zm12.415 3.59l.522-1.085c.063-.126.23-.188.356-.126l1.254.564c.23.104.209.438-.042.522l-1.756.521a.285.285 0 01-.334-.396zm-.104-7.534c-.126-.105-.126-.313.02-.397l7.9-5.405a.252.252 0 01.377.125l.982 2.692c.021.042.021.084 0 .147l-1.61 6.198a.226.226 0 01-.292.146l-4.347-1.169c-.042 0-.063-.02-.084-.042L13.891 6.72zm-3.825 12.814l.146-1.21c0-.063.042-.126.105-.168l.292-.208c.042-.021.084-.042.126-.042h2.466c.042 0 .104.02.125.042l.293.208c.063.042.083.105.104.167l.126 1.21a.243.243 0 01-.23.272h-3.344c-.105 0-.21-.125-.21-.271zM7.85 13.607l1.254-.564a.27.27 0 01.356.126l.522 1.085c.105.208-.104.438-.334.375l-1.777-.521c-.23-.063-.25-.397-.02-.501zM.808 3.86c-.021-.042 0-.105 0-.146l.982-2.672c.063-.146.251-.208.376-.125l7.9 5.405a.244.244 0 01.022.397L7.14 9.015a.159.159 0 01-.084.042L2.71 10.226a.226.226 0 01-.293-.146L.807 3.86z",
  fill: "#F36D34"
});

var SvgIcon = function SvgIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties$1(_ref, ["svgRef"]);

  return React.createElement("svg", _extends$2({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcon, _extends$2({
    svgRef: ref
  }, props));
});

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  & {\n    color: #333;\n    background: ", ";\n    border: 1px solid #ccc;\n  }\n  &:hover {\n    background-color: #f3f2f2;\n  }\n  &:active {\n    background-color: #e4e4e4;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$4() {
  var data = _taggedTemplateLiteral(["\n  & {\n    color: ", ";\n    background: ", ";\n  }\n  &:hover {\n    background-color: ", ";\n  }\n  &:active {\n    background-color: ", ";\n  }\n"]);

  _templateObject2$4 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$d() {
  var data = _taggedTemplateLiteral(["\n  & {\n    transition: all 0.15s ease;\n  }\n\n  &:hover {\n    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);\n  }\n\n  && > svg.r-ff-icon {\n    height: ", ";\n    width: ", ";\n    margin-right: 0.5rem;\n    margin-bottom: -2px;\n  }\n"]);

  _templateObject$d = function _templateObject() {
    return data;
  };

  return data;
}

var brandColors = {
  baseColor: '#000',
  hoverColor: '#4c4c4c',
  activeColor: '#999',
  foregroundColor: '#FFFFFF'
};
var MMStyledButton = styled(StyledButton)(_templateObject$d(), function (props) {
  return props.size === 'small' ? '1rem' : '1.5rem';
}, function (props) {
  return props.size === 'small' ? '1rem' : '1.5rem';
});
var StyledButtonSolid = styled(MMStyledButton)(_templateObject2$4(), brandColors.foregroundColor, brandColors.baseColor, brandColors.hoverColor, brandColors.activeColor);
var StyledButtonOutline = styled(MMStyledButton)(_templateObject3(), brandColors.foregroundColor);

var ButtonBody$1 = function ButtonBody(_ref) {
  var children = _ref.children,
      size = _ref.size;
  return React.createElement(React.Fragment, null, React.createElement(ForwardRef, {
    className: 'r-ff-icon',
    size: size
  }), children);
};

var MetaMaskButtonSolid = function MetaMaskButtonSolid(_ref2) {
  var className = _ref2.className,
      children = _ref2.children,
      props = _objectWithoutProperties(_ref2, ["className", "children"]);

  return React.createElement(StyledButtonSolid, _extends({
    className: className
  }, props), React.createElement(ButtonBody$1, {
    children: children,
    size: props.size
  }));
};

var MetaMaskButtonOutline = function MetaMaskButtonOutline(_ref3) {
  var className = _ref3.className,
      children = _ref3.children,
      props = _objectWithoutProperties(_ref3, ["className", "children"]);

  return React.createElement(StyledButtonOutline, _extends({
    className: className
  }, props), React.createElement(ButtonBody$1, {
    children: children,
    size: props.size
  }));
};

var defaultProps$1 = _objectSpread2({}, Button.defaultProps, {
  width: 'auto',
  borderRadius: 1,
  boxShadow: 1
});

MetaMaskButtonSolid.defaultProps = defaultProps$1;
MetaMaskButtonOutline.defaultProps = defaultProps$1;
var MetaMaskButton;
MetaMaskButton = MetaMaskButtonSolid;
MetaMaskButton.Solid = MetaMaskButtonSolid;
MetaMaskButton.Outline = MetaMaskButtonOutline;
MetaMaskButton.propTypes = _objectSpread2({}, Button.propTypes);
MetaMaskButton.displayName = 'MetaMaskButton';
var MetaMaskButton$1 = MetaMaskButton;

function _extends$3() {
  _extends$3 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$3.apply(this, arguments);
}

function _objectWithoutProperties$2(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$2(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose$2(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var _ref2$1 =
/*#__PURE__*/
React.createElement("path", {
  d: "M22.842 17.08L12.839 1.458a.997.997 0 00-1.678 0L1.159 17.08a.993.993 0 00.466 1.458l10.003 4.032a.997.997 0 00.746 0l10.003-4.032a.993.993 0 00.466-1.458zM12 8.628a3.33 3.33 0 013.331 3.331A3.33 3.33 0 0112 15.291a3.33 3.33 0 110-6.663zm4.767 9.506c-.963.43-2.566.722-4.407.758h-.007c-.115.003-.234.003-.353.003h-.006c-.12 0-.235 0-.354-.003h-.006c-1.838-.036-3.444-.328-4.408-.758-1.355-.515-2.203-1.24-2.203-2.05 0-.98 1.246-1.84 3.132-2.342.086.19.186.37.298.543-1.799.453-2.827 1.205-2.827 1.802 0 .286.235.607.675.913.235-.633 1.632-1.16 3.543-1.392.63.373 1.366.592 2.15.592a4.22 4.22 0 002.149-.591c1.911.23 3.308.758 3.543 1.39.44-.305.675-.626.675-.912 0-.597-1.025-1.349-2.827-1.802.112-.174.212-.353.298-.543 1.886.504 3.133 1.365 3.133 2.342.006.81-.842 1.535-2.198 2.05z"
});

var SvgIcon$1 = function SvgIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties$2(_ref, ["svgRef"]);

  return React.createElement("svg", _extends$3({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "#5C4BCD",
    ref: svgRef
  }, props), _ref2$1);
};

var ForwardRef$1 = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcon$1, _extends$3({
    svgRef: ref
  }, props));
});

function _templateObject3$1() {
  var data = _taggedTemplateLiteral(["\n  & {\n    color: #333;\n    background: ", ";\n    border: 1px solid #ccc;\n  }\n  &:hover {\n    background-color: #f3f2f2;\n  }\n  &:active {\n    background-color: #e4e4e4;\n  }\n"]);

  _templateObject3$1 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$5() {
  var data = _taggedTemplateLiteral(["\n  & {\n    color: ", ";\n    background: ", ";\n  }\n  &:hover {\n    background-color: ", ";\n  }\n  &:active {\n    background-color: ", ";\n  }\n  > svg:first-child {\n    fill: ", ";\n  }\n"]);

  _templateObject2$5 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$e() {
  var data = _taggedTemplateLiteral(["\n  & {\n    transition: all 0.15s ease;\n  }\n\n  &:hover {\n    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);\n  }\n\n  && > svg.r-up-icon {\n    height: ", ";\n    width: ", ";\n    margin-right: 0.5rem;\n  }\n"]);

  _templateObject$e = function _templateObject() {
    return data;
  };

  return data;
}

var brandColors$1 = {
  baseColor: '#5c50ca',
  hoverColor: curriedTint(0.1, '#5c50ca'),
  activeColor: curriedShade(0.1, '#5c50ca'),
  foregroundColor: '#FFFFFF'
};
var UPStyledButton = styled(StyledButton)(_templateObject$e(), function (props) {
  return props.size === 'small' ? '16px' : '24px';
}, function (props) {
  return props.size === 'small' ? '16px' : '24px';
});
var StyledButtonSolid$1 = styled(UPStyledButton)(_templateObject2$5(), brandColors$1.foregroundColor, brandColors$1.baseColor, brandColors$1.hoverColor, brandColors$1.activeColor, brandColors$1.foregroundColor);
var StyledButtonOutline$1 = styled(UPStyledButton)(_templateObject3$1(), brandColors$1.foregroundColor);

var ButtonBody$2 = function ButtonBody(_ref) {
  var children = _ref.children,
      size = _ref.size;
  return React.createElement(React.Fragment, null, React.createElement(ForwardRef$1, {
    className: 'r-up-icon',
    size: size
  }), children);
};

var UPortButtonSolid = function UPortButtonSolid(_ref2) {
  var className = _ref2.className,
      children = _ref2.children,
      props = _objectWithoutProperties(_ref2, ["className", "children"]);

  return React.createElement(StyledButtonSolid$1, _extends({
    className: className
  }, props), React.createElement(ButtonBody$2, {
    children: children,
    size: props.size
  }));
};

var UPortButtonOutline = function UPortButtonOutline(_ref3) {
  var className = _ref3.className,
      children = _ref3.children,
      props = _objectWithoutProperties(_ref3, ["className", "children"]);

  return React.createElement(StyledButtonOutline$1, _extends({
    className: className
  }, props), React.createElement(ButtonBody$2, {
    children: children,
    size: props.size
  }));
};

var defaultProps$2 = _objectSpread2({}, Button.defaultProps, {
  width: [1, 'auto'],
  borderRadius: 1,
  boxShadow: 1
});

UPortButtonSolid.defaultProps = defaultProps$2;
UPortButtonOutline.defaultProps = defaultProps$2;
var UPortButton;
UPortButton = UPortButtonOutline;
UPortButton.Solid = UPortButtonSolid;
UPortButton.Outline = UPortButtonOutline;
UPortButton.propTypes = _objectSpread2({}, Button.propTypes);
UPortButton.displayName = 'UPortButton';
var UPortButton$1 = UPortButton;

function _templateObject$f() {
  var data = _taggedTemplateLiteral(["\n  & {\n    position: relative;\n    overflow: hidden;\n    border-radius: 100%;\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n    background-image: url(", ");\n  }\n\n  ", "\n"]);

  _templateObject$f = function _templateObject() {
    return data;
  };

  return data;
}

var size$1 = function size(props) {
  switch (props.size) {
    case 'small':
      return "\n        height: 2em;\n        width: 2em;\n      ";

    case 'medium':
      return "\n        height: 3em;\n        width: 3em;\n      ";

    case 'large':
      return "\n        height: 4em;\n        width: 4em;\n      ";

    default:
      return "";
  }
};

var StyledAvatar = styled(Box)(_templateObject$f(), function (props) {
  return props.src;
}, size$1);
StyledAvatar.defaultProps = {
  theme: theme
};
var Avatar = React.forwardRef(function (props, ref) {
  return React.createElement(StyledAvatar, _extends({
    ref: ref
  }, props));
});
Avatar.defaultProps = {
  size: '2rem',
  bg: 'grey',
  alt: 'Avatar'
};
Avatar.propTypes = _objectSpread2({
  /**
   * Sets alt attribute on image for accessibility
   */
  alt: PropTypes.string,

  /**
   * Sets avatar height and width
   */
  size: PropTypes.string,

  /**
   * Sets avatar image
   */
  src: PropTypes.string.isRequired,

  /**
   * Sets theme
   */
  theme: PropTypes.object
}, Box.propTypes);
Avatar.displayName = 'Avatar';
var blockies = createCommonjsModule(function (module) {
  (function () {
    // The random number is a js implementation of the Xorshift PRNG
    var randseed = new Array(4); // Xorshift: [x, y, z, w] 32 bit values

    function seedrand(seed) {
      for (var i = 0; i < randseed.length; i++) {
        randseed[i] = 0;
      }

      for (var i = 0; i < seed.length; i++) {
        randseed[i % 4] = (randseed[i % 4] << 5) - randseed[i % 4] + seed.charCodeAt(i);
      }
    }

    function rand() {
      // based on Java's String.hashCode(), expanded to 4 32bit values
      var t = randseed[0] ^ randseed[0] << 11;
      randseed[0] = randseed[1];
      randseed[1] = randseed[2];
      randseed[2] = randseed[3];
      randseed[3] = randseed[3] ^ randseed[3] >> 19 ^ t ^ t >> 8;
      return (randseed[3] >>> 0) / (1 << 31 >>> 0);
    }

    function createColor() {
      //saturation is the whole color spectrum
      var h = Math.floor(rand() * 360); //saturation goes from 40 to 100, it avoids greyish colors

      var s = rand() * 60 + 40 + '%'; //lightness can be anything from 0 to 100, but probabilities are a bell curve around 50%

      var l = (rand() + rand() + rand() + rand()) * 25 + '%';
      var color = 'hsl(' + h + ',' + s + ',' + l + ')';
      return color;
    }

    function createImageData(size) {
      var width = size; // Only support square icons for now

      var height = size;
      var dataWidth = Math.ceil(width / 2);
      var mirrorWidth = width - dataWidth;
      var data = [];

      for (var y = 0; y < height; y++) {
        var row = [];

        for (var x = 0; x < dataWidth; x++) {
          // this makes foreground and background color to have a 43% (1/2.3) probability
          // spot color has 13% chance
          row[x] = Math.floor(rand() * 2.3);
        }

        var r = row.slice(0, mirrorWidth);
        r.reverse();
        row = row.concat(r);

        for (var i = 0; i < row.length; i++) {
          data.push(row[i]);
        }
      }

      return data;
    }

    function buildOpts(opts) {
      var newOpts = {};
      newOpts.size = opts.size || 8;
      newOpts.scale = opts.scale || 4;
      newOpts.seed = opts.seed || Math.floor(Math.random() * Math.pow(10, 16)).toString(16);
      newOpts.color = opts.color || createColor();
      newOpts.bgcolor = opts.bgcolor || createColor();
      newOpts.spotcolor = opts.spotcolor || createColor();
      seedrand(newOpts.seed);
      return newOpts;
    }

    function renderIcon(opts, canvas) {
      var opts = buildOpts(opts || {});
      var imageData = createImageData(opts.size);
      var width = Math.sqrt(imageData.length);
      canvas.width = canvas.height = opts.size * opts.scale;
      var cc = canvas.getContext('2d');
      cc.fillStyle = opts.bgcolor;
      cc.fillRect(0, 0, canvas.width, canvas.height);
      cc.fillStyle = opts.color;

      for (var i = 0; i < imageData.length; i++) {
        // if data is 0, leave the background
        if (imageData[i]) {
          var row = Math.floor(i / width);
          var col = i % width; // if data is 2, choose spot color, if 1 choose foreground

          cc.fillStyle = imageData[i] == 1 ? opts.color : opts.spotcolor;
          cc.fillRect(col * opts.scale, row * opts.scale, opts.scale, opts.scale);
        }
      }

      return canvas;
    }

    function createIcon(opts) {
      var opts = buildOpts(opts || {});
      var canvas = document.createElement('canvas');
      renderIcon(opts, canvas);
      return canvas;
    }

    var api = {
      create: createIcon,
      render: renderIcon
    };
    {
      module.exports = api;
    }

    if (typeof window !== "undefined") {
      window.blockies = api;
    }
  })();
});

var BlockiesIdenticon =
/*#__PURE__*/
function (_Component) {
  _inherits(BlockiesIdenticon, _Component);

  function BlockiesIdenticon(props) {
    _classCallCheck(this, BlockiesIdenticon);

    return _possibleConstructorReturn(this, _getPrototypeOf(BlockiesIdenticon).call(this, props));
  }

  _createClass(BlockiesIdenticon, [{
    key: "getOpts",
    value: function getOpts() {
      return {
        seed: this.props.opts.seed || 'foo',
        color: this.props.opts.color || '#dfe',
        bgcolor: this.props.opts.bgcolor || '#a71',
        size: this.props.opts.size || 15,
        scale: this.props.opts.scale || 3,
        spotcolor: this.props.opts.spotcolor || '#000'
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.draw();
    }
  }, {
    key: "draw",
    value: function draw() {
      blockies.render(this.getOpts(), this.canvas);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      return React.createElement('canvas', {
        ref: function ref(canvas) {
          return _this.canvas = canvas;
        }
      });
    }
  }]);

  return BlockiesIdenticon;
}(Component);

BlockiesIdenticon.defaultProps = {
  opts: {
    seed: 'foo',
    color: '#dfe',
    bgcolor: '#a71',
    size: 15,
    scale: 3,
    spotcolor: '#000'
  }
};
BlockiesIdenticon.propTypes = {
  /**
   * Sets the options for the blockies identicon
   */
  opts: PropTypes.shape({
    seed: PropTypes.string,
    color: PropTypes.string,
    bgcolor: PropTypes.string,
    size: PropTypes.number,
    scale: PropTypes.number,
    spotcolor: PropTypes.string
  })
};
BlockiesIdenticon.displayName = 'BlockiesIdenticon';

function _templateObject$g() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  ", "\n"]);

  _templateObject$g = function _templateObject() {
    return data;
  };

  return data;
}

var defaultProps$3 = {
  fontFamily: 'sansSerif',
  fontWeight: 3,
  lineHeight: 'title',
  m: 0,
  p: 0
}; // Heading

var StyledHeading = styled.div(_templateObject$g(), COMMON, TYPOGRAPHY);
StyledHeading.defaultProps = _objectSpread2({
  theme: theme
}, defaultProps$3);
var Heading = React.forwardRef(function (props, ref) {
  return React.createElement(StyledHeading, _extends({
    ref: ref
  }, props));
});
Heading.defaultProps = _objectSpread2({}, defaultProps$3, {
  as: 'h3',
  fontSize: 4
});
Heading.propTypes = _objectSpread2({}, COMMON.propTypes, {}, TYPOGRAPHY.propTypes, {
  theme: PropTypes.object
});
Heading.displayName = 'Heading'; // H1

Heading.h1 = function (props) {
  return React.createElement(Heading, props);
};

Heading.h1.defaultProps = _objectSpread2({}, defaultProps$3, {
  as: 'h1',
  fontSize: 6
});
Heading.h1.displayName = 'Heading.h1'; // H2

Heading.h2 = function (props) {
  return React.createElement(Heading, props);
};

Heading.h2.defaultProps = _objectSpread2({}, defaultProps$3, {
  as: 'h2',
  fontSize: 5
});
Heading.h2.displayName = 'Heading.h2'; // H3

Heading.h3 = function (props) {
  return React.createElement(Heading, props);
};

Heading.h3.defaultProps = _objectSpread2({}, defaultProps$3, {
  as: 'h3',
  fontSize: 4
});
Heading.h3.displayName = 'Heading.h3'; // H4

Heading.h4 = function (props) {
  return React.createElement(Heading, props);
};

Heading.h4.defaultProps = _objectSpread2({}, defaultProps$3, {
  as: 'h4',
  fontSize: 3
});
Heading.h4.displayName = 'Heading.h4'; // H5

Heading.h5 = function (props) {
  return React.createElement(Heading, props);
};

Heading.h5.defaultProps = _objectSpread2({}, defaultProps$3, {
  as: 'h5',
  fontSize: 2
});
Heading.h5.displayName = 'Heading.h5'; // H6

Heading.h6 = function (props) {
  return React.createElement(Heading, props);
};

Heading.h6.defaultProps = _objectSpread2({}, defaultProps$3, {
  as: 'h6',
  fontSize: 1
});
Heading.h6.displayName = 'Heading.h6';

function _templateObject$h() {
  var data = _taggedTemplateLiteral(["\n  & {\n    appearance: none;\n    display: inline-block;\n    overflow: hidden;\n    height: 8px;\n    border-radius: 8px;\n  }\n  &::-webkit-progress-bar {\n    background-color: ", ";\n  }\n  &::-webkit-progress-value {\n    background-color: ", ";\n    border-radius: 8px;\n  }\n"]);

  _templateObject$h = function _templateObject() {
    return data;
  };

  return data;
}

var StyledProgress = styled.progress.attrs(function (props) {
  return {
    primarycolor: themeGet('colors.primary', '#000')(props)
  };
})(_templateObject$h(), function (props) {
  return curriedTransparentize('0.75', props.primarycolor);
}, function (props) {
  return props.primarycolor;
});
var Progress = React.forwardRef(function (props, ref) {
  return React.createElement(StyledProgress, _extends({
    ref: ref
  }, props));
});
StyledProgress.defaultProps = {
  theme: theme
}; // Progress.defaultProps = {
//   theme,
// };

Progress.propTypes = {
  theme: PropTypes.object
};
Progress.displayName = 'Progress';

function _templateObject2$6() {
  var data = _taggedTemplateLiteral(["\n  & {\n    cursor: pointer;\n  }\n  &:hover input:not(:disabled) ~ svg[name='unchecked'] {\n    fill: ", ";\n  }\n"]);

  _templateObject2$6 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$i() {
  var data = _taggedTemplateLiteral(["\n  & {\n    position: relative;\n    display: inline-block;\n  }\n\n  > input {\n    cursor: pointer;\n    appearance: none;\n    position: relative;\n    z-index: 1;\n    display: block;\n    height: 1.5rem;\n    width: 1.5rem;\n    margin: 0;\n  }\n\n  > svg {\n    position: absolute;\n    z-index: 0;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    height: 100%;\n    width: 100%;\n    pointer-events: none;\n    fill: ", ";\n  }\n\n  > svg[name='checked'] {\n    display: none;\n    z-index: 1;\n    fill: ", ";\n  }\n\n  > input:checked ~ svg[name='checked'] {\n    display: block;\n  }\n"]);

  _templateObject$i = function _templateObject() {
    return data;
  };

  return data;
}

var StyledWrapper$1 = styled(Box)(_templateObject$i(), function (props) {
  return themeGet('colors.grey', '#CCC');
}, function (props) {
  return themeGet('colors.primary', '#000');
});
var StyledLabel$1 = styled(Box)(_templateObject2$6(), function (props) {
  return themeGet('colors.primary', '#000');
});
StyledWrapper$1.defaultProps = {
  theme: theme
};
var Radio$1 = React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
      label = _ref.label,
      name = _ref.name,
      value = _ref.value,
      id = _ref.id,
      props = _objectWithoutProperties(_ref, ["className", "label", "name", "value", "id"]);

  return React.createElement(StyledLabel$1, _extends({
    forwardedAs: 'label',
    display: 'flex',
    alignItems: 'center',
    className: className
  }, props, {
    htmlFor: id,
    opacity: props.disabled ? 0.4 : 1
  }), React.createElement(StyledWrapper$1, {
    theme: props.theme
  }, React.createElement("input", _extends({
    type: 'radio',
    name: name,
    value: value,
    id: id,
    ref: ref
  }, props)), React.createElement(IconChecked$1, {
    name: 'checked'
  }), React.createElement(IconUnChecked$1, {
    name: 'unchecked'
  })), React.createElement(Text, {
    fontSize: 1,
    fontWeight: 3,
    lineHeight: 1,
    ml: 1,
    mr: 2
  }, label));
});
Radio$1.defaultProps = {
  theme: theme,
  color: 'primary'
};
Radio$1.propTypes = _objectSpread2({}, Box.propTypes, {
  theme: PropTypes.object,
  label: PropTypes.string
});
Radio$1.displayName = 'Radio';

function _templateObject$j() {
  var data = _taggedTemplateLiteral(["\n  & {\n    position: relative;\n    display: inline-block;\n  }\n\n  > ", " {\n    pointer-events: none;\n    position: absolute;\n    right: 0;\n    top: 0;\n    bottom: 0;\n  }\n"]);

  _templateObject$j = function _templateObject() {
    return data;
  };

  return data;
}

var StyledWrapper$2 = styled.div(_templateObject$j(), ExpandMore$1);
var Select = React.forwardRef(function (_ref, ref) {
  var options = _ref.options,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["options", "children"]);

  var renderChildren = function renderChildren() {
    if (children) {
      return children;
    } else if (options) {
      return options.map(function (option, i) {
        return React.createElement("option", {
          key: i,
          value: option.value,
          children: option.label
        });
      });
    } else {
      return null;
    }
  };

  return React.createElement(StyledWrapper$2, null, React.createElement(StyledInput, _extends({
    as: 'select',
    children: renderChildren(),
    ref: ref,
    py: 0,
    pl: 3,
    pr: '3rem'
  }, props)), React.createElement(ExpandMore$1, {
    my: 'auto',
    mx: 3
  }));
});
Select.propTypes = {
  options: PropTypes.arrayOf(PropTypes.object)
};
Select.displayName = 'Select';

function _templateObject$k() {
  var data = _taggedTemplateLiteral(["\n  & {\n    appearance: none;\n    height: 2rem;\n    min-width: 200px;\n  }\n  &::-webkit-slider-runnable-track {\n    box-sizing: border-box;\n    appearance: none;\n    border: none;\n    border-radius: 4px;\n    background: currentColor;\n    height: 4px;\n    display: flex;\n    align-items: center;\n  }\n  &::-webkit-slider-thumb {\n    box-sizing: border-box;\n    appearance: none;\n    border: 1px solid #ccc;\n    background: white;\n    height: 1.5rem;\n    width: 1.5rem;\n    border-radius: 100%;\n    cursor: grab;\n    &:hover {\n      box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);\n    }\n    &:active {\n      cursor: grabbing;\n      border-color: currentColor;\n    }\n  }\n\n  &::-moz-range-track {\n    box-sizing: border-box;\n    appearance: none;\n    border: none;\n    border-radius: 4px;\n    background: currentColor;\n    height: 4px;\n    display: flex;\n    align-items: center;\n  }\n  &::-moz-range-thumb {\n    box-sizing: border-box;\n    appearance: none;\n    border: 1px solid #ccc;\n    background: white;\n    height: 1.5rem;\n    width: 1.5rem;\n    border-radius: 100%;\n    cursor: grab;\n    &:hover {\n      box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);\n    }\n    &:active {\n      cursor: grabbing;\n      border-color: currentColor;\n    }\n  }\n  ", "\n"]);

  _templateObject$k = function _templateObject() {
    return data;
  };

  return data;
}

var StyledSlider = styled('input').attrs(function (props) {
  return {
    type: 'range'
  };
})(_templateObject$k(), COMMON);
var Slider = React.forwardRef(function (props, ref) {
  return React.createElement(StyledSlider, _extends({
    ref: ref
  }, props));
});
StyledSlider.defaultProps = {
  theme: theme,
  m: 0,
  color: 'primary'
}; // Slider.defaultProps = {
//   theme,
//   m: 0,
//   color: 'primary',
// };

Slider.propTypes = _objectSpread2({}, COMMON.propTypes, {
  theme: PropTypes.object
});
Slider.displayName = 'Slider';

function _templateObject$l() {
  var data = _taggedTemplateLiteral(["\n  & {\n    border-collapse: collapse;\n  }\n\n  th,\n  td {\n    border: solid;\n    border-width: 1px 0;\n    border-color: inherit;\n    text-align: left;\n    padding: 0 2rem;\n  }\n\n  tbody tr {\n    height: ", ";\n  }\n\n  thead tr,\n  tfoot tr {\n    height: ", ";\n  }\n\n  thead th {\n    font-weight: ", ";\n    text-transform: uppercase;\n  }\n\n  ", "\n"]);

  _templateObject$l = function _templateObject() {
    return data;
  };

  return data;
}

var StyledTable = styled(Box)(_templateObject$l(), themeGet('height[3]', '4rem'), themeGet('height[2]', '3rem'), themeGet('fontWeights.3', 'bold'), TYPOGRAPHY);
StyledTable.defaultProps = {
  theme: theme
};
var Table = React.forwardRef(function (props, ref) {
  return React.createElement(StyledTable, _extends({
    ref: ref
  }, props, {
    forwardedAs: 'table'
  }));
});
Table.defaultProps = {
  width: 1,
  border: 1,
  borderColor: 'grey',
  fontSize: 1,
  fontWeight: 2,
  fontFamily: 'sansSerif',
  color: 'dark-gray',
  boxShadow: 1
};
Table.propTypes = _objectSpread2({}, Box.propTypes, {
  theme: PropTypes.object
});
Table.displayName = 'Table';
var Textarea = React.forwardRef(function (props, ref) {
  return React.createElement(StyledInput, _extends({
    ref: ref
  }, props, {
    as: 'textarea'
  }));
});
Textarea.defaultProps = {
  color: 'copyColor',
  bg: 'white',
  fontFamily: 'sansSerif',
  fontSize: '1rem',
  lineHeight: 'solid',
  height: 'auto',
  border: 1,
  borderColor: 'grey',
  borderRadius: 1,
  boxShadow: 1
};
Textarea.propTypes = {
  theme: PropTypes.object
};
Textarea.displayName = 'Textarea';
/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.15.0
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
var timeoutDuration = 0;

for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
  if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
    timeoutDuration = 1;
    break;
  }
}

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }

    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;
/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/

var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;
/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */

function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}
/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */


function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  } // NOTE: 1 DOM access here


  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}
/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */


function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }

  return element.parentNode || element.host;
}
/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */


function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;

    case '#document':
      return element.body;
  } // Firefox want us to check `-x` and `-y` variations as well


  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);
/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */

function isIE(version) {
  if (version === 11) {
    return isIE11;
  }

  if (version === 10) {
    return isIE10;
  }

  return isIE11 || isIE10;
}
/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */


function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null; // NOTE: 1 DOM access here

  var offsetParent = element.offsetParent || null; // Skip hidden elements which don't have an offsetParent

  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  } // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...


  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }

  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}
/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */


function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}
/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */


function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  } // Here we make sure to give as "start" the element that comes first in the DOM


  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1; // Get common ancestor container

  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer; // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  } // one of the nodes is inside shadowDOM, find which one


  var element1root = getRoot(element1);

  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}
/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */


function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}
/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */


function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}
/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */


function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);
  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var defineProperty = function defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends$4 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};
/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */


function getClientRect(offsets) {
  return _extends$4({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}
/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */


function getBoundingClientRect(element) {
  var rect = {}; // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11

  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  }; // subtract scrollbar size from sizes

  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.right - result.left;
  var height = sizes.height || element.clientHeight || result.bottom - result.top;
  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height; // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons

  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');
    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);
  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10); // In cases where the parent is fixed, we must ignore negative scroll in offset calc

  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }

  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0; // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.

  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop, 10);
    var marginLeft = parseFloat(styles.marginLeft, 10);
    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft; // Attach marginTop and marginLeft because in some circumstances we may need them

    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);
  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;
  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };
  return getClientRect(offset);
}
/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */


function isFixed(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }

  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }

  var parentNode = getParentNode(element);

  if (!parentNode) {
    return false;
  }

  return isFixed(parentNode);
}
/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */


function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }

  var el = element.parentElement;

  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }

  return el || document.documentElement;
}
/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */


function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false; // NOTE: 1 DOM access here

  var boundaries = {
    top: 0,
    left: 0
  };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference); // Handle viewport case

  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;

    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));

      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition); // In case of HTML, we need a different computation

    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  } // Add paddings


  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;
  return width * height;
}
/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */


function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);
  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };
  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends$4({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });
  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });
  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
  var variation = placement.split('-')[1];
  return computedPlacement + (variation ? '-' + variation : '');
}
/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */


function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}
/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */


function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}
/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */


function getOppositePlacement(placement) {
  var hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
  };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}
/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */


function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0]; // Get popper node sizes

  var popperRect = getOuterSizes(popper); // Add position, width and height to our offsets object

  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  }; // depending by the popper placement we have to compute its offsets slightly differently

  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';
  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;

  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}
/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */


function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  } // use `filter` to obtain the same behavior of `find`


  return arr.filter(check)[0];
}
/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */


function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  } // use `find` + `indexOf` if `findIndex` isn't supported


  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}
/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */


function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));
  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }

    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation

    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);
      data = fn(data, modifier);
    }
  });
  return data;
}
/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */


function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  }; // compute reference element offsets

  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed); // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value

  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding); // store the computed placement inside `originalPlacement`

  data.originalPlacement = data.placement;
  data.positionFixed = this.options.positionFixed; // compute the popper offsets

  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute'; // run the modifiers

  data = runModifiers(this.modifiers, data); // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback

  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}
/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */


function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}
/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */


function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;

    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }

  return null;
}
/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */


function destroy() {
  this.state.isDestroyed = true; // touch DOM only if `applyStyle` modifier is enabled

  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners(); // remove the popper if user explicity asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it

  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }

  return this;
}
/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */


function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, {
    passive: true
  });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }

  scrollParents.push(target);
}
/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */


function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, {
    passive: true
  }); // Scroll event listener on scroll parents

  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;
  return state;
}
/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */


function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}
/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */


function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound); // Remove scroll event listener on scroll parents

  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  }); // Reset state

  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}
/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */


function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}
/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */


function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}
/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */


function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = ''; // add unit if the value is numeric and is one of the following

    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }

    element.style[prop] = styles[prop] + unit;
  });
}
/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */


function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];

    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */


function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles); // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element

  setAttributes(data.instance.popper, data.attributes); // if arrowElement is defined and arrowStyles has some properties

  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}
/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */


function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed); // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value

  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
  popper.setAttribute('x-placement', placement); // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations

  setStyles(popper, {
    position: options.positionFixed ? 'fixed' : 'absolute'
  });
  return options;
}
/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */


function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);
  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;
  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */

function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper; // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;

  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }

  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent); // Styles

  var styles = {
    position: popper.position
  };
  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);
  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right'; // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed

  var prefixedProperty = getSupportedPropertyName('transform'); // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.

  var left = void 0,
      top = void 0;

  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }

  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }

  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  } // Attributes


  var attributes = {
    'x-placement': data.placement
  }; // Update `data` attributes, styles and arrowStyles

  data.attributes = _extends$4({}, attributes, data.attributes);
  data.styles = _extends$4({}, styles, data.styles);
  data.arrowStyles = _extends$4({}, data.offsets.arrow, data.arrowStyles);
  return data;
}
/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */


function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });
  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';

    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }

  return isRequired;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */


function arrow(data, options) {
  var _data$offsets$arrow; // arrow depends on keepTogether in order to work


  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element; // if arrowElement is a string, suppose it's a CSS selector

  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement); // if arrowElement is not found, don't run the modifier

    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var isVertical = ['left', 'right'].indexOf(placement) !== -1;
  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len]; //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //
  // top/left side

  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  } // bottom/right side


  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }

  data.offsets.popper = getClientRect(data.offsets.popper); // compute center of the popper

  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2; // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available

  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide; // prevent arrowElement from being placed not contiguously to its popper

  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
  return data;
}
/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */


function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }

  return variation;
}
/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */


var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start']; // Get rid of `auto` `auto-start` and `auto-end`

var validPlacements = placements.slice(3);
/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */

function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */

function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';
  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;

    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;

    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;

    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);
    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference; // using floor because the reference offsets may contain decimals we are not going to consider here

    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom; // flip the variation if required

    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1; // flips variation if reference element overflows boundaries

    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom); // flips variation if popper content overflows boundaries

    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);
    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : ''); // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future

      data.offsets.popper = _extends$4({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */


function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }

  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}
/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */


function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2]; // If it's not a number it's an operator, I guess

  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;

    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;

      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;

    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }

    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}
/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */


function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0]; // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one

  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1; // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)

  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  }); // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space

  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  } // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.


  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments]; // Convert the values with units to absolute pixels to allow our computations

  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, []) // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  }); // Loop trough the offsets arrays and execute the operations

  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */


function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var basePlacement = placement.split('-')[0];
  var offsets = void 0;

  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */


function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper); // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken

  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  } // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself


  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification

  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];
  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';
  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed); // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed

  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;
  options.boundaries = boundaries;
  var order = options.priority;
  var popper = data.offsets.popper;
  var check = {
    primary: function primary(placement) {
      var value = popper[placement];

      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }

      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];

      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }

      return defineProperty({}, mainSide, value);
    }
  };
  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends$4({}, popper, check[side](placement));
  });
  data.offsets.popper = popper;
  return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */


function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1]; // if shift shiftvariation is specified, run the modifier

  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;
    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';
    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };
    data.offsets.popper = _extends$4({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */


function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */


function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;
  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;
  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);
  return data;
}
/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */


var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,

    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,

    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,

    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,

    /** @prop {ModifierFn} */
    fn: offset,

    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,

    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,

    /** @prop {ModifierFn} */
    fn: preventOverflow,

    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],

    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,

    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,

    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,

    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,

    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,

    /** @prop {ModifierFn} */
    fn: arrow,

    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,

    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,

    /** @prop {ModifierFn} */
    fn: flip,

    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',

    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,

    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',

    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,

    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,

    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,

    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,

    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,

    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,

    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,

    /** @prop {ModifierFn} */
    fn: computeStyle,

    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,

    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',

    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,

    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,

    /** @prop {ModifierFn} */
    fn: applyStyle,

    /** @prop {Function} */
    onLoad: applyStyleOnLoad,

    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};
/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */

var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};
/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */
// Utils
// Methods

var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    }; // make update() debounced, so that it only runs at most once-per-tick


    this.update = debounce(this.update.bind(this)); // with {} we create a new object with the options inside it

    this.options = _extends$4({}, Popper.Defaults, options); // init state

    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    }; // get reference and popper elements (allow jQuery wrappers)

    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper; // Deep merge modifiers options

    this.options.modifiers = {};
    Object.keys(_extends$4({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends$4({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    }); // Refactoring modifiers' list (Object => Array)

    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends$4({
        name: name
      }, _this.options.modifiers[name]);
    }) // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    }); // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!

    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    }); // fire the first update to position the popper in the right place

    this.update();
    var eventsEnabled = this.options.eventsEnabled;

    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  } // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }
    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */

    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();
/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

var _global = createCommonjsModule(function (module) {
  // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
  var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self // eslint-disable-next-line no-new-func
  : Function('return this')();
  if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef
});

var _core = createCommonjsModule(function (module) {
  var core = module.exports = {
    version: '2.6.9'
  };
  if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef
});

var _core_1 = _core.version;

var _aFunction = function _aFunction(it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
}; // optional / simple context binding


var _ctx = function _ctx(fn, that, length) {
  _aFunction(fn);

  if (that === undefined) return fn;

  switch (length) {
    case 1:
      return function (a) {
        return fn.call(that, a);
      };

    case 2:
      return function (a, b) {
        return fn.call(that, a, b);
      };

    case 3:
      return function (a, b, c) {
        return fn.call(that, a, b, c);
      };
  }

  return function ()
  /* ...args */
  {
    return fn.apply(that, arguments);
  };
};

var _isObject = function _isObject(it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

var _anObject = function _anObject(it) {
  if (!_isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

var _fails = function _fails(exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
}; // Thank's IE8 for his funny defineProperty


var _descriptors = !_fails(function () {
  return Object.defineProperty({}, 'a', {
    get: function get() {
      return 7;
    }
  }).a != 7;
});

var document$1 = _global.document; // typeof document.createElement is 'object' in old IE

var is$1 = _isObject(document$1) && _isObject(document$1.createElement);

var _domCreate = function _domCreate(it) {
  return is$1 ? document$1.createElement(it) : {};
};

var _ie8DomDefine = !_descriptors && !_fails(function () {
  return Object.defineProperty(_domCreate('div'), 'a', {
    get: function get() {
      return 7;
    }
  }).a != 7;
}); // 7.1.1 ToPrimitive(input [, PreferredType])
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string


var _toPrimitive = function _toPrimitive(it, S) {
  if (!_isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !_isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var dP = Object.defineProperty;
var f = _descriptors ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  _anObject(O);

  P = _toPrimitive(P, true);

  _anObject(Attributes);

  if (_ie8DomDefine) try {
    return dP(O, P, Attributes);
  } catch (e) {
    /* empty */
  }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};
var _objectDp = {
  f: f
};

var _propertyDesc = function _propertyDesc(bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var _hide = _descriptors ? function (object, key, value) {
  return _objectDp.f(object, key, _propertyDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var hasOwnProperty = {}.hasOwnProperty;

var _has = function _has(it, key) {
  return hasOwnProperty.call(it, key);
};

var PROTOTYPE = 'prototype';

var $export = function $export(type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? _core : _core[name] || (_core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? _global : IS_STATIC ? _global[name] : (_global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;

  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && _has(exports, key)) continue; // export native or passed

    out = own ? target[key] : source[key]; // prevent global pollution for namespaces

    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key] // bind timers to global for call from export context
    : IS_BIND && own ? _ctx(out, _global) // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? function (C) {
      var F = function F(a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0:
              return new C();

            case 1:
              return new C(a);

            case 2:
              return new C(a, b);
          }

          return new C(a, b, c);
        }

        return C.apply(this, arguments);
      };

      F[PROTOTYPE] = C[PROTOTYPE];
      return F; // make static versions for prototype methods
    }(out) : IS_PROTO && typeof out == 'function' ? _ctx(Function.call, out) : out; // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%

    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out; // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%

      if (type & $export.R && expProto && !expProto[key]) _hide(expProto, key, out);
    }
  }
}; // type bitmap


$export.F = 1; // forced

$export.G = 2; // global

$export.S = 4; // static

$export.P = 8; // proto

$export.B = 16; // bind

$export.W = 32; // wrap

$export.U = 64; // safe

$export.R = 128; // real proto method for `library`

var _export = $export;
var toString = {}.toString;

var _cof = function _cof(it) {
  return toString.call(it).slice(8, -1);
}; // fallback for non-array-like ES3 and non-enumerable old V8 strings
// eslint-disable-next-line no-prototype-builtins


var _iobject = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return _cof(it) == 'String' ? it.split('') : Object(it);
}; // 7.2.1 RequireObjectCoercible(argument)


var _defined = function _defined(it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
}; // to indexed object, toObject with fallback for non-array-like ES3 strings


var _toIobject = function _toIobject(it) {
  return _iobject(_defined(it));
}; // 7.1.4 ToInteger


var ceil = Math.ceil;
var floor = Math.floor;

var _toInteger = function _toInteger(it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
}; // 7.1.15 ToLength


var min = Math.min;

var _toLength = function _toLength(it) {
  return it > 0 ? min(_toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

var max = Math.max;
var min$1 = Math.min;

var _toAbsoluteIndex = function _toAbsoluteIndex(index, length) {
  index = _toInteger(index);
  return index < 0 ? max(index + length, 0) : min$1(index, length);
}; // false -> Array#indexOf
// true  -> Array#includes


var _arrayIncludes = function _arrayIncludes(IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = _toIobject($this);

    var length = _toLength(O.length);

    var index = _toAbsoluteIndex(fromIndex, length);

    var value; // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare

    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++]; // eslint-disable-next-line no-self-compare

      if (value != value) return true; // Array#indexOf ignores holes, Array#includes - not
    } else for (; length > index; index++) {
      if (IS_INCLUDES || index in O) {
        if (O[index] === el) return IS_INCLUDES || index || 0;
      }
    }
    return !IS_INCLUDES && -1;
  };
};

var _library = true;

var _shared = createCommonjsModule(function (module) {
  var SHARED = '__core-js_shared__';
  var store = _global[SHARED] || (_global[SHARED] = {});
  (module.exports = function (key, value) {
    return store[key] || (store[key] = value !== undefined ? value : {});
  })('versions', []).push({
    version: _core.version,
    mode: 'pure',
    copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
  });
});

var id = 0;
var px$1 = Math.random();

var _uid = function _uid(key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px$1).toString(36));
};

var shared = _shared('keys');

var _sharedKey = function _sharedKey(key) {
  return shared[key] || (shared[key] = _uid(key));
};

var arrayIndexOf = _arrayIncludes(false);

var IE_PROTO = _sharedKey('IE_PROTO');

var _objectKeysInternal = function _objectKeysInternal(object, names) {
  var O = _toIobject(object);

  var i = 0;
  var result = [];
  var key;

  for (key in O) {
    if (key != IE_PROTO) _has(O, key) && result.push(key);
  } // Don't enum bug & hidden keys


  while (names.length > i) {
    if (_has(O, key = names[i++])) {
      ~arrayIndexOf(result, key) || result.push(key);
    }
  }

  return result;
}; // IE 8- don't enum bug keys


var _enumBugKeys = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(','); // 19.1.2.14 / 15.2.3.14 Object.keys(O)


var _objectKeys = Object.keys || function keys(O) {
  return _objectKeysInternal(O, _enumBugKeys);
};

var f$1 = Object.getOwnPropertySymbols;
var _objectGops = {
  f: f$1
};
var f$2 = {}.propertyIsEnumerable;
var _objectPie = {
  f: f$2
}; // 7.1.13 ToObject(argument)

var _toObject = function _toObject(it) {
  return Object(_defined(it));
}; // 19.1.2.1 Object.assign(target, source, ...)


var $assign = Object.assign; // should work with symbols and should have deterministic property order (V8 bug)

var _objectAssign = !$assign || _fails(function () {
  var A = {};
  var B = {}; // eslint-disable-next-line no-undef

  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) {
    B[k] = k;
  });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) {
  // eslint-disable-line no-unused-vars
  var T = _toObject(target);

  var aLen = arguments.length;
  var index = 1;
  var getSymbols = _objectGops.f;
  var isEnum = _objectPie.f;

  while (aLen > index) {
    var S = _iobject(arguments[index++]);

    var keys = getSymbols ? _objectKeys(S).concat(getSymbols(S)) : _objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;

    while (length > j) {
      key = keys[j++];
      if (!_descriptors || isEnum.call(S, key)) T[key] = S[key];
    }
  }

  return T;
} : $assign; // 19.1.3.1 Object.assign(target, source)


_export(_export.S + _export.F, 'Object', {
  assign: _objectAssign
});

var assign = _core.Object.assign;
var assign$1 = createCommonjsModule(function (module) {
  module.exports = {
    "default": assign,
    __esModule: true
  };
});
unwrapExports(assign$1);

var _extends$5 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;

  var _assign2 = _interopRequireDefault(assign$1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = _assign2.default || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
});

var _extends$6 = unwrapExports(_extends$5);
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */


var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */

function is$2(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}
/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */


function shallowEqual(objA, objB) {
  if (is$2(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  } // Test for A's keys different from B.


  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty$1.call(objB, keysA[i]) || !is$2(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

var shallowEqual_1 = shallowEqual;
var classCallCheck$1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;

  exports.default = function (instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  };
});

var _classCallCheck$1 = unwrapExports(classCallCheck$1); // true  -> String#at
// false -> String#codePointAt


var _stringAt = function _stringAt(TO_STRING) {
  return function (that, pos) {
    var s = String(_defined(that));

    var i = _toInteger(pos);

    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

var _redefine = _hide;

var _objectDps = _descriptors ? Object.defineProperties : function defineProperties(O, Properties) {
  _anObject(O);

  var keys = _objectKeys(Properties);

  var length = keys.length;
  var i = 0;
  var P;

  while (length > i) {
    _objectDp.f(O, P = keys[i++], Properties[P]);
  }

  return O;
};

var document$2 = _global.document;

var _html = document$2 && document$2.documentElement; // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])


var IE_PROTO$1 = _sharedKey('IE_PROTO');

var Empty = function Empty() {
  /* empty */
};

var PROTOTYPE$1 = 'prototype'; // Create object with fake `null` prototype: use iframe Object with cleared prototype

var _createDict = function createDict() {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = _domCreate('iframe');

  var i = _enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';

  _html.appendChild(iframe);

  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);

  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  _createDict = iframeDocument.F;

  while (i--) {
    delete _createDict[PROTOTYPE$1][_enumBugKeys[i]];
  }

  return _createDict();
};

var _objectCreate = Object.create || function create(O, Properties) {
  var result;

  if (O !== null) {
    Empty[PROTOTYPE$1] = _anObject(O);
    result = new Empty();
    Empty[PROTOTYPE$1] = null; // add "__proto__" for Object.getPrototypeOf polyfill

    result[IE_PROTO$1] = O;
  } else result = _createDict();

  return Properties === undefined ? result : _objectDps(result, Properties);
};

var _wks = createCommonjsModule(function (module) {
  var store = _shared('wks');

  var Symbol = _global.Symbol;
  var USE_SYMBOL = typeof Symbol == 'function';

  var $exports = module.exports = function (name) {
    return store[name] || (store[name] = USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : _uid)('Symbol.' + name));
  };

  $exports.store = store;
});

var def = _objectDp.f;

var TAG = _wks('toStringTag');

var _setToStringTag = function _setToStringTag(it, tag, stat) {
  if (it && !_has(it = stat ? it : it.prototype, TAG)) def(it, TAG, {
    configurable: true,
    value: tag
  });
};

var IteratorPrototype = {}; // 25.1.2.1.1 %IteratorPrototype%[@@iterator]()

_hide(IteratorPrototype, _wks('iterator'), function () {
  return this;
});

var _iterCreate = function _iterCreate(Constructor, NAME, next) {
  Constructor.prototype = _objectCreate(IteratorPrototype, {
    next: _propertyDesc(1, next)
  });

  _setToStringTag(Constructor, NAME + ' Iterator');
}; // 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)


var IE_PROTO$2 = _sharedKey('IE_PROTO');

var ObjectProto = Object.prototype;

var _objectGpo = Object.getPrototypeOf || function (O) {
  O = _toObject(O);
  if (_has(O, IE_PROTO$2)) return O[IE_PROTO$2];

  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  }

  return O instanceof Object ? ObjectProto : null;
};

var ITERATOR = _wks('iterator');

var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`

var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var _iterDefine = function _iterDefine(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  _iterCreate(Constructor, NAME, next);

  var getMethod = function getMethod(kind) {
    if (!BUGGY && kind in proto) return proto[kind];

    switch (kind) {
      case KEYS:
        return function keys() {
          return new Constructor(this, kind);
        };

      case VALUES:
        return function values() {
          return new Constructor(this, kind);
        };
    }

    return function entries() {
      return new Constructor(this, kind);
    };
  };

  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype; // Fix native

  if ($anyNative) {
    IteratorPrototype = _objectGpo($anyNative.call(new Base()));

    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      _setToStringTag(IteratorPrototype, TAG, true);
    }
  } // fix Array#{values, @@iterator}.name in V8 / FF


  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;

    $default = function values() {
      return $native.call(this);
    };
  } // Define iterator


  if (FORCED && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    _hide(proto, ITERATOR, $default);
  }

  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) _redefine(proto, key, methods[key]);
    } else _export(_export.P + _export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }

  return methods;
};

var $at = _stringAt(true); // 21.1.3.27 String.prototype[@@iterator]()


_iterDefine(String, 'String', function (iterated) {
  this._t = String(iterated); // target

  this._i = 0; // next index
  // 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return {
    value: undefined,
    done: true
  };
  point = $at(O, index);
  this._i += point.length;
  return {
    value: point,
    done: false
  };
});

var _iterStep = function _iterStep(done, value) {
  return {
    value: value,
    done: !!done
  };
}; // 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()


var es6_array_iterator = _iterDefine(Array, 'Array', function (iterated, kind) {
  this._t = _toIobject(iterated); // target

  this._i = 0; // next index

  this._k = kind; // kind
  // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;

  if (!O || index >= O.length) {
    this._t = undefined;
    return _iterStep(1);
  }

  if (kind == 'keys') return _iterStep(0, index);
  if (kind == 'values') return _iterStep(0, O[index]);
  return _iterStep(0, [index, O[index]]);
}, 'values');

var TO_STRING_TAG = _wks('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' + 'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' + 'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' + 'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' + 'TextTrackList,TouchList').split(',');

for (var i$1 = 0; i$1 < DOMIterables.length; i$1++) {
  var NAME = DOMIterables[i$1];
  var Collection = _global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) _hide(proto, TO_STRING_TAG, NAME);
}

var f$3 = _wks;
var _wksExt = {
  f: f$3
};

var iterator = _wksExt.f('iterator');

var iterator$1 = createCommonjsModule(function (module) {
  module.exports = {
    "default": iterator,
    __esModule: true
  };
});
unwrapExports(iterator$1);

var _meta = createCommonjsModule(function (module) {
  var META = _uid('meta');

  var setDesc = _objectDp.f;
  var id = 0;

  var isExtensible = Object.isExtensible || function () {
    return true;
  };

  var FREEZE = !_fails(function () {
    return isExtensible(Object.preventExtensions({}));
  });

  var setMeta = function setMeta(it) {
    setDesc(it, META, {
      value: {
        i: 'O' + ++id,
        // object ID
        w: {} // weak collections IDs

      }
    });
  };

  var fastKey = function fastKey(it, create) {
    // return primitive with prefix
    if (!_isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;

    if (!_has(it, META)) {
      // can't set metadata to uncaught frozen object
      if (!isExtensible(it)) return 'F'; // not necessary to add metadata

      if (!create) return 'E'; // add missing metadata

      setMeta(it); // return object ID
    }

    return it[META].i;
  };

  var getWeak = function getWeak(it, create) {
    if (!_has(it, META)) {
      // can't set metadata to uncaught frozen object
      if (!isExtensible(it)) return true; // not necessary to add metadata

      if (!create) return false; // add missing metadata

      setMeta(it); // return hash weak collections IDs
    }

    return it[META].w;
  }; // add metadata on freeze-family methods calling


  var onFreeze = function onFreeze(it) {
    if (FREEZE && meta.NEED && isExtensible(it) && !_has(it, META)) setMeta(it);
    return it;
  };

  var meta = module.exports = {
    KEY: META,
    NEED: false,
    fastKey: fastKey,
    getWeak: getWeak,
    onFreeze: onFreeze
  };
});

var _meta_1 = _meta.KEY;
var _meta_2 = _meta.NEED;
var _meta_3 = _meta.fastKey;
var _meta_4 = _meta.getWeak;
var _meta_5 = _meta.onFreeze;
var defineProperty$1 = _objectDp.f;

var _wksDefine = function _wksDefine(name) {
  var $Symbol = _core.Symbol || (_core.Symbol = {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty$1($Symbol, name, {
    value: _wksExt.f(name)
  });
}; // all enumerable object keys, includes symbols


var _enumKeys = function _enumKeys(it) {
  var result = _objectKeys(it);

  var getSymbols = _objectGops.f;

  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = _objectPie.f;
    var i = 0;
    var key;

    while (symbols.length > i) {
      if (isEnum.call(it, key = symbols[i++])) result.push(key);
    }
  }

  return result;
}; // 7.2.2 IsArray(argument)


var _isArray = Array.isArray || function isArray(arg) {
  return _cof(arg) == 'Array';
}; // 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)


var hiddenKeys = _enumBugKeys.concat('length', 'prototype');

var f$4 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return _objectKeysInternal(O, hiddenKeys);
};

var _objectGopn = {
  f: f$4
}; // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window

var gOPN = _objectGopn.f;
var toString$1 = {}.toString;
var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function getWindowNames(it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

var f$5 = function getOwnPropertyNames(it) {
  return windowNames && toString$1.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(_toIobject(it));
};

var _objectGopnExt = {
  f: f$5
};
var gOPD = Object.getOwnPropertyDescriptor;
var f$6 = _descriptors ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = _toIobject(O);
  P = _toPrimitive(P, true);
  if (_ie8DomDefine) try {
    return gOPD(O, P);
  } catch (e) {
    /* empty */
  }
  if (_has(O, P)) return _propertyDesc(!_objectPie.f.call(O, P), O[P]);
};
var _objectGopd = {
  f: f$6
}; // ECMAScript 6 symbols shim

var META = _meta.KEY;
var gOPD$1 = _objectGopd.f;
var dP$1 = _objectDp.f;
var gOPN$1 = _objectGopnExt.f;
var $Symbol = _global.Symbol;
var $JSON = _global.JSON;

var _stringify = $JSON && $JSON.stringify;

var PROTOTYPE$2 = 'prototype';

var HIDDEN = _wks('_hidden');

var TO_PRIMITIVE = _wks('toPrimitive');

var isEnum = {}.propertyIsEnumerable;

var SymbolRegistry = _shared('symbol-registry');

var AllSymbols = _shared('symbols');

var OPSymbols = _shared('op-symbols');

var ObjectProto$1 = Object[PROTOTYPE$2];
var USE_NATIVE = typeof $Symbol == 'function' && !!_objectGops.f;
var QObject = _global.QObject; // Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173

var setter = !QObject || !QObject[PROTOTYPE$2] || !QObject[PROTOTYPE$2].findChild; // fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687

var setSymbolDesc = _descriptors && _fails(function () {
  return _objectCreate(dP$1({}, 'a', {
    get: function get() {
      return dP$1(this, 'a', {
        value: 7
      }).a;
    }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD$1(ObjectProto$1, key);
  if (protoDesc) delete ObjectProto$1[key];
  dP$1(it, key, D);
  if (protoDesc && it !== ObjectProto$1) dP$1(ObjectProto$1, key, protoDesc);
} : dP$1;

var wrap = function wrap(tag) {
  var sym = AllSymbols[tag] = _objectCreate($Symbol[PROTOTYPE$2]);

  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto$1) $defineProperty(OPSymbols, key, D);

  _anObject(it);

  key = _toPrimitive(key, true);

  _anObject(D);

  if (_has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!_has(it, HIDDEN)) dP$1(it, HIDDEN, _propertyDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (_has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _objectCreate(D, {
        enumerable: _propertyDesc(0, false)
      });
    }

    return setSymbolDesc(it, key, D);
  }

  return dP$1(it, key, D);
};

var $defineProperties = function defineProperties(it, P) {
  _anObject(it);

  var keys = _enumKeys(P = _toIobject(P));

  var i = 0;
  var l = keys.length;
  var key;

  while (l > i) {
    $defineProperty(it, key = keys[i++], P[key]);
  }

  return it;
};

var $create = function create(it, P) {
  return P === undefined ? _objectCreate(it) : $defineProperties(_objectCreate(it), P);
};

var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = _toPrimitive(key, true));
  if (this === ObjectProto$1 && _has(AllSymbols, key) && !_has(OPSymbols, key)) return false;
  return E || !_has(this, key) || !_has(AllSymbols, key) || _has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = _toIobject(it);
  key = _toPrimitive(key, true);
  if (it === ObjectProto$1 && _has(AllSymbols, key) && !_has(OPSymbols, key)) return;
  var D = gOPD$1(it, key);
  if (D && _has(AllSymbols, key) && !(_has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};

var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN$1(_toIobject(it));
  var result = [];
  var i = 0;
  var key;

  while (names.length > i) {
    if (!_has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  }

  return result;
};

var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto$1;
  var names = gOPN$1(IS_OP ? OPSymbols : _toIobject(it));
  var result = [];
  var i = 0;
  var key;

  while (names.length > i) {
    if (_has(AllSymbols, key = names[i++]) && (IS_OP ? _has(ObjectProto$1, key) : true)) result.push(AllSymbols[key]);
  }

  return result;
}; // 19.4.1.1 Symbol([description])


if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');

    var tag = _uid(arguments.length > 0 ? arguments[0] : undefined);

    var $set = function $set(value) {
      if (this === ObjectProto$1) $set.call(OPSymbols, value);
      if (_has(this, HIDDEN) && _has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, _propertyDesc(1, value));
    };

    if (_descriptors && setter) setSymbolDesc(ObjectProto$1, tag, {
      configurable: true,
      set: $set
    });
    return wrap(tag);
  };

  _redefine($Symbol[PROTOTYPE$2], 'toString', function toString() {
    return this._k;
  });

  _objectGopd.f = $getOwnPropertyDescriptor;
  _objectDp.f = $defineProperty;
  _objectGopn.f = _objectGopnExt.f = $getOwnPropertyNames;
  _objectPie.f = $propertyIsEnumerable;
  _objectGops.f = $getOwnPropertySymbols;

  if (_descriptors && !_library) {
    _redefine(ObjectProto$1, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  _wksExt.f = function (name) {
    return wrap(_wks(name));
  };
}

_export(_export.G + _export.W + _export.F * !USE_NATIVE, {
  Symbol: $Symbol
});

for (var es6Symbols = // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), j = 0; es6Symbols.length > j;) {
  _wks(es6Symbols[j++]);
}

for (var wellKnownSymbols = _objectKeys(_wks.store), k = 0; wellKnownSymbols.length > k;) {
  _wksDefine(wellKnownSymbols[k++]);
}

_export(_export.S + _export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function _for(key) {
    return _has(SymbolRegistry, key += '') ? SymbolRegistry[key] : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');

    for (var key in SymbolRegistry) {
      if (SymbolRegistry[key] === sym) return key;
    }
  },
  useSetter: function useSetter() {
    setter = true;
  },
  useSimple: function useSimple() {
    setter = false;
  }
});

_export(_export.S + _export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
}); // Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443


var FAILS_ON_PRIMITIVES = _fails(function () {
  _objectGops.f(1);
});

_export(_export.S + _export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return _objectGops.f(_toObject(it));
  }
}); // 24.3.2 JSON.stringify(value [, replacer [, space]])


$JSON && _export(_export.S + _export.F * (!USE_NATIVE || _fails(function () {
  var S = $Symbol(); // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols

  return _stringify([S]) != '[null]' || _stringify({
    a: S
  }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;

    while (arguments.length > i) {
      args.push(arguments[i++]);
    }

    $replacer = replacer = args[1];
    if (!_isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined

    if (!_isArray(replacer)) replacer = function replacer(key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
}); // 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)

$Symbol[PROTOTYPE$2][TO_PRIMITIVE] || _hide($Symbol[PROTOTYPE$2], TO_PRIMITIVE, $Symbol[PROTOTYPE$2].valueOf); // 19.4.3.5 Symbol.prototype[@@toStringTag]

_setToStringTag($Symbol, 'Symbol'); // 20.2.1.9 Math[@@toStringTag]


_setToStringTag(Math, 'Math', true); // 24.3.3 JSON[@@toStringTag]


_setToStringTag(_global.JSON, 'JSON', true);

_wksDefine('asyncIterator');

_wksDefine('observable');

var symbol = _core.Symbol;
var symbol$1 = createCommonjsModule(function (module) {
  module.exports = {
    "default": symbol,
    __esModule: true
  };
});
unwrapExports(symbol$1);

var _typeof_1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;

  var _iterator2 = _interopRequireDefault(iterator$1);

  var _symbol2 = _interopRequireDefault(symbol$1);

  var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj;
  };

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
    return typeof obj === "undefined" ? "undefined" : _typeof(obj);
  } : function (obj) {
    return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
  };
});

unwrapExports(_typeof_1);
var possibleConstructorReturn = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;

  var _typeof3 = _interopRequireDefault(_typeof_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = function (self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
  };
});

var _possibleConstructorReturn$1 = unwrapExports(possibleConstructorReturn); // Works with __proto__ only. Old v8 can't work with null proto objects.

/* eslint-disable no-proto */


var check = function check(O, proto) {
  _anObject(O);

  if (!_isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};

var _setProto = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
  function (test, buggy, set) {
    try {
      set = _ctx(Function.call, _objectGopd.f(Object.prototype, '__proto__').set, 2);
      set(test, []);
      buggy = !(test instanceof Array);
    } catch (e) {
      buggy = true;
    }

    return function setPrototypeOf(O, proto) {
      check(O, proto);
      if (buggy) O.__proto__ = proto;else set(O, proto);
      return O;
    };
  }({}, false) : undefined),
  check: check
}; // 19.1.3.19 Object.setPrototypeOf(O, proto)

_export(_export.S, 'Object', {
  setPrototypeOf: _setProto.set
});

var setPrototypeOf = _core.Object.setPrototypeOf;
var setPrototypeOf$1 = createCommonjsModule(function (module) {
  module.exports = {
    "default": setPrototypeOf,
    __esModule: true
  };
});
unwrapExports(setPrototypeOf$1); // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])

_export(_export.S, 'Object', {
  create: _objectCreate
});

var $Object = _core.Object;

var create = function create(P, D) {
  return $Object.create(P, D);
};

var create$1 = createCommonjsModule(function (module) {
  module.exports = {
    "default": create,
    __esModule: true
  };
});
unwrapExports(create$1);
var inherits = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;

  var _setPrototypeOf2 = _interopRequireDefault(setPrototypeOf$1);

  var _create2 = _interopRequireDefault(create$1);

  var _typeof3 = _interopRequireDefault(_typeof_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = function (subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
    }

    subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
  };
});

var _inherits$1 = unwrapExports(inherits);

var objectWithoutProperties = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;

  exports.default = function (obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  };
});
unwrapExports(objectWithoutProperties); // most Object methods by ES6 should accept primitives

var _objectSap = function _objectSap(KEY, exec) {
  var fn = (_core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);

  _export(_export.S + _export.F * _fails(function () {
    fn(1);
  }), 'Object', exp);
}; // 19.1.2.14 Object.keys(O)


_objectSap('keys', function () {
  return function keys(it) {
    return _objectKeys(_toObject(it));
  };
});

var keys = _core.Object.keys;
var keys$1 = createCommonjsModule(function (module) {
  module.exports = {
    "default": keys,
    __esModule: true
  };
});

var _Object$keys = unwrapExports(keys$1);

var lib$1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var createChangeEmitter = exports.createChangeEmitter = function createChangeEmitter() {
    var currentListeners = [];
    var nextListeners = currentListeners;

    function ensureCanMutateNextListeners() {
      if (nextListeners === currentListeners) {
        nextListeners = currentListeners.slice();
      }
    }

    function listen(listener) {
      if (typeof listener !== 'function') {
        throw new Error('Expected listener to be a function.');
      }

      var isSubscribed = true;
      ensureCanMutateNextListeners();
      nextListeners.push(listener);
      return function () {
        if (!isSubscribed) {
          return;
        }

        isSubscribed = false;
        ensureCanMutateNextListeners();
        var index = nextListeners.indexOf(listener);
        nextListeners.splice(index, 1);
      };
    }

    function emit() {
      currentListeners = nextListeners;
      var listeners = currentListeners;

      for (var i = 0; i < listeners.length; i++) {
        listeners[i].apply(listeners, arguments);
      }
    }

    return {
      listen: listen,
      emit: emit
    };
  };
});
unwrapExports(lib$1);
var lib_1 = lib$1.createChangeEmitter;

function symbolObservablePonyfill(root) {
  var result;
  var Symbol = root.Symbol;

  if (typeof Symbol === 'function') {
    if (Symbol.observable) {
      result = Symbol.observable;
    } else {
      result = Symbol('observable');
      Symbol.observable = result;
    }
  } else {
    result = '@@observable';
  }

  return result;
}
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (typeof module !== 'undefined') {
  root = module;
} else {
  root = Function('return this')();
}

var result = symbolObservablePonyfill(root);

var setStatic = function setStatic(key, value) {
  return function (BaseComponent) {
    /* eslint-disable no-param-reassign */
    BaseComponent[key] = value;
    /* eslint-enable no-param-reassign */

    return BaseComponent;
  };
};

var setDisplayName = function setDisplayName(displayName) {
  return setStatic('displayName', displayName);
};

var getDisplayName = function getDisplayName(Component$$1) {
  if (typeof Component$$1 === 'string') {
    return Component$$1;
  }

  if (!Component$$1) {
    return undefined;
  }

  return Component$$1.displayName || Component$$1.name || 'Component';
};

var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
  return hocName + '(' + getDisplayName(BaseComponent) + ')';
};

var mapValues = function mapValues(obj, func) {
  var result = {};
  /* eslint-disable no-restricted-syntax */

  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      result[key] = func(obj[key], key);
    }
  }
  /* eslint-enable no-restricted-syntax */


  return result;
};

var withHandlers = function withHandlers(handlers) {
  return function (BaseComponent) {
    var factory = createFactory(BaseComponent);

    var WithHandlers = function (_Component) {
      _inherits$1(WithHandlers, _Component);

      function WithHandlers() {
        var _temp, _this, _ret;

        _classCallCheck$1(this, WithHandlers);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn$1(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn$1(_this, _ret);
      }

      WithHandlers.prototype.render = function render() {
        return factory(_extends$6({}, this.props, this.handlers));
      };

      return WithHandlers;
    }(Component);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.handlers = mapValues(typeof handlers === 'function' ? handlers(this.props) : handlers, function (createHandler) {
        return function () {
          var handler = createHandler(_this2.props);

          if (process.env.NODE_ENV !== 'production' && typeof handler !== 'function') {
            console.error( // eslint-disable-line no-console
            'withHandlers(): Expected a map of higher-order functions. ' + 'Refer to the docs for more info.');
          }

          return handler.apply(undefined, arguments);
        };
      });
    };

    if (process.env.NODE_ENV !== 'production') {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withHandlers'))(WithHandlers);
    }

    return WithHandlers;
  };
};

var withStateHandlers = function withStateHandlers(initialState, stateUpdaters) {
  return function (BaseComponent) {
    var factory = createFactory(BaseComponent);

    var WithStateHandlers = function (_Component) {
      _inherits$1(WithStateHandlers, _Component);

      function WithStateHandlers() {
        var _temp, _this, _ret;

        _classCallCheck$1(this, WithStateHandlers);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn$1(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn$1(_this, _ret);
      }

      WithStateHandlers.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        var propsChanged = nextProps !== this.props; // the idea is to skip render if stateUpdater handler return undefined
        // this allows to create no state update handlers with access to state and props

        var stateChanged = !shallowEqual_1(nextState, this.state);
        return propsChanged || stateChanged;
      };

      WithStateHandlers.prototype.render = function render() {
        return factory(_extends$6({}, this.props, this.state, this.stateUpdaters));
      };

      return WithStateHandlers;
    }(Component);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.state = typeof initialState === 'function' ? initialState(this.props) : initialState;
      this.stateUpdaters = mapValues(stateUpdaters, function (handler) {
        return function (mayBeEvent) {
          for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          } // Having that functional form of setState can be called async
          // we need to persist SyntheticEvent


          if (mayBeEvent && typeof mayBeEvent.persist === 'function') {
            mayBeEvent.persist();
          }

          _this2.setState(function (state, props) {
            return handler(state, props).apply(undefined, [mayBeEvent].concat(args));
          });
        };
      });
    };

    if (process.env.NODE_ENV !== 'production') {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withStateHandlers'))(WithStateHandlers);
    }

    return WithStateHandlers;
  };
};

var Nothing = function (_Component) {
  _inherits$1(Nothing, _Component);

  function Nothing() {
    _classCallCheck$1(this, Nothing);

    return _possibleConstructorReturn$1(this, _Component.apply(this, arguments));
  }

  Nothing.prototype.render = function render() {
    return null;
  };

  return Nothing;
}(Component);

var lifecycle = function lifecycle(spec) {
  return function (BaseComponent) {
    var factory = createFactory(BaseComponent);

    if (process.env.NODE_ENV !== 'production' && spec.hasOwnProperty('render')) {
      console.error('lifecycle() does not support the render method; its behavior is to ' + 'pass all props and state to the base component.');
    }

    var Lifecycle = function (_Component) {
      _inherits$1(Lifecycle, _Component);

      function Lifecycle() {
        _classCallCheck$1(this, Lifecycle);

        return _possibleConstructorReturn$1(this, _Component.apply(this, arguments));
      }

      Lifecycle.prototype.render = function render() {
        return factory(_extends$6({}, this.props, this.state));
      };

      return Lifecycle;
    }(Component);

    _Object$keys(spec).forEach(function (hook) {
      return Lifecycle.prototype[hook] = spec[hook];
    });

    if (process.env.NODE_ENV !== 'production') {
      return setDisplayName(wrapDisplayName(BaseComponent, 'lifecycle'))(Lifecycle);
    }

    return Lifecycle;
  };
};

var setPropTypes = function setPropTypes(propTypes) {
  return setStatic('propTypes', propTypes);
};

var compose$1 = function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  }, function (arg) {
    return arg;
  });
};

var _extends$7 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var enhance = compose$1(setDisplayName('Popper'), setPropTypes({
  renderRef: PropTypes.any.isRequired,
  renderPop: PropTypes.func,
  children: PropTypes.any,
  options: PropTypes.object,
  defaultIsOpened: PropTypes.bool,
  canClickOutside: PropTypes.bool
}), withStateHandlers({
  reference: null
}, {
  setReference: function setReference() {
    return function (reference) {
      if (reference) {
        return {
          reference: reference
        };
      }
    };
  }
}), withStateHandlers({
  pop: null,
  popper: null
}, {
  setPop: function setPop(_ref, props) {
    var prevPopper = _ref.popper;
    return function (pop) {
      if (prevPopper) {
        prevPopper.destroy();
      }

      var popper = pop ? new Popper(props.reference, pop, props.options) : null;
      return {
        pop: pop,
        popper: popper
      };
    };
  }
}), withStateHandlers(function (_ref2) {
  var _ref2$defaultIsOpened = _ref2.defaultIsOpened,
      defaultIsOpened = _ref2$defaultIsOpened === undefined ? false : _ref2$defaultIsOpened;
  return {
    isOpened: defaultIsOpened
  };
}, {
  open: function open(_, props) {
    return function () {
      return {
        isOpened: true
      };
    };
  },
  close: function close() {
    return function () {
      return {
        isOpened: false
      };
    };
  },
  toggle: function toggle(_ref3, props) {
    var isOpened = _ref3.isOpened;
    return function () {
      return {
        isOpened: !isOpened
      };
    };
  }
}), withHandlers({
  onClick: function onClick(props) {
    return function (e) {
      if (props.reference && !props.canClickOutside && !e.canBeIgnoredByReactPopper) {
        var isInsidePop = props.pop && props.pop.contains(e.target);

        if (!props.reference.contains(e.target) && !isInsidePop) {
          // click outside
          props.close();
        }
      }
    };
  }
}), lifecycle({
  componentDidUpdate: function componentDidUpdate() {
    if (this.props.popper) {
      this.props.popper.scheduleUpdate();
    }
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (this.props.options != nextProps.options && this.props.pop) {
      this.props.setPop(this.props.pop);
    }
  },
  componentWillMount: function componentWillMount() {
    document.addEventListener('mousedown', this.props.onClick);
  },
  componentWillUnmount: function componentWillUnmount() {
    document.removeEventListener('mousedown', this.props.onClick);

    if (this.props.popper) {
      this.props.popper.destroy();
    }
  }
}));
var Popper$1 = enhance(function (props) {
  return React.createElement(React.Fragment, null, props.renderRef(_extends$7({}, props)), props.isOpened && (props.renderPop ? props.renderPop(_extends$7({}, props)) : React.createElement('div', {
    ref: props.setPop,
    style: props.style,
    className: props.className
  }, props.children)));
});

var isBrowser$1 = function isBrowser() {
  return typeof window !== 'undefined' && typeof document !== 'undefined' ? true : false;
};

function _templateObject$m() {
  var data = _taggedTemplateLiteral(["\n  & {\n    background: ", ";\n    color: ", ";\n    border: ", ";\n    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);\n    border-radius: 4px;\n    display: flex;\n    align-items: center;\n    min-height: 24px;\n    margin: 4px;\n    padding: 12px;\n    line-height: 16px;\n    font-size: 12px;\n    z-index: 999999;\n  }\n"]);

  _templateObject$m = function _templateObject() {
    return data;
  };

  return data;
}
/**
 * Tooltip display a message near to an anchoring element when the user's mouse hovers or focus is set on anchoring element.
 */


var StyledTooltip = styled(Text)(_templateObject$m(), function (props) {
  return props.variant === 'dark' ? '#333' : '#FFF';
}, function (props) {
  return props.variant === 'dark' ? '#FFF' : '#666';
}, function (props) {
  return props.variant === 'dark' ? 'none' : '1px solid #CCCCCC';
});
StyledTooltip.defaultProps = {
  theme: theme,
  fontFamily: 'sansSerif'
};

var Tooltip = function Tooltip(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  var options = {
    placement: props.placement,
    modifiers: {
      offset: {
        offset: props.offset
      }
    }
  };

  var triggerElement = function triggerElement(_ref2) {
    var setReference = _ref2.setReference,
        toggle = _ref2.toggle;
    return React.cloneElement(children, {
      ref: setReference,
      onMouseEnter: toggle,
      onMouseLeave: toggle
    });
  };

  if (isBrowser$1()) {
    return React.createElement(Popper$1, {
      options: options,
      renderRef: triggerElement,
      style: {
        zIndex: 99999
      }
    }, React.createElement(StyledTooltip, {
      variant: props.variant,
      children: props.message
    }));
  } else {
    return children;
  }
};

Tooltip.displayName = 'Tooltip';
Tooltip.defaultProps = {
  variant: 'dark',
  placement: 'bottom',
  offset: '0, 0',
  message: 'props.message text'
};
Tooltip.propTypes = {
  /** Sets the theme of tooltip. Options are light or dark. */
  variant: PropTypes.oneOf(['light', 'dark']),

  /** Sets the placement of tooltip relative to anchoring element. */
  placement: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),

  /** Sets the placement of tooltip relative to anchoring element. */
  offset: PropTypes.string,

  /** Sets the content of tooltip. Only accepts text and not markup. */
  message: PropTypes.string
};

function _templateObject2$7() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  html {\n    box-sizing: border-box;\n  }\n  *, *:before, *:after {\n    box-sizing: inherit;\n  }\n  ::selection {\n    background: ", ";\n  }\n"]);

  _templateObject2$7 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$n() {
  var data = _taggedTemplateLiteral(["\n  & {\n    font-size: 1em;\n    font-family: ", ";\n    color: ", ";\n  }\n"]);

  _templateObject$n = function _templateObject() {
    return data;
  };

  return data;
}

var Base = styled.div(_templateObject$n(), function (props) {
  return props.theme.fonts.sansSerif;
}, function (props) {
  return props.theme.colors.copyColor;
});
var GlobalStyle = createGlobalStyle(_templateObject2$7(), normalize(), function (props) {
  return curriedTransparentize(0.7, props.theme.colors.primary);
});

var ThemeProvider = function ThemeProvider(_ref) {
  var children = _ref.children,
      theme = _ref.theme,
      props = _objectWithoutProperties(_ref, ["children", "theme"]);

  return React.createElement(ThemeProvider$1, _extends({
    theme: theme
  }, props), React.createElement(React.Fragment, null, React.createElement(GlobalStyle, null), React.createElement(Base, {
    children: children
  })));
};

ThemeProvider.propTypes = {
  theme: PropTypes.object
};
ThemeProvider.defaultProps = {
  theme: theme
};
ThemeProvider.displayName = 'ThemeProvider';

function _templateObject2$8() {
  var data = _taggedTemplateLiteral(["\n  & {\n    display: block;\n    position: relative;\n    overflow: hidden;\n  }\n\n  > svg {\n    fill: currentColor;\n    height: 100%;\n    width: 100%;\n    display: block;\n    animation: ", " 1000ms linear infinite;\n    animation-timing-function: cubic-bezier(0.445, 0.05, 0.55, 0.95);\n  }\n"]);

  _templateObject2$8 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$o() {
  var data = _taggedTemplateLiteral(["\n  0% {\n    transform: rotate(225deg);\n  }\n\n  100% {\n    transform: rotate(585deg);\n  }\n"]);

  _templateObject$o = function _templateObject() {
    return data;
  };

  return data;
}

var rotate = keyframes(_templateObject$o());
var Rotate = styled(Box)(_templateObject2$8(), rotate);
var Loader = React.forwardRef(function (props, ref) {
  return React.createElement(Rotate, _extends({
    ref: ref
  }, props), React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20.5714C16.7339 20.5714 20.5714 16.7339 20.5714 12C20.5714 7.26613 16.7339 3.42857 12 3.42857C7.26613 3.42857 3.42857 7.26613 3.42857 12C3.42857 16.7339 7.26613 20.5714 12 20.5714ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "currentColor",
    opacity: "0.25"
  }), React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20.5714C16.7339 20.5714 20.5714 16.7339 20.5714 12C20.5714 7.26613 16.7339 3.42857 12 3.42857C7.26613 3.42857 3.42857 7.26613 3.42857 12C3.42857 16.7339 7.26613 20.5714 12 20.5714ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "currentColor"
  })), React.createElement("g", {
    mask: "url(#mask0)"
  }, React.createElement("path", {
    d: "M12 24V15.8824V12H24V24H12Z",
    fill: "currentColor"
  }))));
});
Loader.defaultProps = {
  color: 'primary',
  bg: 'transparent',
  size: '1rem'
};
Loader.propTypes = _objectSpread2({}, Box.propTypes);
Loader.displayName = 'Loader';

function _extends$8() {
  _extends$8 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$8.apply(this, arguments);
}

function _objectWithoutProperties$3(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$3(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose$3(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var _ref2$2 =
/*#__PURE__*/
React.createElement("rect", {
  y: 5,
  width: 6,
  height: 6,
  rx: 1,
  fill: "#4E3FCE",
  fillOpacity: 0.1
});

var _ref3$1 =
/*#__PURE__*/
React.createElement("rect", {
  x: 30,
  y: 30,
  width: 6,
  height: 6,
  rx: 1,
  fill: "#4E3FCE",
  fillOpacity: 0.1
});

var _ref4$1 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10 1a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1V1z",
  fill: "#4E3FCE",
  fillOpacity: 0.5
});

var _ref5$1 =
/*#__PURE__*/
React.createElement("rect", {
  x: 20,
  y: 15,
  width: 6,
  height: 6,
  rx: 1,
  fill: "#4E3FCE",
  fillOpacity: 0.5
});

var _ref6 =
/*#__PURE__*/
React.createElement("rect", {
  x: 20,
  y: 25,
  width: 6,
  height: 6,
  rx: 1,
  fill: "#4E3FCE",
  fillOpacity: 0.5
});

var _ref7 =
/*#__PURE__*/
React.createElement("rect", {
  x: 10,
  y: 20,
  width: 6,
  height: 6,
  rx: 1,
  fill: "#4E3FCE",
  fillOpacity: 0.5
});

var _ref8 =
/*#__PURE__*/
React.createElement("rect", {
  y: 15,
  width: 6,
  height: 6,
  rx: 1,
  fill: "#4E3FCE",
  fillOpacity: 0.7
});

var _ref9 =
/*#__PURE__*/
React.createElement("rect", {
  x: 30,
  width: 6,
  height: 6,
  rx: 1,
  fill: "#4E3FCE",
  fillOpacity: 0.1
});

var _ref10 =
/*#__PURE__*/
React.createElement("rect", {
  x: 30,
  y: 20,
  width: 6,
  height: 6,
  rx: 1,
  fill: "#4E3FCE",
  fillOpacity: 0.1
});

var _ref11 =
/*#__PURE__*/
React.createElement("rect", {
  x: 30,
  y: 10,
  width: 6,
  height: 6,
  rx: 1,
  fill: "#4E3FCE",
  fillOpacity: 0.7
});

var _ref12 =
/*#__PURE__*/
React.createElement("rect", {
  x: 10,
  y: 10,
  width: 6,
  height: 6,
  rx: 1,
  fill: "#4E3FCE",
  fillOpacity: 0.9
});

var _ref13 =
/*#__PURE__*/
React.createElement("rect", {
  x: 20,
  y: 5,
  width: 6,
  height: 6,
  rx: 1,
  fill: "#4E3FCE",
  fillOpacity: 0.9
});

var SvgIconProcessing = function SvgIconProcessing(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties$3(_ref, ["svgRef"]);

  return React.createElement("svg", _extends$8({
    width: "1em",
    height: "1em",
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), _ref2$2, _ref3$1, _ref4$1, _ref5$1, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

var ForwardRef$2 = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconProcessing, _extends$8({
    svgRef: ref
  }, props));
});

function _templateObject2$9() {
  var data = _taggedTemplateLiteral(["\n  & {\n    display: block;\n  }\n  > * {\n    animation-name: ", ";\n    animation-duration: ", ";\n    animation-timing-function: ease;\n    animation-delay: 0s;\n    animation-iteration-count: infinite;\n  }\n  > *:nth-child(4n + 0) {\n    animation-duration: ", ";\n    animation-delay: ", ";\n  }\n  > *:nth-child(2n + 0) {\n    animation-duration: ", ";\n  }\n  > *:nth-child(3n + 0) {\n    animation-duration: ", ";\n    animation-delay: ", ";\n  }\n"]);

  _templateObject2$9 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$p() {
  var data = _taggedTemplateLiteral(["\n  0% {\n    opacity: 0.1;\n    transform: translateY(-1px);\n  }\n  20% {\n    opacity: 0.6;\n  }\n  40% {\n    opacity: 0.9;\n    transform: translateY(1px);\n  }\n  60% {\n    opacity: 0.5;\n    transform: translateY(2px);\n  }\n  100% {\n    opacity: 0;\n    transform: translateY(3px);\n  }\n"]);

  _templateObject$p = function _templateObject() {
    return data;
  };

  return data;
}

var WrappedIconProcessing = function WrappedIconProcessing(props) {
  return React.createElement(ForwardRef$2, props);
};

var flicker = keyframes(_templateObject$p());
var AnimatedIconProcessing = styled(WrappedIconProcessing).attrs({
  seed: Math.floor(1000 + Math.random() * 7000),
  seeda: Math.floor(Date.now().toString().substring(2, 6) + Math.random() * 9000).toString().substring(0, 4),
  seedb: Math.floor(Date.now().toString().substring(0, 4) + Math.random() * 4500).toString().substring(0, 4)
})(_templateObject2$9(), flicker, function (props) {
  return props.seed + 'ms';
}, function (props) {
  return props.seeda + 'ms';
}, function (props) {
  return props.seeda + 'ms';
}, function (props) {
  return props.seedb + 'ms';
}, function (props) {
  return props.seeda + 'ms';
}, function (props) {
  return props.seedb + 'ms';
});

function _extends$9() {
  _extends$9 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$9.apply(this, arguments);
}

function _objectWithoutProperties$4(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$4(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose$4(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var _ref2$3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18 36c9.941 0 18-8.059 18-18S27.941 0 18 0 0 8.059 0 18s8.059 18 18 18z",
  fill: "#DFF6EC"
});

var _ref3$2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.616 14.284c.472.412.515 1.123.096 1.588l-6.084 6.75a1.153 1.153 0 01-1.633.077l-3.63-3.323a1.113 1.113 0 01-.059-1.59 1.156 1.156 0 011.615-.058l2.773 2.539 5.308-5.889a1.156 1.156 0 011.614-.095z",
  fill: "#33C489"
});

var SvgIconPositive = function SvgIconPositive(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties$4(_ref, ["svgRef"]);

  return React.createElement("svg", _extends$9({
    width: "1em",
    height: "1em",
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), _ref2$3, _ref3$2);
};

var ForwardRef$3 = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconPositive, _extends$9({
    svgRef: ref
  }, props));
});

function _templateObject$q() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject$q = function _templateObject() {
    return data;
  };

  return data;
}

var WrappedIconPositive = function WrappedIconPositive(props) {
  return React.createElement(ForwardRef$3, props);
};

var IconPositive = styled(WrappedIconPositive)(_templateObject$q());

function _extends$a() {
  _extends$a = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$a.apply(this, arguments);
}

function _objectWithoutProperties$5(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$5(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose$5(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var _ref2$4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M0 0h36v36H0z"
});

var _ref3$3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.083 3.526a1 1 0 011.738 0l16.232 28.506a1 1 0 01-.87 1.495H1.72a1 1 0 01-.869-1.495L17.083 3.526z",
  fill: "#DC2C10",
  fillOpacity: 0.15
});

var _ref4$2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18 15a1 1 0 00-1 1v6a1 1 0 102 0v-6a1 1 0 00-1-1zm-1 10.333a1 1 0 112 0 1 1 0 01-2 0z",
  fill: "#DC2C10"
});

var SvgIconNegative = function SvgIconNegative(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties$5(_ref, ["svgRef"]);

  return React.createElement("svg", _extends$a({
    width: "1em",
    height: "1em",
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), _ref2$4, _ref3$3, _ref4$2);
};

var ForwardRef$4 = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconNegative, _extends$a({
    svgRef: ref
  }, props));
});

function _templateObject$r() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject$r = function _templateObject() {
    return data;
  };

  return data;
}

var WrappedIconNegative = function WrappedIconNegative(props) {
  return React.createElement(ForwardRef$4, props);
};

var IconNegative = styled(WrappedIconNegative)(_templateObject$r());

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  & {\n    pointer-events: all;\n    user-select: none;\n    overflow: hidden;\n    display: flex;\n    flex-flow: row nowrap;\n    align-items: center;\n    height: 80px;\n    padding: 0 1rem;\n    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.1);\n    transition: all 0.15s ease;\n  }\n\n  &:hover {\n    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.15);\n  }\n\n  > .iconBox {\n    display: none;\n  }\n\n  > .closeBttn {\n    display: none;\n  }\n\n  > ", " > div {\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    word-wrap: normal;\n  }\n\n  @media screen and (max-width: 420px) {\n    border-color: transparent;\n  }\n\n  @media screen and (min-width: 420px) {\n    & {\n      border-radius: 4px;\n      padding: ", ";\n    }\n\n    > .iconBox {\n      display: block;\n    }\n\n    > .closeBttn {\n      display: flex;\n      align-self: flex-start;\n    }\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  & {\n    ", "\n    text-align: left;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  & {\n    display: block;\n    position: fixed;\n    z-index: 9999;\n    top: auto;\n    bottom: 0;\n    left: auto;\n    right: 0;\n    width: 100%;\n    max-width: 100%;\n    pointer-events: none;\n  }\n\n  @media screen and (min-width: 420px) {\n    width: 420px;\n    padding: 1rem;\n  }\n\n  > div {\n    width: 100%;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  & {\n    animation-name: ", ";\n    animation-duration: ", ";\n    animation-timing-function: ", ";\n    animation-delay: 0s;\n    animation-iteration-count: 1;\n    animation-direction: normal;\n    animation-fill-mode: forwards;\n    animation-play-state: running;\n  }\n  @media screen and (min-width: 420px) {\n    animation-name: ", ";\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$2() {
  var data = _taggedTemplateLiteral(["\n  from {\n    opacity: 1;\n    transform: translateX(0);\n  }\n\n  to {\n    opacity: 0;\n    transform: translateX(120%);\n  }\n"]);

  _templateObject3$2 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$a() {
  var data = _taggedTemplateLiteral(["\n  from {\n    opacity: 1;\n    transform: translateY(0);\n  }\n\n  to {\n    opacity: 0;\n    transform: translateY(120%);\n  }\n"]);

  _templateObject2$a = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$s() {
  var data = _taggedTemplateLiteral(["\n  from {\n    transform: translateY(100%);\n  }\n\n  to {\n    transform: translateY(0);\n  }\n"]);

  _templateObject$s = function _templateObject() {
    return data;
  };

  return data;
}

var animInKeyframes = keyframes(_templateObject$s());
var animOutKeyframes = keyframes(_templateObject2$a());
var animOutKeyframesDesktop = keyframes(_templateObject3$2());
var AnimationWrapper = styled.div(_templateObject4(), function (props) {
  return props.direction ? animOutKeyframes : animInKeyframes;
}, function (props) {
  return props.direction ? '500ms' : '300ms';
}, function (props) {
  return props.direction ? timingFunctions('easeOutSine') : 'ease';
}, function (props) {
  return props.direction ? animOutKeyframesDesktop : animInKeyframes;
});
var StyledToastContainer = styled.div(_templateObject5());
var StyledTextCell = styled(Box)(_templateObject6(), ellipsis());
var StyledToastMessage = styled(Box)(_templateObject7(), StyledTextCell, function (props) {
  return props.closeElem ? '0 0 0 1rem' : '0 1rem';
});
var ToastMessage = React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  var themeIsDark = props.colorTheme === 'dark' ? true : false;

  var renderVariantSvg = function renderVariantSvg(variant) {
    switch (variant) {
      case 'processing':
        return React.createElement(AnimatedIconProcessing, {
          width: '32px',
          height: '32px'
        });
        break;

      case 'success':
        return React.createElement(IconPositive, {
          width: '32px',
          height: '32px'
        });
        break;

      case 'failure':
        return React.createElement(IconNegative, {
          width: '32px',
          height: '32px'
        });
        break;

      default:
        return '';
    }
  };

  var renderFigure = function renderFigure(_ref2) {
    var variant = _ref2.variant,
        icon = _ref2.icon;

    if (variant && variant !== 'default') {
      return React.createElement(Box, {
        className: 'iconBox',
        flex: '0 0',
        mr: 2
      }, renderVariantSvg(variant));
    } else if (icon && icon.length) {
      return React.createElement(Box, {
        className: 'iconBox',
        flex: '0 0',
        mr: 2
      }, React.createElement(Icon$1, {
        name: icon,
        color: !themeIsDark ? 'primary' : 'white',
        size: '32px'
      }));
    } else {
      return null;
    }
  };

  var renderCloseBttn = function renderCloseBttn(_ref3) {
    var closeElem = _ref3.closeElem,
        closeFunction = _ref3.closeFunction;

    if (closeElem) {
      return React.createElement(Button$2.Text, {
        onClick: closeFunction,
        className: 'closeBttn',
        size: 'small',
        icononly: true
      }, React.createElement(Icon$1, {
        name: 'Close',
        size: '16px',
        color: !themeIsDark ? '#666' : '#afafaf'
      }));
    } else {
      return null;
    }
  };

  return React.createElement(StyledToastMessage, _extends({
    className: className,
    bg: !themeIsDark ? 'white' : 'near-black',
    border: 1,
    borderColor: !themeIsDark ? '#D6D6D6' : 'transparent',
    ref: ref
  }, props), renderFigure(props), React.createElement(StyledTextCell, {
    flex: '1 1 auto',
    mx: 2
  }, props.message && React.createElement(Text, {
    fontSize: 1,
    fontWeight: 3,
    color: !themeIsDark ? 'black' : 'white'
  }, props.message), props.secondaryMessage && React.createElement(Text, {
    fontSize: 1,
    color: !themeIsDark ? '#666' : '#afafaf'
  }, props.secondaryMessage)), React.createElement(Text, {
    flex: '0 1',
    mr: 2,
    textAlign: 'right',
    lineHeight: '18px'
  }, props.actionText && props.actionHref && React.createElement(Link$1, {
    href: props.actionHref,
    target: '_blank',
    color: !themeIsDark ? 'primary' : '#9387FF'
  }, props.actionText)), renderCloseBttn(props));
});

var ProtoToastMessage =
/*#__PURE__*/
function (_Component) {
  _inherits(ProtoToastMessage, _Component);

  function ProtoToastMessage(props) {
    var _this;

    _classCallCheck(this, ProtoToastMessage);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProtoToastMessage).call(this, props));

    _this.handleClose = function (e) {
      e.preventDefault();
    };

    return _this;
  }

  _createClass(ProtoToastMessage, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          message = _this$props.message,
          secondaryMessage = _this$props.secondaryMessage,
          actionHref = _this$props.actionHref,
          actionText = _this$props.actionText,
          variant = _this$props.variant,
          icon = _this$props.icon;
      return React.createElement(ToastMessage, _extends({
        message: message,
        secondaryMessage: secondaryMessage,
        actionHref: actionHref,
        actionText: actionText
      }, this.props));
    }
  }]);

  return ProtoToastMessage;
}(Component);

ProtoToastMessage.displayName = 'Proto Toast Message';
ProtoToastMessage.defaultProps = {
  message: 'Message text… ',
  secondaryMessage: '',
  actionHref: '',
  actionText: '',
  variant: '',
  icon: '',
  colorTheme: 'dark',
  closeElem: true
};

var ToastProvider =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ToastProvider, _React$Component);

  function ToastProvider(props) {
    var _this2;

    _classCallCheck(this, ToastProvider);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(ToastProvider).call(this, props));

    _this2.addMessage = function (msg, data) {
      if (!msg) {
        return false;
      }

      _this2.setState(function () {
        return {
          isOpen: false
        };
      }, function () {
        setTimeout(function () {
          _this2.setState(function () {
            return {
              isOpen: true,
              unMount: false,
              currentMsg: _objectSpread2({
                message: msg
              }, data)
            };
          }, function () {
            _this2.startTimer();
          });
        }, 500);
      });
    };

    _this2.removeMessage = function () {
      if (!_this2.state.isOpen) {
        return null;
      }

      _this2.clearTimer();

      _this2.setState(function (state, props) {
        return {
          isOpen: false
        };
      });
    };

    _this2.startTimer = function () {
      if (!document.hasFocus()) {
        return null;
      }

      _this2.clearTimer();

      _this2.timer = setTimeout(function () {
        _this2.removeMessage();
      }, _this2.props.delay);
    };

    _this2.clearTimer = function () {
      clearTimeout(_this2.timer);
    };

    _this2.handleClose = function (e) {
      e.preventDefault();
    };

    _this2.handleEnter = function (e) {
      e.preventDefault();

      _this2.clearTimer();
    };

    _this2.handleLeave = function (e) {
      e.preventDefault();

      _this2.startTimer();
    };

    _this2.renderMessage = function () {
      return React.createElement(ProtoToastMessage, _extends({}, _this2.state.currentMsg, {
        onMouseEnter: _this2.handleEnter,
        onMouseLeave: _this2.handleLeave,
        closeFunction: _this2.removeMessage
      }));
    };

    _this2.state = {
      isReady: false,
      isOpen: false,
      unMount: true,
      currentMsg: _this2.props.messageData
    };
    _this2.timer = {};
    return _this2;
  }

  _createClass(ToastProvider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;

      this.setState(function (state, props) {
        return {
          isReady: true
        };
      });

      window.onfocus = function () {
        _this3.startTimer();
      };

      window.onblur = function () {
        _this3.clearTimer();
      };
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.onfocus = null;
      window.onblur = null;
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.state.isReady) {
        return null;
      }

      return React.createElement(StyledToastContainer, null, !this.state.unMount && React.createElement(AnimationWrapper, {
        direction: this.state.isOpen ? null : 'out'
      }, this.renderMessage()));
    }
  }]);

  return ToastProvider;
}(React.Component);

ToastProvider.displayName = 'Toast Message Provider';
ToastProvider.defaultProps = {
  messageData: {
    message: '[…Placeholder Message…]',
    secondaryMessage: '',
    actionHref: '',
    actionText: '',
    icon: '',
    variant: 'default'
  },
  delay: 3000
};
ToastMessage.Success = React.forwardRef(function (props, ref) {
  return React.createElement(ToastMessage, _extends({
    ref: ref
  }, props, {
    variant: 'success'
  }));
});
ToastMessage.Failure = React.forwardRef(function (props, ref) {
  return React.createElement(ToastMessage, _extends({
    ref: ref
  }, props, {
    variant: 'failure'
  }));
});
ToastMessage.Processing = React.forwardRef(function (props, ref) {
  return React.createElement(ToastMessage, _extends({
    ref: ref
  }, props, {
    variant: 'processing'
  }));
});
ToastMessage.Provider = ToastProvider;
ToastMessage.defaultProps = {
  message: 'Write update here [Required]',
  secondaryMessage: '',
  actionHref: '',
  actionText: '',
  variant: 'default',
  icon: '',
  colorTheme: 'light',
  closeElem: false
};
ToastMessage.propTypes = {
  /**
   * Sets primary message text
   */
  message: PropTypes.string,

  /**
   * Sets secondary message text
   */
  secondaryMessage: PropTypes.string,

  /**
   * Sets URL for button
   */
  actionHref: PropTypes.string,

  /**
   * Sets text for button
   */
  actionText: PropTypes.string,

  /**
   * Sets type of ToastMessage to display
   */
  variant: PropTypes.oneOf(['default', 'success', 'failure', 'processing']),

  /**
   * Sets icon to display
   */
  icon: PropTypes.string,

  /**
   * Sets background and text color
   */
  colorTheme: PropTypes.oneOf(['light', 'dark']),

  /**
   * Allows ToastMessage to be closed by user
   */
  closeElem: PropTypes.bool
};
ToastMessage.displayName = 'ToastMessage';

function _templateObject$t() {
  var data = _taggedTemplateLiteral(["\n  & {\n    position: relative;\n    background: none;\n    overflow: hidden;\n  }\n  &::before {\n    content: '';\n    display: block;\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    height: 100%;\n    width: 100%;\n    background-color: currentColor;\n    opacity: 0.12;\n    pointer-events: none;\n  }\n"]);

  _templateObject$t = function _templateObject() {
    return data;
  };

  return data;
}

var StyledPill = styled(Text)(_templateObject$t());
var Pill = React.forwardRef(function (props, ref) {
  return React.createElement(StyledPill, _extends({
    ref: ref
  }, props));
});
Pill.defaultProps = {
  color: 'dark-gray',
  fontFamily: 'sansSerif',
  fontSize: 1,
  fontWeight: 2,
  lineHeight: 'solid',
  height: 2,
  px: 3,
  py: 1,
  borderRadius: 3,
  display: 'inline-flex',
  alignItems: 'center'
};
Pill.propTypes = _objectSpread2({}, Text.propTypes, {
  theme: PropTypes.object
});
Pill.displayName = 'Pill';
var portalRoot = isBrowser$1() ? document.body : null;

var Portal =
/*#__PURE__*/
function (_Component) {
  _inherits(Portal, _Component);

  function Portal(props) {
    var _this;

    _classCallCheck(this, Portal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Portal).call(this, props));
    _this.el = isBrowser$1() ? document.createElement('div') : null;
    return _this;
  }

  _createClass(Portal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      portalRoot.appendChild(this.el);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      portalRoot.removeChild(this.el);
    }
  }, {
    key: "render",
    value: function render() {
      if (isBrowser$1()) {
        return ReactDOM.createPortal(this.props.children, this.el);
      } // ssr


      return null;
    }
  }]);

  return Portal;
}(Component);

Portal.propTypes = {
  children: PropTypes.element.isRequired
};

function _templateObject$u() {
  var data = _taggedTemplateLiteral(["\n  & {\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    z-index: 9999;\n    height: 100vh;\n    width: 100vw;\n    display: flex;\n    flex-flow: column;\n    place-items: center;\n    place-content: center;\n  }\n"]);

  _templateObject$u = function _templateObject() {
    return data;
  };

  return data;
}

var StyledOverlay = styled(Box)(_templateObject$u());
StyledOverlay.defaultProps = {
  bg: 'blacks.10',
  p: 3
};

var Modal =
/*#__PURE__*/
function (_Component) {
  _inherits(Modal, _Component);

  function Modal(props) {
    var _this;

    _classCallCheck(this, Modal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Modal).call(this, props));

    _this.closeModal = function (e) {
      e.preventDefault();

      _this.setState(function (state, props) {
        return {
          isOpen: false
        };
      });
    };

    _this.openModal = function (e) {
      e.preventDefault();

      _this.setState(function (state, props) {
        return {
          isOpen: true
        };
      });
    };

    _this.state = {
      isOpen: _this.props.isOpen || false
    };
    return _this;
  }

  _createClass(Modal, [{
    key: "render",
    value: function render() {
      if (!this.props.isOpen) {
        return null;
      }

      return React.createElement(Portal, null, React.createElement(StyledOverlay, null, this.props.children));
    }
  }]);

  return Modal;
}(Component);

Modal.defaultProps = {
  isOpen: false
};
Modal.propTypes = {
  /**
   * Shows the content of the Modal when true
   */
  isOpen: PropTypes.bool
};
Modal.displayName = 'Modal';
var mode = {
  MODE_NUMBER: 1 << 0,
  MODE_ALPHA_NUM: 1 << 1,
  MODE_8BIT_BYTE: 1 << 2,
  MODE_KANJI: 1 << 3
};

function QR8bitByte(data) {
  this.mode = mode.MODE_8BIT_BYTE;
  this.data = data;
}

QR8bitByte.prototype = {
  getLength: function getLength(buffer) {
    return this.data.length;
  },
  write: function write(buffer) {
    for (var i = 0; i < this.data.length; i++) {
      // not JIS ...
      buffer.put(this.data.charCodeAt(i), 8);
    }
  }
};
var _8BitByte = QR8bitByte;
var ErrorCorrectLevel = {
  L: 1,
  M: 0,
  Q: 3,
  H: 2
}; // ErrorCorrectLevel

function QRRSBlock(totalCount, dataCount) {
  this.totalCount = totalCount;
  this.dataCount = dataCount;
}

QRRSBlock.RS_BLOCK_TABLE = [// L
// M
// Q
// H
// 1
[1, 26, 19], [1, 26, 16], [1, 26, 13], [1, 26, 9], // 2
[1, 44, 34], [1, 44, 28], [1, 44, 22], [1, 44, 16], // 3
[1, 70, 55], [1, 70, 44], [2, 35, 17], [2, 35, 13], // 4		
[1, 100, 80], [2, 50, 32], [2, 50, 24], [4, 25, 9], // 5
[1, 134, 108], [2, 67, 43], [2, 33, 15, 2, 34, 16], [2, 33, 11, 2, 34, 12], // 6
[2, 86, 68], [4, 43, 27], [4, 43, 19], [4, 43, 15], // 7		
[2, 98, 78], [4, 49, 31], [2, 32, 14, 4, 33, 15], [4, 39, 13, 1, 40, 14], // 8
[2, 121, 97], [2, 60, 38, 2, 61, 39], [4, 40, 18, 2, 41, 19], [4, 40, 14, 2, 41, 15], // 9
[2, 146, 116], [3, 58, 36, 2, 59, 37], [4, 36, 16, 4, 37, 17], [4, 36, 12, 4, 37, 13], // 10		
[2, 86, 68, 2, 87, 69], [4, 69, 43, 1, 70, 44], [6, 43, 19, 2, 44, 20], [6, 43, 15, 2, 44, 16], // 11
[4, 101, 81], [1, 80, 50, 4, 81, 51], [4, 50, 22, 4, 51, 23], [3, 36, 12, 8, 37, 13], // 12
[2, 116, 92, 2, 117, 93], [6, 58, 36, 2, 59, 37], [4, 46, 20, 6, 47, 21], [7, 42, 14, 4, 43, 15], // 13
[4, 133, 107], [8, 59, 37, 1, 60, 38], [8, 44, 20, 4, 45, 21], [12, 33, 11, 4, 34, 12], // 14
[3, 145, 115, 1, 146, 116], [4, 64, 40, 5, 65, 41], [11, 36, 16, 5, 37, 17], [11, 36, 12, 5, 37, 13], // 15
[5, 109, 87, 1, 110, 88], [5, 65, 41, 5, 66, 42], [5, 54, 24, 7, 55, 25], [11, 36, 12], // 16
[5, 122, 98, 1, 123, 99], [7, 73, 45, 3, 74, 46], [15, 43, 19, 2, 44, 20], [3, 45, 15, 13, 46, 16], // 17
[1, 135, 107, 5, 136, 108], [10, 74, 46, 1, 75, 47], [1, 50, 22, 15, 51, 23], [2, 42, 14, 17, 43, 15], // 18
[5, 150, 120, 1, 151, 121], [9, 69, 43, 4, 70, 44], [17, 50, 22, 1, 51, 23], [2, 42, 14, 19, 43, 15], // 19
[3, 141, 113, 4, 142, 114], [3, 70, 44, 11, 71, 45], [17, 47, 21, 4, 48, 22], [9, 39, 13, 16, 40, 14], // 20
[3, 135, 107, 5, 136, 108], [3, 67, 41, 13, 68, 42], [15, 54, 24, 5, 55, 25], [15, 43, 15, 10, 44, 16], // 21
[4, 144, 116, 4, 145, 117], [17, 68, 42], [17, 50, 22, 6, 51, 23], [19, 46, 16, 6, 47, 17], // 22
[2, 139, 111, 7, 140, 112], [17, 74, 46], [7, 54, 24, 16, 55, 25], [34, 37, 13], // 23
[4, 151, 121, 5, 152, 122], [4, 75, 47, 14, 76, 48], [11, 54, 24, 14, 55, 25], [16, 45, 15, 14, 46, 16], // 24
[6, 147, 117, 4, 148, 118], [6, 73, 45, 14, 74, 46], [11, 54, 24, 16, 55, 25], [30, 46, 16, 2, 47, 17], // 25
[8, 132, 106, 4, 133, 107], [8, 75, 47, 13, 76, 48], [7, 54, 24, 22, 55, 25], [22, 45, 15, 13, 46, 16], // 26
[10, 142, 114, 2, 143, 115], [19, 74, 46, 4, 75, 47], [28, 50, 22, 6, 51, 23], [33, 46, 16, 4, 47, 17], // 27
[8, 152, 122, 4, 153, 123], [22, 73, 45, 3, 74, 46], [8, 53, 23, 26, 54, 24], [12, 45, 15, 28, 46, 16], // 28
[3, 147, 117, 10, 148, 118], [3, 73, 45, 23, 74, 46], [4, 54, 24, 31, 55, 25], [11, 45, 15, 31, 46, 16], // 29
[7, 146, 116, 7, 147, 117], [21, 73, 45, 7, 74, 46], [1, 53, 23, 37, 54, 24], [19, 45, 15, 26, 46, 16], // 30
[5, 145, 115, 10, 146, 116], [19, 75, 47, 10, 76, 48], [15, 54, 24, 25, 55, 25], [23, 45, 15, 25, 46, 16], // 31
[13, 145, 115, 3, 146, 116], [2, 74, 46, 29, 75, 47], [42, 54, 24, 1, 55, 25], [23, 45, 15, 28, 46, 16], // 32
[17, 145, 115], [10, 74, 46, 23, 75, 47], [10, 54, 24, 35, 55, 25], [19, 45, 15, 35, 46, 16], // 33
[17, 145, 115, 1, 146, 116], [14, 74, 46, 21, 75, 47], [29, 54, 24, 19, 55, 25], [11, 45, 15, 46, 46, 16], // 34
[13, 145, 115, 6, 146, 116], [14, 74, 46, 23, 75, 47], [44, 54, 24, 7, 55, 25], [59, 46, 16, 1, 47, 17], // 35
[12, 151, 121, 7, 152, 122], [12, 75, 47, 26, 76, 48], [39, 54, 24, 14, 55, 25], [22, 45, 15, 41, 46, 16], // 36
[6, 151, 121, 14, 152, 122], [6, 75, 47, 34, 76, 48], [46, 54, 24, 10, 55, 25], [2, 45, 15, 64, 46, 16], // 37
[17, 152, 122, 4, 153, 123], [29, 74, 46, 14, 75, 47], [49, 54, 24, 10, 55, 25], [24, 45, 15, 46, 46, 16], // 38
[4, 152, 122, 18, 153, 123], [13, 74, 46, 32, 75, 47], [48, 54, 24, 14, 55, 25], [42, 45, 15, 32, 46, 16], // 39
[20, 147, 117, 4, 148, 118], [40, 75, 47, 7, 76, 48], [43, 54, 24, 22, 55, 25], [10, 45, 15, 67, 46, 16], // 40
[19, 148, 118, 6, 149, 119], [18, 75, 47, 31, 76, 48], [34, 54, 24, 34, 55, 25], [20, 45, 15, 61, 46, 16]];

QRRSBlock.getRSBlocks = function (typeNumber, errorCorrectLevel) {
  var rsBlock = QRRSBlock.getRsBlockTable(typeNumber, errorCorrectLevel);

  if (rsBlock == undefined) {
    throw new Error("bad rs block @ typeNumber:" + typeNumber + "/errorCorrectLevel:" + errorCorrectLevel);
  }

  var length = rsBlock.length / 3;
  var list = new Array();

  for (var i = 0; i < length; i++) {
    var count = rsBlock[i * 3 + 0];
    var totalCount = rsBlock[i * 3 + 1];
    var dataCount = rsBlock[i * 3 + 2];

    for (var j = 0; j < count; j++) {
      list.push(new QRRSBlock(totalCount, dataCount));
    }
  }

  return list;
};

QRRSBlock.getRsBlockTable = function (typeNumber, errorCorrectLevel) {
  switch (errorCorrectLevel) {
    case ErrorCorrectLevel.L:
      return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 0];

    case ErrorCorrectLevel.M:
      return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 1];

    case ErrorCorrectLevel.Q:
      return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 2];

    case ErrorCorrectLevel.H:
      return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 3];

    default:
      return undefined;
  }
};

var RSBlock = QRRSBlock;

function QRBitBuffer() {
  this.buffer = new Array();
  this.length = 0;
}

QRBitBuffer.prototype = {
  get: function get(index) {
    var bufIndex = Math.floor(index / 8);
    return (this.buffer[bufIndex] >>> 7 - index % 8 & 1) == 1;
  },
  put: function put(num, length) {
    for (var i = 0; i < length; i++) {
      this.putBit((num >>> length - i - 1 & 1) == 1);
    }
  },
  getLengthInBits: function getLengthInBits() {
    return this.length;
  },
  putBit: function putBit(bit) {
    var bufIndex = Math.floor(this.length / 8);

    if (this.buffer.length <= bufIndex) {
      this.buffer.push(0);
    }

    if (bit) {
      this.buffer[bufIndex] |= 0x80 >>> this.length % 8;
    }

    this.length++;
  }
};
var BitBuffer = QRBitBuffer;
var QRMath = {
  glog: function glog(n) {
    if (n < 1) {
      throw new Error("glog(" + n + ")");
    }

    return QRMath.LOG_TABLE[n];
  },
  gexp: function gexp(n) {
    while (n < 0) {
      n += 255;
    }

    while (n >= 256) {
      n -= 255;
    }

    return QRMath.EXP_TABLE[n];
  },
  EXP_TABLE: new Array(256),
  LOG_TABLE: new Array(256)
};

for (var i$2 = 0; i$2 < 8; i$2++) {
  QRMath.EXP_TABLE[i$2] = 1 << i$2;
}

for (var i$2 = 8; i$2 < 256; i$2++) {
  QRMath.EXP_TABLE[i$2] = QRMath.EXP_TABLE[i$2 - 4] ^ QRMath.EXP_TABLE[i$2 - 5] ^ QRMath.EXP_TABLE[i$2 - 6] ^ QRMath.EXP_TABLE[i$2 - 8];
}

for (var i$2 = 0; i$2 < 255; i$2++) {
  QRMath.LOG_TABLE[QRMath.EXP_TABLE[i$2]] = i$2;
}

var math = QRMath;

function QRPolynomial(num, shift) {
  if (num.length == undefined) {
    throw new Error(num.length + "/" + shift);
  }

  var offset = 0;

  while (offset < num.length && num[offset] == 0) {
    offset++;
  }

  this.num = new Array(num.length - offset + shift);

  for (var i = 0; i < num.length - offset; i++) {
    this.num[i] = num[i + offset];
  }
}

QRPolynomial.prototype = {
  get: function get(index) {
    return this.num[index];
  },
  getLength: function getLength() {
    return this.num.length;
  },
  multiply: function multiply(e) {
    var num = new Array(this.getLength() + e.getLength() - 1);

    for (var i = 0; i < this.getLength(); i++) {
      for (var j = 0; j < e.getLength(); j++) {
        num[i + j] ^= math.gexp(math.glog(this.get(i)) + math.glog(e.get(j)));
      }
    }

    return new QRPolynomial(num, 0);
  },
  mod: function mod(e) {
    if (this.getLength() - e.getLength() < 0) {
      return this;
    }

    var ratio = math.glog(this.get(0)) - math.glog(e.get(0));
    var num = new Array(this.getLength());

    for (var i = 0; i < this.getLength(); i++) {
      num[i] = this.get(i);
    }

    for (var i = 0; i < e.getLength(); i++) {
      num[i] ^= math.gexp(math.glog(e.get(i)) + ratio);
    } // recursive call


    return new QRPolynomial(num, 0).mod(e);
  }
};
var Polynomial = QRPolynomial;
var QRMaskPattern = {
  PATTERN000: 0,
  PATTERN001: 1,
  PATTERN010: 2,
  PATTERN011: 3,
  PATTERN100: 4,
  PATTERN101: 5,
  PATTERN110: 6,
  PATTERN111: 7
};
var QRUtil = {
  PATTERN_POSITION_TABLE: [[], [6, 18], [6, 22], [6, 26], [6, 30], [6, 34], [6, 22, 38], [6, 24, 42], [6, 26, 46], [6, 28, 50], [6, 30, 54], [6, 32, 58], [6, 34, 62], [6, 26, 46, 66], [6, 26, 48, 70], [6, 26, 50, 74], [6, 30, 54, 78], [6, 30, 56, 82], [6, 30, 58, 86], [6, 34, 62, 90], [6, 28, 50, 72, 94], [6, 26, 50, 74, 98], [6, 30, 54, 78, 102], [6, 28, 54, 80, 106], [6, 32, 58, 84, 110], [6, 30, 58, 86, 114], [6, 34, 62, 90, 118], [6, 26, 50, 74, 98, 122], [6, 30, 54, 78, 102, 126], [6, 26, 52, 78, 104, 130], [6, 30, 56, 82, 108, 134], [6, 34, 60, 86, 112, 138], [6, 30, 58, 86, 114, 142], [6, 34, 62, 90, 118, 146], [6, 30, 54, 78, 102, 126, 150], [6, 24, 50, 76, 102, 128, 154], [6, 28, 54, 80, 106, 132, 158], [6, 32, 58, 84, 110, 136, 162], [6, 26, 54, 82, 110, 138, 166], [6, 30, 58, 86, 114, 142, 170]],
  G15: 1 << 10 | 1 << 8 | 1 << 5 | 1 << 4 | 1 << 2 | 1 << 1 | 1 << 0,
  G18: 1 << 12 | 1 << 11 | 1 << 10 | 1 << 9 | 1 << 8 | 1 << 5 | 1 << 2 | 1 << 0,
  G15_MASK: 1 << 14 | 1 << 12 | 1 << 10 | 1 << 4 | 1 << 1,
  getBCHTypeInfo: function getBCHTypeInfo(data) {
    var d = data << 10;

    while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15) >= 0) {
      d ^= QRUtil.G15 << QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15);
    }

    return (data << 10 | d) ^ QRUtil.G15_MASK;
  },
  getBCHTypeNumber: function getBCHTypeNumber(data) {
    var d = data << 12;

    while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18) >= 0) {
      d ^= QRUtil.G18 << QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18);
    }

    return data << 12 | d;
  },
  getBCHDigit: function getBCHDigit(data) {
    var digit = 0;

    while (data != 0) {
      digit++;
      data >>>= 1;
    }

    return digit;
  },
  getPatternPosition: function getPatternPosition(typeNumber) {
    return QRUtil.PATTERN_POSITION_TABLE[typeNumber - 1];
  },
  getMask: function getMask(maskPattern, i, j) {
    switch (maskPattern) {
      case QRMaskPattern.PATTERN000:
        return (i + j) % 2 == 0;

      case QRMaskPattern.PATTERN001:
        return i % 2 == 0;

      case QRMaskPattern.PATTERN010:
        return j % 3 == 0;

      case QRMaskPattern.PATTERN011:
        return (i + j) % 3 == 0;

      case QRMaskPattern.PATTERN100:
        return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 == 0;

      case QRMaskPattern.PATTERN101:
        return i * j % 2 + i * j % 3 == 0;

      case QRMaskPattern.PATTERN110:
        return (i * j % 2 + i * j % 3) % 2 == 0;

      case QRMaskPattern.PATTERN111:
        return (i * j % 3 + (i + j) % 2) % 2 == 0;

      default:
        throw new Error("bad maskPattern:" + maskPattern);
    }
  },
  getErrorCorrectPolynomial: function getErrorCorrectPolynomial(errorCorrectLength) {
    var a = new Polynomial([1], 0);

    for (var i = 0; i < errorCorrectLength; i++) {
      a = a.multiply(new Polynomial([1, math.gexp(i)], 0));
    }

    return a;
  },
  getLengthInBits: function getLengthInBits(mode$1, type) {
    if (1 <= type && type < 10) {
      // 1 - 9
      switch (mode$1) {
        case mode.MODE_NUMBER:
          return 10;

        case mode.MODE_ALPHA_NUM:
          return 9;

        case mode.MODE_8BIT_BYTE:
          return 8;

        case mode.MODE_KANJI:
          return 8;

        default:
          throw new Error("mode:" + mode$1);
      }
    } else if (type < 27) {
      // 10 - 26
      switch (mode$1) {
        case mode.MODE_NUMBER:
          return 12;

        case mode.MODE_ALPHA_NUM:
          return 11;

        case mode.MODE_8BIT_BYTE:
          return 16;

        case mode.MODE_KANJI:
          return 10;

        default:
          throw new Error("mode:" + mode$1);
      }
    } else if (type < 41) {
      // 27 - 40
      switch (mode$1) {
        case mode.MODE_NUMBER:
          return 14;

        case mode.MODE_ALPHA_NUM:
          return 13;

        case mode.MODE_8BIT_BYTE:
          return 16;

        case mode.MODE_KANJI:
          return 12;

        default:
          throw new Error("mode:" + mode$1);
      }
    } else {
      throw new Error("type:" + type);
    }
  },
  getLostPoint: function getLostPoint(qrCode) {
    var moduleCount = qrCode.getModuleCount();
    var lostPoint = 0; // LEVEL1

    for (var row = 0; row < moduleCount; row++) {
      for (var col = 0; col < moduleCount; col++) {
        var sameCount = 0;
        var dark = qrCode.isDark(row, col);

        for (var r = -1; r <= 1; r++) {
          if (row + r < 0 || moduleCount <= row + r) {
            continue;
          }

          for (var c = -1; c <= 1; c++) {
            if (col + c < 0 || moduleCount <= col + c) {
              continue;
            }

            if (r == 0 && c == 0) {
              continue;
            }

            if (dark == qrCode.isDark(row + r, col + c)) {
              sameCount++;
            }
          }
        }

        if (sameCount > 5) {
          lostPoint += 3 + sameCount - 5;
        }
      }
    } // LEVEL2


    for (var row = 0; row < moduleCount - 1; row++) {
      for (var col = 0; col < moduleCount - 1; col++) {
        var count = 0;
        if (qrCode.isDark(row, col)) count++;
        if (qrCode.isDark(row + 1, col)) count++;
        if (qrCode.isDark(row, col + 1)) count++;
        if (qrCode.isDark(row + 1, col + 1)) count++;

        if (count == 0 || count == 4) {
          lostPoint += 3;
        }
      }
    } // LEVEL3


    for (var row = 0; row < moduleCount; row++) {
      for (var col = 0; col < moduleCount - 6; col++) {
        if (qrCode.isDark(row, col) && !qrCode.isDark(row, col + 1) && qrCode.isDark(row, col + 2) && qrCode.isDark(row, col + 3) && qrCode.isDark(row, col + 4) && !qrCode.isDark(row, col + 5) && qrCode.isDark(row, col + 6)) {
          lostPoint += 40;
        }
      }
    }

    for (var col = 0; col < moduleCount; col++) {
      for (var row = 0; row < moduleCount - 6; row++) {
        if (qrCode.isDark(row, col) && !qrCode.isDark(row + 1, col) && qrCode.isDark(row + 2, col) && qrCode.isDark(row + 3, col) && qrCode.isDark(row + 4, col) && !qrCode.isDark(row + 5, col) && qrCode.isDark(row + 6, col)) {
          lostPoint += 40;
        }
      }
    } // LEVEL4


    var darkCount = 0;

    for (var col = 0; col < moduleCount; col++) {
      for (var row = 0; row < moduleCount; row++) {
        if (qrCode.isDark(row, col)) {
          darkCount++;
        }
      }
    }

    var ratio = Math.abs(100 * darkCount / moduleCount / moduleCount - 50) / 5;
    lostPoint += ratio * 10;
    return lostPoint;
  }
};
var util$1 = QRUtil;

function QRCode(typeNumber, errorCorrectLevel) {
  this.typeNumber = typeNumber;
  this.errorCorrectLevel = errorCorrectLevel;
  this.modules = null;
  this.moduleCount = 0;
  this.dataCache = null;
  this.dataList = [];
} // for client side minification


var proto$1 = QRCode.prototype;

proto$1.addData = function (data) {
  var newData = new _8BitByte(data);
  this.dataList.push(newData);
  this.dataCache = null;
};

proto$1.isDark = function (row, col) {
  if (row < 0 || this.moduleCount <= row || col < 0 || this.moduleCount <= col) {
    throw new Error(row + "," + col);
  }

  return this.modules[row][col];
};

proto$1.getModuleCount = function () {
  return this.moduleCount;
};

proto$1.make = function () {
  // Calculate automatically typeNumber if provided is < 1
  if (this.typeNumber < 1) {
    var typeNumber = 1;

    for (typeNumber = 1; typeNumber < 40; typeNumber++) {
      var rsBlocks = RSBlock.getRSBlocks(typeNumber, this.errorCorrectLevel);
      var buffer = new BitBuffer();
      var totalDataCount = 0;

      for (var i = 0; i < rsBlocks.length; i++) {
        totalDataCount += rsBlocks[i].dataCount;
      }

      for (var i = 0; i < this.dataList.length; i++) {
        var data = this.dataList[i];
        buffer.put(data.mode, 4);
        buffer.put(data.getLength(), util$1.getLengthInBits(data.mode, typeNumber));
        data.write(buffer);
      }

      if (buffer.getLengthInBits() <= totalDataCount * 8) break;
    }

    this.typeNumber = typeNumber;
  }

  this.makeImpl(false, this.getBestMaskPattern());
};

proto$1.makeImpl = function (test, maskPattern) {
  this.moduleCount = this.typeNumber * 4 + 17;
  this.modules = new Array(this.moduleCount);

  for (var row = 0; row < this.moduleCount; row++) {
    this.modules[row] = new Array(this.moduleCount);

    for (var col = 0; col < this.moduleCount; col++) {
      this.modules[row][col] = null; //(col + row) % 3;
    }
  }

  this.setupPositionProbePattern(0, 0);
  this.setupPositionProbePattern(this.moduleCount - 7, 0);
  this.setupPositionProbePattern(0, this.moduleCount - 7);
  this.setupPositionAdjustPattern();
  this.setupTimingPattern();
  this.setupTypeInfo(test, maskPattern);

  if (this.typeNumber >= 7) {
    this.setupTypeNumber(test);
  }

  if (this.dataCache == null) {
    this.dataCache = QRCode.createData(this.typeNumber, this.errorCorrectLevel, this.dataList);
  }

  this.mapData(this.dataCache, maskPattern);
};

proto$1.setupPositionProbePattern = function (row, col) {
  for (var r = -1; r <= 7; r++) {
    if (row + r <= -1 || this.moduleCount <= row + r) continue;

    for (var c = -1; c <= 7; c++) {
      if (col + c <= -1 || this.moduleCount <= col + c) continue;

      if (0 <= r && r <= 6 && (c == 0 || c == 6) || 0 <= c && c <= 6 && (r == 0 || r == 6) || 2 <= r && r <= 4 && 2 <= c && c <= 4) {
        this.modules[row + r][col + c] = true;
      } else {
        this.modules[row + r][col + c] = false;
      }
    }
  }
};

proto$1.getBestMaskPattern = function () {
  var minLostPoint = 0;
  var pattern = 0;

  for (var i = 0; i < 8; i++) {
    this.makeImpl(true, i);
    var lostPoint = util$1.getLostPoint(this);

    if (i == 0 || minLostPoint > lostPoint) {
      minLostPoint = lostPoint;
      pattern = i;
    }
  }

  return pattern;
};

proto$1.createMovieClip = function (target_mc, instance_name, depth) {
  var qr_mc = target_mc.createEmptyMovieClip(instance_name, depth);
  var cs = 1;
  this.make();

  for (var row = 0; row < this.modules.length; row++) {
    var y = row * cs;

    for (var col = 0; col < this.modules[row].length; col++) {
      var x = col * cs;
      var dark = this.modules[row][col];

      if (dark) {
        qr_mc.beginFill(0, 100);
        qr_mc.moveTo(x, y);
        qr_mc.lineTo(x + cs, y);
        qr_mc.lineTo(x + cs, y + cs);
        qr_mc.lineTo(x, y + cs);
        qr_mc.endFill();
      }
    }
  }

  return qr_mc;
};

proto$1.setupTimingPattern = function () {
  for (var r = 8; r < this.moduleCount - 8; r++) {
    if (this.modules[r][6] != null) {
      continue;
    }

    this.modules[r][6] = r % 2 == 0;
  }

  for (var c = 8; c < this.moduleCount - 8; c++) {
    if (this.modules[6][c] != null) {
      continue;
    }

    this.modules[6][c] = c % 2 == 0;
  }
};

proto$1.setupPositionAdjustPattern = function () {
  var pos = util$1.getPatternPosition(this.typeNumber);

  for (var i = 0; i < pos.length; i++) {
    for (var j = 0; j < pos.length; j++) {
      var row = pos[i];
      var col = pos[j];

      if (this.modules[row][col] != null) {
        continue;
      }

      for (var r = -2; r <= 2; r++) {
        for (var c = -2; c <= 2; c++) {
          if (r == -2 || r == 2 || c == -2 || c == 2 || r == 0 && c == 0) {
            this.modules[row + r][col + c] = true;
          } else {
            this.modules[row + r][col + c] = false;
          }
        }
      }
    }
  }
};

proto$1.setupTypeNumber = function (test) {
  var bits = util$1.getBCHTypeNumber(this.typeNumber);

  for (var i = 0; i < 18; i++) {
    var mod = !test && (bits >> i & 1) == 1;
    this.modules[Math.floor(i / 3)][i % 3 + this.moduleCount - 8 - 3] = mod;
  }

  for (var i = 0; i < 18; i++) {
    var mod = !test && (bits >> i & 1) == 1;
    this.modules[i % 3 + this.moduleCount - 8 - 3][Math.floor(i / 3)] = mod;
  }
};

proto$1.setupTypeInfo = function (test, maskPattern) {
  var data = this.errorCorrectLevel << 3 | maskPattern;
  var bits = util$1.getBCHTypeInfo(data); // vertical		

  for (var i = 0; i < 15; i++) {
    var mod = !test && (bits >> i & 1) == 1;

    if (i < 6) {
      this.modules[i][8] = mod;
    } else if (i < 8) {
      this.modules[i + 1][8] = mod;
    } else {
      this.modules[this.moduleCount - 15 + i][8] = mod;
    }
  } // horizontal


  for (var i = 0; i < 15; i++) {
    var mod = !test && (bits >> i & 1) == 1;

    if (i < 8) {
      this.modules[8][this.moduleCount - i - 1] = mod;
    } else if (i < 9) {
      this.modules[8][15 - i - 1 + 1] = mod;
    } else {
      this.modules[8][15 - i - 1] = mod;
    }
  } // fixed module


  this.modules[this.moduleCount - 8][8] = !test;
};

proto$1.mapData = function (data, maskPattern) {
  var inc = -1;
  var row = this.moduleCount - 1;
  var bitIndex = 7;
  var byteIndex = 0;

  for (var col = this.moduleCount - 1; col > 0; col -= 2) {
    if (col == 6) col--;

    while (true) {
      for (var c = 0; c < 2; c++) {
        if (this.modules[row][col - c] == null) {
          var dark = false;

          if (byteIndex < data.length) {
            dark = (data[byteIndex] >>> bitIndex & 1) == 1;
          }

          var mask = util$1.getMask(maskPattern, row, col - c);

          if (mask) {
            dark = !dark;
          }

          this.modules[row][col - c] = dark;
          bitIndex--;

          if (bitIndex == -1) {
            byteIndex++;
            bitIndex = 7;
          }
        }
      }

      row += inc;

      if (row < 0 || this.moduleCount <= row) {
        row -= inc;
        inc = -inc;
        break;
      }
    }
  }
};

QRCode.PAD0 = 0xEC;
QRCode.PAD1 = 0x11;

QRCode.createData = function (typeNumber, errorCorrectLevel, dataList) {
  var rsBlocks = RSBlock.getRSBlocks(typeNumber, errorCorrectLevel);
  var buffer = new BitBuffer();

  for (var i = 0; i < dataList.length; i++) {
    var data = dataList[i];
    buffer.put(data.mode, 4);
    buffer.put(data.getLength(), util$1.getLengthInBits(data.mode, typeNumber));
    data.write(buffer);
  } // calc num max data.


  var totalDataCount = 0;

  for (var i = 0; i < rsBlocks.length; i++) {
    totalDataCount += rsBlocks[i].dataCount;
  }

  if (buffer.getLengthInBits() > totalDataCount * 8) {
    throw new Error("code length overflow. (" + buffer.getLengthInBits() + ">" + totalDataCount * 8 + ")");
  } // end code


  if (buffer.getLengthInBits() + 4 <= totalDataCount * 8) {
    buffer.put(0, 4);
  } // padding


  while (buffer.getLengthInBits() % 8 != 0) {
    buffer.putBit(false);
  } // padding


  while (true) {
    if (buffer.getLengthInBits() >= totalDataCount * 8) {
      break;
    }

    buffer.put(QRCode.PAD0, 8);

    if (buffer.getLengthInBits() >= totalDataCount * 8) {
      break;
    }

    buffer.put(QRCode.PAD1, 8);
  }

  return QRCode.createBytes(buffer, rsBlocks);
};

QRCode.createBytes = function (buffer, rsBlocks) {
  var offset = 0;
  var maxDcCount = 0;
  var maxEcCount = 0;
  var dcdata = new Array(rsBlocks.length);
  var ecdata = new Array(rsBlocks.length);

  for (var r = 0; r < rsBlocks.length; r++) {
    var dcCount = rsBlocks[r].dataCount;
    var ecCount = rsBlocks[r].totalCount - dcCount;
    maxDcCount = Math.max(maxDcCount, dcCount);
    maxEcCount = Math.max(maxEcCount, ecCount);
    dcdata[r] = new Array(dcCount);

    for (var i = 0; i < dcdata[r].length; i++) {
      dcdata[r][i] = 0xff & buffer.buffer[i + offset];
    }

    offset += dcCount;
    var rsPoly = util$1.getErrorCorrectPolynomial(ecCount);
    var rawPoly = new Polynomial(dcdata[r], rsPoly.getLength() - 1);
    var modPoly = rawPoly.mod(rsPoly);
    ecdata[r] = new Array(rsPoly.getLength() - 1);

    for (var i = 0; i < ecdata[r].length; i++) {
      var modIndex = i + modPoly.getLength() - ecdata[r].length;
      ecdata[r][i] = modIndex >= 0 ? modPoly.get(modIndex) : 0;
    }
  }

  var totalCodeCount = 0;

  for (var i = 0; i < rsBlocks.length; i++) {
    totalCodeCount += rsBlocks[i].totalCount;
  }

  var data = new Array(totalCodeCount);
  var index = 0;

  for (var i = 0; i < maxDcCount; i++) {
    for (var r = 0; r < rsBlocks.length; r++) {
      if (i < dcdata[r].length) {
        data[index++] = dcdata[r][i];
      }
    }
  }

  for (var i = 0; i < maxEcCount; i++) {
    for (var r = 0; r < rsBlocks.length; r++) {
      if (i < ecdata[r].length) {
        data[index++] = ecdata[r][i];
      }
    }
  }

  return data;
};

var QRCode_1 = QRCode;

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends$b() {
  _extends$b = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$b.apply(this, arguments);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty$1(target, key, source[key]);
    });
  }

  return target;
}

function _objectWithoutProperties$6(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$6(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose$6(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck$2(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$1(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$1(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn$2(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized$2(self);
}

function _getPrototypeOf$2(o) {
  _getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$2(o);
}

function _inherits$2(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$2(subClass, superClass);
}

function _setPrototypeOf$2(o, p) {
  _setPrototypeOf$2 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$2(o, p);
}

function _assertThisInitialized$2(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
} // qr.js doesn't handle error level of zero (M) so we need to do it right,
// thus the deep require.
// Convert from UTF-16, forcing the use of byte-mode encoding in our QR Code.
// This allows us to encode Hanji, Kanji, emoji, etc. Ideally we'd do more
// detection and not resort to byte-mode if possible, but we're trading off
// a smaller library for a smaller amount of data we can potentially encode.
// Based on http://jonisalonen.com/2012/from-utf-16-to-utf-8-in-javascript/


function convertStr(str) {
  var out = '';

  for (var i = 0; i < str.length; i++) {
    var charcode = str.charCodeAt(i);

    if (charcode < 0x0080) {
      out += String.fromCharCode(charcode);
    } else if (charcode < 0x0800) {
      out += String.fromCharCode(0xc0 | charcode >> 6);
      out += String.fromCharCode(0x80 | charcode & 0x3f);
    } else if (charcode < 0xd800 || charcode >= 0xe000) {
      out += String.fromCharCode(0xe0 | charcode >> 12);
      out += String.fromCharCode(0x80 | charcode >> 6 & 0x3f);
      out += String.fromCharCode(0x80 | charcode & 0x3f);
    } else {
      // This is a surrogate pair, so we'll reconsitute the pieces and work
      // from that
      i++;
      charcode = 0x10000 + ((charcode & 0x3ff) << 10 | str.charCodeAt(i) & 0x3ff);
      out += String.fromCharCode(0xf0 | charcode >> 18);
      out += String.fromCharCode(0x80 | charcode >> 12 & 0x3f);
      out += String.fromCharCode(0x80 | charcode >> 6 & 0x3f);
      out += String.fromCharCode(0x80 | charcode & 0x3f);
    }
  }

  return out;
}

var DEFAULT_PROPS = {
  size: 128,
  level: 'L',
  bgColor: '#FFFFFF',
  fgColor: '#000000',
  includeMargin: false
};
var PROP_TYPES = {
  value: PropTypes.string.isRequired,
  size: PropTypes.number,
  level: PropTypes.oneOf(['L', 'M', 'Q', 'H']),
  bgColor: PropTypes.string,
  fgColor: PropTypes.string,
  includeMargin: PropTypes.bool
};
var MARGIN_SIZE = 4;

function generatePath(modules) {
  var margin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var ops = [];
  modules.forEach(function (row, y) {
    var start = null;
    row.forEach(function (cell, x) {
      if (!cell && start !== null) {
        // M0 0h7v1H0z injects the space with the move and drops the comma,
        // saving a char per operation
        ops.push("M".concat(start + margin, " ").concat(y + margin, "h").concat(x - start, "v1H").concat(start + margin, "z"));
        start = null;
        return;
      } // end of row, clean up or skip


      if (x === row.length - 1) {
        if (!cell) {
          // We would have closed the op above already so this can only mean
          // 2+ light modules in a row.
          return;
        }

        if (start === null) {
          // Just a single dark module.
          ops.push("M".concat(x + margin, ",").concat(y + margin, " h1v1H").concat(x + margin, "z"));
        } else {
          // Otherwise finish the current line.
          ops.push("M".concat(start + margin, ",").concat(y + margin, " h").concat(x + 1 - start, "v1H").concat(start + margin, "z"));
        }

        return;
      }

      if (cell && start === null) {
        start = x;
      }
    });
  });
  return ops.join('');
} // For canvas we're going to switch our drawing mode based on whether or not
// the environment supports Path2D. We only need the constructor to be
// supported, but Edge doesn't actually support the path (string) type
// argument. Luckily it also doesn't support the addPath() method. We can
// treat that as the same thing.


var SUPPORTS_PATH2D = function () {
  try {
    new Path2D().addPath(new Path2D());
  } catch (e) {
    return false;
  }

  return true;
}();

var QRCodeCanvas =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits$2(QRCodeCanvas, _React$PureComponent);

  function QRCodeCanvas() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck$2(this, QRCodeCanvas);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn$2(this, (_getPrototypeOf2 = _getPrototypeOf$2(QRCodeCanvas)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty$1(_assertThisInitialized$2(_assertThisInitialized$2(_this)), "_canvas", void 0);

    return _this;
  }

  _createClass$1(QRCodeCanvas, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.update();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.update();
    }
  }, {
    key: "update",
    value: function update() {
      var _this$props = this.props,
          value = _this$props.value,
          size = _this$props.size,
          level = _this$props.level,
          bgColor = _this$props.bgColor,
          fgColor = _this$props.fgColor,
          includeMargin = _this$props.includeMargin; // We'll use type===-1 to force QRCode to automatically pick the best type

      var qrcode = new QRCode_1(-1, ErrorCorrectLevel[level]);
      qrcode.addData(convertStr(value));
      qrcode.make();

      if (this._canvas != null) {
        var canvas = this._canvas;
        var ctx = canvas.getContext('2d');

        if (!ctx) {
          return;
        }

        var cells = qrcode.modules;

        if (cells === null) {
          return;
        }

        var margin = includeMargin ? MARGIN_SIZE : 0;
        var numCells = cells.length + margin * 2; // We're going to scale this so that the number of drawable units
        // matches the number of cells. This avoids rounding issues, but does
        // result in some potentially unwanted single pixel issues between
        // blocks, only in environments that don't support Path2D.

        var pixelRatio = window.devicePixelRatio || 1;
        canvas.height = canvas.width = size * pixelRatio;
        var scale = size / numCells * pixelRatio;
        ctx.scale(scale, scale); // Draw solid background, only paint dark modules.

        ctx.fillStyle = bgColor;
        ctx.fillRect(0, 0, numCells, numCells);
        ctx.fillStyle = fgColor;

        if (SUPPORTS_PATH2D) {
          // $FlowFixMe: Path2D c'tor doesn't support args yet.
          ctx.fill(new Path2D(generatePath(cells, margin)));
        } else {
          cells.forEach(function (row, rdx) {
            row.forEach(function (cell, cdx) {
              if (cell) {
                ctx.fillRect(cdx + margin, rdx + margin, 1, 1);
              }
            });
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          value = _this$props2.value,
          size = _this$props2.size,
          level = _this$props2.level,
          bgColor = _this$props2.bgColor,
          fgColor = _this$props2.fgColor,
          style = _this$props2.style,
          includeMargin = _this$props2.includeMargin,
          otherProps = _objectWithoutProperties$6(_this$props2, ["value", "size", "level", "bgColor", "fgColor", "style", "includeMargin"]);

      var canvasStyle = _objectSpread({
        height: size,
        width: size
      }, style);

      return React.createElement("canvas", _extends$b({
        style: canvasStyle,
        height: size,
        width: size,
        ref: function ref(_ref) {
          return _this2._canvas = _ref;
        }
      }, otherProps));
    }
  }]);

  return QRCodeCanvas;
}(React.PureComponent);

_defineProperty$1(QRCodeCanvas, "defaultProps", DEFAULT_PROPS);

_defineProperty$1(QRCodeCanvas, "propTypes", PROP_TYPES);

var QRCodeSVG =
/*#__PURE__*/
function (_React$PureComponent2) {
  _inherits$2(QRCodeSVG, _React$PureComponent2);

  function QRCodeSVG() {
    _classCallCheck$2(this, QRCodeSVG);

    return _possibleConstructorReturn$2(this, _getPrototypeOf$2(QRCodeSVG).apply(this, arguments));
  }

  _createClass$1(QRCodeSVG, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          value = _this$props3.value,
          size = _this$props3.size,
          level = _this$props3.level,
          bgColor = _this$props3.bgColor,
          fgColor = _this$props3.fgColor,
          includeMargin = _this$props3.includeMargin,
          otherProps = _objectWithoutProperties$6(_this$props3, ["value", "size", "level", "bgColor", "fgColor", "includeMargin"]); // We'll use type===-1 to force QRCode to automatically pick the best type


      var qrcode = new QRCode_1(-1, ErrorCorrectLevel[level]);
      qrcode.addData(convertStr(value));
      qrcode.make();
      var cells = qrcode.modules;

      if (cells === null) {
        return null;
      }

      var margin = includeMargin ? MARGIN_SIZE : 0; // Drawing strategy: instead of a rect per module, we're going to create a
      // single path for the dark modules and layer that on top of a light rect,
      // for a total of 2 DOM nodes. We pay a bit more in string concat but that's
      // way faster than DOM ops.
      // For level 1, 441 nodes -> 2
      // For level 40, 31329 -> 2

      var fgPath = generatePath(cells, margin);
      var numCells = cells.length + margin * 2;
      return React.createElement("svg", _extends$b({
        shapeRendering: "crispEdges",
        height: size,
        width: size,
        viewBox: "0 0 ".concat(numCells, " ").concat(numCells)
      }, otherProps), React.createElement("path", {
        fill: bgColor,
        d: "M0,0 h".concat(numCells, "v").concat(numCells, "H0z")
      }), React.createElement("path", {
        fill: fgColor,
        d: fgPath
      }));
    }
  }]);

  return QRCodeSVG;
}(React.PureComponent);

_defineProperty$1(QRCodeSVG, "defaultProps", DEFAULT_PROPS);

_defineProperty$1(QRCodeSVG, "propTypes", PROP_TYPES);

var QRCode$1 = function QRCode(props) {
  var renderAs = props.renderAs,
      otherProps = _objectWithoutProperties$6(props, ["renderAs"]);

  var Component = renderAs === 'svg' ? QRCodeSVG : QRCodeCanvas;
  return React.createElement(Component, otherProps);
};

QRCode$1.defaultProps = _objectSpread({
  renderAs: 'canvas'
}, DEFAULT_PROPS);
var lib$2 = QRCode$1;
var QR = React.forwardRef(function (props, ref) {
  return React.createElement(lib$2, _extends({
    ref: ref
  }, props));
});
QR.propTypes = {
  /**
   * Sets the value of the QR code
   */
  value: PropTypes.string.isRequired,

  /**
   * Changes the element that contains the QR code
   */
  renderAs: PropTypes.oneOf(['canvas', 'svg']),

  /**
   * Sets the height and width in pixels
   */
  size: PropTypes.number,

  /**
   * Sets the background color
   */
  bgColor: PropTypes.string,

  /**
   * Sets the foreground color
   */
  fgColor: PropTypes.string,

  /**
   * Sets the amount of error correction
   */
  level: PropTypes.oneOf(['L', 'M', 'Q', 'H']),

  /**
   * Adds margin around the QR code
   */
  includeMargin: PropTypes.bool
};
QR.defaultProps = {
  renderAs: 'svg',
  size: 128,
  bgColor: '#FFFFFF',
  fgColor: '#000000',
  level: 'L',
  includeMargin: false
};
QR.displayName = 'QR';

var useHiddenState = function useHiddenState() {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setIsVisible = _useState2[1];

  var toggle = function toggle() {
    setIsVisible(!visible);
  };

  return {
    visible: visible,
    toggle: toggle
  };
};

var clipboard = createCommonjsModule(function (module, exports) {
  /*!
   * clipboard.js v2.0.4
   * https://zenorocha.github.io/clipboard.js
   * 
   * Licensed MIT © Zeno Rocha
   */
  (function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory();
  })(commonjsGlobal, function () {
    return (
      /******/
      function (modules) {
        // webpackBootstrap

        /******/
        // The module cache

        /******/
        var installedModules = {};
        /******/

        /******/
        // The require function

        /******/

        function __webpack_require__(moduleId) {
          /******/

          /******/
          // Check if module is in cache

          /******/
          if (installedModules[moduleId]) {
            /******/
            return installedModules[moduleId].exports;
            /******/
          }
          /******/
          // Create a new module (and put it into the cache)

          /******/


          var module = installedModules[moduleId] = {
            /******/
            i: moduleId,

            /******/
            l: false,

            /******/
            exports: {}
            /******/

          };
          /******/

          /******/
          // Execute the module function

          /******/

          modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
          /******/

          /******/
          // Flag the module as loaded

          /******/

          module.l = true;
          /******/

          /******/
          // Return the exports of the module

          /******/

          return module.exports;
          /******/
        }
        /******/

        /******/

        /******/
        // expose the modules object (__webpack_modules__)

        /******/


        __webpack_require__.m = modules;
        /******/

        /******/
        // expose the module cache

        /******/

        __webpack_require__.c = installedModules;
        /******/

        /******/
        // define getter function for harmony exports

        /******/

        __webpack_require__.d = function (exports, name, getter) {
          /******/
          if (!__webpack_require__.o(exports, name)) {
            /******/
            Object.defineProperty(exports, name, {
              enumerable: true,
              get: getter
            });
            /******/
          }
          /******/

        };
        /******/

        /******/
        // define __esModule on exports

        /******/


        __webpack_require__.r = function (exports) {
          /******/
          if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
            /******/
            Object.defineProperty(exports, Symbol.toStringTag, {
              value: 'Module'
            });
            /******/
          }
          /******/


          Object.defineProperty(exports, '__esModule', {
            value: true
          });
          /******/
        };
        /******/

        /******/
        // create a fake namespace object

        /******/
        // mode & 1: value is a module id, require it

        /******/
        // mode & 2: merge all properties of value into the ns

        /******/
        // mode & 4: return value when already ns object

        /******/
        // mode & 8|1: behave like require

        /******/


        __webpack_require__.t = function (value, mode) {
          /******/
          if (mode & 1) value = __webpack_require__(value);
          /******/

          if (mode & 8) return value;
          /******/

          if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
          /******/

          var ns = Object.create(null);
          /******/

          __webpack_require__.r(ns);
          /******/


          Object.defineProperty(ns, 'default', {
            enumerable: true,
            value: value
          });
          /******/

          if (mode & 2 && typeof value != 'string') for (var key in value) {
            __webpack_require__.d(ns, key, function (key) {
              return value[key];
            }.bind(null, key));
          }
          /******/

          return ns;
          /******/
        };
        /******/

        /******/
        // getDefaultExport function for compatibility with non-harmony modules

        /******/


        __webpack_require__.n = function (module) {
          /******/
          var getter = module && module.__esModule ?
          /******/
          function getDefault() {
            return module['default'];
          } :
          /******/
          function getModuleExports() {
            return module;
          };
          /******/

          __webpack_require__.d(getter, 'a', getter);
          /******/


          return getter;
          /******/
        };
        /******/

        /******/
        // Object.prototype.hasOwnProperty.call

        /******/


        __webpack_require__.o = function (object, property) {
          return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/

        /******/
        // __webpack_public_path__

        /******/


        __webpack_require__.p = "";
        /******/

        /******/

        /******/
        // Load entry module and return exports

        /******/

        return __webpack_require__(__webpack_require__.s = 0);
        /******/
      }(
      /************************************************************************/

      /******/
      [
      /* 0 */

      /***/
      function (module, exports, __webpack_require__) {
        var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
          return typeof obj;
        } : function (obj) {
          return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };

        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }

          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();

        var _clipboardAction = __webpack_require__(1);

        var _clipboardAction2 = _interopRequireDefault(_clipboardAction);

        var _tinyEmitter = __webpack_require__(3);

        var _tinyEmitter2 = _interopRequireDefault(_tinyEmitter);

        var _goodListener = __webpack_require__(4);

        var _goodListener2 = _interopRequireDefault(_goodListener);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }

        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }

          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }

        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }

          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        /**
         * Base class which takes one or more elements, adds event listeners to them,
         * and instantiates a new `ClipboardAction` on each click.
         */


        var Clipboard = function (_Emitter) {
          _inherits(Clipboard, _Emitter);
          /**
           * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
           * @param {Object} options
           */


          function Clipboard(trigger, options) {
            _classCallCheck(this, Clipboard);

            var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this));

            _this.resolveOptions(options);

            _this.listenClick(trigger);

            return _this;
          }
          /**
           * Defines if attributes would be resolved using internal setter functions
           * or custom functions that were passed in the constructor.
           * @param {Object} options
           */


          _createClass(Clipboard, [{
            key: 'resolveOptions',
            value: function resolveOptions() {
              var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              this.action = typeof options.action === 'function' ? options.action : this.defaultAction;
              this.target = typeof options.target === 'function' ? options.target : this.defaultTarget;
              this.text = typeof options.text === 'function' ? options.text : this.defaultText;
              this.container = _typeof(options.container) === 'object' ? options.container : document.body;
            }
            /**
             * Adds a click event listener to the passed trigger.
             * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
             */

          }, {
            key: 'listenClick',
            value: function listenClick(trigger) {
              var _this2 = this;

              this.listener = (0, _goodListener2.default)(trigger, 'click', function (e) {
                return _this2.onClick(e);
              });
            }
            /**
             * Defines a new `ClipboardAction` on each click event.
             * @param {Event} e
             */

          }, {
            key: 'onClick',
            value: function onClick(e) {
              var trigger = e.delegateTarget || e.currentTarget;

              if (this.clipboardAction) {
                this.clipboardAction = null;
              }

              this.clipboardAction = new _clipboardAction2.default({
                action: this.action(trigger),
                target: this.target(trigger),
                text: this.text(trigger),
                container: this.container,
                trigger: trigger,
                emitter: this
              });
            }
            /**
             * Default `action` lookup function.
             * @param {Element} trigger
             */

          }, {
            key: 'defaultAction',
            value: function defaultAction(trigger) {
              return getAttributeValue('action', trigger);
            }
            /**
             * Default `target` lookup function.
             * @param {Element} trigger
             */

          }, {
            key: 'defaultTarget',
            value: function defaultTarget(trigger) {
              var selector = getAttributeValue('target', trigger);

              if (selector) {
                return document.querySelector(selector);
              }
            }
            /**
             * Returns the support of the given action, or all actions if no action is
             * given.
             * @param {String} [action]
             */

          }, {
            key: 'defaultText',

            /**
             * Default `text` lookup function.
             * @param {Element} trigger
             */
            value: function defaultText(trigger) {
              return getAttributeValue('text', trigger);
            }
            /**
             * Destroy lifecycle.
             */

          }, {
            key: 'destroy',
            value: function destroy() {
              this.listener.destroy();

              if (this.clipboardAction) {
                this.clipboardAction.destroy();
                this.clipboardAction = null;
              }
            }
          }], [{
            key: 'isSupported',
            value: function isSupported() {
              var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['copy', 'cut'];
              var actions = typeof action === 'string' ? [action] : action;
              var support = !!document.queryCommandSupported;
              actions.forEach(function (action) {
                support = support && !!document.queryCommandSupported(action);
              });
              return support;
            }
          }]);

          return Clipboard;
        }(_tinyEmitter2.default);
        /**
         * Helper function to retrieve attribute value.
         * @param {String} suffix
         * @param {Element} element
         */


        function getAttributeValue(suffix, element) {
          var attribute = 'data-clipboard-' + suffix;

          if (!element.hasAttribute(attribute)) {
            return;
          }

          return element.getAttribute(attribute);
        }

        module.exports = Clipboard;
        /***/
      },
      /* 1 */

      /***/
      function (module, exports, __webpack_require__) {
        var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
          return typeof obj;
        } : function (obj) {
          return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };

        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }

          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();

        var _select = __webpack_require__(2);

        var _select2 = _interopRequireDefault(_select);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        /**
         * Inner class which performs selection from either `text` or `target`
         * properties and then executes copy or cut operations.
         */


        var ClipboardAction = function () {
          /**
           * @param {Object} options
           */
          function ClipboardAction(options) {
            _classCallCheck(this, ClipboardAction);

            this.resolveOptions(options);
            this.initSelection();
          }
          /**
           * Defines base properties passed from constructor.
           * @param {Object} options
           */


          _createClass(ClipboardAction, [{
            key: 'resolveOptions',
            value: function resolveOptions() {
              var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              this.action = options.action;
              this.container = options.container;
              this.emitter = options.emitter;
              this.target = options.target;
              this.text = options.text;
              this.trigger = options.trigger;
              this.selectedText = '';
            }
            /**
             * Decides which selection strategy is going to be applied based
             * on the existence of `text` and `target` properties.
             */

          }, {
            key: 'initSelection',
            value: function initSelection() {
              if (this.text) {
                this.selectFake();
              } else if (this.target) {
                this.selectTarget();
              }
            }
            /**
             * Creates a fake textarea element, sets its value from `text` property,
             * and makes a selection on it.
             */

          }, {
            key: 'selectFake',
            value: function selectFake() {
              var _this = this;

              var isRTL = document.documentElement.getAttribute('dir') == 'rtl';
              this.removeFake();

              this.fakeHandlerCallback = function () {
                return _this.removeFake();
              };

              this.fakeHandler = this.container.addEventListener('click', this.fakeHandlerCallback) || true;
              this.fakeElem = document.createElement('textarea'); // Prevent zooming on iOS

              this.fakeElem.style.fontSize = '12pt'; // Reset box model

              this.fakeElem.style.border = '0';
              this.fakeElem.style.padding = '0';
              this.fakeElem.style.margin = '0'; // Move element out of screen horizontally

              this.fakeElem.style.position = 'absolute';
              this.fakeElem.style[isRTL ? 'right' : 'left'] = '-9999px'; // Move element to the same position vertically

              var yPosition = window.pageYOffset || document.documentElement.scrollTop;
              this.fakeElem.style.top = yPosition + 'px';
              this.fakeElem.setAttribute('readonly', '');
              this.fakeElem.value = this.text;
              this.container.appendChild(this.fakeElem);
              this.selectedText = (0, _select2.default)(this.fakeElem);
              this.copyText();
            }
            /**
             * Only removes the fake element after another click event, that way
             * a user can hit `Ctrl+C` to copy because selection still exists.
             */

          }, {
            key: 'removeFake',
            value: function removeFake() {
              if (this.fakeHandler) {
                this.container.removeEventListener('click', this.fakeHandlerCallback);
                this.fakeHandler = null;
                this.fakeHandlerCallback = null;
              }

              if (this.fakeElem) {
                this.container.removeChild(this.fakeElem);
                this.fakeElem = null;
              }
            }
            /**
             * Selects the content from element passed on `target` property.
             */

          }, {
            key: 'selectTarget',
            value: function selectTarget() {
              this.selectedText = (0, _select2.default)(this.target);
              this.copyText();
            }
            /**
             * Executes the copy operation based on the current selection.
             */

          }, {
            key: 'copyText',
            value: function copyText() {
              var succeeded = void 0;

              try {
                succeeded = document.execCommand(this.action);
              } catch (err) {
                succeeded = false;
              }

              this.handleResult(succeeded);
            }
            /**
             * Fires an event based on the copy operation result.
             * @param {Boolean} succeeded
             */

          }, {
            key: 'handleResult',
            value: function handleResult(succeeded) {
              this.emitter.emit(succeeded ? 'success' : 'error', {
                action: this.action,
                text: this.selectedText,
                trigger: this.trigger,
                clearSelection: this.clearSelection.bind(this)
              });
            }
            /**
             * Moves focus away from `target` and back to the trigger, removes current selection.
             */

          }, {
            key: 'clearSelection',
            value: function clearSelection() {
              if (this.trigger) {
                this.trigger.focus();
              }

              window.getSelection().removeAllRanges();
            }
            /**
             * Sets the `action` to be performed which can be either 'copy' or 'cut'.
             * @param {String} action
             */

          }, {
            key: 'destroy',

            /**
             * Destroy lifecycle.
             */
            value: function destroy() {
              this.removeFake();
            }
          }, {
            key: 'action',
            set: function set() {
              var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'copy';
              this._action = action;

              if (this._action !== 'copy' && this._action !== 'cut') {
                throw new Error('Invalid "action" value, use either "copy" or "cut"');
              }
            }
            /**
             * Gets the `action` property.
             * @return {String}
             */
            ,
            get: function get() {
              return this._action;
            }
            /**
             * Sets the `target` property using an element
             * that will be have its content copied.
             * @param {Element} target
             */

          }, {
            key: 'target',
            set: function set(target) {
              if (target !== undefined) {
                if (target && (typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object' && target.nodeType === 1) {
                  if (this.action === 'copy' && target.hasAttribute('disabled')) {
                    throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
                  }

                  if (this.action === 'cut' && (target.hasAttribute('readonly') || target.hasAttribute('disabled'))) {
                    throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
                  }

                  this._target = target;
                } else {
                  throw new Error('Invalid "target" value, use a valid Element');
                }
              }
            }
            /**
             * Gets the `target` property.
             * @return {String|HTMLElement}
             */
            ,
            get: function get() {
              return this._target;
            }
          }]);

          return ClipboardAction;
        }();

        module.exports = ClipboardAction;
        /***/
      },
      /* 2 */

      /***/
      function (module, exports) {
        function select(element) {
          var selectedText;

          if (element.nodeName === 'SELECT') {
            element.focus();
            selectedText = element.value;
          } else if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
            var isReadOnly = element.hasAttribute('readonly');

            if (!isReadOnly) {
              element.setAttribute('readonly', '');
            }

            element.select();
            element.setSelectionRange(0, element.value.length);

            if (!isReadOnly) {
              element.removeAttribute('readonly');
            }

            selectedText = element.value;
          } else {
            if (element.hasAttribute('contenteditable')) {
              element.focus();
            }

            var selection = window.getSelection();
            var range = document.createRange();
            range.selectNodeContents(element);
            selection.removeAllRanges();
            selection.addRange(range);
            selectedText = selection.toString();
          }

          return selectedText;
        }

        module.exports = select;
        /***/
      },
      /* 3 */

      /***/
      function (module, exports) {
        function E() {// Keep this empty so it's easier to inherit from
          // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
        }

        E.prototype = {
          on: function on(name, callback, ctx) {
            var e = this.e || (this.e = {});
            (e[name] || (e[name] = [])).push({
              fn: callback,
              ctx: ctx
            });
            return this;
          },
          once: function once(name, callback, ctx) {
            var self = this;

            function listener() {
              self.off(name, listener);
              callback.apply(ctx, arguments);
            }

            listener._ = callback;
            return this.on(name, listener, ctx);
          },
          emit: function emit(name) {
            var data = [].slice.call(arguments, 1);
            var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
            var i = 0;
            var len = evtArr.length;

            for (i; i < len; i++) {
              evtArr[i].fn.apply(evtArr[i].ctx, data);
            }

            return this;
          },
          off: function off(name, callback) {
            var e = this.e || (this.e = {});
            var evts = e[name];
            var liveEvents = [];

            if (evts && callback) {
              for (var i = 0, len = evts.length; i < len; i++) {
                if (evts[i].fn !== callback && evts[i].fn._ !== callback) liveEvents.push(evts[i]);
              }
            } // Remove event from queue to prevent memory leak
            // Suggested by https://github.com/lazd
            // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910


            liveEvents.length ? e[name] = liveEvents : delete e[name];
            return this;
          }
        };
        module.exports = E;
        /***/
      },
      /* 4 */

      /***/
      function (module, exports, __webpack_require__) {
        var is = __webpack_require__(5);

        var delegate = __webpack_require__(6);
        /**
         * Validates all params and calls the right
         * listener function based on its target type.
         *
         * @param {String|HTMLElement|HTMLCollection|NodeList} target
         * @param {String} type
         * @param {Function} callback
         * @return {Object}
         */


        function listen(target, type, callback) {
          if (!target && !type && !callback) {
            throw new Error('Missing required arguments');
          }

          if (!is.string(type)) {
            throw new TypeError('Second argument must be a String');
          }

          if (!is.fn(callback)) {
            throw new TypeError('Third argument must be a Function');
          }

          if (is.node(target)) {
            return listenNode(target, type, callback);
          } else if (is.nodeList(target)) {
            return listenNodeList(target, type, callback);
          } else if (is.string(target)) {
            return listenSelector(target, type, callback);
          } else {
            throw new TypeError('First argument must be a String, HTMLElement, HTMLCollection, or NodeList');
          }
        }
        /**
         * Adds an event listener to a HTML element
         * and returns a remove listener function.
         *
         * @param {HTMLElement} node
         * @param {String} type
         * @param {Function} callback
         * @return {Object}
         */


        function listenNode(node, type, callback) {
          node.addEventListener(type, callback);
          return {
            destroy: function destroy() {
              node.removeEventListener(type, callback);
            }
          };
        }
        /**
         * Add an event listener to a list of HTML elements
         * and returns a remove listener function.
         *
         * @param {NodeList|HTMLCollection} nodeList
         * @param {String} type
         * @param {Function} callback
         * @return {Object}
         */


        function listenNodeList(nodeList, type, callback) {
          Array.prototype.forEach.call(nodeList, function (node) {
            node.addEventListener(type, callback);
          });
          return {
            destroy: function destroy() {
              Array.prototype.forEach.call(nodeList, function (node) {
                node.removeEventListener(type, callback);
              });
            }
          };
        }
        /**
         * Add an event listener to a selector
         * and returns a remove listener function.
         *
         * @param {String} selector
         * @param {String} type
         * @param {Function} callback
         * @return {Object}
         */


        function listenSelector(selector, type, callback) {
          return delegate(document.body, selector, type, callback);
        }

        module.exports = listen;
        /***/
      },
      /* 5 */

      /***/
      function (module, exports) {
        /**
         * Check if argument is a HTML element.
         *
         * @param {Object} value
         * @return {Boolean}
         */
        exports.node = function (value) {
          return value !== undefined && value instanceof HTMLElement && value.nodeType === 1;
        };
        /**
         * Check if argument is a list of HTML elements.
         *
         * @param {Object} value
         * @return {Boolean}
         */


        exports.nodeList = function (value) {
          var type = Object.prototype.toString.call(value);
          return value !== undefined && (type === '[object NodeList]' || type === '[object HTMLCollection]') && 'length' in value && (value.length === 0 || exports.node(value[0]));
        };
        /**
         * Check if argument is a string.
         *
         * @param {Object} value
         * @return {Boolean}
         */


        exports.string = function (value) {
          return typeof value === 'string' || value instanceof String;
        };
        /**
         * Check if argument is a function.
         *
         * @param {Object} value
         * @return {Boolean}
         */


        exports.fn = function (value) {
          var type = Object.prototype.toString.call(value);
          return type === '[object Function]';
        };
        /***/

      },
      /* 6 */

      /***/
      function (module, exports, __webpack_require__) {
        var closest = __webpack_require__(7);
        /**
         * Delegates event to a selector.
         *
         * @param {Element} element
         * @param {String} selector
         * @param {String} type
         * @param {Function} callback
         * @param {Boolean} useCapture
         * @return {Object}
         */


        function _delegate(element, selector, type, callback, useCapture) {
          var listenerFn = listener.apply(this, arguments);
          element.addEventListener(type, listenerFn, useCapture);
          return {
            destroy: function destroy() {
              element.removeEventListener(type, listenerFn, useCapture);
            }
          };
        }
        /**
         * Delegates event to a selector.
         *
         * @param {Element|String|Array} [elements]
         * @param {String} selector
         * @param {String} type
         * @param {Function} callback
         * @param {Boolean} useCapture
         * @return {Object}
         */


        function delegate(elements, selector, type, callback, useCapture) {
          // Handle the regular Element usage
          if (typeof elements.addEventListener === 'function') {
            return _delegate.apply(null, arguments);
          } // Handle Element-less usage, it defaults to global delegation


          if (typeof type === 'function') {
            // Use `document` as the first parameter, then apply arguments
            // This is a short way to .unshift `arguments` without running into deoptimizations
            return _delegate.bind(null, document).apply(null, arguments);
          } // Handle Selector-based usage


          if (typeof elements === 'string') {
            elements = document.querySelectorAll(elements);
          } // Handle Array-like based usage


          return Array.prototype.map.call(elements, function (element) {
            return _delegate(element, selector, type, callback, useCapture);
          });
        }
        /**
         * Finds closest match and invokes callback.
         *
         * @param {Element} element
         * @param {String} selector
         * @param {String} type
         * @param {Function} callback
         * @return {Function}
         */


        function listener(element, selector, type, callback) {
          return function (e) {
            e.delegateTarget = closest(e.target, selector);

            if (e.delegateTarget) {
              callback.call(element, e);
            }
          };
        }

        module.exports = delegate;
        /***/
      },
      /* 7 */

      /***/
      function (module, exports) {
        var DOCUMENT_NODE_TYPE = 9;
        /**
         * A polyfill for Element.matches()
         */

        if (typeof Element !== 'undefined' && !Element.prototype.matches) {
          var proto = Element.prototype;
          proto.matches = proto.matchesSelector || proto.mozMatchesSelector || proto.msMatchesSelector || proto.oMatchesSelector || proto.webkitMatchesSelector;
        }
        /**
         * Finds the closest parent that matches a selector.
         *
         * @param {Element} element
         * @param {String} selector
         * @return {Function}
         */


        function closest(element, selector) {
          while (element && element.nodeType !== DOCUMENT_NODE_TYPE) {
            if (typeof element.matches === 'function' && element.matches(selector)) {
              return element;
            }

            element = element.parentNode;
          }
        }

        module.exports = closest;
        /***/
      }
      /******/
      ])
    );
  });
});
var ClipboardJS = unwrapExports(clipboard);

var Clipboard = function Clipboard(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isCopied = _useState2[0],
      setIsCopied = _useState2[1];

  var targetEl = useRef(null);
  var timer = useRef(0);
  useEffect(function () {
    var afterCopy = function afterCopy() {
      setIsCopied(true);
      clearTimeout(timer.current);
      timer.current = setTimeout(function () {
        return setIsCopied(false);
      }, 1500);
    };

    var clipboard = new ClipboardJS(targetEl.current, {
      text: function text() {
        return props.text;
      }
    });
    clipboard.on('success', function (e) {
      // console.log('text copied!:', props.text);
      afterCopy();
    });
    clipboard.on('error', function (e) {
      console.log('error: failed to copy text');
    });
    return function () {
      clipboard.destroy();
      clearTimeout(timer.current);
    };
  }, []);
  return React.createElement("div", {
    ref: targetEl
  }, props.children(isCopied));
};

function _templateObject2$b() {
  var data = _taggedTemplateLiteral(["\n  & {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    width: 100%;\n    position: relative;\n  }\n"]);

  _templateObject2$b = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$v() {
  var data = _taggedTemplateLiteral(["\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"]);

  _templateObject$v = function _templateObject() {
    return data;
  };

  return data;
}

var StyledInput$1 = styled(Input$1)(_templateObject$v());
StyledInput$1.defaultProps = {
  title: 'Ethereum Address',
  'aria-label': 'Ethereum Address'
};
var StyledWrapper$3 = styled(Box)(_templateObject2$b());

var AddressQrModal = function AddressQrModal(_ref) {
  var isOpen = _ref.isOpen,
      hide = _ref.hide,
      address = _ref.address;
  var text = {
    title: 'Ethereum Address',
    description: 'To send funds to this Ethereum address, scan this code using your mobile wallet app'
  };
  var colors = {
    foreground: 'black',
    background: 'white'
  };

  if (isOpen) {
    return React.createElement(Portal, null, React.createElement(StyledOverlay, null, React.createElement(Card, {
      width: 1,
      maxWidth: 6,
      bg: colors.background,
      color: colors.foreground,
      border: 'none',
      borderRadius: 2,
      p: 0,
      display: 'flex',
      flexDirection: 'column'
    }, React.createElement(Button$2.Text, {
      icon: 'Close',
      mainColor: 'inherit',
      p: 0,
      borderRadius: '100%',
      position: 'absolute',
      top: 0,
      right: 0,
      onClick: hide
    }), React.createElement(Text, {
      color: 'inherit',
      p: 3,
      borderBottom: 1,
      borderColor: 'blacks.4',
      lineHeight: 'solid',
      textAlign: 'center',
      fontWeight: 3
    }, text.title), React.createElement(Box, {
      p: [3, 4],
      overflow: 'scroll'
    }, React.createElement(Text, {
      color: 'inherit',
      textAlign: 'center',
      mb: 4
    }, text.description), React.createElement(Box // size={['100%', '200px']}
    , {
      width: 1,
      maxWidth: '220px',
      mx: 'auto',
      mb: 4,
      p: 4,
      bg: 'white',
      border: 1,
      borderColor: 'blacks.3',
      boxShadow: 2
    }, React.createElement(QR, {
      value: address,
      size: '100%'
    })), React.createElement(Clipboard, {
      text: address
    }, function (isCopied) {
      return React.createElement(Box, {
        color: 'inherit',
        position: 'relative',
        display: 'flex',
        alignItems: 'center'
      }, React.createElement(StyledInput$1, {
        readOnly: true,
        value: address,
        width: 1,
        pr: '5rem',
        fontWeight: 3
      }), React.createElement(Button$2, {
        size: 'small',
        width: '4rem',
        mx: 2,
        position: 'absolute',
        right: 0
      }, !isCopied ? 'Copy' : React.createElement(Icon$1, {
        name: 'Check'
      })));
    })))));
  }

  return null;
};

var QRButton = function QRButton(_ref2) {
  var address = _ref2.address,
      props = _objectWithoutProperties(_ref2, ["address"]);

  var _useHiddenState = useHiddenState(),
      visible = _useHiddenState.visible,
      toggle = _useHiddenState.toggle;

  var text = {
    tooltip: 'Show QR Code',
    button: 'Show QR Code'
  };

  if (!props.textLabels) {
    return React.createElement(React.Fragment, null, React.createElement(Tooltip, {
      message: text.tooltip
    }, React.createElement(Button$2, {
      size: 'small',
      ml: 2,
      p: 0,
      onClick: toggle
    }, React.createElement(Icon$1, {
      name: 'CenterFocusStrong'
    }))), React.createElement(AddressQrModal, {
      address: address,
      isOpen: visible,
      hide: toggle
    }));
  }

  return React.createElement(React.Fragment, null, React.createElement(Button$2, {
    size: 'small',
    ml: 2,
    onClick: toggle
  }, text.button), React.createElement(AddressQrModal, {
    address: address,
    isOpen: visible,
    hide: toggle
  }));
};

var CopyButton = function CopyButton(_ref3) {
  var clipboardText = _ref3.clipboardText,
      props = _objectWithoutProperties(_ref3, ["clipboardText"]);

  var text = {
    tooltip: 'Copy to clipboard',
    button: 'Copy'
  };

  if (!props.textLabels) {
    return React.createElement(Clipboard, {
      text: clipboardText
    }, function (isCopied) {
      return React.createElement(Tooltip, {
        message: text.tooltip
      }, React.createElement(Button$2, {
        size: 'small',
        p: 0
      }, React.createElement(Icon$1, {
        name: isCopied ? 'Check' : 'Assignment'
      })));
    });
  }

  return React.createElement(Clipboard, {
    text: clipboardText
  }, function (isCopied) {
    return React.createElement(Button$2, {
      size: 'small'
    }, !isCopied ? text.button : 'Copied!');
  });
};

var EthAddress =
/*#__PURE__*/
function (_Component) {
  _inherits(EthAddress, _Component);

  function EthAddress() {
    _classCallCheck(this, EthAddress);

    return _possibleConstructorReturn(this, _getPrototypeOf(EthAddress).apply(this, arguments));
  }

  _createClass(EthAddress, [{
    key: "render",
    value: function render() {
      return React.createElement(StyledWrapper$3, this.props, React.createElement(StyledInput$1, {
        readOnly: true,
        value: this.props.address,
        ref: this.inputRef,
        width: 1,
        fontWeight: 3,
        pr: this.props.textLabels ? '12rem' : '6rem'
      }), React.createElement(Flex, {
        position: 'absolute',
        right: 0,
        mr: 2
      }, React.createElement(CopyButton, {
        clipboardText: this.props.address,
        textLabels: this.props.textLabels
      }), React.createElement(QRButton, {
        address: this.props.address,
        textLabels: this.props.textLabels
      })));
    }
  }]);

  return EthAddress;
}(Component);

EthAddress.propTypes = {
  /**
   * Sets Ethereum address as the value of the field
   */
  address: PropTypes.string.isRequired,

  /**
   * Changes buttons to text from icons
   */
  textLabels: PropTypes.bool
};
EthAddress.defaultProps = {
  textLabels: false
};
EthAddress.displayName = 'EthAddress';
export { Avatar, BlockiesIdenticon as Blockie, Box, Button$2 as Button, Card, Checkbox, EthAddress, Field, Flash, Flex, Form, Heading, Icon$1 as Icon, Image, Input$1 as Input, Link$1 as Link, Loader, MetaMaskButton$1 as MetaMaskButton, Modal, Pill, Portal, Progress, QR, Radio$1 as Radio, Select, Slider, Table, Text, Textarea, ThemeProvider, ToastMessage, Tooltip, UPortButton$1 as UPortButton, theme };